/* eslint-disable */
import { TypedDocumentNode as DocumentNode } from '@graphql-typed-document-node/core'
export type Maybe<T> = T | null
export type InputMaybe<T> = Maybe<T>
export type Exact<T extends { [key: string]: unknown }> = { [K in keyof T]: T[K] }
export type MakeOptional<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]?: Maybe<T[SubKey]> }
export type MakeMaybe<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]: Maybe<T[SubKey]> }
export type MakeEmpty<T extends { [key: string]: unknown }, K extends keyof T> = {
  [_ in K]?: never
}
export type Incremental<T> =
  | T
  | { [P in keyof T]?: P extends ' $fragmentName' | '__typename' ? T[P] : never }
/** All built-in and custom scalars, mapped to their actual values */
export type Scalars = {
  ID: { input: string; output: string }
  String: { input: string; output: string }
  Boolean: { input: boolean; output: boolean }
  Int: { input: number; output: number }
  Float: { input: number; output: number }
  AccountNumber: { input: any; output: any }
  BigInt: { input: any; output: any }
  Byte: { input: any; output: any }
  CountryCode: { input: any; output: any }
  CountryName: { input: any; output: any }
  Cuid: { input: any; output: any }
  Currency: { input: any; output: any }
  DID: { input: any; output: any }
  Date: { input: any; output: any }
  /** Date with time (isoformat) */
  DateTime: { input: any; output: any }
  DateTimeISO: { input: any; output: any }
  DeweyDecimal: { input: any; output: any }
  Duration: { input: any; output: any }
  EmailAddress: { input: any; output: any }
  GUID: { input: any; output: any }
  GeoJSON: { input: any; output: any }
  HSL: { input: any; output: any }
  HSLA: { input: any; output: any }
  HexColorCode: { input: any; output: any }
  Hexadecimal: { input: any; output: any }
  IBAN: { input: any; output: any }
  IP: { input: any; output: any }
  IPCPatent: { input: any; output: any }
  IPv4: { input: any; output: any }
  IPv6: { input: any; output: any }
  ISBN: { input: any; output: any }
  ISO8601Duration: { input: any; output: any }
  /** The `JSON` scalar type represents JSON values as specified by [ECMA-404](https://ecma-international.org/wp-content/uploads/ECMA-404_2nd_edition_december_2017.pdf). */
  JSON: { input: any; output: any }
  JSONObject: { input: any; output: any }
  JWT: { input: any; output: any }
  LCCSubclass: { input: any; output: any }
  Latitude: { input: any; output: any }
  LocalDate: { input: any; output: any }
  LocalDateTime: { input: any; output: any }
  LocalEndTime: { input: any; output: any }
  LocalTime: { input: any; output: any }
  Locale: { input: any; output: any }
  Long: { input: any; output: any }
  Longitude: { input: any; output: any }
  MAC: { input: any; output: any }
  NegativeFloat: { input: any; output: any }
  NegativeInt: { input: any; output: any }
  NonEmptyString: { input: any; output: any }
  NonNegativeFloat: { input: any; output: any }
  NonNegativeInt: { input: any; output: any }
  NonPositiveFloat: { input: any; output: any }
  NonPositiveInt: { input: any; output: any }
  ObjectID: { input: any; output: any }
  PhoneNumber: { input: any; output: any }
  Port: { input: any; output: any }
  PositiveFloat: { input: any; output: any }
  PositiveInt: { input: any; output: any }
  PostalCode: { input: any; output: any }
  RGB: { input: any; output: any }
  RGBA: { input: any; output: any }
  RoutingNumber: { input: any; output: any }
  SESSN: { input: any; output: any }
  SafeInt: { input: any; output: any }
  SemVer: { input: any; output: any }
  Time: { input: any; output: any }
  TimeZone: { input: any; output: any }
  Timestamp: { input: any; output: any }
  URL: { input: any; output: any }
  USCurrency: { input: any; output: any }
  UUID: { input: any; output: any }
  UnsignedFloat: { input: any; output: any }
  UnsignedInt: { input: any; output: any }
  UtcOffset: { input: any; output: any }
  Void: { input: any; output: any }
}

/** AI metadata derived from existing summaries and transcripts. */
export type AiMetadataMediaAsset = {
  __typename?: 'AIMetadataMediaAsset'
  /** AI-generated summary text, or null when unavailable. */
  summary?: Maybe<Scalars['String']['output']>
  /** Pre-processed transcript text, or null when unavailable. */
  transcript?: Maybe<Scalars['String']['output']>
}

/** Ambassador lead */
export type AmbassadorLead = {
  __typename?: 'AmbassadorLead'
  /** The ambassador ID */
  ambassadorId?: Maybe<Scalars['Int']['output']>
  /** The date the row was created */
  createdAt?: Maybe<Scalars['DateTime']['output']>
  /** The ambassador email */
  email: Scalars['String']['output']
  /** When this ambassador lead expires */
  expiresAt: Scalars['DateTime']['output']
  /** The primary identifier for this record */
  id: Scalars['ID']['output']
  /** When the postback was sent */
  postbackSentAt?: Maybe<Scalars['DateTime']['output']>
  /** Ambassador ID before Everflow migration */
  preMigrationAmbassadorId?: Maybe<Scalars['Int']['output']>
  /** The ambassador referral ID */
  referralId?: Maybe<Scalars['String']['output']>
  /** The ambassador referral source */
  referralSource?: Maybe<Scalars['String']['output']>
  /** The ambassador referral source ID */
  referralSourceId?: Maybe<Scalars['Int']['output']>
  /** The ambassador tracking data */
  trackingData: Scalars['JSON']['output']
  /** The date the row was last updated */
  updatedAt?: Maybe<Scalars['DateTime']['output']>
  /** The associated user info uuid */
  userInfoUuid?: Maybe<Scalars['ID']['output']>
  /** The ambassador UTM campaign */
  utmCampaign?: Maybe<Scalars['String']['output']>
  /** The ambassador UTM medium */
  utmMedium?: Maybe<Scalars['String']['output']>
  /** The ambassador UTM source */
  utmSource?: Maybe<Scalars['String']['output']>
  /** The uuid value */
  uuid: Scalars['ID']['output']
}

/** Ambassador lead where created at input type */
export type AmbassadorLeadWhereCreatedAtInput = {
  /** Is the value equal to the field */
  eq?: InputMaybe<Scalars['DateTime']['input']>
  /** Is the value greater than to the field */
  gt?: InputMaybe<Scalars['DateTime']['input']>
  /** Is the value greater than or equal to the field */
  gte?: InputMaybe<Scalars['DateTime']['input']>
  /** Are the values in the field */
  in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>
  /** Is the value less than to the field */
  lt?: InputMaybe<Scalars['DateTime']['input']>
  /** Is the value less than or equal to the field */
  lte?: InputMaybe<Scalars['DateTime']['input']>
}

/** Ambassador lead where id input type */
export type AmbassadorLeadWhereIdInput = {
  /** Is the value equal to the field */
  eq?: InputMaybe<Scalars['ID']['input']>
  /** Is the value greater than to the field */
  gt?: InputMaybe<Scalars['ID']['input']>
  /** Is the value greater than or equal to the field */
  gte?: InputMaybe<Scalars['ID']['input']>
  /** Are the values in the field */
  in?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>
}

/** Ambassador lead where updated at input type */
export type AmbassadorLeadWhereUpdatedAtInput = {
  /** Is the value equal to the field */
  eq?: InputMaybe<Scalars['DateTime']['input']>
  /** Is the value greater than to the field */
  gt?: InputMaybe<Scalars['DateTime']['input']>
  /** Is the value greater than or equal to the field */
  gte?: InputMaybe<Scalars['DateTime']['input']>
  /** Are the values in the field */
  in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>
  /** Is the value less than to the field */
  lt?: InputMaybe<Scalars['DateTime']['input']>
  /** Is the value less than or equal to the field */
  lte?: InputMaybe<Scalars['DateTime']['input']>
}

/** Ambassador lead count response */
export type AmbassadorLeadsCountResponse = {
  __typename?: 'AmbassadorLeadsCountResponse'
  /** The number of rows */
  count: Scalars['Int']['output']
}

/** Ambassador lead list response */
export type AmbassadorLeadsListResponse = {
  __typename?: 'AmbassadorLeadsListResponse'
  /** A list of Ambassador lead */
  ambassadorLeads: Array<AmbassadorLead>
}

export type AmbassadorLeadsS3Input = {
  /** The object access control policy */
  acl?: InputMaybe<S3Acl>
  /** The primary identifier for the file */
  fileName: Scalars['ID']['input']
}

/** Ambassador lead upload file response */
export type AmbassadorLeadsUploadFileToS3Response = {
  __typename?: 'AmbassadorLeadsUploadFileToS3Response'
  /** Total ambassador leads rows processed */
  ambassadorLeadsProcessed: Scalars['Int']['output']
  /** The max ambassador lead id processed */
  maxAmbassadorLeadIdProcessed: Scalars['Int']['output']
}

/** Ambassador lead where conditions to filter rows */
export type AmbassadorLeadsWhereInput = {
  /** The created at field where clause */
  createdAt?: InputMaybe<AmbassadorLeadWhereCreatedAtInput>
  /** The id field where clause */
  id?: InputMaybe<AmbassadorLeadWhereIdInput>
  /** The updated at field where clause */
  updatedAt?: InputMaybe<AmbassadorLeadWhereUpdatedAtInput>
}

export type AppError = {
  __typename?: 'AppError'
  code: Scalars['String']['output']
  message: Scalars['String']['output']
}

/**
 * Asset represents a file (image, video, document, text track, etc.) that can be associated with content.
 *
 * Conceptually, assets are the actual files stored in cloud storage (AWS S3, ImgIX, Brightcove, etc.)
 * that are referenced by content. Assets can include:
 * - Images (thumbnails, posters, artwork)
 * - Video files
 * - Text tracks (subtitles, closed captions, chapters)
 * - Documents (PDFs, etc.)
 *
 * ASSET vs IMAGE PREFERENCE:
 * Assets are PREFERRED over Images for accessing content-related files. Assets have a deterministic
 * relationship to content through ContentAssetReference, which provides a clear, predictable way to
 * associate files with content. Images exist for backward compatibility but have a non-deterministic
 * relationship to content through ImageContentRelationship, making them less reliable for programmatic access.
 * Always prefer using Assets (via contentAssetReferences) over Images when possible.
 *
 * Important Usage Notes:
 * - To get the actual asset file, use the renderUrl field and make an HTTP GET request to that URL.
 *   This is the most efficient way to retrieve asset data, as it leverages CDN caching and direct
 *   file access rather than going through GraphQL.
 *
 * - The renderUrl supports query parameters for dynamic image transformations:
 *   - w: width (1-7680 pixels)
 *   - h: height (1-4320 pixels)
 *   - fm: format (e.g., "jpg", "png", "webp")
 *   - q: quality (1-100)
 *   - auto: auto optimization
 *   - upscale: allow upscaling (boolean)
 *   - cs: color space (e.g., "strip", "srgb")
 *   - genFill: generate fill for missing image margins (boolean)
 *
 *   Example: renderUrl + "?w=800&h=600&fm=webp&q=85" to get a WebP image at 800x600 with 85% quality.
 *
 * - For text tracks (subtitles, closed captions): If you only need the raw VTT file data, it is
 *   more efficient to access the renderUrl directly via REST/HTTP rather than using GraphQL.
 *   GraphQL is better when you need parsed metadata or relationships, but for raw file content,
 *   direct URL access is preferred.
 */
export type Asset = {
  __typename?: 'Asset'
  /** The asset providers directly linked to this asset */
  assetProviders?: Maybe<Array<Maybe<AssetProvider>>>
  /** The content asset reference directly linked to this asset */
  contentAssetReference?: Maybe<ContentAssetReference>
  /** Get course item progress for this asset (if it is an asset in a course) */
  courseItemProgress?: Maybe<UserStateProgressCourseItem>
  /** The date the row was created */
  createdAt?: Maybe<Scalars['DateTime']['output']>
  /** The optional duration of the asset in seconds for assets that have a duration e.g. videos */
  duration?: Maybe<Scalars['Int']['output']>
  /** The hash of the file to allow checking of assets changes without loading the file */
  fileHash?: Maybe<Scalars['String']['output']>
  /** The file size in bytes */
  fileSize?: Maybe<Scalars['Int']['output']>
  /** The height of the asset in pixels for assets that have a height */
  height?: Maybe<Scalars['Int']['output']>
  /** The primary identifier for this record */
  id?: Maybe<Scalars['ID']['output']>
  /**
   * The image linked to the asset (if this asset is associated with an Image record).
   * NOTE: Assets are preferred over Images. This field exists for backward compatibility with the Image type.
   * Use contentAssetReference to access the deterministic relationship to content instead.
   */
  image?: Maybe<Image>
  /** The optional language of asset that was used to create all of the translations (NULL if the file has no language) */
  language?: Maybe<Scalars['String']['output']>
  /** The mime type of the asset */
  mimeType?: Maybe<Scalars['String']['output']>
  /** The original name of the file for the asset */
  originalFileName?: Maybe<Scalars['String']['output']>
  /** The URL for the provider when proxing the asset for internal usage (do not use this in an application) */
  providerSourceRenderUrl?: Maybe<Scalars['String']['output']>
  /** The provider to render the asset */
  renderProvider?: Maybe<AssetProviders>
  /**
   * The URL to retrieve and display the asset in an application.
   * This is the most efficient way to get the actual asset file - make an HTTP GET request to this URL.
   * Supports query parameters for dynamic transformations (w, h, fm, q, auto, upscale, cs, genFill).
   * For text tracks, accessing this URL directly via REST is preferred over GraphQL if you only need raw data.
   */
  renderUrl?: Maybe<Scalars['String']['output']>
  /** The date the row was last updated */
  updatedAt?: Maybe<Scalars['DateTime']['output']>
  /** The public identifier for this record to be used with external api calls */
  uuid?: Maybe<Scalars['ID']['output']>
  /** The width of the asset in pixels for assets that have a width */
  width?: Maybe<Scalars['Int']['output']>
}

/**
 * Asset represents a file (image, video, document, text track, etc.) that can be associated with content.
 *
 * Conceptually, assets are the actual files stored in cloud storage (AWS S3, ImgIX, Brightcove, etc.)
 * that are referenced by content. Assets can include:
 * - Images (thumbnails, posters, artwork)
 * - Video files
 * - Text tracks (subtitles, closed captions, chapters)
 * - Documents (PDFs, etc.)
 *
 * ASSET vs IMAGE PREFERENCE:
 * Assets are PREFERRED over Images for accessing content-related files. Assets have a deterministic
 * relationship to content through ContentAssetReference, which provides a clear, predictable way to
 * associate files with content. Images exist for backward compatibility but have a non-deterministic
 * relationship to content through ImageContentRelationship, making them less reliable for programmatic access.
 * Always prefer using Assets (via contentAssetReferences) over Images when possible.
 *
 * Important Usage Notes:
 * - To get the actual asset file, use the renderUrl field and make an HTTP GET request to that URL.
 *   This is the most efficient way to retrieve asset data, as it leverages CDN caching and direct
 *   file access rather than going through GraphQL.
 *
 * - The renderUrl supports query parameters for dynamic image transformations:
 *   - w: width (1-7680 pixels)
 *   - h: height (1-4320 pixels)
 *   - fm: format (e.g., "jpg", "png", "webp")
 *   - q: quality (1-100)
 *   - auto: auto optimization
 *   - upscale: allow upscaling (boolean)
 *   - cs: color space (e.g., "strip", "srgb")
 *   - genFill: generate fill for missing image margins (boolean)
 *
 *   Example: renderUrl + "?w=800&h=600&fm=webp&q=85" to get a WebP image at 800x600 with 85% quality.
 *
 * - For text tracks (subtitles, closed captions): If you only need the raw VTT file data, it is
 *   more efficient to access the renderUrl directly via REST/HTTP rather than using GraphQL.
 *   GraphQL is better when you need parsed metadata or relationships, but for raw file content,
 *   direct URL access is preferred.
 */
export type AssetCourseItemProgressArgs = {
  courseTitleGroupId: Scalars['String']['input']
}

/** Asset filter input */
export type AssetFilterInput = {
  /** The asset language */
  language?: InputMaybe<Scalars['String']['input']>
}

/** Asset */
export type AssetProvider = {
  __typename?: 'AssetProvider'
  /** The asset linked to this asset provider */
  asset?: Maybe<Asset>
  /** The the asset linked to this provider */
  assetsId?: Maybe<Scalars['ID']['output']>
  /** The date the row was created */
  createdAt?: Maybe<Scalars['DateTime']['output']>
  /** The primary identifier for this record */
  id?: Maybe<Scalars['ID']['output']>
  /** The provider where the asset is stored e.g. AWS_S3 */
  provider?: Maybe<AssetProviders>
  /** The unique key for the asset on providers system e.g. on S3 it would be file key or it might be a url for an external provider */
  providerKey?: Maybe<Scalars['String']['output']>
  /** The url to render this specific provider asset (in an application it is preferred to use the asset render url) */
  renderUrl?: Maybe<Scalars['String']['output']>
  /** The date the row was last updated */
  updatedAt?: Maybe<Scalars['DateTime']['output']>
}

/** AssetProvider where id input */
export type AssetProviderWhereIdInput = {
  /** Is the value equal to the field */
  eq?: InputMaybe<Scalars['ID']['input']>
  /** Is the value greater than to the field */
  gt?: InputMaybe<Scalars['ID']['input']>
  /** Is the value greater than or equal to the field */
  gte?: InputMaybe<Scalars['ID']['input']>
  /** Are the values in the field */
  in?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>
  /** Is the value less than to the field */
  lt?: InputMaybe<Scalars['ID']['input']>
  /** Is the value less than or equal to the field */
  lte?: InputMaybe<Scalars['ID']['input']>
}

/** AssetProvider where input */
export type AssetProviderWhereInput = {
  /** AssetProvider where id clause */
  id?: InputMaybe<AssetProviderWhereIdInput>
}

/** Asset providers */
export enum AssetProviders {
  /** AWS S3 */
  AwsS3 = 'AWS_S3',
  /** The Brightcove assets service */
  BrightcoveImages = 'BRIGHTCOVE_IMAGES',
  /** The ImgIX assets service */
  Imgix = 'IMGIX',
}

/** AssetProviders list response */
export type AssetProvidersListResponse = {
  __typename?: 'AssetProvidersListResponse'
  /** A list of assetProviders */
  assetProviders?: Maybe<Array<Maybe<AssetProvider>>>
}

/** Asset where id input */
export type AssetWhereIdInput = {
  /** Is the value equal to the field */
  eq?: InputMaybe<Scalars['ID']['input']>
  /** Is the value greater than to the field */
  gt?: InputMaybe<Scalars['ID']['input']>
  /** Is the value greater than or equal to the field */
  gte?: InputMaybe<Scalars['ID']['input']>
  /** Are the values in the field */
  in?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>
  /** Is the value less than to the field */
  lt?: InputMaybe<Scalars['ID']['input']>
  /** Is the value less than or equal to the field */
  lte?: InputMaybe<Scalars['ID']['input']>
}

/** Asset where input */
export type AssetWhereInput = {
  /** Asset where id clause */
  id?: InputMaybe<AssetWhereIdInput>
  /** Asset where language clause */
  language?: InputMaybe<AssetWhereLanguageInput>
  /** Asset where mimeTypes clause */
  mimeType?: InputMaybe<AssetWhereMimeTypeInput>
  /** Asset where uuid clause */
  uuid?: InputMaybe<AssetWhereUuidInput>
}

/** Asset where language input */
export type AssetWhereLanguageInput = {
  /** Is the value equal to the field */
  eq?: InputMaybe<Scalars['ID']['input']>
  /** Are the values in the field */
  in?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>
}

export type AssetWhereMimeTypeInput = {
  /** Is the value equal to the field */
  eq?: InputMaybe<Scalars['String']['input']>
  /** Are the values in the field */
  in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
}

/** Asset where uuid input */
export type AssetWhereUuidInput = {
  /** Is the value equal to the field */
  eq?: InputMaybe<Scalars['ID']['input']>
  /** Are the values in the field */
  in?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>
}

/** Assets list response */
export type AssetsListResponse = {
  __typename?: 'AssetsListResponse'
  /** A list of assets */
  assets?: Maybe<Array<Maybe<Asset>>>
  /** Total number of rows of content found (uses a slower count query for list) */
  count?: Maybe<Scalars['Int']['output']>
  /** The limit applied to the rows */
  limit?: Maybe<Scalars['Int']['output']>
  /** The offset applied to the rows */
  offset?: Maybe<Scalars['Int']['output']>
}

/** Audit Category Type */
export enum AuditCategoryType {
  /** Ambassador */
  Ambassador = 'ambassador',
  /** Billing */
  Billing = 'billing',
  /** User */
  User = 'user',
}

/** Audit Field Name */
export enum AuditFieldName {
  AccountOwnerChange = 'ACCOUNT_OWNER_CHANGE',
  AnonymizeUser = 'ANONYMIZE_USER',
  Active = 'Active',
  BusinessName = 'BusinessName',
  Cancel = 'CANCEL',
  Chargeback = 'CHARGEBACK',
  Comp = 'COMP',
  CurrencyChange = 'CURRENCY_CHANGE',
  ContactEmail = 'ContactEmail',
  ContactName = 'ContactName',
  Created = 'Created',
  EmailChange = 'EMAIL_CHANGE',
  EntitlementAdded = 'ENTITLEMENT_ADDED',
  EntitlementChange = 'ENTITLEMENT_CHANGE',
  EntitlementRemoved = 'ENTITLEMENT_REMOVED',
  EverflowAffiliateId = 'EverflowAffiliateId',
  GiftPurchase = 'GIFT_PURCHASE',
  GiftRedemption = 'GIFT_REDEMPTION',
  Hold = 'HOLD',
  LeadExpirationOverrideDays = 'LeadExpirationOverrideDays',
  NameChangeFirst = 'NAME_CHANGE_FIRST',
  NameChangeLast = 'NAME_CHANGE_LAST',
  PasswordChange = 'PASSWORD_CHANGE',
  PlanChange = 'PLAN_CHANGE',
  PostalCodeChange = 'POSTAL_CODE_CHANGE',
  PostalCodeCleanup = 'POSTAL_CODE_CLEANUP',
  ProfileAdd = 'PROFILE_ADD',
  ProfileDelete = 'PROFILE_DELETE',
  Parent = 'Parent',
  PayoutCurrency = 'PayoutCurrency',
  Processed = 'Processed',
  Reactivation = 'REACTIVATION',
  Refund = 'REFUND',
  RefundCancel = 'REFUND_CANCEL',
  RefundDowngrade = 'REFUND_DOWNGRADE',
  RemovePaymentMethods = 'REMOVE_PAYMENT_METHODS',
  Resume = 'RESUME',
  Relationship = 'Relationship',
  RelationshipOwner = 'RelationshipOwner',
  ResidenceCountry = 'ResidenceCountry',
  Ripple1Percentage = 'Ripple1Percentage',
  Ripple2Percentage = 'Ripple2Percentage',
  Signup = 'SIGNUP',
  StatusChange = 'STATUS_CHANGE',
  StartedAt = 'StartedAt',
  UpdateBillingAddress = 'UPDATE_BILLING_ADDRESS',
  UpdatePaymentMethod = 'UPDATE_PAYMENT_METHOD',
  UsernameChange = 'USERNAME_CHANGE',
  UserSubscriptionImport = 'USER_SUBSCRIPTION_IMPORT',
}

/** Auth role */
export type AuthRole = {
  __typename?: 'AuthRole'
  /** The time in milliseconds where expired authentication will still be considered valid and renewed for users with this role, null is infinity */
  authenticationExpiredValidMilliseconds?: Maybe<Scalars['Int']['output']>
  /** The time in milliseconds where authentication should expire for users with this role, null is infinity */
  authenticationExpiresMilliseconds?: Maybe<Scalars['Int']['output']>
  /** The date the row was created */
  createdAt?: Maybe<Scalars['DateTime']['output']>
  /** The description of the role */
  description?: Maybe<Scalars['String']['output']>
  /** The maximum allowed failed login attempt for users with this role, null is infinity */
  maxFailedLoginAttempts?: Maybe<Scalars['Int']['output']>
  /** The name of the role */
  name: Scalars['String']['output']
  /** The primary key */
  role: Scalars['ID']['output']
  /** The date the row was last updated */
  updatedAt?: Maybe<Scalars['DateTime']['output']>
  /** The user roles associated with this record */
  userRoles?: Maybe<Array<Maybe<UserRole>>>
}

/** Auth role */
export type AuthRoleUserRolesArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>
  offset?: InputMaybe<Scalars['Int']['input']>
}

/** Input type for creating a new auth role */
export type AuthRoleCreateInput = {
  /** The time in milliseconds where expired authentication will still be considered valid and renewed for users with this role, null is infinity */
  authenticationExpiredValidMilliseconds?: InputMaybe<Scalars['Int']['input']>
  /** The time in milliseconds where authentication should expire for users with this role, null is infinity */
  authenticationExpiresMilliseconds?: InputMaybe<Scalars['Int']['input']>
  /** The description of the role */
  description?: InputMaybe<Scalars['String']['input']>
  /** The maximum allowed failed login attempt for users with this role, null is infinity */
  maxFailedLoginAttempts?: InputMaybe<Scalars['Int']['input']>
  /** The name of the role */
  name: Scalars['String']['input']
  /** The primary key (optional) */
  role?: InputMaybe<Scalars['ID']['input']>
}

/** Input type for deleting an existing auth role */
export type AuthRoleDeleteInput = {
  /** The primary key of the auth role to delete */
  role: Scalars['ID']['input']
}

/** Auth role list response */
export type AuthRoleListResponse = {
  __typename?: 'AuthRoleListResponse'
  /** A list of userInfo reference */
  authRoles?: Maybe<Array<Maybe<AuthRole>>>
  /** Total number of rows found (uses a slower count query for list) */
  count?: Maybe<Scalars['Int']['output']>
  /** The limit applied to the rows */
  limit?: Maybe<Scalars['Int']['output']>
  /** The offset applied to the rows */
  offset?: Maybe<Scalars['Int']['output']>
}

/** Auth role where conditions to filter rows */
export type AuthRoleListWhereInput = {
  /** The name field where clause */
  name?: InputMaybe<AuthRoleListWhereNameInput>
  /** The role field where clause */
  role?: InputMaybe<AuthRoleListWhereRoleInput>
}

/** Auth role name where input type */
export type AuthRoleListWhereNameInput = {
  /** Is the value equal to the field */
  eq?: InputMaybe<Scalars['ID']['input']>
  /** Are the values in the field */
  in?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>
}

/** Auth role id where input type */
export type AuthRoleListWhereRoleInput = {
  /** Is the value equal to the field */
  eq?: InputMaybe<Scalars['ID']['input']>
  /** Is the value greater than to the field */
  gt?: InputMaybe<Scalars['ID']['input']>
  /** Is the value greater than or equal to the field */
  gte?: InputMaybe<Scalars['ID']['input']>
  /** Are the values in the field */
  in?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>
  /** Is the value less than the field */
  lt?: InputMaybe<Scalars['ID']['input']>
  /** Is the value less than or equal to the field */
  lte?: InputMaybe<Scalars['ID']['input']>
}

/** Response object containing a boolean property of success and the created/deleted auth role */
export type AuthRoleMutationResponse = {
  __typename?: 'AuthRoleMutationResponse'
  /** The created or deleted auth role */
  authRole?: Maybe<AuthRole>
  /** A boolean property of success indicating whether the operation was successful */
  success: Scalars['Boolean']['output']
}

/** Input type for updating an existing auth role */
export type AuthRoleUpdateInput = {
  /** The time in milliseconds where expired authentication will still be considered valid and renewed for users with this role, null is infinity (optional) */
  authenticationExpiredValidMilliseconds?: InputMaybe<Scalars['Int']['input']>
  /** The time in milliseconds where authentication should expire for users with this role, null is infinity (optional) */
  authenticationExpiresMilliseconds?: InputMaybe<Scalars['Int']['input']>
  /** The description of the role (optional) */
  description?: InputMaybe<Scalars['String']['input']>
  /** The maximum allowed failed login attempt for users with this role, null is infinity (optional) */
  maxFailedLoginAttempts?: InputMaybe<Scalars['Int']['input']>
  /** The name of the role */
  name?: InputMaybe<Scalars['String']['input']>
  /** The primary key of the auth role to update */
  role: Scalars['ID']['input']
}

/** Billing Account */
export type BillingAccount = {
  __typename?: 'BillingAccount'
  /** Whether this account has been closed */
  accountClosed?: Maybe<Scalars['Boolean']['output']>
  /** Billing Provider associated with this Billing Account */
  billingProvider?: Maybe<BillingProvider>
  /** The billing provider ID of the billing account */
  billingProviderId?: Maybe<Scalars['Int']['output']>
  /** The date the user accepted the cancel offer */
  cancelOfferAcceptedDate?: Maybe<Scalars['Date']['output']>
  /** The country for the billing account */
  country?: Maybe<Scalars['String']['output']>
  /** When the row was created */
  createdAt?: Maybe<Scalars['DateTime']['output']>
  /** The currency for the billing account */
  currency?: Maybe<Scalars['String']['output']>
  /** The id of the billing account */
  id?: Maybe<Scalars['ID']['output']>
  /** Whether the initial authorization was successful */
  initialAuthSuccess?: Maybe<Scalars['Boolean']['output']>
  /** The postal code for the billing account */
  postalCode?: Maybe<Scalars['String']['output']>
  /** Whether this is the primary billing account for the user */
  primaryAccount?: Maybe<Scalars['Boolean']['output']>
  /** The billing provider's account alternate ID for the billing account (Zuora only) */
  providerAccountAltId?: Maybe<Scalars['String']['output']>
  /** The billing provider's account ID for the billing account */
  providerAccountId?: Maybe<Scalars['String']['output']>
  /** The state for the billing account */
  state?: Maybe<Scalars['String']['output']>
  /** The tax jurisdiction code for the billing account (Avalara PCode) */
  taxJurisdictionCode?: Maybe<Scalars['String']['output']>
  /** When the row was updated */
  updatedAt?: Maybe<Scalars['DateTime']['output']>
  /** User associated with this Billing Account */
  userInfo?: Maybe<UserInfo>
  /** The User UUID of the billing account */
  userInfoUuid?: Maybe<Scalars['ID']['output']>
  /** The UUID of the billing account */
  uuid?: Maybe<Scalars['ID']['output']>
}

/** Billing Account create input type */
export type BillingAccountCreateInput = {
  /** Whether this account has been closed */
  accountClosed?: InputMaybe<Scalars['Boolean']['input']>
  /** The billing provider ID of the billing account */
  billingProviderId: Scalars['Int']['input']
  /** The date the user accepted the cancel offer */
  cancelOfferAcceptedDate?: InputMaybe<Scalars['Date']['input']>
  /** The country for the billing account */
  country?: InputMaybe<Scalars['String']['input']>
  /** The currency for the billing account */
  currency: Scalars['String']['input']
  /** Whether the initial authorization was successful */
  initialAuthSuccess?: InputMaybe<Scalars['Boolean']['input']>
  /** The postal code for the billing account */
  postalCode?: InputMaybe<Scalars['String']['input']>
  /** Whether this is the primary billing account for the user */
  primaryAccount: Scalars['Boolean']['input']
  /** The billing provider's account alternate ID for the billing account (Zuora only) */
  providerAccountAltId?: InputMaybe<Scalars['String']['input']>
  /** The billing provider's account ID for the billing account */
  providerAccountId: Scalars['String']['input']
  /** The state for the billing account */
  state?: InputMaybe<Scalars['String']['input']>
  /** The tax jurisdiction code for the billing account (Avalara PCode) */
  taxJurisdictionCode?: InputMaybe<Scalars['String']['input']>
  /** The User UUID of the billing account */
  userInfoUuid: Scalars['ID']['input']
  /** The UUID of the billing account */
  uuid?: InputMaybe<Scalars['ID']['input']>
}

/** Billing Account list response */
export type BillingAccountListResponse = {
  __typename?: 'BillingAccountListResponse'
  /** A list of billing account reference */
  billingAccounts?: Maybe<Array<Maybe<BillingAccount>>>
}

/** Billing Account list where Boolean input type */
export type BillingAccountListWhereBooleanInput = {
  /** Is the value equal to the field */
  eq?: InputMaybe<Scalars['Boolean']['input']>
}

/** Billing Account list where Date input type */
export type BillingAccountListWhereDateInput = {
  /** Is the value greater than the field */
  gt?: InputMaybe<Scalars['Date']['input']>
  /** Is the value greater than or equal to the field */
  gte?: InputMaybe<Scalars['Date']['input']>
  /** Is the value less than the field */
  lt?: InputMaybe<Scalars['Date']['input']>
  /** Is the value less than or equal to the field */
  lte?: InputMaybe<Scalars['Date']['input']>
}

/** Billing Account list where ID input type */
export type BillingAccountListWhereIdInput = {
  /** Is the value equal to the field */
  eq?: InputMaybe<Scalars['ID']['input']>
  /** Are the values in the field */
  in?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>
}

/** Billing Account list where input type */
export type BillingAccountListWhereInput = {
  /** The billing account accountClosed field where clause */
  accountClosed?: InputMaybe<BillingAccountListWhereBooleanInput>
  /** The billing account billingProviderId field where clause */
  billingProviderId?: InputMaybe<BillingAccountListWhereIntInput>
  /** The billing account cancelOfferAcceptedDate field where clause */
  cancelOfferAcceptedDate?: InputMaybe<BillingAccountListWhereDateInput>
  /** The billing account country field where clause */
  country?: InputMaybe<BillingAccountListWhereStringInput>
  /** The billing account createdAt field where clause */
  createdAt?: InputMaybe<BillingAccountListWhereDateInput>
  /** The billing account currency field where clause */
  currency?: InputMaybe<BillingAccountListWhereStringInput>
  /** The billing account id field where clause */
  id?: InputMaybe<BillingAccountListWhereIdInput>
  /** The billing account initialAuthSuccess field where clause */
  initialAuthSuccess?: InputMaybe<BillingAccountListWhereBooleanInput>
  /** The billing account postalCode field where clause */
  postalCode?: InputMaybe<BillingAccountListWhereStringInput>
  /** The billing account primaryAccount field where clause */
  primaryAccount?: InputMaybe<BillingAccountListWhereBooleanInput>
  /** The billing account providerAccountAltId field where clause */
  providerAccountAltId?: InputMaybe<BillingAccountListWhereStringInput>
  /** The billing account providerAccountId field where clause */
  providerAccountId?: InputMaybe<BillingAccountListWhereStringInput>
  /** The billing account state field where clause */
  state?: InputMaybe<BillingAccountListWhereStringInput>
  /** The billing account taxJurisdictionCode field where clause */
  taxJurisdictionCode?: InputMaybe<BillingAccountListWhereStringInput>
  /** The billing account userInfoUuid field where clause */
  userInfoUuid?: InputMaybe<BillingAccountListWhereStringInput>
  /** The billing account uuid field where clause */
  uuid?: InputMaybe<BillingAccountListWhereStringInput>
}

/** Billing Account list where Int input type */
export type BillingAccountListWhereIntInput = {
  /** Is the value equal to the field */
  eq?: InputMaybe<Scalars['Int']['input']>
  /** Are the values in the field */
  in?: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>
}

/** Billing Account list where String input type */
export type BillingAccountListWhereStringInput = {
  /** Is the value equal to the field */
  eq?: InputMaybe<Scalars['String']['input']>
  /** Are the values in the field */
  in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
}

/** Billing Account update input type */
export type BillingAccountUpdateInput = {
  /** Whether this account has been closed */
  accountClosed?: InputMaybe<Scalars['Boolean']['input']>
  /** The billing provider ID of the billing account */
  billingProviderId?: InputMaybe<Scalars['Int']['input']>
  /** The date the user accepted the cancel offer */
  cancelOfferAcceptedDate?: InputMaybe<Scalars['Date']['input']>
  /** The country for the billing account */
  country?: InputMaybe<Scalars['String']['input']>
  /** The currency for the billing account */
  currency?: InputMaybe<Scalars['String']['input']>
  /** The id of the billing account */
  id: Scalars['ID']['input']
  /** Whether the initial authorization was successful */
  initialAuthSuccess?: InputMaybe<Scalars['Boolean']['input']>
  /** The postal code for the billing account */
  postalCode?: InputMaybe<Scalars['String']['input']>
  /** Whether this is the primary billing account for the user */
  primaryAccount?: InputMaybe<Scalars['Boolean']['input']>
  /** The billing provider's account alternate ID for the billing account (Zuora only) */
  providerAccountAltId?: InputMaybe<Scalars['String']['input']>
  /** The billing provider's account ID for the billing account */
  providerAccountId?: InputMaybe<Scalars['String']['input']>
  /** The state for the billing account */
  state?: InputMaybe<Scalars['String']['input']>
  /** The tax jurisdiction code for the billing account (Avalara PCode) */
  taxJurisdictionCode?: InputMaybe<Scalars['String']['input']>
  /** The User UUID of the billing account */
  userInfoUuid?: InputMaybe<Scalars['ID']['input']>
}

/**
 * Billing events are payment events sent from individual payment providers (Google Play, Apple App Store,
 * PayPal, Amazon, Adyen, Zuora, etc.) when transactions occur. These are the raw, unprocessed events that
 * represent the complete payment history for a user.
 *
 * These events are used to:
 * 1. Create and update user entitlements (access rights) when payments are successful
 * 2. Track payment history and subscription status
 * 3. Calculate financial metrics (aggregated in billingEventsOverview)
 * 4. Handle subscription renewals, cancellations, refunds, and plan changes
 * 5. Determine user payment state and subscription status
 *
 * Event Flow:
 * - Payment provider sends webhook/notification → BillingEvent created
 * - Event processing → UserEntitlement created/updated based on event type
 * - Event aggregation → billingEventsOverview calculated for financial reporting
 *
 * Understanding Payment State from Events:
 * To determine a user's current payment state, examine the most recent events (ordered by txnDate DESC):
 *
 * 1. Active Subscription:
 *    - Look for recent "payment" or "renewal" events with paymentStatus="completed"
 *    - Check paidThroughDate: if in the future, user has paid access
 *    - Check endDate: if in the future or null, subscription is active
 *    - Check expiresDate: if in the future, subscription hasn't expired
 *
 * 2. Payment Issues:
 *    - paymentStatus="failed" or "pending" indicates payment problems
 *    - errorCode field contains details about payment failures
 *    - Check if paidThroughDate is in the past (access may be suspended)
 *
 * 3. Subscription Status:
 *    - "cancellation" event: Subscription cancelled (check cancelReason)
 *    - "refund" event: Payment was refunded (may affect entitlements)
 *    - "plan_change" event: User upgraded/downgraded subscription
 *    - "trial_start"/"trial_end": Trial period tracking (isTrialPeriod=true)
 *
 * 4. Payment Method State:
 *    - paymentMethod indicates how user pays (credit_card, paypal, google_wallet, etc.)
 *    - paymentType indicates payment structure (subscription, one_time, trial)
 *    - scheduledPaymentDate shows when next payment is expected
 *
 * 5. Access Period:
 *    - startDate: When access period begins
 *    - endDate: When access period ends (null = no expiration)
 *    - paidThroughDate: Date through which user has paid (key indicator of active access)
 *
 * Common transaction types (txnType):
 * - "payment": Successful payment (one-time or initial subscription payment)
 * - "renewal": Subscription renewal (recurring payment)
 * - "cancellation": Subscription cancelled (may still have access until endDate/paidThroughDate)
 * - "refund": Payment refunded (may revoke entitlements)
 * - "plan_change": Subscription plan changed (upgrade/downgrade)
 * - "trial_start": Trial period started
 * - "trial_end": Trial period ended
 * - "hold": Subscription paused (temporary suspension)
 * - "sync_billing": Billing synchronization event (for app store subscriptions)
 *
 * The source field identifies the payment provider (e.g., "google", "apple", "paypal", "amazon", "adyen", "zuora").
 * Events are linked to users via the uid field, which corresponds to UserInfo.uid.
 *
 * IMPORTANT: To get the complete payment picture, query all events for a user and analyze the sequence.
 * The most recent event with paymentStatus="completed" and a future paidThroughDate typically indicates
 * active payment status. However, always check for subsequent cancellation or refund events that may
 * have changed the state.
 */
export type BillingEvent = {
  __typename?: 'BillingEvent'
  /**
   * Whether this event has been processed for account history. Used to track
   * which events have been included in historical calculations.
   */
  accountHistoryProcessed?: Maybe<Scalars['Boolean']['output']>
  /** The payment amount (in the specified currency) */
  amount?: Maybe<Scalars['Float']['output']>
  /** Reason for cancellation (if this is a cancellation event) */
  cancellationReason?: Maybe<Scalars['String']['output']>
  /** When the row was created in the database */
  createdAt?: Maybe<Scalars['DateTime']['output']>
  /** The currency code for the payment amount (e.g., USD, EUR, GBP) */
  currency?: Maybe<Scalars['String']['output']>
  /**
   * The end date for the subscription or access period. When the user's access ends.
   * If null, the subscription has no expiration. Compare with current date to determine
   * if access is still valid. This is a key field for determining active subscription status.
   */
  endDate?: Maybe<Scalars['DateTime']['output']>
  /**
   * Error code if the payment failed or had issues. Contains provider-specific error codes
   * when paymentStatus is "failed" or "pending". Use this along with providerComments
   * to understand why a payment failed and what action might be needed.
   *
   * Common scenarios:
   * - Payment method declined (insufficient funds, expired card, etc.)
   * - Provider-specific errors (network issues, account problems, etc.)
   * - Validation errors (invalid payment details)
   *
   * If errorCode is set, the payment did not complete successfully and entitlements
   * should not be granted based on this event.
   */
  errorCode?: Maybe<Scalars['String']['output']>
  /**
   * The date when the subscription or access expires. Similar to endDate but may
   * represent a different expiration concept depending on the provider. Check both
   * endDate and expiresDate to fully understand access expiration.
   *
   * If expiresDate is in the future, the subscription hasn't expired yet.
   * If in the past, the subscription has expired and may need renewal.
   */
  expiresDate?: Maybe<Scalars['DateTime']['output']>
  /** The primary identifier for this record (auto-incrementing integer) */
  id?: Maybe<Scalars['ID']['output']>
  /**
   * Whether this transaction is part of a trial period. If true, this is a trial
   * payment and the user may not have been charged (or charged a reduced amount).
   * Trial periods typically convert to paid subscriptions after trial_end events.
   *
   * Use this field along with txnType="trial_start" or "trial_end" to track trial
   * status and understand when trial converts to paid subscription.
   */
  isTrialPeriod?: Maybe<Scalars['Boolean']['output']>
  /** Linkshare affiliate identifier (for affiliate tracking) */
  linkshareAffiliate?: Maybe<Scalars['String']['output']>
  /** The date when the Linkshare affiliate was recorded */
  linkshareDate?: Maybe<Scalars['DateTime']['output']>
  /** The amount that will be billed next (for recurring subscriptions) */
  nextBillAmount?: Maybe<Scalars['Float']['output']>
  /**
   * The date through which the user has paid (subscription paid through date).
   * This is CRITICAL for determining payment state:
   * - If paidThroughDate is in the future: User has paid access until that date
   * - If paidThroughDate is in the past: User's paid access has expired
   * - If null: May indicate one-time payment or trial (check paymentType)
   *
   * This date is typically set when a payment is successful and determines when
   * entitlements should be active. Always check this field along with paymentStatus
   * to understand current payment state.
   */
  paidThroughDate?: Maybe<Scalars['DateTime']['output']>
  /**
   * The parent transaction ID. For subscription renewals or related transactions,
   * this links to the original transaction.
   */
  parentTxnId?: Maybe<Scalars['String']['output']>
  /**
   * The payment method (e.g., "credit_card", "paypal", "google_wallet", "apple_pay", "amazon_pay").
   * Identifies how the user pays. Useful for understanding payment provider relationships
   * and troubleshooting payment issues specific to payment methods.
   */
  paymentMethod?: Maybe<Scalars['String']['output']>
  /**
   * The payment status (e.g., "completed", "pending", "failed", "refunded", "voided").
   * CRITICAL field for understanding payment state:
   * - "completed": Payment successful, entitlements should be granted
   * - "pending": Payment processing, entitlements may be delayed
   * - "failed": Payment failed, no entitlements granted, check errorCode
   * - "refunded": Payment was refunded, entitlements may be revoked
   * - "voided": Payment was voided/cancelled before completion
   *
   * Always check this field to determine if the payment was actually successful.
   * Only events with paymentStatus="completed" should result in active entitlements.
   */
  paymentStatus?: Maybe<Scalars['String']['output']>
  /**
   * The payment type (e.g., "subscription", "one_time", "trial").
   * - "subscription": Recurring payment (expect renewals)
   * - "one_time": Single payment (no automatic renewals)
   * - "trial": Trial period payment (may convert to subscription)
   *
   * Use this to understand the payment structure and predict future events.
   */
  paymentType?: Maybe<Scalars['String']['output']>
  /** The plan ID associated with this transaction (system identifier) */
  planId?: Maybe<Scalars['String']['output']>
  /** The plan name associated with this transaction (human-readable) */
  planName?: Maybe<Scalars['String']['output']>
  /**
   * Plan segment data stored as JSON. Contains information about the plan segments,
   * pricing tiers, or product variations.
   */
  planSegmentData?: Maybe<Scalars['JSON']['output']>
  /**
   * The date and time when this event was processed by the system. Indicates when
   * the event was received and stored, which may differ from txnDate (when the
   * transaction actually occurred at the provider). Useful for debugging event
   * processing delays and understanding event timeline.
   */
  processedAt?: Maybe<Scalars['DateTime']['output']>
  /** Comments or notes from the payment provider */
  providerComments?: Maybe<Scalars['String']['output']>
  /**
   * Raw provider data stored as JSON. Contains the complete response from the payment provider,
   * including provider-specific fields and metadata.
   */
  providerData?: Maybe<Scalars['JSON']['output']>
  /** The subscription ID in the payment provider's system (for recurring subscriptions) */
  providerSubscriptionId?: Maybe<Scalars['String']['output']>
  /** The user ID in the payment provider's system */
  providerUserId?: Maybe<Scalars['String']['output']>
  /** Referral channels (how the user was referred) */
  referralChannels?: Maybe<Scalars['String']['output']>
  /** Referral source (where the user came from) */
  referralSource?: Maybe<Scalars['String']['output']>
  /**
   * Referral source data stored as JSON. Contains detailed referral information
   * and tracking parameters.
   */
  referralSourceJsonb?: Maybe<Scalars['JSON']['output']>
  /**
   * The scheduled date for the next payment (for recurring subscriptions).
   * Indicates when the next billing cycle will occur. Useful for understanding
   * subscription renewal timeline and predicting future payment state.
   */
  scheduledPaymentDate?: Maybe<Scalars['DateTime']['output']>
  /** The country code where the user signed up */
  signupCountry?: Maybe<Scalars['String']['output']>
  /**
   * The payment provider source (e.g., "google", "apple", "paypal", "amazon", "adyen").
   * Identifies which payment system sent this event.
   */
  source?: Maybe<Scalars['String']['output']>
  /**
   * The start date for the subscription or access period. When the user's access begins.
   * Compare with current date to determine if access period has started.
   */
  startDate?: Maybe<Scalars['DateTime']['output']>
  /** The tax amount for this transaction */
  taxAmount?: Maybe<Scalars['Float']['output']>
  /** The date and time when the transaction occurred */
  txnDate?: Maybe<Scalars['DateTime']['output']>
  /**
   * The transaction ID from the payment provider. Unique identifier for this transaction
   * in the provider's system.
   */
  txnId?: Maybe<Scalars['String']['output']>
  /**
   * The transaction type (e.g., "payment", "renewal", "cancellation", "refund", "plan_change",
   * "trial_start", "trial_end"). Describes what kind of event this is.
   */
  txnType?: Maybe<Scalars['String']['output']>
  /** The user uid (legacy identifier) linking this event to UserInfo */
  uid?: Maybe<Scalars['ID']['output']>
  /** When the row was last updated in the database */
  updatedAt?: Maybe<Scalars['DateTime']['output']>
  /**
   * The user associated with this event. Links to UserInfo via the uid field.
   * This is the user who made the payment or whose subscription was affected.
   *
   * To understand a user's complete payment state:
   * 1. Query all billingEvents for this user (ordered by txnDate DESC)
   * 2. Filter by source if user has multiple payment providers
   * 3. Check the most recent events with paymentStatus="completed"
   * 4. Examine paidThroughDate to determine if access is currently active
   * 5. Look for cancellation or refund events that may have changed state
   * 6. Check scheduledPaymentDate to predict future payment state
   * 7. Review errorCode and paymentStatus for any payment issues
   *
   * The sequence of events tells the story of the user's payment journey:
   * - Initial payment → Renewals → Plan changes → Cancellations → Refunds
   * Each event represents a state change in the user's payment relationship.
   */
  userInfo?: Maybe<UserInfo>
  /**
   * User referral data stored as JSON. Contains information about user referrals
   * and referral program participation.
   */
  userReferralJsonb?: Maybe<Scalars['JSON']['output']>
  /** The event UUID (unique identifier for this specific event) */
  uuid?: Maybe<Scalars['ID']['output']>
}

export type BillingEventCountResponse = {
  __typename?: 'BillingEventCountResponse'
  /** The count of rows */
  count: Scalars['Int']['output']
}

/** EventCreateInput */
export type BillingEventCreateInput = {
  /** The account history processed date for event */
  accountHistoryProcessed?: InputMaybe<Scalars['Boolean']['input']>
  /** The payment amount for event */
  amount?: InputMaybe<Scalars['Float']['input']>
  /** The cancellation reason for event */
  cancellationReason?: InputMaybe<Scalars['String']['input']>
  /** The payment currency for event */
  currency?: InputMaybe<Scalars['String']['input']>
  /** The end date for event */
  endDate?: InputMaybe<Scalars['DateTime']['input']>
  /** The error code for event */
  errorCode?: InputMaybe<Scalars['String']['input']>
  /** The expires date for event */
  expiresDate?: InputMaybe<Scalars['DateTime']['input']>
  /** The is trial period flag for event */
  isTrialPeriod?: InputMaybe<Scalars['Boolean']['input']>
  /** The linkshare affiliate for event */
  linkshareAffiliate?: InputMaybe<Scalars['String']['input']>
  /** The linkshare share date for event */
  linkshareDate?: InputMaybe<Scalars['DateTime']['input']>
  /** The next bill amount for event */
  nextBillAmount?: InputMaybe<Scalars['Float']['input']>
  /** The paid through date for event */
  paidThroughDate?: InputMaybe<Scalars['DateTime']['input']>
  /** The parent transaction Id for event */
  parentTxnId: Scalars['String']['input']
  /** The payment method for event */
  paymentMethod?: InputMaybe<Scalars['String']['input']>
  /** The payment status for event */
  paymentStatus?: InputMaybe<Scalars['String']['input']>
  /** The payment type for event */
  paymentType?: InputMaybe<Scalars['String']['input']>
  /** The plan id for event */
  planId: Scalars['String']['input']
  /** The plan name for event */
  planName: Scalars['String']['input']
  /** The plan segment data response for event */
  planSegmentData?: InputMaybe<Scalars['JSON']['input']>
  /** The processed date for event */
  processedAt?: InputMaybe<Scalars['DateTime']['input']>
  /** The provider comments for event */
  providerComments?: InputMaybe<Scalars['String']['input']>
  /** The provider data response for event */
  providerData?: InputMaybe<Scalars['JSON']['input']>
  /** The provider subscription Id for event */
  providerSubscriptionId?: InputMaybe<Scalars['String']['input']>
  /** The provider user Id for event */
  providerUserId?: InputMaybe<Scalars['String']['input']>
  /** The referral channels for event */
  referralChannels?: InputMaybe<Scalars['String']['input']>
  /** The referral source for event */
  referralSource?: InputMaybe<Scalars['String']['input']>
  /** The referral source data for event */
  referralSourceJsonb?: InputMaybe<Scalars['JSON']['input']>
  /** The scheduled payment date for event */
  scheduledPaymentDate?: InputMaybe<Scalars['DateTime']['input']>
  /** The signup country for event */
  signupCountry?: InputMaybe<Scalars['String']['input']>
  /** The source for event */
  source: Scalars['String']['input']
  /** The start date for event */
  startDate?: InputMaybe<Scalars['DateTime']['input']>
  /** The tax amount for event */
  taxAmount?: InputMaybe<Scalars['Float']['input']>
  /** The transaction date for event */
  txnDate: Scalars['DateTime']['input']
  /** The transaction Id for event */
  txnId: Scalars['String']['input']
  /** The transaction type for event */
  txnType: Scalars['String']['input']
  /** The user uid for event */
  uid: Scalars['ID']['input']
  /** The user referral data for event */
  userReferralJsonb?: InputMaybe<Scalars['JSON']['input']>
}

/** Billing event policy list response */
export type BillingEventListResponse = {
  __typename?: 'BillingEventListResponse'
  /** A list of user accounts */
  billingEvents?: Maybe<Array<Maybe<BillingEvent>>>
  /** Total number of rows found (uses a slower count query for list) */
  count?: Maybe<Scalars['Int']['output']>
  /** The limit applied to the rows */
  limit?: Maybe<Scalars['Int']['output']>
  /** The offset applied to the rows */
  offset?: Maybe<Scalars['Int']['output']>
}

/** Event id type where input type */
export type BillingEventListWhereIdInput = {
  /** Is the value equal to the field */
  eq?: InputMaybe<Scalars['ID']['input']>
  /** Is the value greater than to the field */
  gt?: InputMaybe<Scalars['ID']['input']>
  /** Is the value greater than or equal to the field */
  gte?: InputMaybe<Scalars['ID']['input']>
  /** Are the values in the field */
  in?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>
}

/** Event where conditions to filter rows */
export type BillingEventListWhereInput = {
  /** The id field where clause */
  id?: InputMaybe<BillingEventListWhereIdInput>
  /** The signupCountry field where clause */
  signupCountry?: InputMaybe<BillingEventListWhereSignupCountryInput>
  /** The source field where clause */
  source?: InputMaybe<BillingEventListWhereSourceInput>
  /** The txnType field where clause */
  txnType?: InputMaybe<BillingEventListWhereTxnTypeInput>
  /** The uid field where clause */
  uid?: InputMaybe<BillingEventListWhereUidInput>
}

/** Event signup country where input type */
export type BillingEventListWhereSignupCountryInput = {
  /** Is the value equal to the field */
  eq?: InputMaybe<Scalars['String']['input']>
  /** Are the values in the field */
  in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
}

/** Event source where input type */
export type BillingEventListWhereSourceInput = {
  /** Is the value equal to the field */
  eq?: InputMaybe<Scalars['String']['input']>
  /** Are the values in the field */
  in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
}

/** Event transaction where input type */
export type BillingEventListWhereTxnTypeInput = {
  /** Is the value equal to the field */
  eq?: InputMaybe<Scalars['String']['input']>
  /** Are the values in the field */
  in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
}

/** Event uid type where input type */
export type BillingEventListWhereUidInput = {
  /** Is the value equal to the field */
  eq?: InputMaybe<Scalars['ID']['input']>
  /** Is the value greater than to the field */
  gt?: InputMaybe<Scalars['ID']['input']>
  /** Is the value greater than or equal to the field */
  gte?: InputMaybe<Scalars['ID']['input']>
  /** Are the values in the field */
  in?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>
}

/** EventUpdateInput */
export type BillingEventUpdateInput = {
  /** The account history processed date for event */
  accountHistoryProcessed?: InputMaybe<Scalars['Boolean']['input']>
  /** The payment amount for event */
  amount?: InputMaybe<Scalars['Float']['input']>
  /** The cancellation reason for event */
  cancellationReason?: InputMaybe<Scalars['String']['input']>
  /** The payment currency for event */
  currency?: InputMaybe<Scalars['String']['input']>
  /** The end date for event */
  endDate?: InputMaybe<Scalars['DateTime']['input']>
  /** The error code for event */
  errorCode?: InputMaybe<Scalars['String']['input']>
  /** The expires date for event */
  expiresDate?: InputMaybe<Scalars['DateTime']['input']>
  /** The primary identifier for this record */
  id: Scalars['ID']['input']
  /** The is trial period flag for event */
  isTrialPeriod?: InputMaybe<Scalars['Boolean']['input']>
  /** The linkshare affiliate for event */
  linkshareAffiliate?: InputMaybe<Scalars['String']['input']>
  /** The linkshare share date for event */
  linkshareDate?: InputMaybe<Scalars['DateTime']['input']>
  /** The next bill amount for event */
  nextBillAmount?: InputMaybe<Scalars['Float']['input']>
  /** The paid through date for event */
  paidThroughDate?: InputMaybe<Scalars['DateTime']['input']>
  /** The parent transaction Id for event */
  parentTxnId?: InputMaybe<Scalars['String']['input']>
  /** The payment method for event */
  paymentMethod?: InputMaybe<Scalars['String']['input']>
  /** The payment status for event */
  paymentStatus?: InputMaybe<Scalars['String']['input']>
  /** The payment type for event */
  paymentType?: InputMaybe<Scalars['String']['input']>
  /** The plan id for event */
  planId?: InputMaybe<Scalars['String']['input']>
  /** The plan name for event */
  planName?: InputMaybe<Scalars['String']['input']>
  /** The plan segment data response for event */
  planSegmentData?: InputMaybe<Scalars['JSON']['input']>
  /** The processed date for event */
  processedAt?: InputMaybe<Scalars['DateTime']['input']>
  /** The provider comments for event */
  providerComments?: InputMaybe<Scalars['String']['input']>
  /** The provider data response for event */
  providerData?: InputMaybe<Scalars['JSON']['input']>
  /** The provider subscription Id for event */
  providerSubscriptionId?: InputMaybe<Scalars['String']['input']>
  /** The provider user Id for event */
  providerUserId?: InputMaybe<Scalars['String']['input']>
  /** The referral channels for event */
  referralChannels?: InputMaybe<Scalars['String']['input']>
  /** The referral source for event */
  referralSource?: InputMaybe<Scalars['String']['input']>
  /** The referral source data for event */
  referralSourceJsonb?: InputMaybe<Scalars['JSON']['input']>
  /** The scheduled payment date for event */
  scheduledPaymentDate?: InputMaybe<Scalars['DateTime']['input']>
  /** The signup country for event */
  signupCountry?: InputMaybe<Scalars['String']['input']>
  /** The source for event */
  source?: InputMaybe<Scalars['String']['input']>
  /** The start date for event */
  startDate?: InputMaybe<Scalars['DateTime']['input']>
  /** The tax amount for event */
  taxAmount?: InputMaybe<Scalars['Float']['input']>
  /** The transaction date for event */
  txnDate?: InputMaybe<Scalars['DateTime']['input']>
  /** The transaction Id for event */
  txnId?: InputMaybe<Scalars['String']['input']>
  /** The transaction type for event */
  txnType?: InputMaybe<Scalars['String']['input']>
  /** The user uid for event */
  uid?: InputMaybe<Scalars['ID']['input']>
  /** The user referral data for event */
  userReferralJsonb?: InputMaybe<Scalars['JSON']['input']>
}

/**
 * Billing events overview provides aggregated financial metrics for a user's payment history.
 * This is calculated from all BillingEvent records for the user and provides a summary view
 * of their financial relationship with the platform.
 *
 * The overview aggregates individual billing events to calculate:
 * - Profit metrics (gross, net, tax)
 * - Loss totals (refunds, chargebacks, etc.)
 * - Currency information
 *
 * IMPORTANT: All payment amounts are in the user's currency. If multiple currencies are present,
 * the aggregate totals may not be valid for direct comparison.
 *
 * This overview is useful for:
 * - Understanding a user's lifetime value
 * - Calculating revenue metrics
 * - Financial reporting and analysis
 * - Customer support inquiries about payment history
 *
 * The profit and loss calculations use specific transaction types (defined in eventProfitTxnTypes
 * and eventLossTxnTypes) to categorize events appropriately.
 */
export type BillingEventsOverview = {
  __typename?: 'BillingEventsOverview'
  /**
   * The currencies for all of the payment events. This is an array of all unique currency codes
   * found in the user's billing events.
   *
   * WARNING: If there is more than one currency, the aggregate totals (profit, loss, etc.) are not
   * valid for direct comparison as they mix different currencies. Always check the currencies array
   * before using aggregate totals.
   */
  currencies?: Maybe<Array<Maybe<Scalars['String']['output']>>>
  /**
   * The event transaction types used to filter loss events. These are the txnType values
   * from BillingEvent that are considered losses (e.g., "refund", "chargeback").
   */
  eventLossTxnTypes?: Maybe<Array<Maybe<Scalars['String']['output']>>>
  /**
   * The event transaction types used to filter profit events. These are the txnType values
   * from BillingEvent that are considered profit-generating (e.g., "payment", "renewal").
   */
  eventProfitTxnTypes?: Maybe<Array<Maybe<Scalars['String']['output']>>>
  /**
   * The loss total: total of all loss events (refunds, chargebacks, cancellations, etc.).
   * This represents money returned to customers or lost due to failed transactions.
   */
  lossTotal?: Maybe<Scalars['Float']['output']>
  /**
   * The profit: final profit calculation after deducting cost of goods sold, tax, and losses.
   * This is the net profit after all deductions and losses are accounted for.
   */
  profit?: Maybe<Scalars['Float']['output']>
  /**
   * The profit gross: profit without deducting any costs. This is the raw revenue
   * from all profitable transactions before any deductions.
   */
  profitGross?: Maybe<Scalars['Float']['output']>
  /**
   * The profit net: profit after deducting cost of goods sold, with only tax deducted.
   * This represents the net profit from profitable transactions.
   */
  profitNet?: Maybe<Scalars['Float']['output']>
  /**
   * The profit tax: total tax collected for all profitable events. This is the sum
   * of tax amounts from all profit-generating transactions.
   */
  profitTax?: Maybe<Scalars['Float']['output']>
  /** The user uid linking this overview to UserInfo */
  uid?: Maybe<Scalars['ID']['output']>
}

/** Billing Invoice */
export type BillingInvoice = {
  __typename?: 'BillingInvoice'
  /** The balance of the billing invoice */
  balance?: Maybe<Scalars['Float']['output']>
  /** Billing One Time Purchase associated with this Billing Invoice */
  billingOneTimePurchase?: Maybe<BillingOneTimePurchase>
  /** The billing one time purchase ID of the billing invoice */
  billingOneTimePurchaseId?: Maybe<Scalars['ID']['output']>
  /** The billing provider product ID of the billing invoice */
  billingProviderProductId?: Maybe<Scalars['ID']['output']>
  /** Billing Subscription Plan associated with this Billing Invoice */
  billingSubscriptionPlan?: Maybe<BillingSubscriptionPlan>
  /** The billing subscription ID of the billing invoice */
  billingSubscriptionPlanId?: Maybe<Scalars['ID']['output']>
  /** When the row was created */
  createdAt?: Maybe<Scalars['DateTime']['output']>
  /** The due date of the billing invoice */
  dueDate?: Maybe<Scalars['DateTime']['output']>
  /** The id of the billing invoice */
  id?: Maybe<Scalars['ID']['output']>
  /** The period end of the billing invoice */
  periodEnd?: Maybe<Scalars['DateTime']['output']>
  /** The period start of the billing invoice */
  periodStart?: Maybe<Scalars['DateTime']['output']>
  /** The billing provider invoice ID of the billing invoice */
  providerInvoiceId?: Maybe<Scalars['String']['output']>
  /** The quantity of the billing invoice */
  quantity?: Maybe<Scalars['Int']['output']>
  /** The tax amount of the billing invoice */
  taxAmount?: Maybe<Scalars['Float']['output']>
  /** The tax amount of the billing invoice */
  taxJurisdictionCode?: Maybe<Scalars['String']['output']>
  /** The total amount of the billing invoice */
  totalAmount?: Maybe<Scalars['Float']['output']>
  /** When the row was last updated */
  updatedAt?: Maybe<Scalars['DateTime']['output']>
  /** The UUID of the billing invoice */
  uuid?: Maybe<Scalars['ID']['output']>
  /** The balance of the billing invoice */
  writtenOff?: Maybe<Scalars['Boolean']['output']>
}

/** Create input for Billing Invoice */
export type BillingInvoiceCreateInput = {
  /** Balance of the billing invoice */
  balance?: InputMaybe<Scalars['Float']['input']>
  /** The billing one time purchase Id of the billing invoice */
  billingOneTimePurchaseId?: InputMaybe<Scalars['ID']['input']>
  /** The billing provider product Id of the billing invoice */
  billingProviderProductId: Scalars['ID']['input']
  /** The billing subscription plan Id of the billing invoice */
  billingSubscriptionPlanId?: InputMaybe<Scalars['ID']['input']>
  /** Due date of the billing invoice */
  dueDate: Scalars['DateTime']['input']
  /** Period ends of the billing invoice */
  periodEnd: Scalars['DateTime']['input']
  /** Period starts of the billing invoice */
  periodStart: Scalars['DateTime']['input']
  /** The provider invoice Id of the billing invoice */
  providerInvoiceId?: InputMaybe<Scalars['ID']['input']>
  /** The quantity of the billing invoice */
  quantity: Scalars['Int']['input']
  /** Tax amount of the billing invoice */
  taxAmount: Scalars['Float']['input']
  /** Tax Jurisdiction code of the billing invoice */
  taxJurisdictionCode?: InputMaybe<Scalars['String']['input']>
  /** Total amount of the billing invoice */
  totalAmount: Scalars['Float']['input']
  /** Whether the invoice was written off */
  writtenOff: Scalars['Boolean']['input']
}

/** Billing Invoice list response */
export type BillingInvoiceListResponse = {
  __typename?: 'BillingInvoiceListResponse'
  billingInvoices?: Maybe<Array<Maybe<BillingInvoice>>>
}

/** Billing Invoice boolean where input type */
export type BillingInvoiceListWhereBooleanInput = {
  /** Is the value equal to the field */
  eq?: InputMaybe<Scalars['Boolean']['input']>
}

/** Billing Invoice list where Date input type */
export type BillingInvoiceListWhereDateInput = {
  /** Is the value greater than the field */
  gt?: InputMaybe<Scalars['Date']['input']>
  /** Is the value greater than or equal to the field */
  gte?: InputMaybe<Scalars['Date']['input']>
  /** Is the value less than the field */
  lt?: InputMaybe<Scalars['Date']['input']>
  /** Is the value less than or equal to the field */
  lte?: InputMaybe<Scalars['Date']['input']>
}

/** Billing Invoice float where input type */
export type BillingInvoiceListWhereFloatInput = {
  /** Is the value equal to the field */
  eq?: InputMaybe<Scalars['Float']['input']>
}

/** Billing Invoice list id where input type */
export type BillingInvoiceListWhereIdInput = {
  /** Is the value equal to the field */
  eq?: InputMaybe<Scalars['ID']['input']>
  /** Are the values in the field */
  in?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>
}

/** Billing Invoice list where input type */
export type BillingInvoiceListWhereInput = {
  /** The billingInvoice balance field where clause */
  balance?: InputMaybe<BillingInvoiceListWhereFloatInput>
  /** The billingInvoice billingOneTimePurchaseId field where clause */
  billingOneTimePurchaseId?: InputMaybe<BillingInvoiceListWhereIdInput>
  /** The billingInvoice billingProviderProductId field where clause */
  billingProviderProductId?: InputMaybe<BillingInvoiceListWhereIdInput>
  /** The billingInvoice billingSubscriptionPlanId field where clause */
  billingSubscriptionPlanId?: InputMaybe<BillingInvoiceListWhereIdInput>
  /** The billingInvoice createdAt field where clause */
  createdAt?: InputMaybe<BillingInvoiceListWhereDateInput>
  /** The billingInvoice dueDate field where clause */
  dueDate?: InputMaybe<BillingInvoiceListWhereDateInput>
  /** The billingInvoice id field where clause */
  id?: InputMaybe<BillingInvoiceListWhereIdInput>
  /** The billingInvoice periodEnd field where clause */
  periodEnd?: InputMaybe<BillingInvoiceListWhereDateInput>
  /** The billingInvoice periodStart field where clause */
  periodStart?: InputMaybe<BillingInvoiceListWhereDateInput>
  /** The billingInvoice providerInvoiceId field where clause */
  providerInvoiceId?: InputMaybe<BillingInvoiceListWhereIdInput>
  /** The billingInvoice quantity field where clause */
  quantity?: InputMaybe<BillingInvoiceListWhereIntInput>
  /** The billingInvoice taxAmount field where clause */
  taxAmount?: InputMaybe<BillingInvoiceListWhereFloatInput>
  /** The billingInvoice taxJurisdictionCode field where clause */
  taxJurisdictionCode?: InputMaybe<BillingInvoiceListWhereStringInput>
  /** The billingInvoice totalAmount field where clause */
  totalAmount?: InputMaybe<BillingInvoiceListWhereFloatInput>
  /** The billingInvoice uuid field where clause */
  uuid?: InputMaybe<BillingInvoiceListWhereStringInput>
  /** The billingInvoice writtenOff field where clause */
  writtenOff?: InputMaybe<BillingInvoiceListWhereBooleanInput>
}

/** Billing Invoice integer where input type */
export type BillingInvoiceListWhereIntInput = {
  /** Is the value equal to the field */
  eq?: InputMaybe<Scalars['Int']['input']>
  /** Are the values in the field */
  in?: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>
}

/** Billing Invoice string where input type */
export type BillingInvoiceListWhereStringInput = {
  /** Is the value equal to the field */
  eq?: InputMaybe<Scalars['String']['input']>
  /** Are the values in the field */
  in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
}

/** Update input for Billing Invoice */
export type BillingInvoiceUpdateInput = {
  /** Balance of the billing invoice */
  balance?: InputMaybe<Scalars['Float']['input']>
  /** The billing one time purchase Id of the billing invoice */
  billingOneTimePurchaseId?: InputMaybe<Scalars['ID']['input']>
  /** The billing provider product Id of the billing invoice */
  billingProviderProductId?: InputMaybe<Scalars['ID']['input']>
  /** The billing subscription plan Id of the billing invoice */
  billingSubscriptionPlanId?: InputMaybe<Scalars['ID']['input']>
  /** Due date of the billing invoice */
  dueDate?: InputMaybe<Scalars['DateTime']['input']>
  /** The id of the billing payment */
  id: Scalars['ID']['input']
  /** Period ends of the billing invoice */
  periodEnd?: InputMaybe<Scalars['DateTime']['input']>
  /** Period starts of the billing invoice */
  periodStart?: InputMaybe<Scalars['DateTime']['input']>
  /** The provider invoice Id of the billing invoice */
  providerInvoiceId?: InputMaybe<Scalars['ID']['input']>
  /** The quantity of the billing invoice */
  quantity?: InputMaybe<Scalars['Int']['input']>
  /** Tax amount of the billing invoice */
  taxAmount?: InputMaybe<Scalars['Float']['input']>
  /** Tax Jurisdiction code of the billing invoice */
  taxJurisdictionCode?: InputMaybe<Scalars['String']['input']>
  /** Total amount of the billing invoice */
  totalAmount?: InputMaybe<Scalars['Float']['input']>
  /** Whether the invoice was written off */
  writtenOff?: InputMaybe<Scalars['Boolean']['input']>
}

/** Billing One Time Purchase */
export type BillingOneTimePurchase = {
  __typename?: 'BillingOneTimePurchase'
  /** When the Billing one time Purchase end date */
  accessEndDate?: Maybe<Scalars['DateTime']['output']>
  /** When the Billing one time Purchase was started */
  accessStartDate?: Maybe<Scalars['DateTime']['output']>
  /** The Billing Account Id of the Billing one time Purchase */
  billingAccountId?: Maybe<Scalars['ID']['output']>
  createdAt?: Maybe<Scalars['DateTime']['output']>
  /** The gift bulk purchase Id of the Billing one time Purchase */
  giftBulkPurchaseId?: Maybe<Scalars['ID']['output']>
  /** The gift Id of the Billing one time Purchase */
  giftId?: Maybe<Scalars['ID']['output']>
  /** The id of the Billing one time Purchase */
  id?: Maybe<Scalars['ID']['output']>
  /** The billing provider order ID of the Billing one time Purchase */
  providerOrderId?: Maybe<Scalars['ID']['output']>
  /** When the Billing one time Purchase was purchase */
  purchaseDate?: Maybe<Scalars['DateTime']['output']>
  /** When the row was last updated */
  updatedAt?: Maybe<Scalars['DateTime']['output']>
  /** The UUID of the Billing one time Purchase */
  uuid?: Maybe<Scalars['ID']['output']>
}

/** Create input for Billing One Time Purchase */
export type BillingOneTimePurchaseCreateInput = {
  /** The effective accessEndDate of the Billing one time Purchase */
  accessEndDate?: InputMaybe<Scalars['DateTime']['input']>
  /** The effective accessStartDate of the Billing one time Purchase */
  accessStartDate?: InputMaybe<Scalars['DateTime']['input']>
  /** The billing billingAccountId of the Billing one time Purchase */
  billingAccountId: Scalars['ID']['input']
  /** The billing giftBulkPurchaseId of the Billing one time Purchase */
  giftBulkPurchaseId?: InputMaybe<Scalars['ID']['input']>
  /** The billing giftId of the Billing one time Purchase */
  giftId?: InputMaybe<Scalars['ID']['input']>
  /** The provider providerOrderId of the Billing one time Purchase */
  providerOrderId?: InputMaybe<Scalars['String']['input']>
  /** The effective purchaseDate of the Billing one time Purchase */
  purchaseDate: Scalars['DateTime']['input']
}

/** Billing One Time Purchase list response */
export type BillingOneTimePurchaseListResponse = {
  __typename?: 'BillingOneTimePurchaseListResponse'
  billingOneTimePurchases?: Maybe<Array<Maybe<BillingOneTimePurchase>>>
}

/** Billing One Time Purchase list where Date input type */
export type BillingOneTimePurchaseListWhereDateInput = {
  /** Is the value greater than the field */
  gt?: InputMaybe<Scalars['Date']['input']>
  /** Is the value greater than or equal to the field */
  gte?: InputMaybe<Scalars['Date']['input']>
  /** Is the value less than the field */
  lt?: InputMaybe<Scalars['Date']['input']>
  /** Is the value less than or equal to the field */
  lte?: InputMaybe<Scalars['Date']['input']>
}

/** Billing One Time Purchase list id where input type */
export type BillingOneTimePurchaseListWhereIdInput = {
  /** Is the value equal to the field */
  eq?: InputMaybe<Scalars['ID']['input']>
  /** Are the values in the field */
  in?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>
}

/** Billing One Time Purchase list where input type */
export type BillingOneTimePurchaseListWhereInput = {
  /** The billingOneTimePurchase accessEndDate field where clause */
  accessEndDate?: InputMaybe<BillingOneTimePurchaseListWhereDateInput>
  /** The billingOneTimePurchase accessStartDate field where clause */
  accessStartDate?: InputMaybe<BillingOneTimePurchaseListWhereDateInput>
  /** The billingOneTimePurchase billingAccountId field where clause */
  billingAccountId?: InputMaybe<BillingOneTimePurchaseListWhereIdInput>
  /** The billingOneTimePurchase createdAt field where clause */
  createdAt?: InputMaybe<BillingOneTimePurchaseListWhereDateInput>
  /** The billingOneTimePurchase giftBulkPurchaseId field where clause */
  giftBulkPurchaseId?: InputMaybe<BillingOneTimePurchaseListWhereIdInput>
  /** The billingOneTimePurchase giftId field where clause */
  giftId?: InputMaybe<BillingOneTimePurchaseListWhereIdInput>
  /** The billingOneTimePurchase id field where clause */
  id?: InputMaybe<BillingOneTimePurchaseListWhereIdInput>
  /** The billingOneTimePurchase providerOrderId field where clause */
  providerOrderId?: InputMaybe<BillingOneTimePurchaseListWhereStringInput>
  /** The billingOneTimePurchase purchaseDate field where clause */
  purchaseDate?: InputMaybe<BillingOneTimePurchaseListWhereDateInput>
  /** The billingOneTimePurchase uuid field where clause */
  uuid?: InputMaybe<BillingOneTimePurchaseListWhereStringInput>
}

/** Billing One Time Purchase string where input type */
export type BillingOneTimePurchaseListWhereStringInput = {
  /** Is the value equal to the field */
  eq?: InputMaybe<Scalars['String']['input']>
  /** Are the values in the field */
  in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
}

/** Update input for Billing One Time Purchase */
export type BillingOneTimePurchaseUpdateInput = {
  /** The effective accessEndDate of the Billing one time Purchase */
  accessEndDate?: InputMaybe<Scalars['DateTime']['input']>
  /** The effective accessStartDate of the Billing one time Purchase */
  accessStartDate?: InputMaybe<Scalars['DateTime']['input']>
  /** The billing billingAccountId of the Billing one time Purchase */
  billingAccountId?: InputMaybe<Scalars['ID']['input']>
  /** The billing giftBulkPurchaseId of the Billing one time Purchase */
  giftBulkPurchaseId?: InputMaybe<Scalars['ID']['input']>
  /** The billing giftId of the Billing one time Purchase */
  giftId?: InputMaybe<Scalars['ID']['input']>
  /** The id of the Billing one time Purchase */
  id: Scalars['ID']['input']
  /** The provider providerOrderId of the Billing one time Purchase */
  providerOrderId?: InputMaybe<Scalars['String']['input']>
  /** The effective purchaseDate of the Billing one time Purchase */
  purchaseDate?: InputMaybe<Scalars['DateTime']['input']>
}

/** Billing Payment */
export type BillingPayment = {
  __typename?: 'BillingPayment'
  /** The payment amount */
  amount?: Maybe<Scalars['Float']['output']>
  /** Billing Invoice associated with this Billing Payment */
  billingInvoice?: Maybe<BillingInvoice>
  /** The billing invoice ID of the billing payment */
  billingInvoiceId?: Maybe<Scalars['ID']['output']>
  /** Billing Payment Method associated with this Billing Payment */
  billingPaymentMethod?: Maybe<BillingPaymentMethod>
  /** ID of billing payment method */
  billingPaymentMethodId?: Maybe<Scalars['String']['output']>
  /** When the row was created */
  createdAt?: Maybe<Scalars['DateTime']['output']>
  /** The payment currency */
  currency?: Maybe<Scalars['String']['output']>
  /** The payment gateway error */
  gatewayError?: Maybe<Scalars['String']['output']>
  /** The id of the billing payment */
  id?: Maybe<Scalars['ID']['output']>
  /** The payment date */
  paymentDate?: Maybe<Scalars['DateTime']['output']>
  /** Provider payment id */
  providerPaymentId?: Maybe<Scalars['String']['output']>
  /** Whether the payment method has been success */
  success?: Maybe<Scalars['Boolean']['output']>
  /** When the row was last updated */
  updatedAt?: Maybe<Scalars['DateTime']['output']>
  /** The UUID of the billing payment */
  uuid?: Maybe<Scalars['ID']['output']>
}

/** Create input for Billing Payment */
export type BillingPaymentCreateInput = {
  /** The payment amount */
  amount: Scalars['Float']['input']
  /** The billing invoice ID of the billing payment */
  billingInvoiceId: Scalars['ID']['input']
  /** The billing payment method ID of the billing payment */
  billingPaymentMethodId?: InputMaybe<Scalars['ID']['input']>
  /** The payment currency */
  currency: Scalars['String']['input']
  /** The gateway error of payment */
  gatewayError?: InputMaybe<Scalars['String']['input']>
  /** Date of payment date */
  paymentDate: Scalars['DateTime']['input']
  /** The provider payment ID of the billing payment */
  providerPaymentId: Scalars['String']['input']
  /** Whether the payment has been success */
  success?: InputMaybe<Scalars['Boolean']['input']>
}

/** Billing Payment list response */
export type BillingPaymentListResponse = {
  __typename?: 'BillingPaymentListResponse'
  billingPayments?: Maybe<Array<Maybe<BillingPayment>>>
}

/** Billing Payment boolean where input type */
export type BillingPaymentListWhereBooleanInput = {
  /** Is the value equal to the field */
  eq?: InputMaybe<Scalars['Boolean']['input']>
}

/** Billing Payment list where Date input type */
export type BillingPaymentListWhereDateInput = {
  /** Is the value greater than the field */
  gt?: InputMaybe<Scalars['Date']['input']>
  /** Is the value greater than or equal to the field */
  gte?: InputMaybe<Scalars['Date']['input']>
  /** Is the value less than the field */
  lt?: InputMaybe<Scalars['Date']['input']>
  /** Is the value less than or equal to the field */
  lte?: InputMaybe<Scalars['Date']['input']>
}

/** Billing Payment float where input type */
export type BillingPaymentListWhereFloatInput = {
  /** Is the value equal to the field */
  eq?: InputMaybe<Scalars['Float']['input']>
}

/** Billing Payment list id where input type */
export type BillingPaymentListWhereIdInput = {
  /** Is the value equal to the field */
  eq?: InputMaybe<Scalars['ID']['input']>
  /** Are the values in the field */
  in?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>
}

/** Billing Payment list where input type */
export type BillingPaymentListWhereInput = {
  /** The billingPayment billingInvoiceId field where clause */
  billingInvoiceId?: InputMaybe<BillingPaymentListWhereIdInput>
  /** The billingPayment billingPaymentMethodId field where clause */
  billingPaymentMethodId?: InputMaybe<BillingPaymentListWhereIdInput>
  /** The billingPayment createdAt field where clause */
  createdAt?: InputMaybe<BillingPaymentListWhereDateInput>
  /** The billingPayment currency field where clause */
  currency?: InputMaybe<BillingPaymentListWhereStringInput>
  /** The billingPayment gatewayError field where clause */
  gatewayError?: InputMaybe<BillingPaymentListWhereStringInput>
  /** The billingPayment id field where clause */
  id?: InputMaybe<BillingPaymentListWhereIdInput>
  /** The billingPayment paymentDate field where clause */
  paymentDate?: InputMaybe<BillingPaymentListWhereDateInput>
  /** The billingPayment provider payment Id field where clause */
  providerPaymentId?: InputMaybe<BillingPaymentListWhereStringInput>
  /** The billingPayment success field where clause */
  success?: InputMaybe<BillingPaymentListWhereBooleanInput>
  /** The billingPayment amount field where clause */
  type?: InputMaybe<BillingPaymentListWhereFloatInput>
  /** The billingPayment uuid field where clause */
  uuid?: InputMaybe<BillingPaymentListWhereStringInput>
}

/** Billing Payment string where input type */
export type BillingPaymentListWhereStringInput = {
  /** Is the value equal to the field */
  eq?: InputMaybe<Scalars['String']['input']>
  /** Are the values in the field */
  in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
}

/** Billing Payment Method */
export type BillingPaymentMethod = {
  __typename?: 'BillingPaymentMethod'
  /** The Adyen Recurring Detail Reference */
  adyenRecurringDetailReference?: Maybe<Scalars['String']['output']>
  /** The Adyen Shopper Reference */
  adyenShopperReference?: Maybe<Scalars['String']['output']>
  /** Billing Account associated with this Billing Payment Method */
  billingAccount?: Maybe<BillingAccount>
  /** The billing account ID of the billing payment method */
  billingAccountId?: Maybe<Scalars['ID']['output']>
  /** The credit card summary (last 4 digits) */
  cardSummary?: Maybe<Scalars['String']['output']>
  /** The credit card type (Visa, MasterCard, etc) */
  cardType?: Maybe<Scalars['String']['output']>
  /** When the row was created */
  createdAt?: Maybe<Scalars['DateTime']['output']>
  /** The payment gateway name */
  gatewayName?: Maybe<Scalars['String']['output']>
  /** The id of the billing payment method */
  id?: Maybe<Scalars['ID']['output']>
  /** The PayPal Agreement ID */
  paypalAgreementId?: Maybe<Scalars['String']['output']>
  /** Whether the payment method is the primary payment method for the account */
  primaryPaymentMethod?: Maybe<Scalars['Boolean']['output']>
  /** ID of payment method in source system (zuora only) */
  providerPaymentMethodId?: Maybe<Scalars['String']['output']>
  /** Whether the payment method has been removed */
  removed?: Maybe<Scalars['Boolean']['output']>
  /** The payment method type */
  type?: Maybe<PaymentMethodType>
  /** When the row was last updated */
  updatedAt?: Maybe<Scalars['DateTime']['output']>
  /** The UUID of the billing payment method */
  uuid?: Maybe<Scalars['ID']['output']>
}

/** Create input for Billing Payment Method */
export type BillingPaymentMethodCreateInput = {
  /** The Adyen Recurring Detail Reference */
  adyenRecurringDetailReference?: InputMaybe<Scalars['String']['input']>
  /** The Adyen Shopper Reference */
  adyenShopperReference?: InputMaybe<Scalars['String']['input']>
  /** The billing account ID of the billing payment method */
  billingAccountId: Scalars['ID']['input']
  /** The credit card summary (last 4 digits) */
  cardSummary?: InputMaybe<Scalars['String']['input']>
  /** The credit card type (Visa, MasterCard, etc) */
  cardType?: InputMaybe<Scalars['String']['input']>
  /** The payment gateway name */
  gatewayName: Scalars['String']['input']
  /** The PayPal Agreement ID */
  paypalAgreementId?: InputMaybe<Scalars['String']['input']>
  /** Whether the payment method is the primary payment method for the account */
  primaryPaymentMethod: Scalars['Boolean']['input']
  /** ID of payment method in source system (zuora only) */
  providerPaymentMethodId: Scalars['String']['input']
  /** Whether the payment method has been removed */
  removed?: InputMaybe<Scalars['Boolean']['input']>
  /** The payment method type */
  type: PaymentMethodType
}

/** Billing Payment Method list response */
export type BillingPaymentMethodListResponse = {
  __typename?: 'BillingPaymentMethodListResponse'
  /** A list of billingProviderProductPricing reference */
  billingPaymentMethods?: Maybe<Array<Maybe<BillingPaymentMethod>>>
}

/** Billing Payment Method boolean where input type */
export type BillingPaymentMethodListWhereBooleanInput = {
  /** Is the value equal to the field */
  eq?: InputMaybe<Scalars['Boolean']['input']>
}

/** Billing Payment Method list id where input type */
export type BillingPaymentMethodListWhereIdInput = {
  /** Is the value equal to the field */
  eq?: InputMaybe<Scalars['ID']['input']>
  /** Are the values in the field */
  in?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>
}

/** Billing Payment Method list where input type */
export type BillingPaymentMethodListWhereInput = {
  /** The billingPaymentMethod adyenRecurringDetailReference field where clause */
  adyenRecurringDetailReference?: InputMaybe<BillingPaymentMethodListWhereStringInput>
  /** The billingPaymentMethod adyenShopperReference field where clause */
  adyenShopperReference?: InputMaybe<BillingPaymentMethodListWhereStringInput>
  /** The billingPaymentMethod billingAccountId field where clause */
  billingAccountId?: InputMaybe<BillingPaymentMethodListWhereIdInput>
  /** The billingPaymentMethod cardSummary field where clause */
  cardSummary?: InputMaybe<BillingPaymentMethodListWhereStringInput>
  /** The billingPaymentMethod cardType field where clause */
  cardType?: InputMaybe<BillingPaymentMethodListWhereStringInput>
  /** The billingPaymentMethod gatewayName field where clause */
  gatewayName?: InputMaybe<BillingPaymentMethodListWhereStringInput>
  /** The billingPaymentMethod id field where clause */
  id?: InputMaybe<BillingPaymentMethodListWhereIdInput>
  /** The billingPaymentMethod paypalAgreementId field where clause */
  paypalAgreementId?: InputMaybe<BillingPaymentMethodListWhereStringInput>
  /** The billingPaymentMethod primaryPaymentMethod field where clause */
  primaryPaymentMethod?: InputMaybe<BillingPaymentMethodListWhereBooleanInput>
  /** The billingPaymentMethod providerPaymentMethodId field where clause */
  providerPaymentMethodId?: InputMaybe<BillingPaymentMethodListWhereStringInput>
  /** The billingPaymentMethod removed field where clause */
  removed?: InputMaybe<BillingPaymentMethodListWhereBooleanInput>
  /** The billingPaymentMethod type field where clause */
  type?: InputMaybe<BillingPaymentMethodListWhereStringInput>
  /** The billingPaymentMethod uuid field where clause */
  uuid?: InputMaybe<BillingPaymentMethodListWhereStringInput>
}

/** Billing Payment Method string where input type */
export type BillingPaymentMethodListWhereStringInput = {
  /** Is the value equal to the field */
  eq?: InputMaybe<Scalars['String']['input']>
  /** Are the values in the field */
  in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
}

/** Update input for Billing Payment Method */
export type BillingPaymentMethodUpdateInput = {
  /** The Adyen Recurring Detail Reference */
  adyenRecurringDetailReference?: InputMaybe<Scalars['String']['input']>
  /** The Adyen Shopper Reference */
  adyenShopperReference?: InputMaybe<Scalars['String']['input']>
  /** The billing account ID of the billing payment method */
  billingAccountId?: InputMaybe<Scalars['ID']['input']>
  /** The credit card summary (last 4 digits) */
  cardSummary?: InputMaybe<Scalars['String']['input']>
  /** The credit card type (Visa, MasterCard, etc) */
  cardType?: InputMaybe<Scalars['String']['input']>
  /** The payment gateway name */
  gatewayName?: InputMaybe<Scalars['String']['input']>
  /** The id of the billing payment method */
  id: Scalars['ID']['input']
  /** The PayPal Agreement ID */
  paypalAgreementId?: InputMaybe<Scalars['String']['input']>
  /** Whether the payment method is the primary payment method for the account */
  primaryPaymentMethod?: InputMaybe<Scalars['Boolean']['input']>
  /** ID of payment method in source system (zuora only) */
  providerPaymentMethodId?: InputMaybe<Scalars['String']['input']>
  /** Whether the payment method has been removed */
  removed?: InputMaybe<Scalars['Boolean']['input']>
  /** The payment method type */
  type?: InputMaybe<PaymentMethodType>
}

/** Update input for Billing Payment */
export type BillingPaymentUpdateInput = {
  /** The payment amount */
  amount?: InputMaybe<Scalars['Float']['input']>
  /** The billing invoice ID of the billing payment */
  billingInvoiceId?: InputMaybe<Scalars['ID']['input']>
  /** The billing payment method ID of the billing payment */
  billingPaymentMethodId?: InputMaybe<Scalars['ID']['input']>
  /** The payment currency */
  currency?: InputMaybe<Scalars['String']['input']>
  /** The gateway error of payment */
  gatewayError?: InputMaybe<Scalars['String']['input']>
  /** The id of the billing payment */
  id: Scalars['ID']['input']
  /** Date of payment date */
  paymentDate?: InputMaybe<Scalars['DateTime']['input']>
  /** The provider payment ID of the billing payment */
  providerPaymentId?: InputMaybe<Scalars['String']['input']>
  /** Whether the payment has been success */
  success?: InputMaybe<Scalars['Boolean']['input']>
}

/** Billing Plan Grid */
export type BillingPlanGrid = {
  __typename?: 'BillingPlanGrid'
  /** The plan grid matches if the user's current or next billing product ID is in this list */
  billingProductIdIn?: Maybe<Array<Maybe<Scalars['Int']['output']>>>
  /** The plan grid matches if the user's current or next billing product ID is not in this list */
  billingProductIdNotIn?: Maybe<Array<Maybe<Scalars['Int']['output']>>>
  /** The plan grid matches if the user's current or next billing provider product ID is in this list */
  billingProviderProductIdIn?: Maybe<Array<Maybe<Scalars['Int']['output']>>>
  /** The plan grid matches if the user's current or next billing provider product ID is not in this list */
  billingProviderProductIdNotIn?: Maybe<Array<Maybe<Scalars['Int']['output']>>>
  /** The ordered list of user specific billing provider products in the plan grid */
  billingProviderProducts: Array<BillingProviderProduct>
  /** The plan grid matches if the user's country is in this list */
  countryIn?: Maybe<Array<Maybe<Scalars['String']['output']>>>
  /** The plan grid matches if the user's country is not in this list */
  countryNotIn?: Maybe<Array<Maybe<Scalars['String']['output']>>>
  /** When the row was created */
  createdAt: Scalars['DateTime']['output']
  /** The plan grid matches if the user's currency is in this list */
  currencyIn?: Maybe<Array<Maybe<Scalars['String']['output']>>>
  /** The plan grid matches if the user's currency is not in this list */
  currencyNotIn?: Maybe<Array<Maybe<Scalars['String']['output']>>>
  /** Whether this plan grid is the default for the given page */
  defaultPageGrid: Scalars['Boolean']['output']
  /** The plan grid matches if the user's device type is in this list */
  deviceTypeIn?: Maybe<Array<Maybe<Scalars['String']['output']>>>
  /** The plan grid matches if the user's device type is not in this list */
  deviceTypeNotIn?: Maybe<Array<Maybe<Scalars['String']['output']>>>
  /** Whether the billing plan grid is enabled */
  enabled: Scalars['Boolean']['output']
  /** The end date of the billing plan grid */
  endDate?: Maybe<Scalars['DateTime']['output']>
  /** The best value plan ID in the plan grid for existing members */
  existingMemberBestValueBillingProviderProductId?: Maybe<Scalars['Int']['output']>
  /** The first plan ID in the plan grid for existing members */
  existingMemberBillingProviderProductId1: Scalars['Int']['output']
  /** The second plan ID in the plan grid for existing members */
  existingMemberBillingProviderProductId2?: Maybe<Scalars['Int']['output']>
  /** The third plan ID in the plan grid for existing members */
  existingMemberBillingProviderProductId3?: Maybe<Scalars['Int']['output']>
  /** The fourth plan ID in the plan grid for existing members */
  existingMemberBillingProviderProductId4?: Maybe<Scalars['Int']['output']>
  /** The id of the billing plan grid */
  id: Scalars['ID']['output']
  /** The plan grid matches if the user's language is in this list */
  languageIn?: Maybe<Array<Maybe<Scalars['String']['output']>>>
  /** The plan grid matches if the user's language is not in this list */
  languageNotIn?: Maybe<Array<Maybe<Scalars['String']['output']>>>
  /** The best value plan ID in the plan grid for new members */
  newMemberBestValueBillingProviderProductId?: Maybe<Scalars['Int']['output']>
  /** The first plan ID in the plan grid for new members */
  newMemberBillingProviderProductId1: Scalars['Int']['output']
  /** The second plan ID in the plan grid for new members */
  newMemberBillingProviderProductId2?: Maybe<Scalars['Int']['output']>
  /** The third plan ID in the plan grid for new members */
  newMemberBillingProviderProductId3?: Maybe<Scalars['Int']['output']>
  /** The first plan ID in the plan grid for new members */
  newMemberBillingProviderProductId4?: Maybe<Scalars['Int']['output']>
  /** The page the billing plan grid belongs to */
  page: Scalars['String']['output']
  /** The priority of the plan grid */
  priority: Scalars['Int']['output']
  /** The start date of the billing plan grid */
  startDate?: Maybe<Scalars['DateTime']['output']>
  /** When the row was last updated */
  updatedAt: Scalars['DateTime']['output']
  /** The variant name of the billing plan grid */
  variantName?: Maybe<Scalars['String']['output']>
}

/** Billing Plan Grid list response */
export type BillingPlanGridListResponse = {
  __typename?: 'BillingPlanGridListResponse'
  billingPlanGrids?: Maybe<Array<Maybe<BillingPlanGrid>>>
}

/** Billing Plan Grid list boolean where input type */
export type BillingPlanGridListWhereBooleanInput = {
  /** Is the value equal to the field */
  eq?: InputMaybe<Scalars['Boolean']['input']>
}

/** Billing Plan Grid list where Date input type */
export type BillingPlanGridListWhereDateInput = {
  /** Is the value greater than the field */
  gt?: InputMaybe<Scalars['Date']['input']>
  /** Is the value greater than or equal to the field */
  gte?: InputMaybe<Scalars['Date']['input']>
  /** Is the value less than the field */
  lt?: InputMaybe<Scalars['Date']['input']>
  /** Is the value less than or equal to the field */
  lte?: InputMaybe<Scalars['Date']['input']>
}

/** Billing Plan Grid list device type where input type */
export type BillingPlanGridListWhereDeviceTypeInput = {
  /** Is the value equal to the field */
  eq?: InputMaybe<PlanGridDeviceType>
  /** Are the values in the field */
  in?: InputMaybe<Array<InputMaybe<PlanGridDeviceType>>>
}

/** Billing Plan Grid list id where input type */
export type BillingPlanGridListWhereIdInput = {
  /** Is the value equal to the field */
  eq?: InputMaybe<Scalars['ID']['input']>
  /** Are the values in the field */
  in?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>
}

/** Billing Plan Grid list ID list where input type */
export type BillingPlanGridListWhereIdListInput = {
  /** Are the values in the field */
  in?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>
}

/** Billing Plan Grid list where input type */
export type BillingPlanGridListWhereInput = {
  /** The filter for the billing plan grid billing product id in */
  billingProductIdIn?: InputMaybe<BillingPlanGridListWhereIdListInput>
  /** The filter for the billing plan grid billing product id not in */
  billingProductIdNotIn?: InputMaybe<BillingPlanGridListWhereIdListInput>
  /** The filter for the billing plan grid billing provider product id in */
  billingProviderProductIdIn?: InputMaybe<BillingPlanGridListWhereIdListInput>
  /** The filter for the billing plan grid billing provider product id not in */
  billingProviderProductIdNotIn?: InputMaybe<BillingPlanGridListWhereIdListInput>
  /** The filter for the billing plan grid country in */
  countryIn?: InputMaybe<BillingPlanGridListWhereStringListInput>
  /** The filter for the billing plan grid country not in */
  countryNotIn?: InputMaybe<BillingPlanGridListWhereStringListInput>
  /** The filter for the billing plan grid currency in */
  currencyIn?: InputMaybe<BillingPlanGridListWhereStringListInput>
  /** The filter for the billing plan grid currency not in */
  currencyNotIn?: InputMaybe<BillingPlanGridListWhereStringListInput>
  /** The filter for the billing plan grid default page grid */
  defaultPageGrid?: InputMaybe<BillingPlanGridListWhereBooleanInput>
  /** The filter for the billing plan grid enabled */
  enabled?: InputMaybe<BillingPlanGridListWhereBooleanInput>
  /** The filter for the billing plan grid end date */
  endDate?: InputMaybe<BillingPlanGridListWhereDateInput>
  /** The filter for the billing plan grid id */
  id?: InputMaybe<BillingPlanGridListWhereIdInput>
  /** The filter for the billing plan grid language in */
  languageIn?: InputMaybe<BillingPlanGridListWhereStringListInput>
  /** The filter for the billing plan grid language not in */
  languageNotIn?: InputMaybe<BillingPlanGridListWhereStringListInput>
  /** The filter for the billing plan grid page */
  page?: InputMaybe<BillingPlanGridListWhereStringInOrEqListInput>
  /** The filter for the billing plan grid priority */
  priority?: InputMaybe<BillingPlanGridListWhereIntInput>
  /** The filter for the billing plan grid start date */
  startDate?: InputMaybe<BillingPlanGridListWhereDateInput>
  /** The filter for the billing plan grid variant name */
  variantName?: InputMaybe<BillingPlanGridListWhereStringInOrEqListInput>
}

/** Billing Plan Grid list int where input type */
export type BillingPlanGridListWhereIntInput = {
  /** Is the value equal to the field */
  eq?: InputMaybe<Scalars['Int']['input']>
  /** Are the values in the field */
  in?: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>
}

/** Billing Plan Grid list string list where eq input type */
export type BillingPlanGridListWhereStringEqListInput = {
  /** Is the value equal to the field */
  eq?: InputMaybe<Scalars['String']['input']>
}

/** Billing Plan Grid list string list where in or eq input type */
export type BillingPlanGridListWhereStringInOrEqListInput = {
  /** Is the value equal to the field */
  eq?: InputMaybe<Scalars['String']['input']>
  /** Are the values in the field */
  in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
}

/** Billing Plan Grid list string list where in input type */
export type BillingPlanGridListWhereStringListInput = {
  /** Are the values in the field */
  in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
}

/** Billing Product */
export type BillingProduct = {
  __typename?: 'BillingProduct'
  /** Billing Provider Products associated with this Billing Product */
  billingProviderProducts?: Maybe<Array<Maybe<BillingProviderProduct>>>
  /** The content set id of the billing product */
  contentSetId?: Maybe<Scalars['Int']['output']>
  /** When the row was created */
  createdAt?: Maybe<Scalars['DateTime']['output']>
  /** The id of the billing product */
  id?: Maybe<Scalars['ID']['output']>
  /** The name of the billing product */
  name?: Maybe<Scalars['String']['output']>
  /** The platform of the billing product */
  platform?: Maybe<ProductPlatform>
  /** When the row was last updated */
  updatedAt?: Maybe<Scalars['DateTime']['output']>
  /** The UUID of the billing product */
  uuid?: Maybe<Scalars['ID']['output']>
}

/** Billing Product Change Log */
export type BillingProductChangeLog = {
  __typename?: 'BillingProductChangeLog'
  /** The type of change */
  changeType: ProductChangeLogType
  /** When the row was created */
  createdAt: Scalars['DateTime']['output']
  /** The ecommerce sku of the changed entity */
  ecommerceSku?: Maybe<Scalars['String']['output']>
  /** The entity that was changed */
  entityName: Scalars['String']['output']
  /** The id of the billing product */
  id: Scalars['ID']['output']
  /** The new values of the row */
  newValues?: Maybe<Scalars['JSON']['output']>
  /** The plan grid page of the changed entity */
  planGridPage?: Maybe<Scalars['String']['output']>
  /** The plan grid variant of the changed entity */
  planGridVariant?: Maybe<Scalars['String']['output']>
  /** The previous values of the row */
  previousValues?: Maybe<Scalars['JSON']['output']>
  /** The pricing currency of the changed entity */
  pricingCurrency?: Maybe<Scalars['String']['output']>
  /** The product of the changed entity */
  productName?: Maybe<Scalars['String']['output']>
  /** The provider of the changed entity */
  providerName?: Maybe<Scalars['String']['output']>
  /** The sku of the changed entity */
  sku?: Maybe<Scalars['String']['output']>
  /** The text key of the changed entity */
  textKey?: Maybe<Scalars['String']['output']>
  /** The text language of the changed entity */
  textLanguage?: Maybe<Scalars['String']['output']>
  /** When the row was last updated */
  updatedAt: Scalars['DateTime']['output']
  /** UUID of the user who made the change */
  userInfoUuid: Scalars['ID']['output']
  /** The username of the user who made the change */
  username: Scalars['String']['output']
}

/** Billing Product Change Log input type */
export type BillingProductChangeLogInput = {
  /** The type of change */
  changeType: ProductChangeLogType
  /** The ecommerce sku of the changed entity */
  ecommerceSku?: InputMaybe<Scalars['String']['input']>
  /** The entity that was changed */
  entityName: ProductChangeLogEntityName
  /** The new values of the row */
  newValues?: InputMaybe<Scalars['JSON']['input']>
  /** The plan grid page of the changed entity */
  planGridPage?: InputMaybe<Scalars['String']['input']>
  /** The plan grid variant of the changed entity */
  planGridVariant?: InputMaybe<Scalars['String']['input']>
  /** The previous values of the row */
  previousValues?: InputMaybe<Scalars['JSON']['input']>
  /** The pricing currency of the changed entity */
  pricingCurrency?: InputMaybe<Scalars['String']['input']>
  /** The product of the changed entity */
  productName?: InputMaybe<Scalars['String']['input']>
  /** The provider of the changed entity */
  providerName?: InputMaybe<Scalars['String']['input']>
  /** The sku of the changed entity */
  sku?: InputMaybe<Scalars['String']['input']>
  /** The text key of the changed entity */
  textKey?: InputMaybe<Scalars['String']['input']>
  /** The text language of the changed entity */
  textLanguage?: InputMaybe<Scalars['String']['input']>
}

export type BillingProductChangeLogListResponse = {
  __typename?: 'BillingProductChangeLogListResponse'
  /** A list of billingProductChangeLog reference */
  billingProductChangeLogs?: Maybe<Array<Maybe<BillingProductChangeLog>>>
}

/** Billing Product Change Log list where Date input type */
export type BillingProductChangeLogListWhereDateInput = {
  /** Is the value greater than the field */
  gt?: InputMaybe<Scalars['Date']['input']>
  /** Is the value greater than or equal to the field */
  gte?: InputMaybe<Scalars['Date']['input']>
  /** Is the value less than the field */
  lt?: InputMaybe<Scalars['Date']['input']>
  /** Is the value less than or equal to the field */
  lte?: InputMaybe<Scalars['Date']['input']>
}

/** Billing Product Change Log list id where input type */
export type BillingProductChangeLogListWhereIdInput = {
  /** Is the value equal to the field */
  eq?: InputMaybe<Scalars['ID']['input']>
  /** Are the values in the field */
  in?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>
}

export type BillingProductChangeLogListWhereInput = {
  /** The billingProduct type field where clause */
  changeType?: InputMaybe<BillingProductChangeLogWhereChangeTypeInput>
  /** The billingProduct createdAt field where clause */
  createdAt?: InputMaybe<BillingProductChangeLogListWhereDateInput>
  /** The billingProduct ecommerceSku field where clause */
  ecommerceSku?: InputMaybe<BillingProductChangeLogWhereStringInput>
  /** The billingProduct entityName field where clause */
  entityName?: InputMaybe<BillingProductChangeLogWhereEntityNameInput>
  /** The billingProduct id field where clause */
  id?: InputMaybe<BillingProductChangeLogListWhereIdInput>
  /** The billingProduct planGridPage field where clause */
  planGridPage?: InputMaybe<BillingProductChangeLogWhereStringInput>
  /** The billingProduct planGridVariant field where clause */
  planGridVariant?: InputMaybe<BillingProductChangeLogWhereStringInput>
  /** The billingProduct pricingCurrency field where clause */
  pricingCurrency?: InputMaybe<BillingProductChangeLogWhereStringInput>
  /** The billingProduct productName field where clause */
  productName?: InputMaybe<BillingProductChangeLogWhereStringInput>
  /** The billingProduct providerName field where clause */
  providerName?: InputMaybe<BillingProductChangeLogWhereStringInput>
  /** The billingProduct sku field where clause */
  sku?: InputMaybe<BillingProductChangeLogWhereStringInput>
  /** The billingProduct textKey field where clause */
  textKey?: InputMaybe<BillingProductChangeLogWhereStringInput>
  /** The billingProduct textLanguage field where clause */
  textLanguage?: InputMaybe<BillingProductChangeLogWhereLanguageInput>
  /** The billingProduct updatedAt field where clause */
  updatedAt?: InputMaybe<BillingProductChangeLogListWhereDateInput>
  /** The billingProduct uuid field where clause */
  userInfoUuid?: InputMaybe<BillingProductChangeLogListWhereIdInput>
}

/** Billing Product Change Log User */
export type BillingProductChangeLogUser = {
  __typename?: 'BillingProductChangeLogUser'
  /** The username of the user */
  username: Scalars['String']['output']
  /** The UUID of the user */
  uuid: Scalars['ID']['output']
}

export type BillingProductChangeLogUserListResponse = {
  __typename?: 'BillingProductChangeLogUserListResponse'
  /** A list of unique users who made changes */
  users?: Maybe<Array<Maybe<BillingProductChangeLogUser>>>
}

/** BillingProduct Change Log change type where input type */
export type BillingProductChangeLogWhereChangeTypeInput = {
  /** Is the value equal to the field */
  eq?: InputMaybe<ProductChangeLogType>
  /** Are the values in the field */
  in?: InputMaybe<Array<InputMaybe<ProductChangeLogType>>>
}

/** Billing Product Change Log entity name where input type */
export type BillingProductChangeLogWhereEntityNameInput = {
  /** Is the value equal to the field */
  eq?: InputMaybe<ProductChangeLogEntityName>
  /** Are the values in the field */
  in?: InputMaybe<Array<InputMaybe<ProductChangeLogEntityName>>>
}

/** BillingProduct Change Log language where input type */
export type BillingProductChangeLogWhereLanguageInput = {
  /** Is the value equal to the field */
  eq?: InputMaybe<ProviderProductLanguage>
  /** Are the values in the field */
  in?: InputMaybe<Array<InputMaybe<ProviderProductLanguage>>>
}

/** Billing Product Change Log string where input type */
export type BillingProductChangeLogWhereStringInput = {
  /** Is the value equal to the field */
  eq?: InputMaybe<Scalars['String']['input']>
  /** Are the values in the field */
  in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
}

/** Billing Product list response */
export type BillingProductListResponse = {
  __typename?: 'BillingProductListResponse'
  /** A list of billingProducts */
  billingProducts?: Maybe<Array<Maybe<BillingProduct>>>
}

/** Billing Product list id where input type */
export type BillingProductListWhereIdInput = {
  /** Is the value equal to the field */
  eq?: InputMaybe<Scalars['ID']['input']>
  /** Are the values in the field */
  in?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>
}

/** Billing Product list where input type */
export type BillingProductListWhereInput = {
  /** The billingProduct contentSetId field where clause */
  contentSetId?: InputMaybe<BillingProductWhereIntInput>
  /** The billingProduct id field where clause */
  id?: InputMaybe<BillingProductListWhereIdInput>
  /** The billingProduct name field where clause */
  name?: InputMaybe<BillingProductWhereStringInput>
  /** The billingProduct platform field where clause */
  platform?: InputMaybe<BillingProductWherePlatformInput>
  /** The billingProduct uuid field where clause */
  uuid?: InputMaybe<BillingProductListWhereIdInput>
}

/** Billing Product boolean where input type */
export type BillingProductWhereBooleanInput = {
  /** Is the value equal to the field */
  eq?: InputMaybe<Scalars['Boolean']['input']>
}

/** Billing Product int where input type */
export type BillingProductWhereIntInput = {
  /** Is the value equal to the field */
  eq?: InputMaybe<Scalars['Int']['input']>
  /** Are the values in the field */
  in?: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>
}

/** Billing Product platform where input type */
export type BillingProductWherePlatformInput = {
  /** Is the value equal to the field */
  eq?: InputMaybe<ProductPlatform>
  /** Are the values in the field */
  in?: InputMaybe<Array<InputMaybe<ProductPlatform>>>
}

/** Billing Product string where input type */
export type BillingProductWhereStringInput = {
  /** Is the value equal to the field */
  eq?: InputMaybe<Scalars['String']['input']>
  /** Are the values in the field */
  in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
}

/** Billing Provider */
export type BillingProvider = {
  __typename?: 'BillingProvider'
  /** Billing Provider Products associated with this Billing Provider */
  billingProviderProducts?: Maybe<Array<Maybe<BillingProviderProduct>>>
  /** When the row was created */
  createdAt?: Maybe<Scalars['DateTime']['output']>
  /** The id of the billing provider */
  id?: Maybe<Scalars['ID']['output']>
  /** The name of the billing provider */
  name?: Maybe<BillingProviderName>
  /** Whether the billing provider has subscription management */
  subscriptionManagement?: Maybe<Scalars['Boolean']['output']>
  /** When the row was last updated */
  updatedAt?: Maybe<Scalars['DateTime']['output']>
  /** The UUID of the billing provider */
  uuid?: Maybe<Scalars['ID']['output']>
}

/** Billing Provider Currency */
export type BillingProviderCurrency = {
  __typename?: 'BillingProviderCurrency'
  /** Billing Provider associated with this Billing Provider Currency */
  billingProvider?: Maybe<BillingProvider>
  /** Billing Provider ID */
  billingProviderId?: Maybe<Scalars['ID']['output']>
  /** Provider Currency countryCodeISO2 */
  countryCodeISO2?: Maybe<Scalars['String']['output']>
  /** Provider Currency countryCodeISO3 */
  countryCodeISO3?: Maybe<Scalars['String']['output']>
  /** When the row was created */
  createdAt?: Maybe<Scalars['DateTime']['output']>
  /** The billing provider currency */
  currency?: Maybe<Scalars['String']['output']>
  /** The primary identifier for this record */
  id?: Maybe<Scalars['ID']['output']>
  /** When the row was last updated */
  updatedAt?: Maybe<Scalars['DateTime']['output']>
  /** Billing Provider Currency UUID */
  uuid?: Maybe<Scalars['ID']['output']>
}

/** Billing Provider Currency Input */
export type BillingProviderCurrencyInput = {
  /** Billing Provider ID */
  billingProviderId: Scalars['ID']['input']
  /** Provider Currency countryCodeISO2 */
  countryCodeISO2: Scalars['String']['input']
  /** Provider Currency countryCodeISO3 */
  countryCodeISO3: Scalars['String']['input']
  /** The billing provider currency */
  currency: Scalars['String']['input']
}

/** Billing Provider Currency list billingProvider input type */
export type BillingProviderCurrencyListBillingProviderInput = {
  /** The billingProvider name field where clause */
  name?: InputMaybe<BillingProviderCurrencyWhereStringInput>
}

/** Billing Provider Currency list response */
export type BillingProviderCurrencyListResponse = {
  __typename?: 'BillingProviderCurrencyListResponse'
  /** A list of billingProviderCurrency */
  billingProviderCurrency?: Maybe<Array<Maybe<BillingProviderCurrency>>>
}

/** Billing Provider Currency list ID where input type */
export type BillingProviderCurrencyListWhereIdInput = {
  /** Is the value equal to the field */
  eq?: InputMaybe<Scalars['ID']['input']>
  /** Are the values in the field */
  in?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>
}

/** Billing Provider Currency list where input type */
export type BillingProviderCurrencyListWhereInput = {
  /** The billingProviderCurrency billingProviderId field where clause */
  billingProviderId?: InputMaybe<BillingProviderCurrencyListWhereIdInput>
  /** The billingProviderCurrency countryCodeISO2 field where clause */
  countryCodeISO2?: InputMaybe<BillingProviderCurrencyWhereStringInput>
  /** The billingProviderCurrency countryCodeISO3 field where clause */
  countryCodeISO3?: InputMaybe<BillingProviderCurrencyWhereStringInput>
  /** The billingProviderCurrency currency field where clause */
  currency?: InputMaybe<BillingProviderCurrencyWhereStringInput>
  /** The billingProviderCurrency id field where clause */
  id?: InputMaybe<BillingProviderCurrencyListWhereIdInput>
}

/** Billing Provider Currency Update Input */
export type BillingProviderCurrencyUpdateInput = {
  /** Billing Provider ID */
  billingProviderId?: InputMaybe<Scalars['ID']['input']>
  /** Provider Currency countryCodeISO2 */
  countryCodeISO2?: InputMaybe<Scalars['String']['input']>
  /** Provider Currency countryCodeISO3 */
  countryCodeISO3?: InputMaybe<Scalars['String']['input']>
  /** The billing provider currency */
  currency?: InputMaybe<Scalars['String']['input']>
  /** The billingProviderCurrency id */
  id: Scalars['ID']['input']
}

/** Billing Product int where input type */
export type BillingProviderCurrencyWhereIntInput = {
  /** Is the value equal to the field */
  eq?: InputMaybe<Scalars['Int']['input']>
  /** Are the values in the field */
  in?: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>
}

/** Billing Provider Currency string where input type */
export type BillingProviderCurrencyWhereStringInput = {
  /** Is the value equal to the field */
  eq?: InputMaybe<Scalars['String']['input']>
  /** Are the values in the field */
  in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
}

/** Billing Provider list response */
export type BillingProviderListResponse = {
  __typename?: 'BillingProviderListResponse'
  /** A list of billingProviders */
  billingProviders?: Maybe<Array<Maybe<BillingProvider>>>
}

/** Billing Product list id where input type */
export type BillingProviderListWhereIdInput = {
  /** Is the value equal to the field */
  eq?: InputMaybe<Scalars['ID']['input']>
  /** Are the values in the field */
  in?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>
}

/** Billing Product list where input type */
export type BillingProviderListWhereInput = {
  /** The billingProvider id field where clause */
  id?: InputMaybe<BillingProviderListWhereIdInput>
  /** The billingProvider name field where clause */
  name?: InputMaybe<BillingProviderWhereStringInput>
  /** The billingProvider subscriptionManagement field where clause */
  subscriptionManagement?: InputMaybe<BillingProviderWhereBooleanInput>
  /** The billingProvider uuid field where clause */
  uuid?: InputMaybe<BillingProviderListWhereIdInput>
}

/** Billing Provider Name */
export enum BillingProviderName {
  /** Amazon */
  Amazon = 'amazon',
  /** Google Play */
  Google = 'google',
  /** iTunes */
  Itunes = 'itunes',
  /** My Yoga Online PayPal */
  MyoPaypal = 'myo_paypal',
  /** PayPal */
  Paypal = 'paypal',
  /** Roku */
  Roku = 'roku',
  /** Zuora */
  Zuora = 'zuora',
}

/** Billing Provider Product */
export type BillingProviderProduct = {
  __typename?: 'BillingProviderProduct'
  /** Whether the plan can be changed */
  allowChangePlan?: Maybe<Scalars['Boolean']['output']>
  /** Billing Plan Grids associated with this Billing Provider Product */
  billingPlanGrids?: Maybe<Array<Maybe<BillingPlanGrid>>>
  /** Billing Product associated with this Billing Provider Product */
  billingProduct?: Maybe<BillingProduct>
  /** Billing Product ID */
  billingProductId?: Maybe<Scalars['ID']['output']>
  /** Billing Provider associated with this Billing Provider Product */
  billingProvider?: Maybe<BillingProvider>
  /** Billing Provider ID */
  billingProviderId?: Maybe<Scalars['ID']['output']>
  /** Billing Provider Product Pricing array associated with this Billing Provider Product */
  billingProviderProductPrices?: Maybe<Array<Maybe<BillingProviderProductPricing>>>
  /** Billing Provider Product Text array associated with this Billing Provider Product */
  billingProviderProductText?: Maybe<Array<Maybe<BillingProviderProductText>>>
  /** Whether checkout is enabled for this provider product */
  checkoutEnabled?: Maybe<Scalars['Boolean']['output']>
  /** Date when checkout is disabled for this product */
  checkoutEnabledEnd?: Maybe<Scalars['DateTime']['output']>
  /** Date when checkout is enabled for this product */
  checkoutEnabledStart?: Maybe<Scalars['DateTime']['output']>
  /** Countries restricted to this list */
  countryRestrictedIn?: Maybe<Array<Maybe<Scalars['String']['output']>>>
  /** Countries restricted to not in this list */
  countryRestrictedNotIn?: Maybe<Array<Maybe<Scalars['String']['output']>>>
  /** When the row was created */
  createdAt?: Maybe<Scalars['DateTime']['output']>
  /** Whether the logged in user's current plan matches this product (plan level) */
  currentSubscriptionPlanMatchesProduct?: Maybe<Scalars['Boolean']['output']>
  /** Whether the logged in user's current plan matches this provider product (specific plan) */
  currentSubscriptionPlanMatchesProviderProduct?: Maybe<Scalars['Boolean']['output']>
  /** Default Oracle personality from Oracle API for this billing provider product */
  defaultOraclePersonality?: Maybe<OraclePersonality>
  /** Default Oracle personality ID from Oracle API for this billing provider product */
  defaultOraclePersonalityId?: Maybe<Scalars['Int']['output']>
  /** Provider Product description */
  description?: Maybe<Scalars['String']['output']>
  ecommerceSkuMappingBonusEligibilities?: Maybe<Array<Maybe<EcommerceSkuMappingBonusEligibility>>>
  /** Enabled */
  enabled?: Maybe<Scalars['Boolean']['output']>
  /** The primary identifier for this record */
  id?: Maybe<Scalars['ID']['output']>
  /** Whether the logged in user's next plan matches this product (plan level) */
  nextSubscriptionPlanMatchesProduct?: Maybe<Scalars['Boolean']['output']>
  /** Whether the logged in user's next plan matches this provider product (specific plan) */
  nextSubscriptionPlanMatchesProviderProduct?: Maybe<Scalars['Boolean']['output']>
  /** Primary stakeholder of the billing provider product */
  primaryStakeholder?: Maybe<ProviderProductPrimaryStakeholder>
  /** ID of main product in source system (zuora only) */
  providerFirstSegmentId?: Maybe<Scalars['String']['output']>
  /** ID of recurring product in source system (zuora only).  Only populated for trial plans. */
  providerSecondSegmentId?: Maybe<Scalars['String']['output']>
  /** Savings Comparison Billing Provider Product ID */
  savingsComparisonId?: Maybe<Scalars['ID']['output']>
  /** Provider Product sku */
  sku?: Maybe<Scalars['String']['output']>
  /** Whether this plan is taxed */
  taxable?: Maybe<Scalars['Boolean']['output']>
  /** Provider Product term length - null denotes lifetime access (courses) */
  termLength?: Maybe<Scalars['Int']['output']>
  /** Term type range */
  termType?: Maybe<ProviderProductTermType>
  /** Provider Product trial length - null denotes no trial */
  trialLength?: Maybe<Scalars['Int']['output']>
  /** Provider Product trial term range */
  trialTermType?: Maybe<ProviderProductTermType>
  /** Provider Product type */
  type?: Maybe<ProviderProductType>
  /** When the row was last updated */
  updatedAt?: Maybe<Scalars['DateTime']['output']>
  /** Billing Provider Product UUID */
  uuid?: Maybe<Scalars['ID']['output']>
}

/** Billing Provider Product */
export type BillingProviderProductBillingPlanGridsArgs = {
  enabled?: InputMaybe<Scalars['Boolean']['input']>
  page?: InputMaybe<Scalars['String']['input']>
}

/** Billing Provider Product */
export type BillingProviderProductBillingProviderProductPricesArgs = {
  currency?: InputMaybe<Scalars['String']['input']>
  subscriptionPricingReplacementType?: InputMaybe<SubscriptionPricingReplacementType>
}

/** Billing Provider Product */
export type BillingProviderProductBillingProviderProductTextArgs = {
  currency?: InputMaybe<Scalars['String']['input']>
  effectiveDate?: InputMaybe<Scalars['DateTime']['input']>
  language?: InputMaybe<ProviderProductLanguage>
  skipReplacement?: InputMaybe<Scalars['Boolean']['input']>
  subscriptionPricingReplacementType?: InputMaybe<SubscriptionPricingReplacementType>
}

/** Billing Provider Product */
export type BillingProviderProductEcommerceSkuMappingBonusEligibilitiesArgs = {
  effectiveDate?: InputMaybe<Scalars['DateTime']['input']>
  languages?: InputMaybe<Array<InputMaybe<ProviderProductLanguage>>>
}

/** Billing Provider Product Delete By Id Input */
export type BillingProviderProductDeleteByIdInput = {
  /** The id to delete */
  id: Scalars['ID']['input']
}

/** Billing Provider Product Input */
export type BillingProviderProductInput = {
  /** Whether the plan can be changed */
  allowChangePlan?: InputMaybe<Scalars['Boolean']['input']>
  /** Billing Product ID */
  billingProductId: Scalars['ID']['input']
  /** Billing Provider ID */
  billingProviderId: Scalars['ID']['input']
  /** Date when checkout is disabled for this product */
  checkoutEnabledEnd?: InputMaybe<Scalars['DateTime']['input']>
  /** Date when checkout is enabled for this product */
  checkoutEnabledStart?: InputMaybe<Scalars['DateTime']['input']>
  /** Countries restricted to this list */
  countryRestrictedIn?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  /** Countries restricted to not in this list */
  countryRestrictedNotIn?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  /** Default AI persona ID from Oracle API for this billing provider product */
  defaultOraclePersonalityId?: InputMaybe<Scalars['Int']['input']>
  /** Provider Product description */
  description: Scalars['String']['input']
  /** Enabled */
  enabled: Scalars['Boolean']['input']
  /** Primary stakeholder of the billing provider product */
  primaryStakeholder?: InputMaybe<ProviderProductPrimaryStakeholder>
  /** ID of main product in source system (zuora only) */
  providerFirstSegmentId?: InputMaybe<Scalars['String']['input']>
  /** ID of recurring product in source system (zuora only).  Only populated for trial plans. */
  providerSecondSegmentId?: InputMaybe<Scalars['String']['input']>
  /** Savings Comparison Billing Provider Product ID */
  savingsComparisonId?: InputMaybe<Scalars['ID']['input']>
  /** Provider Product sku */
  sku: Scalars['String']['input']
  /** Whether this plan is taxed */
  taxable: Scalars['Boolean']['input']
  /** Provider Product term length - null denotes lifetime access (courses) */
  termLength: Scalars['Int']['input']
  /** Term type range */
  termType: ProviderProductTermType
  /** Provider Product trial length - null denotes no trial */
  trialLength?: InputMaybe<Scalars['Int']['input']>
  /** Provider Product trial term range */
  trialTermType?: InputMaybe<ProviderProductTermType>
  /** Provider Product type */
  type: ProviderProductType
}

/** Billing Product input type */
export type BillingProviderProductListBillingProductInput = {
  /** The billingProduct contentSetId field where clause */
  contentSetId?: InputMaybe<BillingProductWhereIntInput>
  /** The billingProduct name field where clause */
  name?: InputMaybe<BillingProviderProductWhereStringInput>
  /** The billingProduct platform field where clause */
  platform?: InputMaybe<BillingProductWherePlatformInput>
}

/** Billing Provider Product list billingProvider input type */
export type BillingProviderProductListBillingProviderInput = {
  /** The billingProvider name field where clause */
  name?: InputMaybe<BillingProviderWhereNameInput>
}

/** Billing Provider Product list response */
export type BillingProviderProductListResponse = {
  __typename?: 'BillingProviderProductListResponse'
  /** A list of billingProviderProducts */
  billingProviderProducts?: Maybe<Array<Maybe<BillingProviderProduct>>>
}

/** Billing Provider Product list ID where input type */
export type BillingProviderProductListWhereIdInput = {
  /** Is the value equal to the field */
  eq?: InputMaybe<Scalars['ID']['input']>
  /** Are the values in the field */
  in?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>
}

/** Billing Provider Product list where input type */
export type BillingProviderProductListWhereInput = {
  /** The billingProviderProduct billingProductId field where clause */
  billingProductId?: InputMaybe<BillingProviderProductListWhereIdInput>
  /** The billingProviderProduct billingProviderId field where clause */
  billingProviderId?: InputMaybe<BillingProviderProductListWhereIdInput>
  /** The billingProviderProduct checkoutEnabled field where clause */
  checkoutEnabled?: InputMaybe<BillingProductWhereBooleanInput>
  /** The billingProviderProduct enabled field where clause */
  enabled?: InputMaybe<BillingProductWhereBooleanInput>
  /** The billingProviderProduct id field where clause */
  id?: InputMaybe<BillingProviderProductListWhereIdInput>
  /** The billingProviderProduct primaryStakeholder field where clause */
  primaryStakeholder?: InputMaybe<BillingProviderProductListWhereStakeholderInput>
  /** The billingProviderProduct providerFirstSegmentId (zuora rate plan ID) field where clause */
  providerFirstSegmentId?: InputMaybe<BillingProviderProductWhereStringInput>
  /** The billingProviderProduct providerSecondSegmentId field where clause */
  providerSecondSegmentId?: InputMaybe<BillingProviderProductWhereStringInput>
  /** The billingProviderProduct sku field where clause */
  sku?: InputMaybe<BillingProviderProductWhereStringInput>
  /** The billingProviderProduct taxable field where clause */
  taxable?: InputMaybe<BillingProductWhereBooleanInput>
  /** The billingProviderProduct termLength field where clause */
  termLength?: InputMaybe<BillingProductWhereIntInput>
  /** The billingProviderProduct term type field where clause */
  termType?: InputMaybe<BillingProviderProductWhereTermTypeInput>
  /** The billingProviderProduct trialLength field where clause */
  trialLength?: InputMaybe<BillingProductWhereIntInput>
  /** The billingProviderProduct trial term type field where clause */
  trialTermType?: InputMaybe<BillingProviderProductWhereTermTypeInput>
  /** The billingProviderProduct type field where clause */
  type?: InputMaybe<BillingProviderProductWhereTypeInput>
}

/** Billing Provider Product list primary stakeholder where input type */
export type BillingProviderProductListWhereStakeholderInput = {
  /** Is the value equal to the field */
  eq?: InputMaybe<ProviderProductPrimaryStakeholder>
  /** Are the values in the field */
  in?: InputMaybe<Array<InputMaybe<ProviderProductPrimaryStakeholder>>>
}

/** Billing Provider Product Pricing Input */
export type BillingProviderProductPriceInput = {
  /** The billingProviderProductPrice currency */
  currency: Scalars['String']['input']
  /** The billingProviderProductPrice price */
  price: Scalars['Float']['input']
  /** The billingProviderProductPrice trialSegmentPrice */
  trialSegmentPrice?: InputMaybe<Scalars['Float']['input']>
}

/** Billing Provider Product Pricing type */
export type BillingProviderProductPricing = {
  __typename?: 'BillingProviderProductPricing'
  /** Billing Provider Product associated with this Billing Provider Product Pricing */
  billingProviderProduct?: Maybe<BillingProviderProduct>
  /** The billing provider product id of the billing provider product pricing */
  billingProviderProductId?: Maybe<Scalars['ID']['output']>
  /** When the row was created */
  createdAt?: Maybe<Scalars['DateTime']['output']>
  /** The billing provider product pricing currency */
  currency?: Maybe<Scalars['String']['output']>
  /** The billing provider product pricing currency symbol */
  currencySymbol?: Maybe<Scalars['String']['output']>
  /** The id of the billing provider product pricing */
  id?: Maybe<Scalars['ID']['output']>
  /** Percent Savings - If savings comparison ID is defined on the billingProviderProduct */
  percentSavings?: Maybe<Scalars['Int']['output']>
  /** The billing provider product pricing price */
  price?: Maybe<Scalars['Float']['output']>
  /** The billing provider product pricing formatted price */
  priceFormatted?: Maybe<Scalars['String']['output']>
  /** The billing provider product pricing price per month equivalent */
  pricePerMonth?: Maybe<Scalars['Float']['output']>
  /** The billing provider product pricing formatted price per month equivalent */
  pricePerMonthFormatted?: Maybe<Scalars['String']['output']>
  /** Trial Segment Percent Savings - If savings comparison ID is defined on the billingProviderProduct */
  trialPercentSavings?: Maybe<Scalars['Int']['output']>
  /** The billing provider product trial segment price */
  trialSegmentPrice?: Maybe<Scalars['Float']['output']>
  /** The billing provider product formatted trial segment price */
  trialSegmentPriceFormatted?: Maybe<Scalars['String']['output']>
  /** The billing provider product trial segment price per month equivalent */
  trialSegmentPricePerMonth?: Maybe<Scalars['Float']['output']>
  /** The billing provider product formatted trial segment price per month equivalent */
  trialSegmentPricePerMonthFormatted?: Maybe<Scalars['String']['output']>
  /** When the row was last updated */
  updatedAt?: Maybe<Scalars['DateTime']['output']>
  /** The UUID of the billing provider product pricing */
  uuid?: Maybe<Scalars['ID']['output']>
}

/** Billing Provider Product Pricing type */
export type BillingProviderProductPricingPriceFormattedArgs = {
  includeCurrencyISO?: InputMaybe<Scalars['Boolean']['input']>
  language?: InputMaybe<ProviderProductLanguage>
}

/** Billing Provider Product Pricing type */
export type BillingProviderProductPricingPricePerMonthFormattedArgs = {
  includeCurrencyISO?: InputMaybe<Scalars['Boolean']['input']>
  language?: InputMaybe<ProviderProductLanguage>
}

/** Billing Provider Product Pricing type */
export type BillingProviderProductPricingTrialSegmentPriceFormattedArgs = {
  includeCurrencyISO?: InputMaybe<Scalars['Boolean']['input']>
  language?: InputMaybe<ProviderProductLanguage>
}

/** Billing Provider Product Pricing type */
export type BillingProviderProductPricingTrialSegmentPricePerMonthFormattedArgs = {
  includeCurrencyISO?: InputMaybe<Scalars['Boolean']['input']>
  language?: InputMaybe<ProviderProductLanguage>
}

/** Create a billingProviderProductPricing input type */
export type BillingProviderProductPricingCreateInput = {
  /** The billing provider product id of the billing provider product pricing */
  billingProviderProductId: Scalars['ID']['input']
  /** The billing provider product pricing currency */
  currency: Scalars['String']['input']
  /** The billing provider product pricing price */
  price: Scalars['Float']['input']
  /** The billing provider product trial segment price */
  trialSegmentPrice?: InputMaybe<Scalars['Float']['input']>
}

/** Billing Provider Product Pricing Delete response */
export type BillingProviderProductPricingDeleteResponse = {
  __typename?: 'BillingProviderProductPricingDeleteResponse'
  /** The success status of the delete operation */
  success?: Maybe<Scalars['Boolean']['output']>
}

/** Billing Provider Product Pricing list response */
export type BillingProviderProductPricingListResponse = {
  __typename?: 'BillingProviderProductPricingListResponse'
  /** A list of billingProviderProductPricing reference */
  billingProviderProductPrices?: Maybe<Array<Maybe<BillingProviderProductPricing>>>
}

/** Billing Provider Product Pricing list id where input type */
export type BillingProviderProductPricingListWhereIdInput = {
  /** Is the value equal to the field */
  eq?: InputMaybe<Scalars['ID']['input']>
  /** Are the values in the field */
  in?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>
}

/** Billing Provider Product Pricing list where input type */
export type BillingProviderProductPricingListWhereInput = {
  /** The billingProviderProductPricing billingProviderProductId field where clause */
  billingProviderProductId?: InputMaybe<BillingProviderProductPricingListWhereIdInput>
  /** The billingProviderProductPricing currency field where clause */
  currency?: InputMaybe<BillingProviderProductPricingWhereStringInput>
  /** The billingProviderProductPricing id field where clause */
  id?: InputMaybe<BillingProviderProductPricingListWhereIdInput>
  /** The billingProviderProductPricing uuid field where clause */
  uuid?: InputMaybe<BillingProviderProductPricingListWhereIdInput>
}

/** Update a billingProviderProductPricing input type */
export type BillingProviderProductPricingUpdateInput = {
  /** The billing provider product id of the billing provider product pricing */
  billingProviderProductId?: InputMaybe<Scalars['ID']['input']>
  /** The billing provider product pricing currency */
  currency?: InputMaybe<Scalars['String']['input']>
  /** The id of the billing provider product pricing */
  id: Scalars['ID']['input']
  /** The billing provider product pricing price */
  price?: InputMaybe<Scalars['Float']['input']>
  /** The billing provider product trial segment price */
  trialSegmentPrice?: InputMaybe<Scalars['Float']['input']>
}

/** Billing Provider Product Pricing string where input type */
export type BillingProviderProductPricingWhereStringInput = {
  /** Is the value equal to the field */
  eq?: InputMaybe<Scalars['String']['input']>
  /** Are the values in the field */
  in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
}

/** Billing Provider Product Text */
export type BillingProviderProductText = {
  __typename?: 'BillingProviderProductText'
  /** Billing Provider Product associated with this Billing Provider Product Text */
  billingProviderProduct?: Maybe<BillingProviderProduct>
  /** The billing provider product id of the billing provider product text */
  billingProviderProductId?: Maybe<Scalars['ID']['output']>
  /** When the row was created */
  createdAt?: Maybe<Scalars['DateTime']['output']>
  /** The billingProviderProductText ecommerce sku (Indicates this is a value prop that relates to a bonus) */
  ecommerceSku?: Maybe<Scalars['ID']['output']>
  /** Ecommerce SKU Mapping (Bonus) associated with this Billing Provider Product Text */
  ecommerceSkuMapping?: Maybe<EcommerceSkuMapping>
  /** Ecommerce SKU Mapping Bonus Eligibilities (Bonus Campaigns) associated with this Billing Provider Product Text */
  ecommerceSkuMappingBonusEligibilities?: Maybe<Array<Maybe<EcommerceSkuMappingBonusEligibility>>>
  /** Whether the text is enabled */
  enabled?: Maybe<Scalars['Boolean']['output']>
  /** The id of the billing provider product text */
  id?: Maybe<Scalars['ID']['output']>
  /** Whether the text is a value proposition */
  isValueProp?: Maybe<Scalars['Boolean']['output']>
  /** Key */
  key?: Maybe<Scalars['String']['output']>
  /** Language */
  language?: Maybe<Scalars['String']['output']>
  /** String replacement parameters */
  parameters?: Maybe<Array<Maybe<Scalars['String']['output']>>>
  /** When the row was last updated */
  updatedAt?: Maybe<Scalars['DateTime']['output']>
  /** The UUID of the billing provider product text */
  uuid?: Maybe<Scalars['ID']['output']>
  /** Value */
  value?: Maybe<Scalars['String']['output']>
  /** The order of the value proposition */
  valuePropOrder?: Maybe<Scalars['Int']['output']>
}

/** Billing Provider Product Text */
export type BillingProviderProductTextEcommerceSkuMappingBonusEligibilitiesArgs = {
  effectiveDate?: InputMaybe<Scalars['DateTime']['input']>
  languages?: InputMaybe<Array<InputMaybe<ProviderProductLanguage>>>
}

/** Billing Provider Product Text Create Input */
export type BillingProviderProductTextCreateInput = {
  /** The billingProviderProductText billingProviderProductId */
  billingProviderProductId: Scalars['ID']['input']
  /** The billingProviderProductText ecommerceSku */
  ecommerceSku?: InputMaybe<Scalars['ID']['input']>
  /** The billingProviderProductText enabled */
  enabled: Scalars['Boolean']['input']
  /** The billingProviderProductText isValueProp */
  isValueProp: Scalars['Boolean']['input']
  /** The billingProviderProductText key */
  key: Scalars['String']['input']
  /** The billingProviderProductText language */
  language: ProviderProductLanguage
  /** The billingProviderProductText parameters */
  parameters?: InputMaybe<Array<InputMaybe<BillingProviderProductTextParameters>>>
  /** The billingProviderProductText value */
  value: Scalars['String']['input']
  /** The billingProviderProductText valuePropOrder */
  valuePropOrder?: InputMaybe<Scalars['Int']['input']>
}

/** Billing Provider Product Text Delete response */
export type BillingProviderProductTextDeleteResponse = {
  __typename?: 'BillingProviderProductTextDeleteResponse'
  /** The success status of the delete operation */
  success?: Maybe<Scalars['Boolean']['output']>
}

/** Billing Provider Product Text Input */
export type BillingProviderProductTextInput = {
  /** The billingProviderProductText ecommerce sku (Indicates this is a value prop that relates to a bonus) */
  ecommerceSku?: InputMaybe<Scalars['ID']['input']>
  /** Whether the billingProviderProductText is enabled */
  enabled?: InputMaybe<Scalars['Boolean']['input']>
  /** Whether this text is a value prop */
  isValueProp?: InputMaybe<Scalars['Boolean']['input']>
  /** The billingProviderProductText key */
  key: Scalars['String']['input']
  /** The billingProviderProductText language */
  language: ProviderProductLanguage
  /** The billingProviderProductText parameters */
  parameters?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  /** The billingProviderProductText value */
  value: Scalars['String']['input']
  /** The billingProviderProductText value prop order */
  valuePropOrder?: InputMaybe<Scalars['Int']['input']>
}

/** Billing Provider Product Text list response */
export type BillingProviderProductTextListResponse = {
  __typename?: 'BillingProviderProductTextListResponse'
  /** A list of billingProviderProductText */
  billingProviderProductText?: Maybe<Array<Maybe<BillingProviderProductText>>>
}

/** Billing Provider Product Text list id where input type */
export type BillingProviderProductTextListWhereIdInput = {
  /** Is the value equal to the field */
  eq?: InputMaybe<Scalars['ID']['input']>
  /** Are the values in the field */
  in?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>
}

/** Billing Provider Product Text list where input type */
export type BillingProviderProductTextListWhereInput = {
  /** The billingProviderProductText billingProviderProductId field where clause */
  billingProviderProductId?: InputMaybe<BillingProviderProductTextListWhereIdInput>
  /** The billingProviderProductText billingProviderProduct sku field where clause */
  billingProviderProductSku?: InputMaybe<BillingProviderProductTextWhereStringInput>
  /** The billingProviderProductText ecommerceSku field where clause */
  ecommerceSku?: InputMaybe<BillingProviderProductTextWhereStringInput>
  /** The billingProviderProductText enabled field where clause */
  enabled?: InputMaybe<BillingProviderProductTextWhereBooleanInput>
  /** The billingProviderProductText id field where clause */
  id?: InputMaybe<BillingProviderProductTextListWhereIdInput>
  /** The billingProviderProductText isValueProp field where clause */
  isValueProp?: InputMaybe<BillingProviderProductTextWhereBooleanInput>
  /** The billingProviderProductText key field where clause */
  key?: InputMaybe<BillingProviderProductTextWhereStringInput>
  /** The billingProviderProductText language field where clause */
  language?: InputMaybe<BillingProviderProductTextWhereLanguageInput>
  /** The billingProviderProductText uuid field where clause */
  uuid?: InputMaybe<BillingProviderProductTextListWhereIdInput>
  /** The billingProviderProductText valuePropOrder field where clause */
  valuePropOrder?: InputMaybe<BillingProviderProductTextListWhereIntInput>
}

/** Billing Provider Product Text list int where input type */
export type BillingProviderProductTextListWhereIntInput = {
  /** Is the value equal to the field */
  eq?: InputMaybe<Scalars['Int']['input']>
  /** Are the values in the field */
  in?: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>
}

/** Billing Provider Product Text Parameters */
export enum BillingProviderProductTextParameters {
  /** Percent savings of the billing provider product over another billing provider product (Monthly) */
  PercentSavings = 'percentSavings',
  /** Primary price of the billing provider product */
  Price = 'price',
  /** Trial segment percent savings of the billing provider product over another billing provider product (Monthly) */
  TrialPercentSavings = 'trialPercentSavings',
  /** Trial segment price of the billing provider product */
  TrialSegmentPrice = 'trialSegmentPrice',
}

/** Input for billingProviderProductText translation */
export type BillingProviderProductTextTranslateInput = {
  /** The billingProviderProduct to base translation on */
  billingProviderProduct?: InputMaybe<BillingProviderProductTextTranslateProviderProductInput>
  /** The billingProviderProductText to translate */
  billingProviderProductText?: InputMaybe<BillingProviderProductTextTranslateProviderProductTextInput>
  /** Whether to check for existing translations (default: true) */
  checkForExistingTranslations?: InputMaybe<Scalars['Boolean']['input']>
  /** The languages to translate to */
  languages?: InputMaybe<Array<InputMaybe<ProviderProductLanguage>>>
  /** String replacement parameters (if providing text) */
  parameters?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  /** Text to translate (not in the database) */
  text?: InputMaybe<Scalars['String']['input']>
}

/** Input for translation of all text for a billingProviderProduct */
export type BillingProviderProductTextTranslateProviderProductInput = {
  /** The billingProviderProduct ID */
  id?: InputMaybe<Scalars['Int']['input']>
  /** The billingProviderProduct SKU */
  sku?: InputMaybe<Scalars['String']['input']>
}

/** Input for translation of a billingProviderProductText */
export type BillingProviderProductTextTranslateProviderProductTextInput = {
  /** The billingProviderProductText ID */
  id?: InputMaybe<Scalars['Int']['input']>
  /** The billingProviderProduct key */
  key?: InputMaybe<Scalars['String']['input']>
}

/** Response for billingProviderProductText translation */
export type BillingProviderProductTextTranslateResponse = {
  __typename?: 'BillingProviderProductTextTranslateResponse'
  /** The translations */
  translations: Array<Maybe<BillingProviderProductTextTranslation>>
}

/** Translation for billingProviderProductText */
export type BillingProviderProductTextTranslation = {
  __typename?: 'BillingProviderProductTextTranslation'
  /** Whether the translation was retrieved from the database */
  fromDatabase?: Maybe<Scalars['Boolean']['output']>
  /** The input billingProviderProductText ID */
  id?: Maybe<Scalars['Int']['output']>
  /** The key of the billingProviderProductText */
  key?: Maybe<Scalars['String']['output']>
  /** The language of the translation */
  language: ProviderProductLanguage
  /** The translated text */
  value: Scalars['String']['output']
}

/** Input for billingProviderProductText translation options */
export type BillingProviderProductTextTranslationOptionsInput = {
  /** Additional context to help the translation */
  additionalContext?: InputMaybe<Scalars['String']['input']>
  /** The level of formality to use in the translation */
  formality?: InputMaybe<TranslationFormality>
  /** Whether to preserve the original formatting */
  preserveFormatting?: InputMaybe<Scalars['Boolean']['input']>
  /** Whether to split the text into sentences */
  splitSentences?: InputMaybe<Scalars['Boolean']['input']>
  /** The translation model to use */
  translationModel?: InputMaybe<TranslationModel>
}

/** Billing Provider Product Text Update Input */
export type BillingProviderProductTextUpdateInput = {
  /** The billingProviderProductText ecommerceSku */
  ecommerceSku?: InputMaybe<Scalars['ID']['input']>
  /** The billingProviderProductText enabled */
  enabled?: InputMaybe<Scalars['Boolean']['input']>
  /** The billingProviderProductText id */
  id: Scalars['ID']['input']
  /** The billingProviderProductText isValueProp */
  isValueProp?: InputMaybe<Scalars['Boolean']['input']>
  /** The billingProviderProductText key */
  key?: InputMaybe<Scalars['String']['input']>
  /** The billingProviderProductText language */
  language?: InputMaybe<ProviderProductLanguage>
  /** The billingProviderProductText parameters */
  parameters?: InputMaybe<Array<InputMaybe<BillingProviderProductTextParameters>>>
  /** The billingProviderProductText value */
  value?: InputMaybe<Scalars['String']['input']>
  /** The billingProviderProductText valuePropOrder */
  valuePropOrder?: InputMaybe<Scalars['Int']['input']>
}

/** Billing Provider Product Text Verify Error */
export type BillingProviderProductTextVerifyError = {
  __typename?: 'BillingProviderProductTextVerifyError'
  /** The error type of the billing provider product text verification */
  errorType?: Maybe<Scalars['String']['output']>
  /** The text of the string from the file */
  fileString?: Maybe<Scalars['String']['output']>
  /** Whether the text is a value proposition */
  isValueProp?: Maybe<Scalars['Boolean']['output']>
  /** The key of the billing provider product text */
  key?: Maybe<Scalars['String']['output']>
  /** The language of the billing provider product text */
  language?: Maybe<Scalars['String']['output']>
  /** The parameter related to the error */
  param?: Maybe<Scalars['String']['output']>
  /** The text of the string from the database */
  rawDbString?: Maybe<Scalars['String']['output']>
  /** The text of the string from the database with parameters replaced */
  replacedDbString?: Maybe<Scalars['String']['output']>
  /** The sku the billing provider product text belongs to */
  sku?: Maybe<Scalars['String']['output']>
  /** The order of the value proposition */
  valuePropOrder?: Maybe<Scalars['Int']['output']>
}

/** Billing Provider Product Text list where input type */
export type BillingProviderProductTextVerifyWhereInput = {
  /** The billingProviderProductText language field where clause */
  language?: InputMaybe<BillingProviderProductTextWhereLanguageInput>
  /** The billingProviderProductText sku field where clause */
  sku?: InputMaybe<BillingProviderProductTextWhereStringInput>
}

/** Billing Provider Product Text boolean where input type */
export type BillingProviderProductTextWhereBooleanInput = {
  /** Is the value equal to the field */
  eq?: InputMaybe<Scalars['Boolean']['input']>
}

/** Billing Provider Product Text language where input type */
export type BillingProviderProductTextWhereLanguageInput = {
  /** Is the value equal to the field */
  eq?: InputMaybe<ProviderProductLanguage>
  /** Are the values in the field */
  in?: InputMaybe<Array<InputMaybe<ProviderProductLanguage>>>
}

/** Billing Provider Product Text string where input type */
export type BillingProviderProductTextWhereStringInput = {
  /** Is the value equal to the field */
  eq?: InputMaybe<Scalars['String']['input']>
  /** Are the values in the field */
  in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
}

/** Billing Provider Product Update Input */
export type BillingProviderProductUpdateInput = {
  /** Whether the plan can be changed */
  allowChangePlan?: InputMaybe<Scalars['Boolean']['input']>
  /** Billing Product ID */
  billingProductId?: InputMaybe<Scalars['ID']['input']>
  /** Billing Provider ID */
  billingProviderId?: InputMaybe<Scalars['ID']['input']>
  /** Date when checkout is disabled for this product */
  checkoutEnabledEnd?: InputMaybe<Scalars['DateTime']['input']>
  /** Date when checkout is enabled for this product */
  checkoutEnabledStart?: InputMaybe<Scalars['DateTime']['input']>
  /** Countries restricted to this list */
  countryRestrictedIn?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  /** Countries restricted to not in this list */
  countryRestrictedNotIn?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  /** Default AI persona ID from Oracle API for this billing provider product */
  defaultOraclePersonalityId?: InputMaybe<Scalars['Int']['input']>
  /** Provider Product description */
  description?: InputMaybe<Scalars['String']['input']>
  /** Enabled */
  enabled?: InputMaybe<Scalars['Boolean']['input']>
  /** The billingProviderProduct id */
  id: Scalars['ID']['input']
  /** Primary stakeholder of the billing provider product */
  primaryStakeholder?: InputMaybe<ProviderProductPrimaryStakeholder>
  /** ID of main product in source system (zuora only) */
  providerFirstSegmentId?: InputMaybe<Scalars['String']['input']>
  /** ID of recurring product in source system (zuora only).  Only populated for trial plans. */
  providerSecondSegmentId?: InputMaybe<Scalars['String']['input']>
  /** Savings Comparison Billing Provider Product ID */
  savingsComparisonId?: InputMaybe<Scalars['ID']['input']>
  /** Whether this plan is taxed */
  taxable?: InputMaybe<Scalars['Boolean']['input']>
  /** Provider Product term length - null denotes lifetime access (courses) */
  termLength?: InputMaybe<Scalars['Int']['input']>
  /** Term type range */
  termType?: InputMaybe<ProviderProductTermType>
  /** Provider Product trial length - null denotes no trial */
  trialLength?: InputMaybe<Scalars['Int']['input']>
  /** Provider Product trial term range */
  trialTermType?: InputMaybe<ProviderProductTermType>
  /** Provider Product type */
  type?: InputMaybe<ProviderProductType>
}

/** Billing Provider Product string where input type */
export type BillingProviderProductWhereStringInput = {
  /** Is the value equal to the field */
  eq?: InputMaybe<Scalars['String']['input']>
  /** Are the values in the field */
  in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
}

/** Billing Provider Product where term type input type */
export type BillingProviderProductWhereTermTypeInput = {
  /** Is the value equal to the field */
  eq?: InputMaybe<ProviderProductTermType>
  /** Are the values in the field */
  in?: InputMaybe<Array<InputMaybe<ProviderProductTermType>>>
}

/** Billing Provider Product where type input type */
export type BillingProviderProductWhereTypeInput = {
  /** Is the value equal to the field */
  eq?: InputMaybe<ProviderProductType>
  /** Are the values in the field */
  in?: InputMaybe<Array<InputMaybe<ProviderProductType>>>
}

/** Billing Provider boolean where input type */
export type BillingProviderWhereBooleanInput = {
  /** Is the value equal to the field */
  eq?: InputMaybe<Scalars['Boolean']['input']>
}

/** Billing Provider Product Name where input type */
export type BillingProviderWhereNameInput = {
  /** Is the value equal to the field */
  eq?: InputMaybe<BillingProviderName>
  /** Are the values in the field */
  in?: InputMaybe<Array<InputMaybe<BillingProviderName>>>
}

/** Billing Product string where input type */
export type BillingProviderWhereStringInput = {
  /** Is the value equal to the field */
  eq?: InputMaybe<BillingProviderName>
  /** Are the values in the field */
  in?: InputMaybe<Array<InputMaybe<BillingProviderName>>>
}

/** Billing Refund */
export type BillingRefund = {
  __typename?: 'BillingRefund'
  /** The refund amount */
  amount?: Maybe<Scalars['Float']['output']>
  /** The billing refund ID of the billing refund */
  billingPaymentId?: Maybe<Scalars['ID']['output']>
  /** When the row was created */
  createdAt?: Maybe<Scalars['DateTime']['output']>
  /** The refund gateway error */
  gatewayError?: Maybe<Scalars['String']['output']>
  /** The id of the billing refund */
  id?: Maybe<Scalars['ID']['output']>
  /** ID of provider refund */
  providerRefundId?: Maybe<Scalars['String']['output']>
  /** When the refund was processed */
  refundDate?: Maybe<Scalars['DateTime']['output']>
  /** Whether the refund has been success */
  success?: Maybe<Scalars['Boolean']['output']>
  /** When the row was last updated */
  updatedAt?: Maybe<Scalars['DateTime']['output']>
  /** The UUID of the billing refund */
  uuid?: Maybe<Scalars['ID']['output']>
}

/** Create input for Billing Refund */
export type BillingRefundCreateInput = {
  /** The refund amount */
  amount: Scalars['Float']['input']
  /** The billing payment ID of the billing refund */
  billingPaymentId: Scalars['ID']['input']
  /** The gateway error of payment */
  gatewayError?: InputMaybe<Scalars['String']['input']>
  /** The provider refund ID of the billing refund */
  providerRefundId: Scalars['String']['input']
  /** Date of refund date */
  refundDate: Scalars['DateTime']['input']
  /** Whether the payment has been success */
  success: Scalars['Boolean']['input']
}

/** Billing Refund list response */
export type BillingRefundListResponse = {
  __typename?: 'BillingRefundListResponse'
  billingRefunds?: Maybe<Array<Maybe<BillingRefund>>>
}

/** Billing Refund boolean where input type */
export type BillingRefundListWhereBooleanInput = {
  /** Is the value equal to the field */
  eq?: InputMaybe<Scalars['Boolean']['input']>
}

/** Billing Refund list where Date input type */
export type BillingRefundListWhereDateInput = {
  /** Is the value greater than the field */
  gt?: InputMaybe<Scalars['Date']['input']>
  /** Is the value greater than or equal to the field */
  gte?: InputMaybe<Scalars['Date']['input']>
  /** Is the value less than the field */
  lt?: InputMaybe<Scalars['Date']['input']>
  /** Is the value less than or equal to the field */
  lte?: InputMaybe<Scalars['Date']['input']>
}

/** Billing Refund float where input type */
export type BillingRefundListWhereFloatInput = {
  /** Is the value equal to the field */
  eq?: InputMaybe<Scalars['Float']['input']>
}

/** Billing Refund list id where input type */
export type BillingRefundListWhereIdInput = {
  /** Is the value equal to the field */
  eq?: InputMaybe<Scalars['ID']['input']>
  /** Are the values in the field */
  in?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>
}

/** Billing Refund list where input type */
export type BillingRefundListWhereInput = {
  /** The billingRefund amount field where clause */
  amount?: InputMaybe<BillingRefundListWhereFloatInput>
  /** The billingRefund billingPaymentId field where clause */
  billingPaymentId?: InputMaybe<BillingRefundListWhereIdInput>
  /** The billingRefund createdAt field where clause */
  createdAt?: InputMaybe<BillingRefundListWhereDateInput>
  /** The billingRefund gatewayError field where clause */
  gatewayError?: InputMaybe<BillingRefundListWhereStringInput>
  /** The billingRefund id field where clause */
  id?: InputMaybe<BillingRefundListWhereIdInput>
  /** The billingRefund providerRefundId field where clause */
  providerRefundId?: InputMaybe<BillingRefundListWhereStringInput>
  /** The billingRefund refundDate field where clause */
  refundDate?: InputMaybe<BillingRefundListWhereDateInput>
  /** The billingRefund success field where clause */
  success?: InputMaybe<BillingRefundListWhereBooleanInput>
  /** The billingRefund uuid field where clause */
  uuid?: InputMaybe<BillingRefundListWhereStringInput>
}

/** Billing Refund string where input type */
export type BillingRefundListWhereStringInput = {
  /** Is the value equal to the field */
  eq?: InputMaybe<Scalars['String']['input']>
  /** Are the values in the field */
  in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
}

/** Update input for Billing Refund */
export type BillingRefundUpdateInput = {
  /** The refund amount */
  amount?: InputMaybe<Scalars['Float']['input']>
  /** The billing payment ID of the billing refund */
  billingPaymentId?: InputMaybe<Scalars['ID']['input']>
  /** The gateway error of payment */
  gatewayError?: InputMaybe<Scalars['String']['input']>
  /** The id of the billing refund */
  id: Scalars['ID']['input']
  /** The provider refund ID of the billing refund */
  providerRefundId?: InputMaybe<Scalars['String']['input']>
  /** Date of refund date */
  refundDate?: InputMaybe<Scalars['DateTime']['input']>
  /** Whether the payment has been success */
  success?: InputMaybe<Scalars['Boolean']['input']>
}

/** Billing subscriptions */
export type BillingSubscription = {
  __typename?: 'BillingSubscription'
  /** The billing account ID of subscription */
  billingAccountId?: Maybe<Scalars['ID']['output']>
  /** The billing provider ID of subscription */
  billingProviderId?: Maybe<Scalars['ID']['output']>
  /** The cancelDate of subscription */
  cancelDate?: Maybe<Scalars['DateTime']['output']>
  /** The cancelReason of subscription */
  cancelReason?: Maybe<Scalars['String']['output']>
  /** When the row was created */
  createdAt?: Maybe<Scalars['DateTime']['output']>
  /** The endDate of subscription */
  endDate?: Maybe<Scalars['DateTime']['output']>
  /** The primary identifier for this record */
  id?: Maybe<Scalars['ID']['output']>
  /** The latamPricing of subscription */
  latamPricing?: Maybe<Scalars['Boolean']['output']>
  /** The nextInvoiceAmount of subscription */
  nextInvoiceAmount?: Maybe<Scalars['Float']['output']>
  /** The nextInvoiceDate of subscription */
  nextInvoiceDate?: Maybe<Scalars['DateTime']['output']>
  /** The paidThroughDate of subscription */
  paidThroughDate?: Maybe<Scalars['DateTime']['output']>
  /** The pauseDate of subscription */
  pauseDate?: Maybe<Scalars['DateTime']['output']>
  /** The priceOverrideReason of subscription */
  priceOverrideReason?: Maybe<SubscriptionPriceOverrideReason>
  /** The provider subscription id */
  providerSubscriptionId?: Maybe<Scalars['String']['output']>
  /** The resumeDate of subscription */
  resumeDate?: Maybe<Scalars['DateTime']['output']>
  /** The startDate of subscription */
  startDate?: Maybe<Scalars['DateTime']['output']>
  /** The status of subscription */
  status?: Maybe<SubscriptionStatus>
  /** When the row was last updated */
  updatedAt?: Maybe<Scalars['DateTime']['output']>
  /** The billing subscription uuid */
  uuid?: Maybe<Scalars['ID']['output']>
}

/** Create input for Billing Subscription */
export type BillingSubscriptionCreateInput = {
  /** The billing account ID of subscription */
  billingAccountId: Scalars['ID']['input']
  /** The billing provider ID of subscription */
  billingProviderId: Scalars['ID']['input']
  /** The cancelDate of subscription */
  cancelDate?: InputMaybe<Scalars['DateTime']['input']>
  /** The cancelReason of subscription */
  cancelReason?: InputMaybe<Scalars['String']['input']>
  /** The endDate of subscription */
  endDate?: InputMaybe<Scalars['DateTime']['input']>
  /** The latamPricing of subscription */
  latamPricing: Scalars['Boolean']['input']
  /** The nextInvoiceAmount of subscription */
  nextInvoiceAmount?: InputMaybe<Scalars['DateTime']['input']>
  /** The nextInvoiceDate of subscription */
  nextInvoiceDate?: InputMaybe<Scalars['DateTime']['input']>
  /** The paidThroughDate of subscription */
  paidThroughDate: Scalars['DateTime']['input']
  /** The pauseDate of subscription */
  pauseDate?: InputMaybe<Scalars['DateTime']['input']>
  /** The priceOverrideReason of subscription */
  priceOverrideReason?: InputMaybe<SubscriptionPriceOverrideReason>
  /** The provider subscription ID of subscription */
  providerSubscriptionId: Scalars['String']['input']
  /** The resumeDate of subscription */
  resumeDate?: InputMaybe<Scalars['DateTime']['input']>
  /** The startDate of subscription */
  startDate: Scalars['DateTime']['input']
  /** The status of subscription */
  status: SubscriptionStatus
}

/** Billing subscription policy list response */
export type BillingSubscriptionListResponse = {
  __typename?: 'BillingSubscriptionListResponse'
  /** A list of user accounts */
  billingSubscriptions?: Maybe<Array<Maybe<BillingSubscription>>>
  /** Total number of rows of content found (uses a slower count query for list) */
  count?: Maybe<Scalars['Int']['output']>
  /** The limit applied to the rows */
  limit?: Maybe<Scalars['Int']['output']>
  /** The offset applied to the rows */
  offset?: Maybe<Scalars['Int']['output']>
}

/** Billing subscription id type where input type */
export type BillingSubscriptionListWhereIdInput = {
  /** Is the value equal to the field */
  eq?: InputMaybe<Scalars['ID']['input']>
  /** Is the value greater than to the field */
  gt?: InputMaybe<Scalars['ID']['input']>
  /** Is the value greater than or equal to the field */
  gte?: InputMaybe<Scalars['ID']['input']>
  /** Are the values in the field */
  in?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>
}

/** Billing subscription policy where conditions to filter rows */
export type BillingSubscriptionListWhereInput = {
  /** The billingAccountId: field where clause */
  billingAccountId?: InputMaybe<BillingSubscriptionListWhereIdInput>
  /** The billingProviderId: field where clause */
  billingProviderId?: InputMaybe<BillingSubscriptionListWhereIdInput>
  /** The id field where clause */
  id?: InputMaybe<BillingSubscriptionListWhereIdInput>
  /** The providerSubscriptionId: field where clause */
  providerSubscriptionId?: InputMaybe<BillingSubscriptionWhereStringInput>
  /** The billing subscription status: field where clause */
  status?: InputMaybe<BillingSubscriptionOrderListWhereStatusInput>
}

/** Billing Subscription Order */
export type BillingSubscriptionOrder = {
  __typename?: 'BillingSubscriptionOrder'
  /** The billing subscription ID of the billing subscription order */
  billingSubscriptionId?: Maybe<Scalars['ID']['output']>
  createdAt?: Maybe<Scalars['DateTime']['output']>
  /** When the billing subscription order was effective date */
  effectiveDate?: Maybe<Scalars['DateTime']['output']>
  /** The id of the billing subscription order */
  id?: Maybe<Scalars['ID']['output']>
  /** Order request of billing subscription order */
  orderRequest?: Maybe<Scalars['JSON']['output']>
  /** Order response of billing subscription order */
  orderResponse?: Maybe<Scalars['JSON']['output']>
  /** The provider order Id */
  providerOrderId?: Maybe<Scalars['String']['output']>
  /** Whether the billing subscription order has been removed */
  removed?: Maybe<Scalars['Boolean']['output']>
  /** Whether the billing subscription order has been success */
  success?: Maybe<Scalars['Boolean']['output']>
  /** The billing subscription order type */
  type?: Maybe<SubscriptionOrderType>
  /** When the row was last updated */
  updatedAt?: Maybe<Scalars['DateTime']['output']>
  /** The UUID of the billing subscription order */
  uuid?: Maybe<Scalars['ID']['output']>
}

/** Create input for Billing Subscription Order */
export type BillingSubscriptionOrderCreateInput = {
  /** The billing subscription ID of the billing subscription order */
  billingSubscriptionId: Scalars['ID']['input']
  /** The effective date of the billing subscription order */
  effectiveDate: Scalars['DateTime']['input']
  /** The order request of the billing subscription order */
  orderRequest?: InputMaybe<Scalars['JSON']['input']>
  /** The order response of the billing subscription order */
  orderResponse?: InputMaybe<Scalars['JSON']['input']>
  /** The provider order Id of the billing subscription order */
  providerOrderId: Scalars['String']['input']
  /** Whether the billing subscription order has been removed */
  removed: Scalars['Boolean']['input']
  /** Whether the billing subscription order has been success */
  success: Scalars['Boolean']['input']
  /** The type of the billing subscription order */
  type: SubscriptionOrderType
}

/** Billing Subscription Order list response */
export type BillingSubscriptionOrderListResponse = {
  __typename?: 'BillingSubscriptionOrderListResponse'
  billingSubscriptionOrders?: Maybe<Array<Maybe<BillingSubscriptionOrder>>>
}

/** Billing Subscription Order boolean where input type */
export type BillingSubscriptionOrderListWhereBooleanInput = {
  /** Is the value equal to the field */
  eq?: InputMaybe<Scalars['Boolean']['input']>
}

/** Billing Subscription Order list where Date input type */
export type BillingSubscriptionOrderListWhereDateInput = {
  /** Is the value greater than the field */
  gt?: InputMaybe<Scalars['Date']['input']>
  /** Is the value greater than or equal to the field */
  gte?: InputMaybe<Scalars['Date']['input']>
  /** Is the value less than the field */
  lt?: InputMaybe<Scalars['Date']['input']>
  /** Is the value less than or equal to the field */
  lte?: InputMaybe<Scalars['Date']['input']>
}

/** Billing Subscription Order list id where input type */
export type BillingSubscriptionOrderListWhereIdInput = {
  /** Is the value equal to the field */
  eq?: InputMaybe<Scalars['ID']['input']>
  /** Are the values in the field */
  in?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>
}

/** Billing Subscription Order list where input type */
export type BillingSubscriptionOrderListWhereInput = {
  /** The billingSubscriptionOrder billingSubscriptionId field where clause */
  billingSubscriptionId?: InputMaybe<BillingSubscriptionOrderListWhereIdInput>
  /** The billingSubscriptionOrder createdAt field where clause */
  createdAt?: InputMaybe<BillingSubscriptionOrderListWhereDateInput>
  /** The billingSubscriptionOrder effectiveDate field where clause */
  effectiveDate?: InputMaybe<BillingSubscriptionOrderListWhereDateInput>
  /** The billingSubscriptionOrder id field where clause */
  id?: InputMaybe<BillingSubscriptionOrderListWhereIdInput>
  /** The billingSubscriptionOrder providerOrderId field where clause */
  providerOrderId?: InputMaybe<BillingSubscriptionOrderListWhereStringInput>
  /** The billingSubscriptionOrder removed field where clause */
  removed?: InputMaybe<BillingSubscriptionOrderListWhereBooleanInput>
  /** The billingSubscriptionOrder success field where clause */
  success?: InputMaybe<BillingSubscriptionOrderListWhereBooleanInput>
  /** The billingSubscriptionOrder type field where clause */
  type?: InputMaybe<BillingSubscriptionOrderListWhereTypeInput>
  /** The billingSubscriptionOrder uuid field where clause */
  uuid?: InputMaybe<BillingSubscriptionOrderListWhereStringInput>
}

/** Billing Subscription status where input type */
export type BillingSubscriptionOrderListWhereStatusInput = {
  /** Is the value equal to the field */
  eq?: InputMaybe<Scalars['String']['input']>
  /** Are the values in the field */
  in?: InputMaybe<Array<InputMaybe<SubscriptionStatus>>>
}

/** Billing Subscription Order string where input type */
export type BillingSubscriptionOrderListWhereStringInput = {
  /** Is the value equal to the field */
  eq?: InputMaybe<Scalars['String']['input']>
  /** Are the values in the field */
  in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
}

/** Billing Provider Product where type input type */
export type BillingSubscriptionOrderListWhereTypeInput = {
  /** Is the value equal to the field */
  eq?: InputMaybe<SubscriptionOrderType>
  /** Are the values in the field */
  in?: InputMaybe<Array<InputMaybe<SubscriptionOrderType>>>
}

/** Billing subscriptions */
export type BillingSubscriptionOrderPlan = {
  __typename?: 'BillingSubscriptionOrderPlan'
  /** The action of subscription */
  action?: Maybe<SubscriptionOrderPlanAction>
  /** The billingSubscriptionOrderId of subscription order plan */
  billingSubscriptionOrderId?: Maybe<Scalars['ID']['output']>
  /** The billingSubscriptionPlanId of subscription order plan */
  billingSubscriptionPlanId?: Maybe<Scalars['ID']['output']>
  /** When the row was created */
  createdAt?: Maybe<Scalars['DateTime']['output']>
  /** The primary identifier for this record */
  id?: Maybe<Scalars['ID']['output']>
  /** The newValues of billing subscription order plan */
  newValues?: Maybe<Scalars['JSON']['output']>
  /** The oldValues of billing subscription order plan */
  oldValues?: Maybe<Scalars['JSON']['output']>
  /** When the row was last updated */
  updatedAt?: Maybe<Scalars['DateTime']['output']>
  /** The billing subscription order plan uuid */
  uuid?: Maybe<Scalars['ID']['output']>
}

/** Create input for Billing Subscription Order Plan */
export type BillingSubscriptionOrderPlanCreateInput = {
  /** The action of subscription */
  action: SubscriptionOrderPlanAction
  /** The billingSubscriptionOrderId of subscription order plan */
  billingSubscriptionOrderId: Scalars['ID']['input']
  /** The billingSubscriptionPlanId of subscription order plan */
  billingSubscriptionPlanId: Scalars['ID']['input']
  /** The newValues of billing subscription order plan */
  newValues?: InputMaybe<Scalars['JSON']['input']>
  /** The oldValues of billing subscription order plan */
  oldValues?: InputMaybe<Scalars['JSON']['input']>
}

/** Billing subscription policy list response */
export type BillingSubscriptionOrderPlanListResponse = {
  __typename?: 'BillingSubscriptionOrderPlanListResponse'
  /** A list of user accounts */
  billingSubscriptionOrderPlans?: Maybe<Array<Maybe<BillingSubscriptionOrderPlan>>>
  /** Total number of rows of content found (uses a slower count query for list) */
  count?: Maybe<Scalars['Int']['output']>
  /** The limit applied to the rows */
  limit?: Maybe<Scalars['Int']['output']>
  /** The offset applied to the rows */
  offset?: Maybe<Scalars['Int']['output']>
}

/** Billing subscription order plan status where input type */
export type BillingSubscriptionOrderPlanListWhereActionInput = {
  /** Is the value equal to the field */
  eq?: InputMaybe<Scalars['String']['input']>
  /** Are the values in the field */
  in?: InputMaybe<Array<InputMaybe<SubscriptionOrderPlanAction>>>
}

/** Billing subscription subscription order plan id type where input type */
export type BillingSubscriptionOrderPlanListWhereIdInput = {
  /** Is the value equal to the field */
  eq?: InputMaybe<Scalars['ID']['input']>
  /** Is the value greater than to the field */
  gt?: InputMaybe<Scalars['ID']['input']>
  /** Is the value greater than or equal to the field */
  gte?: InputMaybe<Scalars['ID']['input']>
  /** Are the values in the field */
  in?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>
}

/** Billing subscription order plan policy where conditions to filter rows */
export type BillingSubscriptionOrderPlanListWhereInput = {
  /** The billing subscription status: field where clause */
  action?: InputMaybe<BillingSubscriptionOrderPlanListWhereActionInput>
  /** The billingAccountId: field where clause */
  billingSubscriptionOrderId?: InputMaybe<BillingSubscriptionOrderPlanListWhereIdInput>
  /** The billingSubscriptionPlanId: field where clause */
  billingSubscriptionPlanId?: InputMaybe<BillingSubscriptionOrderPlanListWhereIdInput>
  /** The id field where clause */
  id?: InputMaybe<BillingSubscriptionOrderPlanListWhereIdInput>
  /** The uuid field where clause */
  uuid?: InputMaybe<BillingSubscriptionOrderPlanWhereStringInput>
}

/** Create input for Billing Subscription Order Plan */
export type BillingSubscriptionOrderPlanUpdateInput = {
  /** The action of subscription */
  action: SubscriptionOrderPlanAction
  /** The billingSubscriptionOrderId of subscription order plan */
  billingSubscriptionOrderId?: InputMaybe<Scalars['ID']['input']>
  /** The billingSubscriptionPlanId of subscription order plan */
  billingSubscriptionPlanId?: InputMaybe<Scalars['ID']['input']>
  /** The ID of subscription order plan */
  id?: InputMaybe<Scalars['ID']['input']>
  /** The newValues of billing subscription order plan */
  newValues?: InputMaybe<Scalars['JSON']['input']>
  /** The oldValues of billing subscription order plan */
  oldValues?: InputMaybe<Scalars['JSON']['input']>
}

/** Billing subscription order plan string where input type */
export type BillingSubscriptionOrderPlanWhereStringInput = {
  /** Is the value equal to the field */
  eq?: InputMaybe<Scalars['String']['input']>
  /** Are the values in the field */
  in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
}

/** Update input for Billing Subscription Order */
export type BillingSubscriptionOrderUpdateInput = {
  /** The billing subscription ID of the billing subscription order */
  billingSubscriptionId?: InputMaybe<Scalars['ID']['input']>
  /** The effective date of the billing subscription order */
  effectiveDate?: InputMaybe<Scalars['DateTime']['input']>
  /** The id of the billing subscription order */
  id: Scalars['ID']['input']
  /** The order request of the billing subscription order */
  orderRequest?: InputMaybe<Scalars['JSON']['input']>
  /** The order response of the billing subscription order */
  orderResponse?: InputMaybe<Scalars['JSON']['input']>
  /** The provider order Id of the billing subscription order */
  providerOrderId?: InputMaybe<Scalars['String']['input']>
  /** Whether the billing subscription order has been removed */
  removed?: InputMaybe<Scalars['Boolean']['input']>
  /** Whether the billing subscription order has been success */
  success?: InputMaybe<Scalars['Boolean']['input']>
  /** The type of the billing subscription order */
  type?: InputMaybe<SubscriptionOrderType>
}

/** Billing Subscription Plan */
export type BillingSubscriptionPlan = {
  __typename?: 'BillingSubscriptionPlan'
  /** The billing provider product ID of the billing subscription plan */
  billingProviderProductId?: Maybe<Scalars['ID']['output']>
  /** The billing subscription ID of the billing subscription plan */
  billingSubscriptionId?: Maybe<Scalars['ID']['output']>
  createdAt?: Maybe<Scalars['DateTime']['output']>
  /** When the billing subscription plan ends */
  endDate?: Maybe<Scalars['DateTime']['output']>
  /** The id of the billing subscription plan */
  id?: Maybe<Scalars['ID']['output']>
  /** When the billing subscription plan trial ends date */
  priceOverride?: Maybe<Scalars['Float']['output']>
  /** Whether the billing subscription plan has been removed */
  removed?: Maybe<Scalars['Boolean']['output']>
  /** When the billing subscription plan starts */
  startDate?: Maybe<Scalars['DateTime']['output']>
  /** When the billing subscription plan trial ends date */
  trialEndDate?: Maybe<Scalars['DateTime']['output']>
  /** When the row was last updated */
  updatedAt?: Maybe<Scalars['DateTime']['output']>
  /** The UUID of the billing subscription plan */
  uuid?: Maybe<Scalars['ID']['output']>
}

/** Create input for Billing Subscription Plan */
export type BillingSubscriptionPlanCreateInput = {
  /** The billingProviderProductId of the billing subscription plan */
  billingProviderProductId: Scalars['ID']['input']
  /** The billingSubscriptionId of the billing subscription plan */
  billingSubscriptionId: Scalars['ID']['input']
  /** The end date of the billing subscription plan */
  endDate?: InputMaybe<Scalars['DateTime']['input']>
  /** The price override of the billing subscription plan */
  priceOverride?: InputMaybe<Scalars['Float']['input']>
  /** Whether the billing subscription plan has been removed */
  removed: Scalars['Boolean']['input']
  /** The start date of the billing subscription plan */
  startDate: Scalars['DateTime']['input']
  /** The trial end date of the billing subscription plan */
  trialEndDate?: InputMaybe<Scalars['DateTime']['input']>
}

/** Billing Subscription Plan list response */
export type BillingSubscriptionPlanListResponse = {
  __typename?: 'BillingSubscriptionPlanListResponse'
  billingSubscriptionPlans?: Maybe<Array<Maybe<BillingSubscriptionPlan>>>
}

/** Billing Subscription Plan boolean where input type */
export type BillingSubscriptionPlanListWhereBooleanInput = {
  /** Is the value equal to the field */
  eq?: InputMaybe<Scalars['Boolean']['input']>
}

/** Billing Subscription Plan list where Date input type */
export type BillingSubscriptionPlanListWhereDateInput = {
  /** Is the value greater than the field */
  gt?: InputMaybe<Scalars['Date']['input']>
  /** Is the value greater than or equal to the field */
  gte?: InputMaybe<Scalars['Date']['input']>
  /** Is the value less than the field */
  lt?: InputMaybe<Scalars['Date']['input']>
  /** Is the value less than or equal to the field */
  lte?: InputMaybe<Scalars['Date']['input']>
}

/** Billing Invoice float where input type */
export type BillingSubscriptionPlanListWhereFloatInput = {
  /** Is the value equal to the field */
  eq?: InputMaybe<Scalars['Float']['input']>
}

/** Billing Subscription Plan list id where input type */
export type BillingSubscriptionPlanListWhereIdInput = {
  /** Is the value equal to the field */
  eq?: InputMaybe<Scalars['ID']['input']>
  /** Are the values in the field */
  in?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>
}

/** Billing Subscription Plan list where input type */
export type BillingSubscriptionPlanListWhereInput = {
  /** The billingSubscriptionPlan billingProviderProductId field where clause */
  billingProviderProductId?: InputMaybe<BillingSubscriptionPlanListWhereIdInput>
  /** The billingSubscriptionPlan billingSubscriptionId field where clause */
  billingSubscriptionId?: InputMaybe<BillingSubscriptionPlanListWhereIdInput>
  /** The billingSubscriptionPlan createdAt field where clause */
  createdAt?: InputMaybe<BillingSubscriptionPlanListWhereDateInput>
  /** The billingSubscriptionPlan endDate field where clause */
  endDate?: InputMaybe<BillingSubscriptionPlanListWhereDateInput>
  /** The billingSubscriptionPlan id field where clause */
  id?: InputMaybe<BillingSubscriptionPlanListWhereIdInput>
  /** The billingSubscriptionPlan priceOverride field where clause */
  priceOverride?: InputMaybe<BillingSubscriptionPlanListWhereFloatInput>
  /** The billingSubscriptionPlan removed field where clause */
  removed?: InputMaybe<BillingSubscriptionPlanListWhereBooleanInput>
  /** The billingSubscriptionPlan startDate field where clause */
  startDate?: InputMaybe<BillingSubscriptionPlanListWhereDateInput>
  /** The billingSubscriptionPlan trialEndDate field where clause */
  trialEndDate?: InputMaybe<BillingSubscriptionPlanListWhereDateInput>
  /** The billingSubscriptionPlan uuid field where clause */
  uuid?: InputMaybe<BillingSubscriptionPlanListWhereStringInput>
}

/** Billing Subscription Plan string where input type */
export type BillingSubscriptionPlanListWhereStringInput = {
  /** Is the value equal to the field */
  eq?: InputMaybe<Scalars['String']['input']>
  /** Are the values in the field */
  in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
}

/** Update input for Billing Subscription Plan */
export type BillingSubscriptionPlanUpdateInput = {
  /** The billingProviderProductId of the billing subscription plan */
  billingProviderProductId?: InputMaybe<Scalars['ID']['input']>
  /** The billingSubscriptionId of the billing subscription plan */
  billingSubscriptionId?: InputMaybe<Scalars['ID']['input']>
  /** The end date of the billing subscription plan */
  endDate?: InputMaybe<Scalars['DateTime']['input']>
  /** The id of the billing subscription plan */
  id: Scalars['ID']['input']
  /** The price override of the billing subscription plan */
  priceOverride?: InputMaybe<Scalars['Float']['input']>
  /** Whether the billing subscription plan has been removed */
  removed?: InputMaybe<Scalars['Boolean']['input']>
  /** The start date of the billing subscription plan */
  startDate?: InputMaybe<Scalars['DateTime']['input']>
  /** The trial end date of the billing subscription plan */
  trialEndDate?: InputMaybe<Scalars['DateTime']['input']>
}

/** Update input for Billing Subscription */
export type BillingSubscriptionUpdateInput = {
  /** The billing account ID of subscription */
  billingAccountId?: InputMaybe<Scalars['ID']['input']>
  /** The billing provider ID of subscription */
  billingProviderId?: InputMaybe<Scalars['ID']['input']>
  /** The cancelDate of subscription */
  cancelDate?: InputMaybe<Scalars['DateTime']['input']>
  /** The cancelReason of subscription */
  cancelReason?: InputMaybe<Scalars['String']['input']>
  /** The endDate of subscription */
  endDate?: InputMaybe<Scalars['DateTime']['input']>
  /** The billing ID of subscription */
  id: Scalars['ID']['input']
  /** The latamPricing of subscription */
  latamPricing?: InputMaybe<Scalars['Boolean']['input']>
  /** The nextInvoiceAmount of subscription */
  nextInvoiceAmount?: InputMaybe<Scalars['DateTime']['input']>
  /** The nextInvoiceDate of subscription */
  nextInvoiceDate?: InputMaybe<Scalars['DateTime']['input']>
  /** The paidThroughDate of subscription */
  paidThroughDate: Scalars['DateTime']['input']
  /** The pauseDate of subscription */
  pauseDate?: InputMaybe<Scalars['DateTime']['input']>
  /** The priceOverrideReason of subscription */
  priceOverrideReason?: InputMaybe<SubscriptionPriceOverrideReason>
  /** The provider subscription ID of subscription */
  providerSubscriptionId?: InputMaybe<Scalars['String']['input']>
  /** The resumeDate of subscription */
  resumeDate?: InputMaybe<Scalars['DateTime']['input']>
  /** The startDate of subscription */
  startDate?: InputMaybe<Scalars['DateTime']['input']>
  /** The status of subscription */
  status?: InputMaybe<SubscriptionStatus>
}

/** Billing subscription string where input type */
export type BillingSubscriptionWhereStringInput = {
  /** Is the value equal to the field */
  eq?: InputMaybe<Scalars['String']['input']>
  /** Are the values in the field */
  in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
}

/** Chat history */
export type ChatHistory = {
  __typename?: 'ChatHistory'
  /** The chat sessions id */
  chatSessionsId: Scalars['ID']['output']
  /** The date the row was created */
  createdAt?: Maybe<Scalars['DateTime']['output']>
  /** The chat message data */
  data?: Maybe<Scalars['JSON']['output']>
  /** The chat history id */
  id: Scalars['ID']['output']
  /** The chat response data */
  responseData?: Maybe<Scalars['JSON']['output']>
  /** The chat message type */
  type?: Maybe<Scalars['String']['output']>
  /** The date the row was last updated */
  updatedAt?: Maybe<Scalars['DateTime']['output']>
  /** The user linked to this chat history */
  userInfo?: Maybe<UserInfo>
  /** The user info uuid */
  userInfoUuid: Scalars['ID']['output']
}

/** Chat history create input */
export type ChatHistoryCreateInput = {
  /** The chat session id */
  chatSessionsId: Scalars['ID']['input']
  /** The chat history data */
  data: Scalars['JSON']['input']
  /** The chat response data */
  responseData?: InputMaybe<Scalars['JSON']['input']>
  /** The chat history type */
  type?: InputMaybe<Scalars['String']['input']>
  /** The user info uuid (defaults to the requesting user) */
  userInfoUuid?: InputMaybe<Scalars['ID']['input']>
}

/** Chat history delete input */
export type ChatHistoryDeleteInput = {
  /** The chat history id */
  id: Scalars['ID']['input']
  /** The user info uuid (defaults to the requesting user) */
  userInfoUuid?: InputMaybe<Scalars['ID']['input']>
}

/** Chat history list response */
export type ChatHistoryListResponse = {
  __typename?: 'ChatHistoryListResponse'
  /** A list of Chat history */
  chatHistories?: Maybe<Array<Maybe<ChatHistory>>>
}

/** Chat history mutation response */
export type ChatHistoryMutationResponse = {
  __typename?: 'ChatHistoryMutationResponse'
  /** The deleted chat history */
  chatHistory?: Maybe<ChatHistory>
  /** When true successfully deleted */
  success?: Maybe<Scalars['Boolean']['output']>
}

/** Chat history update input */
export type ChatHistoryUpdateInput = {
  /** The chat history data (the entire value will be updated if defined) */
  data?: InputMaybe<Scalars['JSON']['input']>
  /** The chat history id */
  id: Scalars['ID']['input']
  /** The chat response data (the entire value will be updated  if defined) */
  responseData?: InputMaybe<Scalars['JSON']['input']>
  /** The chat history type */
  type?: InputMaybe<Scalars['String']['input']>
  /** The user info uuid (defaults to the requesting user) */
  userInfoUuid?: InputMaybe<Scalars['ID']['input']>
}

/** Chat history where title group id input type */
export type ChatHistoryWhereChatSessionsIdInput = {
  /** Is the value equal to the field */
  eq?: InputMaybe<Scalars['ID']['input']>
  /** Are the values in the field */
  in?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>
}

/** Chat history where title group id input type */
export type ChatHistoryWhereIdInput = {
  /** Is the value equal to the field */
  eq?: InputMaybe<Scalars['ID']['input']>
  /** Are the values in the field */
  in?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>
}

/** Chat history where conditions to filter rows */
export type ChatHistoryWhereInput = {
  /** The chat session id field where clause */
  chatSessionsId?: InputMaybe<ChatHistoryWhereChatSessionsIdInput>
  /** The id field where clause */
  id?: InputMaybe<ChatHistoryWhereIdInput>
  /** The uid field where clause */
  userInfoUuid?: InputMaybe<ChatHistoryWhereUserInfoUuidInput>
}

/** Chat history where id input type */
export type ChatHistoryWhereUserInfoUuidInput = {
  /** Is the value equal to the field */
  eq?: InputMaybe<Scalars['ID']['input']>
  /** Are the values in the field */
  in?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>
}

/** Chat session */
export type ChatSession = {
  __typename?: 'ChatSession'
  /** The chat history for this session */
  chatHistory?: Maybe<Array<Maybe<ChatHistory>>>
  /** The date the row was created */
  createdAt?: Maybe<Scalars['DateTime']['output']>
  /** The chat session description */
  description?: Maybe<Scalars['String']['output']>
  /** The chat session id */
  id: Scalars['ID']['output']
  /** The chat session title */
  title?: Maybe<Scalars['String']['output']>
  /** The date the row was last updated */
  updatedAt?: Maybe<Scalars['DateTime']['output']>
  /** The user linked to this chat history */
  userInfo?: Maybe<UserInfo>
  /** The user info uuid */
  userInfoUuid: Scalars['ID']['output']
}

/** Chat session */
export type ChatSessionChatHistoryArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>
  offset?: InputMaybe<Scalars['Int']['input']>
}

/** Chat session create input */
export type ChatSessionCreateInput = {
  /** The chat session description */
  description?: InputMaybe<Scalars['String']['input']>
  /** The chat session title */
  title?: InputMaybe<Scalars['String']['input']>
  /** The user info uuid (defaults to the requesting user) */
  userInfoUuid?: InputMaybe<Scalars['ID']['input']>
}

/** Chat session delete input */
export type ChatSessionDeleteInput = {
  /** The chat session id */
  id: Scalars['ID']['input']
  /** The user info uuid (defaults to the requesting user) */
  userInfoUuid?: InputMaybe<Scalars['ID']['input']>
}

/** Chat session where title group id input type */
export type ChatSessionIdInput = {
  /** Is the value equal to the field */
  eq?: InputMaybe<Scalars['ID']['input']>
  /** Are the values in the field */
  in?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>
}

/** Chat session mutation response */
export type ChatSessionMutationResponse = {
  __typename?: 'ChatSessionMutationResponse'
  /** The deleted chat session */
  chatSession?: Maybe<ChatSession>
  /** When true successfully deleted */
  success?: Maybe<Scalars['Boolean']['output']>
}

/** Chat session update input */
export type ChatSessionUpdateInput = {
  /** The chat session description */
  description?: InputMaybe<Scalars['String']['input']>
  /** The chat session id */
  id: Scalars['ID']['input']
  /** The chat session title */
  title?: InputMaybe<Scalars['String']['input']>
  /** The user info uuid (defaults to the requesting user) */
  userInfoUuid?: InputMaybe<Scalars['ID']['input']>
}

/** Chat session where conditions to filter rows */
export type ChatSessionWhereInput = {
  /** The session id field where clause */
  id?: InputMaybe<ChatSessionIdInput>
  /** The id field where clause */
  userInfoUuid?: InputMaybe<ChatSessionWhereUserInfoUuidInput>
}

/** Chat session where id input type */
export type ChatSessionWhereUserInfoUuidInput = {
  /** Is the value equal to the field */
  eq?: InputMaybe<Scalars['ID']['input']>
  /** Are the values in the field */
  in?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>
}

/** Chat session list response */
export type ChatSessionsListResponse = {
  __typename?: 'ChatSessionsListResponse'
  /** A list of chat sessions */
  chatSessions?: Maybe<Array<Maybe<ChatSession>>>
}

/** Comment type */
export type Comment = {
  __typename?: 'Comment'
  /** The body of the comment */
  comment?: Maybe<Scalars['String']['output']>
  /** The parent comment if this is a reply */
  commentParent?: Maybe<Comment>
  /** The child comments if this is a parent comment */
  commentsChildren?: Maybe<Array<Maybe<Comment>>>
  /** The content linked to this comment */
  content?: Maybe<Array<Maybe<Content>>>
  /** The id of the content */
  contentId?: Maybe<Scalars['Int']['output']>
  /** The type of the content */
  contentType?: Maybe<Scalars['String']['output']>
  /** The date the row was created */
  createdAt?: Maybe<Scalars['DateTime']['output']>
  /** The depth type of the comment */
  depthType?: Maybe<CommentDepthType>
  /** The primary identifier for this record */
  id?: Maybe<Scalars['ID']['output']>
  /** The parent comment id if this comment is a reply */
  pid?: Maybe<Scalars['Int']['output']>
  /** The status of the comment i.e. approved or not approved */
  status?: Maybe<CommentStatus>
  /** The subject (title) of the comment */
  subject?: Maybe<Scalars['String']['output']>
  /** The id of the user or null if anonymous */
  uid?: Maybe<Scalars['Int']['output']>
  /** The date the row was last updated */
  updatedAt?: Maybe<Scalars['DateTime']['output']>
  /** The user info linked to this comment */
  userInfo?: Maybe<UserInfo>
}

/** Comment type */
export type CommentCommentsChildrenArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>
  offset?: InputMaybe<Scalars['Int']['input']>
  order?: InputMaybe<Array<InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>>>
}

/** Content filter for comments */
export type CommentContentFilter = {
  /** The id of the content */
  contentId?: InputMaybe<Scalars['Int']['input']>
  /** The type of the content */
  contentType?: InputMaybe<Scalars['String']['input']>
  /** When true the content must be published */
  published?: InputMaybe<Scalars['Boolean']['input']>
}

/** The depth type of the comment */
export enum CommentDepthType {
  /** The comment is a reply */
  Reply = 'REPLY',
  /** The comment is a root comment */
  Root = 'ROOT',
}

/** Comment status enum */
export enum CommentStatus {
  /** The comment needs review */
  NeedsReview = 'NEEDS_REVIEW',
  /** The comment is published */
  Published = 'PUBLISHED',
  /** The comment is unpublished */
  Unpublished = 'UNPUBLISHED',
}

/** Comment where id input type */
export type CommentWhereIdInput = {
  /** Is the value equal to the field */
  eq?: InputMaybe<Scalars['ID']['input']>
  /** Is the value greater than to the field */
  gt?: InputMaybe<Scalars['ID']['input']>
  /** Is the value greater than or equal to the field */
  gte?: InputMaybe<Scalars['ID']['input']>
  /** Are the values in the field */
  in?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>
  /** Is the value less than to the field */
  lt?: InputMaybe<Scalars['ID']['input']>
  /** Is the value less than or equal to the field */
  lte?: InputMaybe<Scalars['ID']['input']>
}

/** Comment where conditions to filter rows */
export type CommentWhereInput = {
  /** The id field where clause */
  id?: InputMaybe<CommentWhereIdInput>
  /** The parent id field where clause */
  pid?: InputMaybe<CommentWhereIdInput>
  /** The status field where clause */
  status?: InputMaybe<CommentWhereIdInput>
  /** The uid field where clause */
  uid?: InputMaybe<CommentWhereUidInput>
}

/** Comment where uid input type */
export type CommentWhereUidInput = {
  /** Is the value equal to the field */
  eq?: InputMaybe<Scalars['ID']['input']>
  /** Is the value greater than to the field */
  gt?: InputMaybe<Scalars['ID']['input']>
  /** Is the value greater than or equal to the field */
  gte?: InputMaybe<Scalars['ID']['input']>
  /** Are the values in the field */
  in?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>
  /** Is the value less than to the field */
  lt?: InputMaybe<Scalars['ID']['input']>
  /** Is the value less than or equal to the field */
  lte?: InputMaybe<Scalars['ID']['input']>
}

/** Comment list response */
export type CommentsListResponse = {
  __typename?: 'CommentsListResponse'
  /** A list of comments */
  comments?: Maybe<Array<Maybe<Comment>>>
  /** The total number of comments matching the query */
  count?: Maybe<Scalars['Int']['output']>
  /** The limit used in the query */
  limit?: Maybe<Scalars['Int']['output']>
  /** The offset used in the query */
  offset?: Maybe<Scalars['Int']['output']>
}

/** Community comment type */
export type CommunityComment = {
  __typename?: 'CommunityComment'
  /** The author's user ID */
  authorId?: Maybe<Scalars['ID']['output']>
  /** The comment content */
  content?: Maybe<Scalars['String']['output']>
  /** When the comment was created */
  createdAt?: Maybe<Scalars['DateTime']['output']>
  /** The unique identifier for the comment */
  id: Scalars['ID']['output']
  /** The parent comment ID if this is a reply */
  parentId?: Maybe<Scalars['ID']['output']>
  /** The post ID this comment belongs to */
  postId: Scalars['ID']['output']
}

/** Community event type */
export type CommunityEvent = {
  __typename?: 'CommunityEvent'
  /** The event capacity */
  capacity?: Maybe<Scalars['Int']['output']>
  /** The event description */
  description?: Maybe<Scalars['String']['output']>
  /** When the event ends */
  endTime?: Maybe<Scalars['DateTime']['output']>
  /** The unique identifier for the event */
  id: Scalars['ID']['output']
  /** The location type (e.g., 'online', 'in-person') */
  locationType?: Maybe<Scalars['String']['output']>
  /** The number of registrations */
  registrationsCount?: Maybe<Scalars['Int']['output']>
  /** The space ID this event belongs to */
  spaceId: Scalars['ID']['output']
  /** When the event starts */
  startTime?: Maybe<Scalars['DateTime']['output']>
  /** The event title */
  title?: Maybe<Scalars['String']['output']>
}

/** Community post type */
export type CommunityPost = {
  __typename?: 'CommunityPost'
  /** The author's user ID */
  authorId?: Maybe<Scalars['ID']['output']>
  /** The post content */
  content?: Maybe<Scalars['String']['output']>
  /** When the post was created */
  createdAt?: Maybe<Scalars['DateTime']['output']>
  /** The unique identifier for the post */
  id: Scalars['ID']['output']
  /** The space ID this post belongs to */
  spaceId?: Maybe<Scalars['ID']['output']>
  /** The post status */
  status?: Maybe<Scalars['String']['output']>
  /** The post title */
  title?: Maybe<Scalars['String']['output']>
  /** When the post was last updated */
  updatedAt?: Maybe<Scalars['DateTime']['output']>
}

/** Community reaction type */
export type CommunityReaction = {
  __typename?: 'CommunityReaction'
  /** The author's user ID */
  authorId?: Maybe<Scalars['ID']['output']>
  /** When the reaction was created */
  createdAt?: Maybe<Scalars['DateTime']['output']>
  /** The unique identifier for the reaction */
  id: Scalars['ID']['output']
  /** The post ID this reaction belongs to */
  postId: Scalars['ID']['output']
  /** The reaction emoji */
  reaction: Scalars['String']['output']
}

/** Community space type */
export type CommunitySpace = {
  __typename?: 'CommunitySpace'
  /** When the space was created */
  createdAt?: Maybe<Scalars['DateTime']['output']>
  /** The description of the space */
  description?: Maybe<Scalars['String']['output']>
  /** The unique identifier for the space */
  id: Scalars['ID']['output']
  /** Whether the space is invite-only */
  inviteOnly?: Maybe<Scalars['Boolean']['output']>
  /** Whether the space is private */
  isPrivate?: Maybe<Scalars['Boolean']['output']>
  /** The number of members in the space */
  memberCount?: Maybe<Scalars['Int']['output']>
  /** The display name of the space */
  name?: Maybe<Scalars['String']['output']>
}

/** Content entity from federated content service */
export type Content = {
  __typename?: 'Content'
  /** The assets description */
  assetsDescription?: Maybe<Scalars['String']['output']>
  /** The assets label */
  assetsLabel?: Maybe<Scalars['String']['output']>
  /** Bundle for a tag, (d6 vocabulary vid) */
  bundle?: Maybe<Scalars['String']['output']>
  /** The cast in the video */
  cast?: Maybe<Scalars['String']['output']>
  /** The content analytic linked to this content */
  contentAnalytic?: Maybe<ContentAnalytic>
  /** Content asset references linked to this content */
  contentAssetReferences?: Maybe<Array<Maybe<ContentAssetReference>>>
  /** The content document linked to this content */
  contentDocument?: Maybe<ContentDocument>
  /** The content references linked to this content */
  contentDocumentAggregate?: Maybe<ContentDocumentAggregate>
  /** Content linked to this content as an episode which have a default order of seasonNumber and then episodeNumber */
  contentEpisodes?: Maybe<Array<Maybe<Content>>>
  /** Content featured for this content */
  contentFeatured?: Maybe<ContentFeatured>
  /** The content filter set to display for this content */
  contentFilterSet?: Maybe<ContentFilterSet>
  /**
   * The content group identifier (NOT the primary key - do not confuse with id).
   * Also known as D6 nid. All translations of the same content share the same contentId.
   *
   * IMPORTANT: contentId is NOT useful without contentType. Always use contentId + contentType together
   * (and optionally language) to uniquely identify content. Use contentId + contentType + language to
   * uniquely identify a specific language version.
   *
   * NOTE: id is the primary key and is preferred for direct lookups. contentId + contentType is used for grouping translations.
   */
  contentId?: Maybe<Scalars['Int']['output']>
  /**
   * The content policy linked to this content that controls access, sharing, and availability.
   * Use contentPolicy.accessCheck to determine if the current user can access this content.
   */
  contentPolicy?: Maybe<ContentPolicy>
  /**
   * A reference to the content policy that controls access, sharing, and availability rules for this content.
   * The content policy determines which users can access the content based on subscriptions, countries,
   * client attributes, and other access control rules.
   */
  contentPolicyPolicyId?: Maybe<Scalars['Int']['output']>
  /** The content provider linked to this content */
  contentProvider?: Maybe<ContentProvider>
  /** The content references linked both to and from this content */
  contentReferences?: Maybe<Array<Maybe<ContentReference>>>
  /** The content references link from this content */
  contentReferencesFrom?: Maybe<Array<Maybe<ContentReference>>>
  /** The content references linked to this content */
  contentReferencesTo?: Maybe<Array<Maybe<ContentReference>>>
  /**
   * Content related to this content which defaults to video.
   * When using this query consider using @defer or multiple GraphQL queries
   * in an application for performance
   */
  contentRelated?: Maybe<Array<Maybe<Content>>>
  /** When true the content will be visible in content search */
  contentSearchNoIndex?: Maybe<Scalars['Boolean']['output']>
  /** Content linked to this content as a series */
  contentSeries?: Maybe<Array<Maybe<Content>>>
  /** The content type which can be expanded in the future i.e. video or series */
  contentType?: Maybe<Scalars['String']['output']>
  /** The copyright date as text */
  copyright?: Maybe<Scalars['String']['output']>
  /** Get course item progress for this content (if it is a video in a course) */
  courseItemProgress?: Maybe<UserStateProgressCourseItem>
  /** Get course module progress for this content (if it is a course module) */
  courseModuleProgress?: Maybe<UserStateProgressCourseModule>
  /** Get course progress for this content (if it is a course) */
  courseProgress?: Maybe<UserStateProgressCourse>
  /** The date the row was created */
  createdAt?: Maybe<Scalars['DateTime']['output']>
  /** the deeplink path on the gaia app where the promoted item lives */
  ctaDeeplinkPath?: Maybe<Scalars['String']['output']>
  /** the call to action label */
  ctaLabel?: Maybe<Scalars['String']['output']>
  /** the path on the gaia web app where the promoted item lives */
  ctaPath?: Maybe<Scalars['String']['output']>
  /** The url to purchase the product */
  ctaProductUrl?: Maybe<Scalars['String']['output']>
  /** The day number */
  dayNumber?: Maybe<Scalars['Int']['output']>
  /** The description in the given language */
  description?: Maybe<Scalars['String']['output']>
  /** The format of the long description (null = plain text) */
  descriptionFormat?: Maybe<Scalars['String']['output']>
  /** The directions description */
  directionsDescription?: Maybe<Scalars['String']['output']>
  /** The directions label */
  directionsLabel?: Maybe<Scalars['String']['output']>
  /** The name of the directory of the video */
  director?: Maybe<Scalars['String']['output']>
  /** The display type to be used in UI rendering */
  displayType?: Maybe<Scalars['String']['output']>
  /** The series season episode number */
  episodeNumber?: Maybe<Scalars['Int']['output']>
  /** Get a count of all episodes linked to this content */
  episodesCount?: Maybe<Scalars['Int']['output']>
  /** When true the content will be excluded from recommendations */
  excludeFromRecommendations?: Maybe<Scalars['Boolean']['output']>
  /** If true the content is family friendly */
  familyFriendly?: Maybe<Scalars['Boolean']['output']>
  /** The feature media for this content */
  featureMedia?: Maybe<Media>
  /** The foreign key to the media table to the feature media */
  featureMediaId?: Maybe<Scalars['ID']['output']>
  /** Optional filter type to include this content as a filter option */
  filterType?: Maybe<Scalars['String']['output']>
  /** The primary identifier for this content record */
  id?: Maybe<Scalars['ID']['output']>
  /** Image content relationships linked to this content */
  imageContentRelationships?: Maybe<Array<Maybe<ImageContentRelationship>>>
  /** The name of the instructor in the video */
  instructor?: Maybe<Scalars['String']['output']>
  /** When true the content is considered new by published at or created at */
  isNew?: Maybe<Scalars['Boolean']['output']>
  /** The language of this content */
  language?: Maybe<Scalars['String']['output']>
  /** The language of this content in full text e.g. English */
  languageFullText?: Maybe<Scalars['String']['output']>
  /** The path part of a url which matches this content */
  path?: Maybe<Scalars['String']['output']>
  /** The path redirect by source linked to this content by path */
  pathRedirectBySource?: Maybe<PathRedirect>
  /** PM people list */
  peopleListId?: Maybe<Scalars['String']['output']>
  /** The requesting user playlist items for this content */
  playlistItems?: Maybe<Array<Maybe<PlaylistItem>>>
  /** The preview media for this content */
  previewMedia?: Maybe<Media>
  /** The foreign key to the media table to the preview media */
  previewMediaId?: Maybe<Scalars['ID']['output']>
  /** The language of content that was used to create all of the translations */
  primaryLanguage?: Maybe<Scalars['String']['output']>
  /** The name of producer of the video */
  producer?: Maybe<Scalars['String']['output']>
  /** The product type identifier in UI rendering */
  productType?: Maybe<Scalars['String']['output']>
  /** The production status */
  productionStatus?: Maybe<Scalars['String']['output']>
  /**
   * Published state of the content. IMPORTANT: Content that is not published (published=false) should NEVER be accessible to end users.
   *
   * Published State Meanings:
   * - published=false: Content is NOT published and should NEVER be accessible. This content is hidden from all public access.
   * - published=true + publishedAtDate is in the future: Content is published but NOT YET playable. It can be discovered in search/browse but cannot be played until publishedAtDate is reached.
   * - published=true + publishedAtDate is now or in the past: Content is published AND playable (PUBLISHED_NOW state). This is the only state where content can be fully accessed and played.
   *
   * Use publishedState filter (PUBLISHED_NOW) to get only playable content, or published=true to get all discoverable content (including future-dated).
   */
  published?: Maybe<Scalars['Boolean']['output']>
  /**
   * The date and time when the content becomes playable. Used in combination with published field:
   * - If published=true and publishedAtDate is in the future: Content is discoverable but not playable
   * - If published=true and publishedAtDate is now or in the past: Content is playable (PUBLISHED_NOW)
   * - If published=false: Content is not accessible regardless of publishedAtDate
   */
  publishedAtDate?: Maybe<Scalars['DateTime']['output']>
  /** When performing a search query the relevance score */
  queryRelevanceScore?: Maybe<Scalars['Float']['output']>
  /** The content references linked from this content which is useful in an apps when displaying categories, tags, topics, etc. */
  references?: Maybe<Array<Maybe<ContentReference>>>
  /** The content references linked from this content which are considered tags useful in an apps when displaying tags */
  referencesByTypeTag?: Maybe<Array<Maybe<ContentReference>>>
  /** Document embeddings related to this content directly or by feature media */
  relatedDocumentEmbeddings?: Maybe<ContentRelatedDocumentEmbeddings>
  /** The series season number */
  seasonNumber?: Maybe<Scalars['Int']['output']>
  /** Get a count of all seasons linked to this content */
  seasonsCount?: Maybe<Scalars['Int']['output']>
  /** The SEO canonical url */
  seoCanonicalUrl?: Maybe<Scalars['String']['output']>
  /** The SEO short description in the given language */
  seoDescription?: Maybe<Scalars['String']['output']>
  /** The SEO keywords in the given language */
  seoKeywords?: Maybe<Scalars['String']['output']>
  /** The SEO no follow attribute */
  seoRobotsNoFollow?: Maybe<Scalars['Boolean']['output']>
  /** The SEO no index attribute */
  seoRobotsNoIndex?: Maybe<Scalars['Boolean']['output']>
  /** The SEO title of this video in the given language */
  seoTitle?: Maybe<Scalars['String']['output']>
  /** The share URL for this content, constructed based on content policy shareAllowed setting */
  shareUrl?: Maybe<Scalars['String']['output']>
  /** The short description in the given language */
  shortDescription?: Maybe<Scalars['String']['output']>
  /** The format of the long description (null = plain text) */
  shortDescriptionFormat?: Maybe<Scalars['String']['output']>
  /** The studio where the video was filmed */
  studio?: Maybe<Scalars['String']['output']>
  /** The content sub type used by apps for rendering (not useful in other contexts) */
  subType?: Maybe<Scalars['String']['output']>
  /** The third party description in the given language */
  thirdPartyDescription?: Maybe<Scalars['String']['output']>
  /** The title of this video in the given language */
  title?: Maybe<Scalars['String']['output']>
  /**
   * A human-readable identifier that groups all translations of the same content together.
   * Format: "{contentId}-{contentType}" (e.g., "123-video").
   * All language versions of the same content share the same titleGroupId.
   * Use this field to query for all translations of a piece of content or to group content by title.
   */
  titleGroupId?: Maybe<Scalars['String']['output']>
  /**
   * A human-readable identifier that uniquely identifies a specific language version of content.
   * Format: "{contentId}-{contentType}-{language}" (e.g., "123-video-en").
   * This is globally unique across all content - each language version has a unique titleId.
   *
   * NOTE: contentId is PREFERRED over titleId for querying and programmatic access.
   * Use contentId + contentType + language instead when possible.
   */
  titleId?: Maybe<Scalars['String']['output']>
  /** The date the content was unpublished (when published was changed from true to false) */
  unpublishedAt?: Maybe<Scalars['DateTime']['output']>
  /** The date the row was last updated */
  updatedAt?: Maybe<Scalars['DateTime']['output']>
  /** The requesting user latest vote for this content */
  vote?: Maybe<Vote>
  /** The weight when ordering in lists */
  weight?: Maybe<Scalars['Int']['output']>
  /** The name of the video */
  writer?: Maybe<Scalars['String']['output']>
}

/** Content entity from federated content service */
export type ContentContentAssetReferencesArgs = {
  contentAssetReferences?: InputMaybe<Array<InputMaybe<ContentAssetReferenceFilterInput>>>
  limit?: InputMaybe<Scalars['Int']['input']>
  offset?: InputMaybe<Scalars['Int']['input']>
}

/** Content entity from federated content service */
export type ContentContentEpisodesArgs = {
  applyContentPolicy?: InputMaybe<Scalars['Boolean']['input']>
  content?: InputMaybe<Array<InputMaybe<ContentFilterInput>>>
  language?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  limit?: InputMaybe<Scalars['Int']['input']>
  offset?: InputMaybe<Scalars['Int']['input']>
  seasonNumber?: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>
}

/** Content entity from federated content service */
export type ContentContentFeaturedArgs = {
  applyContentPolicy?: InputMaybe<Scalars['Boolean']['input']>
  content?: InputMaybe<Array<InputMaybe<ContentFilterInput>>>
  language?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  limit?: InputMaybe<Scalars['Int']['input']>
  offset?: InputMaybe<Scalars['Int']['input']>
}

/** Content entity from federated content service */
export type ContentContentReferencesArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>
  offset?: InputMaybe<Scalars['Int']['input']>
  types?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
}

/** Content entity from federated content service */
export type ContentContentReferencesFromArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>
  offset?: InputMaybe<Scalars['Int']['input']>
  types?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
}

/** Content entity from federated content service */
export type ContentContentReferencesToArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>
  offset?: InputMaybe<Scalars['Int']['input']>
  types?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
}

/** Content entity from federated content service */
export type ContentContentRelatedArgs = {
  applyContentPolicy?: InputMaybe<Scalars['Boolean']['input']>
  content?: InputMaybe<Array<InputMaybe<ContentFilterInput>>>
  language?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  limit?: InputMaybe<Scalars['Int']['input']>
  offset?: InputMaybe<Scalars['Int']['input']>
  type?: InputMaybe<ContentRelatedType>
}

/** Content entity from federated content service */
export type ContentContentSeriesArgs = {
  applyContentPolicy?: InputMaybe<Scalars['Boolean']['input']>
  content?: InputMaybe<Array<InputMaybe<ContentFilterInput>>>
  language?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
}

/** Content entity from federated content service */
export type ContentCourseItemProgressArgs = {
  courseTitleGroupId: Scalars['String']['input']
}

/** Content entity from federated content service */
export type ContentCourseModuleProgressArgs = {
  courseTitleGroupId: Scalars['String']['input']
}

/** Content entity from federated content service */
export type ContentDescriptionArgs = {
  format?: InputMaybe<ContentTextFormat>
  truncate?: InputMaybe<Scalars['Int']['input']>
}

/** Content entity from federated content service */
export type ContentEpisodesCountArgs = {
  applyContentPolicy?: InputMaybe<Scalars['Boolean']['input']>
  content?: InputMaybe<Array<InputMaybe<ContentFilterInput>>>
  language?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  seasonNumber?: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>
}

/** Content entity from federated content service */
export type ContentImageContentRelationshipsArgs = {
  imageContentRelationships?: InputMaybe<
    Array<InputMaybe<ContentImageContentRelationshipsFilterInput>>
  >
  language?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  types?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
}

/** Content entity from federated content service */
export type ContentReferencesArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>
  offset?: InputMaybe<Scalars['Int']['input']>
  types?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  typesByTypeTag?: InputMaybe<Scalars['Boolean']['input']>
}

/** Content entity from federated content service */
export type ContentRelatedDocumentEmbeddingsArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>
  offset?: InputMaybe<Scalars['Int']['input']>
  query?: InputMaybe<Scalars['String']['input']>
}

/** Content entity from federated content service */
export type ContentSeasonsCountArgs = {
  applyContentPolicy?: InputMaybe<Scalars['Boolean']['input']>
  content?: InputMaybe<Array<InputMaybe<ContentFilterInput>>>
  language?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
}

/** Content entity from federated content service */
export type ContentShortDescriptionArgs = {
  format?: InputMaybe<ContentTextFormat>
  truncate?: InputMaybe<Scalars['Int']['input']>
}

/** Content analytic */
export type ContentAnalytic = {
  __typename?: 'ContentAnalytic'
  /** The total number of comments for this content */
  commentsCountTotal?: Maybe<Scalars['Int']['output']>
  /** The content linked to this content analytic */
  content?: Maybe<Array<Maybe<Content>>>
  /** The content id for the content this analytics row */
  contentId?: Maybe<Scalars['Int']['output']>
  /** The content type for the content this analytics row */
  contentType?: Maybe<Scalars['String']['output']>
  /** One day video play count for the content */
  count1Day?: Maybe<Scalars['Int']['output']>
  /** Three day video play count for the content */
  count3Day?: Maybe<Scalars['Int']['output']>
  /** seven day video play count for the content */
  count7Day?: Maybe<Scalars['Int']['output']>
  /** 7 day share count for German content */
  countShares7dDe?: Maybe<Scalars['Int']['output']>
  /** 7 day share count for English content */
  countShares7dEn?: Maybe<Scalars['Int']['output']>
  /** 7 day share count for Spanish content */
  countShares7dEs?: Maybe<Scalars['Int']['output']>
  /** 7 day share count for French content */
  countShares7dFr?: Maybe<Scalars['Int']['output']>
  /** rolling 7 day share count for German content */
  countSharesDailyDe?: Maybe<Array<Maybe<Scalars['Int']['output']>>>
  /** rolling 7 day share count for English content */
  countSharesDailyEn?: Maybe<Array<Maybe<Scalars['Int']['output']>>>
  /** rolling 7 day share count for Spanish content */
  countSharesDailyEs?: Maybe<Array<Maybe<Scalars['Int']['output']>>>
  /** rolling 7 day share count for French content */
  countSharesDailyFr?: Maybe<Array<Maybe<Scalars['Int']['output']>>>
  /** forever video play count for the content */
  countTotal?: Maybe<Scalars['Int']['output']>
  /** Three day video play count for German content */
  count_3d_de?: Maybe<Scalars['Int']['output']>
  /** Three day video play count for English content */
  count_3d_en?: Maybe<Scalars['Int']['output']>
  /** Three day video play count for Spanish content */
  count_3d_es?: Maybe<Scalars['Int']['output']>
  /** Three day video play count for French content */
  count_3d_fr?: Maybe<Scalars['Int']['output']>
  /** Seven day video play count for German content */
  count_7d_de?: Maybe<Scalars['Int']['output']>
  /** Seven day video play count for English content */
  count_7d_en?: Maybe<Scalars['Int']['output']>
  /** Seven day video play count for Spanish content */
  count_7d_es?: Maybe<Scalars['Int']['output']>
  /** Seven day video play count for French content */
  count_7d_fr?: Maybe<Scalars['Int']['output']>
  /** The date the row was created */
  createdAt?: Maybe<Scalars['DateTime']['output']>
  /** The primary identifier for this record */
  id?: Maybe<Scalars['ID']['output']>
  /** daily counts for all languages (plus combined 'all') */
  languageCounts?: Maybe<Scalars['JSON']['output']>
  /** A human readable id that is identifies the content in a title group */
  titleGroupId?: Maybe<Scalars['String']['output']>
  /** The date the row was last updated */
  updatedAt?: Maybe<Scalars['DateTime']['output']>
  /** The total number of votes for this content */
  votesCountTotal?: Maybe<Scalars['Int']['output']>
  /** The total number of up votes for this content */
  votesUpCountTotal?: Maybe<Scalars['Int']['output']>
}

/** Content analytic where id input type */
export type ContentAnalyticWhereIdInput = {
  /** Is the value equal to the field */
  eq?: InputMaybe<Scalars['ID']['input']>
  /** Is the value greater than to the field */
  gt?: InputMaybe<Scalars['ID']['input']>
  /** Is the value greater than or equal to the field */
  gte?: InputMaybe<Scalars['ID']['input']>
  /** Are the values in the field */
  in?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>
}

/** Content analytic where conditions to filter rows */
export type ContentAnalyticWhereInput = {
  /** The id field where clause */
  id?: InputMaybe<ContentAnalyticWhereIdInput>
  /** The title group id field where clause */
  titleGroupId?: InputMaybe<ContentAnalyticWhereTitleGroupIdInput>
}

/** Content analytic where title group id input type */
export type ContentAnalyticWhereTitleGroupIdInput = {
  /** Is the value equal to the field */
  eq?: InputMaybe<Scalars['ID']['input']>
  /** Are the values in the field */
  in?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>
}

/** Content analytic list response */
export type ContentAnalyticsListResponse = {
  __typename?: 'ContentAnalyticsListResponse'
  /** A list of Content analytic */
  contentAnalytics?: Maybe<Array<Maybe<ContentAnalytic>>>
}

/** ContentAssetReference */
export type ContentAssetReference = {
  __typename?: 'ContentAssetReference'
  /** The asset linked to the content asset reference */
  asset?: Maybe<Asset>
  /** The asset id foreign key */
  assetsId?: Maybe<Scalars['ID']['output']>
  /** The content list linked to the content asset reference */
  content?: Maybe<Array<Maybe<Content>>>
  /** The content asset reference type directly linked to this content asset reference */
  contentAssetReferenceType?: Maybe<ContentAssetReferenceType>
  /** The content asset reference types id foreign key */
  contentAssetReferenceTypesId?: Maybe<Scalars['ID']['output']>
  /** The content contentTitleGroupId foreign key */
  contentTitleGroupId?: Maybe<Scalars['String']['output']>
  /** The date the row was created */
  createdAt?: Maybe<Scalars['DateTime']['output']>
  /** The primary identifier for this record */
  id?: Maybe<Scalars['ID']['output']>
  /** The date the row was last updated */
  updatedAt?: Maybe<Scalars['DateTime']['output']>
}

/** ContentAssetReference */
export type ContentAssetReferenceAssetArgs = {
  filter?: InputMaybe<AssetFilterInput>
}

/** ContentAssetReference */
export type ContentAssetReferenceContentArgs = {
  content?: InputMaybe<Array<InputMaybe<ContentFilterInput>>>
}

/** Input type for creating a new content asset reference */
export type ContentAssetReferenceCreateInput = {
  /** The assets_id of the asset */
  assetsId: Scalars['ID']['input']
  /** The content_asset_reference_types_id of the content asset reference type */
  contentAssetReferenceTypesId: Scalars['ID']['input']
  /** The content_title_group_id of the content title group */
  contentTitleGroupId: Scalars['ID']['input']
  /** The primary key (optional) */
  id?: InputMaybe<Scalars['ID']['input']>
}

/** Input type for deleting an existing content asset reference */
export type ContentAssetReferenceDeleteInput = {
  /** The primary key of the content asset reference to delete */
  id: Scalars['ID']['input']
}

export type ContentAssetReferenceFilterInput = {
  /** The content asset reference types id foreign key */
  contentAssetReferenceTypesId?: InputMaybe<Scalars['ID']['input']>
  /** The content contentTitleGroupId foreign key */
  contentTitleGroupId?: InputMaybe<Scalars['String']['input']>
  /** The content asset reference type */
  type?: InputMaybe<Scalars['String']['input']>
}

/** Response object containing a boolean property of success and the created/deleted content asset reference */
export type ContentAssetReferenceMutationResponse = {
  __typename?: 'ContentAssetReferenceMutationResponse'
  /** The created or deleted content asset reference */
  contentAssetReference?: Maybe<ContentAssetReference>
  /** A boolean property of success indicating whether the operation was successful */
  success: Scalars['Boolean']['output']
}

/** ContentAssetReferenceType */
export type ContentAssetReferenceType = {
  __typename?: 'ContentAssetReferenceType'
  /** The date the row was created */
  createdAt?: Maybe<Scalars['DateTime']['output']>
  /** The primary identifier for this record */
  id?: Maybe<Scalars['ID']['output']>
  /** The content asset reference type */
  type?: Maybe<Scalars['ID']['output']>
  /** The date the row was last updated */
  updatedAt?: Maybe<Scalars['DateTime']['output']>
}

/** ContentAssetReferenceType where id input */
export type ContentAssetReferenceTypeWhereIdInput = {
  /** Is the value equal to the field */
  eq?: InputMaybe<Scalars['ID']['input']>
  /** Is the value greater than to the field */
  gt?: InputMaybe<Scalars['ID']['input']>
  /** Is the value greater than or equal to the field */
  gte?: InputMaybe<Scalars['ID']['input']>
  /** Are the values in the field */
  in?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>
  /** Is the value less than to the field */
  lt?: InputMaybe<Scalars['ID']['input']>
  /** Is the value less than or equal to the field */
  lte?: InputMaybe<Scalars['ID']['input']>
}

/** ContentAssetReferenceType where input */
export type ContentAssetReferenceTypeWhereInput = {
  /** ContentAssetReferenceType where id clause */
  id?: InputMaybe<ContentAssetReferenceTypeWhereIdInput>
}

/** ContentAssetReferenceTypes list response */
export type ContentAssetReferenceTypesListResponse = {
  __typename?: 'ContentAssetReferenceTypesListResponse'
  /** A list of assets */
  contentAssetReferenceTypes?: Maybe<Array<Maybe<ContentAssetReferenceType>>>
}

/** ContentAssetReference where id input */
export type ContentAssetReferenceWhereIdInput = {
  /** Is the value equal to the field */
  eq?: InputMaybe<Scalars['ID']['input']>
  /** Is the value greater than to the field */
  gt?: InputMaybe<Scalars['ID']['input']>
  /** Is the value greater than or equal to the field */
  gte?: InputMaybe<Scalars['ID']['input']>
  /** Are the values in the field */
  in?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>
  /** Is the value less than to the field */
  lt?: InputMaybe<Scalars['ID']['input']>
  /** Is the value less than or equal to the field */
  lte?: InputMaybe<Scalars['ID']['input']>
}

/** ContentAssetReference where input */
export type ContentAssetReferenceWhereInput = {
  /** ContentAssetReference where id clause */
  id?: InputMaybe<ContentAssetReferenceWhereIdInput>
}

/** ContentAssetReferences list response */
export type ContentAssetReferencesListResponse = {
  __typename?: 'ContentAssetReferencesListResponse'
  /** A list of assets */
  contentAssetReferences?: Maybe<Array<Maybe<ContentAssetReference>>>
}

/** Content content provider filter input */
export type ContentContentProviderFilterInput = {
  /** The content provider */
  provider?: InputMaybe<ContentProviderProviders>
  /** The content provider key for this content */
  providerKey?: InputMaybe<Scalars['String']['input']>
}

/** Content content references from filter input */
export type ContentContentReferencesFromFilterInput = {
  /** The content id */
  contentId?: InputMaybe<Scalars['Int']['input']>
  /** The content type */
  contentType?: InputMaybe<Scalars['String']['input']>
  /** The content reference type */
  type?: InputMaybe<Scalars['String']['input']>
}

/** Content content references to filter input */
export type ContentContentReferencesToFilterInput = {
  /** The content id */
  contentId?: InputMaybe<Scalars['Int']['input']>
  /** The content type */
  contentType?: InputMaybe<Scalars['String']['input']>
  /** The content reference type */
  type?: InputMaybe<Scalars['String']['input']>
}

/** Content document row that links content to a document */
export type ContentDocument = {
  __typename?: 'ContentDocument'
  /** Content linked to this content document */
  content?: Maybe<Content>
  /** The content references link to this content */
  contentDocumentAggregate?: Maybe<ContentDocumentAggregate>
  /** The content id */
  contentId?: Maybe<Scalars['ID']['output']>
  /** The date the row was created */
  createdAt?: Maybe<Scalars['DateTime']['output']>
  /** Document linked to this content document */
  document?: Maybe<Document>
  /** The documents id */
  documentsId?: Maybe<Scalars['ID']['output']>
  /** The date the row was last updated */
  updatedAt?: Maybe<Scalars['DateTime']['output']>
}

/** Content document row that links content to a document */
export type ContentDocumentAggregate = {
  __typename?: 'ContentDocumentAggregate'
  /** The embedding average of all the document embeddings for this content */
  averageEmbedding?: Maybe<Array<Maybe<Scalars['Float']['output']>>>
  /** Content linked to this content document aggregate */
  content?: Maybe<Content>
  /** The content id */
  contentId?: Maybe<Scalars['ID']['output']>
  /** The date the row was created */
  createdAt?: Maybe<Scalars['DateTime']['output']>
  /** A SHA256 hash of all of the document_embedding columns to determine if the sum and average should be recalculated */
  documentEmbeddingsHash?: Maybe<Scalars['String']['output']>
  /** The language of the content document aggregates */
  language?: Maybe<Scalars['String']['output']>
  /** The document relevance to the query */
  queryRelevance?: Maybe<Scalars['Float']['output']>
  /** Content document aggregates similar to this one based on cosine similarity */
  similarContentDocumentAggregates?: Maybe<Array<Maybe<ContentDocumentAggregate>>>
  /** The embedding sum of all the document embeddings for this content */
  sumEmbedding?: Maybe<Array<Maybe<Scalars['Float']['output']>>>
  /** The date the row was last updated */
  updatedAt?: Maybe<Scalars['DateTime']['output']>
}

/** Content document row that links content to a document */
export type ContentDocumentAggregateSimilarContentDocumentAggregatesArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>
  offset?: InputMaybe<Scalars['Int']['input']>
}

/** GraphQL content document aggregate where id input */
export type ContentDocumentAggregateWhereContentIdInput = {
  /** Is the value equal to the field */
  eq?: InputMaybe<Scalars['ID']['input']>
  /** Is the value greater than to the field */
  gt?: InputMaybe<Scalars['ID']['input']>
  /** Is the value greater than or equal to the field */
  gte?: InputMaybe<Scalars['ID']['input']>
  /** Is the value less than to the field */
  lt?: InputMaybe<Scalars['ID']['input']>
  /** Is the value less than or equal to the field */
  lte?: InputMaybe<Scalars['ID']['input']>
}

/** GraphQL content document aggregate where language input */
export type ContentDocumentAggregateWhereContentLanguageInput = {
  /** Is the value equal to the field */
  eq?: InputMaybe<Scalars['String']['input']>
}

/** The document emebdding where input */
export type ContentDocumentAggregateWhereInput = {
  /** The content id field where clause */
  contentId?: InputMaybe<ContentDocumentAggregateWhereContentIdInput>
  /** The language of the content document aggregates */
  language?: InputMaybe<ContentDocumentAggregateWhereContentLanguageInput>
}

/** Documents list response */
export type ContentDocumentAggregatesList = {
  __typename?: 'ContentDocumentAggregatesList'
  /** Documents */
  contentDocumentAggregates?: Maybe<Array<Maybe<ContentDocumentAggregate>>>
  /** Total number of rows of content found (uses a slower count query for list) */
  count?: Maybe<Scalars['Int']['output']>
  /** The limit applied to the rows */
  limit?: Maybe<Scalars['Int']['output']>
  /** The offset applied to the rows */
  offset?: Maybe<Scalars['Int']['output']>
}

/** Content featured */
export type ContentFeatured = {
  __typename?: 'ContentFeatured'
  /** The featured content */
  content?: Maybe<Content>
  /** The content type e.g. first, last, or continue */
  featuredType?: Maybe<Scalars['String']['output']>
}

/** Content filter */
export type ContentFilter = {
  __typename?: 'ContentFilter'
  content?: Maybe<Array<Maybe<Content>>>
  /** The content filter set linked to this content filter */
  contentFilterSet?: Maybe<ContentFilterSet>
  /** The content_id field on the content table */
  contentId?: Maybe<Scalars['String']['output']>
  /** The content reference type */
  contentReferenceType?: Maybe<ContentReferenceType>
  /** A foreign key to the content_reference_types which defines the relationship between the parent and the child content */
  contentReferenceTypesId?: Maybe<Scalars['ID']['output']>
  /** The content_type field on the content table */
  contentType?: Maybe<Scalars['String']['output']>
  /** When the row was created */
  createdAt?: Maybe<Scalars['DateTime']['output']>
  /** The filter set to which this filter belongs */
  filterSet?: Maybe<Scalars['String']['output']>
  /** The filter type to which this filter belongs */
  filterType?: Maybe<Scalars['String']['output']>
  /** The primary key for this record */
  id?: Maybe<Scalars['ID']['output']>
  /** A human readable id that is identifies the content in a title group */
  titleGroupId?: Maybe<Scalars['String']['output']>
  /** When the row was last updated */
  updatedAt?: Maybe<Scalars['DateTime']['output']>
}

/** Content filter */
export type ContentFilterContentArgs = {
  language?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
}

/**
 * The content filter for associated content.
 *
 * IMPORTANT: Published state filtering:
 * - published=true: Returns content that is discoverable (may include future-dated content that's not yet playable)
 * - published=false: Should NEVER be used in production queries - unpublished content should never be accessible
 * - publishedState=PUBLISHED_NOW: Returns only playable content (published=true AND publishedAtDate is now or in past)
 * - publishedState=PUBLISHED: Returns all discoverable content (published=true, regardless of publishedAtDate)
 *
 * For playable content, always use publishedState=PUBLISHED_NOW or ensure published=true AND publishedAtDate is in the past.
 */
export type ContentFilterInput = {
  /** The content content id */
  contentId?: InputMaybe<Scalars['Int']['input']>
  /** The content content type */
  contentType?: InputMaybe<Scalars['String']['input']>
  /** The content language */
  language?: InputMaybe<Scalars['String']['input']>
  /**
   * The content published state (does not consider published at date - see publishedState for date-aware filtering).
   * WARNING: published=false should NEVER be accessible to end users. Use publishedState filter instead.
   */
  published?: InputMaybe<Scalars['Boolean']['input']>
  /**
   * Alias for various content published states that considers both published flag and publishedAtDate.
   * Use PUBLISHED_NOW to get only playable content, or PUBLISHED to get all discoverable content (including future-dated).
   */
  publishedState?: InputMaybe<ContentFilterPublishedState>
  /** The content title group id */
  titleGroupId?: InputMaybe<Scalars['String']['input']>
}

/** Content filter list response */
export type ContentFilterListResponse = {
  __typename?: 'ContentFilterListResponse'
  /** A list of content reference */
  contentFilters?: Maybe<Array<Maybe<ContentFilter>>>
}

/**
 * Content filter types for various content published states.
 *
 * Published State Meanings:
 * - PUBLISHED: Content where published=true (regardless of publishedAtDate). This includes:
 *   * Content that is discoverable but not yet playable (publishedAtDate in future)
 *   * Content that is playable (publishedAtDate is now or in past)
 *   Use this to get all discoverable content, including future-dated content.
 *
 * - PUBLISHED_NOW: Content where published=true AND publishedAtDate is now or in the past.
 *   This is the ONLY state where content is playable. Use this filter to get only content
 *   that can actually be played by users.
 *
 * IMPORTANT: Content with published=false should NEVER be accessible, regardless of publishedAtDate.
 */
export enum ContentFilterPublishedState {
  /**
   * The content published is true (does not consider published at date).
   * Includes both playable content and future-dated discoverable content.
   */
  Published = 'PUBLISHED',
  /**
   * The content published is true and published at date is now or in the past.
   * This is the ONLY state where content is playable. Use this to filter for content
   * that users can actually access and play.
   */
  PublishedNow = 'PUBLISHED_NOW',
}

/** Content filter set */
export type ContentFilterSet = {
  __typename?: 'ContentFilterSet'
  content?: Maybe<Array<Maybe<Content>>>
  /** The content filters in this content filter set */
  contentFilters?: Maybe<Array<Maybe<ContentFilter>>>
  /** The content_id field on the content table */
  contentId?: Maybe<Scalars['Int']['output']>
  /** The content reference type */
  contentReferenceType?: Maybe<ContentReferenceType>
  /** A foreign key to the content_reference_types which defines the relationship between the parent and the child content */
  contentReferenceTypesId?: Maybe<Scalars['ID']['output']>
  /** The content_type field on the content table */
  contentType?: Maybe<Scalars['String']['output']>
  /** When the row was created */
  createdAt?: Maybe<Scalars['DateTime']['output']>
  /** A list of content_filter types in display order from left to right */
  filterTypeOrder?: Maybe<Array<Maybe<Scalars['String']['output']>>>
  /** The primary key for this record */
  id?: Maybe<Scalars['ID']['output']>
  /** The filter set to which this filter belongs */
  name?: Maybe<Scalars['String']['output']>
  /** A human readable id that is identifies the content in a title group */
  titleGroupId?: Maybe<Scalars['String']['output']>
  /** When the row was last updated */
  updatedAt?: Maybe<Scalars['DateTime']['output']>
}

/** Content filter set */
export type ContentFilterSetContentArgs = {
  language?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
}

/** Content filter set list response */
export type ContentFilterSetListResponse = {
  __typename?: 'ContentFilterSetListResponse'
  /** A list of content reference */
  contentFilterSets?: Maybe<Array<Maybe<ContentFilterSet>>>
}

/** Content path redirect type where input type */
export type ContentFilterSetWhereIdInput = {
  /** Is the value equal to the field */
  eq?: InputMaybe<Scalars['ID']['input']>
  /** Is the value greater than to the field */
  gt?: InputMaybe<Scalars['ID']['input']>
  /** Is the value greater than or equal to the field */
  gte?: InputMaybe<Scalars['ID']['input']>
  /** Are the values in the field */
  in?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>
}

/** Content filter set where conditions to filter rows */
export type ContentFilterSetWhereInput = {
  /** The id field where clause */
  id?: InputMaybe<ContentFilterSetWhereIdInput>
  /** The name field where clause */
  name?: InputMaybe<ContentFilterSetWhereNameInput>
}

/** Content filter set filter type where input type */
export type ContentFilterSetWhereNameInput = {
  /** Is the value equal to the field */
  eq?: InputMaybe<Scalars['String']['input']>
  /** Are the values in the field */
  in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
}

/** Content filter filter set where input type */
export type ContentFilterWhereFilterSetInput = {
  /** Is the value equal to the field */
  eq?: InputMaybe<Scalars['String']['input']>
  /** Are the values in the field */
  in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
}

/** Content filter filter type where input type */
export type ContentFilterWhereFilterTypeInput = {
  /** Is the value equal to the field */
  eq?: InputMaybe<Scalars['String']['input']>
  /** Are the values in the field */
  in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
}

/** Content path redirect type where input type */
export type ContentFilterWhereIdInput = {
  /** Is the value equal to the field */
  eq?: InputMaybe<Scalars['ID']['input']>
  /** Is the value greater than to the field */
  gt?: InputMaybe<Scalars['ID']['input']>
  /** Is the value greater than or equal to the field */
  gte?: InputMaybe<Scalars['ID']['input']>
  /** Are the values in the field */
  in?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>
}

/** Content filter where conditions to filter rows */
export type ContentFilterWhereInput = {
  /** The filterSet field where clause */
  filterSet?: InputMaybe<ContentFilterWhereFilterSetInput>
  /** The filterSet field where clause */
  filterType?: InputMaybe<ContentFilterWhereFilterTypeInput>
  /** The id field where clause */
  id?: InputMaybe<ContentFilterWhereIdInput>
}

/** The content filter for associated imageContentRelationships */
export type ContentImageContentRelationshipsFilterInput = {
  /** The image content relationship language */
  language?: InputMaybe<Scalars['String']['input']>
  /** The image content relationship type */
  type?: InputMaybe<Scalars['String']['input']>
}

/** Single piece of content as input */
export type ContentInput = {
  /** The assets description */
  assetsDescription?: InputMaybe<Scalars['String']['input']>
  /** The assets label */
  assetsLabel?: InputMaybe<Scalars['String']['input']>
  /** Bundle for a tag, (d6 vocabulary vid) */
  bundle?: InputMaybe<Scalars['String']['input']>
  /** The cast in the video */
  cast?: InputMaybe<Scalars['String']['input']>
  /** D6 nid also the content group id i.e. all translations of this content share the same content_id */
  contentId?: InputMaybe<Scalars['Int']['input']>
  /** A reference to the content policy */
  contentPolicyPolicyId?: InputMaybe<Scalars['Int']['input']>
  /** When true the content will be visible in content search */
  contentSearchNoIndex?: InputMaybe<Scalars['Boolean']['input']>
  /** The content type which can be expanded in the future i.e. video or series */
  contentType?: InputMaybe<Scalars['String']['input']>
  /** The copyright date as text */
  copyright?: InputMaybe<Scalars['String']['input']>
  /** The date the row was created */
  createdAt?: InputMaybe<Scalars['DateTime']['input']>
  /** the deeplink path on the gaia app where the promoted item lives */
  ctaDeeplinkPath?: InputMaybe<Scalars['String']['input']>
  /** the call to action label */
  ctaLabel?: InputMaybe<Scalars['String']['input']>
  /** the path on the gaia web app where the promoted item lives */
  ctaPath?: InputMaybe<Scalars['String']['input']>
  /** The URL to purchase the product */
  ctaProductUrl?: InputMaybe<Scalars['String']['input']>
  /** The day number */
  dayNumber?: InputMaybe<Scalars['Int']['input']>
  /** The description in the given language */
  description?: InputMaybe<Scalars['String']['input']>
  /** The format of the long description (null = plain text) */
  descriptionFormat?: InputMaybe<Scalars['String']['input']>
  /** The directions description */
  directionsDescription?: InputMaybe<Scalars['String']['input']>
  /** The directions label */
  directionsLabel?: InputMaybe<Scalars['String']['input']>
  /** The name of the directory of the video */
  director?: InputMaybe<Scalars['String']['input']>
  /** The display type to be used in UI rendering */
  displayType?: InputMaybe<Scalars['String']['input']>
  /** The series season episode number */
  episodeNumber?: InputMaybe<Scalars['Int']['input']>
  /** When true the content will be excluded from recommendations */
  excludeFromRecommendations?: InputMaybe<Scalars['Boolean']['input']>
  /** If true the content is family friendly */
  familyFriendly?: InputMaybe<Scalars['Boolean']['input']>
  /** The foreign key to the media table to the feature media */
  featureMediaId?: InputMaybe<Scalars['ID']['input']>
  /** Optional filter type to include this content as a filter option */
  filterType?: InputMaybe<Scalars['String']['input']>
  /** The primary identifier for this record */
  id?: InputMaybe<Scalars['ID']['input']>
  /** The name of the instructor in the video */
  instructor?: InputMaybe<Scalars['String']['input']>
  /** The language of this content */
  language?: InputMaybe<Scalars['String']['input']>
  /** The path part of a url which matches this content */
  path?: InputMaybe<Scalars['String']['input']>
  /** PM people list */
  peopleListId?: InputMaybe<Scalars['String']['input']>
  /** The foreign key to the media table to the preview media */
  previewMediaId?: InputMaybe<Scalars['ID']['input']>
  /** The language of content that was used to create all of the translations */
  primaryLanguage?: InputMaybe<Scalars['String']['input']>
  /** The name of producer of the video */
  producer?: InputMaybe<Scalars['String']['input']>
  /** The product type identifier in UI rendering */
  productType?: InputMaybe<Scalars['String']['input']>
  /** The production status */
  productionStatus?: InputMaybe<Scalars['String']['input']>
  /** True if the video is published */
  published?: InputMaybe<Scalars['Boolean']['input']>
  /** The date the content was published to allow sorting by language */
  publishedAtDate?: InputMaybe<Scalars['DateTime']['input']>
  /** The series season number */
  seasonNumber?: InputMaybe<Scalars['Int']['input']>
  /** The SEO canonical url */
  seoCanonicalUrl?: InputMaybe<Scalars['String']['input']>
  /** The SEO short description in the given language */
  seoDescription?: InputMaybe<Scalars['String']['input']>
  /** The SEO keywords in the given language */
  seoKeywords?: InputMaybe<Scalars['String']['input']>
  /** The SEO no follow attribute */
  seoRobotsNoFollow?: InputMaybe<Scalars['Boolean']['input']>
  /** The SEO no index attribute */
  seoRobotsNoIndex?: InputMaybe<Scalars['Boolean']['input']>
  /** The SEO title of this video in the given language */
  seoTitle?: InputMaybe<Scalars['String']['input']>
  /** The share URL for this content, constructed based on content policy shareAllowed setting */
  shareUrl?: InputMaybe<Scalars['String']['input']>
  /** The short description in the given language */
  shortDescription?: InputMaybe<Scalars['String']['input']>
  /** The format of the long description (null = plain text) */
  shortDescriptionFormat?: InputMaybe<Scalars['String']['input']>
  /** The studio where the video was filmed */
  studio?: InputMaybe<Scalars['String']['input']>
  /** The third party description in the given language */
  thirdPartyDescription?: InputMaybe<Scalars['String']['input']>
  /** The title of this video in the given language */
  title?: InputMaybe<Scalars['String']['input']>
  /** A human readable id that is identifies the content in a title group */
  titleGroupId?: InputMaybe<Scalars['String']['input']>
  /** A human readable id that is unique for all content */
  titleId?: InputMaybe<Scalars['String']['input']>
  /** The date the content was unpublished */
  unpublishedAt?: InputMaybe<Scalars['DateTime']['input']>
  /** The date the row was last updated */
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>
  /** The weight when ordering in lists */
  weight?: InputMaybe<Scalars['Int']['input']>
  /** The name of the video */
  writer?: InputMaybe<Scalars['String']['input']>
}

/** Content list criteria */
export type ContentListCriteria = {
  __typename?: 'ContentListCriteria'
  /** The content linked to this content list criteria */
  content?: Maybe<Array<Maybe<Content>>>
  /** The content filter set linked to this content list criteria */
  contentFilterSet?: Maybe<ContentFilterSet>
  /** The content content id i.e. all translations of this content share the same content.content_id */
  contentId?: Maybe<Scalars['Int']['output']>
  /** The content content type i.e. video, series, etc. */
  contentType?: Maybe<Scalars['String']['output']>
  /** When the row was created */
  createdAt?: Maybe<Scalars['DateTime']['output']>
  /** How content list should be filtered by the content set */
  criteria?: Maybe<ContentListCriteriaCriteria>
  /** The primary key for this record */
  id?: Maybe<Scalars['ID']['output']>
  /** The language for to match for the criteria */
  language?: Maybe<Scalars['String']['output']>
  /** How should the content be sorted */
  sort?: Maybe<Scalars['String']['output']>
  /** A human readable id that is identifies the content in a title group e.g. content.titleGroupId */
  titleGroupId?: Maybe<Scalars['String']['output']>
  /** A human readable id that is unique for all content e.g. content.titleId */
  titleId?: Maybe<Scalars['String']['output']>
  /** When the row was last updated */
  updatedAt?: Maybe<Scalars['DateTime']['output']>
}

/** Content list criteria */
export type ContentListCriteriaContentArgs = {
  language?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
}

/** One content list criteria row as input */
export type ContentListCriteriaCreateInput = {
  /** The content content id i.e. all translations of this content share the same content.content_id */
  contentId?: InputMaybe<Scalars['Int']['input']>
  /** The content content type i.e. video, series, etc. */
  contentType?: InputMaybe<Scalars['String']['input']>
  /** When the row was created */
  createdAt?: InputMaybe<Scalars['DateTime']['input']>
  /** How content list should be filtered by the content set */
  criteria?: InputMaybe<ContentListCriteriaCriteriaInput>
  /** The primary key for this record */
  id?: InputMaybe<Scalars['ID']['input']>
  /** The language for to match for the criteria */
  language?: InputMaybe<Scalars['String']['input']>
  /** How should the content be sorted */
  sort?: InputMaybe<Scalars['String']['input']>
  /** A human readable id that is identifies the content in a title group e.g. content.titleGroupId */
  titleGroupId?: InputMaybe<Scalars['String']['input']>
  /** A human readable id that is unique for all content e.g. content.titleId */
  titleId?: InputMaybe<Scalars['String']['input']>
  /** When the row was last updated */
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>
}

/** Content list criteria criteria to be applied to content when filtering */
export type ContentListCriteriaCriteria = {
  __typename?: 'ContentListCriteriaCriteria'
  /** Criteria to apply when there are no content filters are specified with the content filter set */
  all?: Maybe<Array<Maybe<ContentListCriteriaCriteriaItem>>>
  /** Criteria to apply when any content filters are specified with the content filter set */
  filtered?: Maybe<Array<Maybe<ContentListCriteriaCriteriaItem>>>
}

/** One Content list criteria criteria */
export type ContentListCriteriaCriteriaInput = {
  /** Criteria to apply when there are no content filters are specified with the content filter set */
  all?: InputMaybe<Array<InputMaybe<ContentListCriteriaCriteriaItemInput>>>
  /** Criteria to apply when any content filters are specified with the content filter set */
  filtered?: InputMaybe<Array<InputMaybe<ContentListCriteriaCriteriaItemInput>>>
}

/** Content list criteria criteria item to be applied to content when filtering */
export type ContentListCriteriaCriteriaItem = {
  __typename?: 'ContentListCriteriaCriteriaItem'
  /** The content content type i.e. video, series, etc. */
  contentType?: Maybe<Scalars['String']['output']>
  /** The content product type i.e. episode, segment, single, etc. */
  productType?: Maybe<Scalars['String']['output']>
}

/** One content list criteria criteria item */
export type ContentListCriteriaCriteriaItemInput = {
  /** The content content type i.e. video, series, etc. */
  contentType?: InputMaybe<Scalars['String']['input']>
  /** The content product type i.e. episode, segment, single, etc. */
  productType?: InputMaybe<Scalars['String']['input']>
}

/** One content list criteria row as input */
export type ContentListCriteriaDeleteInput = {
  /** The primary key for this record */
  id?: InputMaybe<Scalars['ID']['input']>
}

/** Content list criteria list response */
export type ContentListCriteriaListResponse = {
  __typename?: 'ContentListCriteriaListResponse'
  /** A list of content list criteria */
  contentListCriteria?: Maybe<Array<Maybe<ContentListCriteria>>>
}

/** Mutation response for a content list mutation */
export type ContentListCriteriaMutationResponse = {
  __typename?: 'ContentListCriteriaMutationResponse'
  /** The content list criteria that was mutated */
  contentListCriteria?: Maybe<ContentListCriteria>
}

/** Content list criteria id where input type */
export type ContentListCriteriaWhereIdInput = {
  /** Is the value equal to the field */
  eq?: InputMaybe<Scalars['ID']['input']>
  /** Is the value greater than to the field */
  gt?: InputMaybe<Scalars['ID']['input']>
  /** Is the value greater than or equal to the field */
  gte?: InputMaybe<Scalars['ID']['input']>
  /** Are the values in the field */
  in?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>
  /** Is the value less than to the field */
  lt?: InputMaybe<Scalars['ID']['input']>
  /** Is the value less than or equal to the field */
  lte?: InputMaybe<Scalars['ID']['input']>
}

/** Content list criteria where conditions to filter rows */
export type ContentListCriteriaWhereInput = {
  /** The id field where clause */
  id?: InputMaybe<ContentListCriteriaWhereIdInput>
  /** The id field where clause */
  titleGroupId?: InputMaybe<ContentListCriteriaWhereTitleGroupIdInput>
}

/** Content list criteria title group id where input type */
export type ContentListCriteriaWhereTitleGroupIdInput = {
  /** Is the value equal to the field */
  eq?: InputMaybe<Scalars['String']['input']>
  /** Are the values in the field */
  in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
}

/** Content list response */
export type ContentListResponse = {
  __typename?: 'ContentListResponse'
  /** A list of content */
  content?: Maybe<Array<Maybe<Content>>>
  /** Total number of rows of content found (uses a slower count query for list) */
  count?: Maybe<Scalars['Int']['output']>
  /** Debug information from the resolver */
  debug?: Maybe<Scalars['JSON']['output']>
  /** The limit applied to the rows */
  limit?: Maybe<Scalars['Int']['output']>
  /** The offset applied to the rows */
  offset?: Maybe<Scalars['Int']['output']>
  /** Get a overview text of the content list */
  overview?: Maybe<DocumentAnswer>
}

/** Content list response */
export type ContentListResponseOverviewArgs = {
  context?: InputMaybe<ContentOverviewContext>
  format?: InputMaybe<ContentTextFormat>
  limit?: InputMaybe<Scalars['Int']['input']>
  offset?: InputMaybe<Scalars['Int']['input']>
}

export type ContentNotFilterInput = {
  /** The content id to exclude */
  contentId?: InputMaybe<Scalars['Int']['input']>
  /** The content type to exclude */
  contentType?: InputMaybe<Scalars['String']['input']>
}

/** The type of summarization to perform which determines the text summarization style */
export enum ContentOverviewContext {
  /** The default summarization style */
  Default = 'DEFAULT',
  /** The summarization style for a user search query */
  UserSearchQuery = 'USER_SEARCH_QUERY',
}

/**
 * Content policy defines comprehensive access control, sharing permissions, and availability rules for content.
 *
 * Content policies are the central mechanism for controlling who can access content and under what conditions.
 * Each content item is linked to a content policy via the contentPolicyPolicyId field.
 *
 * ACCESS CONTROL RULES (evaluated in order of precedence):
 *
 * 1. User Role Access (HIGHEST PRECEDENCE):
 *    - If userRoleAllowed is true, the user has access regardless of all other rules
 *    - Roles like EDITOR, SITE_ADMIN, CUSTOMER_SERVICE bypass all other restrictions
 *    - This takes precedence over subscriptions, countries, and all other checks
 *
 * 2. Country/Geographic Restrictions:
 *    - availability field controls geographic access:
 *      * Worldwide: Content available everywhere
 *      * Only In: Content only available in countries list
 *      * Blocked: Content blocked in countries list
 *    - countryAllowed indicates if user's country (from authentication or request) is allowed
 *    - Uses user's authenticated country if available, otherwise falls back to request country
 *
 * 3. Client Attributes:
 *    - availabilityClientAttributes controls client-based restrictions:
 *      * No restrictions: All clients can access
 *      * Only with: Only clients with attributes in clientAttributes list can access
 *      * Blocked with: Clients with attributes in clientAttributes list are blocked
 *    - clientAttributesAllowed indicates if user's client attributes are allowed
 *
 * 4. Subscription Plans:
 *    - optionIds contains the list of subscription plan IDs that allow access
 *    - subscriptionsAllowed indicates if user's active subscriptions match any allowed plan
 *    - Users must have at least one matching subscription to access (unless content is free)
 *
 * 5. Ecommerce Entitlements:
 *    - ecommercePurchaseAllowed indicates if user has purchased this specific content
 *    - Can be used for pay-per-view or one-time purchase content
 *
 * 6. Free Content:
 *    - isFreeAllowed indicates if content is free (no subscription required)
 *    - Free content is accessible to all users (subject to country/client restrictions)
 *
 * FINAL ACCESS DECISION:
 * - allowed: True when user has access based on ALL applicable rules
 * - allowedWithEntitlementsMatch: True when ecommercePurchaseAllowed OR subscriptionsAllowed is true
 * - User role access (userRoleAllowed) takes precedence over all other checks
 *
 * SHARING:
 * - shareAllowed: Whether the content can be shared via shareUrl
 * - Controls if content can be shared on social media or via direct links
 *
 * Use the accessCheck field to evaluate access for the current request. The check considers all rules
 * and returns detailed information about which checks passed or failed.
 *
 * AUTHENTICATION-BASED CONTENT FILTERING:
 * When querying content with applyContentPolicy=true, the following authentication properties are used
 * to automatically filter content based on content policy rules:
 *
 * 1. authentication.country (or request country if not authenticated):
 *    - Matched against policy.availability and policy.countries
 *    - Filters out content not available in user's country
 *    - Used to enforce geographic restrictions
 *
 * 2. authentication.clientAttributes:
 *    - Matched against policy.availabilityClientAttributes and policy.clientAttributes
 *    - Filters content based on client device/platform restrictions
 *    - Used to restrict content to specific client types
 *
 * 3. authentication.subscriptions:
 *    - Matched against policy.optionIds
 *    - Filters content to only show what user's subscription allows
 *    - Free content (optionIds includes 0) is shown to all users
 *
 * 4. authentication.roles:
 *    - Checked for special privileges (EDITOR, SITE_ADMIN, etc.)
 *    - Users with privileged roles bypass all other restrictions
 *    - Used to allow staff/admin access to all content
 *
 * These authentication properties are automatically extracted from the request and applied when
 * applyContentPolicy=true is used in content queries (contentList, contentSeries, contentEpisodes, etc.).
 */
export type ContentPolicy = {
  __typename?: 'ContentPolicy'
  /** Access check for the current request against this content policy */
  accessCheck?: Maybe<ContentPolicyAccessCheck>
  /** Content policy availability of countries such as worldwide, only in or blocked */
  availability?: Maybe<Scalars['Int']['output']>
  /** Content policy availability of client attributes such as no restrictions, only with or blocked with */
  availabilityClientAttributes?: Maybe<Scalars['Int']['output']>
  /** The client attributes to apply in combination with availability_client_attributes ordered ASC */
  clientAttributes?: Maybe<Array<Maybe<Scalars['String']['output']>>>
  /** The content associated with this content policy */
  content?: Maybe<Array<Maybe<Content>>>
  /** The countries to apply in combination with availability ordered ASC */
  countries?: Maybe<Array<Maybe<Scalars['String']['output']>>>
  /** When the row was created */
  createdAt?: Maybe<Scalars['DateTime']['output']>
  /** Name of the policy group */
  name?: Maybe<Scalars['String']['output']>
  /** The subscriptions which are allowed for this content policy ordered ASC */
  optionIds?: Maybe<Array<Maybe<Scalars['Int']['output']>>>
  /** The id for this content policy group */
  policyId?: Maybe<Scalars['ID']['output']>
  /** True if this content policy allows sharing */
  shareAllowed?: Maybe<Scalars['Boolean']['output']>
  /** When the row was last updated */
  updatedAt?: Maybe<Scalars['DateTime']['output']>
}

/**
 * Access check results for the current request against a content policy.
 *
 * This type provides detailed information about whether a user can access content based on
 * the content policy rules. Use this to determine access, display appropriate UI, and
 * understand why access was granted or denied.
 *
 * EVALUATION ORDER (precedence matters):
 * 1. userRoleAllowed (HIGHEST) - If true, user has access regardless of all other checks
 * 2. countryAllowed - Geographic restrictions
 * 3. clientAttributesAllowed - Client-based restrictions
 * 4. subscriptionsAllowed - Subscription plan matching
 * 5. ecommercePurchaseAllowed - One-time purchase entitlements
 * 6. isFreeAllowed - Free content access
 *
 * FINAL DECISION:
 * - allowed: True when user passes ALL applicable checks (or userRoleAllowed is true)
 * - allowedWithEntitlementsMatch: True when user has either subscription OR purchase entitlement
 */
export type ContentPolicyAccessCheck = {
  __typename?: 'ContentPolicyAccessCheck'
  /**
   * True when the request is allowed access by the content policy checks applied using all rules.
   * This is the primary field to check for access. If true, the user can access the content.
   * If false, check the individual allowed fields to understand which restriction applies.
   *
   * NOTE: userRoleAllowed=true will make this true regardless of other checks.
   */
  allowed?: Maybe<Scalars['Boolean']['output']>
  /**
   * True when either ecommercePurchaseAllowed OR subscriptionsAllowed is true.
   * Useful for determining if user has any form of entitlement (subscription or purchase).
   */
  allowedWithEntitlementsMatch?: Maybe<Scalars['Boolean']['output']>
  /**
   * True when the user's client attributes match the content policy requirements.
   * Based on availabilityClientAttributes and clientAttributes fields in the policy.
   */
  clientAttributesAllowed?: Maybe<Scalars['Boolean']['output']>
  /**
   * True when the user's country is allowed by the content policy.
   * Uses authenticated country if available, otherwise request country.
   * Based on availability and countries fields in the policy.
   */
  countryAllowed?: Maybe<Scalars['Boolean']['output']>
  /**
   * True when the user has purchased this specific content via ecommerce.
   * Used for pay-per-view or one-time purchase content.
   */
  ecommercePurchaseAllowed?: Maybe<Scalars['Boolean']['output']>
  /**
   * True when the content policy indicates the content is free (no subscription required).
   * Free content is accessible to all users (subject to country/client restrictions).
   */
  isFreeAllowed?: Maybe<Scalars['Boolean']['output']>
  /**
   * True when the user's active subscriptions match any of the allowed subscription plans.
   * Based on optionIds field in the policy. User must have at least one matching subscription.
   */
  subscriptionsAllowed?: Maybe<Scalars['Boolean']['output']>
  /**
   * True when the user's role allows access to the policy.
   * THIS TAKES PRECEDENCE OVER ALL OTHER CHECKS.
   * If true, the user has access regardless of subscriptions, countries, or other restrictions.
   * Roles like EDITOR, SITE_ADMIN, CUSTOMER_SERVICE typically have this privilege.
   */
  userRoleAllowed?: Maybe<Scalars['Boolean']['output']>
  /**
   * The values used for the access check evaluation.
   * Contains the actual country, subscriptions, client attributes, and roles that were evaluated.
   */
  values?: Maybe<ContentPolicyAccessCheckValues>
}

/**
 * Access check values to evaluate rules.
 *
 * These values come from the request authentication and are used to evaluate content policy access.
 * The authentication properties are automatically extracted from the request and used to filter content
 * when applyContentPolicy is true on content queries.
 *
 * AUTHENTICATION PROPERTIES USED FOR FILTERING:
 * - country: User's country code (from authentication, falls back to request country if not authenticated)
 * - clientAttributes: Array of client attributes (e.g., device type, platform) from authentication
 * - subscriptions: Array of subscription plan IDs the user is subscribed to
 * - roles: Array of user role IDs (e.g., EDITOR, SITE_ADMIN) that may bypass restrictions
 *
 * These properties are used to match against content policy rules:
 * - country is matched against policy.availability and policy.countries
 * - clientAttributes are matched against policy.availabilityClientAttributes and policy.clientAttributes
 * - subscriptions are matched against policy.optionIds
 * - roles are checked for special access privileges
 */
export type ContentPolicyAccessCheckValues = {
  __typename?: 'ContentPolicyAccessCheckValues'
  /**
   * The user authentication client attributes (takes precedence for clientAttributesAllowed check).
   * Used to filter content based on client-based restrictions in the content policy.
   */
  clientAttributes?: Maybe<Array<Maybe<Scalars['String']['output']>>>
  /**
   * The user authentication country (takes precedence for countryAllowed check).
   * Used to filter content based on geographic restrictions in the content policy.
   * Falls back to requestCountry if not available from authentication.
   */
  country?: Maybe<Scalars['String']['output']>
  /**
   * The request country used if user authentication country is undefined.
   * Used as a fallback when determining geographic access restrictions.
   */
  requestCountry?: Maybe<Scalars['String']['output']>
  /**
   * The user authentication roles (takes precedence for userRoleAllowed check).
   * Used to determine if user has special access privileges that bypass other restrictions.
   */
  roles?: Maybe<Array<Maybe<Scalars['Int']['output']>>>
  /**
   * The user authentication subscriptions (takes precedence for subscriptionsAllowed check).
   * Used to filter content based on subscription plan requirements in the content policy.
   */
  subscriptions?: Maybe<Array<Maybe<Scalars['Int']['output']>>>
}

/** Content policy list response */
export type ContentPolicyListResponse = {
  __typename?: 'ContentPolicyListResponse'
  /** A list of content reference */
  contentPolicies?: Maybe<Array<Maybe<ContentPolicy>>>
  /** Total number of rows of content policies found (uses a slower count query for list) */
  count?: Maybe<Scalars['Int']['output']>
  /** The limit applied to the rows */
  limit?: Maybe<Scalars['Int']['output']>
  /** The offset applied to the rows */
  offset?: Maybe<Scalars['Int']['output']>
}

/** Content content id where input type */
export type ContentPolicyWhereContentIdInput = {
  /** Is the value equal to the field */
  eq?: InputMaybe<Scalars['Int']['input']>
  /** Is the value greater than to the field */
  gt?: InputMaybe<Scalars['Int']['input']>
  /** Is the value greater than or equal to the field */
  gte?: InputMaybe<Scalars['Int']['input']>
  /** Are the values in the field */
  in?: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>
}

/** Content id where input type */
export type ContentPolicyWhereIdInput = {
  /** Is the value equal to the field */
  eq?: InputMaybe<Scalars['ID']['input']>
  /** Is the value greater than to the field */
  gt?: InputMaybe<Scalars['ID']['input']>
  /** Is the value greater than or equal to the field */
  gte?: InputMaybe<Scalars['ID']['input']>
  /** Are the values in the field */
  in?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>
}

/** Content policy where conditions to filter rows */
export type ContentPolicyWhereInput = {
  /** The id field where clause */
  policyId?: InputMaybe<ContentPolicyWherePolicyIdInput>
}

/** Content content policy type where input type */
export type ContentPolicyWherePolicyIdInput = {
  /** Is the value equal to the field */
  eq?: InputMaybe<Scalars['ID']['input']>
  /** Is the value greater than to the field */
  gt?: InputMaybe<Scalars['ID']['input']>
  /** Is the value greater than or equal to the field */
  gte?: InputMaybe<Scalars['ID']['input']>
  /** Are the values in the field */
  in?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>
}

/** Content provider */
export type ContentProvider = {
  __typename?: 'ContentProvider'
  /** The content associated with this content provider */
  content?: Maybe<Content>
  /** The id for this content provider content.id */
  contentId?: Maybe<Scalars['ID']['output']>
  /** When the row was created */
  createdAt?: Maybe<Scalars['DateTime']['output']>
  /** Metadata specifically for the content provider, generally data that does not fit the content model, but is used by the provider */
  metadata?: Maybe<Scalars['JSON']['output']>
  /** The content provider */
  provider?: Maybe<ContentProviderProviders>
  /** The provider hash value of the data on the provider */
  providerHash?: Maybe<Scalars['String']['output']>
  /** The provider hash algorithm used to produce the hash value */
  providerHashType?: Maybe<ContentProviderHashType>
  /** The content provider key for this content */
  providerKey?: Maybe<Scalars['String']['output']>
  /** When the row was last updated */
  updatedAt?: Maybe<Scalars['DateTime']['output']>
}

/** Content provider */
export type ContentProviderContentArgs = {
  language?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
}

/** Content provider create */
export type ContentProviderCreateByContentIdInput = {
  /** The id for this content provider */
  contentId?: InputMaybe<Scalars['ID']['input']>
  /** Metadata specifically for the content provider, generally data that does not fit the content model, but is used by the provider the mutation will full replace the current value if defined */
  metadata?: InputMaybe<Scalars['JSON']['input']>
  /** The content provider */
  provider?: InputMaybe<ContentProviderProviders>
  /** The provider hash value of the data on the provider */
  providerHash?: InputMaybe<Scalars['String']['input']>
  /** The provider hash algorithm used to produce the hash value */
  providerHashType?: InputMaybe<ContentProviderHashType>
  /** The content provider key for this content */
  providerKey?: InputMaybe<Scalars['String']['input']>
}

/** Content delete provider delete by content id */
export type ContentProviderDeleteByContentIdInput = {
  /** The id for this content provider */
  contentId?: InputMaybe<Scalars['ID']['input']>
}

/** Content provider providers */
export enum ContentProviderHashType {
  /** MD5 */
  Md5 = 'MD5',
}

/** Content provider list response */
export type ContentProviderListResponse = {
  __typename?: 'ContentProviderListResponse'
  /** A list of content reference */
  contentProviders?: Maybe<Array<Maybe<ContentProvider>>>
}

/** Content provider mutation response */
export type ContentProviderMutationResponse = {
  __typename?: 'ContentProviderMutationResponse'
  /** The content provider which was mutated */
  contentProvider?: Maybe<ContentProvider>
}

/** Content provider providers */
export enum ContentProviderProviders {
  /** Gaia Bonus */
  GaiaBonus = 'GAIA_BONUS',
  /** Gaia Worpress */
  GaiaWordpress = 'GAIA_WORDPRESS',
  /** Shopify */
  Shopify = 'SHOPIFY',
  /** Yoga International */
  YogaInternational = 'YOGA_INTERNATIONAL',
}

/** Content delete provider update by content id */
export type ContentProviderUpdateByContentIdInput = {
  /** The id for this content provider */
  contentId?: InputMaybe<Scalars['ID']['input']>
  /** Metadata specifically for the content provider, generally data that does not fit the content model, but is used by the provider the mutation will full replace the current value if defined */
  metadata?: InputMaybe<Scalars['JSON']['input']>
  /** The content provider */
  provider?: InputMaybe<ContentProviderProviders>
  /** The provider hash value of the data on the provider */
  providerHash?: InputMaybe<Scalars['String']['input']>
  /** The provider hash algorithm used to produce the hash value */
  providerHashType?: InputMaybe<ContentProviderHashType>
  /** The content provider key for this content */
  providerKey?: InputMaybe<Scalars['String']['input']>
}

/** Content provider where conditions to filter rows */
export type ContentProviderWhereInput = {
  /** The content id field where clause */
  contentId?: InputMaybe<ContentProvidersWhereContentIdInput>
  /** Metadata JSON input */
  metadata?: InputMaybe<ContentProvidersWhereMetadataInput>
  /** The provider field where clause */
  provider?: InputMaybe<ContentProvidersWhereProviderInput>
  /** The provider key field where clause */
  providerKey?: InputMaybe<ContentProvidersWhereProviderKeyInput>
}

/** Content id where input type */
export type ContentProvidersWhereContentIdInput = {
  /** Is the value equal to the field */
  eq?: InputMaybe<Scalars['ID']['input']>
  /** Is the value greater than to the field */
  gt?: InputMaybe<Scalars['ID']['input']>
  /** Is the value greater than or equal to the field */
  gte?: InputMaybe<Scalars['ID']['input']>
  /** Are the values in the field */
  in?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>
}

/** Content provider where input type */
export type ContentProvidersWhereMetadataInput = {
  /** Does the field contain the values */
  contains?: InputMaybe<Scalars['JSON']['input']>
}

/** Content provider where input type */
export type ContentProvidersWhereProviderInput = {
  /** Is the value equal to the field */
  eq?: InputMaybe<Scalars['ID']['input']>
  /** Are the values in the field */
  in?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>
}

/** Content provider where input type */
export type ContentProvidersWhereProviderKeyInput = {
  /** Is the value equal to the field */
  eq?: InputMaybe<Scalars['ID']['input']>
  /** Are the values in the field */
  in?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>
}

/** Content reference */
export type ContentReference = {
  __typename?: 'ContentReference'
  /** The content linked from this content reference */
  contentFrom?: Maybe<Array<Maybe<Content>>>
  /** The content reference type */
  contentReferenceType?: Maybe<ContentReferenceType>
  /** A foreign key to the content_reference_types which defines the relationship between the parent and the child content */
  contentReferenceTypesId?: Maybe<Scalars['ID']['output']>
  /** The content linked to this content reference */
  contentTo?: Maybe<Array<Maybe<Content>>>
  /** The date the row was created */
  createdAt?: Maybe<Scalars['DateTime']['output']>
  /** The content_id field on the content table where the reference originates */
  fromContentContentId?: Maybe<Scalars['Int']['output']>
  /** The content_type field on the content table where the reference originates */
  fromContentContentType?: Maybe<Scalars['String']['output']>
  /** A human readable id that is identifies the content in a title group for the from content */
  fromTitleGroupId?: Maybe<Scalars['String']['output']>
  /** The primary identifier for this record */
  id?: Maybe<Scalars['ID']['output']>
  /** The label for this content reference in the requested language (only applicable to course-module-practice and course-module-other types) */
  label?: Maybe<Scalars['String']['output']>
  /** The field to sort by */
  sortKey?: Maybe<Scalars['Int']['output']>
  /** The content_type field on the content table where the reference points */
  toContentContentId?: Maybe<Scalars['Int']['output']>
  /** The content_type field on the content table where the reference points */
  toContentContentType?: Maybe<Scalars['String']['output']>
  /** A human readable id that is identifies the content in a title group for the to content */
  toTitleGroupId?: Maybe<Scalars['String']['output']>
  /** The date the row was last updated */
  updatedAt?: Maybe<Scalars['DateTime']['output']>
}

/** Content reference */
export type ContentReferenceContentFromArgs = {
  applyContentPolicy?: InputMaybe<Scalars['Boolean']['input']>
  content?: InputMaybe<Array<InputMaybe<ContentFilterInput>>>
  language?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
}

/** Content reference */
export type ContentReferenceContentToArgs = {
  applyContentPolicy?: InputMaybe<Scalars['Boolean']['input']>
  content?: InputMaybe<Array<InputMaybe<ContentFilterInput>>>
  language?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
}

/** Content reference */
export type ContentReferenceLabelArgs = {
  language?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
}

/** Content references allowed row */
export type ContentReferenceAllowed = {
  __typename?: 'ContentReferenceAllowed'
  /** The content id field on the content table */
  contentId?: Maybe<Scalars['Int']['output']>
  /** The content reference type associated with this row */
  contentReferenceType?: Maybe<ContentReferenceType>
  /** The content reference types id field on the content table where the reference points */
  contentReferenceTypesId?: Maybe<Scalars['Int']['output']>
  /** The content type field on the content table */
  contentType?: Maybe<Scalars['String']['output']>
  /** The primary identifier for this record */
  id?: Maybe<Scalars['ID']['output']>
}

/** Single content reference as create input */
export type ContentReferenceCreateInput = {
  /** The from_content_content_id field */
  fromContentContentId: Scalars['Int']['input']
  /** The from_content_content_type field */
  fromContentContentType: Scalars['String']['input']
  /** The field to sort by */
  sortKey?: InputMaybe<Scalars['Int']['input']>
  /** The to_content_content_id field */
  toContentContentId: Scalars['Int']['input']
  /** The to_content_content_type field */
  toContentContentType: Scalars['String']['input']
  /** The content_reference_types.type field */
  type: Scalars['String']['input']
}

/** Return type for content reference create many. */
export type ContentReferenceCreateManyResponse = {
  __typename?: 'ContentReferenceCreateManyResponse'
  /** The content references that were updated */
  contentReferences?: Maybe<Array<Maybe<ContentReference>>>
}

/** Return type for content reference create. */
export type ContentReferenceCreateResponse = {
  __typename?: 'ContentReferenceCreateResponse'
  /** The content reference that was updated */
  contentReference?: Maybe<ContentReference>
}

/** Single content reference as delete input */
export type ContentReferenceDeleteInput = {
  /** The id of the content reference to delete */
  id: Scalars['ID']['input']
}

/** Return type for content reference delete. */
export type ContentReferenceDeleteResponse = {
  __typename?: 'ContentReferenceDeleteResponse'
  /** The content reference that was deleted */
  contentReference?: Maybe<ContentReference>
}

/** Content reference type */
export type ContentReferenceType = {
  __typename?: 'ContentReferenceType'
  /** The date and time the record was created */
  createdAt?: Maybe<Scalars['DateTime']['output']>
  /** The primary identifier for this record */
  id?: Maybe<Scalars['ID']['output']>
  /** The type of the reference between the content */
  type?: Maybe<Scalars['String']['output']>
  /** The date and time the record was last updated */
  updatedAt?: Maybe<Scalars['DateTime']['output']>
}

/** Content reference types list response */
export type ContentReferenceTypesListResponse = {
  __typename?: 'ContentReferenceTypesListResponse'
  /** A list of content reference types */
  contentReferenceTypes?: Maybe<Array<Maybe<ContentReferenceType>>>
  /** Total number of rows of content found (uses a slower count query for list) */
  count?: Maybe<Scalars['Int']['output']>
  /** The limit applied to the rows */
  limit?: Maybe<Scalars['Int']['output']>
  /** The offset applied to the rows */
  offset?: Maybe<Scalars['Int']['output']>
}

/** Content reference where input type */
export type ContentReferenceTypesWhereIdInput = {
  /** Is the value equal to the field */
  eq?: InputMaybe<Scalars['ID']['input']>
  /** Is the value greater than to the field */
  gt?: InputMaybe<Scalars['ID']['input']>
  /** Is the value greater than or equal to the field */
  gte?: InputMaybe<Scalars['ID']['input']>
  /** Are the values in the field */
  in?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>
}

/** Content reference types where conditions to filter rows */
export type ContentReferenceTypesWhereInput = {
  /** The id field where clause */
  id?: InputMaybe<ContentReferenceTypesWhereIdInput>
}

/** Content reference where fromContentContentId input type */
export type ContentReferenceWhereFromContentContentIdInput = {
  /** Is the value equal to the field */
  eq?: InputMaybe<Scalars['Int']['input']>
  /** Are the values in the field */
  in?: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>
}

/** Content reference where fromContentContentType input type */
export type ContentReferenceWhereFromContentContentTypeInput = {
  /** Is the value equal to the field */
  eq?: InputMaybe<Scalars['String']['input']>
  /** Are the values in the field */
  in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
}

/** Content reference where fromTitleGroupId input type */
export type ContentReferenceWhereFromTitleGroupIdInput = {
  /** Is the value equal to the field */
  eq?: InputMaybe<Scalars['String']['input']>
  /** Are the values in the field */
  in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
}

/** Content reference where id input type */
export type ContentReferenceWhereIdInput = {
  /** Is the value equal to the field */
  eq?: InputMaybe<Scalars['ID']['input']>
  /** Is the value greater than to the field */
  gt?: InputMaybe<Scalars['ID']['input']>
  /** Is the value greater than or equal to the field */
  gte?: InputMaybe<Scalars['ID']['input']>
  /** Are the values in the field */
  in?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>
}

/** Content reference where toContentContentId input type */
export type ContentReferenceWhereToContentContentIdInput = {
  /** Is the value equal to the field */
  eq?: InputMaybe<Scalars['Int']['input']>
  /** Are the values in the field */
  in?: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>
}

/** Content reference where toContentContentType input type */
export type ContentReferenceWhereToContentContentTypeInput = {
  /** Is the value equal to the field */
  eq?: InputMaybe<Scalars['String']['input']>
  /** Are the values in the field */
  in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
}

/** Content reference where toTitleGroupId input type */
export type ContentReferenceWhereToTitleGroupIdInput = {
  /** Is the value equal to the field */
  eq?: InputMaybe<Scalars['String']['input']>
  /** Are the values in the field */
  in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
}

/** Content list response */
export type ContentReferencesAllowedResponse = {
  __typename?: 'ContentReferencesAllowedResponse'
  /** A list of content reference */
  contentReferencesAllowed?: Maybe<Array<Maybe<ContentReferenceAllowed>>>
}

export type ContentReferencesAllowedWhereIdInput = {
  /** Is the value equal to the field */
  eq?: InputMaybe<Scalars['ID']['input']>
  /** Is the value greater than to the field */
  gt?: InputMaybe<Scalars['ID']['input']>
  /** Is the value greater than or equal to the field */
  gte?: InputMaybe<Scalars['ID']['input']>
  /** Are the values in the field */
  in?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>
}

/** Content references allowed where input */
export type ContentReferencesAllowedWhereInput = {
  /** Filter rows by id */
  id?: InputMaybe<ContentReferencesAllowedWhereIdInput>
}

/** Content reference list response */
export type ContentReferencesListResponse = {
  __typename?: 'ContentReferencesListResponse'
  /** A list of content reference */
  contentReferences?: Maybe<Array<Maybe<ContentReference>>>
  /** Total number of rows of content found (uses a slower count query for list) */
  count?: Maybe<Scalars['Int']['output']>
  /** The limit applied to the rows */
  limit?: Maybe<Scalars['Int']['output']>
  /** The offset applied to the rows */
  offset?: Maybe<Scalars['Int']['output']>
}

/** Content reference where conditions to filter rows */
export type ContentReferencesWhereInput = {
  /** The fromContentContentId field where clause */
  fromContentContentId?: InputMaybe<ContentReferenceWhereFromContentContentIdInput>
  /** The fromContentContentType field where clause */
  fromContentContentType?: InputMaybe<ContentReferenceWhereFromContentContentTypeInput>
  /** The fromTitleGroupId field where clause */
  fromTitleGroupId?: InputMaybe<ContentReferenceWhereFromTitleGroupIdInput>
  /** The id field where clause */
  id?: InputMaybe<ContentReferenceWhereIdInput>
  /** The toContentId field where clause */
  toContentContentId?: InputMaybe<ContentReferenceWhereToContentContentIdInput>
  /** The toContentType field where clause */
  toContentContentType?: InputMaybe<ContentReferenceWhereToContentContentTypeInput>
  /** The toTitleGroupId field where clause */
  toTitleGroupId?: InputMaybe<ContentReferenceWhereToTitleGroupIdInput>
}

/** All of the documents linked to this content directly or by feature media */
export type ContentRelatedDocumentEmbeddings = {
  __typename?: 'ContentRelatedDocumentEmbeddings'
  /** The documents */
  documentEmbeddings?: Maybe<Array<Maybe<DocumentEmbedding>>>
  /** A summarization of all document embedding text */
  summarizationText?: Maybe<Scalars['String']['output']>
}

/** Content related type */
export enum ContentRelatedType {
  /** Content that is linked using content references types for similar */
  References = 'REFERENCES',
  /** Content that is similar across mutliple data points */
  Similar = 'SIMILAR',
}

/** Get the GraphQL Types  */
export type ContentSearch = {
  __typename?: 'ContentSearch'
  /** D6 nid also the content group id i.e. all translations of this content share the same content_id */
  contentId?: Maybe<Scalars['Int']['output']>
  /** type of content (i.e. series, video, etc.) */
  contentType?: Maybe<Scalars['String']['output']>
  /** The date the row was created */
  createdAt?: Maybe<Scalars['DateTime']['output']>
  /** The description fuzzy search text */
  fuzzyDesc?: Maybe<Scalars['String']['output']>
  /** The words fuzzy search text */
  fuzzyWords?: Maybe<Scalars['String']['output']>
  /** The primary identifier for this record */
  id?: Maybe<Scalars['ID']['output']>
  /** The language associated with the search content */
  language?: Maybe<Scalars['String']['output']>
  /** The metaphone text to search for this content ID (typically used for names) */
  metaphoneText?: Maybe<Scalars['String']['output']>
  /** The (non-metaphone) text to search for this content ID, weighted by search params */
  searchText?: Maybe<Scalars['String']['output']>
  /** A human readable id that is identifies the content in a title group */
  titleGroupId?: Maybe<Scalars['String']['output']>
  /** The title of this video in the given language with NO accented chars */
  titleUnaccented?: Maybe<Scalars['String']['output']>
  /** The date the row was last updated */
  updatedAt?: Maybe<Scalars['DateTime']['output']>
}

/** Media asset response */
export type ContentSearchListResponse = {
  __typename?: 'ContentSearchListResponse'
  /** A list of media */
  contentSearch?: Maybe<Array<Maybe<ContentSearch>>>
}

/** GraphQL content server where input  */
export type ContentSearchWhereIdInput = {
  /** Is the value equal to the field */
  eq?: InputMaybe<Scalars['ID']['input']>
  /** Is the value greater than to the field */
  gt?: InputMaybe<Scalars['ID']['input']>
  /** Is the value greater than or equal to the field */
  gte?: InputMaybe<Scalars['ID']['input']>
  /** Are the values in the field */
  in?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>
}

/** The where conditions to filter rows */
export type ContentSearchWhereInput = {
  id?: InputMaybe<ContentSearchWhereIdInput>
}

/** User entitlment */
export type ContentSet = {
  __typename?: 'ContentSet'
  /** The content set id */
  contentSetId?: Maybe<Scalars['ID']['output']>
  /** The date the row was created */
  createdAt?: Maybe<Scalars['DateTime']['output']>
  /** When true this is the default content set */
  defaultContentSet?: Maybe<Scalars['Boolean']['output']>
  /** Description of this content set */
  description?: Maybe<Scalars['String']['output']>
  /** The primary key */
  id?: Maybe<Scalars['ID']['output']>
  /** The date the row was last updated */
  updatedAt?: Maybe<Scalars['DateTime']['output']>
}

/** User info policy list response */
export type ContentSetListResponse = {
  __typename?: 'ContentSetListResponse'
  /** A list of userInfo reference */
  contentSets?: Maybe<Array<Maybe<ContentSet>>>
  /** Total number of rows found (uses a slower count query for list) */
  count?: Maybe<Scalars['Int']['output']>
  /** The limit applied to the rows */
  limit?: Maybe<Scalars['Int']['output']>
  /** The offset applied to the rows */
  offset?: Maybe<Scalars['Int']['output']>
}

/** Content set id where input type */
export type ContentSetListWhereContentSetIdInput = {
  /** Is the value equal to the field */
  eq?: InputMaybe<Scalars['ID']['input']>
  /** Is the value greater than to the field */
  gt?: InputMaybe<Scalars['ID']['input']>
  /** Is the value greater than or equal to the field */
  gte?: InputMaybe<Scalars['ID']['input']>
  /** Are the values in the field */
  in?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>
  /** Is the value less than the field */
  lt?: InputMaybe<Scalars['ID']['input']>
  /** Is the value less than or equal to the field */
  lte?: InputMaybe<Scalars['ID']['input']>
}

/** Content set id where input type */
export type ContentSetListWhereIdInput = {
  /** Is the value equal to the field */
  eq?: InputMaybe<Scalars['ID']['input']>
  /** Is the value greater than to the field */
  gt?: InputMaybe<Scalars['ID']['input']>
  /** Is the value greater than or equal to the field */
  gte?: InputMaybe<Scalars['ID']['input']>
  /** Are the values in the field */
  in?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>
  /** Is the value less than the field */
  lt?: InputMaybe<Scalars['ID']['input']>
  /** Is the value less than or equal to the field */
  lte?: InputMaybe<Scalars['ID']['input']>
}

/** User info policy where conditions to filter rows */
export type ContentSetListWhereInput = {
  /** The conten set id field where clause */
  contentSetId?: InputMaybe<ContentSetListWhereContentSetIdInput>
  /** The id field where clause */
  id?: InputMaybe<ContentSetListWhereIdInput>
}

/** Content text format options */
export enum ContentTextFormat {
  /** Format the text as HTML */
  Html = 'HTML',
  /** Format the text as markdown */
  Markdown = 'MARKDOWN',
  /** Format the text as plain text */
  PlainText = 'PLAIN_TEXT',
}

/** Return type for content update */
export type ContentUpdateResponse = {
  __typename?: 'ContentUpdateResponse'
  /** The content that was updated */
  content?: Maybe<Content>
}

/** Content bundle where input type */
export type ContentWhereBundleInput = {
  /** Is the value equal to the field */
  eq?: InputMaybe<Scalars['String']['input']>
  /** Is one of the values equal to the field */
  in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
}

/** Content content id where input type */
export type ContentWhereContentIdInput = {
  /** Is the value equal to the field */
  eq?: InputMaybe<Scalars['Int']['input']>
  /** Is the value greater than to the field */
  gt?: InputMaybe<Scalars['Int']['input']>
  /** Is the value greater than or equal to the field */
  gte?: InputMaybe<Scalars['Int']['input']>
  /** Are the values in the field */
  in?: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>
}

/** Content Policy Policy Id where input type */
export type ContentWhereContentPolicyPolicyIdInput = {
  /** Is the value equal to the field */
  eq?: InputMaybe<Scalars['Int']['input']>
  /** Is one of the values equal to the field */
  in?: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>
}

/** Content content type where input type */
export type ContentWhereContentTypeInput = {
  /** Is the value equal to the field */
  eq?: InputMaybe<Scalars['String']['input']>
  /** Are the values in the field */
  in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
}

/** Content filter type where input type */
export type ContentWhereFilterTypeInput = {
  /** Is the value equal to the field */
  eq?: InputMaybe<Scalars['String']['input']>
  /** Is the value a substring of the field */
  like?: InputMaybe<Scalars['String']['input']>
}

/** Content id where input type */
export type ContentWhereIdInput = {
  /** Is the value equal to the field */
  eq?: InputMaybe<Scalars['ID']['input']>
  /** Is the value greater than to the field */
  gt?: InputMaybe<Scalars['ID']['input']>
  /** Is the value greater than or equal to the field */
  gte?: InputMaybe<Scalars['ID']['input']>
  /** Are the values in the field */
  in?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>
}

/** Content where conditions to filter rows */
export type ContentWhereInput = {
  /** The content bundle */
  bundle?: InputMaybe<ContentWhereBundleInput>
  /** The content content id field where clause */
  contentId?: InputMaybe<ContentWhereContentIdInput>
  /** The Content Policy Policy Id of the content */
  contentPolicyPolicyId?: InputMaybe<ContentWhereContentPolicyPolicyIdInput>
  /** The content content type field where clause */
  contentType?: InputMaybe<ContentWhereContentTypeInput>
  /** The content filter type(s) using 'like' */
  filterType?: InputMaybe<ContentWhereFilterTypeInput>
  /** The id field where clause */
  id?: InputMaybe<ContentWhereIdInput>
  /** The requested language of the content */
  language?: InputMaybe<ContentWhereLanguageInput>
  /** The content path */
  path?: InputMaybe<ContentWherePathInput>
  /** The content is published */
  published?: InputMaybe<ContentWherePublishedInput>
  /** The date the content was published */
  publishedAtDate?: InputMaybe<ContentWherePublishedAtDateInput>
  /**
   * A query to filter content using search, use this with queryType to determine the type of search.
   * Search will consider the request authentication properties (country, clientAttributes, subscriptions)
   * to determine which content is available based on the content policy,
   * but does not filter based on the entire content policy which requires the applyContentPolicy flag to be true.
   */
  query?: InputMaybe<Scalars['String']['input']>
  /** Which search type to perform on the query. */
  queryType?: InputMaybe<ContentWhereQueryType>
  /** The content title */
  title?: InputMaybe<ContentWhereTitleInput>
  /** The content title group id field where clause */
  titleGroupId?: InputMaybe<ContentWhereTitleGroupIdInput>
  /** The date the content was last updated */
  updatedAt?: InputMaybe<ContentWhereUpdatedAtInput>
}

/** Content content language where input type */
export type ContentWhereLanguageInput = {
  /** Is the value equal to the field */
  eq?: InputMaybe<Scalars['String']['input']>
  /** Are the values in the field */
  in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
}

/** Content content path where input type */
export type ContentWherePathInput = {
  /** Is the value equal to the field */
  eq?: InputMaybe<Scalars['String']['input']>
  /** Is the value a case-insensitive substring of the field */
  ilike?: InputMaybe<Scalars['String']['input']>
  /** Are the values in the field */
  in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
}

export type ContentWherePublishedAtDateInput = {
  /** Is the value greater than or equal to the field */
  gte?: InputMaybe<Scalars['DateTime']['input']>
  /** Is the value less than or equal to the field */
  lte?: InputMaybe<Scalars['DateTime']['input']>
}

export type ContentWherePublishedInput = {
  /** Is the value equal to the field */
  eq?: InputMaybe<Scalars['Boolean']['input']>
}

/** The type of search to perform with the query */
export enum ContentWhereQueryType {
  /**
   * Run a full text search query
   * @deprecated Use NATURAL_LANGUAGE_SEARCH instead
   */
  FullTextSearch = 'FULL_TEXT_SEARCH',
  /** Run a natural language search query */
  NaturalLanguageSearch = 'NATURAL_LANGUAGE_SEARCH',
  /** Get recommended content for a user */
  RecommendedContent = 'RECOMMENDED_CONTENT',
}

/** Content content title group id where input type */
export type ContentWhereTitleGroupIdInput = {
  /** Is the value equal to the field */
  eq?: InputMaybe<Scalars['String']['input']>
  /** Are the values in the field */
  in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
}

/** Content title where input type */
export type ContentWhereTitleInput = {
  /** Is the value equal to the field */
  eq?: InputMaybe<Scalars['String']['input']>
  /** Is the value a case-insensitive substring of the field */
  ilike?: InputMaybe<Scalars['String']['input']>
  /** Are the values in the field */
  in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  /** Is the value a substring of the field */
  like?: InputMaybe<Scalars['String']['input']>
}

/** Content updated at where input type */
export type ContentWhereUpdatedAtInput = {
  /** Is the value greater than or equal to the field */
  gte?: InputMaybe<Scalars['DateTime']['input']>
  /** Is the value less than or equal to the field */
  lte?: InputMaybe<Scalars['DateTime']['input']>
}

export type ConversationSearchResponse = {
  __typename?: 'ConversationSearchResponse'
  conversations: Array<ConversationSearchResult>
  totalConversations: Scalars['Int']['output']
}

export type ConversationSearchResult = {
  __typename?: 'ConversationSearchResult'
  conversationId: Scalars['ID']['output']
  conversationTitle: Scalars['String']['output']
  highlightedTitle?: Maybe<Scalars['String']['output']>
  matchCount: Scalars['Int']['output']
  matchedMessages: Array<MessagePairSearchResult>
}

/** Create input for Billing Plan Grid */
export type CreateBillingPlanGridInput = {
  /** The billing plan grid billing product id in */
  billingProductIdIn?: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>
  /** The billing plan grid billing product id not in */
  billingProductIdNotIn?: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>
  /** The billing plan grid billing provider product id in */
  billingProviderProductIdIn?: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>
  /** The billing plan grid billing provider product id not in */
  billingProviderProductIdNotIn?: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>
  /** The billing plan grid country in */
  countryIn?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  /** The billing plan grid country not in */
  countryNotIn?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  /** The billing plan grid currency in */
  currencyIn?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  /** The billing plan grid currency not in */
  currencyNotIn?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  /** Whether this plan grid is the default for the given page */
  defaultPageGrid: Scalars['Boolean']['input']
  /** The billing plan grid device type in */
  deviceTypeIn?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  /** The billing plan grid device type not in */
  deviceTypeNotIn?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  /** Whether the billing plan grid is enabled */
  enabled: Scalars['Boolean']['input']
  /** The billing plan grid end date */
  endDate?: InputMaybe<Scalars['DateTime']['input']>
  /** The best value plan in the plan grid for existing members */
  existingMemberBestValueBillingProviderProductId?: InputMaybe<Scalars['Int']['input']>
  /** The first plan in the plan grid for existing members */
  existingMemberBillingProviderProductId1: Scalars['Int']['input']
  /** The second plan in the plan grid for existing members */
  existingMemberBillingProviderProductId2?: InputMaybe<Scalars['Int']['input']>
  /** The third plan in the plan grid for existing members */
  existingMemberBillingProviderProductId3?: InputMaybe<Scalars['Int']['input']>
  /** The fourth plan in the plan grid for existing members */
  existingMemberBillingProviderProductId4?: InputMaybe<Scalars['Int']['input']>
  /** The billing plan grid language in */
  languageIn?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  /** The billing plan grid language not in */
  languageNotIn?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  /** The best value plan in the plan grid for new members */
  newMemberBestValueBillingProviderProductId?: InputMaybe<Scalars['Int']['input']>
  /** The first plan in the plan grid for new members */
  newMemberBillingProviderProductId1: Scalars['Int']['input']
  /** The second plan in the plan grid for new members */
  newMemberBillingProviderProductId2?: InputMaybe<Scalars['Int']['input']>
  /** The third plan in the plan grid for new members */
  newMemberBillingProviderProductId3?: InputMaybe<Scalars['Int']['input']>
  /** The fourth plan in the plan grid for new members */
  newMemberBillingProviderProductId4?: InputMaybe<Scalars['Int']['input']>
  /** The billing plan grid page */
  page: Scalars['String']['input']
  /** The billing plan grid priority */
  priority: Scalars['Int']['input']
  /** The billing plan grid start date */
  startDate?: InputMaybe<Scalars['DateTime']['input']>
  /** The billing plan grid variant name */
  variantName?: InputMaybe<Scalars['String']['input']>
}

/** Delete input for Billing Plan Grid */
export type DeleteBillingPlanGridInput = {
  /** The billing plan grid id */
  id: Scalars['ID']['input']
}

/** Delete response for Billing Plan Grid */
export type DeleteBillingPlanGridResponse = {
  __typename?: 'DeleteBillingPlanGridResponse'
  /** Whether the delete was successful */
  success?: Maybe<Scalars['Boolean']['output']>
}

/** Deleted Billing Provider Product Pricing type */
export type DeletedBillingProviderProductPricing = {
  __typename?: 'DeletedBillingProviderProductPricing'
  /** The billing provider product id of the billing provider product pricing */
  billingProviderProductId?: Maybe<Scalars['ID']['output']>
  /** Billing Provider Product SKU */
  billingProviderProductSku?: Maybe<Scalars['String']['output']>
  /** When the row was created */
  createdAt?: Maybe<Scalars['DateTime']['output']>
  /** The billing provider product pricing currency */
  currency?: Maybe<Scalars['String']['output']>
  /** The id of the billing provider product pricing */
  id?: Maybe<Scalars['ID']['output']>
  /** The billing provider product pricing price */
  price?: Maybe<Scalars['Float']['output']>
  /** The billing provider product trial segment price */
  trialSegmentPrice?: Maybe<Scalars['Float']['output']>
  /** When the row was last updated */
  updatedAt?: Maybe<Scalars['DateTime']['output']>
  /** The UUID of the billing provider product pricing */
  uuid?: Maybe<Scalars['ID']['output']>
}

/** Name value pair for demographic data */
export type DemographicsNameValuePair = {
  __typename?: 'DemographicsNameValuePair'
  /** The name of the demographic field */
  name?: Maybe<Scalars['String']['output']>
  /** The value of the demographic field */
  value?: Maybe<Scalars['String']['output']>
}

/** Demographics response containing email and data */
export type DemographicsResponse = {
  __typename?: 'DemographicsResponse'
  /** The demographic data as name/value pairs */
  data?: Maybe<Array<Maybe<DemographicsNameValuePair>>>
  /** The email address that was queried */
  email?: Maybe<Scalars['String']['output']>
}

/** Discount code object */
export type DiscountCode = {
  __typename?: 'DiscountCode'
  /** The discount code string */
  code?: Maybe<Scalars['String']['output']>
  /** The end date of the discount code */
  endsAt?: Maybe<Scalars['DateTime']['output']>
  /** The discount code ID from Shopify */
  id?: Maybe<Scalars['ID']['output']>
  /** The start date of the discount code */
  startsAt?: Maybe<Scalars['DateTime']['output']>
  /** The discount code title */
  title?: Maybe<Scalars['String']['output']>
}

/** Discount code create input */
export type DiscountCodeCreateInput = {
  /** The amount off for the discount code */
  amountOff: Scalars['Float']['input']
  /** The discount code */
  code: Scalars['String']['input']
  /** The end date of the discount code */
  endsAt: Scalars['DateTime']['input']
  /** The minimum subtotal for the discount code */
  minimumSubtotal: Scalars['Float']['input']
  /** The start date of the discount code */
  startsAt: Scalars['DateTime']['input']
}

/** Discount code create response */
export type DiscountCodeCreateResponse = {
  __typename?: 'DiscountCodeCreateResponse'
  /** The created discount code */
  discountCode?: Maybe<DiscountCode>
  /** Error message if the mutation failed */
  errorMessage?: Maybe<Scalars['String']['output']>
  /** When true mutation was successful */
  success?: Maybe<Scalars['Boolean']['output']>
}

/** Document row */
export type Document = {
  __typename?: 'Document'
  /** All content associated to this document either directly or through media assets */
  content?: Maybe<Array<Maybe<Content>>>
  /** The date the row was created */
  createdAt?: Maybe<Scalars['DateTime']['output']>
  /** The content directly associated to this document */
  documentContent?: Maybe<Content>
  /** The document embeddings */
  documentEmbeddings?: Maybe<Array<Maybe<DocumentEmbedding>>>
  /** The media asset directly associated to this document */
  documentMediaAsset?: Maybe<MediaAsset>
  /** The size of the embedding chunks */
  embeddingChunks?: Maybe<Scalars['Int']['output']>
  /** The size of the embedding chunks overlap between chunks */
  embeddingChunksOverlap?: Maybe<Scalars['Int']['output']>
  /** A hash document last used to successfully update the emeddings */
  embeddingDocumentHash?: Maybe<Scalars['String']['output']>
  /** The model used to create the embedding e.g. text-embedding-ada-002 */
  embeddingModel?: Maybe<Scalars['String']['output']>
  /** The primary identifier for this record */
  id?: Maybe<Scalars['ID']['output']>
  /** All media assets associated to this document either directly or through content */
  mediaAssets?: Maybe<Array<Maybe<MediaAsset>>>
  /** The date the row was last updated */
  updatedAt?: Maybe<Scalars['DateTime']['output']>
}

/** Document row */
export type DocumentDocumentEmbeddingsArgs = {
  documentEmbeddings?: InputMaybe<Array<InputMaybe<DocumentEmbeddingFilterInput>>>
}

/** The output from an LLM chain */
export type DocumentAnswer = {
  __typename?: 'DocumentAnswer'
  /** The answer text */
  text?: Maybe<Scalars['String']['output']>
}

/** Document call chain response */
export type DocumentCallChainResponse = {
  __typename?: 'DocumentCallChainResponse'
  /** The answer for this chain step */
  answer?: Maybe<DocumentAnswer>
  /** A list of document embeddings returned from the search query in this chain step */
  documentEmbeddings?: Maybe<Array<Maybe<DocumentEmbedding>>>
}

/** A chain to call against the supplied templates and search results */
export type DocumentCallChainStepInput = {
  /** The chain to run */
  chain?: InputMaybe<DocumentChain>
  /** The context to load and use in the chain step */
  contextSource?: InputMaybe<DocumentContextSource>
  /** The llm to use in the chain */
  llm?: InputMaybe<DocumentLlm>
  /** The step search options */
  search?: InputMaybe<DocumentCallChainStepSearchInput>
  /** The llm temperature where higher is more creative (0.9) and lower is less creative (0.0) only used when chain is DocumentChain.PROMPT */
  temperature?: InputMaybe<Scalars['Float']['input']>
  /** The call prompt template only used when chain is DocumentChain.PROMPT */
  template?: InputMaybe<Scalars['String']['input']>
}

/** Document call chain step search input to filter search results */
export type DocumentCallChainStepSearchInput = {
  /** The limit to the number of rows */
  limit?: InputMaybe<Scalars['Int']['input']>
  /** Metadata to match document embedding using a contains operator */
  metadata?: InputMaybe<Scalars['JSON']['input']>
  /** The offset for the rows */
  offset?: InputMaybe<Scalars['Int']['input']>
  /** The search query */
  query?: InputMaybe<Scalars['String']['input']>
  /** The where conditions to filter search rows */
  where?: InputMaybe<DocumentCallPromptChainStepSearchWhere>
}

/** GraphQL document chain where input */
export type DocumentCallPromptChainStepSearchWhere = {
  /** Filter based on query relevance values */
  queryRelevance?: InputMaybe<DocumentCallPromptChainStepSearchWhereQueryRelevanceInput>
}

/** GraphQL document chain where input */
export type DocumentCallPromptChainStepSearchWhereQueryRelevanceInput = {
  /** Is the value equal to the field */
  eq?: InputMaybe<Scalars['Float']['input']>
  /** Is the value greater than to the field */
  gt?: InputMaybe<Scalars['Float']['input']>
  /** Is the value greater than or equal to the field */
  gte?: InputMaybe<Scalars['Float']['input']>
  /** Is the value less than to the field */
  lt?: InputMaybe<Scalars['Float']['input']>
  /** Is the value less than or equal to the field */
  lte?: InputMaybe<Scalars['Float']['input']>
}

/** The available chains */
export enum DocumentChain {
  /** Run a LLM prompt */
  Prompt = 'PROMPT',
  /** Run Q&A using a query */
  RetrievalQa = 'RETRIEVAL_QA',
  /** Run Q&A using multi query generate from the query */
  RetrievalQaMultiQuery = 'RETRIEVAL_QA_MULTI_QUERY',
  /** Run a summarization */
  Summarization = 'SUMMARIZATION',
}

/** The source for the context e.g. the content data media assets data or the document embedding text */
export enum DocumentContextSource {
  /** The source document content */
  Content = 'CONTENT',
  /** The document embedding text */
  DocumentText = 'DOCUMENT_TEXT',
  /** The document embedding text and any metadata which can be loaded for the relationship */
  DocumentTextAndMetadata = 'DOCUMENT_TEXT_AND_METADATA',
  /** The source document media asset provider e.g. the entire text track (closed caption) */
  MediaAssetProvider = 'MEDIA_ASSET_PROVIDER',
}

/** Document embedding row */
export type DocumentEmbedding = {
  __typename?: 'DocumentEmbedding'
  /** The date the row was created */
  createdAt?: Maybe<Scalars['DateTime']['output']>
  /** The document for this document embedding */
  document?: Maybe<Document>
  /** A hash document last used to successfully update the emeddings */
  documentNumber?: Maybe<Scalars['Int']['output']>
  /** The content that was the source for this document emebdding */
  documentSourceContent?: Maybe<Content>
  /** The content that is the feature media for this document embedding */
  documentSourceContentFeatured?: Maybe<Content>
  /** The content of type series that is the feature media for this document embedding */
  documentSourceContentFeaturedSeries?: Maybe<Content>
  /** The media asset that was the source for this document emebdding */
  documentSourceMediaAsset?: Maybe<MediaAsset>
  /** The model used to create the embedding e.g. text-embedding-ada-002 */
  documentText?: Maybe<Scalars['String']['output']>
  /** The primary identifier for this record */
  documentsId?: Maybe<Scalars['ID']['output']>
  /** The document embedding */
  embedding?: Maybe<Array<Maybe<Scalars['Float']['output']>>>
  /** The document embedding text language */
  language?: Maybe<Scalars['String']['output']>
  /** The document embedding metadata for this item */
  metadata?: Maybe<DocumentEmbeddingMetadata>
  /** The document relevance to the user query */
  queryRelevance?: Maybe<Scalars['Float']['output']>
  /** The content related to this document embedding by metadata documentSource relatedContent */
  relatedContent?: Maybe<Array<Maybe<Content>>>
  /** The media assets related to this document embedding by metadata documentSource relatedMediaAssets */
  relatedMediaAssets?: Maybe<Array<Maybe<MediaAsset>>>
  /** Document embedding similar to this one based on cosine similarity */
  similarDocumentEmbeddings?: Maybe<Array<Maybe<DocumentEmbedding>>>
  /** The date the row was last updated */
  updatedAt?: Maybe<Scalars['DateTime']['output']>
}

/** Document embedding row */
export type DocumentEmbeddingSimilarDocumentEmbeddingsArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>
  offset?: InputMaybe<Scalars['Int']['input']>
}

/** Document embedding filtering */
export type DocumentEmbeddingFilterInput = {
  /** Document embedding filtering */
  metadata?: InputMaybe<Scalars['JSON']['input']>
}

/** Document embedding row metadata */
export type DocumentEmbeddingMetadata = {
  __typename?: 'DocumentEmbeddingMetadata'
  /** The document source for the metadata */
  documentSource?: Maybe<DocumentEmbeddingMetadataDocumentSource>
  /** The document embedding text language */
  language?: Maybe<Scalars['String']['output']>
}

/** Document embedding row metadata document source data */
export type DocumentEmbeddingMetadataDocumentSource = {
  __typename?: 'DocumentEmbeddingMetadataDocumentSource'
  /** The column in the datastore */
  column?: Maybe<Scalars['String']['output']>
  /** The content which the document embedding was created from */
  content?: Maybe<DocumentEmbeddingMetadataDocumentSourceContent>
  /** The content that is the feature media for this document embedding */
  contentFeatured?: Maybe<DocumentEmbeddingMetadataDocumentSourceContent>
  /** The content of type series that is the feature media for this document embedding */
  contentFeaturedSeries?: Maybe<DocumentEmbeddingMetadataDocumentSourceContent>
  /** The datastore */
  datastore?: Maybe<DocumentEmbeddingMetadataDocumentSourceDatastore>
  /** The content which the document embedding was created from */
  mediaAsset?: Maybe<DocumentEmbeddingMetadataDocumentSourceMediaAsset>
  /** Related datastore data */
  related?: Maybe<Array<Maybe<DocumentEmbeddingMetadataDocumentSourceRelated>>>
  /** Related content */
  relatedContent?: Maybe<Array<Maybe<DocumentEmbeddingMetadataDocumentSourceContent>>>
  /** Related media assets */
  relatedMediaAssets?: Maybe<Array<Maybe<DocumentEmbeddingMetadataDocumentSourceMediaAsset>>>
  /** The table name in the datastore */
  table?: Maybe<DocumentEmbeddingMetadataDocumentSourceTable>
  /** The column value in the datastore */
  value?: Maybe<Scalars['String']['output']>
}

/** Document embedding row metadata document source content */
export type DocumentEmbeddingMetadataDocumentSourceContent = {
  __typename?: 'DocumentEmbeddingMetadataDocumentSourceContent'
  /** The content content id */
  contentId?: Maybe<Scalars['String']['output']>
  /** The content content type */
  contentType?: Maybe<Scalars['String']['output']>
  /** The content day number */
  dayNumber?: Maybe<Scalars['String']['output']>
  /** The content episode number */
  episodeNumber?: Maybe<Scalars['String']['output']>
  /** The content id */
  id?: Maybe<Scalars['ID']['output']>
  /** The content language */
  language?: Maybe<Scalars['String']['output']>
  /** The content path */
  path?: Maybe<Scalars['String']['output']>
  /** The content published at date */
  publishedAtDate?: Maybe<Scalars['DateTime']['output']>
  /** The content season number */
  seasonNumber?: Maybe<Scalars['String']['output']>
  /** The content title group id */
  titleGroupId?: Maybe<Scalars['String']['output']>
}

/** Document embedding row metadata document source content input */
export type DocumentEmbeddingMetadataDocumentSourceContentInput = {
  /** The content content id */
  contentId?: InputMaybe<Scalars['String']['input']>
  /** The content content type */
  contentType?: InputMaybe<Scalars['String']['input']>
  /** The content day number */
  dayNumber?: InputMaybe<Scalars['String']['input']>
  /** The content episode number */
  episodeNumber?: InputMaybe<Scalars['String']['input']>
  /** The content id */
  id?: InputMaybe<Scalars['ID']['input']>
  /** The content language */
  language?: InputMaybe<Scalars['String']['input']>
  /** The content path */
  path?: InputMaybe<Scalars['String']['input']>
  /** The content published at date */
  publishedAtDate?: InputMaybe<Scalars['DateTime']['input']>
  /** The content season number */
  seasonNumber?: InputMaybe<Scalars['String']['input']>
  /** The content title group id */
  titleGroupId?: InputMaybe<Scalars['String']['input']>
}

/** Document embedding row metadata document source datastore */
export enum DocumentEmbeddingMetadataDocumentSourceDatastore {
  Database = 'DATABASE',
}

/** Document embedding row metadata document source data */
export type DocumentEmbeddingMetadataDocumentSourceInput = {
  /** The content which the document embedding was created from */
  content?: InputMaybe<DocumentEmbeddingMetadataDocumentSourceContentInput>
  /** The content which the document embedding was created from */
  mediaAsset?: InputMaybe<DocumentEmbeddingMetadataDocumentSourceMediaAssetInput>
  /** Related */
  related?: InputMaybe<Array<InputMaybe<DocumentEmbeddingMetadataDocumentSourceRelatedInput>>>
  /** Related content */
  relatedContent?: InputMaybe<
    Array<InputMaybe<DocumentEmbeddingMetadataDocumentSourceContentInput>>
  >
  /** Related media assets */
  relatedMediaAssets?: InputMaybe<
    Array<InputMaybe<DocumentEmbeddingMetadataDocumentSourceMediaAssetInput>>
  >
}

/** Document embedding row metadata document source media asset */
export type DocumentEmbeddingMetadataDocumentSourceMediaAsset = {
  __typename?: 'DocumentEmbeddingMetadataDocumentSourceMediaAsset'
  /** The media asset duration */
  duation?: Maybe<Scalars['String']['output']>
  /** The media asset id */
  id?: Maybe<Scalars['ID']['output']>
  /** The media asset language */
  language?: Maybe<Scalars['String']['output']>
  /** The media id id */
  mediaId?: Maybe<Scalars['ID']['output']>
  /** The media reference type for this media asset */
  mediaReferenceType?: Maybe<Scalars['String']['output']>
}

/** Document embedding row metadata document source media asset input */
export type DocumentEmbeddingMetadataDocumentSourceMediaAssetInput = {
  /** The media asset duration */
  duation?: InputMaybe<Scalars['String']['input']>
  /** The media asset id */
  id?: InputMaybe<Scalars['ID']['input']>
  /** The media asset language */
  language?: InputMaybe<Scalars['String']['input']>
  /** The media id id */
  mediaId?: InputMaybe<Scalars['ID']['input']>
  /** The media reference type for this media asset */
  mediaReferenceType?: InputMaybe<Scalars['String']['input']>
}

/** Document embedding row metadata document source related */
export type DocumentEmbeddingMetadataDocumentSourceRelated = {
  __typename?: 'DocumentEmbeddingMetadataDocumentSourceRelated'
  /** The column in the datastore */
  column?: Maybe<Scalars['String']['output']>
  /** The datastore */
  datastore?: Maybe<DocumentEmbeddingMetadataDocumentSourceDatastore>
  /** The table name in the datastore */
  table?: Maybe<DocumentEmbeddingMetadataDocumentSourceTable>
  /** The column value in the datastore */
  value?: Maybe<Scalars['String']['output']>
}

/** Document embedding row metadata document source related input */
export type DocumentEmbeddingMetadataDocumentSourceRelatedInput = {
  /** The column in the datastore */
  column?: InputMaybe<Scalars['String']['input']>
  /** The datastore */
  datastore?: InputMaybe<DocumentEmbeddingMetadataDocumentSourceDatastore>
  /** The table name in the datastore */
  table?: InputMaybe<DocumentEmbeddingMetadataDocumentSourceTable>
  /** The column value in the datastore */
  value?: InputMaybe<Scalars['String']['input']>
}

/** Document embedding row metadata document source datastore */
export enum DocumentEmbeddingMetadataDocumentSourceTable {
  Content = 'CONTENT',
  Media = 'MEDIA',
  MediaAssets = 'MEDIA_ASSETS',
}

/** Document embedding row metadata input */
export type DocumentEmbeddingMetadataInput = {
  /** The document source for the metadata */
  documentSource?: InputMaybe<DocumentEmbeddingMetadataDocumentSourceInput>
  /** The document embedding text language */
  language?: InputMaybe<Scalars['String']['input']>
}

/** Document embedding where id input */
export type DocumentEmbeddingWhereDocumentNumberInput = {
  /** Is the value equal to the field */
  eq?: InputMaybe<Scalars['ID']['input']>
  /** Is the value greater than to the field */
  gt?: InputMaybe<Scalars['ID']['input']>
  /** Is the value greater than or equal to the field */
  gte?: InputMaybe<Scalars['ID']['input']>
  /** Is the value in the list of values */
  in?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>
  /** Is the value less than to the field */
  lt?: InputMaybe<Scalars['ID']['input']>
  /** Is the value less than or equal to the field */
  lte?: InputMaybe<Scalars['ID']['input']>
}

/** Document embedding where id input */
export type DocumentEmbeddingWhereDocumentsIdInput = {
  /** Is the value equal to the field */
  eq?: InputMaybe<Scalars['ID']['input']>
  /** Is the value greater than to the field */
  gt?: InputMaybe<Scalars['ID']['input']>
  /** Is the value greater than or equal to the field */
  gte?: InputMaybe<Scalars['ID']['input']>
  /** Is the value in the list of values */
  in?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>
  /** Is the value less than to the field */
  lt?: InputMaybe<Scalars['ID']['input']>
  /** Is the value less than or equal to the field */
  lte?: InputMaybe<Scalars['ID']['input']>
}

/** The document emebdding where input */
export type DocumentEmbeddingWhereInput = {
  /** The document number field where clause */
  documentNumber?: InputMaybe<DocumentEmbeddingWhereDocumentNumberInput>
  /** The documents id field where clause */
  documentsId?: InputMaybe<DocumentEmbeddingWhereDocumentsIdInput>
  /** The document embedding language */
  language?: InputMaybe<DocumentEmbeddingWhereLanguageInput>
  /** The metadata field where clause */
  metadata?: InputMaybe<DocumentEmbeddingWhereMetadataInput>
}

/** Document embedding where id input */
export type DocumentEmbeddingWhereLanguageInput = {
  /** Is the value equal to the field */
  eq?: InputMaybe<Scalars['ID']['input']>
  /** Is the value in the list of values */
  in?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>
}

/** GraphQL document embedding metadata where input */
export type DocumentEmbeddingWhereMetadataInput = {
  /** The field contains the value */
  contains?: InputMaybe<DocumentEmbeddingMetadataInput>
}

/** Documents list response */
export type DocumentEmbeddingsListResponse = {
  __typename?: 'DocumentEmbeddingsListResponse'
  /** Total number of rows of content found (uses a slower count query for list) */
  count?: Maybe<Scalars['Int']['output']>
  /** Document embeddings */
  documentEmbeddings?: Maybe<Array<Maybe<DocumentEmbedding>>>
  /** The limit applied to the rows */
  limit?: Maybe<Scalars['Int']['output']>
  /** The offset applied to the rows */
  offset?: Maybe<Scalars['Int']['output']>
}

/** The available LLMs for use in a chain */
export enum DocumentLlm {
  /** The OpenAI LLM */
  Openai = 'OPENAI',
}

/** Document multi query response */
export type DocumentMultiQueryResponse = {
  __typename?: 'DocumentMultiQueryResponse'
  /** Alternative queries to the provide query */
  query?: Maybe<Array<Maybe<Scalars['String']['output']>>>
}

/** An emedding generate using a query */
export type DocumentQueryEmbeddingResponse = {
  __typename?: 'DocumentQueryEmbeddingResponse'
  queryEmbedding?: Maybe<Array<Maybe<Scalars['Float']['output']>>>
}

/** GraphQL document chain where input */
export type DocumentWhereIdInput = {
  /** Is the value equal to the field */
  eq?: InputMaybe<Scalars['ID']['input']>
  /** Is the value greater than to the field */
  gt?: InputMaybe<Scalars['ID']['input']>
  /** Is the value greater than or equal to the field */
  gte?: InputMaybe<Scalars['ID']['input']>
  /** Is the value less than to the field */
  lt?: InputMaybe<Scalars['ID']['input']>
  /** Is the value less than or equal to the field */
  lte?: InputMaybe<Scalars['ID']['input']>
}

/** The document where input */
export type DocumentWhereInput = {
  /** The id field where clause */
  id?: InputMaybe<DocumentWhereIdInput>
}

/** Documents list response */
export type DocumentsListResponse = {
  __typename?: 'DocumentsListResponse'
  /** Total number of rows of content found (uses a slower count query for list) */
  count?: Maybe<Scalars['Int']['output']>
  /** Documents */
  documents?: Maybe<Array<Maybe<Document>>>
  /** The limit applied to the rows */
  limit?: Maybe<Scalars['Int']['output']>
  /** The offset applied to the rows */
  offset?: Maybe<Scalars['Int']['output']>
}

/** Documents worker reset response */
export type DocumentsWorkerResetResponse = {
  __typename?: 'DocumentsWorkerResetResponse'
  /** Will be true if reset was successful */
  success?: Maybe<Scalars['Boolean']['output']>
  /** The worker that was reset */
  worker?: Maybe<Worker>
}

/** Ecommerce Sku Mapping */
export type EcommerceSkuMapping = {
  __typename?: 'EcommerceSkuMapping'
  /** The content provider that represents the ecommerce sku primary language. It contains the content data for the sku itself. */
  contentProvider?: Maybe<ContentProvider>
  /** The contentProviderKey that maps to the content provider table record that represents this sku */
  contentProviderKey?: Maybe<Scalars['String']['output']>
  /** The content providers that represent the ecommerce sku across all languages. */
  contentProviders?: Maybe<Array<Maybe<ContentProvider>>>
  /** The content relating to the contentTitleGroupIds. Episodes may be nested in series. */
  contentRelated?: Maybe<Array<Maybe<Content>>>
  /** A list of content_title_group_id values for this sku */
  contentTitleGroupIds?: Maybe<Array<Maybe<Scalars['String']['output']>>>
  /** The date the row was created */
  createdAt?: Maybe<Scalars['DateTime']['output']>
  /** Whether to not entitle this sku to users. For example, if the sku is a tshirt, we do not want to entitle it to users. Default is false. */
  doNotEntitle?: Maybe<Scalars['Boolean']['output']>
  /** The unique sku for the given provider */
  ecommerceSku?: Maybe<Scalars['ID']['output']>
  /** The ecommerce sku mapping bonus eligibilities related to this item */
  ecommerceSkuMappingBonusEligibilities?: Maybe<Array<Maybe<EcommerceSkuMappingBonusEligibility>>>
  /** Whether this SKU mapping is enabled and available for use. Default is true. */
  enabled?: Maybe<Scalars['Boolean']['output']>
  /** The entitlement duration seconds for this sku in seconds */
  entitlementDurationSeconds?: Maybe<Scalars['Int']['output']>
  /** The ecommerce provider */
  provider?: Maybe<Scalars['ID']['output']>
  /** The title of the variant */
  title?: Maybe<Scalars['String']['output']>
  /** The date the row was last updated */
  updatedAt?: Maybe<Scalars['DateTime']['output']>
}

/** Ecommerce Sku Mapping */
export type EcommerceSkuMappingContentRelatedArgs = {
  content?: InputMaybe<Array<InputMaybe<ContentFilterInput>>>
  language?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
}

/** Ecommerce Sku Mapping */
export type EcommerceSkuMappingEcommerceSkuMappingBonusEligibilitiesArgs = {
  userCurrent?: InputMaybe<Scalars['Boolean']['input']>
}

/** Ecommerce Sku Mappings list response */
export type EcommerceSkuMappingBonusEligibilitiesListResponse = {
  __typename?: 'EcommerceSkuMappingBonusEligibilitiesListResponse'
  /** Total number of rows found (uses a slower count query for list) */
  count?: Maybe<Scalars['Int']['output']>
  /** A list of ecommerce sku mappings */
  ecommerceSkuMappingBonusEligibilities?: Maybe<Array<Maybe<EcommerceSkuMappingBonusEligibility>>>
  /** The limit applied to the rows */
  limit?: Maybe<Scalars['Int']['output']>
  /** The offset applied to the rows */
  offset?: Maybe<Scalars['Int']['output']>
}

/** Ecommerce Sku Mapping Bonus Eligibility where Ecommerce Sku input type */
export type EcommerceSkuMappingBonusEligibilitiesWhereEcommerceSkuInput = {
  /** Is the value equal to the field */
  eq?: InputMaybe<Scalars['ID']['input']>
  /** Are the values in the field */
  in?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>
}

/** Ecommerce Sku Mapping Bonus Eligibility where End Date input type */
export type EcommerceSkuMappingBonusEligibilitiesWhereEndDateInput = {
  /** Is the value greater than or equal to the field */
  gte?: InputMaybe<Scalars['ID']['input']>
  /** Is the value less than the field */
  lt?: InputMaybe<Scalars['ID']['input']>
}

/** Ecommerce Sku Mapping Bonus Eligibility where conditions to filter rows */
export type EcommerceSkuMappingBonusEligibilitiesWhereInput = {
  /** The ecommerceSku bonus eligibilities field where clause */
  ecommerceSku?: InputMaybe<EcommerceSkuMappingBonusEligibilitiesWhereEcommerceSkuInput>
  endDate?: InputMaybe<EcommerceSkuMappingBonusEligibilitiesWhereEndDateInput>
  languages?: InputMaybe<EcommerceSkuMappingBonusEligibilityWhereLanguagesInput>
  planSku?: InputMaybe<EcommerceSkuMappingBonusEligibilitiesWherePlanSkuInput>
  provider?: InputMaybe<EcommerceSkuMappingBonusEligibilitiesWhereProviderInput>
  retainOnPlanChange?: InputMaybe<EcommerceSkuMappingBonusEligibilitiesWhereRetainOnPlanChangeInput>
  startDate?: InputMaybe<EcommerceSkuMappingBonusEligibilitiesWhereStartDateInput>
}

/** Ecommerce Sku Mapping Bonus Eligibility where PlanSku input type */
export type EcommerceSkuMappingBonusEligibilitiesWherePlanSkuInput = {
  /** Is the value equal to the field */
  eq?: InputMaybe<Scalars['ID']['input']>
  /** Are the values in the field */
  in?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>
}

/** Ecommerce Sku Mapping Bonus Eligibility where Provider input type */
export type EcommerceSkuMappingBonusEligibilitiesWhereProviderInput = {
  /** Is the value equal to the field */
  eq?: InputMaybe<Scalars['ID']['input']>
  /** Are the values in the field */
  in?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>
}

/** Ecommerce Sku Mapping Bonus Eligibility where Retain On Plan Change input type */
export type EcommerceSkuMappingBonusEligibilitiesWhereRetainOnPlanChangeInput = {
  /** Is the value equal to the field */
  eq?: InputMaybe<Scalars['Boolean']['input']>
}

/** Ecommerce Sku Mapping Bonus Eligibility where Start Date input type */
export type EcommerceSkuMappingBonusEligibilitiesWhereStartDateInput = {
  /** Is the value greater than the field */
  gt?: InputMaybe<Scalars['ID']['input']>
  /** Is the value less than or equal to the field */
  lte?: InputMaybe<Scalars['ID']['input']>
}

/** Ecommerce SKU Mapping Bonus Eligibility */
export type EcommerceSkuMappingBonusEligibility = {
  __typename?: 'EcommerceSkuMappingBonusEligibility'
  /** The BillingProviderProduct that bestows this ecommerce sku */
  billingProviderProduct?: Maybe<BillingProviderProduct>
  /** The date the row was created */
  createdAt?: Maybe<Scalars['DateTime']['output']>
  /** The description of the eligibility */
  description?: Maybe<Scalars['String']['output']>
  /** The ecommerce sku */
  ecommerceSku?: Maybe<Scalars['String']['output']>
  /** The ecommerce sku mapping for this record */
  ecommerceSkuMapping?: Maybe<EcommerceSkuMapping>
  /** The end date when eligibility ends */
  endDate?: Maybe<Scalars['DateTime']['output']>
  /** The id of the ecommerce sku mapping bonus eligibility */
  id?: Maybe<Scalars['ID']['output']>
  /** A list of languages for this item */
  languages: Array<Language>
  /** An optional coupon code or gift card code to grant for marketplace */
  marketplaceCouponCode?: Maybe<Scalars['String']['output']>
  /** An optional coupon code or gift card expiration to grant for marketplace */
  marketplaceCouponCodeExpiration?: Maybe<Scalars['DateTime']['output']>
  /** The plan sku that bestows this ecommerce sku */
  planSku?: Maybe<Scalars['String']['output']>
  /** The ecommerce provider */
  provider?: Maybe<Scalars['String']['output']>
  /** Whether to retain the bonus eligibilities when the user changes plan */
  retainOnPlanChange?: Maybe<Scalars['Boolean']['output']>
  /** The start date when eligibility begins */
  startDate?: Maybe<Scalars['DateTime']['output']>
  /** The date the row was last updated */
  updatedAt?: Maybe<Scalars['DateTime']['output']>
  /** The users who have this eligibility */
  userEcommerceSkuMappingBonusEligibilities?: Maybe<
    Array<Maybe<UserEcommerceSkuMappingBonusEligibility>>
  >
}

/** Ecommerce SKU Mapping Bonus Eligibility */
export type EcommerceSkuMappingBonusEligibilityUserEcommerceSkuMappingBonusEligibilitiesArgs = {
  userCurrent?: InputMaybe<Scalars['Boolean']['input']>
}

/** Ecommerce Sku Mapping Bonus Eligibility create */
export type EcommerceSkuMappingBonusEligibilityCreateInput = {
  /** Description */
  description?: InputMaybe<Scalars['String']['input']>
  /** Ecommerce Sku */
  ecommerceSku?: InputMaybe<Scalars['String']['input']>
  /** End Date */
  endDate?: InputMaybe<Scalars['DateTime']['input']>
  /** A list of languages for this item */
  languages: Array<Language>
  /** An optional coupon code or gift card code to grant for marketplace */
  marketplaceCouponCode?: InputMaybe<Scalars['String']['input']>
  /** An optional coupon code or gift card code expiration to grant for marketplace */
  marketplaceCouponCodeExpiration?: InputMaybe<Scalars['DateTime']['input']>
  /** Plan Sku */
  planSku?: InputMaybe<Scalars['String']['input']>
  /** Ecommerce Sku Provider */
  provider?: InputMaybe<Scalars['String']['input']>
  /** Whether to retain the bonus eligibilities when the user changes plan */
  retainOnPlanChange?: InputMaybe<Scalars['Boolean']['input']>
  /** Start Date */
  startDate: Scalars['DateTime']['input']
}

/** Ecommerce Sku Mapping Bonus Eligibility delete */
export type EcommerceSkuMappingBonusEligibilityDeleteByIdInput = {
  /** id required to delete */
  id: Scalars['ID']['input']
}

/** Ecommerce Sku Mapping Bonus Eligibility update */
export type EcommerceSkuMappingBonusEligibilityUpdateByIdInput = {
  /** Description */
  description?: InputMaybe<Scalars['String']['input']>
  /** End Date */
  endDate?: InputMaybe<Scalars['DateTime']['input']>
  /** id required to update */
  id: Scalars['ID']['input']
  /** A list of languages for this item */
  languages?: InputMaybe<Array<Language>>
  /** An optional coupon code or gift card code to grant for marketplace */
  marketplaceCouponCode?: InputMaybe<Scalars['String']['input']>
  /** An optional coupon code or gift card code expiration to grant for marketplace */
  marketplaceCouponCodeExpiration?: InputMaybe<Scalars['DateTime']['input']>
  /** Plan Sku */
  planSku?: InputMaybe<Scalars['String']['input']>
  /** Whether to retain the bonus eligibilities when the user changes plan */
  retainOnPlanChange?: InputMaybe<Scalars['Boolean']['input']>
  /** Start Date */
  startDate?: InputMaybe<Scalars['DateTime']['input']>
}

/** Ecommerce Sku Mapping Bonus Eligibility where Language Ids input type */
export type EcommerceSkuMappingBonusEligibilityWhereLanguagesInput = {
  /** Includes any of the values in the field */
  overlap?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>
}

/** Ecommerce Sku Mapping create */
export type EcommerceSkuMappingCreateInput = {
  /** The contentProviderKey that maps to the content provider table record that represents this sku - this is immutable once created and will populate with a uuid if left out */
  contentProviderKey?: InputMaybe<Scalars['String']['input']>
  /** A list of content_title_group_id values for this sku */
  contentTitleGroupIds: Array<InputMaybe<Scalars['String']['input']>>
  /** Whether to not entitle this sku to users. For example, if the sku is a tshirt, we do not want to entitle it to users. */
  doNotEntitle?: InputMaybe<Scalars['Boolean']['input']>
  /** Ecommerce Sku */
  ecommerceSku: Scalars['String']['input']
  /** Whether this SKU mapping is enabled and available for use */
  enabled?: InputMaybe<Scalars['Boolean']['input']>
  /** The entitlement duration seconds for this sku in seconds */
  entitlementDurationSeconds?: InputMaybe<Scalars['Int']['input']>
  /** The languages of the content that represents this sku. If not provided, the primary language will be used. */
  languages?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  /** The primaryLanguage of the content that represents this sku - this is immutable once created */
  primaryLanguage: Scalars['String']['input']
  /** Ecommerce Sku Provider */
  provider: Scalars['String']['input']
  /** The title of the ecommmerce sku */
  title: Scalars['String']['input']
}

/** Ecommerce Sku Mapping update */
export type EcommerceSkuMappingUpdateByProviderAndEcommerceSkuInput = {
  /** A list of content_title_group_id values for this sku */
  contentTitleGroupIds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  /** Whether to not entitle this sku to users. For example, if the sku is a tshirt, we do not want to entitle it to users. */
  doNotEntitle?: InputMaybe<Scalars['Boolean']['input']>
  /** Ecommerce Sku required to update */
  ecommerceSku: Scalars['String']['input']
  /** Whether this SKU mapping is enabled and available for use */
  enabled?: InputMaybe<Scalars['Boolean']['input']>
  /** The entitlement duration seconds for this sku in seconds */
  entitlementDurationSeconds?: InputMaybe<Scalars['Int']['input']>
  /** Additional languages of the content that represents this sku. If languages already exist but are not provided, they will not be removed. */
  languages?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  /** Ecommerce Sku Provider required to update */
  provider: Scalars['String']['input']
  /** The title of the ecommmerce sku */
  title?: InputMaybe<Scalars['String']['input']>
}

/** Ecommerce Sku Mappings list response */
export type EcommerceSkuMappingsListResponse = {
  __typename?: 'EcommerceSkuMappingsListResponse'
  /** Total number of rows found (uses a slower count query for list) */
  count?: Maybe<Scalars['Int']['output']>
  /** A list of ecommerce sku mappings */
  ecommerceSkuMappings?: Maybe<Array<Maybe<EcommerceSkuMapping>>>
  /** The limit applied to the rows */
  limit?: Maybe<Scalars['Int']['output']>
  /** The offset applied to the rows */
  offset?: Maybe<Scalars['Int']['output']>
}

/** Ecommerce Sku Mapping where Content Title Group Ids input type */
export type EcommerceSkuMappingsWhereContentTitleGroupIdsInput = {
  /** Are the values in the field */
  overlap?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>
}

/** Ecommerce Sku Mapping where Do Not Entitle input type */
export type EcommerceSkuMappingsWhereDoNotEntitleInput = {
  /** Is the value equal to the field */
  eq?: InputMaybe<Scalars['Boolean']['input']>
}

/** Ecommerce Sku Mapping where Ecommerce Sku input type */
export type EcommerceSkuMappingsWhereEcommerceSkuInput = {
  /** Is the value equal to the field */
  eq?: InputMaybe<Scalars['ID']['input']>
  /** Is the value a case-insensitive substring of the field */
  ilike?: InputMaybe<Scalars['String']['input']>
  /** Are the values in the field */
  in?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>
}

/** Ecommerce Sku Mapping where Enabled input type */
export type EcommerceSkuMappingsWhereEnabledInput = {
  /** Is the value equal to the field */
  eq?: InputMaybe<Scalars['Boolean']['input']>
}

/** Ecommerce Sku Mappings where conditions to filter rows */
export type EcommerceSkuMappingsWhereInput = {
  contentTitleGroupIds?: InputMaybe<EcommerceSkuMappingsWhereContentTitleGroupIdsInput>
  doNotEntitle?: InputMaybe<EcommerceSkuMappingsWhereDoNotEntitleInput>
  /** The ecommerceSku field where clause */
  ecommerceSku?: InputMaybe<EcommerceSkuMappingsWhereEcommerceSkuInput>
  enabled?: InputMaybe<EcommerceSkuMappingsWhereEnabledInput>
  provider?: InputMaybe<EcommerceSkuMappingsWhereProviderInput>
}

/** Ecommerce Sku Mapping where Provider input type */
export type EcommerceSkuMappingsWhereProviderInput = {
  /** Is the value equal to the field */
  eq?: InputMaybe<Scalars['ID']['input']>
  /** Are the values in the field */
  in?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>
}

/** Event-specific data fields */
export type EventDataInput = {
  /** Collated test assignments (optional, may be JSON string) */
  allTestsCollated?: InputMaybe<Scalars['String']['input']>
  /** Application name (required for some events) */
  appName?: InputMaybe<Scalars['String']['input']>
  /** Application version (required for some events) */
  appVersion?: InputMaybe<Scalars['String']['input']>
  /** Array of content IDs for view content events */
  contentIds?: InputMaybe<Array<Scalars['Int']['input']>>
  /** Content name for view content events */
  contentName?: InputMaybe<Scalars['String']['input']>
  /** Content identifier for detail page clicks */
  contentTitleGroupId?: InputMaybe<Scalars['String']['input']>
  /** Content type for view content events */
  contentType?: InputMaybe<Scalars['String']['input']>
  /** Currency code (e.g., 'USD', 'EUR') */
  currency?: InputMaybe<Scalars['String']['input']>
  /** Email address for lead events */
  email?: InputMaybe<Scalars['String']['input']>
  /** External identifier */
  externalId?: InputMaybe<Scalars['String']['input']>
  /** Facebook click ID */
  fbc?: InputMaybe<Scalars['String']['input']>
  /** Facebook browser ID */
  fbp?: InputMaybe<Scalars['String']['input']>
  /** Guest phase identifier (required for some events) */
  guestPhase?: InputMaybe<Scalars['Boolean']['input']>
  /** Whether content is featured (optional) */
  isFeaturedMedia?: InputMaybe<Scalars['Boolean']['input']>
  /** Media language (optional) */
  mediaLanguage?: InputMaybe<Scalars['String']['input']>
  /** User membership status (required for some events) */
  membershipStatus?: InputMaybe<Scalars['String']['input']>
  /** Order identifier for purchase events */
  orderId?: InputMaybe<Scalars['String']['input']>
  /** Page location identifier (optional) */
  pageLocation?: InputMaybe<Scalars['String']['input']>
  /** Price amount for purchase events */
  price?: InputMaybe<Scalars['Float']['input']>
  /** Content rating (0: Dislike, 1: Like, 2: Love) */
  rating?: InputMaybe<Scalars['Int']['input']>
  /** Recommendation ID for Recombee events */
  recommId?: InputMaybe<Scalars['String']['input']>
  /** Retention Period (1M, 3M, 6M, 12M, etc) */
  retentionPeriod?: InputMaybe<Scalars['String']['input']>
  /** Row name identifier (optional) */
  rowName?: InputMaybe<Scalars['String']['input']>
  /** Row placement identifier (optional) */
  rowPlacement?: InputMaybe<Scalars['Int']['input']>
  /** Subscription tier */
  subscriptionTier?: InputMaybe<Scalars['String']['input']>
  /** Tile position number (optional) */
  tileNumber?: InputMaybe<Scalars['Int']['input']>
  /** UI element identifier (optional) */
  uiElement?: InputMaybe<Scalars['String']['input']>
  /** UI location identifier (optional) */
  uiLocation?: InputMaybe<Scalars['String']['input']>
  /** User test assignment (optional) */
  userInTest?: InputMaybe<Scalars['Boolean']['input']>
  /** User language preference (required for some events) */
  userLanguage?: InputMaybe<Scalars['String']['input']>
  /** Lifetime Value - total amount paid over the lifetime of the user */
  userLifetimeValue?: InputMaybe<Scalars['Float']['input']>
  /** Winback status */
  winback?: InputMaybe<Scalars['Boolean']['input']>
}

/** Event log input */
export type EventLogInput = {
  /** Action source (e.g., 'website') */
  actionSource?: InputMaybe<Scalars['String']['input']>
  /** Event-specific data with typed fields */
  data?: InputMaybe<EventDataInput>
  /** Optional event ID for tracking and deduplication (auto-generated if not provided) */
  eventId?: InputMaybe<Scalars['String']['input']>
  /** The event name */
  eventName: EventName
  /** Source URL where the event originated (optional, derived from referer if not provided) */
  eventSourceUrl?: InputMaybe<Scalars['String']['input']>
  /** Event timestamp (optional, defaults to now) */
  eventTime?: InputMaybe<Scalars['DateTime']['input']>
  /** Optional test ID for testing environments */
  testId?: InputMaybe<Scalars['String']['input']>
}

/** Event log response */
export type EventLogResponse = {
  __typename?: 'EventLogResponse'
  /** Response message */
  message?: Maybe<Scalars['String']['output']>
  /** Whether the event was logged successfully */
  success: Scalars['Boolean']['output']
}

/** Event name for user interaction events */
export enum EventName {
  /** User completes setting up a pause on their account */
  AccountPaused = 'AccountPaused',
  /** User completes removing the pause from their account */
  AccountUnpaused = 'AccountUnpaused',
  /** User deletes conversation from history */
  AiConversationDeleted = 'AiConversationDeleted',
  /** User adds conversation to favorites */
  AiConversationFavorited = 'AiConversationFavorited',
  /** User changes conversation label */
  AiConversationNameUpdated = 'AiConversationNameUpdated',
  /** User clicks on a conversation in sidebar */
  AiConversationOpened = 'AiConversationOpened',
  /** Fires when the user makes the first post of a session on a previously exiting thread from the full page experience */
  AiConversationResumed = 'AiConversationResumed',
  /** User clicks New Conversation button, submits text in the empty state of chat home, selects a pre prompt from AI home, submits text from the MH module, or selects a pre prompt from MH module */
  AiConversationStarted = 'AiConversationStarted',
  /** User removes conversation from favorites */
  AiConversationUnfavorited = 'AiConversationUnfavorited',
  /** Backend failure or API error */
  AiErrorResponse = 'AiErrorResponse',
  /** Failed message submission */
  AiMessageFailure = 'AiMessageFailure',
  /** AI returns a message */
  AiMessageReceived = 'AiMessageReceived',
  /** User types a message to AI from empty screen, in existing conversation, in MH module, selects a pre prompt from empty AI home or MH module, or is in voice mode and sends something that the AI responds to */
  AiMessageSent = 'AiMessageSent',
  /** User clicks on AI navigation item */
  AiNavigationClicked = 'AiNavigationClicked',
  /** Fires when user is notified that they are no longer able to enter prompts for the day */
  AiRateLimitHit = 'AiRateLimitHit',
  /** User copies a response to clipboard */
  AiResponseCopied = 'AiResponseCopied',
  /** User gives thumbs up or thumbs down */
  AiResponseFeedback = 'AiResponseFeedback',
  /** User requests a regenerated response */
  AiResponseRefresh = 'AiResponseRefresh',
  /** Fires when the text field is populate with text that the user spoke via speech to text feature */
  AiSpeechToText = 'AiSpeechToText',
  /** Chat can't interpret a prompt, BE will say something, reject */
  AiUnrecognizedInput = 'AiUnrecognizedInput',
  /** User connects to an AirPlay device */
  AirplayConnected = 'AirplayConnected',
  /** User clicks on the CTA in the anon testarossa ribbon */
  AnonRibbonClick = 'AnonRibbonClick',
  /** When the app is opened from Roku's out-of-app content search/listings */
  AppOpenFromCatalogSearch = 'AppOpenFromCatalogSearch',
  /** When the app is opened from a gaia deeplink (email, push, mobile web redirect, etc) */
  AppOpenedFromDeeplink = 'AppOpenedFromDeeplink',
  /** When the app is opened from Amazon's out-of-app content search/listings */
  AppOpenedFromFireTvSearch = 'AppOpenedFromFireTVSearch',
  /** When the app is opened from Apple's out-of-app content search/listings (Siri search) */
  AppOpenedFromSiriSearch = 'AppOpenedFromSiriSearch',
  /** User clicks a Yoga Pose link on the Yoga Home page or an Article link on the Articles page */
  ArticleClicked = 'ArticleClicked',
  /** Fires when user changes their autoplay setting (either in account or on video endscreen). User toggles on | off the Autoplay button from the Video End Screen or from Account > Settings > Display Options */
  AutoplayToggled = 'AutoplayToggled',
  /** User clicks Cancel Membership on Account page, selects Too Expensive from the Menu and clicks Change Plan on the Cancel page */
  CancelFlowChangePlanSelected = 'CancelFlowChangePlanSelected',
  /** User clicked the 'Coming Soon' CTA on the cancellation confirmation page after canceling their account */
  CancelFlowComingSoonClicked = 'CancelFlowComingSoonClicked',
  /** User clicks Cancel Membership on Account page, selects any option from the Menu and clicks Continue to Cancel on the Cancel page, clicks Keep membership and accept offer on the Offer page */
  CancelFlowFreeMonthSelected = 'CancelFlowFreeMonthSelected',
  /** User clicked reactivation link CTA on cancellation confirmation page */
  CancelFlowReactivateClicked = 'CancelFlowReactivateClicked',
  /** User clicks Cancel Membership on Account page, selects any option from the Menu on the Cancel page */
  CancelFlowReasonSelected = 'CancelFlowReasonSelected',
  /** User selects a Plan and clicks the Get Started Now button on Plan Selection page. Fires when user first selects OR selects a new plan after the initial selection */
  CheckoutBegin = 'CheckoutBegin',
  /** User clicks the edit email button in the Single Page Checkout flow in the mobile ribbon, web summary, or email section at the top */
  CheckoutEditClicked = 'CheckoutEditClicked',
  /** After a user completes the checkout process, in the confirmation page the event is fired if the user clicks the button change next to their email address */
  CheckoutUpdateEmail = 'CheckoutUpdateEmail',
  /** User clicks the Cast button in the Video Player, selects a Chromecast device and casts the video to the device */
  ChromecastConnected = 'ChromecastConnected',
  /** User clicks the Thumbs Up or Thumbs Down button */
  ContentRated = 'ContentRated',
  /** User initiates new user signup, clicks Continue button on Account Creation page */
  CreateAccountPrecursor = 'CreateAccountPrecursor',
  /** Generic event for old GA3 custom events */
  CustomEvent = 'CustomEvent',
  /** User clicks the Video or Series Title in Spotlight on the Member Home page, clicks the Title or Thumbnail on a Tile, clicks Video or Series Title in Jumbotron on Series | Episode Detail page, or clicks a Video Title in the Episode List, Related Tab, Recommended Next Video Tile, Just Finished Video, Notifications Menu, or Notifications page */
  DetailPageClicked = 'DetailPageClicked',
  /** This fires when auto-sync with BE prevents the user from creating a second billing */
  DoubleSignupPreventedEntSync = 'DoubleSignupPreventedEntSync',
  /** This fires when the user deletes a downloaded video off their device */
  DownloadDeleted = 'DownloadDeleted',
  /** User submits an email in an email form outside of checkout flow. Anonymous user clicks a Gaia Share Link, enters an email address and submits */
  EmailCaptured = 'EmailCaptured',
  /** User enters their email on the Share Email Capture page */
  EmailCapturedShare = 'EmailCapturedShare',
  /** This event fires when a logged in user toggles email permissions in account. User toggles on | off the Email Subscription button from Account > Settings > Communications */
  EmailPermissionToggled = 'EmailPermissionToggled',
  /** This fires when the anon user taps the explore button at the end of the intro-screens and goes to the anon homepage */
  ExploreTapped = 'ExploreTapped',
  /** User applies a filter on a Topic page, Series | Person page, Films & Docs page, All Yoga Practices | Yoga Person page, or All Meditation | Meditation Person page */
  FilterApplied = 'FilterApplied',
  /** User clicks the Edit button, clicks the Red X button on one or more Video Tiles and clicks the Done button on Watch History page */
  ItemRemovedFromHistory = 'ItemRemovedFromHistory',
  /** Anon user changes Site Language from Nav Globe or Footer. Logged in user changes Site Language from Nav Globe or Footer or from Account > Settings > Language */
  LanguageChanged = 'LanguageChanged',
  /** Fires when the user clicks on 'Send Me The Code' after selecting 'Log In With A Code' in the LogIn modal */
  LogInEmailRequested = 'LogInEmailRequested',
  /** User clicks any item in the Top Navigation Menu */
  NavClicked = 'NavClicked',
  /** User clicks the Bell Icon to open the Notifications Menu then clicks the Manage link */
  NotificationsManageClicked = 'NotificationsManageClicked',
  /** User clicks the Bell Icon to open the Notifications Menu */
  NotificationsOpened = 'NotificationsOpened',
  /** User clicks the Bell Icon to open the Notifications Menu then clicks the View All link */
  NotificationsViewAllClicked = 'NotificationsViewAllClicked',
  /** User hits button to download a video to their device */
  OfflineDownloadStarted = 'OfflineDownloadStarted',
  /** User reaches final on-boarding screen */
  OnBoardingCompleted = 'OnBoardingCompleted',
  /** Currently deprecated, but would fire when user clicks skip button during on-boarding */
  OnboardingSkipped = 'OnboardingSkipped',
  /** Fires once when a user is bucketed into an Optimizely experiment variation, indicating successful enrollment in the test */
  OptimizelyFeatureTestEnrollment = 'OptimizelyFeatureTestEnrollment',
  /** The event fires when a user pays with paypal */
  PayPalPopupOpened = 'PayPalPopupOpened',
  /** User clicks the Enter Payment Info button on Billing page. When Adyen iFrame detects locations and displays actual payment options. Happens automatically after a plan is selected */
  PaymentInfoPageViewed = 'PaymentInfoPageViewed',
  /** User clicks the See Plans button on Plan Selection page */
  PlanSelectPrecursor = 'PlanSelectPrecursor',
  /** User clicks Play button from Spotlight, Tile, Detail page, Video Player, Watch Later | Favorites | Watch History, Custom Playlist, Topic page, All Series page, Recently Added page, Films & Docs page, Recipes page, Yoga & Meditation page, All Yoga | All Meditations page, Person page, Programs | Lifestyle | Pilates & More, Search page, Episode List, Related tab, Recommended Next Tile on Video End Screen, or Video Autoplay on the Recommended Next Tile. User clicks Watch Now button in Jumbotron, for a Video in the Notifications Menu, or for a Video in the Notifications List page */
  PlayClick = 'PlayClick',
  /** User toggles on | off the Video Player Info button from within the Video Player or from Account > Settings > Display Options */
  PlayerInfoToggled = 'PlayerInfoToggled',
  /** User clicks Add to Playlist button from Spotlight, Tile, Detail Page or Video Player, clicks Create New Playlist and enters a New Playlist Name and clicks Save New Playlist. User clicks Create New Playlist button on My Library page and enters a New Playlist Name and clicks Save New Playlist */
  PlaylistCreated = 'PlaylistCreated',
  /** User selects a Custom Playlist and clicks the Delete button on the My Library page */
  PlaylistDeleted = 'PlaylistDeleted',
  /** Fires when API request to add a video or series to a playlist is fired. User clicks Add to Playlist button from Spotlight, Tile, Detail Page or Video Player and checks a Checkbox for a Playlist */
  PlaylistItemAdded = 'PlaylistItemAdded',
  /** Fires when API request to remove a video or series from a playlist is fired. User clicks Add to Playlist button from Spotlight, Tile, Detail Page or Video Player and unchecks a Checkbox for the Playlist the video is in. User selects any Playlist on the My Library page, clicks the Edit button, clicks the Red X Button on any number of Tiles, then clicks Done */
  PlaylistItemRemoved = 'PlaylistItemRemoved',
  /** User selects a Custom Playlist and clicks the Share button on the My Library page */
  PlaylistShared = 'PlaylistShared',
  /** User clicks the Preview button to watch a preview video */
  PreviewPlayed = 'PreviewPlayed',
  /** User clicks on a Product tile and links out to marketplace */
  ProductTileClicked = 'ProductTileClicked',
  /** User clicks the CTA button on a Promo Unit on Member Home page */
  PromoUnitClick = 'PromoUnitClick',
  /** User sees a Promo Unit on Member Home page */
  PromoUnitImpression = 'PromoUnitImpression',
  /** User purchase a plan upgrade */
  PurchasePlanUpgrade = 'PurchasePlanUpgrade',
  /** User reactivates their account after cancellation or lapse */
  PurchaseReactivation = 'PurchaseReactivation',
  /** User loads a Row on Member Home page or clicks an Arrow button for a Row on Member Home page */
  RowImpression = 'RowImpression',
  /** User selects any Content Languages options from Account > Settings > Language */
  SecondaryLanguageChanged = 'SecondaryLanguageChanged',
  /** User clicks the Follow Series button from a Series | Episode Detail page or from the Notifications Menu or Notifications page */
  SeriesFollowed = 'SeriesFollowed',
  /** User clicks the Unfollow Series button from a Series | Video Detail page or clicks the Unfollow button from the Notifications Menu or Notifications page */
  SeriesUnfollowed = 'SeriesUnfollowed',
  /** OBSOLETE ON WEB APP, this step is not required anymore. User clicks Share for Free, clicks Continue to Share, clicks Generate Link button */
  ShareCompleted = 'ShareCompleted',
  /** User clicks the Share for Free button on a Detail page, clicks the Share button on Video Player, or clicks the Share button the Video End Screen */
  ShareInitiated = 'ShareInitiated',
  /** User clicks the sign up for special offer button on the Share Watch page */
  ShareOfferClicked = 'ShareOfferClicked',
  /** User toggles the mute | unmute button on the Spotlight when a Trailer is playing on Member Home */
  SpotlightAudioToggle = 'SpotlightAudioToggle',
  /** User loads the Spotlight on Member Home page, and the content is a merch campaign, auto recommendation, content impression, or promoting a live event */
  SpotlightImpression = 'SpotlightImpression',
  /** User toggles the play | pause button on the Spotlight when a Trailer is playing on Member Home */
  SpotlightPlayToggle = 'SpotlightPlayToggle',
  /** User clicks the button to collapse or expand the Spotlight on Member Home page or toggles on | off the Homepage Promotions button from Account > Settings > Display Options */
  SpotlightToggled = 'SpotlightToggled',
  /** User clicks on the Start Free Trial button */
  StartFreeTrialClicked = 'StartFreeTrialClicked',
  /** User clicks on a tag or User clicks a tag on a Video | Series Tile */
  TagClicked = 'TagClicked',
  /** Fires when a tile becomes visible on the user's screen */
  TileImpression = 'TileImpression',
  /** User clicks a sub or super topic on the browse All Topics page or clicks a Topic or Sub-topic from Topics Page */
  TopicClicked = 'TopicClicked',
  /** User Became Member */
  UserBecameMember = 'UserBecameMember',
  /** Fires after the user enters a logs in */
  UserLogin = 'UserLogin',
  /** Anon user clicks Log In Button on any page; clicks New To Gaia?... link or User opens the login modal, then clicks on the New to Gaia link */
  UserLoginNewToGaiaClick = 'UserLoginNewToGaiaClick',
  /** User enters Credit Card / Paypal and clicks the Start Membership button on Payment page */
  UserPurchase = 'UserPurchase',
  /** User purchases a plan directly to paid */
  UserPurchasedDirectToPaid = 'UserPurchasedDirectToPaid',
  /** User completes purchase of a Monthly Subscription with a Trial (also, monthly no trial, annual with/ without, gaia+) */
  UserPurchasedMonthlyWithTrial = 'UserPurchasedMonthlyWithTrial',
  /** User retained event */
  UserRetained = 'UserRetained',
  /** User enters name, email, password and clicks Continue button on Account Creation page */
  UserSignUp = 'UserSignUp',
  /** User completes a sign up during a session that started from a deeplink */
  UserSignedUpFromDeeplink = 'UserSignedUpFromDeeplink',
  /** User changes the audio language in the Video Player while a video is playing */
  VideoAudioChanged = 'VideoAudioChanged',
  /** User initiates video play from the Spotlight on Member Home, on Member Home, from a Tile on Member Home and initiates video play from the Jumbotron on the Detail page, or from any page other than Member Home; video completes and Video Endscreen appears */
  VideoCompleted = 'VideoCompleted',
  /** User initiates video play on Member Home; video plays for 25% of the total duration. User clicks a Tile on Member Home and initiates video play from the Jumbotron on the Detail page; video plays for 25% of the total duration. User initiates video play from any page other than Member Home; video plays for 25% of the total duration. User plays from the Share Watch page */
  VideoEngagedView = 'VideoEngagedView',
  /** The user watches the video for 120 seconds (any 120 seconds) */
  VideoInterestedView = 'VideoInterestedView',
  /** User initiates video play from the Spotlight on Member Home, on Member Home, from a Tile on Member Home and initiates video play from the Jumbotron on the Detail page, or from any page other than Member Home; Video Player begins video play */
  VideoLoadsAndStartsToPlay = 'VideoLoadsAndStartsToPlay',
  /** User initiates video play from the Spotlight on Member Home, on Member Home, from a Tile on Member Home and initiates video play from the Jumbotron on the Detail page, or from any page other than Member Home; Video Player launches */
  VideoPlayerOpened = 'VideoPlayerOpened',
  /** The user watches the video for 15 seconds (any 15 seconds). User initiates video play from the Spotlight on Member Home, on Member Home, from a Tile on Member Home and initiates video play from the Jumbotron on the Detail page, or from any page other than Member Home; video plays for at least 15 seconds */
  VideoQualifiedView = 'VideoQualifiedView',
  /** User changes the playback speed in the Video Player while a video is playing */
  VideoSpeedChanged = 'VideoSpeedChanged',
  /** User initiates video play; video player starts. While video is playing the user changes subtitle language or disables subtitles */
  VideoSubtitlesSet = 'VideoSubtitlesSet',
  /** User click the view more link/button for a Row on Member Home page */
  ViewMoreClicked = 'ViewMoreClicked',
}

/**
 * Image represents an image file that can be associated with content.
 *
 * IMPORTANT: Assets are PREFERRED over Images for accessing content-related images.
 * - Assets have a deterministic relationship to content through ContentAssetReference, providing
 *   a clear, predictable way to associate files with content.
 * - Images have a non-deterministic relationship to content through ImageContentRelationship,
 *   making them unsuitable for programmatic access where consistency is required.
 *
 * Images will continue to be supported for backward compatibility, but Assets should always
 * be preferred when possible. Use contentAssetReferences on Content to access images via Assets
 * instead of using imageContentRelationships.
 *
 * The Image type may link to an Asset via the asset field, but this relationship is non-deterministic.
 */
export type Image = {
  __typename?: 'Image'
  /**
   * The asset associated with this image (if one exists).
   * NOTE: Assets are preferred over Images. Assets have a deterministic relationship to content, while Images have a non-deterministic relationship.
   * Use Assets via contentAssetReferences on Content instead.
   */
  asset?: Maybe<Asset>
  /** The asset associated with this image */
  assetsId?: Maybe<Scalars['Int']['output']>
  /** Image Content Relationship primay key */
  contentRelationshipId?: Maybe<Scalars['ID']['output']>
  /** The date the row was created */
  createdAt?: Maybe<Scalars['DateTime']['output']>
  /** The file extension */
  fileExtension?: Maybe<Scalars['String']['output']>
  /** The file size in bytes */
  fileSize?: Maybe<Scalars['Int']['output']>
  /** The key for the image on the file system */
  fileSystemKey?: Maybe<Scalars['String']['output']>
  /** The hash of the image file */
  hash?: Maybe<Scalars['String']['output']>
  /** The height of the image in pixels */
  height?: Maybe<Scalars['String']['output']>
  /** The primary identifier for this record */
  id?: Maybe<Scalars['ID']['output']>
  /** Image content relationship linked to this image */
  imageContentRelationship?: Maybe<ImageContentRelationship>
  /** The file mime type */
  mimeType?: Maybe<Scalars['String']['output']>
  /** The original file name that was uploaded for this image */
  originalFileName?: Maybe<Scalars['String']['output']>
  /** The provider of this image */
  provider?: Maybe<Scalars['String']['output']>
  /** The key used to access this image using the provider interface */
  providerKey?: Maybe<Scalars['String']['output']>
  /** The render provider e.g. the render url which is returned to the apps */
  renderUrlProvider?: Maybe<Scalars['String']['output']>
  /** The date the row was last updated */
  updatedAt?: Maybe<Scalars['DateTime']['output']>
  /** The image render url to be used when displaying an image */
  url?: Maybe<Scalars['String']['output']>
  /** The width of the image in pixels */
  width?: Maybe<Scalars['String']['output']>
}

/** Image content relationship */
export type ImageContentRelationship = {
  __typename?: 'ImageContentRelationship'
  /** The content title_group_id column linking from this image relationship to content */
  contentTitleGroupId?: Maybe<Scalars['String']['output']>
  /** The date the row was created */
  createdAt?: Maybe<Scalars['DateTime']['output']>
  /** The Drupal 6 Content Type which is combined with d6Id for Drupal look ups */
  d6ContentType?: Maybe<Scalars['String']['output']>
  /** The Drupal 6 Id which is combined with d6ContentType for Drupal look ups */
  d6Id?: Maybe<Scalars['Int']['output']>
  /** The primary identifier for this record */
  id?: Maybe<Scalars['ID']['output']>
  /** The image linked from this image content relationship */
  image?: Maybe<Image>
  /** The this is the default image for the content i.e. the source image */
  isSource?: Maybe<Scalars['Boolean']['output']>
  /** The language this image is meant to statisfy in the relationship */
  language?: Maybe<Scalars['String']['output']>
  /** The type of relationship between the image and content */
  type?: Maybe<Scalars['String']['output']>
  /** The date the row was last updated */
  updatedAt?: Maybe<Scalars['DateTime']['output']>
}

/** Image content relationship by content input */
export type ImageContentRelationshipByContentInput = {
  /** The content content id */
  contentId?: InputMaybe<Scalars['Int']['input']>
  /** The content content type */
  contentType?: InputMaybe<Scalars['String']['input']>
  /** The image content relationship types */
  types?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
}

/** Image content relationship where contentTitleGroupId input */
export type ImageContentRelationshipWhereContentTitleGroupIdInput = {
  /** Is the value equal to the field */
  eq?: InputMaybe<Scalars['String']['input']>
  /** Are the values in the field */
  in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
}

/** Image content relationship where d6ContentType input */
export type ImageContentRelationshipWhereD6ContentTypeInput = {
  /** Is the value equal to the field */
  eq?: InputMaybe<Scalars['String']['input']>
  /** Are the values in the field */
  in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
}

/** Image content relationship where d6Id input */
export type ImageContentRelationshipWhereD6IdInput = {
  /** Is the value equal to the field */
  eq?: InputMaybe<Scalars['Int']['input']>
  /** Is the value greater than the field */
  gt?: InputMaybe<Scalars['Int']['input']>
  /** Are the values in the field */
  in?: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>
  /** Is the value less than the field */
  let?: InputMaybe<Scalars['Int']['input']>
}

/** Image content relationship where id input */
export type ImageContentRelationshipWhereIdInput = {
  /** Is the value equal to the field */
  eq?: InputMaybe<Scalars['ID']['input']>
  /** Are the values in the field */
  in?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>
}

/** Image content relationship where input */
export type ImageContentRelationshipWhereInput = {
  /** Image content relationship where content title group id clause */
  contentTitleGroupId?: InputMaybe<ImageContentRelationshipWhereContentTitleGroupIdInput>
  /** Image content relationship where d6 id clause */
  d6ContentType?: InputMaybe<ImageContentRelationshipWhereD6ContentTypeInput>
  /** Image content relationship where d6 id clause */
  d6Id?: InputMaybe<ImageContentRelationshipWhereD6IdInput>
  /** Image content relationship where id clause */
  id?: InputMaybe<ImageContentRelationshipWhereIdInput>
  /** Image content relationship where language clause */
  language?: InputMaybe<ImageContentRelationshipWhereLanguageInput>
  /** Image content relationship where type clause */
  type?: InputMaybe<ImageContentRelationshipWhereTypeInput>
}

/** Image content relationship where language input */
export type ImageContentRelationshipWhereLanguageInput = {
  /** Is the value equal to the field */
  eq?: InputMaybe<Scalars['ID']['input']>
  /** Are the values in the field */
  in?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>
}

/** Image content relationship where type input */
export type ImageContentRelationshipWhereTypeInput = {
  /** Is the value equal to the field */
  eq?: InputMaybe<Scalars['ID']['input']>
  /** Are the values in the field */
  in?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>
}

/** Image content relationship response */
export type ImageContentRelationshipsListResponse = {
  __typename?: 'ImageContentRelationshipsListResponse'
  /** A list of image content relationships */
  imageContentRelationships?: Maybe<Array<Maybe<ImageContentRelationship>>>
}

/** Image providers */
export enum ImageProviders {
  /** AWS S3 */
  AwsS3 = 'AWS_S3',
  /** The imgIX image service */
  Imgix = 'IMGIX',
}

/** Image where id input */
export type ImageWhereIdInput = {
  /** Is the value equal to the field */
  eq?: InputMaybe<Scalars['ID']['input']>
  /** Are the values in the field */
  in?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>
}

/** Image where input */
export type ImageWhereInput = {
  /** Image where id clause */
  id?: InputMaybe<ImageWhereIdInput>
}

/** Images list response */
export type ImagesListResponse = {
  __typename?: 'ImagesListResponse'
  /** A list of images */
  images?: Maybe<Array<Maybe<Image>>>
}

export enum Language {
  De = 'de',
  En = 'en',
  Es = 'es',
  Fr = 'fr',
}

/** The input for a login / renew cookie argument */
export type LoginRenewCookieInput = {
  /** The domain for the cookie where it is valid */
  domain?: InputMaybe<Scalars['String']['input']>
  /** When true include cookie information the the token data that is returned */
  include?: InputMaybe<Scalars['Boolean']['input']>
  /** When true the cookie is considered secure */
  secure?: InputMaybe<Scalars['Boolean']['input']>
  /** When true call express cookie function to send the cookie header */
  send?: InputMaybe<Scalars['Boolean']['input']>
}

export type LoginRenewResponse = {
  __typename?: 'LoginRenewResponse'
  /** The current user authentication group, authentication tokens with values less than the current value are invalid */
  authenticationGroupId?: Maybe<Scalars['Int']['output']>
  /** The client attributes for the authentication token */
  clientAttributes?: Maybe<Array<Maybe<Scalars['String']['output']>>>
  /** The codes for the login result */
  codes?: Maybe<Array<Maybe<Scalars['String']['output']>>>
  /** The user country based on the request */
  country?: Maybe<Scalars['String']['output']>
  /** The user display name */
  displayName?: Maybe<Scalars['String']['output']>
  /** The user email address */
  email?: Maybe<Scalars['String']['output']>
  /** The date when the token expires */
  idExpires?: Maybe<Scalars['DateTime']['output']>
  /** The idToken to use in API requests */
  idToken?: Maybe<Scalars['String']['output']>
  /** A JWT token to use in authentication requests */
  jwt?: Maybe<Scalars['ID']['output']>
  /** The user languages */
  language?: Maybe<Array<Maybe<Scalars['String']['output']>>>
  /** The date of the last billing event which can be used to by an application to determine if new billing data should be fetched */
  lastBillingEvent?: Maybe<Scalars['DateTime']['output']>
  /** The messages for the login result */
  messages?: Maybe<Array<Maybe<Scalars['String']['output']>>>
  /** A list of user roles ids */
  roleIds?: Maybe<Array<Maybe<Scalars['Int']['output']>>>
  /** The google subscription status */
  subscriptionStatus?: Maybe<Scalars['String']['output']>
  /** A list of user subcription ids */
  subscriptions?: Maybe<Array<Maybe<Scalars['Int']['output']>>>
  /** When true login was successful */
  success?: Maybe<Scalars['Boolean']['output']>
  /** The user uid */
  uid?: Maybe<Scalars['ID']['output']>
  /** The current user account authentication group, authentication tokens with values less than the current value are invalid */
  userAccountAuthenticationGroupId?: Maybe<Scalars['Int']['output']>
  /** The user account id */
  userAccountId?: Maybe<Scalars['ID']['output']>
  /** The user username */
  username?: Maybe<Scalars['String']['output']>
  /** The user uuid */
  uuid?: Maybe<Scalars['ID']['output']>
}

export enum MatchSourceType {
  Agent = 'AGENT',
  User = 'USER',
}

/**
 * Media represents playable media content (video/audio streams) and associated metadata.
 *
 * Media is linked to Content and contains the actual playable streams and text tracks.
 * To get the actual media files (streams, subtitles, etc.), use the mediaAssets field to get
 * MediaAsset objects, then access their url fields via HTTP requests for the most efficient access.
 */
export type Media = {
  __typename?: 'Media'
  /** Media aspect ratio */
  aspectRatio?: Maybe<Scalars['String']['output']>
  /** Media colorspace value */
  colorspace?: Maybe<Scalars['String']['output']>
  /** All of the content where this media appears as the feature */
  contentFeatured?: Maybe<Array<Maybe<Content>>>
  /** A fully qualified string identifier for the media (not content.contentId) */
  contentId?: Maybe<Scalars['String']['output']>
  /** The content policy linked to this media */
  contentPolicy?: Maybe<ContentPolicy>
  /** All of the content where this media appears as the preview */
  contentPreview?: Maybe<Array<Maybe<Content>>>
  /** The date the row was created */
  createdAt?: Maybe<Scalars['DateTime']['output']>
  /** The media duration derived from playable media asset of media reference type 'ms' */
  duration?: Maybe<Scalars['Int']['output']>
  /** Filename of input media file */
  filename?: Maybe<Scalars['String']['output']>
  /** Media framerate */
  framerate?: Maybe<Scalars['Int']['output']>
  /** A flag indicating the media has been published */
  isPublished?: Maybe<Scalars['Boolean']['output']>
  /** A list of linked media assets */
  mediaAssets?: Maybe<Array<Maybe<MediaAsset>>>
  /** Video playback data for the media asset of type media stream (ms) */
  mediaAssetsVideoPlayback?: Maybe<Array<Maybe<MediaAssetVideoPlayback>>>
  /** The primary key */
  mediaId?: Maybe<Scalars['ID']['output']>
  /** Media maestro ID */
  mediaMaestroTitleCode?: Maybe<Scalars['String']['output']>
  /** Media motion type */
  motionType?: Maybe<Scalars['String']['output']>
  /** viewing policy which can yield arrays of country codes allowed/denied */
  policyId?: Maybe<Scalars['Int']['output']>
  /** Media type */
  subtype?: Maybe<Scalars['String']['output']>
  /** The date the row was last updated */
  updatedAt?: Maybe<Scalars['DateTime']['output']>
  /** Media use (feature/trailer) */
  use?: Maybe<Scalars['Int']['output']>
  /** The user media position for the current position on this media */
  userMediaPosition?: Maybe<UserMediaPosition>
  /** Size of Video (1080, 720, etc.) */
  videoSize?: Maybe<Scalars['Int']['output']>
}

/**
 * Media represents playable media content (video/audio streams) and associated metadata.
 *
 * Media is linked to Content and contains the actual playable streams and text tracks.
 * To get the actual media files (streams, subtitles, etc.), use the mediaAssets field to get
 * MediaAsset objects, then access their url fields via HTTP requests for the most efficient access.
 */
export type MediaContentFeaturedArgs = {
  applyContentPolicy?: InputMaybe<Scalars['Boolean']['input']>
  language?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  limit?: InputMaybe<Scalars['Int']['input']>
  offset?: InputMaybe<Scalars['Int']['input']>
}

/**
 * Media represents playable media content (video/audio streams) and associated metadata.
 *
 * Media is linked to Content and contains the actual playable streams and text tracks.
 * To get the actual media files (streams, subtitles, etc.), use the mediaAssets field to get
 * MediaAsset objects, then access their url fields via HTTP requests for the most efficient access.
 */
export type MediaContentPreviewArgs = {
  applyContentPolicy?: InputMaybe<Scalars['Boolean']['input']>
  language?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  limit?: InputMaybe<Scalars['Int']['input']>
  offset?: InputMaybe<Scalars['Int']['input']>
}

/**
 * Media represents playable media content (video/audio streams) and associated metadata.
 *
 * Media is linked to Content and contains the actual playable streams and text tracks.
 * To get the actual media files (streams, subtitles, etc.), use the mediaAssets field to get
 * MediaAsset objects, then access their url fields via HTTP requests for the most efficient access.
 */
export type MediaMediaAssetsArgs = {
  language?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  languageMatchType?: InputMaybe<MediaMediaAssetsLanguageMatchType>
  mediaAssets?: InputMaybe<Array<InputMaybe<MediaMediaAssetsInput>>>
}

/**
 * Media represents playable media content (video/audio streams) and associated metadata.
 *
 * Media is linked to Content and contains the actual playable streams and text tracks.
 * To get the actual media files (streams, subtitles, etc.), use the mediaAssets field to get
 * MediaAsset objects, then access their url fields via HTTP requests for the most efficient access.
 */
export type MediaMediaAssetsVideoPlaybackArgs = {
  deliveryRule?: InputMaybe<MediaAssetVideoPlaybackDeliverRule>
  hlsVersion?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  language?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  languageMatchType?: InputMaybe<MediaMediaAssetsLanguageMatchType>
}

/**
 * Media asset represents a file associated with media (video streams, subtitles, closed captions, chapters).
 *
 * Media assets are the actual files that make up playable media content:
 * - MEDIA_STREAM: Playable video/audio streams (HLS, DASH)
 * - CLOSED_CAPTION: Closed caption text tracks (VTT format)
 * - SUBTITLE: Subtitle text tracks (VTT format)
 * - CHAPTER: Chapter marker text tracks (VTT format)
 *
 * Important Usage Notes:
 * - To get the actual media asset file, use the url field and make an HTTP GET request to that URL.
 *   This is the most efficient way to retrieve media asset data, as it leverages CDN caching and
 *   direct file access rather than going through GraphQL.
 *
 * - For text tracks (subtitles, closed captions, chapters): If you only need the raw VTT file data,
 *   it is more efficient to access the url directly via REST/HTTP rather than using GraphQL.
 *   GraphQL is better when you need parsed metadata (via providerData) or relationships, but for
 *   raw file content, direct URL access is preferred.
 */
export type MediaAsset = {
  __typename?: 'MediaAsset'
  /** The content policy linked to this media asset by the media */
  contentPolicy?: Maybe<ContentPolicy>
  /** The date the row was created */
  createdAt?: Maybe<Scalars['DateTime']['output']>
  /** An optional duration */
  duration?: Maybe<Scalars['Int']['output']>
  /** An optional height */
  height?: Maybe<Scalars['Int']['output']>
  /** The primary identifier for this record */
  id?: Maybe<Scalars['ID']['output']>
  /** The status of ingest for the provider asset */
  ingestStatus?: Maybe<Scalars['String']['output']>
  /** The language of asset that was used to create all of the translations */
  language?: Maybe<Scalars['String']['output']>
  /** The media associated with this media asset */
  media?: Maybe<Media>
  /** The media asset document linked to this media asset */
  mediaAssetDocument?: Maybe<MediaAssetDocument>
  /** The media id on the media table */
  mediaId?: Maybe<Scalars['ID']['output']>
  /** A string that describes the relationship between the asset and media e.g. cc */
  mediaReferenceType?: Maybe<Scalars['String']['output']>
  /** The mime type of the asset */
  mimeType?: Maybe<Scalars['String']['output']>
  /** The original name of the file for the asset */
  originalFileName?: Maybe<Scalars['String']['output']>
  /** The provider where the asset is stored e.g. AWS_S3 */
  provider?: Maybe<Scalars['String']['output']>
  /**
   * The media assets provider specific data (e.g., parsed VTT data).
   * This field provides structured access to parsed content like VTT cues for text tracks.
   * If you only need raw file data, use the url field with direct HTTP access instead.
   */
  providerData?: Maybe<MediaAssetProviderData>
  /** The unique key for the asset on providers system e.g. on S3 it would be file key or it might be a url for an external provider */
  providerKey?: Maybe<Scalars['String']['output']>
  /** The when true the media asset is publically available */
  published?: Maybe<Scalars['Boolean']['output']>
  /** The date the row was last updated */
  updatedAt?: Maybe<Scalars['DateTime']['output']>
  /**
   * The URL to retrieve the media asset file.
   * This is the most efficient way to get the actual media asset - make an HTTP GET request to this URL.
   * For text tracks (subtitles, closed captions, chapters), accessing this URL directly via REST
   * is preferred over GraphQL if you only need the raw VTT file data.
   */
  url?: Maybe<Scalars['String']['output']>
  /** The public primary identifier for this record */
  uuid?: Maybe<Scalars['String']['output']>
  /** Video playback data for media streams */
  videoPlayback?: Maybe<MediaAssetVideoPlayback>
  /** An optional width */
  width?: Maybe<Scalars['Int']['output']>
}

/**
 * Media asset represents a file associated with media (video streams, subtitles, closed captions, chapters).
 *
 * Media assets are the actual files that make up playable media content:
 * - MEDIA_STREAM: Playable video/audio streams (HLS, DASH)
 * - CLOSED_CAPTION: Closed caption text tracks (VTT format)
 * - SUBTITLE: Subtitle text tracks (VTT format)
 * - CHAPTER: Chapter marker text tracks (VTT format)
 *
 * Important Usage Notes:
 * - To get the actual media asset file, use the url field and make an HTTP GET request to that URL.
 *   This is the most efficient way to retrieve media asset data, as it leverages CDN caching and
 *   direct file access rather than going through GraphQL.
 *
 * - For text tracks (subtitles, closed captions, chapters): If you only need the raw VTT file data,
 *   it is more efficient to access the url directly via REST/HTTP rather than using GraphQL.
 *   GraphQL is better when you need parsed metadata (via providerData) or relationships, but for
 *   raw file content, direct URL access is preferred.
 */
export type MediaAssetVideoPlaybackArgs = {
  deliveryRule?: InputMaybe<MediaAssetVideoPlaybackDeliverRule>
  hlsVersion?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
}

/** Media asset document row that links media to a document */
export type MediaAssetDocument = {
  __typename?: 'MediaAssetDocument'
  /** The date the row was created */
  createdAt?: Maybe<Scalars['DateTime']['output']>
  /** Document linked to this media document */
  document?: Maybe<Document>
  /** The documents id */
  documentsId?: Maybe<Scalars['ID']['output']>
  /** Media asset linked to this media document */
  mediaAsset?: Maybe<MediaAsset>
  /** The media assets id */
  mediaAssetsId?: Maybe<Scalars['ID']['output']>
  /** The date the row was last updated */
  updatedAt?: Maybe<Scalars['DateTime']['output']>
}

/** Media asset response */
export type MediaAssetListResponse = {
  __typename?: 'MediaAssetListResponse'
  /** A list of media */
  mediaAssets?: Maybe<Array<Maybe<MediaAsset>>>
}

export enum MediaAssetMediaReferenceTypes {
  /** The asset represents a chapter marker */
  Chapter = 'CHAPTER',
  /** The asset represents a closed caption */
  ClosedCaption = 'CLOSED_CAPTION',
  /** The asset represents a playable media stream i.e. hls */
  MediaStream = 'MEDIA_STREAM',
  /** The asset represents a subtitle */
  Subtitle = 'SUBTITLE',
}

/** The provider specific data for the media asset e.g. parsed VTT data */
export type MediaAssetProviderData = {
  __typename?: 'MediaAssetProviderData'
  /** The provider data as text if supported */
  text?: Maybe<Scalars['String']['output']>
  /** Parsed vtt data */
  vtt?: Maybe<MediaAssetProviderDataVtt>
}

/** Parsed vtt data */
export type MediaAssetProviderDataVtt = {
  __typename?: 'MediaAssetProviderDataVtt'
  /** The parsed VTT data cues */
  cues?: Maybe<Array<Maybe<MediaAssetProviderDataVttQues>>>
}

/** The parsed VTT data cues */
export type MediaAssetProviderDataVttQues = {
  __typename?: 'MediaAssetProviderDataVttQues'
  alignment?: Maybe<Scalars['String']['output']>
  direction?: Maybe<Scalars['String']['output']>
  endTime?: Maybe<Scalars['String']['output']>
  id?: Maybe<Scalars['String']['output']>
  lineAlign?: Maybe<Scalars['String']['output']>
  linePosition?: Maybe<Scalars['String']['output']>
  pauseOnExit?: Maybe<Scalars['String']['output']>
  positionAlign?: Maybe<Scalars['String']['output']>
  size?: Maybe<Scalars['String']['output']>
  snapToLines?: Maybe<Scalars['String']['output']>
  startTime?: Maybe<Scalars['String']['output']>
  text?: Maybe<Scalars['String']['output']>
  textPosition?: Maybe<Scalars['String']['output']>
}

/** The video playback information for media assets of type media stream */
export type MediaAssetVideoPlayback = {
  __typename?: 'MediaAssetVideoPlayback'
  /** The provider DASH url */
  dashUrl?: Maybe<Scalars['String']['output']>
  /** The provider HLS url */
  hlsUrl?: Maybe<Scalars['String']['output']>
  /** The HLS stream version */
  hlsVersion?: Maybe<Scalars['String']['output']>
  /** The media asset id */
  id?: Maybe<Scalars['ID']['output']>
  /** The media asset language */
  language?: Maybe<Scalars['String']['output']>
  /** The video thumbnail url */
  thumbnailUrl?: Maybe<Scalars['String']['output']>
}

/** The video playback delivery rules */
export enum MediaAssetVideoPlaybackDeliverRule {
  /** Apply the byte range delivery rule */
  ByteRange = 'BYTE_RANGE',
}

/** The video playback delivery rules */
export enum MediaAssetVideoPlaybackHlsVersions {
  /** HLS version 3 */
  V3 = 'v3',
  /** HLS version 4 */
  V4 = 'v4',
  /** HLS version 7 */
  V7 = 'v7',
}

/** The where clause for a media asset id field */
export type MediaAssetWhereIdInput = {
  /** Is the value equal to the field */
  eq?: InputMaybe<Scalars['ID']['input']>
  /** Is the value greater than to the field */
  gt?: InputMaybe<Scalars['ID']['input']>
  /** Is the value greater than or equal to the field */
  gte?: InputMaybe<Scalars['ID']['input']>
  /** Are the values in the field */
  in?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>
  /** Is the value less than to the field */
  lt?: InputMaybe<Scalars['ID']['input']>
  /** Is the value less than or equal to the field */
  lte?: InputMaybe<Scalars['ID']['input']>
}

/** Media asset where input */
export type MediaAssetWhereInput = {
  /** Media asset where id clause */
  id?: InputMaybe<MediaAssetWhereIdInput>
  /** Media asset where mediaId clause */
  mediaId?: InputMaybe<MediaAssetWhereMediaIdInput>
  /** Media asset where mediaReferenceType clause */
  mediaReferenceType?: InputMaybe<MediaAssetWhereMediaReferenceTypenput>
}

/** The where clause for a media asset id field */
export type MediaAssetWhereMediaIdInput = {
  /** Is the value equal to the field */
  eq?: InputMaybe<Scalars['ID']['input']>
  /** Is the value greater than to the field */
  gt?: InputMaybe<Scalars['ID']['input']>
  /** Is the value greater than or equal to the field */
  gte?: InputMaybe<Scalars['ID']['input']>
  /** Are the values in the field */
  in?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>
  /** Is the value less than to the field */
  lt?: InputMaybe<Scalars['ID']['input']>
  /** Is the value less than or equal to the field */
  lte?: InputMaybe<Scalars['ID']['input']>
}

/** The where clause for a media asset media reference type field */
export type MediaAssetWhereMediaReferenceTypenput = {
  /** Is the value equal to the field */
  eq?: InputMaybe<Scalars['ID']['input']>
  /** Are the values in the field */
  in?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>
}

/** Media asset response */
export type MediaListResponse = {
  __typename?: 'MediaListResponse'
  /** Total number of rows of content found (uses a slower count query for list) */
  count?: Maybe<Scalars['Int']['output']>
  /** The limit applied to the rows */
  limit?: Maybe<Scalars['Int']['output']>
  /** A list of media */
  media?: Maybe<Array<Maybe<Media>>>
  /** The offset applied to the rows */
  offset?: Maybe<Scalars['Int']['output']>
}

/** Media filter for media assets */
export type MediaMediaAssetsInput = {
  /** The media asset language */
  language?: InputMaybe<Scalars['String']['input']>
  /** The media asset media reference type */
  mediaReferenceType?: InputMaybe<Scalars['String']['input']>
}

/** The media media assets association language match type */
export enum MediaMediaAssetsLanguageMatchType {
  /** Match any of the languages */
  Any = 'ANY',
}

/** The where conditions to filter rows */
export type MediaWhereInput = {
  /** The media content id (not content.id or content.content_id) */
  contentId?: InputMaybe<MediaWhereMediaContentIdInput>
  /** The media id */
  mediaId?: InputMaybe<MediaWhereMediaIdInput>
}

/** The where clause for a media content id field */
export type MediaWhereMediaContentIdInput = {
  /** Is the value equal to the field */
  eq?: InputMaybe<Scalars['ID']['input']>
  /** Is the value a case-insensitive substring of the field */
  ilike?: InputMaybe<Scalars['String']['input']>
  /** Are the values in the field */
  in?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>
}

/** The where clause for a media id field */
export type MediaWhereMediaIdInput = {
  /** Is the value equal to the field */
  eq?: InputMaybe<Scalars['ID']['input']>
  /** Is the value greater than to the field */
  gt?: InputMaybe<Scalars['ID']['input']>
  /** Is the value greater than or equal to the field */
  gte?: InputMaybe<Scalars['ID']['input']>
  /** Are the values in the field */
  in?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>
  /** Is the value less than to the field */
  lt?: InputMaybe<Scalars['ID']['input']>
  /** Is the value less than or equal to the field */
  lte?: InputMaybe<Scalars['ID']['input']>
}

export type MessagePairSearchResult = {
  __typename?: 'MessagePairSearchResult'
  createdAt: Scalars['DateTime']['output']
  matchSource: MatchSourceType
  messageIndexInConversation: Scalars['Int']['output']
  messagePairId: Scalars['ID']['output']
  searchRank: Scalars['Float']['output']
  snippet: Scalars['String']['output']
}

/** Oracle AI: Root mutation operations */
export type Mutation = {
  __typename?: 'Mutation'
  _empty?: Maybe<Scalars['String']['output']>
  /** Add a member to a community space (for invite-only spaces) */
  addCommunitySpaceMember?: Maybe<CommunitySpace>
  ambassadorLeadsUploadNdJsonToS3: AmbassadorLeadsUploadFileToS3Response
  /** Creates a new auth role */
  authRoleCreate: AuthRoleMutationResponse
  /** Deletes an existing auth role */
  authRoleDelete: AuthRoleMutationResponse
  /** Updates an existing auth role */
  authRoleUpdate: AuthRoleMutationResponse
  /** Create a billing events */
  billingCreateEvent?: Maybe<BillingEvent>
  /** Update a billing events */
  billingUpdateEvent?: Maybe<BillingEvent>
  /** Create a chat history */
  chatHistoryCreate?: Maybe<ChatHistoryMutationResponse>
  /** Delete a chat history */
  chatHistoryDelete?: Maybe<ChatHistoryMutationResponse>
  /** Update a chat history */
  chatHistoryUpdate?: Maybe<ChatHistoryMutationResponse>
  /** Create a chat session */
  chatSessionCreate?: Maybe<ChatSessionMutationResponse>
  /** Delete a chat session */
  chatSessionDelete?: Maybe<ChatSessionMutationResponse>
  /** Update a chat session */
  chatSessionUpdate?: Maybe<ChatSessionMutationResponse>
  /** Creates a new content asset reference */
  contentAssetReferenceCreate: ContentAssetReferenceMutationResponse
  /** Deletes an existing content asset reference */
  contentAssetReferenceDelete: ContentAssetReferenceMutationResponse
  /** Create one content list criteria */
  contentListCriteriaCreate?: Maybe<ContentListCriteriaMutationResponse>
  /** Delete one content list criteria */
  contentListCriteriaDelete?: Maybe<ContentListCriteriaMutationResponse>
  /** Create one content provider */
  contentProviderCreateByContentId?: Maybe<ContentProviderMutationResponse>
  /** Delete one content provider */
  contentProviderDeleteByContentId?: Maybe<ContentProviderMutationResponse>
  /** Update one content provider */
  contentProviderUpdateByContentId?: Maybe<ContentProviderMutationResponse>
  /** Create a content reference */
  contentReferenceCreate: ContentReferenceCreateResponse
  /**
   * Create many content references
   * - Does not error if references already exist
   */
  contentReferenceCreateMany: ContentReferenceCreateManyResponse
  /** Delete a content reference */
  contentReferenceDelete: ContentReferenceDeleteResponse
  /** Update a single piece of content */
  contentUpdate?: Maybe<ContentUpdateResponse>
  /** Mark an entire course as complete */
  courseMarkComplete: UserStateProgressCourse
  /** Mark a course module as complete */
  courseModuleMarkComplete: UserStateProgressCourseModule
  /** Reset a course (removes all progress, preserves completion count) */
  courseReset: UserStateProgressCourse
  /** Start a course (marks first video as in progress) */
  courseStart: UserStateProgressCourse
  /** Create a billing account */
  createBillingAccount: BillingAccount
  /** Create a billingInvoice */
  createBillingInvoice?: Maybe<BillingInvoice>
  /** Create a billingOneTimePurchase */
  createBillingOneTimePurchase?: Maybe<BillingOneTimePurchase>
  /** Create a billingPayment */
  createBillingPayment?: Maybe<BillingPayment>
  /** Create a billingPaymentMethod */
  createBillingPaymentMethod?: Maybe<BillingPaymentMethod>
  /** Create a billing plan grid */
  createBillingPlanGrid?: Maybe<BillingPlanGrid>
  /** Create billingProduct */
  createBillingProduct?: Maybe<BillingProduct>
  /** Create a billingProductChangeLog */
  createBillingProductChangeLog?: Maybe<BillingProductChangeLog>
  /** Create billingProvider */
  createBillingProvider?: Maybe<BillingProvider>
  /** Create billingProviderCurrency */
  createBillingProviderCurrency?: Maybe<BillingProviderCurrency>
  /** Create billingProviderProduct */
  createBillingProviderProduct?: Maybe<BillingProviderProduct>
  /** Create a billingProviderProductPricing */
  createBillingProviderProductPrice?: Maybe<BillingProviderProductPricing>
  /** Create a billingProviderProductText */
  createBillingProviderProductText?: Maybe<BillingProviderProductText>
  /** Create a billingRefund */
  createBillingRefund?: Maybe<BillingRefund>
  /** Create a billingSubscription */
  createBillingSubscription?: Maybe<BillingSubscription>
  /** Create a billingSubscriptionOrder */
  createBillingSubscriptionOrder?: Maybe<BillingSubscriptionOrder>
  /** Create a BillingSubscriptionOrderPlan */
  createBillingSubscriptionOrderPlan?: Maybe<BillingSubscriptionOrderPlan>
  /** Create a billingSubscriptionPlan */
  createBillingSubscriptionPlan?: Maybe<BillingSubscriptionPlan>
  /** Create a community comment */
  createCommunityComment?: Maybe<CommunityComment>
  /** Create a community event */
  createCommunityEvent?: Maybe<CommunityEvent>
  /** Create a community post */
  createCommunityPost?: Maybe<CommunityPost>
  /** Create a community reaction */
  createCommunityReaction?: Maybe<CommunityReaction>
  /** Create a community space */
  createCommunitySpace?: Maybe<CommunitySpace>
  /** Create a transactions */
  createTransaction?: Maybe<Transaction>
  /** Create a userAuditLog */
  createUserAuditLog?: Maybe<UserAuditLog>
  /**
   * Create a user entitlement. Typically used by administrators or customer service to manually
   * grant access. In normal operation, entitlements are created automatically when billing events
   * are processed. Requires elevated role access.
   */
  createUserEntitlement?: Maybe<UserEntitlement>
  /** Delete a billing plan grid */
  deleteBillingPlanGrid?: Maybe<DeleteBillingPlanGridResponse>
  /** Delete a billingProviderProductPricing */
  deleteBillingProviderProductPrice?: Maybe<BillingProviderProductPricingDeleteResponse>
  /** Delete a billingProviderProductText */
  deleteBillingProviderProductText?: Maybe<BillingProviderProductTextDeleteResponse>
  /** Delete a community comment */
  deleteCommunityComment?: Maybe<Scalars['Boolean']['output']>
  /** Delete a community event */
  deleteCommunityEvent?: Maybe<Scalars['Boolean']['output']>
  /** Delete a community post */
  deleteCommunityPost?: Maybe<Scalars['Boolean']['output']>
  /** Delete a community reaction */
  deleteCommunityReaction?: Maybe<Scalars['Boolean']['output']>
  /** Delete a community space */
  deleteCommunitySpace?: Maybe<Scalars['Boolean']['output']>
  /** Create a discount code in Shopify */
  discountCodeCreate?: Maybe<DiscountCodeCreateResponse>
  /** Reset the worker state for the document embeddings worker e.g. set the worker data null and truncate the rebuild table */
  documentsWorkerReset?: Maybe<DocumentsWorkerResetResponse>
  /** Create one ecommerce sku mapping bonus eligibility */
  ecommerceSkuMappingBonusEligibilityCreate?: Maybe<EcommerceSkuMappingBonusEligibilityCreateResponse>
  /** Delete one ecommerce sku mapping bonus eligibility */
  ecommerceSkuMappingBonusEligibilityDeleteById?: Maybe<EcommerceSkuMappingBonusEligibilityDeleteByIdResponse>
  /** Update one ecommerce sku mapping bonus eligibility */
  ecommerceSkuMappingBonusEligibilityUpdateById?: Maybe<EcommerceSkuMappingBonusEligibilityUpdateByIdResponse>
  /** Create one ecommerce sku mapping */
  ecommerceSkuMappingCreate?: Maybe<EcommerceSkuMappingCreateResponse>
  /** Update one ecommerce sku mapping bonus eligibility */
  ecommerceSkuMappingUpdateByProviderAndEcommerceSku?: Maybe<EcommerceSkuMappingUpdateByProviderAndEcommerceSkuResponse>
  /** Log a user interaction event */
  eventLog: EventLogResponse
  /** Oracle AI (Internal): Send a message to the AI agent with internal tool access */
  internalAgentChat: OracleAgentChatPayload
  /** Join a community space */
  joinCommunitySpace?: Maybe<CommunitySpace>
  /** Leave a community space */
  leaveCommunitySpace?: Maybe<CommunitySpace>
  /** Login a user */
  login?: Maybe<LoginRenewResponse>
  /** Oracle AI: Send a message to the AI agent with tool access */
  oracleAgentChat: OracleAgentChatPayload
  /** Oracle AI: Create a new chat session */
  oracleChatSessionCreate: OracleChatSessionCreateResponse
  /** Oracle AI: Delete a chat session */
  oracleChatSessionDelete: OracleChatSessionDeleteResponse
  /** Oracle AI: Update a chat session's favorite status */
  oracleChatSessionFavorite: OracleChatSessionFavoriteResponse
  /** Oracle AI: Rename a chat session */
  oracleChatSessionRename: OracleChatSessionRenameResponse
  /** Oracle AI: Update an existing chat session */
  oracleChatSessionUpdate: OracleChatSessionUpdateResponse
  /** Oracle AI: Create a new individual message */
  oracleMessageCreate: OracleMessageCreateResponse
  /** Oracle AI: Create a new message pair */
  oracleMessagePairCreate: OracleMessagePairCreateResponse
  /** Oracle AI: Delete a message pair */
  oracleMessagePairDelete: OracleMessagePairDeleteResponse
  /** Oracle AI: Update an existing message pair */
  oracleMessagePairUpdate: OracleMessagePairUpdateResponse
  /** Oracle AI: Update the mode of an existing message pair */
  oracleMessagePairUpdateMode: OracleMessagePairUpdateResponse
  /** Oracle AI: Create a new personality */
  oraclePersonalityCreate: OraclePersonalityCreateResponse
  /** Oracle AI: Delete a personality */
  oraclePersonalityDelete: OraclePersonalityDeleteResponse
  /** Oracle AI: Update an existing personality */
  oraclePersonalityUpdate: OraclePersonalityUpdateResponse
  /** Create one playlist */
  playlistCreate?: Maybe<PlaylistCreateResponse>
  /** Create one playlist item */
  playlistCreatePlaylistItem?: Maybe<PlaylistCreatePlaylistItemResponse>
  /** Delete one playlist */
  playlistDelete?: Maybe<PlaylistDeleteResponse>
  /** Delete one playlist item */
  playlistDeletePlaylistItem?: Maybe<PlaylistDeletePlaylistItemResponse>
  /** Update one playlist item */
  playlistUpdatePlaylistItem?: Maybe<PlaylistUpdatePlaylistItemResponse>
  /** Create a new PM Screen */
  pmScreenCreate: PmScreenCreateResponse
  /** Delete a PM Screen */
  pmScreenDelete: PmScreenDeleteResponse
  /** Update an existing PM Screen */
  pmScreenUpdate: PmScreenUpdateResponse
  /** Create a new PM Section */
  pmSectionCreate: PmSectionCreateResponse
  /** Delete a PM Section */
  pmSectionDelete: PmSectionDeleteResponse
  /** Update an existing PM Section */
  pmSectionUpdate: PmSectionUpdateResponse
  /** Register for a community event */
  registerForCommunityEvent?: Maybe<CommunityEvent>
  /** Remove a member from a community space */
  removeCommunitySpaceMember?: Maybe<CommunitySpace>
  /** Renew a user authorization token provided using authorization header */
  renew?: Maybe<LoginRenewResponse>
  s3UpsertNdjson?: Maybe<S3UpsertNdjsonResult>
  /** Oracle AI: Create a new seed question */
  seedQuestionCreate: SeedQuestionCreateResponse
  /** Oracle AI: Delete a seed question */
  seedQuestionDelete: SeedQuestionDeleteResponse
  /** Oracle AI: Update an existing seed question */
  seedQuestionUpdate: SeedQuestionUpdateResponse
  /** Sync billingProviderProducts with source system */
  syncBillingProviderProducts?: Maybe<SyncBillingProviderProductsResponse>
  /** Unregister from a community event */
  unregisterFromCommunityEvent?: Maybe<CommunityEvent>
  /** Update a billing account */
  updateBillingAccount: BillingAccount
  /** Update a billingInvoice */
  updateBillingInvoice?: Maybe<BillingInvoice>
  /** Update a billingOneTimePurchase */
  updateBillingOneTimePurchase?: Maybe<BillingOneTimePurchase>
  /** Update a billingPayment */
  updateBillingPayment?: Maybe<BillingPayment>
  /** Update a billingPaymentMethod */
  updateBillingPaymentMethod?: Maybe<BillingPaymentMethod>
  /** Update a billing plan grid */
  updateBillingPlanGrid?: Maybe<BillingPlanGrid>
  /** Update billingProduct */
  updateBillingProduct?: Maybe<BillingProduct>
  /** Update billingProvider */
  updateBillingProvider?: Maybe<BillingProvider>
  /** Update billingProviderCurrency */
  updateBillingProviderCurrency?: Maybe<BillingProviderCurrency>
  /** Update billingProviderProduct */
  updateBillingProviderProduct?: Maybe<BillingProviderProduct>
  /** Update a billingProviderProductPricing */
  updateBillingProviderProductPrice?: Maybe<BillingProviderProductPricing>
  /** Update a billingProviderProductText */
  updateBillingProviderProductText?: Maybe<BillingProviderProductText>
  /** Update a billingRefund */
  updateBillingRefund?: Maybe<BillingRefund>
  /** Update a billingSubscription */
  updateBillingSubscription?: Maybe<BillingSubscription>
  /** Update a billingSubscriptionOrder */
  updateBillingSubscriptionOrder?: Maybe<BillingSubscriptionOrder>
  /** Update a BillingSubscriptionOrderPlan */
  updateBillingSubscriptionOrderPlan?: Maybe<BillingSubscriptionOrderPlan>
  /** Update a billingSubscriptionPlan */
  updateBillingSubscriptionPlan?: Maybe<BillingSubscriptionPlan>
  /** Update a community comment */
  updateCommunityComment?: Maybe<CommunityComment>
  /** Update a community event */
  updateCommunityEvent?: Maybe<CommunityEvent>
  /** Update a community post */
  updateCommunityPost?: Maybe<CommunityPost>
  /** Update a community space */
  updateCommunitySpace?: Maybe<CommunitySpace>
  /** Update a member's role in a community space */
  updateCommunitySpaceMemberRole?: Maybe<Scalars['Boolean']['output']>
  /** Update a raw event */
  updateRawEvent?: Maybe<RawEvent>
  /** Update a transactions */
  updateTransaction?: Maybe<Transaction>
  /** Update a userAuditLog */
  updateUserAuditLog?: Maybe<UserAuditLog>
  /**
   * Update a user entitlement. Can modify start/end dates, content set, or other fields.
   * Used for extending access, changing content sets, or correcting entitlement data.
   * Requires elevated role access.
   */
  updateUserEntitlement?: Maybe<UserEntitlement>
  /** Create or update user metadata entries */
  userMetadataCreateOrUpdate: UserMetadataMutationResult
  /** Create or update user state entries */
  userStateCreateOrUpdate: Array<UserState>
  /** Delete a user state entry */
  userStateDelete: Scalars['Boolean']['output']
  /** Create one worker */
  workerCreate: WorkerMutationResponse
  /** Delete one worker the id or name in the input is used to select the worker */
  workerDelete: WorkerMutationResponse
  /** Update one worker */
  workerUpdate: WorkerMutationResponse
}

/** Oracle AI: Root mutation operations */
export type MutationAddCommunitySpaceMemberArgs = {
  spaceId: Scalars['ID']['input']
  userId: Scalars['ID']['input']
}

/** Oracle AI: Root mutation operations */
export type MutationAmbassadorLeadsUploadNdJsonToS3Args = {
  limit?: InputMaybe<Scalars['Int']['input']>
  offset?: InputMaybe<Scalars['Int']['input']>
  order?: InputMaybe<Array<InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>>>
  s3Params: AmbassadorLeadsS3Input
  where?: InputMaybe<AmbassadorLeadsWhereInput>
}

/** Oracle AI: Root mutation operations */
export type MutationAuthRoleCreateArgs = {
  authRole: AuthRoleCreateInput
}

/** Oracle AI: Root mutation operations */
export type MutationAuthRoleDeleteArgs = {
  authRole: AuthRoleDeleteInput
}

/** Oracle AI: Root mutation operations */
export type MutationAuthRoleUpdateArgs = {
  authRole: AuthRoleUpdateInput
}

/** Oracle AI: Root mutation operations */
export type MutationBillingCreateEventArgs = {
  input: BillingEventCreateInput
}

/** Oracle AI: Root mutation operations */
export type MutationBillingUpdateEventArgs = {
  input: BillingEventUpdateInput
}

/** Oracle AI: Root mutation operations */
export type MutationChatHistoryCreateArgs = {
  chatHistory?: InputMaybe<ChatHistoryCreateInput>
}

/** Oracle AI: Root mutation operations */
export type MutationChatHistoryDeleteArgs = {
  chatHistory?: InputMaybe<ChatHistoryDeleteInput>
}

/** Oracle AI: Root mutation operations */
export type MutationChatHistoryUpdateArgs = {
  chatHistory?: InputMaybe<ChatHistoryUpdateInput>
}

/** Oracle AI: Root mutation operations */
export type MutationChatSessionCreateArgs = {
  chatSession?: InputMaybe<ChatSessionCreateInput>
}

/** Oracle AI: Root mutation operations */
export type MutationChatSessionDeleteArgs = {
  chatSession?: InputMaybe<ChatSessionDeleteInput>
}

/** Oracle AI: Root mutation operations */
export type MutationChatSessionUpdateArgs = {
  chatSession?: InputMaybe<ChatSessionUpdateInput>
}

/** Oracle AI: Root mutation operations */
export type MutationContentAssetReferenceCreateArgs = {
  contentAssetReference: ContentAssetReferenceCreateInput
}

/** Oracle AI: Root mutation operations */
export type MutationContentAssetReferenceDeleteArgs = {
  contentAssetReference: ContentAssetReferenceDeleteInput
}

/** Oracle AI: Root mutation operations */
export type MutationContentListCriteriaCreateArgs = {
  contentListCriteria?: InputMaybe<ContentListCriteriaCreateInput>
}

/** Oracle AI: Root mutation operations */
export type MutationContentListCriteriaDeleteArgs = {
  contentListCriteria?: InputMaybe<ContentListCriteriaDeleteInput>
}

/** Oracle AI: Root mutation operations */
export type MutationContentProviderCreateByContentIdArgs = {
  contentProvider?: InputMaybe<ContentProviderCreateByContentIdInput>
}

/** Oracle AI: Root mutation operations */
export type MutationContentProviderDeleteByContentIdArgs = {
  contentProvider?: InputMaybe<ContentProviderDeleteByContentIdInput>
}

/** Oracle AI: Root mutation operations */
export type MutationContentProviderUpdateByContentIdArgs = {
  contentProvider?: InputMaybe<ContentProviderUpdateByContentIdInput>
}

/** Oracle AI: Root mutation operations */
export type MutationContentReferenceCreateArgs = {
  contentReference?: InputMaybe<ContentReferenceCreateInput>
}

/** Oracle AI: Root mutation operations */
export type MutationContentReferenceCreateManyArgs = {
  contentReferences: Array<ContentReferenceCreateInput>
  deleteOmittedReferences?: InputMaybe<Scalars['Boolean']['input']>
}

/** Oracle AI: Root mutation operations */
export type MutationContentReferenceDeleteArgs = {
  contentReference?: InputMaybe<ContentReferenceDeleteInput>
}

/** Oracle AI: Root mutation operations */
export type MutationContentUpdateArgs = {
  content?: InputMaybe<ContentInput>
  generatePath?: InputMaybe<Scalars['Boolean']['input']>
}

/** Oracle AI: Root mutation operations */
export type MutationCourseMarkCompleteArgs = {
  courseTitleGroupId: Scalars['String']['input']
}

/** Oracle AI: Root mutation operations */
export type MutationCourseModuleMarkCompleteArgs = {
  courseModuleTitleGroupId: Scalars['String']['input']
  courseTitleGroupId: Scalars['String']['input']
}

/** Oracle AI: Root mutation operations */
export type MutationCourseResetArgs = {
  courseTitleGroupId: Scalars['String']['input']
}

/** Oracle AI: Root mutation operations */
export type MutationCourseStartArgs = {
  courseTitleGroupId: Scalars['String']['input']
}

/** Oracle AI: Root mutation operations */
export type MutationCreateBillingAccountArgs = {
  input?: InputMaybe<BillingAccountCreateInput>
}

/** Oracle AI: Root mutation operations */
export type MutationCreateBillingInvoiceArgs = {
  input: BillingInvoiceCreateInput
}

/** Oracle AI: Root mutation operations */
export type MutationCreateBillingOneTimePurchaseArgs = {
  input: BillingOneTimePurchaseCreateInput
}

/** Oracle AI: Root mutation operations */
export type MutationCreateBillingPaymentArgs = {
  input: BillingPaymentCreateInput
}

/** Oracle AI: Root mutation operations */
export type MutationCreateBillingPaymentMethodArgs = {
  input: BillingPaymentMethodCreateInput
}

/** Oracle AI: Root mutation operations */
export type MutationCreateBillingPlanGridArgs = {
  input?: InputMaybe<CreateBillingPlanGridInput>
}

/** Oracle AI: Root mutation operations */
export type MutationCreateBillingProductArgs = {
  input: CreateBillingProductInput
}

/** Oracle AI: Root mutation operations */
export type MutationCreateBillingProductChangeLogArgs = {
  input: BillingProductChangeLogInput
}

/** Oracle AI: Root mutation operations */
export type MutationCreateBillingProviderArgs = {
  input: CreateBillingProviderInput
}

/** Oracle AI: Root mutation operations */
export type MutationCreateBillingProviderCurrencyArgs = {
  billingProviderCurrency: BillingProviderCurrencyInput
}

/** Oracle AI: Root mutation operations */
export type MutationCreateBillingProviderProductArgs = {
  billingProviderProduct: BillingProviderProductInput
  billingProviderProductPrices?: InputMaybe<Array<InputMaybe<BillingProviderProductPriceInput>>>
  billingProviderProductText?: InputMaybe<Array<InputMaybe<BillingProviderProductTextInput>>>
  updateProvider?: InputMaybe<Scalars['Boolean']['input']>
}

/** Oracle AI: Root mutation operations */
export type MutationCreateBillingProviderProductPriceArgs = {
  input: BillingProviderProductPricingCreateInput
  updateProvider?: InputMaybe<Scalars['Boolean']['input']>
  updateRelatedBillingProviderProducts?: InputMaybe<Scalars['Boolean']['input']>
}

/** Oracle AI: Root mutation operations */
export type MutationCreateBillingProviderProductTextArgs = {
  input: BillingProviderProductTextCreateInput
}

/** Oracle AI: Root mutation operations */
export type MutationCreateBillingRefundArgs = {
  input: BillingRefundCreateInput
}

/** Oracle AI: Root mutation operations */
export type MutationCreateBillingSubscriptionArgs = {
  input: BillingSubscriptionCreateInput
}

/** Oracle AI: Root mutation operations */
export type MutationCreateBillingSubscriptionOrderArgs = {
  input: BillingSubscriptionOrderCreateInput
}

/** Oracle AI: Root mutation operations */
export type MutationCreateBillingSubscriptionOrderPlanArgs = {
  input: BillingSubscriptionOrderPlanCreateInput
}

/** Oracle AI: Root mutation operations */
export type MutationCreateBillingSubscriptionPlanArgs = {
  input: BillingSubscriptionPlanCreateInput
}

/** Oracle AI: Root mutation operations */
export type MutationCreateCommunityCommentArgs = {
  content: Scalars['String']['input']
  parentId?: InputMaybe<Scalars['ID']['input']>
  postId: Scalars['ID']['input']
}

/** Oracle AI: Root mutation operations */
export type MutationCreateCommunityEventArgs = {
  capacity?: InputMaybe<Scalars['Int']['input']>
  description?: InputMaybe<Scalars['String']['input']>
  endTime?: InputMaybe<Scalars['DateTime']['input']>
  locationType?: InputMaybe<Scalars['String']['input']>
  spaceId: Scalars['ID']['input']
  startTime: Scalars['DateTime']['input']
  title: Scalars['String']['input']
}

/** Oracle AI: Root mutation operations */
export type MutationCreateCommunityPostArgs = {
  content: Scalars['String']['input']
  spaceId: Scalars['ID']['input']
  title: Scalars['String']['input']
}

/** Oracle AI: Root mutation operations */
export type MutationCreateCommunityReactionArgs = {
  postId: Scalars['ID']['input']
  reaction: Scalars['String']['input']
}

/** Oracle AI: Root mutation operations */
export type MutationCreateCommunitySpaceArgs = {
  description?: InputMaybe<Scalars['String']['input']>
  inviteOnly?: InputMaybe<Scalars['Boolean']['input']>
  isPrivate?: InputMaybe<Scalars['Boolean']['input']>
  name: Scalars['String']['input']
}

/** Oracle AI: Root mutation operations */
export type MutationCreateTransactionArgs = {
  input: TransactionCreateInput
}

/** Oracle AI: Root mutation operations */
export type MutationCreateUserAuditLogArgs = {
  input: UserAuditLogCreateInput
}

/** Oracle AI: Root mutation operations */
export type MutationCreateUserEntitlementArgs = {
  input: UserEntitlementCreateInput
}

/** Oracle AI: Root mutation operations */
export type MutationDeleteBillingPlanGridArgs = {
  input?: InputMaybe<DeleteBillingPlanGridInput>
}

/** Oracle AI: Root mutation operations */
export type MutationDeleteBillingProviderProductPriceArgs = {
  id: Scalars['ID']['input']
  updateProvider?: InputMaybe<Scalars['Boolean']['input']>
  updateRelatedBillingProviderProducts?: InputMaybe<Scalars['Boolean']['input']>
}

/** Oracle AI: Root mutation operations */
export type MutationDeleteBillingProviderProductTextArgs = {
  id: Scalars['ID']['input']
}

/** Oracle AI: Root mutation operations */
export type MutationDeleteCommunityCommentArgs = {
  id: Scalars['ID']['input']
}

/** Oracle AI: Root mutation operations */
export type MutationDeleteCommunityEventArgs = {
  id: Scalars['ID']['input']
}

/** Oracle AI: Root mutation operations */
export type MutationDeleteCommunityPostArgs = {
  id: Scalars['ID']['input']
}

/** Oracle AI: Root mutation operations */
export type MutationDeleteCommunityReactionArgs = {
  postId: Scalars['ID']['input']
  reaction: Scalars['String']['input']
}

/** Oracle AI: Root mutation operations */
export type MutationDeleteCommunitySpaceArgs = {
  id: Scalars['ID']['input']
}

/** Oracle AI: Root mutation operations */
export type MutationDiscountCodeCreateArgs = {
  input: DiscountCodeCreateInput
}

/** Oracle AI: Root mutation operations */
export type MutationEcommerceSkuMappingBonusEligibilityCreateArgs = {
  ecommerceSkuMappingBonusEligibility?: InputMaybe<EcommerceSkuMappingBonusEligibilityCreateInput>
}

/** Oracle AI: Root mutation operations */
export type MutationEcommerceSkuMappingBonusEligibilityDeleteByIdArgs = {
  ecommerceSkuMappingBonusEligibility?: InputMaybe<EcommerceSkuMappingBonusEligibilityDeleteByIdInput>
}

/** Oracle AI: Root mutation operations */
export type MutationEcommerceSkuMappingBonusEligibilityUpdateByIdArgs = {
  ecommerceSkuMappingBonusEligibility?: InputMaybe<EcommerceSkuMappingBonusEligibilityUpdateByIdInput>
}

/** Oracle AI: Root mutation operations */
export type MutationEcommerceSkuMappingCreateArgs = {
  ecommerceSkuMapping?: InputMaybe<EcommerceSkuMappingCreateInput>
}

/** Oracle AI: Root mutation operations */
export type MutationEcommerceSkuMappingUpdateByProviderAndEcommerceSkuArgs = {
  ecommerceSkuMapping?: InputMaybe<EcommerceSkuMappingUpdateByProviderAndEcommerceSkuInput>
}

/** Oracle AI: Root mutation operations */
export type MutationEventLogArgs = {
  input: EventLogInput
}

/** Oracle AI: Root mutation operations */
export type MutationInternalAgentChatArgs = {
  input: OracleAgentChatInput
}

/** Oracle AI: Root mutation operations */
export type MutationJoinCommunitySpaceArgs = {
  spaceId: Scalars['ID']['input']
}

/** Oracle AI: Root mutation operations */
export type MutationLeaveCommunitySpaceArgs = {
  spaceId: Scalars['ID']['input']
}

/** Oracle AI: Root mutation operations */
export type MutationLoginArgs = {
  clientAttributes?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  cookie?: InputMaybe<LoginRenewCookieInput>
  device?: InputMaybe<Scalars['String']['input']>
  language?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  password?: InputMaybe<Scalars['String']['input']>
  useMaster?: InputMaybe<Scalars['Boolean']['input']>
  username?: InputMaybe<Scalars['String']['input']>
}

/** Oracle AI: Root mutation operations */
export type MutationOracleAgentChatArgs = {
  input: OracleAgentChatInput
}

/** Oracle AI: Root mutation operations */
export type MutationOracleChatSessionCreateArgs = {
  input: OracleChatSessionCreateInput
}

/** Oracle AI: Root mutation operations */
export type MutationOracleChatSessionDeleteArgs = {
  id: Scalars['ID']['input']
}

/** Oracle AI: Root mutation operations */
export type MutationOracleChatSessionFavoriteArgs = {
  input: OracleChatSessionFavoriteInput
}

/** Oracle AI: Root mutation operations */
export type MutationOracleChatSessionRenameArgs = {
  input: OracleChatSessionRenameInput
}

/** Oracle AI: Root mutation operations */
export type MutationOracleChatSessionUpdateArgs = {
  input: OracleChatSessionUpdateInput
}

/** Oracle AI: Root mutation operations */
export type MutationOracleMessageCreateArgs = {
  input: OracleMessageCreateInput
}

/** Oracle AI: Root mutation operations */
export type MutationOracleMessagePairCreateArgs = {
  input: OracleMessagePairCreateInput
}

/** Oracle AI: Root mutation operations */
export type MutationOracleMessagePairDeleteArgs = {
  id: Scalars['ID']['input']
}

/** Oracle AI: Root mutation operations */
export type MutationOracleMessagePairUpdateArgs = {
  id: Scalars['ID']['input']
  input: OracleMessagePairUpdateInput
}

/** Oracle AI: Root mutation operations */
export type MutationOracleMessagePairUpdateModeArgs = {
  id: Scalars['ID']['input']
  mode: Scalars['String']['input']
}

/** Oracle AI: Root mutation operations */
export type MutationOraclePersonalityCreateArgs = {
  input: OraclePersonalityCreateInput
}

/** Oracle AI: Root mutation operations */
export type MutationOraclePersonalityDeleteArgs = {
  id: Scalars['ID']['input']
}

/** Oracle AI: Root mutation operations */
export type MutationOraclePersonalityUpdateArgs = {
  input: OraclePersonalityUpdateInput
}

/** Oracle AI: Root mutation operations */
export type MutationPlaylistCreateArgs = {
  playlist?: InputMaybe<PlaylistCreatePlaylistInput>
}

/** Oracle AI: Root mutation operations */
export type MutationPlaylistCreatePlaylistItemArgs = {
  createPlaylistIfNotExist?: InputMaybe<Scalars['Boolean']['input']>
  playlist?: InputMaybe<PlaylistCreatePlaylistItemPlaylistInput>
  playlistItem?: InputMaybe<PlaylistCreatePlaylistItemPlaylistItemInput>
  reorderPlaylist?: InputMaybe<Scalars['Boolean']['input']>
}

/** Oracle AI: Root mutation operations */
export type MutationPlaylistDeleteArgs = {
  playlist?: InputMaybe<PlaylistDeletePlaylistInput>
}

/** Oracle AI: Root mutation operations */
export type MutationPlaylistDeletePlaylistItemArgs = {
  playlist?: InputMaybe<PlaylistDeletePlaylistItemPlaylistInput>
  playlistItem?: InputMaybe<PlaylistDeletePlaylistItemPlaylistItemInput>
  reorderPlaylist?: InputMaybe<Scalars['Boolean']['input']>
}

/** Oracle AI: Root mutation operations */
export type MutationPlaylistUpdatePlaylistItemArgs = {
  playlist?: InputMaybe<PlaylistUpdatePlaylistItemPlaylistInput>
  playlistItem?: InputMaybe<PlaylistUpdatePlaylistItemPlaylistItemInput>
  reorderPlaylist?: InputMaybe<Scalars['Boolean']['input']>
}

/** Oracle AI: Root mutation operations */
export type MutationPmScreenCreateArgs = {
  pmScreen: PmScreenCreateInput
}

/** Oracle AI: Root mutation operations */
export type MutationPmScreenDeleteArgs = {
  id: Scalars['ID']['input']
}

/** Oracle AI: Root mutation operations */
export type MutationPmScreenUpdateArgs = {
  pmScreen: PmScreenUpdateInput
}

/** Oracle AI: Root mutation operations */
export type MutationPmSectionCreateArgs = {
  pmSection: PmSectionCreateInput
}

/** Oracle AI: Root mutation operations */
export type MutationPmSectionDeleteArgs = {
  id: Scalars['ID']['input']
}

/** Oracle AI: Root mutation operations */
export type MutationPmSectionUpdateArgs = {
  pmSection: PmSectionUpdateInput
}

/** Oracle AI: Root mutation operations */
export type MutationRegisterForCommunityEventArgs = {
  eventId: Scalars['ID']['input']
}

/** Oracle AI: Root mutation operations */
export type MutationRemoveCommunitySpaceMemberArgs = {
  spaceId: Scalars['ID']['input']
  userId: Scalars['ID']['input']
}

/** Oracle AI: Root mutation operations */
export type MutationRenewArgs = {
  clientAttributes?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  cookie?: InputMaybe<LoginRenewCookieInput>
  language?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  logUserAccountOutOfAllDevices?: InputMaybe<Scalars['Boolean']['input']>
  logUserOutOfAllDevices?: InputMaybe<Scalars['Boolean']['input']>
  refreshToken?: InputMaybe<Scalars['String']['input']>
  useMaster?: InputMaybe<Scalars['Boolean']['input']>
}

/** Oracle AI: Root mutation operations */
export type MutationS3UpsertNdjsonArgs = {
  s3UpsertNdjsonInput: S3UpsertNdjsonInput
}

/** Oracle AI: Root mutation operations */
export type MutationSeedQuestionCreateArgs = {
  input: SeedQuestionCreateInput
}

/** Oracle AI: Root mutation operations */
export type MutationSeedQuestionDeleteArgs = {
  id: Scalars['ID']['input']
}

/** Oracle AI: Root mutation operations */
export type MutationSeedQuestionUpdateArgs = {
  input: SeedQuestionUpdateInput
}

/** Oracle AI: Root mutation operations */
export type MutationUnregisterFromCommunityEventArgs = {
  eventId: Scalars['ID']['input']
}

/** Oracle AI: Root mutation operations */
export type MutationUpdateBillingAccountArgs = {
  input?: InputMaybe<BillingAccountUpdateInput>
}

/** Oracle AI: Root mutation operations */
export type MutationUpdateBillingInvoiceArgs = {
  input: BillingInvoiceUpdateInput
}

/** Oracle AI: Root mutation operations */
export type MutationUpdateBillingOneTimePurchaseArgs = {
  input: BillingOneTimePurchaseUpdateInput
}

/** Oracle AI: Root mutation operations */
export type MutationUpdateBillingPaymentArgs = {
  input: BillingPaymentUpdateInput
}

/** Oracle AI: Root mutation operations */
export type MutationUpdateBillingPaymentMethodArgs = {
  input: BillingPaymentMethodUpdateInput
}

/** Oracle AI: Root mutation operations */
export type MutationUpdateBillingPlanGridArgs = {
  input?: InputMaybe<UpdateBillingPlanGridInput>
}

/** Oracle AI: Root mutation operations */
export type MutationUpdateBillingProductArgs = {
  input: UpdateBillingProductInput
}

/** Oracle AI: Root mutation operations */
export type MutationUpdateBillingProviderArgs = {
  input: UpdateBillingProviderInput
}

/** Oracle AI: Root mutation operations */
export type MutationUpdateBillingProviderCurrencyArgs = {
  input: BillingProviderCurrencyUpdateInput
}

/** Oracle AI: Root mutation operations */
export type MutationUpdateBillingProviderProductArgs = {
  createBillingProviderProductPrices?: InputMaybe<
    Array<InputMaybe<BillingProviderProductPricingCreateInput>>
  >
  createBillingProviderProductText?: InputMaybe<
    Array<InputMaybe<BillingProviderProductTextCreateInput>>
  >
  deleteBillingProviderProductPrices?: InputMaybe<
    Array<InputMaybe<BillingProviderProductDeleteByIdInput>>
  >
  deleteBillingProviderProductText?: InputMaybe<
    Array<InputMaybe<BillingProviderProductDeleteByIdInput>>
  >
  input: BillingProviderProductUpdateInput
  skipProviderSync?: InputMaybe<Scalars['Boolean']['input']>
  updateBillingProviderProductPrices?: InputMaybe<
    Array<InputMaybe<BillingProviderProductPricingUpdateInput>>
  >
  updateBillingProviderProductText?: InputMaybe<
    Array<InputMaybe<BillingProviderProductTextUpdateInput>>
  >
  updateProvider?: InputMaybe<Scalars['Boolean']['input']>
  updateRelatedBillingProviderProducts?: InputMaybe<Scalars['Boolean']['input']>
}

/** Oracle AI: Root mutation operations */
export type MutationUpdateBillingProviderProductPriceArgs = {
  input: BillingProviderProductPricingUpdateInput
  updateProvider?: InputMaybe<Scalars['Boolean']['input']>
  updateRelatedBillingProviderProducts?: InputMaybe<Scalars['Boolean']['input']>
}

/** Oracle AI: Root mutation operations */
export type MutationUpdateBillingProviderProductTextArgs = {
  input: BillingProviderProductTextUpdateInput
}

/** Oracle AI: Root mutation operations */
export type MutationUpdateBillingRefundArgs = {
  input: BillingRefundUpdateInput
}

/** Oracle AI: Root mutation operations */
export type MutationUpdateBillingSubscriptionArgs = {
  input: BillingSubscriptionUpdateInput
}

/** Oracle AI: Root mutation operations */
export type MutationUpdateBillingSubscriptionOrderArgs = {
  input: BillingSubscriptionOrderUpdateInput
}

/** Oracle AI: Root mutation operations */
export type MutationUpdateBillingSubscriptionOrderPlanArgs = {
  input: BillingSubscriptionOrderPlanUpdateInput
}

/** Oracle AI: Root mutation operations */
export type MutationUpdateBillingSubscriptionPlanArgs = {
  input: BillingSubscriptionPlanUpdateInput
}

/** Oracle AI: Root mutation operations */
export type MutationUpdateCommunityCommentArgs = {
  content: Scalars['String']['input']
  id: Scalars['ID']['input']
}

/** Oracle AI: Root mutation operations */
export type MutationUpdateCommunityEventArgs = {
  capacity?: InputMaybe<Scalars['Int']['input']>
  description?: InputMaybe<Scalars['String']['input']>
  endTime?: InputMaybe<Scalars['DateTime']['input']>
  id: Scalars['ID']['input']
  locationType?: InputMaybe<Scalars['String']['input']>
  startTime?: InputMaybe<Scalars['DateTime']['input']>
  title?: InputMaybe<Scalars['String']['input']>
}

/** Oracle AI: Root mutation operations */
export type MutationUpdateCommunityPostArgs = {
  content?: InputMaybe<Scalars['String']['input']>
  id: Scalars['ID']['input']
  title?: InputMaybe<Scalars['String']['input']>
}

/** Oracle AI: Root mutation operations */
export type MutationUpdateCommunitySpaceArgs = {
  description?: InputMaybe<Scalars['String']['input']>
  id: Scalars['ID']['input']
  inviteOnly?: InputMaybe<Scalars['Boolean']['input']>
  isPrivate?: InputMaybe<Scalars['Boolean']['input']>
  name?: InputMaybe<Scalars['String']['input']>
}

/** Oracle AI: Root mutation operations */
export type MutationUpdateCommunitySpaceMemberRoleArgs = {
  roleType: SpaceRoleType
  spaceId: Scalars['ID']['input']
  userId: Scalars['ID']['input']
}

/** Oracle AI: Root mutation operations */
export type MutationUpdateRawEventArgs = {
  input: RawEventUpdateInput
}

/** Oracle AI: Root mutation operations */
export type MutationUpdateTransactionArgs = {
  input: TransactionUpdateInput
}

/** Oracle AI: Root mutation operations */
export type MutationUpdateUserAuditLogArgs = {
  input: UserAuditLogUpdateInput
}

/** Oracle AI: Root mutation operations */
export type MutationUpdateUserEntitlementArgs = {
  input: UserEntitlementUpdateInput
}

/** Oracle AI: Root mutation operations */
export type MutationUserMetadataCreateOrUpdateArgs = {
  input: Array<UserMetadataInput>
}

/** Oracle AI: Root mutation operations */
export type MutationUserStateCreateOrUpdateArgs = {
  input: Array<UserStateInput>
}

/** Oracle AI: Root mutation operations */
export type MutationUserStateDeleteArgs = {
  parentContentTitleGroupId: Scalars['String']['input']
  progressItemId: Scalars['String']['input']
  progressItemType: UserStateProgressItemType
  userUid?: InputMaybe<Scalars['Int']['input']>
}

/** Oracle AI: Root mutation operations */
export type MutationWorkerCreateArgs = {
  worker: WorkerCreateInput
}

/** Oracle AI: Root mutation operations */
export type MutationWorkerDeleteArgs = {
  worker: WorkerDeleteInput
}

/** Oracle AI: Root mutation operations */
export type MutationWorkerUpdateArgs = {
  create?: InputMaybe<Scalars['Boolean']['input']>
  worker: WorkerUpdateInput
}

/** OAuth2/OIDC client */
export type OAuthClient = {
  __typename?: 'OAuthClient'
  /** Unique OAuth2 client identifier */
  clientId?: Maybe<Scalars['String']['output']>
  /** Human-readable client name */
  clientName?: Maybe<Scalars['String']['output']>
  /** Client homepage URL */
  clientUri?: Maybe<Scalars['String']['output']>
  /** Array of contact email addresses */
  contacts?: Maybe<Array<Maybe<Scalars['String']['output']>>>
  /** When the row was created */
  createdAt?: Maybe<Scalars['DateTime']['output']>
  /** Array of supported grant types */
  grantTypes?: Maybe<Array<Maybe<Scalars['String']['output']>>>
  /** The primary identifier for this record (UUID v4) */
  id?: Maybe<Scalars['ID']['output']>
  /** Client logo URL */
  logoUri?: Maybe<Scalars['String']['output']>
  /** Privacy policy URI */
  policyUri?: Maybe<Scalars['String']['output']>
  /** Array of allowed redirect URIs */
  redirectUris?: Maybe<Array<Maybe<Scalars['String']['output']>>>
  /** Array of supported response types */
  responseTypes?: Maybe<Array<Maybe<Scalars['String']['output']>>>
  /** Default scopes for the client */
  scope?: Maybe<Scalars['String']['output']>
  /** Authentication method for token endpoint */
  tokenEndpointAuthMethod?: Maybe<Scalars['String']['output']>
  /** Terms of service URI */
  tosUri?: Maybe<Scalars['String']['output']>
  /** When the row was last updated */
  updatedAt?: Maybe<Scalars['DateTime']['output']>
}

/** OAuth client list response */
export type OAuthClientListResponse = {
  __typename?: 'OAuthClientListResponse'
  /** Total number of rows found (uses a slower count query for list) */
  count?: Maybe<Scalars['Int']['output']>
  /** The limit applied to the rows */
  limit?: Maybe<Scalars['Int']['output']>
  /** A list of OAuth clients */
  oauthClients?: Maybe<Array<Maybe<OAuthClient>>>
  /** The offset applied to the rows */
  offset?: Maybe<Scalars['Int']['output']>
}

/** OAuth client clientId type where input type */
export type OAuthClientListWhereClientIdInput = {
  /** Is the value equal to the field */
  eq?: InputMaybe<Scalars['String']['input']>
  /** Are the values in the field */
  in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
}

/** OAuth client id type where input type */
export type OAuthClientListWhereIdInput = {
  /** Is the value equal to the field */
  eq?: InputMaybe<Scalars['ID']['input']>
  /** Are the values in the field */
  in?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>
}

/** OAuth client where conditions to filter rows */
export type OAuthClientListWhereInput = {
  /** The clientId field where clause */
  clientId?: InputMaybe<OAuthClientListWhereClientIdInput>
  /** The id field where clause */
  id?: InputMaybe<OAuthClientListWhereIdInput>
}

export type OracleAgentChatHistoryInput = {
  /** Maximum number of message pairs to include in chat history (0-30) */
  limit?: Scalars['Int']['input']
}

export type OracleAgentChatInput = {
  /** ID of the chat session to continue, if any */
  chatSessionId?: InputMaybe<Scalars['ID']['input']>
  /** The content ID this session is associated with (null for regular conversations) */
  contentId?: InputMaybe<Scalars['String']['input']>
  /** The current playback time in seconds when the message was sent. */
  currentTimeSeconds?: InputMaybe<Scalars['Float']['input']>
  /** If true, ask LLM to generate gaia:// deep links for native apps */
  deepLinks?: InputMaybe<Scalars['Boolean']['input']>
  /** The feature media ID this session is associated with (null for regular conversations) */
  featureMediaId?: InputMaybe<Scalars['String']['input']>
  /** Chat history configuration */
  history?: InputMaybe<OracleAgentChatHistoryInput>
  /** Whether the video is currently paused when the message was sent. */
  isPaused?: InputMaybe<Scalars['Boolean']['input']>
  /** The temperature for the language model (default: 0.7) */
  llmTemperature?: InputMaybe<Scalars['Float']['input']>
  /** Long-term memory for the agent */
  longTermMemory?: InputMaybe<Scalars['String']['input']>
  /** The maximum number of context documents to use */
  maxContextDocs?: InputMaybe<Scalars['Int']['input']>
  /** The maximum number of iterations for the agent */
  maxIterations?: InputMaybe<Scalars['Int']['input']>
  /** The user's message to the agent */
  message: Scalars['String']['input']
  /** Communication mode ('text' or 'voice') */
  mode?: InputMaybe<Scalars['String']['input']>
  /** The name of the language model to use */
  modelName?: InputMaybe<Scalars['String']['input']>
  /** ID of the personality to use for the chat */
  personalityId: Scalars['ID']['input']
  /** User's timezone for rate limit calculations */
  timezone?: InputMaybe<Scalars['String']['input']>
}

export type OracleAgentChatPayload = {
  __typename?: 'OracleAgentChatPayload'
  /** The ID of the chat session */
  chatSessionId?: Maybe<Scalars['ID']['output']>
  /** A list of documents retrieved by the agent */
  documents: Array<OracleDocument>
  /** Any error message that occurred */
  error?: Maybe<Scalars['String']['output']>
  /** A list of structured errors. */
  errorInfo: Array<AppError>
  /** A list of any errors that occurred */
  errors: Array<Scalars['String']['output']>
  /** The total execution time of the agent chat */
  executionTime: Scalars['Float']['output']
  /** Current rate limit status for the user */
  rateLimitStatus?: Maybe<RateLimitInfo>
  /** The generated title for the chat session */
  sessionTitle?: Maybe<Scalars['String']['output']>
  /** Whether the agent chat was successful */
  success: Scalars['Boolean']['output']
  /** The agent's response text */
  text: Scalars['String']['output']
}

export type OracleAgentChatSubscriptionPayload = {
  __typename?: 'OracleAgentChatSubscriptionPayload'
  /** The session ID for the chat. */
  chatSessionId?: Maybe<Scalars['ID']['output']>
  /** Documents retrieved by the agent. */
  documents?: Maybe<Array<OracleDocument>>
  /** An error message if something went wrong. */
  error?: Maybe<Scalars['String']['output']>
  /** A list of structured errors. */
  errorInfo: Array<AppError>
  /** A list of error messages. */
  errors: Array<Scalars['String']['output']>
  /** Total execution time (sent with final message). */
  executionTime?: Maybe<Scalars['Float']['output']>
  /** Flag to indicate the final message in the stream. */
  isFinal: Scalars['Boolean']['output']
  /** The message pair ID for this interaction. */
  messagePairId?: Maybe<Scalars['ID']['output']>
  /** Current rate limit status for the user (sent with final message). */
  rateLimitStatus?: Maybe<RateLimitInfo>
  /** The generated title for the session (sent with final message). */
  sessionTitle?: Maybe<Scalars['String']['output']>
  /** Indicates if the event was successful. */
  success: Scalars['Boolean']['output']
  /** A chunk of the agent's response text. */
  textChunk?: Maybe<Scalars['String']['output']>
}

/** Oracle AI: Standard operators for boolean filtering */
export type OracleBooleanFilterInput = {
  eq?: InputMaybe<Scalars['Boolean']['input']>
}

/** Oracle AI: A chat session between user and AI */
export type OracleChatSession = {
  __typename?: 'OracleChatSession'
  /** The content ID this session is associated with (null for regular conversations) */
  contentId?: Maybe<Scalars['String']['output']>
  /** Timestamp of when the chat session was created */
  createdAt: Scalars['DateTime']['output']
  /** Auto-incrementing unique identifier for export operations */
  exportIndex: Scalars['Int']['output']
  /** Whether the user has marked this chat session as a favorite. */
  favorite: Scalars['Boolean']['output']
  /** Timestamp when the favorite status was last updated */
  favoriteUpdatedAt?: Maybe<Scalars['DateTime']['output']>
  /** The feature media ID this session is associated with (null for regular conversations) */
  featureMediaId?: Maybe<Scalars['String']['output']>
  /** Unique identifier for the chat session */
  id: Scalars['ID']['output']
  /** The name (LLM-defined or user-defined) for the chat session */
  name: Scalars['String']['output']
  /** The personalities FK for this session */
  personalityId: Scalars['ID']['output']
  /** Timestamp of when the chat session was last updated */
  updatedAt: Scalars['DateTime']['output']
  /** User information for this chat session */
  userInfo: UserInfo
  /** The user info UUID */
  userInfoUuid: Scalars['ID']['output']
}

/** Oracle AI: Input for creating a new chat session */
export type OracleChatSessionCreateInput = {
  /** The name for the chat session */
  name: Scalars['String']['input']
  /** The personality ID to use for this session */
  personalityId: Scalars['ID']['input']
}

/** Oracle AI: Response envelope for chat session creation */
export type OracleChatSessionCreateResponse = {
  __typename?: 'OracleChatSessionCreateResponse'
  /** A list of errors that occurred during the mutation */
  errors: Array<Scalars['String']['output']>
  /** The created chat session, if successful */
  oracleChatSession?: Maybe<OracleChatSession>
  /** Indicates whether the mutation was successful */
  success: Scalars['Boolean']['output']
}

/** Oracle AI: Response envelope for chat session deletion */
export type OracleChatSessionDeleteResponse = {
  __typename?: 'OracleChatSessionDeleteResponse'
  /** True if the deletion was successful, otherwise False */
  deleted?: Maybe<Scalars['Boolean']['output']>
  /** A list of errors that occurred during the mutation */
  errors: Array<Scalars['String']['output']>
  /** Indicates whether the mutation was successful */
  success: Scalars['Boolean']['output']
}

/** Oracle AI: Input for updating chat session favorite status */
export type OracleChatSessionFavoriteInput = {
  /** The new favorite status for the chat session */
  favorite: Scalars['Boolean']['input']
  /** The ID of the chat session to update */
  id: Scalars['ID']['input']
}

/** Oracle AI: Response envelope for chat session favorite update */
export type OracleChatSessionFavoriteResponse = {
  __typename?: 'OracleChatSessionFavoriteResponse'
  /** A list of errors that occurred during the mutation */
  errors: Array<Scalars['String']['output']>
  /** The updated chat session, if successful */
  oracleChatSession?: Maybe<OracleChatSession>
  /** Indicates whether the mutation was successful */
  success: Scalars['Boolean']['output']
}

/** Oracle AI: Chat session list response */
export type OracleChatSessionListResponse = {
  __typename?: 'OracleChatSessionListResponse'
  /** The total number of chat sessions available. */
  count: Scalars['Int']['output']
  /** The number of chat sessions returned in this response. */
  limit: Scalars['Int']['output']
  /** The starting point of the returned chat sessions. */
  offset: Scalars['Int']['output']
  /** A list of chat sessions. */
  oracleChatSessions: Array<OracleChatSession>
}

/** Oracle AI: Filtering options for chat session lists */
export type OracleChatSessionListWhere = {
  /** Filter by content ID */
  contentId?: InputMaybe<OracleStringFilterInput>
  /** Filter by creation timestamp */
  createdAt?: InputMaybe<OracleDateTimeFilterInput>
  /** Filter by favorite status */
  favorite?: InputMaybe<OracleBooleanFilterInput>
  /** Filter by feature media ID */
  featureMediaId?: InputMaybe<OracleStringFilterInput>
  /** Filter by chat session ID */
  id?: InputMaybe<OracleUuidFilterInput>
  /** Filter by chat session name */
  name?: InputMaybe<OracleStringFilterInput>
  /** Filter by personality ID */
  personalityId?: InputMaybe<OracleIntFilterInput>
  /** Filter by update timestamp */
  updatedAt?: InputMaybe<OracleDateTimeFilterInput>
  /** Filter by user info UUID */
  userInfoUuid?: InputMaybe<OracleUuidFilterInput>
}

/** Oracle AI: Input for renaming a chat session */
export type OracleChatSessionRenameInput = {
  /** The ID of the chat session to rename */
  id: Scalars['ID']['input']
  /** The new name/title for the chat session */
  name: Scalars['String']['input']
}

/** Oracle AI: Response envelope for chat session rename */
export type OracleChatSessionRenameResponse = {
  __typename?: 'OracleChatSessionRenameResponse'
  /** A list of errors that occurred during the mutation */
  errors: Array<Scalars['String']['output']>
  /** The updated chat session, if successful */
  oracleChatSession?: Maybe<OracleChatSession>
  /** Indicates whether the mutation was successful */
  success: Scalars['Boolean']['output']
}

/** Oracle AI: Input for updating an existing chat session */
export type OracleChatSessionUpdateInput = {
  /** The ID of the chat session to update */
  id: Scalars['ID']['input']
  /** The new user message to append to the session */
  userMessage: Scalars['String']['input']
}

/** Oracle AI: Response envelope for chat session update */
export type OracleChatSessionUpdateResponse = {
  __typename?: 'OracleChatSessionUpdateResponse'
  /** A list of errors that occurred during the mutation */
  errors: Array<Scalars['String']['output']>
  /** The updated chat session, if successful */
  oracleChatSession?: Maybe<OracleChatSession>
  /** Indicates whether the mutation was successful */
  success: Scalars['Boolean']['output']
}

/** Oracle AI: Standard operators for datetime filtering */
export type OracleDateTimeFilterInput = {
  eq?: InputMaybe<Scalars['DateTime']['input']>
  gt?: InputMaybe<Scalars['DateTime']['input']>
  gte?: InputMaybe<Scalars['DateTime']['input']>
  in?: InputMaybe<Array<Scalars['DateTime']['input']>>
  lt?: InputMaybe<Scalars['DateTime']['input']>
  lte?: InputMaybe<Scalars['DateTime']['input']>
}

/** Schema for document containing text content and metadata */
export type OracleDocument = {
  __typename?: 'OracleDocument'
  /** Reference to the federated Content entity for accessing thumbnails and media */
  content: Content
  /** Content ID (not unique) */
  contentId: Scalars['Int']['output']
  contentType: Scalars['String']['output']
  documentText: Scalars['String']['output']
  /** Primary key for federation with Content service */
  documentsId: Scalars['String']['output']
  embedding: Array<Scalars['Float']['output']>
  language: Scalars['String']['output']
  link: Scalars['String']['output']
  path: Scalars['String']['output']
  score: Scalars['Float']['output']
  title: Scalars['String']['output']
  writer: Scalars['String']['output']
}

export type OracleHealth = {
  __typename?: 'OracleHealth'
  success: Scalars['Boolean']['output']
}

export type OracleHealthResponse = {
  __typename?: 'OracleHealthResponse'
  errors: Array<Scalars['String']['output']>
  health?: Maybe<OracleHealth>
  success: Scalars['Boolean']['output']
}

/** Oracle AI: Standard operators for ID filtering */
export type OracleIdFilterInput = {
  eq?: InputMaybe<Scalars['ID']['input']>
  in?: InputMaybe<Array<Scalars['ID']['input']>>
}

/** Oracle AI: Standard operators for integer filtering */
export type OracleIntFilterInput = {
  eq?: InputMaybe<Scalars['Int']['input']>
  gt?: InputMaybe<Scalars['Int']['input']>
  gte?: InputMaybe<Scalars['Int']['input']>
  in?: InputMaybe<Array<Scalars['Int']['input']>>
  lt?: InputMaybe<Scalars['Int']['input']>
  lte?: InputMaybe<Scalars['Int']['input']>
}

/** Oracle AI: Individual message in a conversation */
export type OracleMessage = {
  __typename?: 'OracleMessage'
  /** The parent chat session ID for this message */
  chatSessionId: Scalars['ID']['output']
  /** The actual text content of the message */
  content: Scalars['String']['output']
  /** Timestamp of when the message was created */
  createdAt: Scalars['DateTime']['output']
  /** Derived unique identifier for the message (since they don't have separate DB IDs) */
  id: Scalars['String']['output']
  /** The role of the message author, e.g., "user" or "assistant" */
  role: Scalars['String']['output']
  /** The user ID for user messages, null for assistant messages */
  userId?: Maybe<Scalars['ID']['output']>
}

/** Oracle AI: Input for creating a new message */
export type OracleMessageCreateInput = {
  /** The chat session ID to which this message belongs */
  chatSessionId: Scalars['ID']['input']
  /** The text content of the message */
  content: Scalars['String']['input']
  /** The role of the message author, e.g., "user" or "assistant" */
  role: Scalars['String']['input']
  /** The user ID for the message, if applicable */
  userId?: InputMaybe<Scalars['ID']['input']>
}

/** Oracle AI: Response envelope for message creation */
export type OracleMessageCreateResponse = {
  __typename?: 'OracleMessageCreateResponse'
  /** A list of errors that occurred during the mutation */
  errors: Array<Scalars['String']['output']>
  /** The created message, if successful */
  oracleMessage?: Maybe<OracleMessage>
  /** Indicates whether the mutation was successful */
  success: Scalars['Boolean']['output']
}

/** Oracle AI: Message list response */
export type OracleMessageListResponse = {
  __typename?: 'OracleMessageListResponse'
  /** The total number of messages available. */
  count: Scalars['Int']['output']
  /** The number of messages returned in this response. */
  limit: Scalars['Int']['output']
  /** The starting point of the returned messages. */
  offset: Scalars['Int']['output']
  /** A list of messages. */
  oracleMessages: Array<OracleMessage>
}

/** Oracle AI: Filtering options for message lists */
export type OracleMessageListWhere = {
  /** Filter by chat session ID */
  chatSessionId?: InputMaybe<OracleUuidFilterInput>
  /** Filter by creation timestamp */
  createdAt?: InputMaybe<OracleDateTimeFilterInput>
  /** Filter by message role */
  role?: InputMaybe<OracleStringFilterInput>
  /** Filter by user ID */
  userId?: InputMaybe<OracleUuidFilterInput>
}

/** Oracle AI: A pair of user and assistant messages */
export type OracleMessagePair = {
  __typename?: 'OracleMessagePair'
  /** The chat_sessions FK for this message pair */
  chatSessionId: Scalars['ID']['output']
  /** Timestamp of when the message pair was created */
  createdAt: Scalars['DateTime']['output']
  /** Documents referenced by this assistant message */
  documents: Array<OracleDocument>
  /** Auto-incrementing unique identifier for export operations */
  exportIndex: Scalars['Int']['output']
  /** Unique identifier for the message pair */
  id: Scalars['ID']['output']
  /** The LLM used to generate the oracle response */
  llmName: Scalars['String']['output']
  /** The sentiment of the message */
  messageSentiment?: Maybe<Scalars['String']['output']>
  /** The topic of the message */
  messageTopic?: Maybe<Scalars['String']['output']>
  /** Communication mode ('text' or 'voice') */
  mode: Scalars['String']['output']
  /** The assistant's message in the pair */
  oracleMessage: OracleMessage
  /** User's thumbs up/down rating of the oracle response ('up', 'down', or 'none') */
  thumbsValue: Scalars['String']['output']
  /** Timestamp of when the message pair was last updated */
  updatedAt: Scalars['DateTime']['output']
  /** The user info UUID */
  userInfoUuid: Scalars['ID']['output']
  /** The user's message in the pair */
  userMessage: OracleMessage
}

/** Oracle AI: Input for creating a new message pair */
export type OracleMessagePairCreateInput = {
  /** The chat session ID for this message pair (alias for chat_session_id) */
  chatSessionId: Scalars['ID']['input']
  /** The name of the LLM that generated the response (alias for llm_name) */
  llmName: Scalars['String']['input']
  /** The sentiment of the message */
  messageSentiment?: InputMaybe<Scalars['String']['input']>
  /** The topic of the message */
  messageTopic?: InputMaybe<Scalars['String']['input']>
  /** Communication mode ('text' or 'voice') */
  mode?: InputMaybe<Scalars['String']['input']>
  /** The assistant's response text */
  oracleMessage: Scalars['String']['input']
  /** The user info UUID for the user message (alias for user_info_uuid) */
  userInfoUuid: Scalars['ID']['input']
  /** The user's message text */
  userMessage: Scalars['String']['input']
}

/** Oracle AI: Response envelope for message pair creation */
export type OracleMessagePairCreateResponse = {
  __typename?: 'OracleMessagePairCreateResponse'
  /** A list of errors that occurred during the mutation */
  errors: Array<Scalars['String']['output']>
  /** The created message pair, if successful */
  oracleMessagePair?: Maybe<OracleMessagePair>
  /** Indicates whether the mutation was successful */
  success: Scalars['Boolean']['output']
}

/** Oracle AI: Response envelope for message pair deletion */
export type OracleMessagePairDeleteResponse = {
  __typename?: 'OracleMessagePairDeleteResponse'
  /** True if the deletion was successful, otherwise False */
  deleted?: Maybe<Scalars['Boolean']['output']>
  /** A list of errors that occurred during the mutation */
  errors: Array<Scalars['String']['output']>
  /** Indicates whether the mutation was successful */
  success: Scalars['Boolean']['output']
}

/** Oracle AI: Message pair list response */
export type OracleMessagePairListResponse = {
  __typename?: 'OracleMessagePairListResponse'
  /** The total number of message pairs available. */
  count: Scalars['Int']['output']
  /** The number of message pairs returned in this response. */
  limit: Scalars['Int']['output']
  /** The starting point of the returned message pairs. */
  offset: Scalars['Int']['output']
  /** A list of message pairs. */
  oracleMessagePairs: Array<OracleMessagePair>
}

/** Oracle AI: Filtering options for message pair lists */
export type OracleMessagePairListWhere = {
  /** Filter by creation timestamp */
  createdAt?: InputMaybe<OracleDateTimeFilterInput>
  /** Filter by message pair ID */
  id?: InputMaybe<OracleUuidFilterInput>
  /** Filter by LLM name */
  llmName?: InputMaybe<OracleStringFilterInput>
  /** Filter by communication mode ('text' or 'voice') */
  mode?: InputMaybe<OracleStringFilterInput>
  /** Filter by update timestamp */
  updatedAt?: InputMaybe<OracleDateTimeFilterInput>
}

/** Oracle AI: Input for updating an existing message pair */
export type OracleMessagePairUpdateInput = {
  /** The updated LLM name */
  llmName?: InputMaybe<Scalars['String']['input']>
  /** The updated message sentiment */
  messageSentiment?: InputMaybe<Scalars['String']['input']>
  /** The updated message topic */
  messageTopic?: InputMaybe<Scalars['String']['input']>
  /** The updated communication mode ('text' or 'voice') */
  mode?: InputMaybe<Scalars['String']['input']>
  /** The updated assistant message text */
  oracleMessage?: InputMaybe<Scalars['String']['input']>
  /** The updated thumbs up/down value ('up', 'down', or 'none') */
  thumbsValue?: InputMaybe<Scalars['String']['input']>
  /** The updated user message text */
  userMessage?: InputMaybe<Scalars['String']['input']>
}

/** Oracle AI: Response envelope for message pair update */
export type OracleMessagePairUpdateResponse = {
  __typename?: 'OracleMessagePairUpdateResponse'
  /** A list of errors that occurred during the mutation */
  errors: Array<Scalars['String']['output']>
  /** The updated message pair, if successful */
  oracleMessagePair?: Maybe<OracleMessagePair>
  /** Indicates whether the mutation was successful */
  success: Scalars['Boolean']['output']
}

/** Oracle AI: AI personality configuration */
export type OraclePersonality = {
  __typename?: 'OraclePersonality'
  /** Timestamp of when the personality was created */
  createdAt: Scalars['DateTime']['output']
  /** Display name for the personality shown on the frontend */
  displayName?: Maybe<Scalars['String']['output']>
  /** Whether this personality is enabled and available for use */
  enabled: Scalars['Boolean']['output']
  /** List of enabled tools for the personality */
  enabledTools: Array<Scalars['String']['output']>
  /** Custom prompt for history summarization (Phase 0.5) */
  historySummarizationPrompt?: Maybe<Scalars['String']['output']>
  /** Unique identifier for the personality */
  id: Scalars['ID']['output']
  /** Whether this is the default personality */
  isDefault: Scalars['Boolean']['output']
  /** Short string key for the personality (e.g., wisdom-keeper) */
  key: Scalars['String']['output']
  /** Frequency penalty for LLM token generation */
  llmFrequencyPenalty?: Maybe<Scalars['Float']['output']>
  /** Maximum tokens for LLM responses */
  llmMaxTokens?: Maybe<Scalars['Int']['output']>
  /** LLM model name for this personality */
  llmModel: Scalars['String']['output']
  /** Provider-specific parameters for LLM configuration (JSON object) */
  llmProviderKwargs?: Maybe<Scalars['JSON']['output']>
  /** LLM temperature setting (0.0 to 1.0) */
  llmTemperature: Scalars['Float']['output']
  /** Soft reference to another personality by ID that serves as its parent */
  parentId?: Maybe<Scalars['ID']['output']>
  /** Frequency penalty for the planner phase LLM token generation */
  plannerLlmFrequencyPenalty?: Maybe<Scalars['Float']['output']>
  /** Reserved model name for future orchestration phase (currently unused). */
  plannerLlmModel?: Maybe<Scalars['String']['output']>
  /** LLM temperature setting for the planner phase (0.0 to 1.0) */
  plannerLlmTemperature?: Maybe<Scalars['Float']['output']>
  /** Custom system prompt for the planner phase (Phase 1.5) */
  plannerSystemPrompt?: Maybe<Scalars['String']['output']>
  /** System message that defines the personality's behavior */
  systemMessage: Scalars['String']['output']
  /** Timestamp of when the personality was last updated */
  updatedAt: Scalars['DateTime']['output']
  /** Reserved toggle for future multi-phase orchestration (currently unused). */
  usePlannerWriter: Scalars['Boolean']['output']
  /** Frequency penalty for the writer phase LLM token generation */
  writerLlmFrequencyPenalty?: Maybe<Scalars['Float']['output']>
  /** Reserved model name for future response phase (currently unused). */
  writerLlmModel?: Maybe<Scalars['String']['output']>
  /** LLM temperature setting for the writer phase (0.0 to 1.0) */
  writerLlmTemperature?: Maybe<Scalars['Float']['output']>
  /** Custom system prompt for the writer phase (Phase 2) */
  writerSystemPrompt?: Maybe<Scalars['String']['output']>
}

/** Oracle AI: Input for creating a new personality */
export type OraclePersonalityCreateInput = {
  /** Display name for the personality shown on the frontend */
  displayName?: InputMaybe<Scalars['String']['input']>
  /** Whether this personality is enabled and available for use */
  enabled?: InputMaybe<Scalars['Boolean']['input']>
  /** List of enabled tools for the personality */
  enabledTools?: Array<Scalars['String']['input']>
  /** Custom prompt for history summarization (Phase 0.5) */
  historySummarizationPrompt?: InputMaybe<Scalars['String']['input']>
  /** Set as the default personality. Setting this to true will automatically unset any existing default personality. */
  isDefault?: InputMaybe<Scalars['Boolean']['input']>
  /** Short string key for the personality (e.g., wisdom-keeper) */
  key: Scalars['String']['input']
  /** Frequency penalty for LLM token generation */
  llmFrequencyPenalty?: InputMaybe<Scalars['Float']['input']>
  /** Maximum tokens for LLM responses */
  llmMaxTokens?: InputMaybe<Scalars['Int']['input']>
  /** LLM model name for this personality */
  llmModel?: InputMaybe<Scalars['String']['input']>
  /** Provider-specific parameters for LLM configuration (JSON object) */
  llmProviderKwargs?: InputMaybe<Scalars['JSON']['input']>
  /** LLM temperature setting (0.0 to 1.0) */
  llmTemperature?: InputMaybe<Scalars['Float']['input']>
  /** Soft reference to another personality by ID that serves as its parent */
  parentId?: InputMaybe<Scalars['ID']['input']>
  /** Frequency penalty for the planner phase LLM token generation */
  plannerLlmFrequencyPenalty?: InputMaybe<Scalars['Float']['input']>
  /** Reserved model name for future orchestration phase (currently unused). */
  plannerLlmModel?: InputMaybe<Scalars['String']['input']>
  /** LLM temperature setting for the planner phase (0.0 to 1.0) */
  plannerLlmTemperature?: InputMaybe<Scalars['Float']['input']>
  /** Custom system prompt for the planner phase (Phase 1.5) */
  plannerSystemPrompt?: InputMaybe<Scalars['String']['input']>
  /** System message that defines the personalities behavior */
  systemMessage: Scalars['String']['input']
  /** Reserved toggle for future multi-phase orchestration (currently unused). */
  usePlannerWriter?: InputMaybe<Scalars['Boolean']['input']>
  /** Frequency penalty for the writer phase LLM token generation */
  writerLlmFrequencyPenalty?: InputMaybe<Scalars['Float']['input']>
  /** Reserved model name for future response phase (currently unused). */
  writerLlmModel?: InputMaybe<Scalars['String']['input']>
  /** LLM temperature setting for the writer phase (0.0 to 1.0) */
  writerLlmTemperature?: InputMaybe<Scalars['Float']['input']>
  /** Custom system prompt for the writer phase (Phase 2) */
  writerSystemPrompt?: InputMaybe<Scalars['String']['input']>
}

/** Oracle AI: Response envelope for personality creation */
export type OraclePersonalityCreateResponse = {
  __typename?: 'OraclePersonalityCreateResponse'
  /** A list of errors that occurred during the mutation */
  errors: Array<Scalars['String']['output']>
  /** The created personality, if successful */
  oraclePersonality?: Maybe<OraclePersonality>
  /** Indicates whether the mutation was successful */
  success: Scalars['Boolean']['output']
}

/** Oracle AI: Response envelope for personality deletion */
export type OraclePersonalityDeleteResponse = {
  __typename?: 'OraclePersonalityDeleteResponse'
  /** True if the deletion was successful, otherwise False */
  deleted?: Maybe<Scalars['Boolean']['output']>
  /** A list of errors that occurred during the mutation */
  errors: Array<Scalars['String']['output']>
  /** Indicates whether the mutation was successful */
  success: Scalars['Boolean']['output']
}

/** Oracle AI: Personality list response */
export type OraclePersonalityListResponse = {
  __typename?: 'OraclePersonalityListResponse'
  /** The total number of personalities available. */
  count: Scalars['Int']['output']
  /** The number of personalities returned in this response. */
  limit: Scalars['Int']['output']
  /** The starting point of the returned personalities. */
  offset: Scalars['Int']['output']
  /** A list of personalities. */
  oraclePersonalities: Array<OraclePersonality>
}

/** Oracle AI: Filtering options for personality lists */
export type OraclePersonalityListWhere = {
  /** Filter by creation timestamp */
  createdAt?: InputMaybe<OracleDateTimeFilterInput>
  /** Filter by enabled status */
  enabled?: InputMaybe<OracleBooleanFilterInput>
  /** Filter by enabled tools */
  enabledTools?: InputMaybe<OracleStringFilterInput>
  /** Filter by personality ID */
  id?: InputMaybe<OracleIntFilterInput>
  /** Filter by default status */
  isDefault?: InputMaybe<OracleBooleanFilterInput>
  /** Filter by personality key */
  key?: InputMaybe<OracleStringFilterInput>
  /** Filter by parent personality ID */
  parentId?: InputMaybe<OracleIntFilterInput>
  /** Filter by update timestamp */
  updatedAt?: InputMaybe<OracleDateTimeFilterInput>
}

/** Oracle AI: Input for updating an existing personality */
export type OraclePersonalityUpdateInput = {
  /** New display name for the personality shown on the frontend */
  displayName?: InputMaybe<Scalars['String']['input']>
  /** Whether this personality is enabled and available for use */
  enabled?: InputMaybe<Scalars['Boolean']['input']>
  /** New list of enabled tools for the personality */
  enabledTools?: InputMaybe<Array<Scalars['String']['input']>>
  /** New custom prompt for history summarization (Phase 0.5) */
  historySummarizationPrompt?: InputMaybe<Scalars['String']['input']>
  /** ID of the personality to update */
  id: Scalars['ID']['input']
  /** Set as the default personality. Setting this to true will automatically unset any existing default personality. */
  isDefault?: InputMaybe<Scalars['Boolean']['input']>
  /** New key for the personality */
  key?: InputMaybe<Scalars['String']['input']>
  /** New frequency penalty for LLM token generation */
  llmFrequencyPenalty?: InputMaybe<Scalars['Float']['input']>
  /** New maximum tokens for LLM responses */
  llmMaxTokens?: InputMaybe<Scalars['Int']['input']>
  /** New LLM model name for this personality */
  llmModel?: InputMaybe<Scalars['String']['input']>
  /** New provider-specific parameters for LLM configuration (JSON object) */
  llmProviderKwargs?: InputMaybe<Scalars['JSON']['input']>
  /** New LLM temperature setting (0.0 to 1.0) */
  llmTemperature?: InputMaybe<Scalars['Float']['input']>
  /** New parent ID for the personality */
  parentId?: InputMaybe<Scalars['ID']['input']>
  /** New frequency penalty for the planner phase LLM token generation */
  plannerLlmFrequencyPenalty?: InputMaybe<Scalars['Float']['input']>
  /** Reserved model name for future orchestration phase (currently unused). */
  plannerLlmModel?: InputMaybe<Scalars['String']['input']>
  /** New LLM temperature setting for the planner phase (0.0 to 1.0) */
  plannerLlmTemperature?: InputMaybe<Scalars['Float']['input']>
  /** New custom system prompt for the planner phase (Phase 1.5) */
  plannerSystemPrompt?: InputMaybe<Scalars['String']['input']>
  /** New system message for the personality */
  systemMessage?: InputMaybe<Scalars['String']['input']>
  /** Reserved toggle for future multi-phase orchestration (currently unused). */
  usePlannerWriter?: InputMaybe<Scalars['Boolean']['input']>
  /** New frequency penalty for the writer phase LLM token generation */
  writerLlmFrequencyPenalty?: InputMaybe<Scalars['Float']['input']>
  /** Reserved model name for future response phase (currently unused). */
  writerLlmModel?: InputMaybe<Scalars['String']['input']>
  /** New LLM temperature setting for the writer phase (0.0 to 1.0) */
  writerLlmTemperature?: InputMaybe<Scalars['Float']['input']>
  /** New custom system prompt for the writer phase (Phase 2) */
  writerSystemPrompt?: InputMaybe<Scalars['String']['input']>
}

/** Oracle AI: Response envelope for personality update */
export type OraclePersonalityUpdateResponse = {
  __typename?: 'OraclePersonalityUpdateResponse'
  /** A list of errors that occurred during the mutation */
  errors: Array<Scalars['String']['output']>
  /** The updated personality, if successful */
  oraclePersonality?: Maybe<OraclePersonality>
  /** Indicates whether the mutation was successful */
  success: Scalars['Boolean']['output']
}

/** Oracle AI: Standard operators for string filtering */
export type OracleStringFilterInput = {
  eq?: InputMaybe<Scalars['String']['input']>
  gt?: InputMaybe<Scalars['String']['input']>
  gte?: InputMaybe<Scalars['String']['input']>
  in?: InputMaybe<Array<Scalars['String']['input']>>
  lt?: InputMaybe<Scalars['String']['input']>
  lte?: InputMaybe<Scalars['String']['input']>
}

/** Oracle AI: Standard operators for tags filtering */
export type OracleTagsFilterInput = {
  /** Filter questions that contain all of the specified tags */
  contains?: InputMaybe<Array<Scalars['String']['input']>>
  /** Filter questions that contain any of the specified tags */
  overlap?: InputMaybe<Array<Scalars['String']['input']>>
}

/** Oracle AI: Standard operators for UUID filtering */
export type OracleUuidFilterInput = {
  eq?: InputMaybe<Scalars['UUID']['input']>
  in?: InputMaybe<Array<Scalars['UUID']['input']>>
}

/** PM List - A curated list of content items (videos, series, people, tags, etc.) that can be associated with PM Sections. Lists are used primarily in 'content-list' section types where each list becomes a tab. Lists contain ordered content items that are displayed together. */
export type PmList = {
  __typename?: 'PMList'
  /** Administrative title used in admin interfaces to identify this list. Not displayed to end users. */
  adminTitle: Scalars['String']['output']
  /** The date the row was created */
  createdAt: Scalars['DateTime']['output']
  /** Description displayed to end users. User-facing description explaining what the list contains. Used for additional context when displaying the list. */
  description?: Maybe<Scalars['String']['output']>
  /** The primary identifier for this record */
  id: Scalars['ID']['output']
  /** Two letter language code (e.g., 'en', 'es', 'fr') for the list's language */
  language: Scalars['String']['output']
  /** Array of content type/content id objects that make up this list. Each item specifies a content type (e.g., 'video', 'series', 'person') and content ID. Items are displayed in the order they appear in this array. Example: [{type: 'series', id: '123'}, {type: 'video', id: '456'}] represents a list with one series followed by one video. */
  listItems: Array<PmListItem>
  /** Title displayed to end users. User-facing title for the list (e.g., 'Featured Videos', 'Popular Series'). Used when the list is displayed as a tab or section header. */
  title?: Maybe<Scalars['String']['output']>
  /** List type string constant that determines what kind of content the list contains. Valid types: 'content' (mix of videos and series from content model), 'content-people' (people/instructors from content model), 'content-tags' (tags from content model), 'portals' (user portals), 'people' (legacy people list type). The type affects how listItems are resolved and displayed. */
  type: Scalars['String']['output']
  /** The date the row was last updated */
  updatedAt: Scalars['DateTime']['output']
}

/** PM List Item */
export type PmListItem = {
  __typename?: 'PMListItem'
  /** The asset linked to this list item (resolved from image.asset) */
  asset?: Maybe<Asset>
  /** The child list id */
  childListId?: Maybe<Scalars['String']['output']>
  /** The content id */
  id?: Maybe<Scalars['String']['output']>
  /** The image linked to this list item (resolved from imageId) */
  image?: Maybe<Image>
  /**
   * The image id (for legacy people lists). Deprecated: use asset field instead.
   * @deprecated Use asset field instead
   */
  imageId?: Maybe<Scalars['String']['output']>
  /**
   * The image URL (computed). Deprecated: use asset.renderUrl instead.
   * @deprecated Use asset.renderUrl instead
   */
  imageUrl?: Maybe<Scalars['String']['output']>
  /** The content title (computed) */
  title?: Maybe<Scalars['String']['output']>
  /** The content type */
  type?: Maybe<Scalars['String']['output']>
}

/** PM List list response */
export type PmListListResponse = {
  __typename?: 'PMListListResponse'
  /** The total number of PM Lists matching the query */
  count?: Maybe<Scalars['Int']['output']>
  /** The limit used in the query */
  limit: Scalars['Int']['output']
  /** The offset used in the query */
  offset: Scalars['Int']['output']
  /** A list of PM List */
  pmLists: Array<PmList>
}

/** PM List where admin title input type */
export type PmListWhereAdminTitleInput = {
  /** Is the value equal to the field */
  eq?: InputMaybe<Scalars['String']['input']>
  /** Are the values in the field */
  in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
}

/** PM List where id input type */
export type PmListWhereIdInput = {
  /** Is the value equal to the field */
  eq?: InputMaybe<Scalars['ID']['input']>
  /** Are the values in the field */
  in?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>
}

/** PM List where conditions to filter rows */
export type PmListWhereInput = {
  /** The admin title field where clause */
  adminTitle?: InputMaybe<PmListWhereAdminTitleInput>
  /** The id field where clause */
  id?: InputMaybe<PmListWhereIdInput>
  /** The language field where clause */
  language?: InputMaybe<PmListWhereLanguageInput>
  /** The type field where clause */
  type?: InputMaybe<PmListWhereTypeInput>
}

/** PM List where language input type */
export type PmListWhereLanguageInput = {
  /** Is the value equal to the field */
  eq?: InputMaybe<Scalars['String']['input']>
  /** Are the values in the field */
  in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
}

/** PM List where type input type */
export type PmListWhereTypeInput = {
  /** Is the value equal to the field */
  eq?: InputMaybe<Scalars['String']['input']>
  /** Are the values in the field */
  in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
}

/** PM Screen - A screen/page in the application that contains multiple PM Sections. Screens define the overall page structure (e.g., member home page, centers page). Each screen has multiple sections that are displayed in order. Examples: 'member-home' (main member landing page), 'member-home-v2'/'member-home-v4' (updated versions), 'centers' (centers/communities page). */
export type PmScreen = {
  __typename?: 'PMScreen'
  /** The date the row was created */
  createdAt: Scalars['DateTime']['output']
  /** The primary identifier for this record */
  id: Scalars['ID']['output']
  /** Two letter language code (e.g., 'en', 'es', 'fr') for the screen's language */
  language: Scalars['String']['output']
  /**
   * PM Sections which are children of this PM Screen. Returns all sections belonging to this screen.
   * Sections can be personalized based on user context, filtered by content properties, and filtered by enabled status.
   * The hierarchy is: PMScreen → PMSection → PMList.
   * @see pmScreenPersonalized resolver for more details
   */
  pmSections: Array<PmSection>
  /** Screen type string constant that identifies the screen/page. Common types: 'member-home' (main member landing page, automatically upgraded to v2), 'member-home-v2' (member home version 2), 'member-home-v4' (member home version 4 with experiments), 'centers' (centers/communities page). Used to fetch the correct screen configuration for a given page in the app. */
  screenType: Scalars['String']['output']
  /** The date the row was last updated */
  updatedAt: Scalars['DateTime']['output']
}

/** PM Screen - A screen/page in the application that contains multiple PM Sections. Screens define the overall page structure (e.g., member home page, centers page). Each screen has multiple sections that are displayed in order. Examples: 'member-home' (main member landing page), 'member-home-v2'/'member-home-v4' (updated versions), 'centers' (centers/communities page). */
export type PmScreenPmSectionsArgs = {
  enabled?: InputMaybe<Scalars['Boolean']['input']>
  language?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  limit?: InputMaybe<Scalars['Int']['input']>
  offset?: InputMaybe<Scalars['Int']['input']>
  order?: InputMaybe<Array<InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>>>
}

/** PM Screen create input */
export type PmScreenCreateInput = {
  /** Two letter language code */
  language: Scalars['String']['input']
  /** Screen type string constant */
  screenType: Scalars['String']['input']
}

/** PM Screen create response */
export type PmScreenCreateResponse = {
  __typename?: 'PMScreenCreateResponse'
  /** The created PM Screen */
  pmScreen: PmScreen
  /** Whether the creation was successful */
  success: Scalars['Boolean']['output']
}

/** PM Screen delete response */
export type PmScreenDeleteResponse = {
  __typename?: 'PMScreenDeleteResponse'
  /** The deleted PM Screen */
  pmScreen: PmScreen
  /** Whether the deletion was successful */
  success: Scalars['Boolean']['output']
}

/** PM Screen list response */
export type PmScreenListResponse = {
  __typename?: 'PMScreenListResponse'
  /** The total number of PM Screens matching the query */
  count?: Maybe<Scalars['Int']['output']>
  /** The limit used in the query */
  limit: Scalars['Int']['output']
  /** The offset used in the query */
  offset: Scalars['Int']['output']
  /** A list of PM Screen */
  pmScreens: Array<PmScreen>
}

/** PM Screen personalized response */
export type PmScreenPersonalizedResponse = {
  __typename?: 'PMScreenPersonalizedResponse'
  /** The personalized PM Screen null when the screen is not found */
  pmScreen?: Maybe<PmScreen>
  /**
   * The screen type for the personalized screen, this is infered screen type from the requested args
   * e.g. the value used to get the pmScreen
   */
  screenType: Scalars['String']['output']
}

/** PM Screen update input */
export type PmScreenUpdateInput = {
  /** The primary identifier for this record */
  id: Scalars['ID']['input']
  /** Two letter language code */
  language?: InputMaybe<Scalars['String']['input']>
  /** Screen type string constant */
  screenType?: InputMaybe<Scalars['String']['input']>
}

/** PM Screen update response */
export type PmScreenUpdateResponse = {
  __typename?: 'PMScreenUpdateResponse'
  /** The updated PM Screen */
  pmScreen: PmScreen
  /** Whether the update was successful */
  success: Scalars['Boolean']['output']
}

/** PM Screen where id input type */
export type PmScreenWhereIdInput = {
  /** Is the value equal to the field */
  eq?: InputMaybe<Scalars['ID']['input']>
  /** Are the values in the field */
  in?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>
}

/** PM Screen where conditions to filter rows */
export type PmScreenWhereInput = {
  /** The id field where clause */
  id?: InputMaybe<PmScreenWhereIdInput>
  /** The language field where clause */
  language?: InputMaybe<PmScreenWhereLanguageInput>
  /** The screen type field where clause */
  screenType?: InputMaybe<PmScreenWhereScreenTypeInput>
}

/** PM Screen where language input type */
export type PmScreenWhereLanguageInput = {
  /** Is the value equal to the field */
  eq?: InputMaybe<Scalars['String']['input']>
  /** Are the values in the field */
  in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
}

/** PM Screen where screen type input type */
export type PmScreenWhereScreenTypeInput = {
  /** Is the value equal to the field */
  eq?: InputMaybe<Scalars['String']['input']>
  /** Are the values in the field */
  in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
}

/** PM Section - A content section that appears on a PM Screen. Sections define what content is displayed and how it's organized. Examples: content-list sections display curated lists of videos/series, continue-watching sections show user's watch history, placement sections show personalized recommendations. */
export type PmSection = {
  __typename?: 'PMSection'
  /** Administrative title used in admin interfaces to identify this section. Not displayed to end users. */
  adminTitle: Scalars['String']['output']
  /** The personalized and rendered version of this section for use in applications. This includes processed data with tabs, personalization, and all computed fields from getSection. */
  app?: Maybe<PmSectionApp>
  /** PM section availability of client attributes. Integer value: 1 = ALLOW_WITH (section only visible if request has matching client attributes), 2 = BLOCKED_WITH (section hidden if request has matching client attributes), 3 = NO_RESTRICTIONS (default, no client attribute filtering). Works in combination with clientAttributes array. */
  availabilityClientAttributes: Scalars['Int']['output']
  /** The client attributes to apply in combination with availability_client_attributes ordered ASC. Client attributes identify the app/platform making the request (e.g., 'app-provider-gaia', 'app-web', 'app-tv-android', 'app-mobile-ios'). Used to restrict section visibility to specific platforms. Must be ordered alphabetically. */
  clientAttributes: Array<Scalars['String']['output']>
  /** The date the row was created */
  createdAt: Scalars['DateTime']['output']
  /** Section is hidden when not enabled. When false, the section will not appear on the screen even if it exists. */
  enabled: Scalars['Boolean']['output']
  /** The primary identifier for this record */
  id: Scalars['ID']['output']
  /** Two letter language code (e.g., 'en', 'es', 'fr') for the section's language */
  language: Scalars['String']['output']
  /** Section placement order within a screen. Lower numbers appear first. Sections are sorted by this field when displayed. Used to control the vertical order of sections on a screen (e.g., header section might be order 1, featured content order 2, etc.). */
  order?: Maybe<Scalars['Int']['output']>
  /** PM Lists associated with this section. Used primarily by 'content-list' section types where each list becomes a tab. Lists are linked to sections through the pm_section_pm_list join table. Returns curated lists of content items (videos, series, people, tags, etc.) that belong to this section. */
  pmList: Array<PmList>
  /** The PM Screen that is the parent for this section. Resolves to the full PMScreen object containing this section. */
  pmScreen?: Maybe<PmScreen>
  /** The Screen this Section belongs to. Foreign key reference to the PMScreen that contains this section. */
  pmScreenId?: Maybe<Scalars['ID']['output']>
  /** The provider for the data of this section. Used when section content comes from external recommendation systems. Valid values: 'personalize' (AWS Personalize recommendations), 'pine' (Pine/SLR recommendation system). When null, section uses static or computed content. */
  provider?: Maybe<Scalars['String']['output']>
  /** The key that can be used to access the data for this provider. This is a provider-specific identifier used to fetch recommendations. For 'personalize' provider, this might be a campaign ID. For 'pine' provider, this might be a placement key. Used in combination with the provider field. */
  providerKey?: Maybe<Scalars['String']['output']>
  /** Section type string constant that determines the section's behavior and data structure. Common types: 'content-list' (curated lists with tabs), 'continue-watching' (user watch history), 'placement' (personalized recommendations), 'header' (screen header with image), 'recommended-content' (AI recommendations), 'most-popular' (popular content), 'courses' (course listings). See types.js for complete list. */
  type: Scalars['String']['output']
  /** The date the row was last updated */
  updatedAt: Scalars['DateTime']['output']
  /** Array of visibility rule objects that control when this section is shown to users. Rules can check user login status, subscriptions, content watched, test groups, etc. Sections are only visible if all rules pass (or are inverted). */
  visibility?: Maybe<Array<PmSectionVisibilityRule>>
}

/** PM Section - A content section that appears on a PM Screen. Sections define what content is displayed and how it's organized. Examples: content-list sections display curated lists of videos/series, continue-watching sections show user's watch history, placement sections show personalized recommendations. */
export type PmSectionAppArgs = {
  LASpotlightOption?: InputMaybe<Scalars['Boolean']['input']>
  content?: InputMaybe<Array<InputMaybe<ContentFilterInput>>>
  contentNot?: InputMaybe<Array<InputMaybe<ContentNotFilterInput>>>
  disableMerchImpressionCount?: InputMaybe<Scalars['Boolean']['input']>
  usePGV?: InputMaybe<Scalars['Boolean']['input']>
  useRandom?: InputMaybe<Scalars['Boolean']['input']>
}

/** PM Section - A content section that appears on a PM Screen. Sections define what content is displayed and how it's organized. Examples: content-list sections display curated lists of videos/series, continue-watching sections show user's watch history, placement sections show personalized recommendations. */
export type PmSectionPmListArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>
  offset?: InputMaybe<Scalars['Int']['input']>
  order?: InputMaybe<Array<InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>>>
}

/** PM Section App - A personalized and rendered version of a PM Section for use in applications. This includes processed data with tabs, personalization, and all computed fields from getSection. */
export type PmSectionApp = {
  __typename?: 'PMSectionApp'
  /** Administrative title used in admin interfaces to identify this section. Not displayed to end users. */
  adminTitle: Scalars['String']['output']
  /** PM section availability of client attributes */
  availabilityClientAttributes: Scalars['Int']['output']
  /** The client attributes to apply in combination with availability_client_attributes ordered ASC */
  clientAttributes: Array<Scalars['String']['output']>
  /** The date the row was created */
  createdAt: Scalars['DateTime']['output']
  /** Section-specific app data object with personalization and computed fields. The structure varies by section type. */
  data?: Maybe<PmSectionAppData>
  /** Section is hidden when not enabled */
  enabled: Scalars['Boolean']['output']
  /** The primary identifier for this record */
  id: Scalars['ID']['output']
  /** Two letter language code (e.g., 'en', 'es', 'fr') for the section's language */
  language: Scalars['String']['output']
  /** Section placement order within a screen */
  order?: Maybe<Scalars['Int']['output']>
  /** The Screen this Section belongs to */
  pmScreenId?: Maybe<Scalars['ID']['output']>
  /** The base PM Section model data for this app-rendered section */
  pmSection?: Maybe<PmSection>
  /** The provider for the data of this section */
  provider?: Maybe<Scalars['String']['output']>
  /** The key that can be used to access the data for this provider */
  providerKey?: Maybe<Scalars['String']['output']>
  /** Section type string constant that determines the section's behavior and data structure */
  type: Scalars['String']['output']
  /** The date the row was last updated */
  updatedAt: Scalars['DateTime']['output']
  /** Array of visibility rule objects that control when this section is shown to users */
  visibility?: Maybe<Array<PmSectionVisibilityRule>>
}

/** PM Section App Data union type - The data structure varies by section type. PMSectionAppDataPlacement for 'placement' sections (personalized recommendations), PMSectionAppDataContinueWatching for 'continue-watching'/'continue-watching-only'/'continue-watching-v3' sections, PMSectionAppDataContentList for 'content-list' sections (curated lists with tabs), PMSectionAppDataHeaderSection for 'header' sections (screen headers with images). */
export type PmSectionAppData =
  | PmSectionAppDataContentList
  | PmSectionAppDataContinueWatching
  | PmSectionAppDataHeaderSection
  | PmSectionAppDataPlacement

/** PM Section App Data Content Item */
export type PmSectionAppDataContentItem = {
  __typename?: 'PMSectionAppDataContentItem'
  /** The label */
  label?: Maybe<Scalars['String']['output']>
  /** The list id */
  listId: Scalars['ID']['output']
}

/** PM Section App Data for Content List types */
export type PmSectionAppDataContentList = {
  __typename?: 'PMSectionAppDataContentList'
  /** Array of content items with listId and label */
  content?: Maybe<Array<PmSectionAppDataContentItem>>
  /** The context for the section to be used in event reporting */
  contextType?: Maybe<Scalars['String']['output']>
  /** The display mode */
  displayMode?: Maybe<Scalars['String']['output']>
  /** Enable content preferences filtering */
  enableContentPreferencesFiltering?: Maybe<Scalars['Boolean']['output']>
  /** Enable user hidden content */
  enableUserHiddenContent?: Maybe<Scalars['Boolean']['output']>
  /** The footer data */
  footer?: Maybe<PmSectionAppDataFooter>
  /** The header data */
  header?: Maybe<PmSectionAppDataHeader>
  /** Hide watched content */
  hideWatched?: Maybe<Scalars['Boolean']['output']>
  /** Log section visibility */
  logSectionVisibility?: Maybe<Scalars['Boolean']['output']>
  /** The recommendation ID from Recombee for tracking purposes */
  recommId?: Maybe<Scalars['String']['output']>
  /** The render data which determines how the section will be displayed */
  render?: Maybe<PmSectionAppDataRender>
  /** The sort order */
  sortOrder?: Maybe<Scalars['String']['output']>
  /** The tabs data (complex computed structure) */
  tabs: Array<PmSectionAppDataTab>
}

/** PM Section App Data for Continue Watching type */
export type PmSectionAppDataContinueWatching = {
  __typename?: 'PMSectionAppDataContinueWatching'
  /** The context for the section to be used in event reporting */
  contextType?: Maybe<Scalars['String']['output']>
  /** The description */
  description?: Maybe<Scalars['String']['output']>
  /** The header data */
  header?: Maybe<PmSectionAppDataHeader>
  /** The render data which determines how the section will be displayed */
  render?: Maybe<PmSectionAppDataRender>
  /** The tabs data (complex computed structure) */
  tabs: Array<PmSectionAppDataTab>
  /** The title */
  title?: Maybe<Scalars['String']['output']>
}

/** PM Section App Data Footer */
export type PmSectionAppDataFooter = {
  __typename?: 'PMSectionAppDataFooter'
  /** The text for the footer of the section */
  label?: Maybe<Scalars['String']['output']>
}

/** PM Section App Data Header */
export type PmSectionAppDataHeader = {
  __typename?: 'PMSectionAppDataHeader'
  /** The text for the header of the section */
  label?: Maybe<Scalars['String']['output']>
}

/** PM Section App Data for Header section type */
export type PmSectionAppDataHeaderSection = {
  __typename?: 'PMSectionAppDataHeaderSection'
  /** The asset linked to this header section (resolved from image.asset) */
  asset?: Maybe<Asset>
  /** The description from the associated pmList */
  description?: Maybe<Scalars['String']['output']>
  /** The image linked to this header section (resolved from imageId) */
  image?: Maybe<Image>
  /**
   * The image id. Deprecated: use asset field instead.
   * @deprecated Use asset field instead
   */
  imageId?: Maybe<Scalars['String']['output']>
  /**
   * The image URL (computed). Deprecated: use asset.renderUrl instead.
   * @deprecated Use asset.renderUrl instead
   */
  imageUrl?: Maybe<Scalars['String']['output']>
  /** The title from the associated pmList */
  title?: Maybe<Scalars['String']['output']>
}

/** PM Section App Data for Placement type */
export type PmSectionAppDataPlacement = {
  __typename?: 'PMSectionAppDataPlacement'
  /** The context for the section to be used in event reporting */
  contextType?: Maybe<Scalars['String']['output']>
  /** The placement name */
  placement?: Maybe<Scalars['String']['output']>
  /** The render data which determines how the section will be displayed */
  render?: Maybe<PmSectionAppDataRender>
  /** The tabs data (complex computed structure) */
  tabs: Array<PmSectionAppDataTab>
}

/** PM Section App Data Render */
export type PmSectionAppDataRender = {
  __typename?: 'PMSectionAppDataRender'
  /** The background to render */
  background?: Maybe<Scalars['String']['output']>
  /** A link to the content */
  link?: Maybe<Scalars['String']['output']>
  /** The display width */
  tileCount?: Maybe<Scalars['String']['output']>
  /** The render type */
  type?: Maybe<Scalars['String']['output']>
}

/** PM Section App Tab */
export type PmSectionAppDataTab = {
  __typename?: 'PMSectionAppDataTab'
  /** The merchandising event ID */
  merchEventId?: Maybe<Scalars['ID']['output']>
  /** The type of payload (merchandising-content, featured-content-impression, etc.) */
  payloadType?: Maybe<Scalars['String']['output']>
  /** The recommendation score at tab level */
  pineScore?: Maybe<Scalars['Float']['output']>
  /** The source in pine for the score at tab level */
  pineSource?: Maybe<Scalars['String']['output']>
  /** The campaign slug for tracking */
  slug?: Maybe<Scalars['String']['output']>
  /** The tab content */
  tabContent: Array<PmSectionAppTabContent>
  /** The tab label */
  tabLabel?: Maybe<Scalars['String']['output']>
  /** The view mode for content display */
  viewMode?: Maybe<Scalars['String']['output']>
}

/** PM Section App Tab Content */
export type PmSectionAppTabContent = {
  __typename?: 'PMSectionAppTabContent'
  /** The content for this tab */
  content?: Maybe<Array<Maybe<Content>>>
  /** The content ID */
  contentId?: Maybe<Scalars['ID']['output']>
  /** The content type */
  contentType?: Maybe<Scalars['String']['output']>
  /** The content label */
  label?: Maybe<Scalars['String']['output']>
  /** The recommendation score */
  pineScore?: Maybe<Scalars['Float']['output']>
  /** The source in pine for the score */
  pineSource?: Maybe<Scalars['String']['output']>
  /** The seed question if this is a seed question e.g. type 'prompt' */
  seedQuestion?: Maybe<SeedQuestion>
  /**
   * The type of tab content (e.g., 'chat', 'prompt')
   * NOTE: this will only be present for seed questions.
   */
  type?: Maybe<PmSectionAppTabContentType>
  /** The video taste segment */
  videoTasteSegment?: Maybe<Scalars['String']['output']>
}

/** PM Section App Tab Content */
export type PmSectionAppTabContentContentArgs = {
  language?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  limit?: InputMaybe<Scalars['Int']['input']>
  offset?: InputMaybe<Scalars['Int']['input']>
}

export enum PmSectionAppTabContentType {
  /** chat */
  Chat = 'CHAT',
  /** prompt */
  Prompt = 'PROMPT',
}

/** PM Section create input */
export type PmSectionCreateInput = {
  /** Administrative title */
  adminTitle: Scalars['String']['input']
  /** PM section availability of client attributes such as no restrictions, only with or blocked with */
  availabilityClientAttributes?: InputMaybe<Scalars['Int']['input']>
  /** The client attributes to apply in combination with availability_client_attributes ordered ASC */
  clientAttributes?: InputMaybe<Array<Scalars['String']['input']>>
  /** JSON object specific to this section type */
  data?: InputMaybe<Scalars['JSON']['input']>
  /** Section is hidden when not enabled */
  enabled?: InputMaybe<Scalars['Boolean']['input']>
  /** Two letter language code */
  language: Scalars['String']['input']
  /** Section placement order within a screen */
  order?: InputMaybe<Scalars['Int']['input']>
  /** The Screen this Section belongs to */
  pmScreenId?: InputMaybe<Scalars['ID']['input']>
  /** The provider for the data of this section e.g. personalize */
  provider?: InputMaybe<Scalars['String']['input']>
  /** The key that can be used to access the data for this provider */
  providerKey?: InputMaybe<Scalars['String']['input']>
  /** Section type string constant */
  type: Scalars['String']['input']
  /** Array of visibility rule objects */
  visibility?: InputMaybe<Array<PmSectionVisibilityRuleInput>>
}

/** PM Section create response */
export type PmSectionCreateResponse = {
  __typename?: 'PMSectionCreateResponse'
  /** The created PM Section */
  pmSection: PmSection
  /** Whether the creation was successful */
  success: Scalars['Boolean']['output']
}

/** PM Section delete response */
export type PmSectionDeleteResponse = {
  __typename?: 'PMSectionDeleteResponse'
  /** The deleted PM Section */
  pmSection: PmSection
  /** Whether the deletion was successful */
  success: Scalars['Boolean']['output']
}

/** PM Section filter input */
export type PmSectionFilterInput = {
  /** The language to filter the rows by */
  language?: InputMaybe<Scalars['String']['input']>
  /** The type to filter the rows by */
  type?: InputMaybe<Scalars['String']['input']>
}

/** PM Section list response */
export type PmSectionListResponse = {
  __typename?: 'PMSectionListResponse'
  /** The total number of PM Sections matching the query */
  count?: Maybe<Scalars['Int']['output']>
  /** The limit used in the query */
  limit: Scalars['Int']['output']
  /** The offset used in the query */
  offset: Scalars['Int']['output']
  /** A list of PM Section */
  pmSections: Array<PmSection>
}

/** PM Section update input */
export type PmSectionUpdateInput = {
  /** Administrative title */
  adminTitle?: InputMaybe<Scalars['String']['input']>
  /** PM section availability of client attributes such as no restrictions, only with or blocked with */
  availabilityClientAttributes?: InputMaybe<Scalars['Int']['input']>
  /** The client attributes to apply in combination with availability_client_attributes ordered ASC */
  clientAttributes?: InputMaybe<Array<Scalars['String']['input']>>
  /** JSON object specific to this section type */
  data?: InputMaybe<Scalars['JSON']['input']>
  /** Section is hidden when not enabled */
  enabled?: InputMaybe<Scalars['Boolean']['input']>
  /** The primary identifier for this record */
  id: Scalars['ID']['input']
  /** Two letter language code */
  language?: InputMaybe<Scalars['String']['input']>
  /** Section placement order within a screen */
  order?: InputMaybe<Scalars['Int']['input']>
  /** The Screen this Section belongs to */
  pmScreenId?: InputMaybe<Scalars['ID']['input']>
  /** The provider for the data of this section e.g. personalize */
  provider?: InputMaybe<Scalars['String']['input']>
  /** The key that can be used to access the data for this provider */
  providerKey?: InputMaybe<Scalars['String']['input']>
  /** Section type string constant */
  type?: InputMaybe<Scalars['String']['input']>
  /** Array of visibility rule objects */
  visibility?: InputMaybe<Array<PmSectionVisibilityRuleInput>>
}

/** PM Section update response */
export type PmSectionUpdateResponse = {
  __typename?: 'PMSectionUpdateResponse'
  /** The updated PM Section */
  pmSection: PmSection
  /** Whether the update was successful */
  success: Scalars['Boolean']['output']
}

/** PM Section Visibility Rule */
export type PmSectionVisibilityRule = {
  __typename?: 'PMSectionVisibilityRule'
  /** Array of content items (required for user-following, user-has-watched, content-impression types) */
  content?: Maybe<Array<PmSectionVisibilityRuleContent>>
  /** Whether to invert the rule */
  inverse?: Maybe<Scalars['Boolean']['output']>
  /** Array of subscription option IDs (required for user-entitlement type) */
  subscriptions?: Maybe<Array<Scalars['Int']['output']>>
  /** Threshold value (required for user-view-count, my-series-min-items, followed-series-min-items types) */
  threshold?: Maybe<Scalars['Int']['output']>
  /** The visibility rule type */
  type: PmSectionVisibilityRuleType
}

/** PM Section Visibility Rule Content */
export type PmSectionVisibilityRuleContent = {
  __typename?: 'PMSectionVisibilityRuleContent'
  /** The content ID */
  contentId: Scalars['Int']['output']
  /** The content type */
  contentType: Scalars['String']['output']
}

/** PM Section Visibility Rule Content Input */
export type PmSectionVisibilityRuleContentInput = {
  /** The content ID */
  contentId: Scalars['Int']['input']
  /** The content type */
  contentType: Scalars['String']['input']
}

/** PM Section Visibility Rule Input */
export type PmSectionVisibilityRuleInput = {
  /** Array of content items (required for user-following, user-has-watched, content-impression types) */
  content?: InputMaybe<Array<PmSectionVisibilityRuleContentInput>>
  /** Whether to invert the rule */
  inverse?: InputMaybe<Scalars['Boolean']['input']>
  /** Array of subscription option IDs (required for user-entitlement type) */
  subscriptions?: InputMaybe<Array<Scalars['Int']['input']>>
  /** Threshold value (required for user-view-count, my-series-min-items, followed-series-min-items types) */
  threshold?: InputMaybe<Scalars['Int']['input']>
  /** The visibility rule type */
  type: PmSectionVisibilityRuleType
}

/** PM Section Visibility Rule Type */
export enum PmSectionVisibilityRuleType {
  /** Content impression rule */
  ContentImpression = 'CONTENT_IMPRESSION',
  /** FMTV only rule */
  FmtvOnly = 'FMTV_ONLY',
  /** Followed series minimum items rule */
  FollowedSeriesMinItems = 'FOLLOWED_SERIES_MIN_ITEMS',
  /** User must be logged in */
  LoggedIn = 'LOGGED_IN',
  /** My series minimum items rule */
  MySeriesMinItems = 'MY_SERIES_MIN_ITEMS',
  /** User must have onboarded terms */
  OnboardUserTerms = 'ONBOARD_USER_TERMS',
  /** Tenure rules */
  Tenure = 'TENURE',
  /** UBS rules */
  Ubs = 'UBS',
  /** User entitlement rule */
  UserEntitlement = 'USER_ENTITLEMENT',
  /** User following rule */
  UserFollowing = 'USER_FOLLOWING',
  /** User has watched rule */
  UserHasWatched = 'USER_HAS_WATCHED',
  /** User RC terms rule */
  UserRcTerms = 'USER_RC_TERMS',
  /** User test group rule */
  UserTestGroup = 'USER_TEST_GROUP',
  /** User view count rule */
  UserViewCount = 'USER_VIEW_COUNT',
  /** VTS rules */
  Vts = 'VTS',
}

/** PM Section where admin title input type */
export type PmSectionWhereAdminTitleInput = {
  /** Is the value equal to the field */
  eq?: InputMaybe<Scalars['String']['input']>
  /** Are the values in the field */
  in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
}

/** PM Section where availability client attributes input type */
export type PmSectionWhereAvailabilityClientAttributesInput = {
  /** Is the value equal to the field */
  eq?: InputMaybe<Scalars['Int']['input']>
  /** Are the values in the field */
  in?: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>
}

/** PM Section where client attributes input type */
export type PmSectionWhereClientAttributesInput = {
  /** Are the values in the field */
  in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
}

/** PM Section where enabled input type */
export type PmSectionWhereEnabledInput = {
  /** Is the value equal to the field */
  eq?: InputMaybe<Scalars['Boolean']['input']>
  /** Are the values in the field */
  in?: InputMaybe<Array<InputMaybe<Scalars['Boolean']['input']>>>
}

/** PM Section where id input type */
export type PmSectionWhereIdInput = {
  /** Is the value equal to the field */
  eq?: InputMaybe<Scalars['ID']['input']>
  /** Are the values in the field */
  in?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>
}

/** PM Section where conditions to filter rows */
export type PmSectionWhereInput = {
  /** The enabled field where clause */
  enabled?: InputMaybe<PmSectionWhereEnabledInput>
  /** The id field where clause */
  id?: InputMaybe<PmSectionWhereIdInput>
  /** The language field where clause */
  language?: InputMaybe<PmSectionWhereLanguageInput>
  /** The pm screen id field where clause */
  pmScreenId?: InputMaybe<PmSectionWherePmScreenIdInput>
  /** The type field where clause */
  type?: InputMaybe<PmSectionWhereTypeInput>
}

/** PM Section where language input type */
export type PmSectionWhereLanguageInput = {
  /** Is the value equal to the field */
  eq?: InputMaybe<Scalars['String']['input']>
  /** Are the values in the field */
  in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
}

/** PM Section where order input type */
export type PmSectionWhereOrderInput = {
  /** Is the value equal to the field */
  eq?: InputMaybe<Scalars['Int']['input']>
  /** Is the value greater than the field */
  gt?: InputMaybe<Scalars['Int']['input']>
  /** Is the value greater than or equal to the field */
  gte?: InputMaybe<Scalars['Int']['input']>
  /** Are the values in the field */
  in?: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>
  /** Is the value less than the field */
  lt?: InputMaybe<Scalars['Int']['input']>
  /** Is the value less than or equal to the field */
  lte?: InputMaybe<Scalars['Int']['input']>
}

/** PM Section where pm screen id input type */
export type PmSectionWherePmScreenIdInput = {
  /** Is the value equal to the field */
  eq?: InputMaybe<Scalars['ID']['input']>
  /** Are the values in the field */
  in?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>
}

/** PM Section where provider input type */
export type PmSectionWhereProviderInput = {
  /** Is the value equal to the field */
  eq?: InputMaybe<Scalars['String']['input']>
  /** Are the values in the field */
  in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
}

/** PM Section where provider key input type */
export type PmSectionWhereProviderKeyInput = {
  /** Is the value equal to the field */
  eq?: InputMaybe<Scalars['String']['input']>
  /** Are the values in the field */
  in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
}

/** PM Section where type input type */
export type PmSectionWhereTypeInput = {
  /** Is the value equal to the field */
  eq?: InputMaybe<Scalars['String']['input']>
  /** Are the values in the field */
  in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
}

/** Path redirect */
export type PathRedirect = {
  __typename?: 'PathRedirect'
  /** When the row was created */
  createdAt?: Maybe<Scalars['DateTime']['output']>
  /** The fragment to append to the redirect path */
  fragment?: Maybe<Scalars['String']['output']>
  /** The full URL for the redirect destination path (includes query & fragment) */
  fullUrl?: Maybe<Scalars['String']['output']>
  /** The primary key for this record */
  id?: Maybe<Scalars['ID']['output']>
  /** The query to append to the redirect path */
  query?: Maybe<Scalars['String']['output']>
  /** The redirect destination path */
  redirect?: Maybe<Scalars['String']['output']>
  /** The path to match */
  source?: Maybe<Scalars['String']['output']>
  /** The content associated with this path redirect by source path */
  sourceContent?: Maybe<Array<Maybe<Content>>>
  /** The HTTP response code (301 or 302) */
  type?: Maybe<Scalars['Int']['output']>
  /** When the row was last updated */
  updatedAt?: Maybe<Scalars['DateTime']['output']>
}

/** Path redirect list response */
export type PathRedirectListResponse = {
  __typename?: 'PathRedirectListResponse'
  /** A list of content reference */
  pathRedirects?: Maybe<Array<Maybe<PathRedirect>>>
}

/** Content path redirect type where input type */
export type PathRedirectWhereIdInput = {
  /** Is the value equal to the field */
  eq?: InputMaybe<Scalars['ID']['input']>
  /** Is the value greater than to the field */
  gt?: InputMaybe<Scalars['ID']['input']>
  /** Is the value greater than or equal to the field */
  gte?: InputMaybe<Scalars['ID']['input']>
  /** Are the values in the field */
  in?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>
}

/** Path redirect where conditions to filter rows */
export type PathRedirectWhereInput = {
  /** The id field where clause */
  id?: InputMaybe<PathRedirectWhereIdInput>
  /** The source field where clause */
  source?: InputMaybe<PathRedirectWhereSourceInput>
}

/** Path redirect id where input type */
export type PathRedirectWhereSourceInput = {
  /** Is the value equal to the field */
  eq?: InputMaybe<Scalars['String']['input']>
  /** Are the values in the field */
  in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
}

/** Payment Method Type */
export enum PaymentMethodType {
  ApplePay = 'ApplePay',
  CreditCard = 'CreditCard',
  GooglePay = 'GooglePay',
  PayPal = 'PayPal',
}

/** Plan Grid Device Type */
export enum PlanGridDeviceType {
  /** Desktop */
  Desktop = 'Desktop',
  /** Mobile */
  Mobile = 'Mobile',
}

/** Playlist row */
export type Playlist = {
  __typename?: 'Playlist'
  /** The date the row was created */
  createdAt?: Maybe<Scalars['DateTime']['output']>
  /** The primary key */
  id?: Maybe<Scalars['ID']['output']>
  /** The playlist items linked to this playlist */
  playlistItems?: Maybe<Array<Maybe<PlaylistItem>>>
  /** The playlist name */
  playlistName?: Maybe<Scalars['String']['output']>
  /** Playlist type (default | offline | yoga | custom) */
  playlistType?: Maybe<Scalars['String']['output']>
  /** User id of the playlist */
  uid?: Maybe<Scalars['ID']['output']>
  /** The date the row was last updated */
  updatedAt?: Maybe<Scalars['DateTime']['output']>
  /** The user info linked to this playlist */
  userInfo?: Maybe<UserInfo>
}

/** Playlist create playlist input */
export type PlaylistCreatePlaylistInput = {
  /** The playlist name */
  playlistName?: InputMaybe<Scalars['String']['input']>
  /** The playlist type */
  playlistType?: InputMaybe<Scalars['String']['input']>
}

/** Playlist create a playlist item input playlist data */
export type PlaylistCreatePlaylistItemPlaylistInput = {
  /** The primary key */
  id?: InputMaybe<Scalars['ID']['input']>
  /** The playlist name */
  playlistName?: InputMaybe<Scalars['String']['input']>
  /** The playlist type */
  playlistType?: InputMaybe<Scalars['String']['input']>
}

/** Playlist create a playlist item input playlist item data */
export type PlaylistCreatePlaylistItemPlaylistItemInput = {
  /** Content content id for this playlist item */
  contentId?: InputMaybe<Scalars['Int']['input']>
  /** Content content type for this playlist item */
  contentType?: InputMaybe<Scalars['String']['input']>
  /** The position of the item in the playlist, the highest number is the start of the playlist with zero being the last item */
  playlistPosition?: InputMaybe<Scalars['Int']['input']>
}

/** Repsonse when creating a playlist item */
export type PlaylistCreatePlaylistItemResponse = {
  __typename?: 'PlaylistCreatePlaylistItemResponse'
  /** The playlist for the created playlist item */
  playlist?: Maybe<Playlist>
  /** The playlist item which was created */
  playlistItem?: Maybe<PlaylistItem>
}

/** Repsonse when creating a playlist item */
export type PlaylistCreateResponse = {
  __typename?: 'PlaylistCreateResponse'
  /** The playlist that was created */
  playlist?: Maybe<Playlist>
}

/** Playlist delete playlist input */
export type PlaylistDeletePlaylistInput = {
  /** The playlist type */
  playlistType?: InputMaybe<Scalars['String']['input']>
}

/** Playlist delete a playlist item input playlist data */
export type PlaylistDeletePlaylistItemPlaylistInput = {
  /** The primary key */
  id?: InputMaybe<Scalars['ID']['input']>
  /** The playlist name */
  playlistName?: InputMaybe<Scalars['String']['input']>
  /** The playlist type */
  playlistType?: InputMaybe<Scalars['String']['input']>
}

/** Playlist item to delete */
export type PlaylistDeletePlaylistItemPlaylistItemInput = {
  /** Content content id for this playlist item */
  contentId?: InputMaybe<Scalars['Int']['input']>
  /** Content content type for this playlist item */
  contentType?: InputMaybe<Scalars['String']['input']>
  /** The playlist item id */
  id?: InputMaybe<Scalars['ID']['input']>
}

/** Repsonse when deleting a playlist item */
export type PlaylistDeletePlaylistItemResponse = {
  __typename?: 'PlaylistDeletePlaylistItemResponse'
  /** The playlist for the deleted playlist item */
  playlist?: Maybe<Playlist>
  /** The playlist item which was deleted */
  playlistItem?: Maybe<PlaylistItem>
}

/** Repsonse when creating a playlist item */
export type PlaylistDeleteResponse = {
  __typename?: 'PlaylistDeleteResponse'
  /** The playlist that was deleted */
  playlist?: Maybe<Playlist>
}

/** PlaylistItem row */
export type PlaylistItem = {
  __typename?: 'PlaylistItem'
  /** The playlist items content */
  content?: Maybe<Array<Maybe<Content>>>
  /** Content content id for this playlist item */
  contentId?: Maybe<Scalars['Int']['output']>
  /** Content content type (video | series) */
  contentType?: Maybe<Scalars['String']['output']>
  /** The date the row was created */
  createdAt?: Maybe<Scalars['DateTime']['output']>
  /** The primary key */
  id?: Maybe<Scalars['ID']['output']>
  /** The playlist linked to this playlist item */
  playlist?: Maybe<Playlist>
  /** ID for the playlist this item is tied to */
  playlistId?: Maybe<Scalars['ID']['output']>
  /** The position of the item in the playlist, the highest number is the start of the playlist with zero being the last item */
  playlistPosition?: Maybe<Scalars['Int']['output']>
  /** A human readable id that is identifies the content in a title group */
  titleGroupId?: Maybe<Scalars['String']['output']>
  /** The date the row was last updated */
  updatedAt?: Maybe<Scalars['DateTime']['output']>
}

/** PlaylistItem row */
export type PlaylistItemContentArgs = {
  applyContentPolicy?: InputMaybe<Scalars['Boolean']['input']>
  language?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
}

/** Playlist item list input to match by playlist */
export type PlaylistItemListPlaylistInput = {
  /** The playlist id */
  id?: InputMaybe<Scalars['ID']['input']>
  /** The playlist name when creating a playlist */
  playlistName?: InputMaybe<Scalars['String']['input']>
  /** The playlist type */
  playlistType?: InputMaybe<Scalars['String']['input']>
}

/** PlaylistItem asset response */
export type PlaylistItemListResponse = {
  __typename?: 'PlaylistItemListResponse'
  /** Total number of rows of content found (uses a slower count query for list) */
  count?: Maybe<Scalars['Int']['output']>
  /** The limit applied to the rows */
  limit?: Maybe<Scalars['Int']['output']>
  /** The offset applied to the rows */
  offset?: Maybe<Scalars['Int']['output']>
  /** A list of playlistItem */
  playlistItems?: Maybe<Array<Maybe<PlaylistItem>>>
}

/** The where clause for a playlistItem id field */
export type PlaylistItemWhereIdInput = {
  /** Is the value equal to the field */
  eq?: InputMaybe<Scalars['ID']['input']>
  /** Are the values in the field */
  in?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>
  /** Is the value not equal to the field */
  ne?: InputMaybe<Scalars['ID']['input']>
}

/** The where conditions to filter rows */
export type PlaylistItemWhereInput = {
  /** The id */
  id?: InputMaybe<PlaylistItemWhereIdInput>
}

/** Playlist asset response */
export type PlaylistListResponse = {
  __typename?: 'PlaylistListResponse'
  /** Total number of rows of content found (uses a slower count query for list) */
  count?: Maybe<Scalars['Int']['output']>
  /** The limit applied to the rows */
  limit?: Maybe<Scalars['Int']['output']>
  /** The offset applied to the rows */
  offset?: Maybe<Scalars['Int']['output']>
  /** A list of playlist */
  playlists?: Maybe<Array<Maybe<Playlist>>>
}

/** Playlist update a playlist item input playlist data */
export type PlaylistUpdatePlaylistItemPlaylistInput = {
  /** The primary key */
  id?: InputMaybe<Scalars['ID']['input']>
  /** The playlist name */
  playlistName?: InputMaybe<Scalars['String']['input']>
  /** The playlist type */
  playlistType?: InputMaybe<Scalars['String']['input']>
}

/** Playlist create a playlist item input playlist data */
export type PlaylistUpdatePlaylistItemPlaylistItemInput = {
  /** Content content id for this playlist item */
  contentId?: InputMaybe<Scalars['Int']['input']>
  /** Content content type for this playlist item */
  contentType?: InputMaybe<Scalars['String']['input']>
  /** The playlist item id */
  id?: InputMaybe<Scalars['ID']['input']>
  /** The position of the item in the playlist, the highest number is the start of the playlist with zero being the last item */
  playlistPosition?: InputMaybe<Scalars['Int']['input']>
}

/** Repsonse when updating a playlist item */
export type PlaylistUpdatePlaylistItemResponse = {
  __typename?: 'PlaylistUpdatePlaylistItemResponse'
  /** The playlist for the updated playlist item */
  playlist?: Maybe<Playlist>
  /** The playlist item which was updated */
  playlistItem?: Maybe<PlaylistItem>
}

/** The where clause for a playlist id field */
export type PlaylistWhereIdInput = {
  /** Is the value equal to the field */
  eq?: InputMaybe<Scalars['ID']['input']>
  /** Are the values in the field */
  in?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>
}

/** The where conditions to filter rows */
export type PlaylistWhereInput = {
  /** The id */
  id?: InputMaybe<PlaylistWhereIdInput>
  /** The playlist name */
  playlistName?: InputMaybe<PlaylistWherePlaylistNameInput>
  /** The uid */
  uid?: InputMaybe<PlaylistWhereUidInput>
}

/** The where clause for a playlist playlist name field */
export type PlaylistWherePlaylistNameInput = {
  /** Is the value equal to the field */
  eq?: InputMaybe<Scalars['ID']['input']>
  /** Are the values in the field */
  in?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>
}

/** The where clause for a playlist uid field */
export type PlaylistWhereUidInput = {
  /** Is the value equal to the field */
  eq?: InputMaybe<Scalars['ID']['input']>
  /** Is the value greater than to the field */
  gt?: InputMaybe<Scalars['ID']['input']>
  /** Is the value greater than or equal to the field */
  gte?: InputMaybe<Scalars['ID']['input']>
  /** Are the values in the field */
  in?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>
  /** Is the value less than to the field */
  lt?: InputMaybe<Scalars['ID']['input']>
  /** Is the value less than or equal to the field */
  lte?: InputMaybe<Scalars['ID']['input']>
}

/** Product Change Log Entity Name */
export enum ProductChangeLogEntityName {
  /** Bonus */
  Bonus = 'Bonus',
  /** Bonus Campaign */
  BonusCampaign = 'BonusCampaign',
  /** BillingProviderProduct */
  Plan = 'Plan',
  /** BillingPlanGrid */
  PlanGrid = 'PlanGrid',
  /** BillingProviderProductPricing */
  Price = 'Price',
  /** BillingProduct */
  Product = 'Product',
  /** BillingProvider */
  Provider = 'Provider',
  /** BillingProviderProductText */
  Text = 'Text',
}

/** Product Change Log Type */
export enum ProductChangeLogType {
  /** Create */
  Create = 'Create',
  /** Delete */
  Delete = 'Delete',
  /** Update */
  Update = 'Update',
}

/** Product Platform */
export enum ProductPlatform {
  /** Gaia */
  Gaia = 'Gaia',
  /** Yoga International */
  YogaInternational = 'YogaInternational',
}

/** Provider Product Language */
export enum ProviderProductLanguage {
  /** German */
  De = 'de',
  /** English */
  En = 'en',
  /** Spanish */
  Es = 'es',
  /** French */
  Fr = 'fr',
}

/** Provider Product Primary Stakeholder */
export enum ProviderProductPrimaryStakeholder {
  /** Marketing stakeholder */
  Marketing = 'marketing',
  /** Product stakeholder */
  Product = 'product',
}

/** Provider Product Term Type */
export enum ProviderProductTermType {
  /** day */
  Day = 'day',
  /** month */
  Month = 'month',
  /** week */
  Week = 'week',
  /** year */
  Year = 'year',
}

/** Provider Product Type */
export enum ProviderProductType {
  /** Course */
  Course = 'Course',
  /** Gift */
  Gift = 'Gift',
  /** Recurring subscription product */
  Recurring = 'Recurring',
}

export type Query = {
  __typename?: 'Query'
  _empty?: Maybe<Scalars['String']['output']>
  /** Get a list of Ambassador lead */
  ambassadorLeadsCount: AmbassadorLeadsCountResponse
  /** Get a list of Ambassador lead */
  ambassadorLeadsList?: Maybe<AmbassadorLeadsListResponse>
  /** Get a list of assetProviders */
  assetProvidersList?: Maybe<AssetProvidersListResponse>
  /** Get a list of assets */
  assetsList?: Maybe<AssetsListResponse>
  /** Get a list of userInfo reference */
  authRoleList?: Maybe<AuthRoleListResponse>
  /** Get a list of billing accounts */
  billingAccountList: BillingAccountListResponse
  /**
   * Get a count of billing events. Useful for understanding payment activity volume
   * without loading all event data. Use where filters to count specific event types,
   * payment providers, or time periods.
   */
  billingEventCount: BillingEventCountResponse
  /**
   * Get a list of billing events. Use this to analyze a user's payment history and
   * determine their current payment state.
   *
   * Best Practices for Payment State Analysis:
   * 1. Filter by uid to get events for a specific user
   * 2. Filter by source if user has multiple payment providers
   * 3. Order by txnDate DESC to get most recent events first
   * 4. Filter by txnType to focus on specific event types (e.g., "payment", "renewal")
   * 5. Use limit to focus on recent events (most recent 10-20 events often sufficient)
   *
   * Example queries:
   * - Recent successful payments: where: { uid: { eq: "123" } }, order: [["txnDate", "DESC"]]
   * - Payment failures: where: { uid: { eq: "123" }, txnType: { eq: "payment" } }
   * - Specific provider: where: { uid: { eq: "123" }, source: { eq: "google" } }
   */
  billingEventList?: Maybe<BillingEventListResponse>
  /** Get a list of billingInvoice */
  billingInvoiceList?: Maybe<BillingInvoiceListResponse>
  /** Get a list of BillingOneTimePurchases */
  billingOneTimePurchaseList?: Maybe<BillingOneTimePurchaseListResponse>
  /** Get a list of billingPayments */
  billingPaymentList?: Maybe<BillingPaymentListResponse>
  /** Get a list of billingProviderProductPricing */
  billingPaymentMethodList?: Maybe<BillingPaymentMethodListResponse>
  /** Get a list of billingPlanGrids */
  billingPlanGridList?: Maybe<BillingPlanGridListResponse>
  /** Get a list of billingProducts */
  billingProductChangeLogList?: Maybe<BillingProductChangeLogListResponse>
  /** Get a list of unique users who made billing product changes */
  billingProductChangeLogUsers?: Maybe<BillingProductChangeLogUserListResponse>
  /** Get a list of billingProducts */
  billingProductList?: Maybe<BillingProductListResponse>
  /** Get a list of billingProviderCurrency */
  billingProviderCurrencyList?: Maybe<BillingProviderCurrencyListResponse>
  /** Get a list of billingProviders */
  billingProviderList?: Maybe<BillingProviderListResponse>
  /** Get a list of billingProviderProducts */
  billingProviderProductList?: Maybe<BillingProviderProductListResponse>
  /** Get a list of billingProviderProductPricing */
  billingProviderProductPricingList?: Maybe<BillingProviderProductPricingListResponse>
  /** Get a list of billingProviderProductText reference */
  billingProviderProductTextList?: Maybe<BillingProviderProductTextListResponse>
  billingProviderProductTextTranslate?: Maybe<BillingProviderProductTextTranslateResponse>
  /** Verify billingProviderProductTexts */
  billingProviderProductTextVerify?: Maybe<Array<Maybe<BillingProviderProductTextVerifyError>>>
  /** Get a list of billingRefunds */
  billingRefundList?: Maybe<BillingRefundListResponse>
  /** Get a list of user accounts */
  billingSubscriptionList?: Maybe<BillingSubscriptionListResponse>
  /** Get a list of billingSubscriptionOrders */
  billingSubscriptionOrderList?: Maybe<BillingSubscriptionOrderListResponse>
  /** Get a list of user accounts */
  billingSubscriptionOrderPlanList?: Maybe<BillingSubscriptionOrderPlanListResponse>
  /** Get a list of billingSubscriptionPlans */
  billingSubscriptionPlanList?: Maybe<BillingSubscriptionPlanListResponse>
  /** Get a list of Chat history */
  chatHistoryList?: Maybe<ChatHistoryListResponse>
  /** Get a list of Chat session */
  chatSessionList?: Maybe<ChatSessionsListResponse>
  /** Get a list of comments */
  commentList?: Maybe<CommentsListResponse>
  /** Get a list of community comments for a post */
  communityCommentList?: Maybe<Array<Maybe<CommunityComment>>>
  /** Get a single community event by ID */
  communityEvent?: Maybe<CommunityEvent>
  /** Get a list of community events */
  communityEventList?: Maybe<Array<Maybe<CommunityEvent>>>
  /** Get a single community post by ID */
  communityPost?: Maybe<CommunityPost>
  /** Get a list of community posts */
  communityPostList?: Maybe<Array<Maybe<CommunityPost>>>
  /** Get a list of community reactions for a post */
  communityReactionList?: Maybe<Array<Maybe<CommunityReaction>>>
  /** Get a single community space by ID */
  communitySpace?: Maybe<CommunitySpace>
  /** Get a list of community spaces */
  communitySpaceList?: Maybe<Array<Maybe<CommunitySpace>>>
  /** Fetch AI-generated summary and transcript metadata by content and media identifiers. */
  contentAIMetadata: AiMetadataMediaAsset
  /** Get a list of Content analytic */
  contentAnalyticsList?: Maybe<ContentAnalyticsListResponse>
  /** Get a list of content asset reference types */
  contentAssetReferenceTypesList?: Maybe<ContentAssetReferenceTypesListResponse>
  /** Get a list of content asset reference types */
  contentAssetReferencesList?: Maybe<ContentAssetReferencesListResponse>
  /** List documents filter by where clauses */
  contentDocumentAggregatesList?: Maybe<ContentDocumentAggregatesList>
  /** Get a list of content reference */
  contentFilterList?: Maybe<ContentFilterListResponse>
  /** Get a list of content reference */
  contentFilterSetList?: Maybe<ContentFilterSetListResponse>
  /** Get a list of content reference */
  contentList?: Maybe<ContentListResponse>
  /** Get a list of content reference */
  contentListCriteriaList?: Maybe<ContentListCriteriaListResponse>
  /** Get a list of content reference */
  contentPolicyList?: Maybe<ContentPolicyListResponse>
  /** Get a list of content reference */
  contentProviderList?: Maybe<ContentProviderListResponse>
  /** Get a list of content reference types */
  contentReferenceTypesList?: Maybe<ContentReferenceTypesListResponse>
  /** Get a list of content references allowed */
  contentReferencesAllowedList?: Maybe<ContentReferencesAllowedResponse>
  /** Get a list of content reference */
  contentReferencesList?: Maybe<ContentReferencesListResponse>
  /** Get a list of media */
  contentSearchList?: Maybe<ContentSearchListResponse>
  /** Get a list of userInfo reference */
  contentSetList?: Maybe<ContentSetListResponse>
  /** Get demographics data for an email address */
  demographics?: Maybe<DemographicsResponse>
  /** List documents filter by where clauses */
  documentEmbeddingsList?: Maybe<DocumentEmbeddingsListResponse>
  /** Generate multiple queries from a single input query */
  documentMultiQuery?: Maybe<DocumentMultiQueryResponse>
  /** Generate an embedding using a query */
  documentQueryEmbedding?: Maybe<DocumentQueryEmbeddingResponse>
  /** Using natural language run chains against documents embedding data to get answers */
  documentsCallChain?: Maybe<Array<Maybe<DocumentCallChainResponse>>>
  /** List documents filter by where clauses */
  documentsList?: Maybe<DocumentsListResponse>
  /** Get a list of ecommerce sku mappings */
  ecommerceSkuMappingBonusEligibilitiesList: EcommerceSkuMappingBonusEligibilitiesListResponse
  /** Get a list of ecommerce sku mappings */
  ecommerceSkuMappingsList: EcommerceSkuMappingsListResponse
  /** Get a list of image content relationships */
  imageContentRelationshipsList?: Maybe<ImageContentRelationshipsListResponse>
  /** Get a list of image content relationships */
  imageContentRelationshipsListByContent?: Maybe<ImageContentRelationshipsListResponse>
  /** Get a list of images */
  imagesList?: Maybe<ImagesListResponse>
  /** Get a list of media assets */
  mediaAssetsList?: Maybe<MediaAssetListResponse>
  /** Get a list of media */
  mediaList?: Maybe<MediaListResponse>
  /** Get all spaces the authenticated user is a member of */
  myCommunitySpaces?: Maybe<Array<Maybe<CommunitySpace>>>
  /** Get a list of OAuth clients (admin only) */
  oauthClientList?: Maybe<OAuthClientListResponse>
  /** Oracle AI: Get a chat session by ID */
  oracleChatSession?: Maybe<OracleChatSession>
  /**
   * Oracle AI: Get chat sessions with optional filtering
   *
   *         Available ordering fields:
   *         - createdAt: Order by chat session creation time
   *         - updatedAt: Order by chat session last update time
   *         - name: Order by chat session name
   *         - id: Order by chat session ID
   *         - exportIndex: Order by export index
   *         - activityUpdatedAt: Order by most recent message activity (COALESCE of latest message created_at, fallback to session created_at)
   *
   *         Order format: [["fieldName", "ASC|DESC"], ...]
   *         Example: [["activityUpdatedAt", "DESC"], ["name", "ASC"]]
   */
  oracleChatSessionList: OracleChatSessionListResponse
  /** Oracle AI: Get server health status and version information */
  oracleHealth: OracleHealthResponse
  /** Oracle AI: Get individual messages, optionally filtered by chat session */
  oracleMessageList: OracleMessageListResponse
  /** Oracle AI: Get a message pair by ID */
  oracleMessagePair?: Maybe<OracleMessagePair>
  /** Oracle AI: Get message pairs with optional filtering */
  oracleMessagePairList: OracleMessagePairListResponse
  /** Oracle AI: Get all personalities */
  oraclePersonalityList: OraclePersonalityListResponse
  /** Get a list of content reference */
  pathRedirectList?: Maybe<PathRedirectListResponse>
  /** Get a list of PlaylistItem */
  playlistItemList?: Maybe<PlaylistItemListResponse>
  /** Get a list of Playlist */
  playlistList?: Maybe<PlaylistListResponse>
  /** Get a list of PM Lists */
  pmListList?: Maybe<PmListListResponse>
  /** Get a list of PM Screens */
  pmScreenList?: Maybe<PmScreenListResponse>
  /**
   * Get a personalized PM Screen considering the request which is used in application
   * UI to display the correct screen
   */
  pmScreenPersonalized: PmScreenPersonalizedResponse
  /** Get a list of PM Sections */
  pmSectionList?: Maybe<PmSectionListResponse>
  /** Oracle AI: Get current rate limit status for the user */
  rateLimitStatus: RateLimitInfo
  /** Get a list of raw events */
  rawEventList?: Maybe<RawEventListResponse>
  relatedBillingProviderProductList?: Maybe<BillingProviderProductListResponse>
  /** Search message pairs by text content */
  searchMessagePairs: ConversationSearchResponse
  /** Oracle AI: Get seed questions with optional filtering and pagination */
  seedQuestionList: SeedQuestionListResponse
  /** Get a list of testarossa subjects */
  testarossaSubjectsList?: Maybe<TestarossaSubjectsListResponse>
  /** Get a list of testarossaUsers */
  testarossaUsersList?: Maybe<TestarossaUsersListResponse>
  /** Get a count of transactions */
  transactionCount: TransactionCountResponse
  /** Get a list of transactions */
  transactionList?: Maybe<TransactionListResponse>
  /** Get a list of user accounts */
  userAccountList?: Maybe<UserAccountListResponse>
  /** Get a list of userAuditLogs */
  userAuditLogList?: Maybe<UserAuditLogListResponse>
  /** Get a list of billingPlanGrids for a user */
  userBillingPlanGridList?: Maybe<UserBillingPlanGridListResponse>
  /** Get a list of ecommerce sku mappings */
  userEcommerceSkuMappingBonusEligibilitiesList: UserEcommerceSkuMappingBonusEligibilitiesListResponse
  /**
   * Get a list of user entitlements. Returns entitlements based on the provided filters.
   * Access is restricted to users with elevated roles (SITE_ADMIN, CUSTOMER_SERVICE, CUSTOMER_SERVICE_MANAGER)
   * or users accessing their own entitlements (or entitlements for their account).
   */
  userEntitlementList?: Maybe<UserEntitlementListResponse>
  /** Get a list of user history events */
  userHistoryEventsList?: Maybe<UserHistoryEventsListResponse>
  /** Get a list of user history which is partitioned by uid consider the userHistory argument with a uid value for better performance */
  userHistoryList?: Maybe<UserHistoryListResponse>
  /** User info for the user currently making this request */
  userInfoCurrent?: Maybe<UserInfoCurrentResponse>
  /** Get a list of userInfo reference */
  userInfoList?: Maybe<UserInfoListResponse>
  /** Get a paginated list of users who have demographic metadata */
  userInfoWithMetadata: UserInfoWithMetadataResponse
  /** Get a list of user media positions */
  userMediaPositionList?: Maybe<UserMediaPositionListResponse>
  /** Get a list of user meta tags */
  userMetaTagList?: Maybe<UserMetaTagListResponse>
  /** Get the user metadata entries for a user */
  userMetadataList: Array<UserMetadata>
  /** Get a list of userInfo reference */
  userRoleList?: Maybe<UserRoleListResponse>
  /** Get a list of user state entries */
  userStateList?: Maybe<UserStateListResponse>
  /** Get a list of user state entries filtered by parent content title group id */
  userStateListByParent?: Maybe<UserStateListResponse>
  /** Get course progress for the current user */
  userStateProgressCourse?: Maybe<UserStateProgressCourseListResponse>
  /** List media */
  videoAnalyticsMediaList?: Maybe<VideoAnalyticsMediaListResponse>
  /** List video */
  videoAnalyticsVideoList?: Maybe<VideoAnalyticsVideoListResponse>
  /** Generate an on-demand summary for watched video content. */
  videoAutoSummary?: Maybe<VideoAutoSummaryPayload>
  /** Generate contextual prompt suggestions for watched video content. */
  videoPromptSuggestions?: Maybe<VideoPromptSuggestionsPayload>
  /** Get a list of Content analytic */
  voteList?: Maybe<VotesListResponse>
  /** Get a list of workers */
  workersList: WorkerListResponse
}

export type QueryAmbassadorLeadsCountArgs = {
  where?: InputMaybe<AmbassadorLeadsWhereInput>
}

export type QueryAmbassadorLeadsListArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>
  offset?: InputMaybe<Scalars['Int']['input']>
  order?: InputMaybe<Array<InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>>>
  where?: InputMaybe<AmbassadorLeadsWhereInput>
}

export type QueryAssetProvidersListArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>
  offset?: InputMaybe<Scalars['Int']['input']>
  order?: InputMaybe<Array<InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>>>
  where?: InputMaybe<AssetProviderWhereInput>
}

export type QueryAssetsListArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>
  offset?: InputMaybe<Scalars['Int']['input']>
  order?: InputMaybe<Array<InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>>>
  where?: InputMaybe<AssetWhereInput>
}

export type QueryAuthRoleListArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>
  offset?: InputMaybe<Scalars['Int']['input']>
  order?: InputMaybe<Array<InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>>>
  where?: InputMaybe<AuthRoleListWhereInput>
}

export type QueryBillingAccountListArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>
  offset?: InputMaybe<Scalars['Int']['input']>
  order?: InputMaybe<Array<InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>>>
  where?: InputMaybe<BillingAccountListWhereInput>
}

export type QueryBillingEventCountArgs = {
  where?: InputMaybe<BillingEventListWhereInput>
}

export type QueryBillingEventListArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>
  offset?: InputMaybe<Scalars['Int']['input']>
  order?: InputMaybe<Array<InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>>>
  where?: InputMaybe<BillingEventListWhereInput>
}

export type QueryBillingInvoiceListArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>
  offset?: InputMaybe<Scalars['Int']['input']>
  order?: InputMaybe<Array<InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>>>
  where?: InputMaybe<BillingInvoiceListWhereInput>
}

export type QueryBillingOneTimePurchaseListArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>
  offset?: InputMaybe<Scalars['Int']['input']>
  order?: InputMaybe<Array<InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>>>
  where?: InputMaybe<BillingOneTimePurchaseListWhereInput>
}

export type QueryBillingPaymentListArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>
  offset?: InputMaybe<Scalars['Int']['input']>
  order?: InputMaybe<Array<InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>>>
  where?: InputMaybe<BillingPaymentListWhereInput>
}

export type QueryBillingPaymentMethodListArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>
  offset?: InputMaybe<Scalars['Int']['input']>
  order?: InputMaybe<Array<InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>>>
  where?: InputMaybe<BillingPaymentMethodListWhereInput>
}

export type QueryBillingPlanGridListArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>
  offset?: InputMaybe<Scalars['Int']['input']>
  order?: InputMaybe<Array<InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>>>
  where?: InputMaybe<BillingPlanGridListWhereInput>
}

export type QueryBillingProductChangeLogListArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>
  offset?: InputMaybe<Scalars['Int']['input']>
  order?: InputMaybe<Array<InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>>>
  where?: InputMaybe<BillingProductChangeLogListWhereInput>
}

export type QueryBillingProductChangeLogUsersArgs = {
  where?: InputMaybe<BillingProductChangeLogListWhereInput>
}

export type QueryBillingProductListArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>
  offset?: InputMaybe<Scalars['Int']['input']>
  order?: InputMaybe<Array<InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>>>
  where?: InputMaybe<BillingProductListWhereInput>
}

export type QueryBillingProviderCurrencyListArgs = {
  billingProvider?: InputMaybe<BillingProviderCurrencyListBillingProviderInput>
  limit?: InputMaybe<Scalars['Int']['input']>
  offset?: InputMaybe<Scalars['Int']['input']>
  order?: InputMaybe<Array<InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>>>
  where?: InputMaybe<BillingProviderCurrencyListWhereInput>
}

export type QueryBillingProviderListArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>
  offset?: InputMaybe<Scalars['Int']['input']>
  order?: InputMaybe<Array<InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>>>
  where?: InputMaybe<BillingProviderListWhereInput>
}

export type QueryBillingProviderProductListArgs = {
  billingProduct?: InputMaybe<BillingProviderProductListBillingProductInput>
  billingProvider?: InputMaybe<BillingProviderProductListBillingProviderInput>
  currency?: InputMaybe<Scalars['String']['input']>
  deviceType?: InputMaybe<PlanGridDeviceType>
  language?: InputMaybe<ProviderProductLanguage>
  limit?: InputMaybe<Scalars['Int']['input']>
  offset?: InputMaybe<Scalars['Int']['input']>
  order?: InputMaybe<Array<InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>>>
  page?: InputMaybe<Scalars['String']['input']>
  planGrid?: InputMaybe<Scalars['Boolean']['input']>
  searchString?: InputMaybe<Scalars['String']['input']>
  where?: InputMaybe<BillingProviderProductListWhereInput>
}

export type QueryBillingProviderProductPricingListArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>
  offset?: InputMaybe<Scalars['Int']['input']>
  order?: InputMaybe<Array<InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>>>
  where?: InputMaybe<BillingProviderProductPricingListWhereInput>
}

export type QueryBillingProviderProductTextListArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>
  offset?: InputMaybe<Scalars['Int']['input']>
  order?: InputMaybe<Array<InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>>>
  where?: InputMaybe<BillingProviderProductTextListWhereInput>
}

export type QueryBillingProviderProductTextTranslateArgs = {
  input?: InputMaybe<BillingProviderProductTextTranslateInput>
  translationOptions?: InputMaybe<BillingProviderProductTextTranslationOptionsInput>
}

export type QueryBillingProviderProductTextVerifyArgs = {
  where?: InputMaybe<BillingProviderProductTextVerifyWhereInput>
}

export type QueryBillingRefundListArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>
  offset?: InputMaybe<Scalars['Int']['input']>
  order?: InputMaybe<Array<InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>>>
  where?: InputMaybe<BillingRefundListWhereInput>
}

export type QueryBillingSubscriptionListArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>
  offset?: InputMaybe<Scalars['Int']['input']>
  order?: InputMaybe<Array<InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>>>
  where?: InputMaybe<BillingSubscriptionListWhereInput>
}

export type QueryBillingSubscriptionOrderListArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>
  offset?: InputMaybe<Scalars['Int']['input']>
  order?: InputMaybe<Array<InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>>>
  where?: InputMaybe<BillingSubscriptionOrderListWhereInput>
}

export type QueryBillingSubscriptionOrderPlanListArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>
  offset?: InputMaybe<Scalars['Int']['input']>
  order?: InputMaybe<Array<InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>>>
  where?: InputMaybe<BillingSubscriptionOrderPlanListWhereInput>
}

export type QueryBillingSubscriptionPlanListArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>
  offset?: InputMaybe<Scalars['Int']['input']>
  order?: InputMaybe<Array<InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>>>
  where?: InputMaybe<BillingSubscriptionPlanListWhereInput>
}

export type QueryChatHistoryListArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>
  offset?: InputMaybe<Scalars['Int']['input']>
  order?: InputMaybe<Array<InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>>>
  where?: InputMaybe<ChatHistoryWhereInput>
}

export type QueryChatSessionListArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>
  offset?: InputMaybe<Scalars['Int']['input']>
  order?: InputMaybe<Array<InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>>>
  where?: InputMaybe<ChatSessionWhereInput>
}

export type QueryCommentListArgs = {
  content?: InputMaybe<Array<InputMaybe<CommentContentFilter>>>
  depthType?: InputMaybe<CommentDepthType>
  limit?: InputMaybe<Scalars['Int']['input']>
  offset?: InputMaybe<Scalars['Int']['input']>
  order?: InputMaybe<Array<InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>>>
  userCurrent?: InputMaybe<Scalars['Boolean']['input']>
  where?: InputMaybe<CommentWhereInput>
}

export type QueryCommunityCommentListArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>
  offset?: InputMaybe<Scalars['Int']['input']>
  postId: Scalars['ID']['input']
}

export type QueryCommunityEventArgs = {
  id: Scalars['ID']['input']
}

export type QueryCommunityEventListArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>
  offset?: InputMaybe<Scalars['Int']['input']>
  spaceId?: InputMaybe<Scalars['ID']['input']>
  upcoming?: InputMaybe<Scalars['Boolean']['input']>
}

export type QueryCommunityPostArgs = {
  id: Scalars['ID']['input']
}

export type QueryCommunityPostListArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>
  offset?: InputMaybe<Scalars['Int']['input']>
  spaceId?: InputMaybe<Scalars['ID']['input']>
}

export type QueryCommunityReactionListArgs = {
  postId: Scalars['ID']['input']
}

export type QueryCommunitySpaceArgs = {
  id: Scalars['ID']['input']
}

export type QueryCommunitySpaceListArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>
  offset?: InputMaybe<Scalars['Int']['input']>
  query?: InputMaybe<Scalars['String']['input']>
}

export type QueryContentAiMetadataArgs = {
  contentId: Scalars['ID']['input']
  mediaId: Scalars['ID']['input']
}

export type QueryContentAnalyticsListArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>
  offset?: InputMaybe<Scalars['Int']['input']>
  order?: InputMaybe<Array<InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>>>
  where?: InputMaybe<ContentAnalyticWhereInput>
}

export type QueryContentAssetReferenceTypesListArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>
  offset?: InputMaybe<Scalars['Int']['input']>
  order?: InputMaybe<Array<InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>>>
  where?: InputMaybe<ContentAssetReferenceTypeWhereInput>
}

export type QueryContentAssetReferencesListArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>
  offset?: InputMaybe<Scalars['Int']['input']>
  order?: InputMaybe<Array<InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>>>
  where?: InputMaybe<ContentAssetReferenceWhereInput>
}

export type QueryContentDocumentAggregatesListArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>
  offset?: InputMaybe<Scalars['Int']['input']>
  order?: InputMaybe<Array<InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>>>
  where?: InputMaybe<ContentDocumentAggregateWhereInput>
}

export type QueryContentFilterListArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>
  offset?: InputMaybe<Scalars['Int']['input']>
  order?: InputMaybe<Array<InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>>>
  where?: InputMaybe<ContentFilterWhereInput>
}

export type QueryContentFilterSetListArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>
  offset?: InputMaybe<Scalars['Int']['input']>
  order?: InputMaybe<Array<InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>>>
  where?: InputMaybe<ContentFilterSetWhereInput>
}

export type QueryContentListArgs = {
  applyContentPolicy?: InputMaybe<Scalars['Boolean']['input']>
  contentProviders?: InputMaybe<Array<InputMaybe<ContentContentProviderFilterInput>>>
  contentProvidersNot?: InputMaybe<Array<InputMaybe<ContentContentProviderFilterInput>>>
  contentReferencesFrom?: InputMaybe<Array<InputMaybe<ContentContentReferencesFromFilterInput>>>
  contentReferencesFromEvery?: InputMaybe<
    Array<InputMaybe<ContentContentReferencesFromFilterInput>>
  >
  contentReferencesFromNot?: InputMaybe<Array<InputMaybe<ContentContentReferencesFromFilterInput>>>
  contentReferencesTo?: InputMaybe<Array<InputMaybe<ContentContentReferencesToFilterInput>>>
  language?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  limit?: InputMaybe<Scalars['Int']['input']>
  offset?: InputMaybe<Scalars['Int']['input']>
  order?: InputMaybe<Array<InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>>>
  publishedAtDateHasExpired?: InputMaybe<Scalars['Boolean']['input']>
  publishedState?: InputMaybe<ContentFilterPublishedState>
  references?: InputMaybe<Array<InputMaybe<ContentContentReferencesToFilterInput>>>
  referencesEvery?: InputMaybe<Array<InputMaybe<ContentContentReferencesToFilterInput>>>
  referencesNot?: InputMaybe<Array<InputMaybe<ContentContentReferencesToFilterInput>>>
  useMaster?: InputMaybe<Scalars['Boolean']['input']>
  where?: InputMaybe<ContentWhereInput>
}

export type QueryContentListCriteriaListArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>
  offset?: InputMaybe<Scalars['Int']['input']>
  order?: InputMaybe<Array<InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>>>
  where?: InputMaybe<ContentListCriteriaWhereInput>
}

export type QueryContentPolicyListArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>
  offset?: InputMaybe<Scalars['Int']['input']>
  order?: InputMaybe<Array<InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>>>
  where?: InputMaybe<ContentPolicyWhereInput>
}

export type QueryContentProviderListArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>
  offset?: InputMaybe<Scalars['Int']['input']>
  order?: InputMaybe<Array<InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>>>
  useMaster?: InputMaybe<Scalars['Boolean']['input']>
  where?: InputMaybe<ContentProviderWhereInput>
}

export type QueryContentReferenceTypesListArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>
  offset?: InputMaybe<Scalars['Int']['input']>
  order?: InputMaybe<Array<InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>>>
  where?: InputMaybe<ContentReferenceTypesWhereInput>
}

export type QueryContentReferencesAllowedListArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>
  offset?: InputMaybe<Scalars['Int']['input']>
  order?: InputMaybe<Array<InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>>>
  where?: InputMaybe<ContentReferencesAllowedWhereInput>
}

export type QueryContentReferencesListArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>
  offset?: InputMaybe<Scalars['Int']['input']>
  order?: InputMaybe<Array<InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>>>
  publishedState?: InputMaybe<ContentFilterPublishedState>
  types?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  where?: InputMaybe<ContentReferencesWhereInput>
}

export type QueryContentSearchListArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>
  offset?: InputMaybe<Scalars['Int']['input']>
  order?: InputMaybe<Array<InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>>>
  where?: InputMaybe<ContentSearchWhereInput>
}

export type QueryContentSetListArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>
  offset?: InputMaybe<Scalars['Int']['input']>
  order?: InputMaybe<Array<InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>>>
  where?: InputMaybe<ContentSetListWhereInput>
}

export type QueryDemographicsArgs = {
  email: Scalars['String']['input']
}

export type QueryDocumentEmbeddingsListArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>
  offset?: InputMaybe<Scalars['Int']['input']>
  order?: InputMaybe<Array<InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>>>
  where?: InputMaybe<DocumentEmbeddingWhereInput>
}

export type QueryDocumentMultiQueryArgs = {
  query?: InputMaybe<Scalars['String']['input']>
  queryCount?: InputMaybe<Scalars['Int']['input']>
}

export type QueryDocumentQueryEmbeddingArgs = {
  query?: InputMaybe<Scalars['String']['input']>
}

export type QueryDocumentsCallChainArgs = {
  steps?: InputMaybe<Array<InputMaybe<DocumentCallChainStepInput>>>
}

export type QueryDocumentsListArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>
  offset?: InputMaybe<Scalars['Int']['input']>
  order?: InputMaybe<Array<InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>>>
  where?: InputMaybe<DocumentWhereInput>
}

export type QueryEcommerceSkuMappingBonusEligibilitiesListArgs = {
  effectiveDate?: InputMaybe<Scalars['DateTime']['input']>
  limit?: InputMaybe<Scalars['Int']['input']>
  offset?: InputMaybe<Scalars['Int']['input']>
  order?: InputMaybe<Array<InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>>>
  searchString?: InputMaybe<Scalars['String']['input']>
  where?: InputMaybe<EcommerceSkuMappingBonusEligibilitiesWhereInput>
}

export type QueryEcommerceSkuMappingsListArgs = {
  active?: InputMaybe<Scalars['Boolean']['input']>
  limit?: InputMaybe<Scalars['Int']['input']>
  offset?: InputMaybe<Scalars['Int']['input']>
  order?: InputMaybe<Array<InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>>>
  searchString?: InputMaybe<Scalars['String']['input']>
  userCurrent?: InputMaybe<Scalars['Boolean']['input']>
  userUuid?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>
  where?: InputMaybe<EcommerceSkuMappingsWhereInput>
}

export type QueryImageContentRelationshipsListArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>
  offset?: InputMaybe<Scalars['Int']['input']>
  order?: InputMaybe<Array<InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>>>
  where?: InputMaybe<ImageContentRelationshipWhereInput>
}

export type QueryImageContentRelationshipsListByContentArgs = {
  content?: InputMaybe<Array<InputMaybe<ImageContentRelationshipByContentInput>>>
}

export type QueryImagesListArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>
  offset?: InputMaybe<Scalars['Int']['input']>
  order?: InputMaybe<Array<InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>>>
  where?: InputMaybe<ImageWhereInput>
}

export type QueryMediaAssetsListArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>
  offset?: InputMaybe<Scalars['Int']['input']>
  order?: InputMaybe<Array<InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>>>
  where?: InputMaybe<MediaAssetWhereInput>
}

export type QueryMediaListArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>
  offset?: InputMaybe<Scalars['Int']['input']>
  order?: InputMaybe<Array<InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>>>
  where?: InputMaybe<MediaWhereInput>
}

export type QueryMyCommunitySpacesArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>
  offset?: InputMaybe<Scalars['Int']['input']>
}

export type QueryOauthClientListArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>
  offset?: InputMaybe<Scalars['Int']['input']>
  order?: InputMaybe<Array<InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>>>
  where?: InputMaybe<OAuthClientListWhereInput>
}

export type QueryOracleChatSessionArgs = {
  id: Scalars['ID']['input']
  queryOptions?: InputMaybe<QueryOptions>
  useMaster?: Scalars['Boolean']['input']
}

export type QueryOracleChatSessionListArgs = {
  id?: InputMaybe<Scalars['ID']['input']>
  limit?: Scalars['Int']['input']
  offset?: Scalars['Int']['input']
  order?: InputMaybe<Array<Array<Scalars['String']['input']>>>
  personalityId?: InputMaybe<Scalars['ID']['input']>
  queryOptions?: InputMaybe<QueryOptions>
  useMaster?: Scalars['Boolean']['input']
  where?: InputMaybe<OracleChatSessionListWhere>
}

export type QueryOracleMessageListArgs = {
  chatSessionId?: InputMaybe<Scalars['ID']['input']>
  limit?: Scalars['Int']['input']
  offset?: Scalars['Int']['input']
  order?: InputMaybe<Array<Array<Scalars['String']['input']>>>
  queryOptions?: InputMaybe<QueryOptions>
  useMaster?: Scalars['Boolean']['input']
  where?: InputMaybe<OracleMessageListWhere>
}

export type QueryOracleMessagePairArgs = {
  id: Scalars['ID']['input']
  queryOptions?: InputMaybe<QueryOptions>
  useMaster?: Scalars['Boolean']['input']
}

export type QueryOracleMessagePairListArgs = {
  chatSessionId?: InputMaybe<Scalars['ID']['input']>
  limit?: Scalars['Int']['input']
  offset?: Scalars['Int']['input']
  order?: InputMaybe<Array<Array<Scalars['String']['input']>>>
  queryOptions?: InputMaybe<QueryOptions>
  useMaster?: Scalars['Boolean']['input']
  where?: InputMaybe<OracleMessagePairListWhere>
}

export type QueryOraclePersonalityListArgs = {
  limit?: Scalars['Int']['input']
  offset?: Scalars['Int']['input']
  order?: InputMaybe<Array<Array<Scalars['String']['input']>>>
  queryOptions?: InputMaybe<QueryOptions>
  useMaster?: Scalars['Boolean']['input']
  where?: InputMaybe<OraclePersonalityListWhere>
}

export type QueryPathRedirectListArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>
  offset?: InputMaybe<Scalars['Int']['input']>
  order?: InputMaybe<Array<InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>>>
  where?: InputMaybe<PathRedirectWhereInput>
}

export type QueryPlaylistItemListArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>
  offset?: InputMaybe<Scalars['Int']['input']>
  order?: InputMaybe<Array<InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>>>
  playlists?: InputMaybe<Array<InputMaybe<PlaylistItemListPlaylistInput>>>
  userCurrent?: InputMaybe<Scalars['Boolean']['input']>
  where?: InputMaybe<PlaylistItemWhereInput>
}

export type QueryPlaylistListArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>
  offset?: InputMaybe<Scalars['Int']['input']>
  order?: InputMaybe<Array<InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>>>
  userCurrent?: InputMaybe<Scalars['Boolean']['input']>
  where?: InputMaybe<PlaylistWhereInput>
}

export type QueryPmListListArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>
  offset?: InputMaybe<Scalars['Int']['input']>
  order?: InputMaybe<Array<InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>>>
  where?: InputMaybe<PmListWhereInput>
}

export type QueryPmScreenListArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>
  offset?: InputMaybe<Scalars['Int']['input']>
  order?: InputMaybe<Array<InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>>>
  where?: InputMaybe<PmScreenWhereInput>
}

export type QueryPmScreenPersonalizedArgs = {
  content?: InputMaybe<Array<InputMaybe<ContentFilterInput>>>
  contentNot?: InputMaybe<Array<InputMaybe<ContentNotFilterInput>>>
  enabled?: InputMaybe<Scalars['Boolean']['input']>
  language?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  screenType: Scalars['String']['input']
}

export type QueryPmSectionListArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>
  offset?: InputMaybe<Scalars['Int']['input']>
  order?: InputMaybe<Array<InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>>>
  where?: InputMaybe<PmSectionWhereInput>
}

export type QueryRateLimitStatusArgs = {
  mode?: InputMaybe<Scalars['String']['input']>
  timezone?: InputMaybe<Scalars['String']['input']>
}

export type QueryRawEventListArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>
  offset?: InputMaybe<Scalars['Int']['input']>
  order?: InputMaybe<Array<InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>>>
  where?: InputMaybe<RawEventListWhereInput>
}

export type QueryRelatedBillingProviderProductListArgs = {
  id?: InputMaybe<Scalars['ID']['input']>
  providerSegmentIds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
}

export type QuerySearchMessagePairsArgs = {
  limit?: Scalars['Int']['input']
  offset?: Scalars['Int']['input']
  query: Scalars['String']['input']
}

export type QuerySeedQuestionListArgs = {
  language?: Scalars['String']['input']
  limit?: Scalars['Int']['input']
  offset?: Scalars['Int']['input']
  order?: InputMaybe<Array<Array<Scalars['String']['input']>>>
  personalized?: InputMaybe<SeedQuestionPersonalization>
  queryOptions?: InputMaybe<QueryOptions>
  randomized?: Scalars['Boolean']['input']
  useMaster?: Scalars['Boolean']['input']
  where?: InputMaybe<SeedQuestionListWhere>
}

export type QueryTestarossaSubjectsListArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>
  offset?: InputMaybe<Scalars['Int']['input']>
  order?: InputMaybe<Array<InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>>>
  where?: InputMaybe<TestarossaSubjectsListWhereInput>
}

export type QueryTestarossaUsersListArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>
  offset?: InputMaybe<Scalars['Int']['input']>
  order?: InputMaybe<Array<InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>>>
  where?: InputMaybe<TestarossaUsersListWhereInput>
}

export type QueryTransactionCountArgs = {
  where?: InputMaybe<TransactionListWhereInput>
}

export type QueryTransactionListArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>
  offset?: InputMaybe<Scalars['Int']['input']>
  order?: InputMaybe<Array<InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>>>
  where?: InputMaybe<TransactionListWhereInput>
}

export type QueryUserAccountListArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>
  offset?: InputMaybe<Scalars['Int']['input']>
  order?: InputMaybe<Array<InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>>>
  where?: InputMaybe<UserAccountListWhereInput>
}

export type QueryUserAuditLogListArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>
  offset?: InputMaybe<Scalars['Int']['input']>
  order?: InputMaybe<Array<InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>>>
  where?: InputMaybe<UserAuditLogListWhereInput>
}

export type QueryUserBillingPlanGridListArgs = {
  where?: InputMaybe<UserBillingPlanGridListWhereInput>
}

export type QueryUserEcommerceSkuMappingBonusEligibilitiesListArgs = {
  ecommerceSku?: InputMaybe<Scalars['String']['input']>
  limit?: InputMaybe<Scalars['Int']['input']>
  offset?: InputMaybe<Scalars['Int']['input']>
  order?: InputMaybe<Array<InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>>>
  planSku?: InputMaybe<Scalars['String']['input']>
  provider?: InputMaybe<Scalars['String']['input']>
  userCurrent?: InputMaybe<Scalars['Boolean']['input']>
  userUuid?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>
  where?: InputMaybe<UserEcommerceSkuMappingBonusEligibilitiesWhereIdInput>
}

export type QueryUserEntitlementListArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>
  offset?: InputMaybe<Scalars['Int']['input']>
  order?: InputMaybe<Array<InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>>>
  where?: InputMaybe<UserEntitlementListWhereInput>
}

export type QueryUserHistoryEventsListArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>
  offset?: InputMaybe<Scalars['Int']['input']>
  order?: InputMaybe<Array<InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>>>
  where?: InputMaybe<UserHistoryEventsListWhereInput>
}

export type QueryUserHistoryListArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>
  offset?: InputMaybe<Scalars['Int']['input']>
  order?: InputMaybe<Array<InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>>>
  userHistory?: InputMaybe<Array<InputMaybe<UserHistoryFilterInput>>>
  where?: InputMaybe<UserHistoryListWhereInput>
}

export type QueryUserInfoListArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>
  offset?: InputMaybe<Scalars['Int']['input']>
  order?: InputMaybe<Array<InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>>>
  where?: InputMaybe<UserInfoListWhereInput>
}

export type QueryUserInfoWithMetadataArgs = {
  limit: Scalars['Int']['input']
  offset: Scalars['Int']['input']
}

export type QueryUserMediaPositionListArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>
  offset?: InputMaybe<Scalars['Int']['input']>
  order?: InputMaybe<Array<InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>>>
  userCurrent?: InputMaybe<Scalars['Boolean']['input']>
  where?: InputMaybe<UserMediaPositionListWhereInput>
}

export type QueryUserMetaTagListArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>
  offset?: InputMaybe<Scalars['Int']['input']>
  order?: InputMaybe<Array<InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>>>
  userCurrent?: InputMaybe<Scalars['Boolean']['input']>
  userMetaTags?: InputMaybe<Array<UserMetaTagFilterInput>>
  where?: InputMaybe<UserMetaTagWhereInput>
}

export type QueryUserMetadataListArgs = {
  uid: Scalars['Int']['input']
}

export type QueryUserRoleListArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>
  offset?: InputMaybe<Scalars['Int']['input']>
  order?: InputMaybe<Array<InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>>>
  where?: InputMaybe<UserRoleListWhereInput>
}

export type QueryUserStateListArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>
  offset?: InputMaybe<Scalars['Int']['input']>
  order?: InputMaybe<Array<InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>>>
  userCurrent?: InputMaybe<Scalars['Boolean']['input']>
  where?: InputMaybe<UserStateWhereInput>
}

export type QueryUserStateListByParentArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>
  offset?: InputMaybe<Scalars['Int']['input']>
  order?: InputMaybe<Array<InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>>>
  parentContentTitleGroupId: Scalars['String']['input']
  userCurrent?: InputMaybe<Scalars['Boolean']['input']>
  where?: InputMaybe<UserStateWhereInput>
}

export type QueryUserStateProgressCourseArgs = {
  courseTitleGroupIds?: InputMaybe<Array<Scalars['String']['input']>>
  limit?: InputMaybe<Scalars['Int']['input']>
  offset?: InputMaybe<Scalars['Int']['input']>
  order?: InputMaybe<Array<InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>>>
  state?: InputMaybe<UserStateCourse>
}

export type QueryVideoAnalyticsMediaListArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>
  offset?: InputMaybe<Scalars['Int']['input']>
  order?: InputMaybe<Array<InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>>>
  where?: InputMaybe<VideoAnalyticsMediaListWhereInput>
}

export type QueryVideoAnalyticsVideoListArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>
  offset?: InputMaybe<Scalars['Int']['input']>
  order?: InputMaybe<Array<InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>>>
  where?: InputMaybe<VideoAnalyticsVideoListWhereInput>
}

export type QueryVideoAutoSummaryArgs = {
  input: VideoAutoSummaryInput
}

export type QueryVideoPromptSuggestionsArgs = {
  input: VideoPromptSuggestionsInput
}

export type QueryVoteListArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>
  offset?: InputMaybe<Scalars['Int']['input']>
  order?: InputMaybe<Array<InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>>>
  userCurrent?: InputMaybe<Scalars['Boolean']['input']>
  where?: InputMaybe<VoteWhereInput>
}

export type QueryWorkersListArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>
  offset?: InputMaybe<Scalars['Int']['input']>
  order?: InputMaybe<Array<InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>>>
  where?: InputMaybe<WorkerWhereInput>
}

export type QueryOptions = {
  useMaster?: Scalars['Boolean']['input']
}

export type RateLimitInfo = {
  __typename?: 'RateLimitInfo'
  /** The mode this rate limit applies to ('text', 'voice', or null for all) */
  mode?: Maybe<Scalars['String']['output']>
  /** Whether the user is currently rate limited */
  rateLimited: Scalars['Boolean']['output']
  /** Number of remaining interactions allowed today */
  remainingInteractions: Scalars['Int']['output']
  /** Total number of interactions today */
  totalInteractions: Scalars['Int']['output']
}

/** Raw events */
export type RawEvent = {
  __typename?: 'RawEvent'
  /** The number of attempts */
  attempts?: Maybe<Scalars['Int']['output']>
  /** When the row was created */
  createdAt?: Maybe<Scalars['DateTime']['output']>
  /** The error level */
  errorLevel?: Maybe<Scalars['Int']['output']>
  /** Whether failed event has been resolved manually */
  errorResolvedManually?: Maybe<Scalars['Boolean']['output']>
  /** Link to event */
  eventUuid?: Maybe<Scalars['ID']['output']>
  /** The primary identifier for this record */
  id?: Maybe<Scalars['ID']['output']>
  /** The new run time for the event */
  nextRunTime?: Maybe<Scalars['DateTime']['output']>
  /** The event payload from the provider */
  payload?: Maybe<Scalars['String']['output']>
  /** When true the raw event was processed */
  processed?: Maybe<Scalars['Boolean']['output']>
  /** The processing error */
  processingError?: Maybe<Scalars['String']['output']>
  /** The event source */
  source?: Maybe<Scalars['String']['output']>
  /** The transaction type */
  txnType?: Maybe<Scalars['String']['output']>
  /** When the row was last updated */
  updatedAt?: Maybe<Scalars['DateTime']['output']>
}

/** Raw event policy list response */
export type RawEventListResponse = {
  __typename?: 'RawEventListResponse'
  /** Total number of rows found (uses a slower count query for list) */
  count?: Maybe<Scalars['Int']['output']>
  /** The limit applied to the rows */
  limit?: Maybe<Scalars['Int']['output']>
  /** The offset applied to the rows */
  offset?: Maybe<Scalars['Int']['output']>
  /** A list of raw events */
  rawEvents?: Maybe<Array<Maybe<RawEvent>>>
}

/** Raw event id type where input type */
export type RawEventListWhereIdInput = {
  /** Is the value equal to the field */
  eq?: InputMaybe<Scalars['ID']['input']>
  /** Is the value greater than to the field */
  gt?: InputMaybe<Scalars['ID']['input']>
  /** Is the value greater than or equal to the field */
  gte?: InputMaybe<Scalars['ID']['input']>
  /** Are the values in the field */
  in?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>
}

/** Raw event policy where conditions to filter rows */
export type RawEventListWhereInput = {
  /** The id field where clause */
  id?: InputMaybe<RawEventListWhereIdInput>
}

export type RawEventUpdateInput = {
  /** Number of attempts made to process this source */
  attempts?: InputMaybe<Scalars['Int']['input']>
  /** Timestamp when this source was created */
  createdAt?: InputMaybe<Scalars['DateTime']['input']>
  /** Error level; e.g., 'info', 'warn', 'error' for this source */
  errorLevel?: InputMaybe<Scalars['Int']['input']>
  /** Whether an error was resolved manually for this source */
  errorResolvedManually?: InputMaybe<Scalars['Boolean']['input']>
  /** Unique identifier for the event associated with this source (if applicable) */
  eventUuid?: InputMaybe<Scalars['String']['input']>
  /** Unique identifier for the source (e.g., a database or file ID) */
  id: Scalars['Int']['input']
  /** Scheduled timestamp for the next run of this source */
  nextRunTime?: InputMaybe<Scalars['DateTime']['input']>
  /** Payload data of the event */
  payload?: InputMaybe<Scalars['String']['input']>
  /** Whether the source has been processed successfully */
  processed?: InputMaybe<Scalars['Boolean']['input']>
  /** Detailed error message associated with processing errors for this source */
  processingError?: InputMaybe<Scalars['String']['input']>
  /** Source of the raw event */
  source?: InputMaybe<Scalars['String']['input']>
  /** Type of transaction associated with this source */
  txnType?: InputMaybe<Scalars['String']['input']>
  /** Timestamp when this source was last updated */
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>
}

export enum Role {
  Ambassador = 'AMBASSADOR',
  AmbassadorAdmin = 'AMBASSADOR_ADMIN',
  ApiClient = 'API_CLIENT',
  BillingSupport = 'BILLING_SUPPORT',
  CustomerService = 'CUSTOMER_SERVICE',
  CustomerServiceManager = 'CUSTOMER_SERVICE_MANAGER',
  Editor = 'EDITOR',
  EditorPlus = 'EDITOR_PLUS',
  FullAccessReadOnly = 'FULL_ACCESS_READ_ONLY',
  MarketingPlansManager = 'MARKETING_PLANS_MANAGER',
  ProductPlansManager = 'PRODUCT_PLANS_MANAGER',
  SiteAdmin = 'SITE_ADMIN',
  User = 'USER',
  ViewContentOnly = 'VIEW_CONTENT_ONLY',
  ViewMediaOnly = 'VIEW_MEDIA_ONLY',
}

export enum S3Acl {
  /** Private */
  Private = 'PRIVATE',
  /** Public read */
  PublicRead = 'PUBLIC_READ',
}

export type S3UpsertNdjsonInput = {
  /** The object access control policy */
  acl?: InputMaybe<S3Acl>
  /** The s3 object data */
  data: Scalars['JSON']['input']
  /** The primary identifier for this record */
  key: Scalars['ID']['input']
}

export type S3UpsertNdjsonResult = {
  __typename?: 'S3UpsertNdjsonResult'
  /** The number of objects upserted */
  count?: Maybe<Scalars['Int']['output']>
}

/** Oracle AI: A seed question for training or reference */
export type SeedQuestion = {
  __typename?: 'SeedQuestion'
  /** Timestamp of when the seed question was created */
  createdAt: Scalars['DateTime']['output']
  /** The primary key */
  id: Scalars['ID']['output']
  /** Language code for the question (e.g., en, es, fr) */
  language: Scalars['String']['output']
  /** The question text */
  question: Scalars['String']['output']
  /** Array of tags for categorizing the question */
  tags: Array<Scalars['String']['output']>
  /** Timestamp of when the seed question was last updated */
  updatedAt: Scalars['DateTime']['output']
}

/** Oracle AI: Input for creating a new seed question */
export type SeedQuestionCreateInput = {
  /** Language code for the question (e.g., en, es, fr) */
  language: Scalars['String']['input']
  /** The question text */
  question: Scalars['String']['input']
  /** Array of tags for categorizing the question */
  tags: Array<Scalars['String']['input']>
}

/** Oracle AI: Response envelope for seed question creation */
export type SeedQuestionCreateResponse = {
  __typename?: 'SeedQuestionCreateResponse'
  /** A list of errors that occurred during the mutation */
  errors: Array<Scalars['String']['output']>
  /** The created seed question, if successful */
  seedQuestion?: Maybe<SeedQuestion>
  /** Indicates whether the mutation was successful */
  success: Scalars['Boolean']['output']
}

/** Oracle AI: Response envelope for seed question deletion */
export type SeedQuestionDeleteResponse = {
  __typename?: 'SeedQuestionDeleteResponse'
  /** A list of errors that occurred during the mutation */
  errors: Array<Scalars['String']['output']>
  /** The deleted seed question, if successful */
  seedQuestion?: Maybe<SeedQuestion>
  /** Indicates whether the mutation was successful */
  success: Scalars['Boolean']['output']
}

/** Oracle AI: Seed question list response */
export type SeedQuestionListResponse = {
  __typename?: 'SeedQuestionListResponse'
  /** The total number of seed questions available. */
  count: Scalars['Int']['output']
  /** The number of seed questions returned in this response. */
  limit: Scalars['Int']['output']
  /** The starting point of the returned seed questions. */
  offset: Scalars['Int']['output']
  /** A list of seed questions. */
  seedQuestions: Array<SeedQuestion>
  /** User meta tags for personalization (empty if personalization is not requested). */
  userMetaTags: Array<UserMetaTag>
}

/** Oracle AI: Filtering options for seed question lists */
export type SeedQuestionListWhere = {
  /** Filter by creation timestamp */
  createdAt?: InputMaybe<OracleDateTimeFilterInput>
  /** Filter by seed question ID */
  id?: InputMaybe<OracleIdFilterInput>
  /** Filter by language code (deprecated: use top-level language parameter instead) */
  language?: InputMaybe<OracleStringFilterInput>
  /** Filter by question text */
  question?: InputMaybe<OracleStringFilterInput>
  /** Filter by tags using overlap operation */
  tags?: InputMaybe<OracleTagsFilterInput>
  /** Filter by update timestamp */
  updatedAt?: InputMaybe<OracleDateTimeFilterInput>
}

export enum SeedQuestionPersonalization {
  RainbowCategory_10 = 'RAINBOW_CATEGORY_10',
}

/** Oracle AI: Input for updating an existing seed question */
export type SeedQuestionUpdateInput = {
  /** The ID of the seed question to update */
  id: Scalars['ID']['input']
  /** Language code for the question (e.g., en, es, fr) */
  language?: InputMaybe<Scalars['String']['input']>
  /** The new question text */
  question?: InputMaybe<Scalars['String']['input']>
  /** The new tags array */
  tags?: InputMaybe<Array<Scalars['String']['input']>>
}

/** Oracle AI: Response envelope for seed question update */
export type SeedQuestionUpdateResponse = {
  __typename?: 'SeedQuestionUpdateResponse'
  /** A list of errors that occurred during the mutation */
  errors: Array<Scalars['String']['output']>
  /** The updated seed question, if successful */
  seedQuestion?: Maybe<SeedQuestion>
  /** Indicates whether the mutation was successful */
  success: Scalars['Boolean']['output']
}

/** Server status */
export type ServerStatus = {
  __typename?: 'ServerStatus'
  success: Scalars['Boolean']['output']
}

/** Space role type enum matching BetterMode's SpaceRoleType */
export enum SpaceRoleType {
  /** Admin role with full permissions */
  Admin = 'admin',
  /** Member role with standard permissions */
  Member = 'member',
}

/** Oracle AI: Root subscription operations */
export type Subscription = {
  __typename?: 'Subscription'
  /** Oracle AI (Internal): Send a message to the AI agent and stream the response (internal tools) */
  internalAgentChat: OracleAgentChatSubscriptionPayload
  /** Oracle AI: Send a message to the AI agent and stream the response */
  oracleAgentChat: OracleAgentChatSubscriptionPayload
  /** Oracle AI: Subscribe to real-time health status updates */
  oracleHealth: OracleHealth
  /** Subscribe to server status updates */
  serverStatusAuthentication?: Maybe<ServerStatus>
  /** Subscribe to server status updates */
  serverStatusBrooklyn?: Maybe<ServerStatus>
  /** Subscribe to server status updates */
  serverStatusTestarossa?: Maybe<ServerStatus>
  /** Subscribe to server status updates */
  serverStatusVideoAnalytics?: Maybe<ServerStatus>
  /**
   * Subscribe to text-to-speech audio streaming
   * (this is a test at this time and not for production use)
   */
  textToSpeech?: Maybe<TextToSpeechAudioChunk>
}

/** Oracle AI: Root subscription operations */
export type SubscriptionInternalAgentChatArgs = {
  input: OracleAgentChatInput
}

/** Oracle AI: Root subscription operations */
export type SubscriptionOracleAgentChatArgs = {
  input: OracleAgentChatInput
}

/** Oracle AI: Root subscription operations */
export type SubscriptionOracleHealthArgs = {
  intervalMilliseconds?: Scalars['Int']['input']
}

/** Oracle AI: Root subscription operations */
export type SubscriptionTextToSpeechArgs = {
  encoding?: InputMaybe<TextToSpeechAudioEncoding>
  language?: InputMaybe<Scalars['String']['input']>
  text: Scalars['String']['input']
}

/** Billing Subscription Order Plan Action */
export enum SubscriptionOrderPlanAction {
  Delete = 'DELETE',
  Insert = 'INSERT',
  Update = 'UPDATE',
}

/** Provider Product Type */
export enum SubscriptionOrderType {
  Cancel = 'CANCEL',
  /** PLAN CHANGE */
  Comp = 'COMP',
  Pause = 'PAUSE',
  Signup = 'SIGNUP',
}

/** Billing Subscription price override reason */
export enum SubscriptionPriceOverrideReason {
  /** Legacy FMTV Price */
  CurrencyOverridePricing = 'CurrencyOverridePricing',
  LatinAmericanPricing = 'LatinAmericanPricing',
  LegacyOfferPricing = 'LegacyOfferPricing',
  PromoCodePricing = 'PromoCodePricing',
}

export enum SubscriptionPricingReplacementType {
  /** Future plan */
  FuturePlan = 'futurePlan',
  /** Next plan */
  NextPlan = 'nextPlan',
  /** None */
  None = 'none',
  /** Current plan */
  Plan = 'plan',
}

/** Billing Subscription Status */
export enum SubscriptionStatus {
  Active = 'Active',
  Canceled = 'Canceled',
  Lapsed = 'Lapsed',
  Paused = 'Paused',
  Pending = 'Pending',
  Suspended = 'Suspended',
}

/** Sync Billing Provider Products Response */
export type SyncBillingProviderProductsResponse = {
  __typename?: 'SyncBillingProviderProductsResponse'
  /** The created or updated billingProviderProductPrices */
  billingProviderProductPrices?: Maybe<Array<Maybe<BillingProviderProductPricing>>>
  /** The updated billingProviderProducts */
  billingProviderProducts?: Maybe<Array<Maybe<BillingProviderProduct>>>
  /** The deleted billingProviderProductPrices */
  deletedBillingProviderProductPrices?: Maybe<Array<Maybe<DeletedBillingProviderProductPricing>>>
}

/** TestarossaSubject row */
export type TestarossaSubject = {
  __typename?: 'TestarossaSubject'
  /** The campaign linked to this testarossa subject */
  campaignUuid?: Maybe<Scalars['ID']['output']>
  /** The campaign version */
  campaignVersion?: Maybe<Scalars['Int']['output']>
  /** The date the row was created */
  createdAt?: Maybe<Scalars['DateTime']['output']>
  /** The testarossa subject status */
  status?: Maybe<TestarossaSubjectStatus>
  /** The user linked to this testarossa subject */
  testarossaUser?: Maybe<TestarossaUser>
  /** The date the row was last updated */
  updatedAt?: Maybe<Scalars['DateTime']['output']>
  /** The user linked to this testarossa subject */
  userUuid?: Maybe<Scalars['ID']['output']>
  /** The primary key */
  uuid: Scalars['ID']['output']
  /** State related to a campaign testarossa subject */
  variables?: Maybe<Scalars['JSON']['output']>
  /** The variation linked to this testarossa subject */
  variationUuid?: Maybe<Scalars['ID']['output']>
}

/** A testarossa subject status */
export enum TestarossaSubjectStatus {
  Active = 'active',
  Excluded = 'excluded',
  Inactive = 'inactive',
}

/** Testarossa subjects list response */
export type TestarossaSubjectsListResponse = {
  __typename?: 'TestarossaSubjectsListResponse'
  /** A list of testarossaSubjects */
  testarossaSubjects?: Maybe<Array<Maybe<TestarossaSubject>>>
}

/** The where conditions to filter rows */
export type TestarossaSubjectsListWhereInput = {
  uuid?: InputMaybe<TestarossaSubjectsListWhereUuidInput>
}

/** The where clause for a testarossa subject uuid field */
export type TestarossaSubjectsListWhereUuidInput = {
  /** Is the value equal to the field */
  eq?: InputMaybe<Scalars['ID']['input']>
  /** Are the values in the field */
  in?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>
}

/** Testarossa user row */
export type TestarossaUser = {
  __typename?: 'TestarossaUser'
  /** The testarossaUser access level */
  accessLevel?: Maybe<TestarossaUserAccessLevel>
  /** The date the row was created */
  createdAt?: Maybe<Scalars['DateTime']['output']>
  /** The user uid */
  drupalUserId?: Maybe<Scalars['ID']['output']>
  /** The subjects linked to this testarossaUser */
  testarossaSubjects?: Maybe<Array<Maybe<TestarossaSubject>>>
  /** The date the row was last updated */
  updatedAt?: Maybe<Scalars['DateTime']['output']>
  /** The primary key */
  uuid: Scalars['ID']['output']
}

/** A testarossaUser access level */
export enum TestarossaUserAccessLevel {
  Manage = 'manage',
  None = 'none',
  Read = 'read',
  Write = 'write',
}

/** Testarossa user list response */
export type TestarossaUsersListResponse = {
  __typename?: 'TestarossaUsersListResponse'
  /** A list of testarossaUsers */
  testarossaUsers?: Maybe<Array<Maybe<TestarossaUser>>>
}

/** The where conditions to filter rows */
export type TestarossaUsersListWhereInput = {
  uuid?: InputMaybe<TestarossaUsersListWhereUuidInput>
}

/** The where clause for a testarossaUser uuid field */
export type TestarossaUsersListWhereUuidInput = {
  /** Is the value equal to the field */
  eq?: InputMaybe<Scalars['ID']['input']>
  /** Are the values in the field */
  in?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>
}

/** Text-to-speech audio chunk for streaming */
export type TextToSpeechAudioChunk = {
  __typename?: 'TextToSpeechAudioChunk'
  /** Base64 encoded audio data */
  data: Scalars['String']['output']
  /** Audio encoding type */
  encoding: TextToSpeechAudioEncoding
  /** Error message if an error occurred during processing */
  error?: Maybe<Scalars['String']['output']>
  /** Whether this is the final chunk */
  isFinal: Scalars['Boolean']['output']
  /** Subscription ID for filtering (internal use) */
  subscriptionId: Scalars['String']['output']
}

/**
 * Text-to-speech audio encoding types
 * Constants defined in: lib/services/speech/encodings.js
 */
export enum TextToSpeechAudioEncoding {
  /** Linear PCM 16-bit encoding (AUDIO_ENCODING_LINEAR16) */
  Linear16 = 'LINEAR16',
  /** OGG Opus encoding (AUDIO_ENCODING_OGG_OPUS) */
  OggOpus = 'OGG_OPUS',
}

/** Transactions */
export type Transaction = {
  __typename?: 'Transaction'
  /** The ccLast4 of the transaction */
  ccLast4?: Maybe<Scalars['String']['output']>
  /** When the row was created */
  createdAt?: Maybe<Scalars['DateTime']['output']>
  /** The entitledAt of the transaction */
  entitledAt?: Maybe<Scalars['DateTime']['output']>
  /** The entitlementContentSet of the transaction */
  entitlementContentSet?: Maybe<Scalars['Int']['output']>
  /** The entitlementEnd of the transaction */
  entitlementEnd?: Maybe<Scalars['DateTime']['output']>
  /** The errorCode of the transaction */
  errorCode?: Maybe<Scalars['String']['output']>
  /** The eventUuid of the transaction */
  eventUuid?: Maybe<Scalars['ID']['output']>
  /** The primary identifier for this record */
  id?: Maybe<Scalars['ID']['output']>
  /** The isDone of the transaction */
  isDone?: Maybe<Scalars['Boolean']['output']>
  /** The isEntitled flag of the transaction */
  isEntitled?: Maybe<Scalars['Boolean']['output']>
  /** The isValid flag of the transaction */
  isValid?: Maybe<Scalars['Boolean']['output']>
  /** The lastPolledAt of the transaction */
  lastPolledAt?: Maybe<Scalars['DateTime']['output']>
  /** The processedAt of the transaction */
  processedAt?: Maybe<Scalars['DateTime']['output']>
  /** The providerData response of the transaction */
  providerData?: Maybe<Scalars['JSON']['output']>
  /** The providerGatewayTxnId of the transaction */
  providerGatewayTxnId?: Maybe<Scalars['String']['output']>
  /** The providerInvoiceNumber of the transaction */
  providerInvoiceNumber?: Maybe<Scalars['String']['output']>
  /** The providerName of the transaction */
  providerName?: Maybe<Scalars['String']['output']>
  /** The providerParentTxnId of the transaction */
  providerParentTxnId?: Maybe<Scalars['String']['output']>
  /** The providerPaymentNumber of the transaction */
  providerPaymentNumber?: Maybe<Scalars['String']['output']>
  /** The providerProductCode of the transaction */
  providerProductCode?: Maybe<Scalars['String']['output']>
  /** The providerRecurringPaymentId of the transaction */
  providerRecurringPaymentId?: Maybe<Scalars['String']['output']>
  /** The providerTxnDt of the transaction */
  providerTxnDt?: Maybe<Scalars['DateTime']['output']>
  /** The providerTxnId of the transaction */
  providerTxnId?: Maybe<Scalars['String']['output']>
  /** The providerTxnType of the transaction */
  providerTxnType?: Maybe<Scalars['String']['output']>
  /** The updateStatus of the transaction */
  updateStatus?: Maybe<Scalars['String']['output']>
  /** When the row was last updated */
  updatedAt?: Maybe<Scalars['DateTime']['output']>
  /** The user UID of the transaction */
  userId?: Maybe<Scalars['ID']['output']>
  /** The userInfoUuid of the transaction */
  userInfoUuid?: Maybe<Scalars['ID']['output']>
  /** The validatedAt of the transaction */
  validatedAt?: Maybe<Scalars['DateTime']['output']>
}

export type TransactionCountResponse = {
  __typename?: 'TransactionCountResponse'
  /** The count of rows */
  count: Scalars['Int']['output']
}

/** TransactionCreateInput */
export type TransactionCreateInput = {
  /** The ccLast4 of the transaction */
  ccLast4?: InputMaybe<Scalars['String']['input']>
  /** The entitledAt of the transaction */
  entitledAt?: InputMaybe<Scalars['DateTime']['input']>
  /** The entitlementContentSet of the transaction */
  entitlementContentSet?: InputMaybe<Scalars['Int']['input']>
  /** The entitlementEnd of the transaction */
  entitlementEnd?: InputMaybe<Scalars['DateTime']['input']>
  /** The errorCode of the transaction */
  errorCode?: InputMaybe<Scalars['String']['input']>
  /** The eventUuid of the transaction */
  eventUuid: Scalars['String']['input']
  /** The isDone of the transaction */
  isDone: Scalars['Boolean']['input']
  /** The isEntitled flag of the transaction */
  isEntitled?: InputMaybe<Scalars['Boolean']['input']>
  /** The isValid flag of the transaction */
  isValid?: InputMaybe<Scalars['Boolean']['input']>
  /** The lastPolledAt of the transaction */
  lastPolledAt?: InputMaybe<Scalars['DateTime']['input']>
  /** The processedAt of the transaction */
  processedAt?: InputMaybe<Scalars['DateTime']['input']>
  /** The providerData response of the transaction */
  providerData?: InputMaybe<Scalars['JSON']['input']>
  /** The providerGatewayTxnId of the transaction */
  providerGatewayTxnId?: InputMaybe<Scalars['String']['input']>
  /** The providerInvoiceNumber of the transaction */
  providerInvoiceNumber?: InputMaybe<Scalars['String']['input']>
  /** The providerName of the transaction */
  providerName: Scalars['String']['input']
  /** The providerParentTxnId of the transaction */
  providerParentTxnId: Scalars['String']['input']
  /** The providerPaymentNumber of the transaction */
  providerPaymentNumber?: InputMaybe<Scalars['String']['input']>
  /** The providerProductCode of the transaction */
  providerProductCode: Scalars['String']['input']
  /** The providerRecurringPaymentId of the transaction */
  providerRecurringPaymentId?: InputMaybe<Scalars['String']['input']>
  /** The providerTxnDt of the transaction */
  providerTxnDt: Scalars['DateTime']['input']
  /** The providerTxnId of the transaction */
  providerTxnId: Scalars['String']['input']
  /** The providerTxnType of the transaction */
  providerTxnType: Scalars['String']['input']
  /** The updateStatus of the transaction */
  updateStatus?: InputMaybe<Scalars['Int']['input']>
  /** The user UID of the transaction */
  userId?: InputMaybe<Scalars['ID']['input']>
  /** The userInfoUuid of the transaction */
  userInfoUuid?: InputMaybe<Scalars['ID']['input']>
  /** The validatedAt of the transaction */
  validatedAt?: InputMaybe<Scalars['DateTime']['input']>
}

/** Transaction policy list response */
export type TransactionListResponse = {
  __typename?: 'TransactionListResponse'
  /** Total number of rows found (uses a slower count query for list) */
  count?: Maybe<Scalars['Int']['output']>
  /** The limit applied to the rows */
  limit?: Maybe<Scalars['Int']['output']>
  /** The offset applied to the rows */
  offset?: Maybe<Scalars['Int']['output']>
  /** A list of user accounts */
  transactions?: Maybe<Array<Maybe<Transaction>>>
}

/** Transaction list where Date input type */
export type TransactionListWhereDateInput = {
  /** Is the value greater than the field */
  gt?: InputMaybe<Scalars['Date']['input']>
  /** Is the value greater than or equal to the field */
  gte?: InputMaybe<Scalars['Date']['input']>
  /** Is the value less than the field */
  lt?: InputMaybe<Scalars['Date']['input']>
  /** Is the value less than or equal to the field */
  lte?: InputMaybe<Scalars['Date']['input']>
}

/** Transaction ID or UUID type where input type */
export type TransactionListWhereIdInput = {
  /** Is the value equal to the field */
  eq?: InputMaybe<Scalars['ID']['input']>
  /** Is the value greater than to the field */
  gt?: InputMaybe<Scalars['ID']['input']>
  /** Is the value greater than or equal to the field */
  gte?: InputMaybe<Scalars['ID']['input']>
  /** Are the values in the field */
  in?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>
}

/** Transaction where conditions to filter rows */
export type TransactionListWhereInput = {
  /** The eventUuid field where clause */
  eventUuid?: InputMaybe<TransactionListWhereIdInput>
  /** The id field where clause */
  id?: InputMaybe<TransactionListWhereIdInput>
  /** The providerName field where clause */
  providerName?: InputMaybe<TransactionListWhereStringInput>
  /** The providerTxnDt field where clause */
  providerTxnDt?: InputMaybe<TransactionListWhereDateInput>
  /** The providerTxnId field where clause */
  providerTxnId?: InputMaybe<TransactionListWhereStringInput>
}

/** Transaction where input type string */
export type TransactionListWhereStringInput = {
  /** Is the value equal to the field */
  eq?: InputMaybe<Scalars['String']['input']>
  /** Are the values in the field */
  in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
}

/** TransactionUpdateInput */
export type TransactionUpdateInput = {
  /** The ccLast4 of the transaction */
  ccLast4?: InputMaybe<Scalars['String']['input']>
  /** The entitledAt of the transaction */
  entitledAt?: InputMaybe<Scalars['DateTime']['input']>
  /** The entitlementContentSet of the transaction */
  entitlementContentSet?: InputMaybe<Scalars['Int']['input']>
  /** The entitlementEnd of the transaction */
  entitlementEnd?: InputMaybe<Scalars['DateTime']['input']>
  /** The errorCode of the transaction */
  errorCode?: InputMaybe<Scalars['String']['input']>
  /** The eventUuid of the transaction */
  eventUuid?: InputMaybe<Scalars['String']['input']>
  /** The primary identifier for this record */
  id: Scalars['ID']['input']
  /** The isDone of the transaction */
  isDone?: InputMaybe<Scalars['Boolean']['input']>
  /** The isEntitled flag of the transaction */
  isEntitled?: InputMaybe<Scalars['Boolean']['input']>
  /** The isValid flag of the transaction */
  isValid?: InputMaybe<Scalars['Boolean']['input']>
  /** The lastPolledAt of the transaction */
  lastPolledAt?: InputMaybe<Scalars['DateTime']['input']>
  /** The processedAt of the transaction */
  processedAt?: InputMaybe<Scalars['DateTime']['input']>
  /** The providerData response of the transaction */
  providerData?: InputMaybe<Scalars['JSON']['input']>
  /** The providerGatewayTxnId of the transaction */
  providerGatewayTxnId?: InputMaybe<Scalars['String']['input']>
  /** The providerInvoiceNumber of the transaction */
  providerInvoiceNumber?: InputMaybe<Scalars['String']['input']>
  /** The providerName of the transaction */
  providerName?: InputMaybe<Scalars['String']['input']>
  /** The providerParentTxnId of the transaction */
  providerParentTxnId?: InputMaybe<Scalars['String']['input']>
  /** The providerPaymentNumber of the transaction */
  providerPaymentNumber?: InputMaybe<Scalars['String']['input']>
  /** The providerProductCode of the transaction */
  providerProductCode?: InputMaybe<Scalars['String']['input']>
  /** The providerRecurringPaymentId of the transaction */
  providerRecurringPaymentId?: InputMaybe<Scalars['String']['input']>
  /** The providerTxnDt of the transaction */
  providerTxnDt?: InputMaybe<Scalars['DateTime']['input']>
  /** The providerTxnId of the transaction */
  providerTxnId?: InputMaybe<Scalars['String']['input']>
  /** The providerTxnType of the transaction */
  providerTxnType?: InputMaybe<Scalars['String']['input']>
  /** The updateStatus of the transaction */
  updateStatus?: InputMaybe<Scalars['Int']['input']>
  /** The user UID of the transaction */
  userId?: InputMaybe<Scalars['ID']['input']>
  /** The userInfoUuid of the transaction */
  userInfoUuid?: InputMaybe<Scalars['ID']['input']>
  /** The validatedAt of the transaction */
  validatedAt?: InputMaybe<Scalars['DateTime']['input']>
}

/** Translation formality options */
export enum TranslationFormality {
  /** Default formality */
  Default = 'default',
  /** Less formal */
  Less = 'less',
  /** More formal */
  More = 'more',
  /** Prefer less formal but not enforced strictly */
  PreferLess = 'prefer_less',
  /** Prefer more formal but not enforced strictly */
  PreferMore = 'prefer_more',
}

/** Translation model options */
export enum TranslationModel {
  /** Optimized for fastest response time */
  LatencyOptimized = 'latency_optimized',
  /** Prefer quality model but not enforced strictly */
  PreferQualityOptimized = 'prefer_quality_optimized',
  /** Optimized for quality */
  QualityOptimized = 'quality_optimized',
}

export enum User_Info_Status {
  /** The user is allowed accss */
  Active = 'active',
  /** The user is denied access */
  Blocked = 'blocked',
}

/** Update input for Billing Plan Grid */
export type UpdateBillingPlanGridInput = {
  /** The billing plan grid billing product id in */
  billingProductIdIn?: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>
  /** The billing plan grid billing product id not in */
  billingProductIdNotIn?: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>
  /** The billing plan grid billing provider product id in */
  billingProviderProductIdIn?: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>
  /** The billing plan grid billing provider product id not in */
  billingProviderProductIdNotIn?: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>
  /** The billing plan grid country in */
  countryIn?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  /** The billing plan grid country not in */
  countryNotIn?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  /** The billing plan grid currency in */
  currencyIn?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  /** The billing plan grid currency not in */
  currencyNotIn?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  /** Whether this plan grid is the default for the given page */
  defaultPageGrid?: InputMaybe<Scalars['Boolean']['input']>
  /** The billing plan grid device type in */
  deviceTypeIn?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  /** The billing plan grid device type not in */
  deviceTypeNotIn?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  /** Whether the billing plan grid is enabled */
  enabled?: InputMaybe<Scalars['Boolean']['input']>
  /** The billing plan grid end date */
  endDate?: InputMaybe<Scalars['DateTime']['input']>
  /** The best value plan in the plan grid for existing members */
  existingMemberBestValueBillingProviderProductId?: InputMaybe<Scalars['Int']['input']>
  /** The first plan in the plan grid for existing members */
  existingMemberBillingProviderProductId1?: InputMaybe<Scalars['Int']['input']>
  /** The second plan in the plan grid for existing members */
  existingMemberBillingProviderProductId2?: InputMaybe<Scalars['Int']['input']>
  /** The third plan in the plan grid for existing members */
  existingMemberBillingProviderProductId3?: InputMaybe<Scalars['Int']['input']>
  /** The fourth plan in the plan grid for existing members */
  existingMemberBillingProviderProductId4?: InputMaybe<Scalars['Int']['input']>
  /** The billing plan grid id */
  id: Scalars['ID']['input']
  /** The billing plan grid language in */
  languageIn?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  /** The billing plan grid language not in */
  languageNotIn?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  /** The best value plan in the plan grid for new members */
  newMemberBestValueBillingProviderProductId?: InputMaybe<Scalars['Int']['input']>
  /** The first plan in the plan grid for new members */
  newMemberBillingProviderProductId1?: InputMaybe<Scalars['Int']['input']>
  /** The second plan in the plan grid for new members */
  newMemberBillingProviderProductId2?: InputMaybe<Scalars['Int']['input']>
  /** The third plan in the plan grid for new members */
  newMemberBillingProviderProductId3?: InputMaybe<Scalars['Int']['input']>
  /** The fourth plan in the plan grid for new members */
  newMemberBillingProviderProductId4?: InputMaybe<Scalars['Int']['input']>
  /** The billing plan grid page */
  page?: InputMaybe<Scalars['String']['input']>
  /** The billing plan grid priority */
  priority?: InputMaybe<Scalars['Int']['input']>
  /** The billing plan grid start date */
  startDate?: InputMaybe<Scalars['DateTime']['input']>
  /** The billing plan grid variant name */
  variantName?: InputMaybe<Scalars['String']['input']>
}

/** User accounts */
export type UserAccount = {
  __typename?: 'UserAccount'
  /** The account owner uid */
  accountOwnerUid?: Maybe<Scalars['ID']['output']>
  /** The account owner uuid */
  accountOwnerUuid?: Maybe<Scalars['ID']['output']>
  /** The current authentication group id all ids less than this value are invalid */
  authenticationGroupId?: Maybe<Scalars['Int']['output']>
  /** When the row was created */
  createdAt?: Maybe<Scalars['DateTime']['output']>
  /** The primary identifier for this record */
  id?: Maybe<Scalars['ID']['output']>
  /** When the row was last updated */
  updatedAt?: Maybe<Scalars['DateTime']['output']>
  /** User info associated with this account as the account owner */
  userInfoByAccountOwner?: Maybe<UserInfo>
}

/** User account policy list response */
export type UserAccountListResponse = {
  __typename?: 'UserAccountListResponse'
  /** Total number of rows found (uses a slower count query for list) */
  count?: Maybe<Scalars['Int']['output']>
  /** The limit applied to the rows */
  limit?: Maybe<Scalars['Int']['output']>
  /** The offset applied to the rows */
  offset?: Maybe<Scalars['Int']['output']>
  /** A list of user accounts */
  userAccounts?: Maybe<Array<Maybe<UserAccount>>>
}

/** User account id type where input type */
export type UserAccountListWhereIdInput = {
  /** Is the value equal to the field */
  eq?: InputMaybe<Scalars['ID']['input']>
  /** Is the value greater than to the field */
  gt?: InputMaybe<Scalars['ID']['input']>
  /** Is the value greater than or equal to the field */
  gte?: InputMaybe<Scalars['ID']['input']>
  /** Are the values in the field */
  in?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>
}

/** User account policy where conditions to filter rows */
export type UserAccountListWhereInput = {
  /** The id field where clause */
  id?: InputMaybe<UserAccountListWhereIdInput>
}

/** User Audit Log */
export type UserAuditLog = {
  __typename?: 'UserAuditLog'
  /** The audit category of user audit */
  auditCategory?: Maybe<AuditCategoryType>
  /** The billing provider Id of user audit */
  billingProviderId?: Maybe<Scalars['ID']['output']>
  /** When the row was created */
  createdAt?: Maybe<Scalars['DateTime']['output']>
  /** When effective date of user audit */
  effectiveDate?: Maybe<Scalars['DateTime']['output']>
  /** The external account Id of user audit */
  externalAccountId?: Maybe<Scalars['String']['output']>
  /** The audit field name of user audit */
  fieldName?: Maybe<AuditFieldName>
  /** The id of the user audit */
  id?: Maybe<Scalars['ID']['output']>
  /** New data value of user audit */
  newValue?: Maybe<Scalars['String']['output']>
  /** The performed by user uuid of user audit */
  performedByUuid?: Maybe<Scalars['ID']['output']>
  /** Previous data value of user audit */
  previousValue?: Maybe<Scalars['String']['output']>
  /** When the row was last updated */
  updatedAt?: Maybe<Scalars['DateTime']['output']>
  /** The user info uuid of user audit */
  userInfoUuid?: Maybe<Scalars['ID']['output']>
}

/** Create input for User Audit Log */
export type UserAuditLogCreateInput = {
  /** The auditCategory of the user audit log */
  auditCategory: AuditCategoryType
  /** The billingProviderId of the user audit log */
  billingProviderId: Scalars['ID']['input']
  /** The effectiveDate of the user audit log */
  effectiveDate: Scalars['DateTime']['input']
  /** The externalAccountId of the user audit log */
  externalAccountId?: InputMaybe<Scalars['String']['input']>
  /** The fieldName of the user audit log */
  fieldName: AuditFieldName
  /** The newValue of the user audit log */
  newValue?: InputMaybe<Scalars['String']['input']>
  /** The performedByUuid of the user audit log */
  performedByUuid: Scalars['ID']['input']
  /** The previousValue of the user audit log */
  previousValue?: InputMaybe<Scalars['String']['input']>
  /** The userInfoUuid of the user audit log */
  userInfoUuid: Scalars['ID']['input']
}

/** User Audit Log list response */
export type UserAuditLogListResponse = {
  __typename?: 'UserAuditLogListResponse'
  userAuditLogs?: Maybe<Array<Maybe<UserAuditLog>>>
}

/** User Audit Log boolean where input type */
export type UserAuditLogListWhereBooleanInput = {
  /** Is the value equal to the field */
  eq?: InputMaybe<Scalars['Boolean']['input']>
}

/** User Audit Log list where Date input type */
export type UserAuditLogListWhereDateInput = {
  /** Is the value greater than the field */
  gt?: InputMaybe<Scalars['Date']['input']>
  /** Is the value greater than or equal to the field */
  gte?: InputMaybe<Scalars['Date']['input']>
  /** Is the value less than the field */
  lt?: InputMaybe<Scalars['Date']['input']>
  /** Is the value less than or equal to the field */
  lte?: InputMaybe<Scalars['Date']['input']>
}

/** User Audit Log where type input field Name */
export type UserAuditLogListWhereFieldNameInput = {
  /** Is the value equal to the field */
  eq?: InputMaybe<AuditFieldName>
  /** Are the values in the field */
  in?: InputMaybe<Array<InputMaybe<AuditFieldName>>>
}

/** User Audit Log list id where input type */
export type UserAuditLogListWhereIdInput = {
  /** Is the value equal to the field */
  eq?: InputMaybe<Scalars['ID']['input']>
  /** Are the values in the field */
  in?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>
}

/** User Audit Log list where input type */
export type UserAuditLogListWhereInput = {
  /** The auditCategory field where clause */
  auditCategory?: InputMaybe<UserAuditLogListWhereTypeInput>
  /** The userAuditLog billingProviderId field where clause */
  billingProviderId?: InputMaybe<UserAuditLogListWhereIdInput>
  /** The userAuditLog effectiveDate field where clause */
  effectiveDate?: InputMaybe<UserAuditLogListWhereDateInput>
  /** The fieldName field where clause */
  fieldName?: InputMaybe<UserAuditLogListWhereFieldNameInput>
  /** The userAuditLog id field where clause */
  id?: InputMaybe<UserAuditLogListWhereIdInput>
  /** The userAuditLog performedByUuid field where clause */
  performedByUuid?: InputMaybe<UserAuditLogListWhereIdInput>
  /** The userAuditLog userInfoUuid field where clause */
  userInfoUuid?: InputMaybe<UserAuditLogListWhereIdInput>
}

/** User Audit Log string where input type */
export type UserAuditLogListWhereStringInput = {
  /** Is the value equal to the field */
  eq?: InputMaybe<Scalars['String']['input']>
  /** Are the values in the field */
  in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
}

/** User Audit Log where type input type */
export type UserAuditLogListWhereTypeInput = {
  /** Is the value equal to the field */
  eq?: InputMaybe<AuditCategoryType>
  /** Are the values in the field */
  in?: InputMaybe<Array<InputMaybe<AuditCategoryType>>>
}

/** Update input for User Audit Log */
export type UserAuditLogUpdateInput = {
  /** The auditCategory of the user audit log */
  auditCategory?: InputMaybe<AuditCategoryType>
  /** The billingProviderId of the user audit log */
  billingProviderId?: InputMaybe<Scalars['ID']['input']>
  /** The effectiveDate of the user audit log */
  effectiveDate?: InputMaybe<Scalars['DateTime']['input']>
  /** The externalAccountId of the user audit log */
  externalAccountId?: InputMaybe<Scalars['String']['input']>
  /** The fieldName of the user audit log */
  fieldName?: InputMaybe<AuditFieldName>
  /** The identifier for the user audit log */
  id: Scalars['ID']['input']
  /** The newValue of the user audit log */
  newValue?: InputMaybe<Scalars['String']['input']>
  /** The performedByUuid of the user audit log */
  performedByUuid?: InputMaybe<Scalars['ID']['input']>
  /** The previousValue of the user audit log */
  previousValue?: InputMaybe<Scalars['String']['input']>
  /** The userInfoUuid of the user audit log */
  userInfoUuid?: InputMaybe<Scalars['ID']['input']>
}

/** User specific billing plan grid */
export type UserBillingPlanGrid = {
  __typename?: 'UserBillingPlanGrid'
  /** The matching user specific billing plan grid */
  billingPlanGrid?: Maybe<BillingPlanGrid>
  /** The device type requested */
  deviceType?: Maybe<PlanGridDeviceType>
}

/** User specific billing plan grid list response */
export type UserBillingPlanGridListResponse = {
  __typename?: 'UserBillingPlanGridListResponse'
  userBillingPlanGrids?: Maybe<Array<Maybe<UserBillingPlanGrid>>>
}

/** User Billing Plan Grid list where input type */
export type UserBillingPlanGridListWhereInput = {
  /** The filter for the billing plan grid device type */
  deviceType: BillingPlanGridListWhereDeviceTypeInput
  /** The filter for the billing plan grid language */
  language: ProviderProductLanguage
  /** The filter for the billing plan grid page */
  page: Scalars['String']['input']
}

/** User Ecommerce Sku Mapping Bonus Eligibilities list response */
export type UserEcommerceSkuMappingBonusEligibilitiesListResponse = {
  __typename?: 'UserEcommerceSkuMappingBonusEligibilitiesListResponse'
  /** Total number of rows found (uses a slower count query for list) */
  count?: Maybe<Scalars['Int']['output']>
  /** The limit applied to the rows */
  limit?: Maybe<Scalars['Int']['output']>
  /** The offset applied to the rows */
  offset?: Maybe<Scalars['Int']['output']>
  /** A list of ecommerce sku mappings */
  userEcommerceSkuMappingBonusEligibilities?: Maybe<
    Array<Maybe<UserEcommerceSkuMappingBonusEligibility>>
  >
}

/** User Ecommerce Sku Mapping where input type */
export type UserEcommerceSkuMappingBonusEligibilitiesWhereIdInput = {
  /** Is the value equal to the field */
  eq?: InputMaybe<Scalars['ID']['input']>
  /** Are the values in the field */
  in?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>
}

/** User User Ecommerce Sku Mapping Bonus Eligibilities where conditions to filter rows */
export type UserEcommerceSkuMappingBonusEligibilitiesWhereInput = {
  /** The UserEcommerceSkuMappingBonusEligibilities id field where clause */
  id?: InputMaybe<UserEcommerceSkuMappingBonusEligibilitiesWhereIdInput>
}

/** User Ecommerce Sku Mapping Bonus Eligibility */
export type UserEcommerceSkuMappingBonusEligibility = {
  __typename?: 'UserEcommerceSkuMappingBonusEligibility'
  /** The Billing Provider Product Text for the item */
  billingProviderProductTextLocalized?: Maybe<Scalars['String']['output']>
  /** The Billing Provider Product Text Language for the item */
  billingProviderProductTextLocalizedLanguage?: Maybe<Scalars['String']['output']>
  /** The date the row was created */
  createdAt?: Maybe<Scalars['DateTime']['output']>
  /** The campaign id */
  ecommerceSkuMappingBonusEligibilitiesId?: Maybe<Scalars['Int']['output']>
  /** The campaigns */
  ecommerceSkuMappingBonusEligibility?: Maybe<EcommerceSkuMappingBonusEligibility>
  /** The unique id for the given record */
  id?: Maybe<Scalars['ID']['output']>
  /** The date the row was last updated */
  updatedAt?: Maybe<Scalars['DateTime']['output']>
  /** The user uuid for the given record */
  userUuid?: Maybe<Scalars['String']['output']>
}

/**
 * User entitlement represents access rights to a content set for a user or account.
 *
 * Entitlements define what content a user can access and when. They are time-based with start and end dates.
 * An entitlement is considered "active" when the current time is between the start and end dates.
 *
 * Entitlement Types:
 * - User-specific entitlement: userInfoUuid is set, userAccountUuid is null. Applies only to that specific user.
 * - Account-level entitlement: Both userInfoUuid and userAccountUuid are set. Applies to all users in that account.
 *   Account-level entitlements are typically owned by the account owner but accessible by all account members.
 *
 * Entitlements are typically created or updated when billing events are processed (payments, renewals, etc.).
 * The eventId field links back to the billing event that created this entitlement.
 *
 * The reason field describes why the entitlement was created/changed (e.g., "payment", "trial", "gift", etc.).
 * The effectiveChangeDate tracks when the entitlement was last modified.
 *
 * State Information:
 * - Active: current time >= start AND (end is null OR current time <= end)
 * - Expired: current time > end (if end is set)
 * - Future: current time < start
 */
export type UserEntitlement = {
  __typename?: 'UserEntitlement'
  /** Content set for this entitlement. Defines what content this entitlement grants access to. */
  contentSet?: Maybe<ContentSet>
  /**
   * The content set ID that this entitlement grants access to. Content sets define groups of content
   * (videos, courses, etc.) that users can access.
   */
  contentSetId?: Maybe<Scalars['Int']['output']>
  /** The date the row was created */
  createdAt?: Maybe<Scalars['DateTime']['output']>
  /**
   * Ecommerce SKU (Stock Keeping Unit) identifier for the product that granted this entitlement.
   * Used to link entitlements to specific products in ecommerce systems.
   */
  ecommerceSku?: Maybe<Scalars['String']['output']>
  /**
   * An Ecommerce SKU Mapping associated with this entitlement. Links the ecommerce SKU
   * to product information and pricing details.
   */
  ecommerceSkuMapping?: Maybe<EcommerceSkuMapping>
  /**
   * Ecommerce SKU Provider name (e.g., "google", "apple", "paypal"). Identifies which
   * ecommerce system the SKU belongs to.
   */
  ecommerceSkuProvider?: Maybe<Scalars['String']['output']>
  /**
   * The date when the entitlement was last changed. Tracks when modifications were made to
   * this entitlement record.
   */
  effectiveChangeDate?: Maybe<Scalars['DateTime']['output']>
  /**
   * The timestamp for when the entitlement ends (Unix timestamp converted to DateTime).
   * If null, the entitlement has no expiration. The entitlement expires at this time.
   */
  end?: Maybe<Scalars['DateTime']['output']>
  /**
   * Additional event data stored as JSON. Contains provider-specific information about
   * the event that created this entitlement.
   */
  eventData?: Maybe<Scalars['JSON']['output']>
  /**
   * The event ID linking to the billing event that created or updated this entitlement.
   * This connects the entitlement to the payment transaction that granted access.
   */
  eventId?: Maybe<Scalars['ID']['output']>
  /** The primary key (auto-incrementing integer) */
  id?: Maybe<Scalars['ID']['output']>
  /**
   * The reason that caused the entitlement change. Common values: "payment", "trial", "gift",
   * "renewal", "cancellation", etc. Describes the business logic that created this entitlement.
   */
  reason?: Maybe<Scalars['String']['output']>
  /**
   * The timestamp for when the entitlement starts (Unix timestamp converted to DateTime).
   * The entitlement becomes active at this time.
   */
  start?: Maybe<Scalars['DateTime']['output']>
  /** The date the row was last updated */
  updatedAt?: Maybe<Scalars['DateTime']['output']>
  /**
   * User account for this entitlement. Only set if this is an account-level entitlement
   * (userAccountUuid is not null).
   */
  userAccount?: Maybe<UserAccount>
  /**
   * The user account uuid the entitlement applies to. If set, this is an account-level entitlement
   * that applies to all users in that account. If null, this is a user-specific entitlement.
   */
  userAccountUuid?: Maybe<Scalars['ID']['output']>
  /**
   * User info for this entitlement. Always set, identifies the user associated with this entitlement.
   * For account-level entitlements, this is typically the account owner.
   */
  userInfo?: Maybe<UserInfo>
  /**
   * The identifier for the user associated with this record. This is always set and identifies
   * the user who owns or is directly associated with this entitlement.
   */
  userInfoUuid?: Maybe<Scalars['ID']['output']>
}

/** UserEntitlementCreateInput */
export type UserEntitlementCreateInput = {
  /** The content the entitlement is allowed to access */
  contentSetId: Scalars['Int']['input']
  /** The date the row was created */
  createdAt?: InputMaybe<Scalars['DateTime']['input']>
  /** Ecommerce SKU */
  ecommerceSku?: InputMaybe<Scalars['String']['input']>
  /** Ecommerce SKU Provider */
  ecommerceSkuProvider?: InputMaybe<Scalars['String']['input']>
  /** The date when the entitlement was changed */
  effectiveChangeDate?: InputMaybe<Scalars['DateTime']['input']>
  /** The timestamp for the entitlement end */
  end?: InputMaybe<Scalars['DateTime']['input']>
  /** The event data */
  eventData?: InputMaybe<Scalars['JSON']['input']>
  /** The event id */
  eventId?: InputMaybe<Scalars['ID']['input']>
  /** The event that cause the entitlement change */
  reason?: InputMaybe<Scalars['String']['input']>
  /** The timestamp for the entitlement start */
  start: Scalars['DateTime']['input']
  /** The user account uuid the entitlement applies to */
  userAccountUuid?: InputMaybe<Scalars['ID']['input']>
  /** The identifier for the user associated with this record */
  userInfoUuid: Scalars['ID']['input']
}

/** User entitlement data */
export type UserEntitlementEventData = {
  __typename?: 'UserEntitlementEventData'
  /** There are no fields defined on this object it needs to be implmented */
  _empty?: Maybe<Scalars['String']['output']>
}

/** User info policy list response */
export type UserEntitlementListResponse = {
  __typename?: 'UserEntitlementListResponse'
  /** Total number of rows found (uses a slower count query for list) */
  count?: Maybe<Scalars['Int']['output']>
  /** The limit applied to the rows */
  limit?: Maybe<Scalars['Int']['output']>
  /** The offset applied to the rows */
  offset?: Maybe<Scalars['Int']['output']>
  /** A list of userInfo reference */
  userEntitlements?: Maybe<Array<Maybe<UserEntitlement>>>
}

/** User entitlement id where input type */
export type UserEntitlementListWhereIdInput = {
  /** Is the value equal to the field */
  eq?: InputMaybe<Scalars['ID']['input']>
  /** Is the value greater than to the field */
  gt?: InputMaybe<Scalars['ID']['input']>
  /** Is the value greater than or equal to the field */
  gte?: InputMaybe<Scalars['ID']['input']>
  /** Are the values in the field */
  in?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>
  /** Is the value less than the field */
  lt?: InputMaybe<Scalars['ID']['input']>
  /** Is the value less than or equal to the field */
  lte?: InputMaybe<Scalars['ID']['input']>
}

/** User info policy where conditions to filter rows */
export type UserEntitlementListWhereInput = {
  /** The id field where clause */
  id?: InputMaybe<UserEntitlementListWhereIdInput>
  /** The user account uuid field where clause */
  userAccountUuid?: InputMaybe<UserEntitlementListWhereUserAccountUuidInput>
  /** The user info uuid field where clause */
  userInfoUuid?: InputMaybe<UserEntitlementListWhereUserInfoUuidInput>
}

/** User entitlement user account uuid where input type */
export type UserEntitlementListWhereUserAccountUuidInput = {
  /** Is the value equal to the field */
  eq?: InputMaybe<Scalars['ID']['input']>
  /** Are the values in the field */
  in?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>
}

/** User entitlement user info uuid where input type */
export type UserEntitlementListWhereUserInfoUuidInput = {
  /** Is the value equal to the field */
  eq?: InputMaybe<Scalars['ID']['input']>
  /** Are the values in the field */
  in?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>
}

/** UserEntitlementUpdateInput */
export type UserEntitlementUpdateInput = {
  /** The content the entitlement is allowed to access */
  contentSetId?: InputMaybe<Scalars['Int']['input']>
  /** The timestamp for the entitlement end */
  end?: InputMaybe<Scalars['DateTime']['input']>
  /** The identifier for the user entitlement record */
  id: Scalars['ID']['input']
  /** The timestamp for the entitlement start */
  start?: InputMaybe<Scalars['DateTime']['input']>
  /** The identifier for the user associated with this record */
  userInfoUuid?: InputMaybe<Scalars['ID']['input']>
}

/** User history row */
export type UserHistory = {
  __typename?: 'UserHistory'
  /** A uuid representing a unique anonymous user */
  anonymousUuid?: Maybe<Scalars['ID']['output']>
  /** A bit value as int identifying bad data within a record. */
  bad?: Maybe<Scalars['Int']['output']>
  /** The error code, if any, returned by the Brightcove server. */
  bcCode?: Maybe<Scalars['Int']['output']>
  /** The error message, if any, returned by the Brightcove server. */
  bcMsg?: Maybe<Scalars['String']['output']>
  /** The language of text captions if being viewed and not default. */
  capLang?: Maybe<Scalars['String']['output']>
  /** The {users}.uid claimed by the client for these statistics. */
  clientUid?: Maybe<Scalars['String']['output']>
  /** The recommId of the Recombee row */
  createdAt?: Maybe<Scalars['DateTime']['output']>
  /** Sums of various time intervals (in seconds) from event array */
  eventSumsArray?: Maybe<Array<Maybe<Scalars['String']['output']>>>
  /** A non-media {node}.nid that references this media. */
  extraNid?: Maybe<Scalars['ID']['output']>
  /** Array of watched counts (6 seconds per count, 30 seconds per entry) */
  histogramArray?: Maybe<Array<Maybe<Scalars['Int']['output']>>>
  /** in ms) that is used to inc. the view count in each histogram bucket. */
  histogramInterval?: Maybe<Scalars['Int']['output']>
  /** s) that is used to inc. the view count in each histogram bucket. */
  histogramResolution?: Maybe<Scalars['Int']['output']>
  /** Hostname of the user who created the record. */
  hostname?: Maybe<Scalars['String']['output']>
  /** The primary identifier for this history record.UserHistory */
  id?: Maybe<Scalars['ID']['output']>
  /** A bit value as int identifying ignore data within a record. */
  ign?: Maybe<Scalars['Int']['output']>
  /** The error code, if any, returned by the Irdeto license server. */
  irdetoCode?: Maybe<Scalars['Int']['output']>
  /** The error message, if any, returned by the Irdeto license server. */
  irdetoMsg?: Maybe<Scalars['String']['output']>
  /** in ms) of the last event in the event array table. */
  lastEventTimestamp?: Maybe<Scalars['String']['output']>
  /** The most recent time the {node} has been viewed. */
  lastPlayed?: Maybe<Scalars['Int']['output']>
  /** The url of the page the media was played on. */
  location?: Maybe<Scalars['String']['output']>
  /** The media linked to this user history */
  media?: Maybe<Media>
  /** The media {node}.nid for these statistics. */
  mediaId?: Maybe<Scalars['ID']['output']>
  /** The language of the media being played. */
  mediaLang?: Maybe<Scalars['String']['output']>
  /** The Unix timestamp when media first started to play. */
  playStartedAt?: Maybe<Scalars['Int']['output']>
  /** The player type (string) that is used by analytics for this record. */
  playerType?: Maybe<Scalars['String']['output']>
  /** The time code in seconds when this video was last playing. */
  position?: Maybe<Scalars['Int']['output']>
  /** Auto generated field from sequelize */
  recommId?: Maybe<Scalars['String']['output']>
  /** A flag indicating this record has already been reported for play counts. */
  reportedCount?: Maybe<Scalars['Int']['output']>
  /** The language of text subtitles if being viewed and not default. */
  subLang?: Maybe<Scalars['String']['output']>
  /** The player type (string) that was used for this record. */
  type?: Maybe<Scalars['String']['output']>
  /** The {users}.uid for these statistics. */
  uid?: Maybe<Scalars['String']['output']>
  /** Auto generated field from sequelize */
  updatedAt?: Maybe<Scalars['DateTime']['output']>
  /** The HTTP User-Agent string of the request that created the record. */
  userAgent?: Maybe<Scalars['String']['output']>
  /** A list of user history events */
  userHistoryEvents?: Maybe<Array<Maybe<UserHistoryEvent>>>
  /** The user connected this this user history */
  userInfo?: Maybe<UserInfo>
  /** The current user media position for this record */
  userMediaPosition?: Maybe<UserMediaPosition>
  /** The future primary identifier for this history record */
  uuid?: Maybe<Scalars['ID']['output']>
  /** The current record version identifier. */
  ver?: Maybe<Scalars['Int']['output']>
  /** The video analytics media for this record */
  videoAnalyticsMedia?: Maybe<VideoAnalyticsMedia>
  /** The video analytics video for this record */
  videoAnalyticsVideo?: Maybe<VideoAnalyticsVideo>
  /** The region/country where the video was viewed (based on IP address). */
  viewRegion?: Maybe<Scalars['String']['output']>
  /** The elapsed seconds of the video played. */
  watched?: Maybe<Scalars['Int']['output']>
  /** The elapsed seconds the user has watched the video. */
  watchedPeriod?: Maybe<Scalars['Int']['output']>
}

/** User history row */
export type UserHistoryUserHistoryEventsArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>
  offset?: InputMaybe<Scalars['Int']['input']>
}

/** User history event row */
export type UserHistoryEvent = {
  __typename?: 'UserHistoryEvent'
  /** The date the row was created */
  createdAt?: Maybe<Scalars['DateTime']['output']>
  /** The index of the event */
  idx?: Maybe<Scalars['ID']['output']>
  /** Optional value specifying the kind of event. */
  kind?: Maybe<Scalars['String']['output']>
  /** Optional language (used with subtitle and caption events) */
  lang?: Maybe<Scalars['String']['output']>
  /** The name of the event. */
  name?: Maybe<Scalars['String']['output']>
  /** The current resume position at the moment of this event */
  position?: Maybe<Scalars['Int']['output']>
  /** The event moment (in ms) since year 0 */
  timestamp?: Maybe<Scalars['String']['output']>
  /** The date the row was updated */
  updatedAt?: Maybe<Scalars['DateTime']['output']>
  /** The user history linked to this event */
  userHistory?: Maybe<UserHistory>
  /** The foreign key for the user history table */
  userHistoryId?: Maybe<Scalars['ID']['output']>
}

/** User history list response */
export type UserHistoryEventsListResponse = {
  __typename?: 'UserHistoryEventsListResponse'
  /** Total number of rows of content found (uses a slower count query for list) */
  count?: Maybe<Scalars['Int']['output']>
  /** The limit applied to the rows */
  limit?: Maybe<Scalars['Int']['output']>
  /** The offset applied to the rows */
  offset?: Maybe<Scalars['Int']['output']>
  /** A list of user history events */
  userHistoryEvents?: Maybe<Array<Maybe<UserHistoryEvent>>>
}

/** User history list where clause for idx */
export type UserHistoryEventsListWhereIdxInput = {
  /** Is the value equal to the field */
  eq?: InputMaybe<Scalars['ID']['input']>
  /** Is the value greater than to the field */
  gt?: InputMaybe<Scalars['ID']['input']>
  /** Is the value greater than or equal to the field */
  gte?: InputMaybe<Scalars['ID']['input']>
  /** Are the values in the field */
  in?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>
  /** Is the value before the field */
  lt?: InputMaybe<Scalars['ID']['input']>
  /** Is the value before or equal to the field */
  lte?: InputMaybe<Scalars['ID']['input']>
}

/** User history list where clause */
export type UserHistoryEventsListWhereInput = {
  /** Filter by the idx field */
  idx?: InputMaybe<UserHistoryEventsListWhereIdxInput>
  /** Filter by the id field */
  userHistoryId?: InputMaybe<UserHistoryEventsListWhereUserHistoryIdInput>
}

/** User history list where clause for user history id */
export type UserHistoryEventsListWhereUserHistoryIdInput = {
  /** Is the value equal to the field */
  eq?: InputMaybe<Scalars['ID']['input']>
  /** Is the value greater than to the field */
  gt?: InputMaybe<Scalars['ID']['input']>
  /** Is the value greater than or equal to the field */
  gte?: InputMaybe<Scalars['ID']['input']>
  /** Are the values in the field */
  in?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>
  /** Is the value before the field */
  lt?: InputMaybe<Scalars['ID']['input']>
  /** Is the value before or equal to the field */
  lte?: InputMaybe<Scalars['ID']['input']>
}

/** User history input for array filtering */
export type UserHistoryFilterInput = {
  /** The id of the user history record */
  id?: InputMaybe<Scalars['ID']['input']>
  /** The uid of the user history record */
  uid?: InputMaybe<Scalars['ID']['input']>
  /** The uuid of the user history record */
  uuid?: InputMaybe<Scalars['ID']['input']>
}

/** User history list response */
export type UserHistoryListResponse = {
  __typename?: 'UserHistoryListResponse'
  /** Total number of rows of content found (uses a slower count query for list) */
  count?: Maybe<Scalars['Int']['output']>
  /** The limit applied to the rows */
  limit?: Maybe<Scalars['Int']['output']>
  /** The offset applied to the rows */
  offset?: Maybe<Scalars['Int']['output']>
  /** A list of user history */
  userHistory?: Maybe<Array<Maybe<UserHistory>>>
}

/** User history list where clause for id */
export type UserHistoryListWhereIdInput = {
  /** Is the value equal to the field */
  eq?: InputMaybe<Scalars['ID']['input']>
  /** Is the value greater than the field */
  gt?: InputMaybe<Scalars['ID']['input']>
  /** Is the value greater than or equal to the field */
  gte?: InputMaybe<Scalars['ID']['input']>
  /** Are the values in the field */
  in?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>
  /** Is the value less than the field */
  lt?: InputMaybe<Scalars['ID']['input']>
  /** Is the value less than or equal to the field */
  lte?: InputMaybe<Scalars['ID']['input']>
}

/** User history list where clause */
export type UserHistoryListWhereInput = {
  /** Filter by the id field */
  id?: InputMaybe<UserHistoryListWhereIdInput>
  /** Filter by the media id field */
  mediaId?: InputMaybe<UserHistoryListWhereMediaIdInput>
  /** Filter by the user uid field */
  uid?: InputMaybe<UserHistoryListWhereUidInput>
  /** Filter by the updated at field */
  updatedAt?: InputMaybe<UserHistoryListWhereUpdatedAtInput>
  /** Filter by the uuid field */
  uuid?: InputMaybe<UserHistoryListWhereUuidInput>
}

/** User history list where clause for media id */
export type UserHistoryListWhereMediaIdInput = {
  /** Is the value equal to the field */
  eq?: InputMaybe<Scalars['ID']['input']>
  /** Is the value greater than the field */
  gt?: InputMaybe<Scalars['ID']['input']>
  /** Is the value greater than or equal to the field */
  gte?: InputMaybe<Scalars['ID']['input']>
  /** Are the values in the field */
  in?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>
}

/** User history list where clause for user uid */
export type UserHistoryListWhereUidInput = {
  /** Is the value equal to the field */
  eq?: InputMaybe<Scalars['ID']['input']>
  /** Is the value greater than the field */
  gt?: InputMaybe<Scalars['ID']['input']>
  /** Is the value greater than or equal to the field */
  gte?: InputMaybe<Scalars['ID']['input']>
  /** Are the values in the field */
  in?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>
}

/** User history list where clause for updated at */
export type UserHistoryListWhereUpdatedAtInput = {
  /** Is the value equal to the date */
  eq?: InputMaybe<Scalars['DateTime']['input']>
  /** Is the value greater than the date */
  gt?: InputMaybe<Scalars['DateTime']['input']>
  /** Is the value greater than or equal to the date */
  gte?: InputMaybe<Scalars['DateTime']['input']>
  /** Are the values in the date range */
  in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>
  /** Is the value before the date */
  lt?: InputMaybe<Scalars['DateTime']['input']>
  /** Is the value before or equal to the date */
  lte?: InputMaybe<Scalars['DateTime']['input']>
}

/** User history list where clause for uuid */
export type UserHistoryListWhereUuidInput = {
  /** Is the value equal to the field */
  eq?: InputMaybe<Scalars['ID']['input']>
  /** Are the values in the field */
  in?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>
}

/** User information */
export type UserInfo = {
  __typename?: 'UserInfo'
  /** Where the user was acquired from */
  acquisitionSource?: Maybe<Scalars['String']['output']>
  /**
   * Current authentication group_id. Authentication groups are used for security and session management.
   * All authentication tokens with a group_id less than this value are invalid. Used to invalidate
   * all sessions when security events occur (password change, account compromise, etc.).
   */
  authenticationGroupId?: Maybe<Scalars['Int']['output']>
  /** External ID for referencing user billing information */
  billingAccountId?: Maybe<Scalars['String']['output']>
  /** Additional external Number for referencing user billing information */
  billingAccountNumber?: Maybe<Scalars['String']['output']>
  /**
   * User billing events associated to this user. Billing events are payment events sent from payment providers
   * (Google Play, Apple App Store, PayPal, Amazon, Adyen, Zuora, etc.) when transactions occur.
   *
   * These raw events represent the complete payment history and are used to:
   * - Create and update user entitlements (access rights)
   * - Track payment history and subscription lifecycle
   * - Calculate financial metrics (see billingEventsOverview)
   * - Determine current payment state and subscription status
   *
   * Understanding Payment State:
   * To determine if a user has active payments, examine the billingEvents:
   * 1. Filter events by paymentStatus="completed" (successful payments only)
   * 2. Check paidThroughDate: if in the future, user has paid access
   * 3. Look for recent "payment" or "renewal" events (not cancelled/refunded)
   * 4. Check endDate/expiresDate to see if subscription is still active
   * 5. Review errorCode for any payment failures that may affect access
   *
   * Payment State Indicators:
   * - Active Payment: Recent event with paymentStatus="completed" AND paidThroughDate in future
   * - Payment Issue: paymentStatus="failed" or "pending" OR errorCode is set
   * - Cancelled: Recent "cancellation" event (but may still have access until paidThroughDate)
   * - Refunded: Recent "refund" event (entitlements may be revoked)
   * - Trial: isTrialPeriod=true (may convert to paid subscription)
   *
   * Events are linked to this user via the uid field. Query with where filters to analyze
   * specific payment providers, transaction types, or time periods.
   */
  billingEvents?: Maybe<Array<Maybe<BillingEvent>>>
  /**
   * The overview of all billing events for this user, providing aggregated financial metrics.
   * Includes profit calculations (gross, net, tax), loss totals, and currency information.
   * Useful for understanding the user's overall payment history and financial status.
   */
  billingEventsOverview?: Maybe<BillingEventsOverview>
  /** A biographical description of the user */
  bio?: Maybe<Scalars['String']['output']>
  /** Users birthday */
  birthday?: Maybe<Scalars['String']['output']>
  /**
   * The datetime of when the user is locked out until. If set and in the future, the user
   * is temporarily blocked. If null or in the past, the user is not blocked (unless status is 'blocked').
   * Used for temporary account locks after failed login attempts.
   */
  blockedUntil?: Maybe<Scalars['String']['output']>
  /**
   * The number of consecutive failed login attempts. Used for security purposes to detect
   * potential brute force attacks. Typically resets after successful login or after blockedUntil expires.
   */
  consecutiveFailedLoginAttempts?: Maybe<Scalars['Int']['output']>
  /** Get course progress for this user */
  courseProgress?: Maybe<UserStateProgressCourseListResponse>
  /** When the row was created */
  createdAt?: Maybe<Scalars['DateTime']['output']>
  /** Source service from which user was created */
  creationSource?: Maybe<Scalars['String']['output']>
  /** The user email */
  email?: Maybe<Scalars['String']['output']>
  /** Indicates email registered in both Gaia and an external system */
  emailRegisteredExternally?: Maybe<Scalars['Boolean']['output']>
  /** First name of the user */
  firstName?: Maybe<Scalars['String']['output']>
  /** External ID for referencing user billing information for FMTV PayPal recurring */
  fmtvPayPalRecurringId?: Maybe<Scalars['String']['output']>
  /** External ID for referencing FMTV user information */
  fmtvUserId?: Maybe<Scalars['Int']['output']>
  /** Full name of the user */
  fullName?: Maybe<Scalars['String']['output']>
  /** gcsi uuid for this user */
  gcsiUserUuid?: Maybe<Scalars['String']['output']>
  /** A list of user languages in priority order i.e. index 0 is their primary language */
  language?: Maybe<Array<Maybe<Scalars['String']['output']>>>
  /** Last name of the user */
  lastName?: Maybe<Scalars['String']['output']>
  /** The comma-separated city and state where the user is located */
  location?: Maybe<Scalars['String']['output']>
  /** Optional member support notes about the user */
  memberSupportNotes?: Maybe<Scalars['String']['output']>
  /** External ID for referencing user billing information for MYO PayPal recurring */
  myoPayPalRecurringId?: Maybe<Scalars['String']['output']>
  /** User setting for app tracking transparency and 3rd party data sharing */
  optOutOfDataSharing?: Maybe<Scalars['Boolean']['output']>
  /** A playlist associated with this user */
  playlist?: Maybe<Playlist>
  /** UUID for referencing user profile image */
  profilePictureUuid?: Maybe<Scalars['ID']['output']>
  /** Personalized seed questions based on the user's rainbow categories */
  seedQuestions: Array<SeedQuestion>
  /**
   * The status of the user. 'active' means the user can access the system.
   * 'blocked' means the user is denied access, potentially until blockedUntil date.
   */
  status?: Maybe<User_Info_Status>
  /** The user id */
  uid?: Maybe<Scalars['ID']['output']>
  /** When the row was last updated */
  updatedAt?: Maybe<Scalars['DateTime']['output']>
  /**
   * User account associated with this user. If this user is a profile, this is the account they belong to.
   * If this user is an account owner, this is the account they own. If null, user is standalone.
   */
  userAccount?: Maybe<UserAccount>
  /** UUID for referencing the UserAccount this user belongs to. If null, user is standalone or is an account owner */
  userAccountId?: Maybe<Scalars['ID']['output']>
  /**
   * User entitlements linked to this user. Entitlements represent access rights to content sets.
   *
   * Entitlements can be:
   * - User-specific: Only apply to this specific user (userAccountUuid is null)
   * - Account-level: Apply to all users in the account (userAccountUuid is set)
   *
   * When userAccount=true, returns entitlements from the account owner (for profiles to access owner's entitlements).
   * When active=true, filters to entitlements where current time is between start and end dates.
   *
   * Entitlements are typically created from billing events when payments are processed.
   */
  userEntitlements?: Maybe<Array<Maybe<UserEntitlement>>>
  /**
   * User entitlements which are currently active, filtered by user account. This is the recommended field
   * for applications and third parties that need to check current entitlement status.
   *
   * Returns active entitlements from the account owner if this user belongs to an account, otherwise
   * returns active entitlements for this user directly.
   */
  userEntitlementsActiveByUserAccount?: Maybe<Array<Maybe<UserEntitlement>>>
  /** The user history records for this user */
  userHistory: Array<UserHistory>
  /** The user media positions for this user e.g. the resume position and statistics for use video playback */
  userMediaPositions: Array<UserMediaPosition>
  /** The user media positions for this user e.g. the resume position and statistics for use video playback */
  userMetaTags: Array<UserMetaTag>
  /** The user metadata entries for this user */
  userMetadata: Array<UserMetadata>
  /** The user roles associated with this user */
  userRoles?: Maybe<Array<Maybe<UserRole>>>
  /**
   * Days the user has been entitled (has had active access). For account owners, calculated from their entitlements.
   * For profiles, calculated from profile creation date. For frozen users, extracted from email pattern.
   */
  userTenureDays?: Maybe<Scalars['Int']['output']>
  /** The unique username for the user */
  username?: Maybe<Scalars['String']['output']>
  /** The user uuid */
  uuid?: Maybe<Scalars['ID']['output']>
  /** The user media positions for this user e.g. the resume position and statistics for use video playback */
  votes: Array<Vote>
  /** External ID for referencing Yoga International user information */
  yogaInternationalUserId?: Maybe<Scalars['String']['output']>
}

/** User information */
export type UserInfoBillingEventsArgs = {
  where?: InputMaybe<BillingEventListWhereInput>
}

/** User information */
export type UserInfoCourseProgressArgs = {
  courseTitleGroupIds?: InputMaybe<Array<Scalars['String']['input']>>
  limit?: InputMaybe<Scalars['Int']['input']>
  offset?: InputMaybe<Scalars['Int']['input']>
  order?: InputMaybe<Array<InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>>>
  state?: InputMaybe<UserStateCourse>
}

/** User information */
export type UserInfoPlaylistArgs = {
  playlistType?: InputMaybe<Scalars['String']['input']>
}

/** User information */
export type UserInfoSeedQuestionsArgs = {
  language?: InputMaybe<Scalars['String']['input']>
  limit?: InputMaybe<Scalars['Int']['input']>
}

/** User information */
export type UserInfoUserEntitlementsArgs = {
  active?: InputMaybe<Scalars['Boolean']['input']>
  limit?: InputMaybe<Scalars['Int']['input']>
  offset?: InputMaybe<Scalars['Int']['input']>
  userAccount?: InputMaybe<Scalars['Boolean']['input']>
}

/** User information */
export type UserInfoUserEntitlementsActiveByUserAccountArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>
  offset?: InputMaybe<Scalars['Int']['input']>
}

/** User information */
export type UserInfoUserHistoryArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>
  offset?: InputMaybe<Scalars['Int']['input']>
  order?: InputMaybe<Array<InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>>>
}

/** User information */
export type UserInfoUserMediaPositionsArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>
  offset?: InputMaybe<Scalars['Int']['input']>
  order?: InputMaybe<Array<InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>>>
}

/** User information */
export type UserInfoUserMetaTagsArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>
  offset?: InputMaybe<Scalars['Int']['input']>
}

/** User information */
export type UserInfoUserMetadataArgs = {
  names?: InputMaybe<Array<Scalars['String']['input']>>
  type?: InputMaybe<Scalars['String']['input']>
}

/** User information */
export type UserInfoVotesArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>
  offset?: InputMaybe<Scalars['Int']['input']>
  order?: InputMaybe<Array<InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>>>
}

/** Request information for the current user */
export type UserInfoCurrentAuthenticationResponse = {
  __typename?: 'UserInfoCurrentAuthenticationResponse'
  /** The client attributes assigned during authentication creation */
  clientAttributes?: Maybe<Array<Maybe<Scalars['String']['output']>>>
  /** The country assigned during authentication creation */
  country?: Maybe<Scalars['String']['output']>
  /** The roles assigned during authentication creation */
  roles?: Maybe<Array<Maybe<Scalars['Int']['output']>>>
  /** The subscriptions assigned during authentication creation */
  subscriptions?: Maybe<Array<Maybe<Scalars['Int']['output']>>>
  /** The user uuid */
  uuid?: Maybe<Scalars['ID']['output']>
}

/** Request information for the current user */
export type UserInfoCurrentRequestResponse = {
  __typename?: 'UserInfoCurrentRequestResponse'
  /** The request country */
  country?: Maybe<Scalars['String']['output']>
}

/** User info for the user currently making this request response */
export type UserInfoCurrentResponse = {
  __typename?: 'UserInfoCurrentResponse'
  /** The authentication information */
  authentication?: Maybe<UserInfoCurrentAuthenticationResponse>
  /** The request information for the current user */
  request?: Maybe<UserInfoCurrentRequestResponse>
  /** User info for the user currently making this request */
  userInfo?: Maybe<UserInfo>
}

/** User info policy list response */
export type UserInfoListResponse = {
  __typename?: 'UserInfoListResponse'
  /** A list of userInfo reference */
  userInfo?: Maybe<Array<Maybe<UserInfo>>>
}

/** User info billing account id type where input type */
export type UserInfoListWhereBillingAccountIdInput = {
  /** Is the value equal to the field */
  eq?: InputMaybe<Scalars['ID']['input']>
  /** Are the values in the field */
  in?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>
}

/** User info billing account number type where input type */
export type UserInfoListWhereBillingAccountNumberInput = {
  /** Is the value equal to the field */
  eq?: InputMaybe<Scalars['ID']['input']>
  /** Are the values in the field */
  in?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>
}

/** User info user account id type where input type */
export type UserInfoListWhereEmailInput = {
  /** Is the value equal to the field */
  eq?: InputMaybe<Scalars['ID']['input']>
  /** Are the values in the field */
  in?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>
}

/** User info policy where conditions to filter rows */
export type UserInfoListWhereInput = {
  /** The billing account id field where clause */
  billingAccountId?: InputMaybe<UserInfoListWhereBillingAccountIdInput>
  /** The billing account number field where clause */
  billingAccountNumber?: InputMaybe<UserInfoListWhereBillingAccountNumberInput>
  /** The email field where clause */
  email?: InputMaybe<UserInfoListWhereEmailInput>
  /** The uid field where clause */
  uid?: InputMaybe<UserInfoListWhereUidInput>
  /** The user account id field where clause */
  userAccountId?: InputMaybe<UserInfoListWhereUserAccountIdInput>
  /** The uuid field where clause */
  uuid?: InputMaybe<UserInfoListWhereUuidInput>
  /** The yoga international user id field where clause */
  yogaInternationalUserId?: InputMaybe<UserInfoListWhereYogaInternationalUserIdInput>
}

/** User info uid type where input type */
export type UserInfoListWhereUidInput = {
  /** Is the value equal to the field */
  eq?: InputMaybe<Scalars['ID']['input']>
  /** Is the value greater than to the field */
  gt?: InputMaybe<Scalars['ID']['input']>
  /** Is the value greater than or equal to the field */
  gte?: InputMaybe<Scalars['ID']['input']>
  /** Are the values in the field */
  in?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>
}

/** User info user account id type where input type */
export type UserInfoListWhereUserAccountIdInput = {
  /** Is the value equal to the field */
  eq?: InputMaybe<Scalars['ID']['input']>
  /** Are the values in the field */
  in?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>
}

/** User info uuid type where input type */
export type UserInfoListWhereUuidInput = {
  /** Is the value equal to the field */
  eq?: InputMaybe<Scalars['ID']['input']>
  /** Are the values in the field */
  in?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>
}

/** User info yoga international user id type where input type */
export type UserInfoListWhereYogaInternationalUserIdInput = {
  /** Is the value equal to the field */
  eq?: InputMaybe<Scalars['ID']['input']>
  /** Are the values in the field */
  in?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>
}

/** User info with metadata response */
export type UserInfoWithMetadataResponse = {
  __typename?: 'UserInfoWithMetadataResponse'
  /** Total count of users with demographic metadata */
  count?: Maybe<Scalars['Int']['output']>
  /** The limit applied to the rows */
  limit?: Maybe<Scalars['Int']['output']>
  /** The offset applied to the rows */
  offset?: Maybe<Scalars['Int']['output']>
  /** A list of user info */
  userInfo: Array<UserInfo>
}

/** User media position row */
export type UserMediaPosition = {
  __typename?: 'UserMediaPosition'
  /** The date the row was created */
  createdAt?: Maybe<Scalars['DateTime']['output']>
  /** User has hidden this media from their watch history when true */
  hiddenByUser?: Maybe<Scalars['Boolean']['output']>
  /** User has hidden this media from showing up in Continue Watching */
  hiddenFromContinue?: Maybe<Scalars['Boolean']['output']>
  /** The most recent time the media has been played. */
  lastPlayed?: Maybe<Scalars['BigInt']['output']>
  /** The media linked from this user media position */
  media?: Maybe<Media>
  /** The node nid that was played. */
  mediaId?: Maybe<Scalars['ID']['output']>
  /** The time offset (in seconds) when this media was last playing (resume point). */
  position?: Maybe<Scalars['BigInt']['output']>
  /** The time this video was last searched by this user (in seconds) */
  searchedTime?: Maybe<Scalars['Int']['output']>
  /** The users uid that played the node nid. */
  uid?: Maybe<Scalars['ID']['output']>
  /** The date the row was updated */
  updatedAt?: Maybe<Scalars['DateTime']['output']>
  /** The user connected this this user history */
  userInfo?: Maybe<UserInfo>
  /** The video analytics media for this record */
  videoAnalyticsMedia?: Maybe<VideoAnalyticsMedia>
  /** The video analytics video for this record */
  videoAnalyticsVideo?: Maybe<VideoAnalyticsVideo>
  /** The total number of views of this media by this user. */
  watchedCount?: Maybe<Scalars['Int']['output']>
  /** The total seconds watched of all views of this media by this user. */
  watchedSum?: Maybe<Scalars['BigInt']['output']>
}

/** User media position list response */
export type UserMediaPositionListResponse = {
  __typename?: 'UserMediaPositionListResponse'
  /** Total number of rows of content found (uses a slower count query for list) */
  count?: Maybe<Scalars['Int']['output']>
  /** The limit applied to the rows */
  limit?: Maybe<Scalars['Int']['output']>
  /** The offset applied to the rows */
  offset?: Maybe<Scalars['Int']['output']>
  /** A list of user media positions */
  userMediaPositions?: Maybe<Array<Maybe<UserMediaPosition>>>
}

/** User media position list where clause */
export type UserMediaPositionListWhereInput = {
  /** Filter by media id */
  mediaId?: InputMaybe<UserMediaPositionListWhereMediaIdInput>
  /** Filter by user uid */
  uid?: InputMaybe<UserMediaPositionListWhereUidInput>
}

/** User media position list where clause for media id */
export type UserMediaPositionListWhereMediaIdInput = {
  /** Is the value equal to the field */
  eq?: InputMaybe<Scalars['ID']['input']>
  /** Is the value greater than to the field */
  gt?: InputMaybe<Scalars['ID']['input']>
  /** Is the value greater than or equal to the field */
  gte?: InputMaybe<Scalars['ID']['input']>
  /** Are the values in the field */
  in?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>
}

/** User media position list where clause for user uid */
export type UserMediaPositionListWhereUidInput = {
  /** Is the value equal to the field */
  eq?: InputMaybe<Scalars['ID']['input']>
  /** Is the value greater than to the field */
  gt?: InputMaybe<Scalars['ID']['input']>
  /** Is the value greater than or equal to the field */
  gte?: InputMaybe<Scalars['ID']['input']>
  /** Are the values in the field */
  in?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>
}

/** User meta tags */
export type UserMetaTag = {
  __typename?: 'UserMetaTag'
  /** When the row was created */
  createdAt?: Maybe<Scalars['DateTime']['output']>
  /** The primary key for this record */
  id: Scalars['ID']['output']
  /** The numeric key for tag name i.e. 2 */
  key: Scalars['Int']['output']
  /** The tag name i.e. 'transformation' */
  name: Scalars['String']['output']
  /** The number of seconds a user could have watched for engaged views in this category/segment */
  potentialSeconds: Scalars['Int']['output']
  /** The source of this data (VA, Brooklyn, ColdStart) */
  source: Scalars['String']['output']
  /** The type of meta tag (UBS, RC, TOPIC) */
  tagType: Scalars['String']['output']
  /** The user id */
  uid: Scalars['Int']['output']
  /** When the row was last updated */
  updatedAt?: Maybe<Scalars['DateTime']['output']>
  /** The user linked to this user meta tag */
  userInfo?: Maybe<UserInfo>
  /** The number of engaged views (where a user has watched more than 25% of a video) */
  viewCount: Scalars['Int']['output']
  /** The number of seconds watched for engaged views (> 25%) only */
  viewSeconds: Scalars['Int']['output']
  /** A fractional value indicating the percentage of all engaged for tag within the type */
  weight?: Maybe<Scalars['Float']['output']>
}

/** User meta tag filter input type */
export type UserMetaTagFilterInput = {
  /** The numeric key for tag name i.e. 2 */
  key?: InputMaybe<Scalars['Int']['input']>
  /** The source of this data (VA, Brooklyn, ColdStart) */
  source?: InputMaybe<Scalars['String']['input']>
  /** The type of meta tag (UBS, RC, TOPIC) */
  type?: InputMaybe<Scalars['String']['input']>
  /** The user id */
  uid?: InputMaybe<Scalars['Int']['input']>
}

/** User meta tag list response */
export type UserMetaTagListResponse = {
  __typename?: 'UserMetaTagListResponse'
  /** A list of user meta tags */
  userMetaTags: Array<UserMetaTag>
}

/** User meta tag where conditions to filter rows */
export type UserMetaTagWhereInput = {
  /** The id field where clause */
  id?: InputMaybe<UserMetaTagWhereIntInput>
  /** The key field where clause */
  key?: InputMaybe<UserMetaTagWhereIntInput>
  /** The name field where clause */
  name?: InputMaybe<UserMetaTagWhereStringInput>
  /** The source field where clause */
  source?: InputMaybe<UserMetaTagWhereStringInput>
  /** The tag_type field where clause */
  tagType?: InputMaybe<UserMetaTagWhereStringInput>
  /** The uid field where clause */
  uid?: InputMaybe<UserMetaTagWhereIntInput>
}

/** User meta tag id where input type */
export type UserMetaTagWhereIntInput = {
  /** Is the value equal to the field */
  eq?: InputMaybe<Scalars['ID']['input']>
  /** Is the value greater than to the field */
  gt?: InputMaybe<Scalars['ID']['input']>
  /** Is the value greater than or equal to the field */
  gte?: InputMaybe<Scalars['ID']['input']>
  /** Are the values in the field */
  in?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>
  /** Is the value less than to the field */
  lt?: InputMaybe<Scalars['ID']['input']>
  /** Is the value less than or equal to the field */
  lte?: InputMaybe<Scalars['ID']['input']>
}

/** User meta tag id where input type */
export type UserMetaTagWhereStringInput = {
  /** Is the value equal to the field */
  eq?: InputMaybe<Scalars['ID']['input']>
  /** Are the values in the field */
  in?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>
}

/** User metadata entry */
export type UserMetadata = {
  __typename?: 'UserMetadata'
  /** When the row was created */
  createdAt?: Maybe<Scalars['DateTime']['output']>
  /** The export index for this record */
  exportIndex: Scalars['Int']['output']
  /** The metadata name */
  name: Scalars['String']['output']
  /** The metadata type */
  type: Scalars['String']['output']
  /** The user id */
  uid: Scalars['Int']['output']
  /** When the row was last updated */
  updatedAt?: Maybe<Scalars['DateTime']['output']>
  /** The metadata value */
  value?: Maybe<Scalars['String']['output']>
}

/** User metadata input */
export type UserMetadataInput = {
  /** The metadata name */
  name: Scalars['String']['input']
  /** The metadata type */
  type: Scalars['String']['input']
  /** The user id */
  uid: Scalars['Int']['input']
  /** The metadata value */
  value?: InputMaybe<Scalars['String']['input']>
}

/** User metadata mutation response */
export type UserMetadataMutationResult = {
  __typename?: 'UserMetadataMutationResult'
  /** The total number of rows created */
  created: Scalars['Int']['output']
  /** The total number of rows updated */
  updated: Scalars['Int']['output']
  /** The resulting user metadata rows */
  userMetadata: Array<UserMetadata>
}

/** User role */
export type UserRole = {
  __typename?: 'UserRole'
  /** The auth role associated with this record */
  authRole?: Maybe<AuthRole>
  /** The date the row was created */
  createdAt?: Maybe<Scalars['DateTime']['output']>
  /** The primary key */
  id?: Maybe<Scalars['ID']['output']>
  /** The auth role id */
  role?: Maybe<Scalars['ID']['output']>
  /** The date the row was last updated */
  updatedAt?: Maybe<Scalars['DateTime']['output']>
  /** The user info associated with this record */
  userInfo?: Maybe<UserInfo>
  /** The identifier for the user associated with this record */
  userInfoUuid?: Maybe<Scalars['ID']['output']>
}

/** User role list response */
export type UserRoleListResponse = {
  __typename?: 'UserRoleListResponse'
  /** Total number of rows found (uses a slower count query for list) */
  count?: Maybe<Scalars['Int']['output']>
  /** The limit applied to the rows */
  limit?: Maybe<Scalars['Int']['output']>
  /** The offset applied to the rows */
  offset?: Maybe<Scalars['Int']['output']>
  /** A list of userInfo reference */
  userRoles?: Maybe<Array<Maybe<UserRole>>>
}

/** User role id where input type */
export type UserRoleListWhereIdInput = {
  /** Is the value equal to the field */
  eq?: InputMaybe<Scalars['ID']['input']>
  /** Is the value greater than to the field */
  gt?: InputMaybe<Scalars['ID']['input']>
  /** Is the value greater than or equal to the field */
  gte?: InputMaybe<Scalars['ID']['input']>
  /** Are the values in the field */
  in?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>
  /** Is the value less than the field */
  lt?: InputMaybe<Scalars['ID']['input']>
  /** Is the value less than or equal to the field */
  lte?: InputMaybe<Scalars['ID']['input']>
}

/** User role where conditions to filter rows */
export type UserRoleListWhereInput = {
  /** The id field where clause */
  id?: InputMaybe<UserRoleListWhereIdInput>
  /** The user role role file where clause */
  role?: InputMaybe<UserRoleListWhereRoleInput>
  /** The user info uuid field where clause */
  userInfoUuid?: InputMaybe<UserRoleListWhereUserInfoUuidInput>
}

/** User role user role where input type */
export type UserRoleListWhereRoleInput = {
  /** Is the value equal to the field */
  eq?: InputMaybe<Scalars['ID']['input']>
  /** Is the value greater than to the field */
  gt?: InputMaybe<Scalars['ID']['input']>
  /** Is the value greater than or equal to the field */
  gte?: InputMaybe<Scalars['ID']['input']>
  /** Are the values in the field */
  in?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>
  /** Is the value less than the field */
  lt?: InputMaybe<Scalars['ID']['input']>
  /** Is the value less than or equal to the field */
  lte?: InputMaybe<Scalars['ID']['input']>
}

/** User role user user info uuid where input type */
export type UserRoleListWhereUserInfoUuidInput = {
  /** Is the value equal to the field */
  eq?: InputMaybe<Scalars['ID']['input']>
  /** Are the values in the field */
  in?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>
}

/** User state entry for tracking progress */
export type UserState = {
  __typename?: 'UserState'
  /** When the row was created */
  createdAt?: Maybe<Scalars['DateTime']['output']>
  /** The parent content title group id (course) */
  parentContentTitleGroupId: Scalars['String']['output']
  /** The id of the progress item. For videos, this should be the contentTitleGroupId. For assets, this should be the asset UUID. */
  progressItemId: Scalars['String']['output']
  /** The type of progress item */
  progressItemType: UserStateProgressItemType
  /** The state of the progress item */
  state: UserStateState
  /** The user id */
  uid: Scalars['Int']['output']
  /** When the row was last updated */
  updatedAt?: Maybe<Scalars['DateTime']['output']>
}

export enum UserStateCourse {
  /** The course is complete */
  Complete = 'COMPLETE',
  /** The course is in progress */
  InProgress = 'IN_PROGRESS',
  /** The course has not been started */
  NotStarted = 'NOT_STARTED',
}

/** User state input */
export type UserStateInput = {
  /** The parent content title group id (course) */
  parentContentTitleGroupId: Scalars['String']['input']
  /** The id of the progress item. For videos, this should be the contentTitleGroupId. For assets, this should be the asset UUID. */
  progressItemId: Scalars['String']['input']
  /** The type of progress item */
  progressItemType: UserStateProgressItemType
  /** The state of the progress item */
  state: UserStateState
  /** The user id (admin only, defaults to current user) */
  userUid?: InputMaybe<Scalars['Int']['input']>
}

/** User state list response */
export type UserStateListResponse = {
  __typename?: 'UserStateListResponse'
  /** The total number of user state entries matching the query */
  count?: Maybe<Scalars['Int']['output']>
  /** The limit used in the query */
  limit?: Maybe<Scalars['Int']['output']>
  /** The offset used in the query */
  offset?: Maybe<Scalars['Int']['output']>
  /** A list of user state entries */
  userState: Array<UserState>
}

/** Course metrics */
export type UserStateMetricsCourse = {
  __typename?: 'UserStateMetricsCourse'
  /** Number of completed videos */
  completedItems: Scalars['Int']['output']
  /** Number of completed modules */
  completedModules: Scalars['Int']['output']
  /** Percentage of items completed (0.0 to 100.0) */
  percentageItemsComplete: Scalars['Float']['output']
  /** Percentage of modules completed (0.0 to 100.0) */
  percentageModulesComplete: Scalars['Float']['output']
  /** Total number of videos in the course */
  totalItems: Scalars['Int']['output']
  /** Total number of modules in the course */
  totalModules: Scalars['Int']['output']
}

/** Course module metrics */
export type UserStateMetricsCourseModule = {
  __typename?: 'UserStateMetricsCourseModule'
  /** Number of completed videos */
  completedItems: Scalars['Int']['output']
  /** Percentage of items completed (0.0 to 100.0) */
  percentageItemsComplete: Scalars['Float']['output']
  /** Total number of videos in the module */
  totalItems: Scalars['Int']['output']
}

/** Course progress */
export type UserStateProgressCourse = {
  __typename?: 'UserStateProgressCourse'
  /** The number of times the course has been completed */
  completionCount: Scalars['Int']['output']
  /** The course title group id */
  courseTitleGroupId: Scalars['String']['output']
  /** The course metrics */
  metrics: UserStateMetricsCourse
  /** The current state of the course. If the course has production_status of 'active-production', this will return IN_PROGRESS instead of COMPLETE even when all videos are complete. */
  state: UserStateCourse
}

/** Course item progress */
export type UserStateProgressCourseItem = {
  __typename?: 'UserStateProgressCourseItem'
  /** The asset (if item is an asset) */
  asset?: Maybe<Asset>
  /** The content (if item is a video) */
  content?: Maybe<Content>
  /** The item id (video or asset id) */
  itemId: Scalars['String']['output']
  /** The type of item */
  itemType: UserStateProgressItemType
  /** The current state of the item */
  state: UserStateState
}

/** Course progress list response */
export type UserStateProgressCourseListResponse = {
  __typename?: 'UserStateProgressCourseListResponse'
  /** The total number of course progress entries matching the query */
  count?: Maybe<Scalars['Int']['output']>
  /** A list of course progress entries */
  courseProgress: Array<UserStateProgressCourse>
  /** The limit used in the query */
  limit?: Maybe<Scalars['Int']['output']>
  /** The offset used in the query */
  offset?: Maybe<Scalars['Int']['output']>
}

/** Course module progress */
export type UserStateProgressCourseModule = {
  __typename?: 'UserStateProgressCourseModule'
  /** The module title group id */
  courseModuleTitleGroupId: Scalars['String']['output']
  /** The module metrics */
  metrics: UserStateMetricsCourseModule
  /** The module content */
  module?: Maybe<Content>
  /** The current state of the module */
  state: UserStateCourse
}

export enum UserStateProgressItemType {
  /** An asset progress item */
  Asset = 'ASSET',
  /** A video progress item */
  Video = 'VIDEO',
}

export enum UserStateState {
  /** The item is complete */
  Complete = 'COMPLETE',
  /** The item is in progress */
  InProgress = 'IN_PROGRESS',
}

/** User state where id input type */
export type UserStateWhereIdInput = {
  /** Is the value equal to the field */
  eq?: InputMaybe<Scalars['ID']['input']>
  /** Is the value greater than to the field */
  gt?: InputMaybe<Scalars['ID']['input']>
  /** Is the value greater than or equal to the field */
  gte?: InputMaybe<Scalars['ID']['input']>
  /** Are the values in the field */
  in?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>
  /** Is the value less than to the field */
  lt?: InputMaybe<Scalars['ID']['input']>
  /** Is the value less than or equal to the field */
  lte?: InputMaybe<Scalars['ID']['input']>
}

/** User state where conditions to filter rows */
export type UserStateWhereInput = {
  /** The id field where clause */
  id?: InputMaybe<UserStateWhereIdInput>
  /** The uid field where clause */
  uid?: InputMaybe<UserStateWhereUidInput>
}

/** User state where uid input type */
export type UserStateWhereUidInput = {
  /** Is the value equal to the field */
  eq?: InputMaybe<Scalars['ID']['input']>
  /** Is the value greater than to the field */
  gt?: InputMaybe<Scalars['ID']['input']>
  /** Is the value greater than or equal to the field */
  gte?: InputMaybe<Scalars['ID']['input']>
  /** Are the values in the field */
  in?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>
  /** Is the value less than to the field */
  lt?: InputMaybe<Scalars['ID']['input']>
  /** Is the value less than or equal to the field */
  lte?: InputMaybe<Scalars['ID']['input']>
}

/** Video analytics media row */
export type VideoAnalyticsMedia = {
  __typename?: 'VideoAnalyticsMedia'
  /** Rotating accumulators for distinct play counts per time period (hourly) */
  countBuckets?: Maybe<Array<Maybe<Scalars['Int']['output']>>>
  /** Rotating accumulators for distinct play counts per time period (hourly) */
  countBuckets_de?: Maybe<Array<Maybe<Scalars['Int']['output']>>>
  /** Rotating accumulators for distinct play counts per time period (hourly) */
  countBuckets_en?: Maybe<Array<Maybe<Scalars['Int']['output']>>>
  /** Rotating accumulators for distinct play counts per time period (hourly) */
  countBuckets_es?: Maybe<Array<Maybe<Scalars['Int']['output']>>>
  /** Rotating accumulators for distinct play counts per time period (hourly) */
  countBuckets_fr?: Maybe<Array<Maybe<Scalars['Int']['output']>>>
  /** Lifetime count of distinct plays */
  countLifetime?: Maybe<Scalars['Int']['output']>
  /** Lifetime count of distinct plays */
  countLifetime_de?: Maybe<Scalars['Int']['output']>
  /** Lifetime count of distinct plays */
  countLifetime_en?: Maybe<Scalars['Int']['output']>
  /** Lifetime count of distinct plays */
  countLifetime_es?: Maybe<Scalars['Int']['output']>
  /** Lifetime count of distinct plays */
  countLifetime_fr?: Maybe<Scalars['Int']['output']>
  /** Auto generated field from sequelize */
  createdAt?: Maybe<Scalars['DateTime']['output']>
  /** The total length of this media (in seconds) */
  duration?: Maybe<Scalars['Int']['output']>
  /** Is this media a feature (true) or a preview (false) */
  isFeature?: Maybe<Scalars['Boolean']['output']>
  /** flag indicating the media has been published */
  isPublished?: Maybe<Scalars['Boolean']['output']>
  /** qualified string identifier for the media */
  lemonadeContentId?: Maybe<Scalars['String']['output']>
  /** The media linked from this video analytics media */
  media?: Maybe<Media>
  /** VideoAnalyticsMedia creation date */
  mediaCreated?: Maybe<Scalars['String']['output']>
  /** The feature_nid */
  mediaId?: Maybe<Scalars['String']['output']>
  /** update to the media */
  mediaUpdated?: Maybe<Scalars['DateTime']['output']>
  /** The series.nid referenced in this video that contains this media */
  seriesId?: Maybe<Scalars['String']['output']>
  /** Auto generated field from sequelize */
  updatedAt?: Maybe<Scalars['DateTime']['output']>
}

/** Video analytics media list response */
export type VideoAnalyticsMediaListResponse = {
  __typename?: 'VideoAnalyticsMediaListResponse'
  /** Total number of rows of content found (uses a slower count query for list) */
  count?: Maybe<Scalars['Int']['output']>
  /** The limit applied to the rows */
  limit?: Maybe<Scalars['Int']['output']>
  /** The offset applied to the rows */
  offset?: Maybe<Scalars['Int']['output']>
  /** A list of media */
  videoAnalyticsMedia?: Maybe<Array<Maybe<VideoAnalyticsMedia>>>
}

/** Video analytics media list where clause for the id */
export type VideoAnalyticsMediaListWhereIdInput = {
  /** Is the value equal to the field */
  eq?: InputMaybe<Scalars['Int']['input']>
  /** Is the value greater than to the field */
  gt?: InputMaybe<Scalars['Int']['input']>
  /** Is the value greater than or equal to the field */
  gte?: InputMaybe<Scalars['Int']['input']>
  /** Are the values in the field */
  in?: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>
}

/** Video analytics media list where clause */
export type VideoAnalyticsMediaListWhereInput = {
  /** Filter by media id */
  mediaId?: InputMaybe<VideoAnalyticsMediaListWhereIdInput>
  /** Filter by series id */
  seriesId?: InputMaybe<VideoAnalyticsMediaListWhereSeriesIdInput>
}

/** Video analytics media list where clause for the series id */
export type VideoAnalyticsMediaListWhereSeriesIdInput = {
  /** Is the value equal to the field */
  eq?: InputMaybe<Scalars['Int']['input']>
  /** Is the value greater than to the field */
  gt?: InputMaybe<Scalars['Int']['input']>
  /** Is the value greater than or equal to the field */
  gte?: InputMaybe<Scalars['Int']['input']>
  /** Are the values in the field */
  in?: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>
}

/** Video analytics video row */
export type VideoAnalyticsVideo = {
  __typename?: 'VideoAnalyticsVideo'
  /** Auto generated field from sequelize */
  createdAt?: Maybe<Scalars['DateTime']['output']>
  /** A flag indicating the video has been published */
  isPublished?: Maybe<Scalars['Boolean']['output']>
  /** The language of the video content */
  language: Scalars['String']['output']
  /** The media linked from this video analytics video */
  media?: Maybe<Media>
  /** The feature.nid referenced in this video */
  mediaId?: Maybe<Scalars['ID']['output']>
  /** The content ID of the next episode in the series */
  nextEpisodeContentId?: Maybe<Scalars['ID']['output']>
  /** The publication date of the next episode in the series */
  nextEpisodePublishedAtDate?: Maybe<Scalars['DateTime']['output']>
  /** Status of the next episode in the series */
  nextEpisodeStatus?: Maybe<Scalars['String']['output']>
  /** The preview.nid referenced in this video */
  previewId?: Maybe<Scalars['ID']['output']>
  /** The primary language of the video content */
  primaryLanguage: Scalars['String']['output']
  /** The publication date of the video */
  publishedAtDate?: Maybe<Scalars['DateTime']['output']>
  /** The rainbow category (name) this video belongs to */
  rainbowCategory?: Maybe<Scalars['String']['output']>
  /** The rainbow category (key) this video belongs to */
  rainbowKey?: Maybe<Scalars['Int']['output']>
  /** The series.nid referenced in this video */
  seriesId?: Maybe<Scalars['ID']['output']>
  /** The title for this video */
  title?: Maybe<Scalars['String']['output']>
  /** The array of topics this video belongs to */
  topics?: Maybe<Array<Maybe<VideoAnalyticsVideoTopics>>>
  /** The UBS segment (key) this video belongs to */
  ubsKey?: Maybe<Scalars['Int']['output']>
  /** The UBS segment (name) this video belongs to */
  ubsSegment?: Maybe<Scalars['String']['output']>
  /** Auto generated field from sequelize */
  updatedAt?: Maybe<Scalars['DateTime']['output']>
  /** VideoAnalyticsVideo creation date */
  videoCreated?: Maybe<Scalars['String']['output']>
  /** The video.nid */
  videoId: Scalars['ID']['output']
  /** Last update to the video */
  videoUpdated?: Maybe<Scalars['DateTime']['output']>
}

/** Video analytics video list response */
export type VideoAnalyticsVideoListResponse = {
  __typename?: 'VideoAnalyticsVideoListResponse'
  /** Total number of rows of content found (uses a slower count query for list) */
  count?: Maybe<Scalars['Int']['output']>
  /** The limit applied to the rows */
  limit?: Maybe<Scalars['Int']['output']>
  /** The offset applied to the rows */
  offset?: Maybe<Scalars['Int']['output']>
  /** A list of videos */
  videoAnalyticsVideos?: Maybe<Array<Maybe<VideoAnalyticsVideo>>>
}

/** Video analytics video list where clause for the id */
export type VideoAnalyticsVideoListWhereIdInput = {
  /** Is the value equal to the field */
  eq?: InputMaybe<Scalars['ID']['input']>
  /** Is the value greater than to the field */
  gt?: InputMaybe<Scalars['ID']['input']>
  /** Is the value greater than or equal to the field */
  gte?: InputMaybe<Scalars['ID']['input']>
  /** Are the values in the field */
  in?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>
}

/** Video analytics video list where clause */
export type VideoAnalyticsVideoListWhereInput = {
  /** Filter by media id */
  mediaId?: InputMaybe<VideoAnalyticsVideoListWhereMediaIdInput>
  /** Filter by series id */
  seriesId?: InputMaybe<VideoAnalyticsVideoListWhereSeriesIdInput>
  /** Filter by video id */
  videoId?: InputMaybe<VideoAnalyticsVideoListWhereIdInput>
}

/** Video analytics video list where clause for the media id */
export type VideoAnalyticsVideoListWhereMediaIdInput = {
  /** Is the value equal to the field */
  eq?: InputMaybe<Scalars['ID']['input']>
  /** Is the value greater than to the field */
  gt?: InputMaybe<Scalars['ID']['input']>
  /** Is the value greater than or equal to the field */
  gte?: InputMaybe<Scalars['ID']['input']>
  /** Are the values in the field */
  in?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>
}

/** Video analytics video list where clause for the series id */
export type VideoAnalyticsVideoListWhereSeriesIdInput = {
  /** Is the value equal to the field */
  eq?: InputMaybe<Scalars['ID']['input']>
  /** Is the value greater than to the field */
  gt?: InputMaybe<Scalars['ID']['input']>
  /** Is the value greater than or equal to the field */
  gte?: InputMaybe<Scalars['ID']['input']>
  /** Are the values in the field */
  in?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>
}

/** Video analytics video row topics */
export type VideoAnalyticsVideoTopics = {
  __typename?: 'VideoAnalyticsVideoTopics'
  /** The topic key (content id) */
  key?: Maybe<Scalars['Int']['output']>
  /** The topic title */
  title?: Maybe<Scalars['String']['output']>
}

/** Input payload for requesting a video auto summary. */
export type VideoAutoSummaryInput = {
  /** Oracle content identifier. */
  contentId: Scalars['String']['input']
  /** Feature media identifier. */
  featureMediaId: Scalars['String']['input']
  /** Playback position in seconds; captions up to this timestamp are summarized. */
  pausedAtSeconds: Scalars['Float']['input']
}

/** Summary result for the watched portion of a video. */
export type VideoAutoSummaryPayload = {
  __typename?: 'VideoAutoSummaryPayload'
  /** Number of caption segments included in the summary. */
  captionCount: Scalars['Int']['output']
  /** Server timestamp when the summary was generated. */
  generatedAt: Scalars['DateTime']['output']
  /** Timestamp of the final caption considered (ISO or HH:MM:SS string). */
  lastCaptionTime?: Maybe<Scalars['String']['output']>
  /** LLM generated summary text. */
  summary: Scalars['String']['output']
}

/** Single prompt suggestion with metadata. */
export type VideoPromptSuggestion = {
  __typename?: 'VideoPromptSuggestion'
  /** The focus area or topic of the suggestion. */
  focus: Scalars['String']['output']
  /** The suggested prompt/question text. */
  prompt: Scalars['String']['output']
  /** Explanation of why this suggestion was made. */
  rationale: Scalars['String']['output']
}

/** Input payload for requesting video prompt suggestions. */
export type VideoPromptSuggestionsInput = {
  /** Oracle content identifier. */
  contentId: Scalars['String']['input']
  /** Playback position in seconds; captions up to this timestamp are considered. */
  currentTimeSeconds: Scalars['Float']['input']
  /** Feature media identifier. */
  featureMediaId: Scalars['String']['input']
}

/** Result payload for video prompt suggestions. */
export type VideoPromptSuggestionsPayload = {
  __typename?: 'VideoPromptSuggestionsPayload'
  /** Number of chunk segments actually included in the context excerpt. */
  contextChunksUsed: Scalars['Int']['output']
  /** End timecode (HH:MM:SS) of the context coverage, or null if unavailable. */
  coverageEndTimecode?: Maybe<Scalars['String']['output']>
  /** Start timecode (HH:MM:SS) of the context coverage, or null if unavailable. */
  coverageStartTimecode?: Maybe<Scalars['String']['output']>
  /** Server timestamp when the suggestions were generated. */
  generatedAt: Scalars['DateTime']['output']
  /** List of suggested prompts/questions. */
  suggestions: Array<VideoPromptSuggestion>
  /** Total number of chunk segments considered from the database. */
  totalChunksConsidered: Scalars['Int']['output']
}

/** Content analytic */
export type Vote = {
  __typename?: 'Vote'
  /** The content linked to this vote */
  content?: Maybe<Array<Maybe<Content>>>
  /** The id of the content */
  contentId?: Maybe<Scalars['Int']['output']>
  /** The content type for the content id */
  contentType?: Maybe<Scalars['String']['output']>
  /** The date the row was created */
  createdAt?: Maybe<Scalars['DateTime']['output']>
  /** The primary identifier for this record */
  id?: Maybe<Scalars['ID']['output']>
  /** The id of the user */
  uid?: Maybe<Scalars['Int']['output']>
  /** The date the row was last updated */
  updatedAt?: Maybe<Scalars['DateTime']['output']>
  /** The user info linked to this vote */
  userInfo?: Maybe<UserInfo>
  /** The vote direction */
  voteDirection?: Maybe<VoteDirection>
}

/** Content analytic */
export type VoteContentArgs = {
  content?: InputMaybe<Array<InputMaybe<ContentFilterInput>>>
  language?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
}

export enum VoteDirection {
  /** This is a down vote */
  Down = 'DOWN',
  /** This is a love vote */
  Love = 'LOVE',
  /** This is an up vote */
  Up = 'UP',
}

/** Content analytic where id input type */
export type VoteWhereIdInput = {
  /** Is the value equal to the field */
  eq?: InputMaybe<Scalars['ID']['input']>
  /** Is the value greater than to the field */
  gt?: InputMaybe<Scalars['ID']['input']>
  /** Is the value greater than or equal to the field */
  gte?: InputMaybe<Scalars['ID']['input']>
  /** Are the values in the field */
  in?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>
  /** Is the value less than to the field */
  lt?: InputMaybe<Scalars['ID']['input']>
  /** Is the value less than or equal to the field */
  lte?: InputMaybe<Scalars['ID']['input']>
}

/** Content analytic where conditions to filter rows */
export type VoteWhereInput = {
  /** The id field where clause */
  id?: InputMaybe<VoteWhereIdInput>
  /** The id field where clause */
  uid?: InputMaybe<VoteWhereUidInput>
}

/** Content analytic where uid input type */
export type VoteWhereUidInput = {
  /** Is the value equal to the field */
  eq?: InputMaybe<Scalars['ID']['input']>
  /** Is the value greater than to the field */
  gt?: InputMaybe<Scalars['ID']['input']>
  /** Is the value greater than or equal to the field */
  gte?: InputMaybe<Scalars['ID']['input']>
  /** Are the values in the field */
  in?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>
  /** Is the value less than to the field */
  lt?: InputMaybe<Scalars['ID']['input']>
  /** Is the value less than or equal to the field */
  lte?: InputMaybe<Scalars['ID']['input']>
}

/** Content analytic list response */
export type VotesListResponse = {
  __typename?: 'VotesListResponse'
  /** The total number of votes matching the query */
  count?: Maybe<Scalars['Int']['output']>
  /** The limit used in the query */
  limit?: Maybe<Scalars['Int']['output']>
  /** The offset used in the query */
  offset?: Maybe<Scalars['Int']['output']>
  /** A list of Content analytic */
  votes?: Maybe<Array<Maybe<Vote>>>
}

/** Worker */
export type Worker = {
  __typename?: 'Worker'
  /** The date the row was created */
  createdAt?: Maybe<Scalars['DateTime']['output']>
  /** Additional data the the worker would need to maintain proper state */
  data?: Maybe<Scalars['JSON']['output']>
  /** When true the worker is allowed to run when false it shoudl not do any work */
  enabled?: Maybe<Scalars['Boolean']['output']>
  /** When the worker last stopped or went idle */
  endDate?: Maybe<Scalars['DateTime']['output']>
  /** The primary identifier for this record */
  id: Scalars['ID']['output']
  /** The last value processed by this worker, an example could be an db offset or id for the last row processed */
  lastProcessedValue?: Maybe<Scalars['String']['output']>
  /** When the worker lock expires or null if there is no lock */
  lockExpiresDate?: Maybe<Scalars['DateTime']['output']>
  /** The human readable name of the worker */
  name: Scalars['String']['output']
  /** The run state of the worker */
  runState?: Maybe<WorkerState>
  /** When the woker last started */
  startDate?: Maybe<Scalars['DateTime']['output']>
  /** The date the row was last updated */
  updatedAt?: Maybe<Scalars['DateTime']['output']>
}

/** Worker create input */
export type WorkerCreateInput = {
  /** Additional data the the worker would need to maintain proper state */
  data?: InputMaybe<Scalars['JSON']['input']>
  /** When true the worker is allowed to run when false it shoudl not do any work */
  enabled?: InputMaybe<Scalars['Boolean']['input']>
  /** When the worker last stopped or went idle */
  endDate?: InputMaybe<Scalars['DateTime']['input']>
  /** The last value processed by this worker, an example could be an db offset or id for the last row processed */
  lastProcessedValue?: InputMaybe<Scalars['String']['input']>
  /** When the worker lock expires or null if there is no lock */
  lockExpiresDate?: InputMaybe<Scalars['DateTime']['input']>
  /** The worker name */
  name: Scalars['String']['input']
  /** The run state of the worker */
  runState?: InputMaybe<WorkerState>
  /** When the woker last started */
  startDate?: InputMaybe<Scalars['DateTime']['input']>
}

/** Worker delete input */
export type WorkerDeleteInput = {
  /** The worker id */
  id?: InputMaybe<Scalars['ID']['input']>
  /** The worker name */
  name?: InputMaybe<Scalars['String']['input']>
}

/** Worker response */
export type WorkerListResponse = {
  __typename?: 'WorkerListResponse'
  /** A list of workers */
  workers?: Maybe<Array<Maybe<Worker>>>
}

/** Worker mutation response */
export type WorkerMutationResponse = {
  __typename?: 'WorkerMutationResponse'
  /** When true mutation was successful */
  success?: Maybe<Scalars['Boolean']['output']>
  /** The worker which was mutated */
  worker?: Maybe<Worker>
}

export enum WorkerState {
  /** The worker is idle */
  Idle = 'IDLE',
  /** The worker is running */
  Running = 'RUNNING',
  /** The worker is stopped */
  Stopped = 'STOPPED',
}

/** Worker update input */
export type WorkerUpdateInput = {
  /** Additional data the the worker would need to maintain proper state */
  data?: InputMaybe<Scalars['JSON']['input']>
  /** When true the worker is allowed to run when false it shoudl not do any work */
  enabled?: InputMaybe<Scalars['Boolean']['input']>
  /** When the worker last stopped or went idle */
  endDate?: InputMaybe<Scalars['DateTime']['input']>
  /** The primary identifier for this record */
  id?: InputMaybe<Scalars['ID']['input']>
  /** The last value processed by this worker, an example could be an db offset or id for the last row processed */
  lastProcessedValue?: InputMaybe<Scalars['String']['input']>
  /** When the worker lock expires or null if there is no lock */
  lockExpiresDate?: InputMaybe<Scalars['DateTime']['input']>
  /** The worker name */
  name?: InputMaybe<Scalars['String']['input']>
  /** The run state of the worker */
  runState?: InputMaybe<WorkerState>
  /** When the woker last started */
  startDate?: InputMaybe<Scalars['DateTime']['input']>
}

/** The where clause for a worker id field */
export type WorkerWhereIdInput = {
  /** Is the value equal to the field */
  eq?: InputMaybe<Scalars['ID']['input']>
  /** Is the value greater than to the field */
  gt?: InputMaybe<Scalars['ID']['input']>
  /** Is the value greater than or equal to the field */
  gte?: InputMaybe<Scalars['ID']['input']>
  /** Are the values in the field */
  in?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>
  /** Is the value less than to the field */
  lt?: InputMaybe<Scalars['ID']['input']>
  /** Is the value less than or equal to the field */
  lte?: InputMaybe<Scalars['ID']['input']>
}

/** Worker where input */
export type WorkerWhereInput = {
  /** Worker where id clause */
  id?: InputMaybe<WorkerWhereIdInput>
  /** Worker where name clause */
  name?: InputMaybe<WorkerWhereNameInput>
}

/** The where clause for a worker name field */
export type WorkerWhereNameInput = {
  /** Is the value equal to the field */
  eq?: InputMaybe<Scalars['ID']['input']>
  /** Are the values in the field */
  in?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>
}

export type CreateBillingProductInput = {
  /** The content set id of the billing product */
  contentSetId: Scalars['Int']['input']
  /** The name of the billing Product */
  name: Scalars['String']['input']
  /** The name of the billing product platform */
  platform: ProductPlatform
}

export type CreateBillingProviderInput = {
  /** The name of the billing provider */
  name: BillingProviderName
  /** Whether the billing provider has subscription management */
  subscriptionManagement: Scalars['Boolean']['input']
}

/** Repsonse when creating an ecommerce sku mapping bonus eligibility item */
export type EcommerceSkuMappingBonusEligibilityCreateResponse = {
  __typename?: 'ecommerceSkuMappingBonusEligibilityCreateResponse'
  /** The ecommerce sku mapping bonus eligibility that was created */
  ecommerceSkuMappingBonusEligibility?: Maybe<EcommerceSkuMappingBonusEligibility>
}

/** Repsonse when deleting an ecommerce sku mapping bonus eligibility item */
export type EcommerceSkuMappingBonusEligibilityDeleteByIdResponse = {
  __typename?: 'ecommerceSkuMappingBonusEligibilityDeleteByIdResponse'
  /** The ecommerce sku mapping bonus eligibility that was deleted */
  ecommerceSkuMappingBonusEligibility?: Maybe<EcommerceSkuMappingBonusEligibility>
}

/** Repsonse when updating an ecommerce sku mapping bonus eligibility item */
export type EcommerceSkuMappingBonusEligibilityUpdateByIdResponse = {
  __typename?: 'ecommerceSkuMappingBonusEligibilityUpdateByIdResponse'
  /** The ecommerce sku mapping bonus eligibility that was updated */
  ecommerceSkuMappingBonusEligibility?: Maybe<EcommerceSkuMappingBonusEligibility>
}

/** Repsonse when creating an ecommerce sku mapping */
export type EcommerceSkuMappingCreateResponse = {
  __typename?: 'ecommerceSkuMappingCreateResponse'
  /** The ecommerce sku mapping that was created */
  ecommerceSkuMapping?: Maybe<EcommerceSkuMapping>
}

/** Repsonse when updating an ecommerce sku mapping */
export type EcommerceSkuMappingUpdateByProviderAndEcommerceSkuResponse = {
  __typename?: 'ecommerceSkuMappingUpdateByProviderAndEcommerceSkuResponse'
  /** The ecommerce sku mapping that was updated */
  ecommerceSkuMapping?: Maybe<EcommerceSkuMapping>
}

export type UpdateBillingProductInput = {
  /** The content set id of the billing product */
  contentSetId?: InputMaybe<Scalars['Int']['input']>
  /** The id of the billing product */
  id: Scalars['ID']['input']
  /** The name of the billing Product */
  name?: InputMaybe<Scalars['String']['input']>
  /** The name of the billing product platform */
  platform?: InputMaybe<ProductPlatform>
}

export type UpdateBillingProviderInput = {
  /** The id of the billing provider */
  id: Scalars['ID']['input']
  /** The name of the billing provider */
  name?: InputMaybe<BillingProviderName>
  /** Whether the billing provider has subscription management */
  subscriptionManagement?: InputMaybe<Scalars['Boolean']['input']>
}

export type NewHistoryFragment = {
  __typename?: 'ChatHistory'
  id: string
  userInfoUuid: string
  chatSessionsId: string
  data?: any | null
  type?: string | null
}

export type ChatHistoryCreateMutationVariables = Exact<{
  userInfoId?: InputMaybe<Scalars['ID']['input']>
  chatSessionId: Scalars['ID']['input']
  chatData: Scalars['JSON']['input']
  chatType?: InputMaybe<Scalars['String']['input']>
}>

export type ChatHistoryCreateMutation = {
  __typename?: 'Mutation'
  chatHistoryCreate?: {
    __typename?: 'ChatHistoryMutationResponse'
    success?: boolean | null
    chatHistory?: {
      __typename?: 'ChatHistory'
      id: string
      userInfoUuid: string
      chatSessionsId: string
      type?: string | null
      data?: any | null
    } | null
  } | null
}

export type ChatHistoryDeleteMutationVariables = Exact<{
  chatHistoryId: Scalars['ID']['input']
}>

export type ChatHistoryDeleteMutation = {
  __typename?: 'Mutation'
  chatHistoryDelete?: {
    __typename?: 'ChatHistoryMutationResponse'
    success?: boolean | null
  } | null
}

export type ChatHistoryListQueryVariables = Exact<{
  userInfoId: Scalars['ID']['input']
  chatSessionId: Scalars['ID']['input']
}>

export type ChatHistoryListQuery = {
  __typename?: 'Query'
  chatHistoryList?: {
    __typename?: 'ChatHistoryListResponse'
    chatHistories?: Array<{
      __typename?: 'ChatHistory'
      id: string
      userInfoUuid: string
      chatSessionsId: string
      type?: string | null
      data?: any | null
      responseData?: any | null
      createdAt?: any | null
      updatedAt?: any | null
    } | null> | null
  } | null
}

export type ChatSessionCreateMutationVariables = Exact<{
  userInfoId?: InputMaybe<Scalars['ID']['input']>
  title?: InputMaybe<Scalars['String']['input']>
  description?: InputMaybe<Scalars['String']['input']>
}>

export type ChatSessionCreateMutation = {
  __typename?: 'Mutation'
  chatSessionCreate?: {
    __typename?: 'ChatSessionMutationResponse'
    success?: boolean | null
    chatSession?: {
      __typename?: 'ChatSession'
      id: string
      title?: string | null
      description?: string | null
    } | null
  } | null
}

export type ChatSessionDeleteMutationVariables = Exact<{
  chatSessionId: Scalars['ID']['input']
}>

export type ChatSessionDeleteMutation = {
  __typename?: 'Mutation'
  chatSessionDelete?: {
    __typename?: 'ChatSessionMutationResponse'
    success?: boolean | null
  } | null
}

export type ChatSessionListQueryVariables = Exact<{
  userInfoId: Scalars['ID']['input']
}>

export type ChatSessionListQuery = {
  __typename?: 'Query'
  chatSessionList?: {
    __typename?: 'ChatSessionsListResponse'
    chatSessions?: Array<{
      __typename?: 'ChatSession'
      id: string
      userInfoUuid: string
      title?: string | null
      description?: string | null
      createdAt?: any | null
      updatedAt?: any | null
    } | null> | null
  } | null
}

export type DocumentContentListQueryVariables = Exact<{
  contentId?: InputMaybe<Scalars['Int']['input']>
}>

export type DocumentContentListQuery = {
  __typename?: 'Query'
  contentList?: {
    __typename?: 'ContentListResponse'
    count?: number | null
    content?: Array<{
      __typename?: 'Content'
      id?: string | null
      contentId?: number | null
      contentType?: string | null
      language?: string | null
      path?: string | null
      title?: string | null
      writer?: string | null
      description?: string | null
    } | null> | null
  } | null
}

export type DocumentEmbeddingsListQueryVariables = Exact<{
  documentId?: InputMaybe<Scalars['ID']['input']>
  documentNumber?: InputMaybe<Scalars['ID']['input']>
}>

export type DocumentEmbeddingsListQuery = {
  __typename?: 'Query'
  documentEmbeddingsList?: {
    __typename?: 'DocumentEmbeddingsListResponse'
    count?: number | null
    documentEmbeddings?: Array<{
      __typename?: 'DocumentEmbedding'
      language?: string | null
      documentsId?: string | null
      documentNumber?: number | null
      documentText?: string | null
      embedding?: Array<number | null> | null
      document?: {
        __typename?: 'Document'
        content?: Array<{
          __typename?: 'Content'
          title?: string | null
          writer?: string | null
          path?: string | null
        } | null> | null
      } | null
    } | null> | null
  } | null
}

export type GetContentImagesQueryVariables = Exact<{
  contentId: Scalars['Int']['input']
  contentType: Scalars['String']['input']
  language: Array<Scalars['String']['input']> | Scalars['String']['input']
}>

export type GetContentImagesQuery = {
  __typename?: 'Query'
  contentList?: {
    __typename?: 'ContentListResponse'
    content?: Array<{
      __typename?: 'Content'
      id?: string | null
      contentId?: number | null
      contentType?: string | null
      language?: string | null
      primaryLanguage?: string | null
      imageContentRelationships?: Array<{
        __typename?: 'ImageContentRelationship'
        id?: string | null
        type?: string | null
        image?: {
          __typename?: 'Image'
          id?: string | null
          url?: string | null
          originalFileName?: string | null
        } | null
      } | null> | null
    } | null> | null
  } | null
}

export type GetMediaByIdQueryVariables = Exact<{
  mediaId: Scalars['ID']['input']
}>

export type GetMediaByIdQuery = {
  __typename?: 'Query'
  mediaList?: {
    __typename?: 'MediaListResponse'
    media?: Array<{
      __typename?: 'Media'
      mediaId?: string | null
      contentId?: string | null
      policyId?: number | null
      mediaMaestroTitleCode?: string | null
      updatedAt?: any | null
      duration?: number | null
      isPublished?: boolean | null
      mediaAssets?: Array<{
        __typename?: 'MediaAsset'
        id?: string | null
        providerKey?: string | null
        originalFileName?: string | null
        updatedAt?: any | null
        language?: string | null
        mediaReferenceType?: string | null
        duration?: number | null
      } | null> | null
    } | null> | null
  } | null
}

export type GetMediaSuggestionsQueryVariables = Exact<{
  contentId: Scalars['String']['input']
  limit: Scalars['Int']['input']
}>

export type GetMediaSuggestionsQuery = {
  __typename?: 'Query'
  mediaList?: {
    __typename?: 'MediaListResponse'
    media?: Array<{
      __typename?: 'Media'
      mediaId?: string | null
      contentId?: string | null
      createdAt?: any | null
    } | null> | null
  } | null
}

export type SearchContentQueryVariables = Exact<{
  contentType: Scalars['String']['input']
  bundle?: InputMaybe<Scalars['String']['input']>
  title?: InputMaybe<Scalars['String']['input']>
  filterType?: InputMaybe<Scalars['String']['input']>
  limit?: InputMaybe<Scalars['Int']['input']>
  language?: InputMaybe<
    Array<InputMaybe<Scalars['String']['input']>> | InputMaybe<Scalars['String']['input']>
  >
}>

export type SearchContentQuery = {
  __typename?: 'Query'
  contentList?: {
    __typename?: 'ContentListResponse'
    content?: Array<{
      __typename?: 'Content'
      id?: string | null
      contentId?: number | null
      contentType?: string | null
      title?: string | null
      published?: boolean | null
      titleGroupId?: string | null
    } | null> | null
  } | null
}

export type SearchVideoContentQueryVariables = Exact<{
  title?: InputMaybe<Scalars['String']['input']>
  limit?: InputMaybe<Scalars['Int']['input']>
  language?: InputMaybe<
    Array<InputMaybe<Scalars['String']['input']>> | InputMaybe<Scalars['String']['input']>
  >
}>

export type SearchVideoContentQuery = {
  __typename?: 'Query'
  contentList?: {
    __typename?: 'ContentListResponse'
    content?: Array<{
      __typename?: 'Content'
      id?: string | null
      contentId?: number | null
      contentType?: string | null
      title?: string | null
      published?: boolean | null
      titleGroupId?: string | null
      imageContentRelationships?: Array<{
        __typename?: 'ImageContentRelationship'
        id?: string | null
        type?: string | null
        image?: { __typename?: 'Image'; id?: string | null; url?: string | null } | null
      } | null> | null
    } | null> | null
  } | null
}

export type CreateContentReferenceMutationVariables = Exact<{
  contentReference: ContentReferenceCreateInput
}>

export type CreateContentReferenceMutation = {
  __typename?: 'Mutation'
  contentReferenceCreate: {
    __typename?: 'ContentReferenceCreateResponse'
    contentReference?: {
      __typename?: 'ContentReference'
      id?: string | null
      fromContentContentId?: number | null
      fromContentContentType?: string | null
      toContentContentId?: number | null
      toContentContentType?: string | null
      contentReferenceTypesId?: string | null
    } | null
  }
}

export type CreateContentReferencesMutationVariables = Exact<{
  contentReferences: Array<ContentReferenceCreateInput> | ContentReferenceCreateInput
  deleteOmittedReferences?: InputMaybe<Scalars['Boolean']['input']>
}>

export type CreateContentReferencesMutation = {
  __typename?: 'Mutation'
  contentReferenceCreateMany: {
    __typename?: 'ContentReferenceCreateManyResponse'
    contentReferences?: Array<{
      __typename?: 'ContentReference'
      id?: string | null
      fromContentContentId?: number | null
      fromContentContentType?: string | null
      toContentContentId?: number | null
      toContentContentType?: string | null
      contentReferenceTypesId?: string | null
    } | null> | null
  }
}

export type DeleteContentReferenceMutationVariables = Exact<{
  contentReference: ContentReferenceDeleteInput
}>

export type DeleteContentReferenceMutation = {
  __typename?: 'Mutation'
  contentReferenceDelete: {
    __typename?: 'ContentReferenceDeleteResponse'
    contentReference?: {
      __typename?: 'ContentReference'
      id?: string | null
      fromContentContentId?: number | null
      fromContentContentType?: string | null
      toContentContentId?: number | null
      toContentContentType?: string | null
    } | null
  }
}

export type ContentListQueryVariables = Exact<{
  offset?: InputMaybe<Scalars['Int']['input']>
  limit?: InputMaybe<Scalars['Int']['input']>
  order?: InputMaybe<
    | Array<
        InputMaybe<
          Array<InputMaybe<Scalars['String']['input']>> | InputMaybe<Scalars['String']['input']>
        >
      >
    | InputMaybe<
        Array<InputMaybe<Scalars['String']['input']>> | InputMaybe<Scalars['String']['input']>
      >
  >
  where?: InputMaybe<ContentWhereInput>
  language?: InputMaybe<
    Array<InputMaybe<Scalars['String']['input']>> | InputMaybe<Scalars['String']['input']>
  >
}>

export type ContentListQuery = {
  __typename?: 'Query'
  contentList?: {
    __typename?: 'ContentListResponse'
    count?: number | null
    limit?: number | null
    offset?: number | null
    content?: Array<{
      __typename?: 'Content'
      titleGroupId?: string | null
      contentId?: number | null
      contentType?: string | null
      language?: string | null
      title?: string | null
    } | null> | null
  } | null
}

export type GetCourseContentQueryVariables = Exact<{
  id: Scalars['ID']['input']
}>

export type GetCourseContentQuery = {
  __typename?: 'Query'
  contentList?: {
    __typename?: 'ContentListResponse'
    content?: Array<{
      __typename?: 'Content'
      id?: string | null
      contentId?: number | null
      contentType?: string | null
      title?: string | null
      description?: string | null
      descriptionFormat?: string | null
      shortDescription?: string | null
      shortDescriptionFormat?: string | null
      thirdPartyDescription?: string | null
      path?: string | null
      language?: string | null
      primaryLanguage?: string | null
      published?: boolean | null
      publishedAtDate?: any | null
      productionStatus?: string | null
      contentSearchNoIndex?: boolean | null
      excludeFromRecommendations?: boolean | null
      createdAt?: any | null
      updatedAt?: any | null
      productType?: string | null
      displayType?: string | null
      seasonNumber?: number | null
      episodeNumber?: number | null
      director?: string | null
      producer?: string | null
      writer?: string | null
      studio?: string | null
      copyright?: string | null
      instructor?: string | null
      cast?: string | null
      previewMediaId?: string | null
      featureMediaId?: string | null
      contentReferencesTo?: Array<{
        __typename?: 'ContentReference'
        sortKey?: number | null
        contentFrom?: Array<{
          __typename?: 'Content'
          id?: string | null
          contentId?: number | null
          contentType?: string | null
          title?: string | null
          published?: boolean | null
          contentReferencesTo?: Array<{
            __typename?: 'ContentReference'
            sortKey?: number | null
            contentReferenceType?: {
              __typename?: 'ContentReferenceType'
              type?: string | null
            } | null
          } | null> | null
        } | null> | null
      } | null> | null
      contentReferencesFrom?: Array<{
        __typename?: 'ContentReference'
        id?: string | null
        contentReferenceType?: { __typename?: 'ContentReferenceType'; type?: string | null } | null
        contentTo?: Array<{
          __typename?: 'Content'
          id?: string | null
          contentId?: number | null
          contentType?: string | null
          title?: string | null
          published?: boolean | null
          titleGroupId?: string | null
        } | null> | null
      } | null> | null
    } | null> | null
  } | null
}

export type GetCourseModuleContentQueryVariables = Exact<{
  id: Scalars['ID']['input']
}>

export type GetCourseModuleContentQuery = {
  __typename?: 'Query'
  contentList?: {
    __typename?: 'ContentListResponse'
    content?: Array<{
      __typename?: 'Content'
      id?: string | null
      contentId?: number | null
      contentType?: string | null
      title?: string | null
      description?: string | null
      descriptionFormat?: string | null
      shortDescription?: string | null
      shortDescriptionFormat?: string | null
      thirdPartyDescription?: string | null
      path?: string | null
      language?: string | null
      primaryLanguage?: string | null
      published?: boolean | null
      publishedAtDate?: any | null
      productionStatus?: string | null
      contentSearchNoIndex?: boolean | null
      excludeFromRecommendations?: boolean | null
      createdAt?: any | null
      updatedAt?: any | null
      productType?: string | null
      displayType?: string | null
      seasonNumber?: number | null
      episodeNumber?: number | null
      director?: string | null
      producer?: string | null
      writer?: string | null
      studio?: string | null
      copyright?: string | null
      instructor?: string | null
      cast?: string | null
    } | null> | null
  } | null
}

export type GetCourseModuleContentReferencesQueryVariables = Exact<{
  id: Scalars['ID']['input']
  language: Array<InputMaybe<Scalars['String']['input']>> | InputMaybe<Scalars['String']['input']>
}>

export type GetCourseModuleContentReferencesQuery = {
  __typename?: 'Query'
  contentList?: {
    __typename?: 'ContentListResponse'
    content?: Array<{
      __typename?: 'Content'
      id?: string | null
      contentReferencesTo?: Array<{
        __typename?: 'ContentReference'
        id?: string | null
        sortKey?: number | null
        contentReferenceType?: { __typename?: 'ContentReferenceType'; type?: string | null } | null
        contentFrom?: Array<{
          __typename?: 'Content'
          id?: string | null
          contentId?: number | null
          contentType?: string | null
          title?: string | null
          published?: boolean | null
          imageContentRelationships?: Array<{
            __typename?: 'ImageContentRelationship'
            id?: string | null
            type?: string | null
            image?: { __typename?: 'Image'; id?: string | null; url?: string | null } | null
          } | null> | null
        } | null> | null
      } | null> | null
    } | null> | null
  } | null
}

export type GetParentCourseIdQueryVariables = Exact<{
  id: Scalars['ID']['input']
}>

export type GetParentCourseIdQuery = {
  __typename?: 'Query'
  contentList?: {
    __typename?: 'ContentListResponse'
    content?: Array<{
      __typename?: 'Content'
      id?: string | null
      contentReferencesFrom?: Array<{
        __typename?: 'ContentReference'
        id?: string | null
        contentTo?: Array<{
          __typename?: 'Content'
          id?: string | null
          contentId?: number | null
          contentType?: string | null
          title?: string | null
        } | null> | null
      } | null> | null
    } | null> | null
  } | null
}

export type GetSeriesWithLatestEpisodeAdminCategoryQueryVariables = Exact<{
  seriesContentId: Scalars['Int']['input']
}>

export type GetSeriesWithLatestEpisodeAdminCategoryQuery = {
  __typename?: 'Query'
  contentList?: {
    __typename?: 'ContentListResponse'
    content?: Array<{
      __typename?: 'Content'
      contentId?: number | null
      contentType?: string | null
      title?: string | null
      language?: string | null
      episodeNumber?: number | null
      seasonNumber?: number | null
      producer?: string | null
      writer?: string | null
      episodesCount?: number | null
      seasonsCount?: number | null
      director?: string | null
      instructor?: string | null
      studio?: string | null
      copyright?: string | null
      cast?: string | null
      productType?: string | null
      contentReferencesFrom?: Array<{
        __typename?: 'ContentReference'
        id?: string | null
        fromContentContentId?: number | null
        fromContentContentType?: string | null
        toContentContentId?: number | null
        toContentContentType?: string | null
        contentTo?: Array<{
          __typename?: 'Content'
          id?: string | null
          contentId?: number | null
          contentType?: string | null
          subType?: string | null
          bundle?: string | null
          title?: string | null
        } | null> | null
      } | null> | null
    } | null> | null
  } | null
}

export type GetProductReferencesQueryVariables = Exact<{
  productContentId: Scalars['Int']['input']
}>

export type GetProductReferencesQuery = {
  __typename?: 'Query'
  contentList?: {
    __typename?: 'ContentListResponse'
    content?: Array<{
      __typename?: 'Content'
      contentId?: number | null
      contentType?: string | null
      title?: string | null
      language?: string | null
      contentReferencesFrom?: Array<{
        __typename?: 'ContentReference'
        id?: string | null
        fromContentContentId?: number | null
        fromContentContentType?: string | null
        toContentContentId?: number | null
        toContentContentType?: string | null
        contentFrom?: Array<{
          __typename?: 'Content'
          id?: string | null
          contentId?: number | null
          contentType?: string | null
          title?: string | null
          language?: string | null
          published?: boolean | null
          path?: string | null
        } | null> | null
        contentTo?: Array<{
          __typename?: 'Content'
          id?: string | null
          contentId?: number | null
          contentType?: string | null
          title?: string | null
          language?: string | null
          published?: boolean | null
          path?: string | null
        } | null> | null
      } | null> | null
      contentReferencesTo?: Array<{
        __typename?: 'ContentReference'
        id?: string | null
        fromContentContentId?: number | null
        fromContentContentType?: string | null
        toContentContentId?: number | null
        toContentContentType?: string | null
        contentFrom?: Array<{
          __typename?: 'Content'
          id?: string | null
          contentId?: number | null
          contentType?: string | null
          title?: string | null
          language?: string | null
          published?: boolean | null
          path?: string | null
        } | null> | null
        contentTo?: Array<{
          __typename?: 'Content'
          id?: string | null
          contentId?: number | null
          contentType?: string | null
          title?: string | null
          language?: string | null
          published?: boolean | null
          path?: string | null
        } | null> | null
      } | null> | null
    } | null> | null
  } | null
}

export type UpdateCourseContentMutationVariables = Exact<{
  content: ContentInput
  generatePath?: InputMaybe<Scalars['Boolean']['input']>
}>

export type UpdateCourseContentMutation = {
  __typename?: 'Mutation'
  contentUpdate?: {
    __typename?: 'ContentUpdateResponse'
    content?: {
      __typename?: 'Content'
      id?: string | null
      contentId?: number | null
      contentType?: string | null
      title?: string | null
      description?: string | null
      descriptionFormat?: string | null
      shortDescription?: string | null
      shortDescriptionFormat?: string | null
      thirdPartyDescription?: string | null
      path?: string | null
      language?: string | null
      published?: boolean | null
      publishedAtDate?: any | null
      productionStatus?: string | null
      contentSearchNoIndex?: boolean | null
      excludeFromRecommendations?: boolean | null
      createdAt?: any | null
      updatedAt?: any | null
      productType?: string | null
      displayType?: string | null
      seasonNumber?: number | null
      episodeNumber?: number | null
      director?: string | null
      producer?: string | null
      writer?: string | null
      studio?: string | null
      copyright?: string | null
      instructor?: string | null
      cast?: string | null
      previewMediaId?: string | null
      featureMediaId?: string | null
    } | null
  } | null
}

export type GetContentReferenceTypesQueryVariables = Exact<{ [key: string]: never }>

export type GetContentReferenceTypesQuery = {
  __typename?: 'Query'
  contentReferenceTypesList?: {
    __typename?: 'ContentReferenceTypesListResponse'
    contentReferenceTypes?: Array<{
      __typename?: 'ContentReferenceType'
      id?: string | null
      type?: string | null
    } | null> | null
  } | null
}

export type UpdateContentReferencesSortOrderMutationVariables = Exact<{
  contentReferences: Array<ContentReferenceCreateInput> | ContentReferenceCreateInput
  deleteOmittedReferences?: InputMaybe<Scalars['Boolean']['input']>
}>

export type UpdateContentReferencesSortOrderMutation = {
  __typename?: 'Mutation'
  contentReferenceCreateMany: {
    __typename?: 'ContentReferenceCreateManyResponse'
    contentReferences?: Array<{
      __typename?: 'ContentReference'
      id?: string | null
      sortKey?: number | null
      fromContentContentId?: number | null
      fromContentContentType?: string | null
      toContentContentId?: number | null
      toContentContentType?: string | null
    } | null> | null
  }
}

export type GetContentTranslationsQueryVariables = Exact<{
  contentId: Scalars['Int']['input']
  contentType: Scalars['String']['input']
}>

export type GetContentTranslationsQuery = {
  __typename?: 'Query'
  contentList?: {
    __typename?: 'ContentListResponse'
    content?: Array<{
      __typename?: 'Content'
      id?: string | null
      contentId?: number | null
      contentType?: string | null
      language?: string | null
      primaryLanguage?: string | null
      title?: string | null
      published?: boolean | null
    } | null> | null
  } | null
}

export type YiContentTypeTagQueryQueryVariables = Exact<{
  title: Scalars['String']['input']
  contentPolicyPolicyId: Scalars['Int']['input']
}>

export type YiContentTypeTagQueryQuery = {
  __typename?: 'Query'
  contentList?: {
    __typename?: 'ContentListResponse'
    content?: Array<{
      __typename?: 'Content'
      id?: string | null
      contentId?: number | null
      contentType?: string | null
    } | null> | null
  } | null
}

export type GaiaVideo_ContentFragmentFragment = {
  __typename?: 'Content'
  episodeNumber?: number | null
  seasonNumber?: number | null
  director?: string | null
  producer?: string | null
  writer?: string | null
  studio?: string | null
  copyright?: string | null
  instructor?: string | null
  cast?: string | null
  productType?: string | null
  displayType?: string | null
  seoTitle?: string | null
  seoDescription?: string | null
  seoKeywords?: string | null
  seoRobotsNoFollow?: boolean | null
  seoRobotsNoIndex?: boolean | null
  excludeFromRecommendations?: boolean | null
  contentSearchNoIndex?: boolean | null
  adminCategory?: Array<{
    __typename?: 'ContentReference'
    id?: string | null
    sortKey?: number | null
    contentReferenceType?: { __typename?: 'ContentReferenceType'; type?: string | null } | null
    contentTo?: Array<{
      __typename?: 'Content'
      id?: string | null
      titleGroupId?: string | null
      title?: string | null
      contentId?: number | null
      contentType?: string | null
      published?: boolean | null
    } | null> | null
  } | null> | null
  category?: Array<{
    __typename?: 'ContentReference'
    id?: string | null
    sortKey?: number | null
    contentReferenceType?: { __typename?: 'ContentReferenceType'; type?: string | null } | null
    contentTo?: Array<{
      __typename?: 'Content'
      id?: string | null
      titleGroupId?: string | null
      title?: string | null
      contentId?: number | null
      contentType?: string | null
      published?: boolean | null
    } | null> | null
  } | null> | null
  centers?: Array<{
    __typename?: 'ContentReference'
    id?: string | null
    sortKey?: number | null
    contentReferenceType?: { __typename?: 'ContentReferenceType'; type?: string | null } | null
    contentTo?: Array<{
      __typename?: 'Content'
      id?: string | null
      titleGroupId?: string | null
      title?: string | null
      contentId?: number | null
      contentType?: string | null
      published?: boolean | null
    } | null> | null
  } | null> | null
  contentOrigin?: Array<{
    __typename?: 'ContentReference'
    id?: string | null
    sortKey?: number | null
    contentReferenceType?: { __typename?: 'ContentReferenceType'; type?: string | null } | null
    contentTo?: Array<{
      __typename?: 'Content'
      id?: string | null
      titleGroupId?: string | null
      title?: string | null
      contentId?: number | null
      contentType?: string | null
      published?: boolean | null
    } | null> | null
  } | null> | null
  consciousFormat?: Array<{
    __typename?: 'ContentReference'
    id?: string | null
    sortKey?: number | null
    contentReferenceType?: { __typename?: 'ContentReferenceType'; type?: string | null } | null
    contentTo?: Array<{
      __typename?: 'Content'
      id?: string | null
      titleGroupId?: string | null
      title?: string | null
      contentId?: number | null
      contentType?: string | null
      published?: boolean | null
    } | null> | null
  } | null> | null
  consciousTopic?: Array<{
    __typename?: 'ContentReference'
    id?: string | null
    sortKey?: number | null
    contentReferenceType?: { __typename?: 'ContentReferenceType'; type?: string | null } | null
    contentTo?: Array<{
      __typename?: 'Content'
      id?: string | null
      titleGroupId?: string | null
      title?: string | null
      contentId?: number | null
      contentType?: string | null
      published?: boolean | null
    } | null> | null
  } | null> | null
  filmSubject?: Array<{
    __typename?: 'ContentReference'
    id?: string | null
    sortKey?: number | null
    contentReferenceType?: { __typename?: 'ContentReferenceType'; type?: string | null } | null
    contentTo?: Array<{
      __typename?: 'Content'
      id?: string | null
      titleGroupId?: string | null
      title?: string | null
      contentId?: number | null
      contentType?: string | null
      published?: boolean | null
    } | null> | null
  } | null> | null
  filmType?: Array<{
    __typename?: 'ContentReference'
    id?: string | null
    sortKey?: number | null
    contentReferenceType?: { __typename?: 'ContentReferenceType'; type?: string | null } | null
    contentTo?: Array<{
      __typename?: 'Content'
      id?: string | null
      titleGroupId?: string | null
      title?: string | null
      contentId?: number | null
      contentType?: string | null
      published?: boolean | null
    } | null> | null
  } | null> | null
  fitnessDuration?: Array<{
    __typename?: 'ContentReference'
    id?: string | null
    sortKey?: number | null
    contentReferenceType?: { __typename?: 'ContentReferenceType'; type?: string | null } | null
    contentTo?: Array<{
      __typename?: 'Content'
      id?: string | null
      titleGroupId?: string | null
      title?: string | null
      contentId?: number | null
      contentType?: string | null
      published?: boolean | null
    } | null> | null
  } | null> | null
  fitnessLevel?: Array<{
    __typename?: 'ContentReference'
    id?: string | null
    sortKey?: number | null
    contentReferenceType?: { __typename?: 'ContentReferenceType'; type?: string | null } | null
    contentTo?: Array<{
      __typename?: 'Content'
      id?: string | null
      titleGroupId?: string | null
      title?: string | null
      contentId?: number | null
      contentType?: string | null
      published?: boolean | null
    } | null> | null
  } | null> | null
  fitnessInstructor?: Array<{
    __typename?: 'ContentReference'
    id?: string | null
    sortKey?: number | null
    contentReferenceType?: { __typename?: 'ContentReferenceType'; type?: string | null } | null
    contentTo?: Array<{
      __typename?: 'Content'
      id?: string | null
      titleGroupId?: string | null
      title?: string | null
      contentId?: number | null
      contentType?: string | null
      published?: boolean | null
    } | null> | null
  } | null> | null
  fitnessSpecialty?: Array<{
    __typename?: 'ContentReference'
    id?: string | null
    sortKey?: number | null
    contentReferenceType?: { __typename?: 'ContentReferenceType'; type?: string | null } | null
    contentTo?: Array<{
      __typename?: 'Content'
      id?: string | null
      titleGroupId?: string | null
      title?: string | null
      contentId?: number | null
      contentType?: string | null
      published?: boolean | null
    } | null> | null
  } | null> | null
  fitnessStyle?: Array<{
    __typename?: 'ContentReference'
    id?: string | null
    sortKey?: number | null
    contentReferenceType?: { __typename?: 'ContentReferenceType'; type?: string | null } | null
    contentTo?: Array<{
      __typename?: 'Content'
      id?: string | null
      titleGroupId?: string | null
      title?: string | null
      contentId?: number | null
      contentType?: string | null
      published?: boolean | null
    } | null> | null
  } | null> | null
  genres?: Array<{
    __typename?: 'ContentReference'
    id?: string | null
    sortKey?: number | null
    contentReferenceType?: { __typename?: 'ContentReferenceType'; type?: string | null } | null
    contentTo?: Array<{
      __typename?: 'Content'
      id?: string | null
      titleGroupId?: string | null
      title?: string | null
      contentId?: number | null
      contentType?: string | null
      published?: boolean | null
    } | null> | null
  } | null> | null
  interviewGuest?: Array<{
    __typename?: 'ContentReference'
    id?: string | null
    sortKey?: number | null
    contentReferenceType?: { __typename?: 'ContentReferenceType'; type?: string | null } | null
    contentTo?: Array<{
      __typename?: 'Content'
      id?: string | null
      titleGroupId?: string | null
      title?: string | null
      contentId?: number | null
      contentType?: string | null
      published?: boolean | null
    } | null> | null
  } | null> | null
  interviewHost?: Array<{
    __typename?: 'ContentReference'
    id?: string | null
    sortKey?: number | null
    contentReferenceType?: { __typename?: 'ContentReferenceType'; type?: string | null } | null
    contentTo?: Array<{
      __typename?: 'Content'
      id?: string | null
      titleGroupId?: string | null
      title?: string | null
      contentId?: number | null
      contentType?: string | null
      published?: boolean | null
    } | null> | null
  } | null> | null
  marketingCenters?: Array<{
    __typename?: 'ContentReference'
    id?: string | null
    sortKey?: number | null
    contentReferenceType?: { __typename?: 'ContentReferenceType'; type?: string | null } | null
    contentTo?: Array<{
      __typename?: 'Content'
      id?: string | null
      titleGroupId?: string | null
      title?: string | null
      contentId?: number | null
      contentType?: string | null
      published?: boolean | null
    } | null> | null
  } | null> | null
  meditationFocus?: Array<{
    __typename?: 'ContentReference'
    id?: string | null
    sortKey?: number | null
    contentReferenceType?: { __typename?: 'ContentReferenceType'; type?: string | null } | null
    contentTo?: Array<{
      __typename?: 'Content'
      id?: string | null
      titleGroupId?: string | null
      title?: string | null
      contentId?: number | null
      contentType?: string | null
      published?: boolean | null
    } | null> | null
  } | null> | null
  meditationStyle?: Array<{
    __typename?: 'ContentReference'
    id?: string | null
    sortKey?: number | null
    contentReferenceType?: { __typename?: 'ContentReferenceType'; type?: string | null } | null
    contentTo?: Array<{
      __typename?: 'Content'
      id?: string | null
      titleGroupId?: string | null
      title?: string | null
      contentId?: number | null
      contentType?: string | null
      published?: boolean | null
    } | null> | null
  } | null> | null
  meditationTeacher?: Array<{
    __typename?: 'ContentReference'
    id?: string | null
    sortKey?: number | null
    contentReferenceType?: { __typename?: 'ContentReferenceType'; type?: string | null } | null
    contentTo?: Array<{
      __typename?: 'Content'
      id?: string | null
      titleGroupId?: string | null
      title?: string | null
      contentId?: number | null
      contentType?: string | null
      published?: boolean | null
    } | null> | null
  } | null> | null
  meditationDuration?: Array<{
    __typename?: 'ContentReference'
    id?: string | null
    sortKey?: number | null
    contentReferenceType?: { __typename?: 'ContentReferenceType'; type?: string | null } | null
    contentTo?: Array<{
      __typename?: 'Content'
      id?: string | null
      titleGroupId?: string | null
      title?: string | null
      contentId?: number | null
      contentType?: string | null
      published?: boolean | null
    } | null> | null
  } | null> | null
  onboardingChoices?: Array<{
    __typename?: 'ContentReference'
    id?: string | null
    sortKey?: number | null
    contentReferenceType?: { __typename?: 'ContentReferenceType'; type?: string | null } | null
    contentTo?: Array<{
      __typename?: 'Content'
      id?: string | null
      titleGroupId?: string | null
      title?: string | null
      contentId?: number | null
      contentType?: string | null
      published?: boolean | null
    } | null> | null
  } | null> | null
  product?: Array<{
    __typename?: 'ContentReference'
    id?: string | null
    sortKey?: number | null
    contentReferenceType?: { __typename?: 'ContentReferenceType'; type?: string | null } | null
    contentTo?: Array<{
      __typename?: 'Content'
      id?: string | null
      titleGroupId?: string | null
      title?: string | null
      contentId?: number | null
      contentType?: string | null
      published?: boolean | null
    } | null> | null
  } | null> | null
  rainbowCategory?: Array<{
    __typename?: 'ContentReference'
    id?: string | null
    sortKey?: number | null
    contentReferenceType?: { __typename?: 'ContentReferenceType'; type?: string | null } | null
    contentTo?: Array<{
      __typename?: 'Content'
      id?: string | null
      titleGroupId?: string | null
      title?: string | null
      contentId?: number | null
      contentType?: string | null
      published?: boolean | null
    } | null> | null
  } | null> | null
  recipeDiet?: Array<{
    __typename?: 'ContentReference'
    id?: string | null
    sortKey?: number | null
    contentReferenceType?: { __typename?: 'ContentReferenceType'; type?: string | null } | null
    contentTo?: Array<{
      __typename?: 'Content'
      id?: string | null
      titleGroupId?: string | null
      title?: string | null
      contentId?: number | null
      contentType?: string | null
      published?: boolean | null
    } | null> | null
  } | null> | null
  recipeType?: Array<{
    __typename?: 'ContentReference'
    id?: string | null
    sortKey?: number | null
    contentReferenceType?: { __typename?: 'ContentReferenceType'; type?: string | null } | null
    contentTo?: Array<{
      __typename?: 'Content'
      id?: string | null
      titleGroupId?: string | null
      title?: string | null
      contentId?: number | null
      contentType?: string | null
      published?: boolean | null
    } | null> | null
  } | null> | null
  series?: Array<{
    __typename?: 'ContentReference'
    id?: string | null
    sortKey?: number | null
    contentReferenceType?: { __typename?: 'ContentReferenceType'; type?: string | null } | null
    contentTo?: Array<{
      __typename?: 'Content'
      id?: string | null
      titleGroupId?: string | null
      title?: string | null
      contentId?: number | null
      contentType?: string | null
      published?: boolean | null
    } | null> | null
  } | null> | null
  similarVideos?: Array<{
    __typename?: 'ContentReference'
    id?: string | null
    sortKey?: number | null
    contentReferenceType?: { __typename?: 'ContentReferenceType'; type?: string | null } | null
    contentTo?: Array<{
      __typename?: 'Content'
      id?: string | null
      titleGroupId?: string | null
      title?: string | null
      contentId?: number | null
      contentType?: string | null
      published?: boolean | null
    } | null> | null
  } | null> | null
  thirdPartyGenre?: Array<{
    __typename?: 'ContentReference'
    id?: string | null
    sortKey?: number | null
    contentReferenceType?: { __typename?: 'ContentReferenceType'; type?: string | null } | null
    contentTo?: Array<{
      __typename?: 'Content'
      id?: string | null
      titleGroupId?: string | null
      title?: string | null
      contentId?: number | null
      contentType?: string | null
      published?: boolean | null
    } | null> | null
  } | null> | null
  videoCollection?: Array<{
    __typename?: 'ContentReference'
    id?: string | null
    sortKey?: number | null
    contentReferenceType?: { __typename?: 'ContentReferenceType'; type?: string | null } | null
    contentTo?: Array<{
      __typename?: 'Content'
      id?: string | null
      titleGroupId?: string | null
      title?: string | null
      contentId?: number | null
      contentType?: string | null
      published?: boolean | null
    } | null> | null
  } | null> | null
  videoTopic?: Array<{
    __typename?: 'ContentReference'
    id?: string | null
    sortKey?: number | null
    contentReferenceType?: { __typename?: 'ContentReferenceType'; type?: string | null } | null
    contentTo?: Array<{
      __typename?: 'Content'
      id?: string | null
      titleGroupId?: string | null
      title?: string | null
      contentId?: number | null
      contentType?: string | null
      published?: boolean | null
    } | null> | null
  } | null> | null
  yogaDuration?: Array<{
    __typename?: 'ContentReference'
    id?: string | null
    sortKey?: number | null
    contentReferenceType?: { __typename?: 'ContentReferenceType'; type?: string | null } | null
    contentTo?: Array<{
      __typename?: 'Content'
      id?: string | null
      titleGroupId?: string | null
      title?: string | null
      contentId?: number | null
      contentType?: string | null
      published?: boolean | null
    } | null> | null
  } | null> | null
  yogaFocus?: Array<{
    __typename?: 'ContentReference'
    id?: string | null
    sortKey?: number | null
    contentReferenceType?: { __typename?: 'ContentReferenceType'; type?: string | null } | null
    contentTo?: Array<{
      __typename?: 'Content'
      id?: string | null
      titleGroupId?: string | null
      title?: string | null
      contentId?: number | null
      contentType?: string | null
      published?: boolean | null
    } | null> | null
  } | null> | null
  yogaLevel?: Array<{
    __typename?: 'ContentReference'
    id?: string | null
    sortKey?: number | null
    contentReferenceType?: { __typename?: 'ContentReferenceType'; type?: string | null } | null
    contentTo?: Array<{
      __typename?: 'Content'
      id?: string | null
      titleGroupId?: string | null
      title?: string | null
      contentId?: number | null
      contentType?: string | null
      published?: boolean | null
    } | null> | null
  } | null> | null
  yogaStyle?: Array<{
    __typename?: 'ContentReference'
    id?: string | null
    sortKey?: number | null
    contentReferenceType?: { __typename?: 'ContentReferenceType'; type?: string | null } | null
    contentTo?: Array<{
      __typename?: 'Content'
      id?: string | null
      titleGroupId?: string | null
      title?: string | null
      contentId?: number | null
      contentType?: string | null
      published?: boolean | null
    } | null> | null
  } | null> | null
  yogaTeacher?: Array<{
    __typename?: 'ContentReference'
    id?: string | null
    sortKey?: number | null
    contentReferenceType?: { __typename?: 'ContentReferenceType'; type?: string | null } | null
    contentTo?: Array<{
      __typename?: 'Content'
      id?: string | null
      titleGroupId?: string | null
      title?: string | null
      contentId?: number | null
      contentType?: string | null
      published?: boolean | null
    } | null> | null
  } | null> | null
}

export type Mutation_GaiaVideo_ContentUpdateMutationVariables = Exact<{
  content: ContentInput
  generatePath?: InputMaybe<Scalars['Boolean']['input']>
}>

export type Mutation_GaiaVideo_ContentUpdateMutation = {
  __typename?: 'Mutation'
  contentUpdate?: {
    __typename?: 'ContentUpdateResponse'
    content?: {
      __typename?: 'Content'
      id?: string | null
      contentId?: number | null
      contentType?: string | null
      published?: boolean | null
      publishedAtDate?: any | null
      createdAt?: any | null
      updatedAt?: any | null
      title?: string | null
      path?: string | null
      shortDescription?: string | null
      description?: string | null
      language?: string | null
      contentPolicyPolicyId?: number | null
      episodeNumber?: number | null
      seasonNumber?: number | null
      director?: string | null
      producer?: string | null
      writer?: string | null
      studio?: string | null
      copyright?: string | null
      instructor?: string | null
      cast?: string | null
      productType?: string | null
      displayType?: string | null
      seoTitle?: string | null
      seoDescription?: string | null
      seoKeywords?: string | null
      seoRobotsNoFollow?: boolean | null
      seoRobotsNoIndex?: boolean | null
      excludeFromRecommendations?: boolean | null
      contentSearchNoIndex?: boolean | null
      adminCategory?: Array<{
        __typename?: 'ContentReference'
        id?: string | null
        sortKey?: number | null
        contentReferenceType?: { __typename?: 'ContentReferenceType'; type?: string | null } | null
        contentTo?: Array<{
          __typename?: 'Content'
          id?: string | null
          titleGroupId?: string | null
          title?: string | null
          contentId?: number | null
          contentType?: string | null
          published?: boolean | null
        } | null> | null
      } | null> | null
      category?: Array<{
        __typename?: 'ContentReference'
        id?: string | null
        sortKey?: number | null
        contentReferenceType?: { __typename?: 'ContentReferenceType'; type?: string | null } | null
        contentTo?: Array<{
          __typename?: 'Content'
          id?: string | null
          titleGroupId?: string | null
          title?: string | null
          contentId?: number | null
          contentType?: string | null
          published?: boolean | null
        } | null> | null
      } | null> | null
      centers?: Array<{
        __typename?: 'ContentReference'
        id?: string | null
        sortKey?: number | null
        contentReferenceType?: { __typename?: 'ContentReferenceType'; type?: string | null } | null
        contentTo?: Array<{
          __typename?: 'Content'
          id?: string | null
          titleGroupId?: string | null
          title?: string | null
          contentId?: number | null
          contentType?: string | null
          published?: boolean | null
        } | null> | null
      } | null> | null
      contentOrigin?: Array<{
        __typename?: 'ContentReference'
        id?: string | null
        sortKey?: number | null
        contentReferenceType?: { __typename?: 'ContentReferenceType'; type?: string | null } | null
        contentTo?: Array<{
          __typename?: 'Content'
          id?: string | null
          titleGroupId?: string | null
          title?: string | null
          contentId?: number | null
          contentType?: string | null
          published?: boolean | null
        } | null> | null
      } | null> | null
      consciousFormat?: Array<{
        __typename?: 'ContentReference'
        id?: string | null
        sortKey?: number | null
        contentReferenceType?: { __typename?: 'ContentReferenceType'; type?: string | null } | null
        contentTo?: Array<{
          __typename?: 'Content'
          id?: string | null
          titleGroupId?: string | null
          title?: string | null
          contentId?: number | null
          contentType?: string | null
          published?: boolean | null
        } | null> | null
      } | null> | null
      consciousTopic?: Array<{
        __typename?: 'ContentReference'
        id?: string | null
        sortKey?: number | null
        contentReferenceType?: { __typename?: 'ContentReferenceType'; type?: string | null } | null
        contentTo?: Array<{
          __typename?: 'Content'
          id?: string | null
          titleGroupId?: string | null
          title?: string | null
          contentId?: number | null
          contentType?: string | null
          published?: boolean | null
        } | null> | null
      } | null> | null
      filmSubject?: Array<{
        __typename?: 'ContentReference'
        id?: string | null
        sortKey?: number | null
        contentReferenceType?: { __typename?: 'ContentReferenceType'; type?: string | null } | null
        contentTo?: Array<{
          __typename?: 'Content'
          id?: string | null
          titleGroupId?: string | null
          title?: string | null
          contentId?: number | null
          contentType?: string | null
          published?: boolean | null
        } | null> | null
      } | null> | null
      filmType?: Array<{
        __typename?: 'ContentReference'
        id?: string | null
        sortKey?: number | null
        contentReferenceType?: { __typename?: 'ContentReferenceType'; type?: string | null } | null
        contentTo?: Array<{
          __typename?: 'Content'
          id?: string | null
          titleGroupId?: string | null
          title?: string | null
          contentId?: number | null
          contentType?: string | null
          published?: boolean | null
        } | null> | null
      } | null> | null
      fitnessDuration?: Array<{
        __typename?: 'ContentReference'
        id?: string | null
        sortKey?: number | null
        contentReferenceType?: { __typename?: 'ContentReferenceType'; type?: string | null } | null
        contentTo?: Array<{
          __typename?: 'Content'
          id?: string | null
          titleGroupId?: string | null
          title?: string | null
          contentId?: number | null
          contentType?: string | null
          published?: boolean | null
        } | null> | null
      } | null> | null
      fitnessLevel?: Array<{
        __typename?: 'ContentReference'
        id?: string | null
        sortKey?: number | null
        contentReferenceType?: { __typename?: 'ContentReferenceType'; type?: string | null } | null
        contentTo?: Array<{
          __typename?: 'Content'
          id?: string | null
          titleGroupId?: string | null
          title?: string | null
          contentId?: number | null
          contentType?: string | null
          published?: boolean | null
        } | null> | null
      } | null> | null
      fitnessInstructor?: Array<{
        __typename?: 'ContentReference'
        id?: string | null
        sortKey?: number | null
        contentReferenceType?: { __typename?: 'ContentReferenceType'; type?: string | null } | null
        contentTo?: Array<{
          __typename?: 'Content'
          id?: string | null
          titleGroupId?: string | null
          title?: string | null
          contentId?: number | null
          contentType?: string | null
          published?: boolean | null
        } | null> | null
      } | null> | null
      fitnessSpecialty?: Array<{
        __typename?: 'ContentReference'
        id?: string | null
        sortKey?: number | null
        contentReferenceType?: { __typename?: 'ContentReferenceType'; type?: string | null } | null
        contentTo?: Array<{
          __typename?: 'Content'
          id?: string | null
          titleGroupId?: string | null
          title?: string | null
          contentId?: number | null
          contentType?: string | null
          published?: boolean | null
        } | null> | null
      } | null> | null
      fitnessStyle?: Array<{
        __typename?: 'ContentReference'
        id?: string | null
        sortKey?: number | null
        contentReferenceType?: { __typename?: 'ContentReferenceType'; type?: string | null } | null
        contentTo?: Array<{
          __typename?: 'Content'
          id?: string | null
          titleGroupId?: string | null
          title?: string | null
          contentId?: number | null
          contentType?: string | null
          published?: boolean | null
        } | null> | null
      } | null> | null
      genres?: Array<{
        __typename?: 'ContentReference'
        id?: string | null
        sortKey?: number | null
        contentReferenceType?: { __typename?: 'ContentReferenceType'; type?: string | null } | null
        contentTo?: Array<{
          __typename?: 'Content'
          id?: string | null
          titleGroupId?: string | null
          title?: string | null
          contentId?: number | null
          contentType?: string | null
          published?: boolean | null
        } | null> | null
      } | null> | null
      interviewGuest?: Array<{
        __typename?: 'ContentReference'
        id?: string | null
        sortKey?: number | null
        contentReferenceType?: { __typename?: 'ContentReferenceType'; type?: string | null } | null
        contentTo?: Array<{
          __typename?: 'Content'
          id?: string | null
          titleGroupId?: string | null
          title?: string | null
          contentId?: number | null
          contentType?: string | null
          published?: boolean | null
        } | null> | null
      } | null> | null
      interviewHost?: Array<{
        __typename?: 'ContentReference'
        id?: string | null
        sortKey?: number | null
        contentReferenceType?: { __typename?: 'ContentReferenceType'; type?: string | null } | null
        contentTo?: Array<{
          __typename?: 'Content'
          id?: string | null
          titleGroupId?: string | null
          title?: string | null
          contentId?: number | null
          contentType?: string | null
          published?: boolean | null
        } | null> | null
      } | null> | null
      marketingCenters?: Array<{
        __typename?: 'ContentReference'
        id?: string | null
        sortKey?: number | null
        contentReferenceType?: { __typename?: 'ContentReferenceType'; type?: string | null } | null
        contentTo?: Array<{
          __typename?: 'Content'
          id?: string | null
          titleGroupId?: string | null
          title?: string | null
          contentId?: number | null
          contentType?: string | null
          published?: boolean | null
        } | null> | null
      } | null> | null
      meditationFocus?: Array<{
        __typename?: 'ContentReference'
        id?: string | null
        sortKey?: number | null
        contentReferenceType?: { __typename?: 'ContentReferenceType'; type?: string | null } | null
        contentTo?: Array<{
          __typename?: 'Content'
          id?: string | null
          titleGroupId?: string | null
          title?: string | null
          contentId?: number | null
          contentType?: string | null
          published?: boolean | null
        } | null> | null
      } | null> | null
      meditationStyle?: Array<{
        __typename?: 'ContentReference'
        id?: string | null
        sortKey?: number | null
        contentReferenceType?: { __typename?: 'ContentReferenceType'; type?: string | null } | null
        contentTo?: Array<{
          __typename?: 'Content'
          id?: string | null
          titleGroupId?: string | null
          title?: string | null
          contentId?: number | null
          contentType?: string | null
          published?: boolean | null
        } | null> | null
      } | null> | null
      meditationTeacher?: Array<{
        __typename?: 'ContentReference'
        id?: string | null
        sortKey?: number | null
        contentReferenceType?: { __typename?: 'ContentReferenceType'; type?: string | null } | null
        contentTo?: Array<{
          __typename?: 'Content'
          id?: string | null
          titleGroupId?: string | null
          title?: string | null
          contentId?: number | null
          contentType?: string | null
          published?: boolean | null
        } | null> | null
      } | null> | null
      meditationDuration?: Array<{
        __typename?: 'ContentReference'
        id?: string | null
        sortKey?: number | null
        contentReferenceType?: { __typename?: 'ContentReferenceType'; type?: string | null } | null
        contentTo?: Array<{
          __typename?: 'Content'
          id?: string | null
          titleGroupId?: string | null
          title?: string | null
          contentId?: number | null
          contentType?: string | null
          published?: boolean | null
        } | null> | null
      } | null> | null
      onboardingChoices?: Array<{
        __typename?: 'ContentReference'
        id?: string | null
        sortKey?: number | null
        contentReferenceType?: { __typename?: 'ContentReferenceType'; type?: string | null } | null
        contentTo?: Array<{
          __typename?: 'Content'
          id?: string | null
          titleGroupId?: string | null
          title?: string | null
          contentId?: number | null
          contentType?: string | null
          published?: boolean | null
        } | null> | null
      } | null> | null
      product?: Array<{
        __typename?: 'ContentReference'
        id?: string | null
        sortKey?: number | null
        contentReferenceType?: { __typename?: 'ContentReferenceType'; type?: string | null } | null
        contentTo?: Array<{
          __typename?: 'Content'
          id?: string | null
          titleGroupId?: string | null
          title?: string | null
          contentId?: number | null
          contentType?: string | null
          published?: boolean | null
        } | null> | null
      } | null> | null
      rainbowCategory?: Array<{
        __typename?: 'ContentReference'
        id?: string | null
        sortKey?: number | null
        contentReferenceType?: { __typename?: 'ContentReferenceType'; type?: string | null } | null
        contentTo?: Array<{
          __typename?: 'Content'
          id?: string | null
          titleGroupId?: string | null
          title?: string | null
          contentId?: number | null
          contentType?: string | null
          published?: boolean | null
        } | null> | null
      } | null> | null
      recipeDiet?: Array<{
        __typename?: 'ContentReference'
        id?: string | null
        sortKey?: number | null
        contentReferenceType?: { __typename?: 'ContentReferenceType'; type?: string | null } | null
        contentTo?: Array<{
          __typename?: 'Content'
          id?: string | null
          titleGroupId?: string | null
          title?: string | null
          contentId?: number | null
          contentType?: string | null
          published?: boolean | null
        } | null> | null
      } | null> | null
      recipeType?: Array<{
        __typename?: 'ContentReference'
        id?: string | null
        sortKey?: number | null
        contentReferenceType?: { __typename?: 'ContentReferenceType'; type?: string | null } | null
        contentTo?: Array<{
          __typename?: 'Content'
          id?: string | null
          titleGroupId?: string | null
          title?: string | null
          contentId?: number | null
          contentType?: string | null
          published?: boolean | null
        } | null> | null
      } | null> | null
      series?: Array<{
        __typename?: 'ContentReference'
        id?: string | null
        sortKey?: number | null
        contentReferenceType?: { __typename?: 'ContentReferenceType'; type?: string | null } | null
        contentTo?: Array<{
          __typename?: 'Content'
          id?: string | null
          titleGroupId?: string | null
          title?: string | null
          contentId?: number | null
          contentType?: string | null
          published?: boolean | null
        } | null> | null
      } | null> | null
      similarVideos?: Array<{
        __typename?: 'ContentReference'
        id?: string | null
        sortKey?: number | null
        contentReferenceType?: { __typename?: 'ContentReferenceType'; type?: string | null } | null
        contentTo?: Array<{
          __typename?: 'Content'
          id?: string | null
          titleGroupId?: string | null
          title?: string | null
          contentId?: number | null
          contentType?: string | null
          published?: boolean | null
        } | null> | null
      } | null> | null
      thirdPartyGenre?: Array<{
        __typename?: 'ContentReference'
        id?: string | null
        sortKey?: number | null
        contentReferenceType?: { __typename?: 'ContentReferenceType'; type?: string | null } | null
        contentTo?: Array<{
          __typename?: 'Content'
          id?: string | null
          titleGroupId?: string | null
          title?: string | null
          contentId?: number | null
          contentType?: string | null
          published?: boolean | null
        } | null> | null
      } | null> | null
      videoCollection?: Array<{
        __typename?: 'ContentReference'
        id?: string | null
        sortKey?: number | null
        contentReferenceType?: { __typename?: 'ContentReferenceType'; type?: string | null } | null
        contentTo?: Array<{
          __typename?: 'Content'
          id?: string | null
          titleGroupId?: string | null
          title?: string | null
          contentId?: number | null
          contentType?: string | null
          published?: boolean | null
        } | null> | null
      } | null> | null
      videoTopic?: Array<{
        __typename?: 'ContentReference'
        id?: string | null
        sortKey?: number | null
        contentReferenceType?: { __typename?: 'ContentReferenceType'; type?: string | null } | null
        contentTo?: Array<{
          __typename?: 'Content'
          id?: string | null
          titleGroupId?: string | null
          title?: string | null
          contentId?: number | null
          contentType?: string | null
          published?: boolean | null
        } | null> | null
      } | null> | null
      yogaDuration?: Array<{
        __typename?: 'ContentReference'
        id?: string | null
        sortKey?: number | null
        contentReferenceType?: { __typename?: 'ContentReferenceType'; type?: string | null } | null
        contentTo?: Array<{
          __typename?: 'Content'
          id?: string | null
          titleGroupId?: string | null
          title?: string | null
          contentId?: number | null
          contentType?: string | null
          published?: boolean | null
        } | null> | null
      } | null> | null
      yogaFocus?: Array<{
        __typename?: 'ContentReference'
        id?: string | null
        sortKey?: number | null
        contentReferenceType?: { __typename?: 'ContentReferenceType'; type?: string | null } | null
        contentTo?: Array<{
          __typename?: 'Content'
          id?: string | null
          titleGroupId?: string | null
          title?: string | null
          contentId?: number | null
          contentType?: string | null
          published?: boolean | null
        } | null> | null
      } | null> | null
      yogaLevel?: Array<{
        __typename?: 'ContentReference'
        id?: string | null
        sortKey?: number | null
        contentReferenceType?: { __typename?: 'ContentReferenceType'; type?: string | null } | null
        contentTo?: Array<{
          __typename?: 'Content'
          id?: string | null
          titleGroupId?: string | null
          title?: string | null
          contentId?: number | null
          contentType?: string | null
          published?: boolean | null
        } | null> | null
      } | null> | null
      yogaStyle?: Array<{
        __typename?: 'ContentReference'
        id?: string | null
        sortKey?: number | null
        contentReferenceType?: { __typename?: 'ContentReferenceType'; type?: string | null } | null
        contentTo?: Array<{
          __typename?: 'Content'
          id?: string | null
          titleGroupId?: string | null
          title?: string | null
          contentId?: number | null
          contentType?: string | null
          published?: boolean | null
        } | null> | null
      } | null> | null
      yogaTeacher?: Array<{
        __typename?: 'ContentReference'
        id?: string | null
        sortKey?: number | null
        contentReferenceType?: { __typename?: 'ContentReferenceType'; type?: string | null } | null
        contentTo?: Array<{
          __typename?: 'Content'
          id?: string | null
          titleGroupId?: string | null
          title?: string | null
          contentId?: number | null
          contentType?: string | null
          published?: boolean | null
        } | null> | null
      } | null> | null
      contentProvider?: {
        __typename?: 'ContentProvider'
        provider?: ContentProviderProviders | null
        providerKey?: string | null
        contentId?: string | null
      } | null
    } | null
  } | null
}

export type YiArticle_ContentFragmentFragment = {
  __typename?: 'Content'
  contentPolicyPolicyId?: number | null
  id?: string | null
  contentId?: number | null
  contentType?: string | null
  language?: string | null
  description?: string | null
  descriptionFormat?: string | null
  shortDescription?: string | null
  shortDescriptionFormat?: string | null
  path?: string | null
  primaryLanguage?: string | null
  published?: boolean | null
  publishedAtDate?: any | null
  seoDescription?: string | null
  seoTitle?: string | null
  title?: string | null
  featureMediaId?: string | null
  yiContentType?: Array<{
    __typename?: 'ContentReference'
    id?: string | null
    sortKey?: number | null
    contentReferenceType?: { __typename?: 'ContentReferenceType'; type?: string | null } | null
    contentTo?: Array<{
      __typename?: 'Content'
      id?: string | null
      titleGroupId?: string | null
      title?: string | null
      contentId?: number | null
      contentType?: string | null
      published?: boolean | null
    } | null> | null
  } | null> | null
  yiYogaTeacher?: Array<{
    __typename?: 'ContentReference'
    id?: string | null
    sortKey?: number | null
    contentReferenceType?: {
      __typename?: 'ContentReferenceType'
      id?: string | null
      type?: string | null
    } | null
    contentTo?: Array<{
      __typename?: 'Content'
      id?: string | null
      title?: string | null
      language?: string | null
      contentType?: string | null
      contentId?: number | null
      published?: boolean | null
      avatar?: Array<{
        __typename?: 'ImageContentRelationship'
        id?: string | null
        type?: string | null
        image?: { __typename?: 'Image'; id?: string | null; url?: string | null } | null
      } | null> | null
    } | null> | null
  } | null> | null
  yiTags?: Array<{
    __typename?: 'ContentReference'
    id?: string | null
    sortKey?: number | null
    contentReferenceType?: { __typename?: 'ContentReferenceType'; type?: string | null } | null
    contentTo?: Array<{
      __typename?: 'Content'
      id?: string | null
      titleGroupId?: string | null
      title?: string | null
      contentId?: number | null
      contentType?: string | null
      published?: boolean | null
    } | null> | null
  } | null> | null
  yiArticleTopic?: Array<{
    __typename?: 'ContentReference'
    id?: string | null
    sortKey?: number | null
    contentReferenceType?: { __typename?: 'ContentReferenceType'; type?: string | null } | null
    contentTo?: Array<{
      __typename?: 'Content'
      id?: string | null
      titleGroupId?: string | null
      title?: string | null
      contentId?: number | null
      contentType?: string | null
      published?: boolean | null
    } | null> | null
  } | null> | null
  featureMedia?: {
    __typename?: 'Media'
    mediaId?: string | null
    contentId?: string | null
    mediaMaestroTitleCode?: string | null
    policyId?: number | null
    updatedAt?: any | null
    duration?: number | null
    isPublished?: boolean | null
    mediaAssets?: Array<{
      __typename?: 'MediaAsset'
      id?: string | null
      providerKey?: string | null
    } | null> | null
  } | null
  providerMetadata?: {
    __typename?: 'ContentProvider'
    metadata?: any | null
    contentId?: string | null
  } | null
}

export type Mutation_YiArticle_ContentUpdateMutationVariables = Exact<{
  content: ContentInput
  generatePath?: InputMaybe<Scalars['Boolean']['input']>
}>

export type Mutation_YiArticle_ContentUpdateMutation = {
  __typename?: 'Mutation'
  contentUpdate?: {
    __typename?: 'ContentUpdateResponse'
    content?: {
      __typename?: 'Content'
      contentPolicyPolicyId?: number | null
      id?: string | null
      contentId?: number | null
      contentType?: string | null
      language?: string | null
      description?: string | null
      descriptionFormat?: string | null
      shortDescription?: string | null
      shortDescriptionFormat?: string | null
      path?: string | null
      primaryLanguage?: string | null
      published?: boolean | null
      publishedAtDate?: any | null
      seoDescription?: string | null
      seoTitle?: string | null
      title?: string | null
      featureMediaId?: string | null
      yiContentType?: Array<{
        __typename?: 'ContentReference'
        id?: string | null
        sortKey?: number | null
        contentReferenceType?: { __typename?: 'ContentReferenceType'; type?: string | null } | null
        contentTo?: Array<{
          __typename?: 'Content'
          id?: string | null
          titleGroupId?: string | null
          title?: string | null
          contentId?: number | null
          contentType?: string | null
          published?: boolean | null
        } | null> | null
      } | null> | null
      yiYogaTeacher?: Array<{
        __typename?: 'ContentReference'
        id?: string | null
        sortKey?: number | null
        contentReferenceType?: {
          __typename?: 'ContentReferenceType'
          id?: string | null
          type?: string | null
        } | null
        contentTo?: Array<{
          __typename?: 'Content'
          id?: string | null
          title?: string | null
          language?: string | null
          contentType?: string | null
          contentId?: number | null
          published?: boolean | null
          avatar?: Array<{
            __typename?: 'ImageContentRelationship'
            id?: string | null
            type?: string | null
            image?: { __typename?: 'Image'; id?: string | null; url?: string | null } | null
          } | null> | null
        } | null> | null
      } | null> | null
      yiTags?: Array<{
        __typename?: 'ContentReference'
        id?: string | null
        sortKey?: number | null
        contentReferenceType?: { __typename?: 'ContentReferenceType'; type?: string | null } | null
        contentTo?: Array<{
          __typename?: 'Content'
          id?: string | null
          titleGroupId?: string | null
          title?: string | null
          contentId?: number | null
          contentType?: string | null
          published?: boolean | null
        } | null> | null
      } | null> | null
      yiArticleTopic?: Array<{
        __typename?: 'ContentReference'
        id?: string | null
        sortKey?: number | null
        contentReferenceType?: { __typename?: 'ContentReferenceType'; type?: string | null } | null
        contentTo?: Array<{
          __typename?: 'Content'
          id?: string | null
          titleGroupId?: string | null
          title?: string | null
          contentId?: number | null
          contentType?: string | null
          published?: boolean | null
        } | null> | null
      } | null> | null
      featureMedia?: {
        __typename?: 'Media'
        mediaId?: string | null
        contentId?: string | null
        mediaMaestroTitleCode?: string | null
        policyId?: number | null
        updatedAt?: any | null
        duration?: number | null
        isPublished?: boolean | null
        mediaAssets?: Array<{
          __typename?: 'MediaAsset'
          id?: string | null
          providerKey?: string | null
        } | null> | null
      } | null
      providerMetadata?: {
        __typename?: 'ContentProvider'
        metadata?: any | null
        contentId?: string | null
      } | null
    } | null
  } | null
}

export type YiClass_ContentFragmentFragment = {
  __typename?: 'Content'
  descriptionFormat?: string | null
  shortDescriptionFormat?: string | null
  displayType?: string | null
  primaryLanguage?: string | null
  productType?: string | null
  seoDescription?: string | null
  seoTitle?: string | null
  contentPolicyPolicyId?: number | null
  featureMediaId?: string | null
  yiContentType?: Array<{
    __typename?: 'ContentReference'
    id?: string | null
    sortKey?: number | null
    contentReferenceType?: { __typename?: 'ContentReferenceType'; type?: string | null } | null
    contentTo?: Array<{
      __typename?: 'Content'
      id?: string | null
      titleGroupId?: string | null
      title?: string | null
      contentId?: number | null
      contentType?: string | null
      published?: boolean | null
    } | null> | null
  } | null> | null
  yiTags?: Array<{
    __typename?: 'ContentReference'
    id?: string | null
    sortKey?: number | null
    contentReferenceType?: { __typename?: 'ContentReferenceType'; type?: string | null } | null
    contentTo?: Array<{
      __typename?: 'Content'
      id?: string | null
      titleGroupId?: string | null
      title?: string | null
      contentId?: number | null
      contentType?: string | null
      published?: boolean | null
    } | null> | null
  } | null> | null
  yiYogaStyle?: Array<{
    __typename?: 'ContentReference'
    id?: string | null
    sortKey?: number | null
    contentReferenceType?: { __typename?: 'ContentReferenceType'; type?: string | null } | null
    contentTo?: Array<{
      __typename?: 'Content'
      id?: string | null
      titleGroupId?: string | null
      title?: string | null
      contentId?: number | null
      contentType?: string | null
      published?: boolean | null
    } | null> | null
  } | null> | null
  yiYogaLevel?: Array<{
    __typename?: 'ContentReference'
    id?: string | null
    sortKey?: number | null
    contentReferenceType?: { __typename?: 'ContentReferenceType'; type?: string | null } | null
    contentTo?: Array<{
      __typename?: 'Content'
      id?: string | null
      titleGroupId?: string | null
      title?: string | null
      contentId?: number | null
      contentType?: string | null
      published?: boolean | null
    } | null> | null
  } | null> | null
  yiYogaTeacher?: Array<{
    __typename?: 'ContentReference'
    id?: string | null
    sortKey?: number | null
    contentReferenceType?: {
      __typename?: 'ContentReferenceType'
      id?: string | null
      type?: string | null
    } | null
    contentTo?: Array<{
      __typename?: 'Content'
      id?: string | null
      title?: string | null
      language?: string | null
      contentType?: string | null
      contentId?: number | null
      published?: boolean | null
      avatar?: Array<{
        __typename?: 'ImageContentRelationship'
        id?: string | null
        type?: string | null
        image?: { __typename?: 'Image'; id?: string | null; url?: string | null } | null
      } | null> | null
    } | null> | null
  } | null> | null
  yiPracticeType?: Array<{
    __typename?: 'ContentReference'
    id?: string | null
    sortKey?: number | null
    contentReferenceType?: { __typename?: 'ContentReferenceType'; type?: string | null } | null
    contentTo?: Array<{
      __typename?: 'Content'
      id?: string | null
      titleGroupId?: string | null
      title?: string | null
      contentId?: number | null
      contentType?: string | null
      published?: boolean | null
    } | null> | null
  } | null> | null
  featureMedia?: {
    __typename?: 'Media'
    mediaId?: string | null
    contentId?: string | null
    mediaMaestroTitleCode?: string | null
    policyId?: number | null
    updatedAt?: any | null
    duration?: number | null
    isPublished?: boolean | null
    mediaAssets?: Array<{
      __typename?: 'MediaAsset'
      id?: string | null
      providerKey?: string | null
    } | null> | null
  } | null
}

export type Mutation_YicLass_ContentUpdateMutationVariables = Exact<{
  content: ContentInput
  generatePath?: InputMaybe<Scalars['Boolean']['input']>
}>

export type Mutation_YicLass_ContentUpdateMutation = {
  __typename?: 'Mutation'
  contentUpdate?: {
    __typename?: 'ContentUpdateResponse'
    content?: {
      __typename?: 'Content'
      id?: string | null
      contentId?: number | null
      contentType?: string | null
      published?: boolean | null
      publishedAtDate?: any | null
      createdAt?: any | null
      updatedAt?: any | null
      title?: string | null
      path?: string | null
      shortDescription?: string | null
      description?: string | null
      language?: string | null
      contentPolicyPolicyId?: number | null
      descriptionFormat?: string | null
      shortDescriptionFormat?: string | null
      displayType?: string | null
      primaryLanguage?: string | null
      productType?: string | null
      seoDescription?: string | null
      seoTitle?: string | null
      featureMediaId?: string | null
      yiContentType?: Array<{
        __typename?: 'ContentReference'
        id?: string | null
        sortKey?: number | null
        contentReferenceType?: { __typename?: 'ContentReferenceType'; type?: string | null } | null
        contentTo?: Array<{
          __typename?: 'Content'
          id?: string | null
          titleGroupId?: string | null
          title?: string | null
          contentId?: number | null
          contentType?: string | null
          published?: boolean | null
        } | null> | null
      } | null> | null
      yiTags?: Array<{
        __typename?: 'ContentReference'
        id?: string | null
        sortKey?: number | null
        contentReferenceType?: { __typename?: 'ContentReferenceType'; type?: string | null } | null
        contentTo?: Array<{
          __typename?: 'Content'
          id?: string | null
          titleGroupId?: string | null
          title?: string | null
          contentId?: number | null
          contentType?: string | null
          published?: boolean | null
        } | null> | null
      } | null> | null
      yiYogaStyle?: Array<{
        __typename?: 'ContentReference'
        id?: string | null
        sortKey?: number | null
        contentReferenceType?: { __typename?: 'ContentReferenceType'; type?: string | null } | null
        contentTo?: Array<{
          __typename?: 'Content'
          id?: string | null
          titleGroupId?: string | null
          title?: string | null
          contentId?: number | null
          contentType?: string | null
          published?: boolean | null
        } | null> | null
      } | null> | null
      yiYogaLevel?: Array<{
        __typename?: 'ContentReference'
        id?: string | null
        sortKey?: number | null
        contentReferenceType?: { __typename?: 'ContentReferenceType'; type?: string | null } | null
        contentTo?: Array<{
          __typename?: 'Content'
          id?: string | null
          titleGroupId?: string | null
          title?: string | null
          contentId?: number | null
          contentType?: string | null
          published?: boolean | null
        } | null> | null
      } | null> | null
      yiYogaTeacher?: Array<{
        __typename?: 'ContentReference'
        id?: string | null
        sortKey?: number | null
        contentReferenceType?: {
          __typename?: 'ContentReferenceType'
          id?: string | null
          type?: string | null
        } | null
        contentTo?: Array<{
          __typename?: 'Content'
          id?: string | null
          title?: string | null
          language?: string | null
          contentType?: string | null
          contentId?: number | null
          published?: boolean | null
          avatar?: Array<{
            __typename?: 'ImageContentRelationship'
            id?: string | null
            type?: string | null
            image?: { __typename?: 'Image'; id?: string | null; url?: string | null } | null
          } | null> | null
        } | null> | null
      } | null> | null
      yiPracticeType?: Array<{
        __typename?: 'ContentReference'
        id?: string | null
        sortKey?: number | null
        contentReferenceType?: { __typename?: 'ContentReferenceType'; type?: string | null } | null
        contentTo?: Array<{
          __typename?: 'Content'
          id?: string | null
          titleGroupId?: string | null
          title?: string | null
          contentId?: number | null
          contentType?: string | null
          published?: boolean | null
        } | null> | null
      } | null> | null
      contentProvider?: {
        __typename?: 'ContentProvider'
        provider?: ContentProviderProviders | null
        providerKey?: string | null
        contentId?: string | null
      } | null
      featureMedia?: {
        __typename?: 'Media'
        mediaId?: string | null
        contentId?: string | null
        mediaMaestroTitleCode?: string | null
        policyId?: number | null
        updatedAt?: any | null
        duration?: number | null
        isPublished?: boolean | null
        mediaAssets?: Array<{
          __typename?: 'MediaAsset'
          id?: string | null
          providerKey?: string | null
        } | null> | null
      } | null
    } | null
  } | null
}

export type YiCourseModuleSearchContentSelectQueryQueryVariables = Exact<{
  offset?: InputMaybe<Scalars['Int']['input']>
  limit?: InputMaybe<Scalars['Int']['input']>
  where?: InputMaybe<ContentWhereInput>
  referencesNot?: InputMaybe<
    | Array<InputMaybe<ContentContentReferencesToFilterInput>>
    | InputMaybe<ContentContentReferencesToFilterInput>
  >
}>

export type YiCourseModuleSearchContentSelectQueryQuery = {
  __typename?: 'Query'
  contentList?: {
    __typename?: 'ContentListResponse'
    content?: Array<{
      __typename?: 'Content'
      updatedAt?: any | null
      title?: string | null
      id?: string | null
      contentType?: string | null
      contentId?: number | null
      published?: boolean | null
      yiCourseModuleType?: Array<{
        __typename?: 'ContentReference'
        id?: string | null
        sortKey?: number | null
        contentReferenceType?: { __typename?: 'ContentReferenceType'; type?: string | null } | null
        contentTo?: Array<{
          __typename?: 'Content'
          id?: string | null
          titleGroupId?: string | null
          title?: string | null
          contentId?: number | null
          contentType?: string | null
          published?: boolean | null
        } | null> | null
      } | null> | null
      providerMetadata?: {
        __typename?: 'ContentProvider'
        metadata?: any | null
        contentId?: string | null
      } | null
    } | null> | null
  } | null
}

export type YiCourse_ModuleDetailsContentFragmentFragment = {
  __typename?: 'Content'
  title?: string | null
  id?: string | null
  contentType?: string | null
  contentId?: number | null
  published?: boolean | null
  yiCourseModuleType?: Array<{
    __typename?: 'ContentReference'
    id?: string | null
    sortKey?: number | null
    contentReferenceType?: { __typename?: 'ContentReferenceType'; type?: string | null } | null
    contentTo?: Array<{
      __typename?: 'Content'
      id?: string | null
      titleGroupId?: string | null
      title?: string | null
      contentId?: number | null
      contentType?: string | null
      published?: boolean | null
    } | null> | null
  } | null> | null
  providerMetadata?: {
    __typename?: 'ContentProvider'
    metadata?: any | null
    contentId?: string | null
  } | null
}

export type YiCourse_ModulesContentReferenceFragmentFragment = {
  __typename?: 'ContentReference'
  sortKey?: number | null
  id?: string | null
  contentReferenceType?: { __typename?: 'ContentReferenceType'; type?: string | null } | null
  contentTo?: Array<{
    __typename?: 'Content'
    title?: string | null
    id?: string | null
    contentType?: string | null
    contentId?: number | null
    published?: boolean | null
    yiCourseModuleType?: Array<{
      __typename?: 'ContentReference'
      id?: string | null
      sortKey?: number | null
      contentReferenceType?: { __typename?: 'ContentReferenceType'; type?: string | null } | null
      contentTo?: Array<{
        __typename?: 'Content'
        id?: string | null
        titleGroupId?: string | null
        title?: string | null
        contentId?: number | null
        contentType?: string | null
        published?: boolean | null
      } | null> | null
    } | null> | null
    providerMetadata?: {
      __typename?: 'ContentProvider'
      metadata?: any | null
      contentId?: string | null
    } | null
  } | null> | null
}

export type YiCourse_ContentFragmentFragment = {
  __typename?: 'Content'
  id?: string | null
  contentId?: number | null
  contentType?: string | null
  published?: boolean | null
  publishedAtDate?: any | null
  createdAt?: any | null
  updatedAt?: any | null
  title?: string | null
  path?: string | null
  shortDescription?: string | null
  description?: string | null
  language?: string | null
  seoDescription?: string | null
  seoTitle?: string | null
  descriptionFormat?: string | null
  shortDescriptionFormat?: string | null
  displayType?: string | null
  featureMediaId?: string | null
  primaryLanguage?: string | null
  productType?: string | null
  contentProvider?: {
    __typename?: 'ContentProvider'
    provider?: ContentProviderProviders | null
    providerKey?: string | null
    contentId?: string | null
  } | null
  contentPolicy?: {
    __typename?: 'ContentPolicy'
    policyId?: string | null
    name?: string | null
  } | null
  yiContentType?: Array<{
    __typename?: 'ContentReference'
    id?: string | null
    sortKey?: number | null
    contentReferenceType?: { __typename?: 'ContentReferenceType'; type?: string | null } | null
    contentTo?: Array<{
      __typename?: 'Content'
      id?: string | null
      titleGroupId?: string | null
      title?: string | null
      contentId?: number | null
      contentType?: string | null
      published?: boolean | null
    } | null> | null
  } | null> | null
  yiTags?: Array<{
    __typename?: 'ContentReference'
    id?: string | null
    sortKey?: number | null
    contentReferenceType?: { __typename?: 'ContentReferenceType'; type?: string | null } | null
    contentTo?: Array<{
      __typename?: 'Content'
      id?: string | null
      titleGroupId?: string | null
      title?: string | null
      contentId?: number | null
      contentType?: string | null
      published?: boolean | null
    } | null> | null
  } | null> | null
  yiYogaTeacher?: Array<{
    __typename?: 'ContentReference'
    id?: string | null
    sortKey?: number | null
    contentReferenceType?: {
      __typename?: 'ContentReferenceType'
      id?: string | null
      type?: string | null
    } | null
    contentTo?: Array<{
      __typename?: 'Content'
      id?: string | null
      title?: string | null
      language?: string | null
      contentType?: string | null
      contentId?: number | null
      published?: boolean | null
      avatar?: Array<{
        __typename?: 'ImageContentRelationship'
        id?: string | null
        type?: string | null
        image?: { __typename?: 'Image'; id?: string | null; url?: string | null } | null
      } | null> | null
    } | null> | null
  } | null> | null
  yiActionType?: Array<{
    __typename?: 'ContentReference'
    id?: string | null
    sortKey?: number | null
    contentReferenceType?: {
      __typename?: 'ContentReferenceType'
      id?: string | null
      type?: string | null
    } | null
    contentTo?: Array<{
      __typename?: 'Content'
      id?: string | null
      title?: string | null
      language?: string | null
      contentType?: string | null
      contentId?: number | null
      published?: boolean | null
      avatar?: Array<{
        __typename?: 'ImageContentRelationship'
        id?: string | null
        type?: string | null
        image?: { __typename?: 'Image'; id?: string | null; url?: string | null } | null
      } | null> | null
    } | null> | null
  } | null> | null
  yiCourseModules?: Array<{
    __typename?: 'ContentReference'
    sortKey?: number | null
    id?: string | null
    contentReferenceType?: { __typename?: 'ContentReferenceType'; type?: string | null } | null
    contentTo?: Array<{
      __typename?: 'Content'
      title?: string | null
      id?: string | null
      contentType?: string | null
      contentId?: number | null
      published?: boolean | null
      yiCourseModuleType?: Array<{
        __typename?: 'ContentReference'
        id?: string | null
        sortKey?: number | null
        contentReferenceType?: { __typename?: 'ContentReferenceType'; type?: string | null } | null
        contentTo?: Array<{
          __typename?: 'Content'
          id?: string | null
          titleGroupId?: string | null
          title?: string | null
          contentId?: number | null
          contentType?: string | null
          published?: boolean | null
        } | null> | null
      } | null> | null
      providerMetadata?: {
        __typename?: 'ContentProvider'
        metadata?: any | null
        contentId?: string | null
      } | null
    } | null> | null
  } | null> | null
  yiCourseSalesPages?: Array<{
    __typename?: 'ContentReference'
    id?: string | null
    contentFrom?: Array<{
      __typename?: 'Content'
      id?: string | null
      contentType?: string | null
      contentId?: number | null
      title?: string | null
      published?: boolean | null
    } | null> | null
  } | null> | null
  providerMetadata?: {
    __typename?: 'ContentProvider'
    metadata?: any | null
    contentId?: string | null
  } | null
}

export type Mutation_YiCourse_ContentUpdateMutationVariables = Exact<{
  content: ContentInput
  generatePath?: InputMaybe<Scalars['Boolean']['input']>
}>

export type Mutation_YiCourse_ContentUpdateMutation = {
  __typename?: 'Mutation'
  contentUpdate?: {
    __typename?: 'ContentUpdateResponse'
    content?: {
      __typename?: 'Content'
      id?: string | null
      contentId?: number | null
      contentType?: string | null
      published?: boolean | null
      publishedAtDate?: any | null
      createdAt?: any | null
      updatedAt?: any | null
      title?: string | null
      path?: string | null
      shortDescription?: string | null
      description?: string | null
      language?: string | null
      contentPolicyPolicyId?: number | null
      seoDescription?: string | null
      seoTitle?: string | null
      descriptionFormat?: string | null
      shortDescriptionFormat?: string | null
      displayType?: string | null
      featureMediaId?: string | null
      primaryLanguage?: string | null
      productType?: string | null
      contentProvider?: {
        __typename?: 'ContentProvider'
        provider?: ContentProviderProviders | null
        providerKey?: string | null
        contentId?: string | null
      } | null
      contentPolicy?: {
        __typename?: 'ContentPolicy'
        policyId?: string | null
        name?: string | null
      } | null
      yiContentType?: Array<{
        __typename?: 'ContentReference'
        id?: string | null
        sortKey?: number | null
        contentReferenceType?: { __typename?: 'ContentReferenceType'; type?: string | null } | null
        contentTo?: Array<{
          __typename?: 'Content'
          id?: string | null
          titleGroupId?: string | null
          title?: string | null
          contentId?: number | null
          contentType?: string | null
          published?: boolean | null
        } | null> | null
      } | null> | null
      yiTags?: Array<{
        __typename?: 'ContentReference'
        id?: string | null
        sortKey?: number | null
        contentReferenceType?: { __typename?: 'ContentReferenceType'; type?: string | null } | null
        contentTo?: Array<{
          __typename?: 'Content'
          id?: string | null
          titleGroupId?: string | null
          title?: string | null
          contentId?: number | null
          contentType?: string | null
          published?: boolean | null
        } | null> | null
      } | null> | null
      yiYogaTeacher?: Array<{
        __typename?: 'ContentReference'
        id?: string | null
        sortKey?: number | null
        contentReferenceType?: {
          __typename?: 'ContentReferenceType'
          id?: string | null
          type?: string | null
        } | null
        contentTo?: Array<{
          __typename?: 'Content'
          id?: string | null
          title?: string | null
          language?: string | null
          contentType?: string | null
          contentId?: number | null
          published?: boolean | null
          avatar?: Array<{
            __typename?: 'ImageContentRelationship'
            id?: string | null
            type?: string | null
            image?: { __typename?: 'Image'; id?: string | null; url?: string | null } | null
          } | null> | null
        } | null> | null
      } | null> | null
      yiActionType?: Array<{
        __typename?: 'ContentReference'
        id?: string | null
        sortKey?: number | null
        contentReferenceType?: {
          __typename?: 'ContentReferenceType'
          id?: string | null
          type?: string | null
        } | null
        contentTo?: Array<{
          __typename?: 'Content'
          id?: string | null
          title?: string | null
          language?: string | null
          contentType?: string | null
          contentId?: number | null
          published?: boolean | null
          avatar?: Array<{
            __typename?: 'ImageContentRelationship'
            id?: string | null
            type?: string | null
            image?: { __typename?: 'Image'; id?: string | null; url?: string | null } | null
          } | null> | null
        } | null> | null
      } | null> | null
      yiCourseModules?: Array<{
        __typename?: 'ContentReference'
        sortKey?: number | null
        id?: string | null
        contentReferenceType?: { __typename?: 'ContentReferenceType'; type?: string | null } | null
        contentTo?: Array<{
          __typename?: 'Content'
          title?: string | null
          id?: string | null
          contentType?: string | null
          contentId?: number | null
          published?: boolean | null
          yiCourseModuleType?: Array<{
            __typename?: 'ContentReference'
            id?: string | null
            sortKey?: number | null
            contentReferenceType?: {
              __typename?: 'ContentReferenceType'
              type?: string | null
            } | null
            contentTo?: Array<{
              __typename?: 'Content'
              id?: string | null
              titleGroupId?: string | null
              title?: string | null
              contentId?: number | null
              contentType?: string | null
              published?: boolean | null
            } | null> | null
          } | null> | null
          providerMetadata?: {
            __typename?: 'ContentProvider'
            metadata?: any | null
            contentId?: string | null
          } | null
        } | null> | null
      } | null> | null
      yiCourseSalesPages?: Array<{
        __typename?: 'ContentReference'
        id?: string | null
        contentFrom?: Array<{
          __typename?: 'Content'
          id?: string | null
          contentType?: string | null
          contentId?: number | null
          title?: string | null
          published?: boolean | null
        } | null> | null
      } | null> | null
      providerMetadata?: {
        __typename?: 'ContentProvider'
        metadata?: any | null
        contentId?: string | null
      } | null
    } | null
  } | null
}

export type YiCourseModule_ContentFragmentFragment = {
  __typename?: 'Content'
  id?: string | null
  title?: string | null
  contentType?: string | null
  contentId?: number | null
  description?: string | null
  descriptionFormat?: string | null
  published?: boolean | null
  publishedAtDate?: any | null
  primaryLanguage?: string | null
  language?: string | null
  shortDescription?: string | null
  shortDescriptionFormat?: string | null
  path?: string | null
  contentPolicyPolicyId?: number | null
  featureMediaId?: string | null
  yiContentType?: Array<{
    __typename?: 'ContentReference'
    id?: string | null
    sortKey?: number | null
    contentReferenceType?: { __typename?: 'ContentReferenceType'; type?: string | null } | null
    contentTo?: Array<{
      __typename?: 'Content'
      id?: string | null
      titleGroupId?: string | null
      title?: string | null
      contentId?: number | null
      contentType?: string | null
      published?: boolean | null
    } | null> | null
  } | null> | null
  yiCourseModuleType?: Array<{
    __typename?: 'ContentReference'
    id?: string | null
    sortKey?: number | null
    contentReferenceType?: { __typename?: 'ContentReferenceType'; type?: string | null } | null
    contentTo?: Array<{
      __typename?: 'Content'
      id?: string | null
      titleGroupId?: string | null
      title?: string | null
      contentId?: number | null
      contentType?: string | null
      published?: boolean | null
    } | null> | null
  } | null> | null
  yiConsumptionType?: Array<{
    __typename?: 'ContentReference'
    id?: string | null
    sortKey?: number | null
    contentReferenceType?: { __typename?: 'ContentReferenceType'; type?: string | null } | null
    contentTo?: Array<{
      __typename?: 'Content'
      id?: string | null
      titleGroupId?: string | null
      title?: string | null
      contentId?: number | null
      contentType?: string | null
      published?: boolean | null
    } | null> | null
  } | null> | null
  yiYogaStyles?: Array<{
    __typename?: 'ContentReference'
    id?: string | null
    sortKey?: number | null
    contentReferenceType?: { __typename?: 'ContentReferenceType'; type?: string | null } | null
    contentTo?: Array<{
      __typename?: 'Content'
      id?: string | null
      titleGroupId?: string | null
      title?: string | null
      contentId?: number | null
      contentType?: string | null
      published?: boolean | null
    } | null> | null
  } | null> | null
  featureMedia?: {
    __typename?: 'Media'
    mediaId?: string | null
    contentId?: string | null
    mediaMaestroTitleCode?: string | null
    policyId?: number | null
    updatedAt?: any | null
    duration?: number | null
    isPublished?: boolean | null
    mediaAssets?: Array<{
      __typename?: 'MediaAsset'
      id?: string | null
      providerKey?: string | null
    } | null> | null
  } | null
  yiCourseModuleDownload?: Array<{
    __typename?: 'ContentAssetReference'
    id?: string | null
    asset?: {
      __typename?: 'Asset'
      id?: string | null
      mimeType?: string | null
      fileSize?: number | null
      originalFileName?: string | null
      renderUrl?: string | null
      contentAssetReference?: {
        __typename?: 'ContentAssetReference'
        assetsId?: string | null
      } | null
    } | null
  } | null> | null
  providerMetadata?: {
    __typename?: 'ContentProvider'
    metadata?: any | null
    contentId?: string | null
  } | null
}

export type Mutation_YiCourseModule_ContentUpdateMutationVariables = Exact<{
  content: ContentInput
}>

export type Mutation_YiCourseModule_ContentUpdateMutation = {
  __typename?: 'Mutation'
  contentUpdate?: {
    __typename?: 'ContentUpdateResponse'
    content?: {
      __typename?: 'Content'
      id?: string | null
      title?: string | null
      contentType?: string | null
      contentId?: number | null
      description?: string | null
      descriptionFormat?: string | null
      published?: boolean | null
      publishedAtDate?: any | null
      primaryLanguage?: string | null
      language?: string | null
      shortDescription?: string | null
      shortDescriptionFormat?: string | null
      path?: string | null
      contentPolicyPolicyId?: number | null
      featureMediaId?: string | null
      yiContentType?: Array<{
        __typename?: 'ContentReference'
        id?: string | null
        sortKey?: number | null
        contentReferenceType?: { __typename?: 'ContentReferenceType'; type?: string | null } | null
        contentTo?: Array<{
          __typename?: 'Content'
          id?: string | null
          titleGroupId?: string | null
          title?: string | null
          contentId?: number | null
          contentType?: string | null
          published?: boolean | null
        } | null> | null
      } | null> | null
      yiCourseModuleType?: Array<{
        __typename?: 'ContentReference'
        id?: string | null
        sortKey?: number | null
        contentReferenceType?: { __typename?: 'ContentReferenceType'; type?: string | null } | null
        contentTo?: Array<{
          __typename?: 'Content'
          id?: string | null
          titleGroupId?: string | null
          title?: string | null
          contentId?: number | null
          contentType?: string | null
          published?: boolean | null
        } | null> | null
      } | null> | null
      yiConsumptionType?: Array<{
        __typename?: 'ContentReference'
        id?: string | null
        sortKey?: number | null
        contentReferenceType?: { __typename?: 'ContentReferenceType'; type?: string | null } | null
        contentTo?: Array<{
          __typename?: 'Content'
          id?: string | null
          titleGroupId?: string | null
          title?: string | null
          contentId?: number | null
          contentType?: string | null
          published?: boolean | null
        } | null> | null
      } | null> | null
      yiYogaStyles?: Array<{
        __typename?: 'ContentReference'
        id?: string | null
        sortKey?: number | null
        contentReferenceType?: { __typename?: 'ContentReferenceType'; type?: string | null } | null
        contentTo?: Array<{
          __typename?: 'Content'
          id?: string | null
          titleGroupId?: string | null
          title?: string | null
          contentId?: number | null
          contentType?: string | null
          published?: boolean | null
        } | null> | null
      } | null> | null
      featureMedia?: {
        __typename?: 'Media'
        mediaId?: string | null
        contentId?: string | null
        mediaMaestroTitleCode?: string | null
        policyId?: number | null
        updatedAt?: any | null
        duration?: number | null
        isPublished?: boolean | null
        mediaAssets?: Array<{
          __typename?: 'MediaAsset'
          id?: string | null
          providerKey?: string | null
        } | null> | null
      } | null
      yiCourseModuleDownload?: Array<{
        __typename?: 'ContentAssetReference'
        id?: string | null
        asset?: {
          __typename?: 'Asset'
          id?: string | null
          mimeType?: string | null
          fileSize?: number | null
          originalFileName?: string | null
          renderUrl?: string | null
          contentAssetReference?: {
            __typename?: 'ContentAssetReference'
            assetsId?: string | null
          } | null
        } | null
      } | null> | null
      providerMetadata?: {
        __typename?: 'ContentProvider'
        metadata?: any | null
        contentId?: string | null
      } | null
    } | null
  } | null
}

export type YiCourseModuleDownload_ContentFragmentFragment = {
  __typename?: 'Content'
  yiCourseModuleDownload?: Array<{
    __typename?: 'ContentAssetReference'
    id?: string | null
    asset?: {
      __typename?: 'Asset'
      id?: string | null
      mimeType?: string | null
      fileSize?: number | null
      originalFileName?: string | null
      renderUrl?: string | null
      contentAssetReference?: {
        __typename?: 'ContentAssetReference'
        assetsId?: string | null
      } | null
    } | null
  } | null> | null
}

export type YiCourseModuleDownloadQueryVariables = Exact<{
  id: Scalars['ID']['input']
}>

export type YiCourseModuleDownloadQuery = {
  __typename?: 'Query'
  contentList?: {
    __typename?: 'ContentListResponse'
    content?: Array<{
      __typename?: 'Content'
      id?: string | null
      yiCourseModuleDownload?: Array<{
        __typename?: 'ContentAssetReference'
        id?: string | null
        asset?: {
          __typename?: 'Asset'
          id?: string | null
          mimeType?: string | null
          fileSize?: number | null
          originalFileName?: string | null
          renderUrl?: string | null
          contentAssetReference?: {
            __typename?: 'ContentAssetReference'
            assetsId?: string | null
          } | null
        } | null
      } | null> | null
    } | null> | null
  } | null
}

export type YiCourseSales_ContentFragmentFragment = {
  __typename?: 'Content'
  contentPolicyPolicyId?: number | null
  description?: string | null
  descriptionFormat?: string | null
  path?: string | null
  primaryLanguage?: string | null
  published?: boolean | null
  publishedAtDate?: any | null
  featureMediaId?: string | null
  yiContentType?: Array<{
    __typename?: 'ContentReference'
    id?: string | null
    sortKey?: number | null
    contentReferenceType?: { __typename?: 'ContentReferenceType'; type?: string | null } | null
    contentTo?: Array<{
      __typename?: 'Content'
      id?: string | null
      titleGroupId?: string | null
      title?: string | null
      contentId?: number | null
      contentType?: string | null
      published?: boolean | null
    } | null> | null
  } | null> | null
  yiCourses?: Array<{
    __typename?: 'ContentReference'
    id?: string | null
    contentTo?: Array<{
      __typename?: 'Content'
      id?: string | null
      contentType?: string | null
      contentId?: number | null
      title?: string | null
      published?: boolean | null
      contentProvider?: {
        __typename?: 'ContentProvider'
        provider?: ContentProviderProviders | null
        providerKey?: string | null
        contentId?: string | null
      } | null
    } | null> | null
  } | null> | null
  featureMedia?: {
    __typename?: 'Media'
    mediaId?: string | null
    contentId?: string | null
    mediaMaestroTitleCode?: string | null
    policyId?: number | null
    updatedAt?: any | null
    duration?: number | null
    isPublished?: boolean | null
    mediaAssets?: Array<{
      __typename?: 'MediaAsset'
      id?: string | null
      providerKey?: string | null
    } | null> | null
  } | null
  providerMetadata?: {
    __typename?: 'ContentProvider'
    metadata?: any | null
    contentId?: string | null
  } | null
}

export type Mutation_YiCourseSales_ContentUpdateMutationVariables = Exact<{
  content: ContentInput
  generatePath?: InputMaybe<Scalars['Boolean']['input']>
}>

export type Mutation_YiCourseSales_ContentUpdateMutation = {
  __typename?: 'Mutation'
  contentUpdate?: {
    __typename?: 'ContentUpdateResponse'
    content?: {
      __typename?: 'Content'
      contentPolicyPolicyId?: number | null
      description?: string | null
      descriptionFormat?: string | null
      path?: string | null
      primaryLanguage?: string | null
      published?: boolean | null
      publishedAtDate?: any | null
      featureMediaId?: string | null
      yiContentType?: Array<{
        __typename?: 'ContentReference'
        id?: string | null
        sortKey?: number | null
        contentReferenceType?: { __typename?: 'ContentReferenceType'; type?: string | null } | null
        contentTo?: Array<{
          __typename?: 'Content'
          id?: string | null
          titleGroupId?: string | null
          title?: string | null
          contentId?: number | null
          contentType?: string | null
          published?: boolean | null
        } | null> | null
      } | null> | null
      yiCourses?: Array<{
        __typename?: 'ContentReference'
        id?: string | null
        contentTo?: Array<{
          __typename?: 'Content'
          id?: string | null
          contentType?: string | null
          contentId?: number | null
          title?: string | null
          published?: boolean | null
          contentProvider?: {
            __typename?: 'ContentProvider'
            provider?: ContentProviderProviders | null
            providerKey?: string | null
            contentId?: string | null
          } | null
        } | null> | null
      } | null> | null
      featureMedia?: {
        __typename?: 'Media'
        mediaId?: string | null
        contentId?: string | null
        mediaMaestroTitleCode?: string | null
        policyId?: number | null
        updatedAt?: any | null
        duration?: number | null
        isPublished?: boolean | null
        mediaAssets?: Array<{
          __typename?: 'MediaAsset'
          id?: string | null
          providerKey?: string | null
        } | null> | null
      } | null
      providerMetadata?: {
        __typename?: 'ContentProvider'
        metadata?: any | null
        contentId?: string | null
      } | null
    } | null
  } | null
}

export type YiCourseSection_ContentFragmentFragment = {
  __typename?: 'Content'
  id?: string | null
  title?: string | null
  contentType?: string | null
  contentId?: number | null
  published?: boolean | null
  yiContentType?: Array<{
    __typename?: 'ContentReference'
    id?: string | null
    sortKey?: number | null
    contentReferenceType?: { __typename?: 'ContentReferenceType'; type?: string | null } | null
    contentTo?: Array<{
      __typename?: 'Content'
      id?: string | null
      titleGroupId?: string | null
      title?: string | null
      contentId?: number | null
      contentType?: string | null
      published?: boolean | null
    } | null> | null
  } | null> | null
  providerMetadata?: {
    __typename?: 'ContentProvider'
    metadata?: any | null
    contentId?: string | null
  } | null
}

export type Mutation_YiCourseSection_ContentUpdateMutationVariables = Exact<{
  content: ContentInput
}>

export type Mutation_YiCourseSection_ContentUpdateMutation = {
  __typename?: 'Mutation'
  contentUpdate?: {
    __typename?: 'ContentUpdateResponse'
    content?: {
      __typename?: 'Content'
      id?: string | null
      title?: string | null
      contentType?: string | null
      contentId?: number | null
      published?: boolean | null
      yiContentType?: Array<{
        __typename?: 'ContentReference'
        id?: string | null
        sortKey?: number | null
        contentReferenceType?: { __typename?: 'ContentReferenceType'; type?: string | null } | null
        contentTo?: Array<{
          __typename?: 'Content'
          id?: string | null
          titleGroupId?: string | null
          title?: string | null
          contentId?: number | null
          contentType?: string | null
          published?: boolean | null
        } | null> | null
      } | null> | null
      providerMetadata?: {
        __typename?: 'ContentProvider'
        metadata?: any | null
        contentId?: string | null
      } | null
    } | null
  } | null
}

export type YiHomepageHero_ContentFragmentFragment = {
  __typename?: 'Content'
  id?: string | null
  contentId?: number | null
  contentType?: string | null
  language?: string | null
  primaryLanguage?: string | null
  published?: boolean | null
  publishedAtDate?: any | null
  title?: string | null
  yiContentType?: Array<{
    __typename?: 'ContentReference'
    id?: string | null
    sortKey?: number | null
    contentReferenceType?: { __typename?: 'ContentReferenceType'; type?: string | null } | null
    contentTo?: Array<{
      __typename?: 'Content'
      id?: string | null
      titleGroupId?: string | null
      title?: string | null
      contentId?: number | null
      contentType?: string | null
      published?: boolean | null
    } | null> | null
  } | null> | null
  yiHomepageHeroContent?: Array<{
    __typename?: 'ContentReference'
    id?: string | null
    contentReferenceType?: { __typename?: 'ContentReferenceType'; type?: string | null } | null
    contentTo?: Array<{
      __typename?: 'Content'
      id?: string | null
      contentType?: string | null
      contentId?: number | null
      title?: string | null
      published?: boolean | null
      yiContentType?: Array<{
        __typename?: 'ContentReference'
        id?: string | null
        sortKey?: number | null
        contentReferenceType?: { __typename?: 'ContentReferenceType'; type?: string | null } | null
        contentTo?: Array<{
          __typename?: 'Content'
          id?: string | null
          titleGroupId?: string | null
          title?: string | null
          contentId?: number | null
          contentType?: string | null
          published?: boolean | null
        } | null> | null
      } | null> | null
      contentProvider?: {
        __typename?: 'ContentProvider'
        provider?: ContentProviderProviders | null
        providerKey?: string | null
        contentId?: string | null
      } | null
    } | null> | null
  } | null> | null
  providerMetadata?: {
    __typename?: 'ContentProvider'
    metadata?: any | null
    contentId?: string | null
  } | null
}

export type Mutation_YiHomepageHero_ContentUpdateMutationVariables = Exact<{
  content: ContentInput
  generatePath?: InputMaybe<Scalars['Boolean']['input']>
}>

export type Mutation_YiHomepageHero_ContentUpdateMutation = {
  __typename?: 'Mutation'
  contentUpdate?: {
    __typename?: 'ContentUpdateResponse'
    content?: {
      __typename?: 'Content'
      id?: string | null
      contentId?: number | null
      contentType?: string | null
      language?: string | null
      primaryLanguage?: string | null
      published?: boolean | null
      publishedAtDate?: any | null
      title?: string | null
      yiContentType?: Array<{
        __typename?: 'ContentReference'
        id?: string | null
        sortKey?: number | null
        contentReferenceType?: { __typename?: 'ContentReferenceType'; type?: string | null } | null
        contentTo?: Array<{
          __typename?: 'Content'
          id?: string | null
          titleGroupId?: string | null
          title?: string | null
          contentId?: number | null
          contentType?: string | null
          published?: boolean | null
        } | null> | null
      } | null> | null
      yiHomepageHeroContent?: Array<{
        __typename?: 'ContentReference'
        id?: string | null
        contentReferenceType?: { __typename?: 'ContentReferenceType'; type?: string | null } | null
        contentTo?: Array<{
          __typename?: 'Content'
          id?: string | null
          contentType?: string | null
          contentId?: number | null
          title?: string | null
          published?: boolean | null
          yiContentType?: Array<{
            __typename?: 'ContentReference'
            id?: string | null
            sortKey?: number | null
            contentReferenceType?: {
              __typename?: 'ContentReferenceType'
              type?: string | null
            } | null
            contentTo?: Array<{
              __typename?: 'Content'
              id?: string | null
              titleGroupId?: string | null
              title?: string | null
              contentId?: number | null
              contentType?: string | null
              published?: boolean | null
            } | null> | null
          } | null> | null
          contentProvider?: {
            __typename?: 'ContentProvider'
            provider?: ContentProviderProviders | null
            providerKey?: string | null
            contentId?: string | null
          } | null
        } | null> | null
      } | null> | null
      providerMetadata?: {
        __typename?: 'ContentProvider'
        metadata?: any | null
        contentId?: string | null
      } | null
    } | null
  } | null
}

export type YiMeditation_ContentFragmentFragment = {
  __typename?: 'Content'
  descriptionFormat?: string | null
  shortDescriptionFormat?: string | null
  displayType?: string | null
  primaryLanguage?: string | null
  productType?: string | null
  seoDescription?: string | null
  seoTitle?: string | null
  contentPolicyPolicyId?: number | null
  featureMediaId?: string | null
  yiContentType?: Array<{
    __typename?: 'ContentReference'
    id?: string | null
    sortKey?: number | null
    contentReferenceType?: { __typename?: 'ContentReferenceType'; type?: string | null } | null
    contentTo?: Array<{
      __typename?: 'Content'
      id?: string | null
      titleGroupId?: string | null
      title?: string | null
      contentId?: number | null
      contentType?: string | null
      published?: boolean | null
    } | null> | null
  } | null> | null
  yiTags?: Array<{
    __typename?: 'ContentReference'
    id?: string | null
    sortKey?: number | null
    contentReferenceType?: { __typename?: 'ContentReferenceType'; type?: string | null } | null
    contentTo?: Array<{
      __typename?: 'Content'
      id?: string | null
      titleGroupId?: string | null
      title?: string | null
      contentId?: number | null
      contentType?: string | null
      published?: boolean | null
    } | null> | null
  } | null> | null
  yiYogaStyle?: Array<{
    __typename?: 'ContentReference'
    id?: string | null
    sortKey?: number | null
    contentReferenceType?: { __typename?: 'ContentReferenceType'; type?: string | null } | null
    contentTo?: Array<{
      __typename?: 'Content'
      id?: string | null
      titleGroupId?: string | null
      title?: string | null
      contentId?: number | null
      contentType?: string | null
      published?: boolean | null
    } | null> | null
  } | null> | null
  yiYogaTeacher?: Array<{
    __typename?: 'ContentReference'
    id?: string | null
    sortKey?: number | null
    contentReferenceType?: {
      __typename?: 'ContentReferenceType'
      id?: string | null
      type?: string | null
    } | null
    contentTo?: Array<{
      __typename?: 'Content'
      id?: string | null
      title?: string | null
      language?: string | null
      contentType?: string | null
      contentId?: number | null
      published?: boolean | null
      avatar?: Array<{
        __typename?: 'ImageContentRelationship'
        id?: string | null
        type?: string | null
        image?: { __typename?: 'Image'; id?: string | null; url?: string | null } | null
      } | null> | null
    } | null> | null
  } | null> | null
  yiPracticeType?: Array<{
    __typename?: 'ContentReference'
    id?: string | null
    sortKey?: number | null
    contentReferenceType?: {
      __typename?: 'ContentReferenceType'
      id?: string | null
      type?: string | null
    } | null
    contentTo?: Array<{
      __typename?: 'Content'
      id?: string | null
      title?: string | null
      language?: string | null
      contentType?: string | null
      contentId?: number | null
      published?: boolean | null
      avatar?: Array<{
        __typename?: 'ImageContentRelationship'
        id?: string | null
        type?: string | null
        image?: { __typename?: 'Image'; id?: string | null; url?: string | null } | null
      } | null> | null
    } | null> | null
  } | null> | null
  featureMedia?: {
    __typename?: 'Media'
    mediaId?: string | null
    contentId?: string | null
    mediaMaestroTitleCode?: string | null
    policyId?: number | null
    updatedAt?: any | null
    duration?: number | null
    isPublished?: boolean | null
    mediaAssets?: Array<{
      __typename?: 'MediaAsset'
      id?: string | null
      providerKey?: string | null
    } | null> | null
  } | null
}

export type Mutation_YiMeditation_ContentUpdateMutationVariables = Exact<{
  content: ContentInput
  generatePath?: InputMaybe<Scalars['Boolean']['input']>
}>

export type Mutation_YiMeditation_ContentUpdateMutation = {
  __typename?: 'Mutation'
  contentUpdate?: {
    __typename?: 'ContentUpdateResponse'
    content?: {
      __typename?: 'Content'
      id?: string | null
      contentId?: number | null
      contentType?: string | null
      published?: boolean | null
      publishedAtDate?: any | null
      createdAt?: any | null
      updatedAt?: any | null
      title?: string | null
      path?: string | null
      shortDescription?: string | null
      description?: string | null
      language?: string | null
      contentPolicyPolicyId?: number | null
      descriptionFormat?: string | null
      shortDescriptionFormat?: string | null
      displayType?: string | null
      primaryLanguage?: string | null
      productType?: string | null
      seoDescription?: string | null
      seoTitle?: string | null
      featureMediaId?: string | null
      yiContentType?: Array<{
        __typename?: 'ContentReference'
        id?: string | null
        sortKey?: number | null
        contentReferenceType?: { __typename?: 'ContentReferenceType'; type?: string | null } | null
        contentTo?: Array<{
          __typename?: 'Content'
          id?: string | null
          titleGroupId?: string | null
          title?: string | null
          contentId?: number | null
          contentType?: string | null
          published?: boolean | null
        } | null> | null
      } | null> | null
      yiTags?: Array<{
        __typename?: 'ContentReference'
        id?: string | null
        sortKey?: number | null
        contentReferenceType?: { __typename?: 'ContentReferenceType'; type?: string | null } | null
        contentTo?: Array<{
          __typename?: 'Content'
          id?: string | null
          titleGroupId?: string | null
          title?: string | null
          contentId?: number | null
          contentType?: string | null
          published?: boolean | null
        } | null> | null
      } | null> | null
      yiYogaStyle?: Array<{
        __typename?: 'ContentReference'
        id?: string | null
        sortKey?: number | null
        contentReferenceType?: { __typename?: 'ContentReferenceType'; type?: string | null } | null
        contentTo?: Array<{
          __typename?: 'Content'
          id?: string | null
          titleGroupId?: string | null
          title?: string | null
          contentId?: number | null
          contentType?: string | null
          published?: boolean | null
        } | null> | null
      } | null> | null
      yiYogaTeacher?: Array<{
        __typename?: 'ContentReference'
        id?: string | null
        sortKey?: number | null
        contentReferenceType?: {
          __typename?: 'ContentReferenceType'
          id?: string | null
          type?: string | null
        } | null
        contentTo?: Array<{
          __typename?: 'Content'
          id?: string | null
          title?: string | null
          language?: string | null
          contentType?: string | null
          contentId?: number | null
          published?: boolean | null
          avatar?: Array<{
            __typename?: 'ImageContentRelationship'
            id?: string | null
            type?: string | null
            image?: { __typename?: 'Image'; id?: string | null; url?: string | null } | null
          } | null> | null
        } | null> | null
      } | null> | null
      yiPracticeType?: Array<{
        __typename?: 'ContentReference'
        id?: string | null
        sortKey?: number | null
        contentReferenceType?: {
          __typename?: 'ContentReferenceType'
          id?: string | null
          type?: string | null
        } | null
        contentTo?: Array<{
          __typename?: 'Content'
          id?: string | null
          title?: string | null
          language?: string | null
          contentType?: string | null
          contentId?: number | null
          published?: boolean | null
          avatar?: Array<{
            __typename?: 'ImageContentRelationship'
            id?: string | null
            type?: string | null
            image?: { __typename?: 'Image'; id?: string | null; url?: string | null } | null
          } | null> | null
        } | null> | null
      } | null> | null
      contentProvider?: {
        __typename?: 'ContentProvider'
        provider?: ContentProviderProviders | null
        providerKey?: string | null
        contentId?: string | null
      } | null
      featureMedia?: {
        __typename?: 'Media'
        mediaId?: string | null
        contentId?: string | null
        mediaMaestroTitleCode?: string | null
        policyId?: number | null
        updatedAt?: any | null
        duration?: number | null
        isPublished?: boolean | null
        mediaAssets?: Array<{
          __typename?: 'MediaAsset'
          id?: string | null
          providerKey?: string | null
        } | null> | null
      } | null
    } | null
  } | null
}

export type YiMemberPromo_ContentFragmentFragment = {
  __typename?: 'Content'
  contentPolicyPolicyId?: number | null
  id?: string | null
  contentId?: number | null
  contentType?: string | null
  language?: string | null
  description?: string | null
  descriptionFormat?: string | null
  path?: string | null
  primaryLanguage?: string | null
  published?: boolean | null
  publishedAtDate?: any | null
  title?: string | null
  featureMediaId?: string | null
  yiContentType?: Array<{
    __typename?: 'ContentReference'
    id?: string | null
    sortKey?: number | null
    contentReferenceType?: { __typename?: 'ContentReferenceType'; type?: string | null } | null
    contentTo?: Array<{
      __typename?: 'Content'
      id?: string | null
      titleGroupId?: string | null
      title?: string | null
      contentId?: number | null
      contentType?: string | null
      published?: boolean | null
    } | null> | null
  } | null> | null
  yiGiveAwayCourses?: Array<{
    __typename?: 'ContentReference'
    id?: string | null
    contentTo?: Array<{
      __typename?: 'Content'
      id?: string | null
      contentType?: string | null
      contentId?: number | null
      title?: string | null
      published?: boolean | null
    } | null> | null
  } | null> | null
  yiPromotedContent?: Array<{
    __typename?: 'ContentReference'
    id?: string | null
    contentTo?: Array<{
      __typename?: 'Content'
      id?: string | null
      contentType?: string | null
      contentId?: number | null
      title?: string | null
      published?: boolean | null
      contentProvider?: {
        __typename?: 'ContentProvider'
        provider?: ContentProviderProviders | null
        providerKey?: string | null
        contentId?: string | null
      } | null
      yiContentType?: Array<{
        __typename?: 'ContentReference'
        id?: string | null
        sortKey?: number | null
        contentReferenceType?: { __typename?: 'ContentReferenceType'; type?: string | null } | null
        contentTo?: Array<{
          __typename?: 'Content'
          id?: string | null
          titleGroupId?: string | null
          title?: string | null
          contentId?: number | null
          contentType?: string | null
          published?: boolean | null
        } | null> | null
      } | null> | null
    } | null> | null
  } | null> | null
  featureMedia?: {
    __typename?: 'Media'
    mediaId?: string | null
    contentId?: string | null
    mediaMaestroTitleCode?: string | null
    policyId?: number | null
    updatedAt?: any | null
    duration?: number | null
    isPublished?: boolean | null
    mediaAssets?: Array<{
      __typename?: 'MediaAsset'
      id?: string | null
      providerKey?: string | null
    } | null> | null
  } | null
  providerMetadata?: {
    __typename?: 'ContentProvider'
    metadata?: any | null
    contentId?: string | null
  } | null
}

export type Mutation_YiMemberPromo_ContentUpdateMutationVariables = Exact<{
  content: ContentInput
  generatePath?: InputMaybe<Scalars['Boolean']['input']>
}>

export type Mutation_YiMemberPromo_ContentUpdateMutation = {
  __typename?: 'Mutation'
  contentUpdate?: {
    __typename?: 'ContentUpdateResponse'
    content?: {
      __typename?: 'Content'
      contentPolicyPolicyId?: number | null
      id?: string | null
      contentId?: number | null
      contentType?: string | null
      language?: string | null
      description?: string | null
      descriptionFormat?: string | null
      path?: string | null
      primaryLanguage?: string | null
      published?: boolean | null
      publishedAtDate?: any | null
      title?: string | null
      featureMediaId?: string | null
      yiContentType?: Array<{
        __typename?: 'ContentReference'
        id?: string | null
        sortKey?: number | null
        contentReferenceType?: { __typename?: 'ContentReferenceType'; type?: string | null } | null
        contentTo?: Array<{
          __typename?: 'Content'
          id?: string | null
          titleGroupId?: string | null
          title?: string | null
          contentId?: number | null
          contentType?: string | null
          published?: boolean | null
        } | null> | null
      } | null> | null
      yiGiveAwayCourses?: Array<{
        __typename?: 'ContentReference'
        id?: string | null
        contentTo?: Array<{
          __typename?: 'Content'
          id?: string | null
          contentType?: string | null
          contentId?: number | null
          title?: string | null
          published?: boolean | null
        } | null> | null
      } | null> | null
      yiPromotedContent?: Array<{
        __typename?: 'ContentReference'
        id?: string | null
        contentTo?: Array<{
          __typename?: 'Content'
          id?: string | null
          contentType?: string | null
          contentId?: number | null
          title?: string | null
          published?: boolean | null
          contentProvider?: {
            __typename?: 'ContentProvider'
            provider?: ContentProviderProviders | null
            providerKey?: string | null
            contentId?: string | null
          } | null
          yiContentType?: Array<{
            __typename?: 'ContentReference'
            id?: string | null
            sortKey?: number | null
            contentReferenceType?: {
              __typename?: 'ContentReferenceType'
              type?: string | null
            } | null
            contentTo?: Array<{
              __typename?: 'Content'
              id?: string | null
              titleGroupId?: string | null
              title?: string | null
              contentId?: number | null
              contentType?: string | null
              published?: boolean | null
            } | null> | null
          } | null> | null
        } | null> | null
      } | null> | null
      featureMedia?: {
        __typename?: 'Media'
        mediaId?: string | null
        contentId?: string | null
        mediaMaestroTitleCode?: string | null
        policyId?: number | null
        updatedAt?: any | null
        duration?: number | null
        isPublished?: boolean | null
        mediaAssets?: Array<{
          __typename?: 'MediaAsset'
          id?: string | null
          providerKey?: string | null
        } | null> | null
      } | null
      providerMetadata?: {
        __typename?: 'ContentProvider'
        metadata?: any | null
        contentId?: string | null
      } | null
    } | null
  } | null
}

export type YiPose_ContentFragmentFragment = {
  __typename?: 'Content'
  contentPolicyPolicyId?: number | null
  id?: string | null
  contentId?: number | null
  contentType?: string | null
  language?: string | null
  description?: string | null
  descriptionFormat?: string | null
  shortDescription?: string | null
  shortDescriptionFormat?: string | null
  path?: string | null
  primaryLanguage?: string | null
  published?: boolean | null
  publishedAtDate?: any | null
  seoDescription?: string | null
  seoTitle?: string | null
  title?: string | null
  titleGroupId?: string | null
  yiContentType?: Array<{
    __typename?: 'ContentReference'
    id?: string | null
    sortKey?: number | null
    contentReferenceType?: { __typename?: 'ContentReferenceType'; type?: string | null } | null
    contentTo?: Array<{
      __typename?: 'Content'
      id?: string | null
      titleGroupId?: string | null
      title?: string | null
      contentId?: number | null
      contentType?: string | null
      published?: boolean | null
    } | null> | null
  } | null> | null
  yiTags?: Array<{
    __typename?: 'ContentReference'
    id?: string | null
    sortKey?: number | null
    contentReferenceType?: { __typename?: 'ContentReferenceType'; type?: string | null } | null
    contentTo?: Array<{
      __typename?: 'Content'
      id?: string | null
      titleGroupId?: string | null
      title?: string | null
      contentId?: number | null
      contentType?: string | null
      published?: boolean | null
    } | null> | null
  } | null> | null
  yiPosePronunciation?: Array<{
    __typename?: 'ContentAssetReference'
    id?: string | null
    contentAssetReferenceTypesId?: string | null
    asset?: {
      __typename?: 'Asset'
      id?: string | null
      renderUrl?: string | null
      originalFileName?: string | null
      uuid?: string | null
    } | null
  } | null> | null
  providerMetadata?: {
    __typename?: 'ContentProvider'
    metadata?: any | null
    contentId?: string | null
  } | null
}

export type Mutation_YiPose_ContentUpdateMutationVariables = Exact<{
  content: ContentInput
  generatePath?: InputMaybe<Scalars['Boolean']['input']>
}>

export type Mutation_YiPose_ContentUpdateMutation = {
  __typename?: 'Mutation'
  contentUpdate?: {
    __typename?: 'ContentUpdateResponse'
    content?: {
      __typename?: 'Content'
      id?: string | null
      contentId?: number | null
      contentType?: string | null
      published?: boolean | null
      publishedAtDate?: any | null
      createdAt?: any | null
      updatedAt?: any | null
      title?: string | null
      path?: string | null
      shortDescription?: string | null
      description?: string | null
      language?: string | null
      contentPolicyPolicyId?: number | null
      descriptionFormat?: string | null
      shortDescriptionFormat?: string | null
      primaryLanguage?: string | null
      seoDescription?: string | null
      seoTitle?: string | null
      titleGroupId?: string | null
      yiContentType?: Array<{
        __typename?: 'ContentReference'
        id?: string | null
        sortKey?: number | null
        contentReferenceType?: { __typename?: 'ContentReferenceType'; type?: string | null } | null
        contentTo?: Array<{
          __typename?: 'Content'
          id?: string | null
          titleGroupId?: string | null
          title?: string | null
          contentId?: number | null
          contentType?: string | null
          published?: boolean | null
        } | null> | null
      } | null> | null
      yiTags?: Array<{
        __typename?: 'ContentReference'
        id?: string | null
        sortKey?: number | null
        contentReferenceType?: { __typename?: 'ContentReferenceType'; type?: string | null } | null
        contentTo?: Array<{
          __typename?: 'Content'
          id?: string | null
          titleGroupId?: string | null
          title?: string | null
          contentId?: number | null
          contentType?: string | null
          published?: boolean | null
        } | null> | null
      } | null> | null
      yiPosePronunciation?: Array<{
        __typename?: 'ContentAssetReference'
        id?: string | null
        contentAssetReferenceTypesId?: string | null
        asset?: {
          __typename?: 'Asset'
          id?: string | null
          renderUrl?: string | null
          originalFileName?: string | null
          uuid?: string | null
        } | null
      } | null> | null
      contentProvider?: {
        __typename?: 'ContentProvider'
        provider?: ContentProviderProviders | null
        providerKey?: string | null
        contentId?: string | null
      } | null
      providerMetadata?: {
        __typename?: 'ContentProvider'
        metadata?: any | null
        contentId?: string | null
      } | null
    } | null
  } | null
}

export type SeriesEpisodeSearchContentSelectQueryQueryVariables = Exact<{
  offset?: InputMaybe<Scalars['Int']['input']>
  limit?: InputMaybe<Scalars['Int']['input']>
  where?: InputMaybe<ContentWhereInput>
  referencesNot?: InputMaybe<
    | Array<InputMaybe<ContentContentReferencesToFilterInput>>
    | InputMaybe<ContentContentReferencesToFilterInput>
  >
}>

export type SeriesEpisodeSearchContentSelectQueryQuery = {
  __typename?: 'Query'
  contentList?: {
    __typename?: 'ContentListResponse'
    content?: Array<{
      __typename?: 'Content'
      title?: string | null
      id?: string | null
      contentType?: string | null
      contentId?: number | null
      published?: boolean | null
      seasonNumber?: number | null
      episodeNumber?: number | null
      providerMetadata?: {
        __typename?: 'ContentProvider'
        metadata?: any | null
        contentId?: string | null
      } | null
    } | null> | null
  } | null
}

export type YiSeries_EpisodeDetailsContentFragmentFragment = {
  __typename?: 'Content'
  title?: string | null
  id?: string | null
  contentType?: string | null
  contentId?: number | null
  published?: boolean | null
  seasonNumber?: number | null
  episodeNumber?: number | null
  providerMetadata?: {
    __typename?: 'ContentProvider'
    metadata?: any | null
    contentId?: string | null
  } | null
}

export type YiSeries_EpisodeContentFragmentFragment = {
  __typename?: 'ContentReference'
  id?: string | null
  sortKey?: number | null
  contentReferenceType?: { __typename?: 'ContentReferenceType'; type?: string | null } | null
  contentTo?: Array<{
    __typename?: 'Content'
    title?: string | null
    id?: string | null
    contentType?: string | null
    contentId?: number | null
    published?: boolean | null
    seasonNumber?: number | null
    episodeNumber?: number | null
    providerMetadata?: {
      __typename?: 'ContentProvider'
      metadata?: any | null
      contentId?: string | null
    } | null
  } | null> | null
}

export type YiSeries_ContentFragmentFragment = {
  __typename?: 'Content'
  id?: string | null
  contentId?: number | null
  contentType?: string | null
  published?: boolean | null
  publishedAtDate?: any | null
  createdAt?: any | null
  updatedAt?: any | null
  title?: string | null
  path?: string | null
  shortDescription?: string | null
  shortDescriptionFormat?: string | null
  description?: string | null
  descriptionFormat?: string | null
  productType?: string | null
  language?: string | null
  primaryLanguage?: string | null
  contentPolicyPolicyId?: number | null
  previewMediaId?: string | null
  contentProvider?: {
    __typename?: 'ContentProvider'
    provider?: ContentProviderProviders | null
    providerKey?: string | null
    contentId?: string | null
  } | null
  yiContentType?: Array<{
    __typename?: 'ContentReference'
    id?: string | null
    sortKey?: number | null
    contentReferenceType?: { __typename?: 'ContentReferenceType'; type?: string | null } | null
    contentTo?: Array<{
      __typename?: 'Content'
      id?: string | null
      titleGroupId?: string | null
      title?: string | null
      contentId?: number | null
      contentType?: string | null
      published?: boolean | null
    } | null> | null
  } | null> | null
  yiSeriesEpisodes?: Array<{
    __typename?: 'ContentReference'
    id?: string | null
    sortKey?: number | null
    contentReferenceType?: { __typename?: 'ContentReferenceType'; type?: string | null } | null
    contentTo?: Array<{
      __typename?: 'Content'
      title?: string | null
      id?: string | null
      contentType?: string | null
      contentId?: number | null
      published?: boolean | null
      seasonNumber?: number | null
      episodeNumber?: number | null
      providerMetadata?: {
        __typename?: 'ContentProvider'
        metadata?: any | null
        contentId?: string | null
      } | null
    } | null> | null
  } | null> | null
  previewMedia?: {
    __typename?: 'Media'
    mediaId?: string | null
    contentId?: string | null
    mediaMaestroTitleCode?: string | null
    policyId?: number | null
    updatedAt?: any | null
    duration?: number | null
    isPublished?: boolean | null
    mediaAssets?: Array<{
      __typename?: 'MediaAsset'
      id?: string | null
      providerKey?: string | null
    } | null> | null
  } | null
  providerMetadata?: {
    __typename?: 'ContentProvider'
    metadata?: any | null
    contentId?: string | null
  } | null
}

export type Mutation_YiSeries_ContentUpdateMutationVariables = Exact<{
  content: ContentInput
  generatePath?: InputMaybe<Scalars['Boolean']['input']>
}>

export type Mutation_YiSeries_ContentUpdateMutation = {
  __typename?: 'Mutation'
  contentUpdate?: {
    __typename?: 'ContentUpdateResponse'
    content?: {
      __typename?: 'Content'
      id?: string | null
      contentId?: number | null
      contentType?: string | null
      published?: boolean | null
      publishedAtDate?: any | null
      createdAt?: any | null
      updatedAt?: any | null
      title?: string | null
      path?: string | null
      shortDescription?: string | null
      description?: string | null
      language?: string | null
      contentPolicyPolicyId?: number | null
      shortDescriptionFormat?: string | null
      descriptionFormat?: string | null
      productType?: string | null
      primaryLanguage?: string | null
      previewMediaId?: string | null
      contentProvider?: {
        __typename?: 'ContentProvider'
        provider?: ContentProviderProviders | null
        providerKey?: string | null
        contentId?: string | null
      } | null
      yiContentType?: Array<{
        __typename?: 'ContentReference'
        id?: string | null
        sortKey?: number | null
        contentReferenceType?: { __typename?: 'ContentReferenceType'; type?: string | null } | null
        contentTo?: Array<{
          __typename?: 'Content'
          id?: string | null
          titleGroupId?: string | null
          title?: string | null
          contentId?: number | null
          contentType?: string | null
          published?: boolean | null
        } | null> | null
      } | null> | null
      yiSeriesEpisodes?: Array<{
        __typename?: 'ContentReference'
        id?: string | null
        sortKey?: number | null
        contentReferenceType?: { __typename?: 'ContentReferenceType'; type?: string | null } | null
        contentTo?: Array<{
          __typename?: 'Content'
          title?: string | null
          id?: string | null
          contentType?: string | null
          contentId?: number | null
          published?: boolean | null
          seasonNumber?: number | null
          episodeNumber?: number | null
          providerMetadata?: {
            __typename?: 'ContentProvider'
            metadata?: any | null
            contentId?: string | null
          } | null
        } | null> | null
      } | null> | null
      previewMedia?: {
        __typename?: 'Media'
        mediaId?: string | null
        contentId?: string | null
        mediaMaestroTitleCode?: string | null
        policyId?: number | null
        updatedAt?: any | null
        duration?: number | null
        isPublished?: boolean | null
        mediaAssets?: Array<{
          __typename?: 'MediaAsset'
          id?: string | null
          providerKey?: string | null
        } | null> | null
      } | null
      providerMetadata?: {
        __typename?: 'ContentProvider'
        metadata?: any | null
        contentId?: string | null
      } | null
    } | null
  } | null
}

export type YiSeriesEpisode_ContentFragmentFragment = {
  __typename?: 'Content'
  id?: string | null
  contentId?: number | null
  contentType?: string | null
  published?: boolean | null
  publishedAtDate?: any | null
  createdAt?: any | null
  updatedAt?: any | null
  title?: string | null
  path?: string | null
  shortDescription?: string | null
  shortDescriptionFormat?: string | null
  description?: string | null
  descriptionFormat?: string | null
  productType?: string | null
  language?: string | null
  primaryLanguage?: string | null
  seasonNumber?: number | null
  episodeNumber?: number | null
  contentPolicyPolicyId?: number | null
  previewMediaId?: string | null
  featureMediaId?: string | null
  contentProvider?: {
    __typename?: 'ContentProvider'
    provider?: ContentProviderProviders | null
    providerKey?: string | null
    contentId?: string | null
  } | null
  yiContentType?: Array<{
    __typename?: 'ContentReference'
    id?: string | null
    sortKey?: number | null
    contentReferenceType?: { __typename?: 'ContentReferenceType'; type?: string | null } | null
    contentTo?: Array<{
      __typename?: 'Content'
      id?: string | null
      titleGroupId?: string | null
      title?: string | null
      contentId?: number | null
      contentType?: string | null
      published?: boolean | null
    } | null> | null
  } | null> | null
  yiSeries?: Array<{
    __typename?: 'ContentReference'
    id?: string | null
    contentReferenceType?: { __typename?: 'ContentReferenceType'; type?: string | null } | null
    contentFrom?: Array<{
      __typename?: 'Content'
      id?: string | null
      contentId?: number | null
      contentType?: string | null
      published?: boolean | null
      title?: string | null
      language?: string | null
      primaryLanguage?: string | null
    } | null> | null
  } | null> | null
  previewMedia?: {
    __typename?: 'Media'
    mediaId?: string | null
    contentId?: string | null
    mediaMaestroTitleCode?: string | null
    policyId?: number | null
    updatedAt?: any | null
    duration?: number | null
    isPublished?: boolean | null
    mediaAssets?: Array<{
      __typename?: 'MediaAsset'
      id?: string | null
      providerKey?: string | null
    } | null> | null
  } | null
  featureMedia?: {
    __typename?: 'Media'
    mediaId?: string | null
    contentId?: string | null
    mediaMaestroTitleCode?: string | null
    policyId?: number | null
    updatedAt?: any | null
    duration?: number | null
    isPublished?: boolean | null
    mediaAssets?: Array<{
      __typename?: 'MediaAsset'
      id?: string | null
      providerKey?: string | null
    } | null> | null
  } | null
  providerMetadata?: {
    __typename?: 'ContentProvider'
    metadata?: any | null
    contentId?: string | null
  } | null
}

export type Mutation_YiSeriesEpisode_ContentUpdateMutationVariables = Exact<{
  content: ContentInput
  generatePath?: InputMaybe<Scalars['Boolean']['input']>
}>

export type Mutation_YiSeriesEpisode_ContentUpdateMutation = {
  __typename?: 'Mutation'
  contentUpdate?: {
    __typename?: 'ContentUpdateResponse'
    content?: {
      __typename?: 'Content'
      id?: string | null
      contentId?: number | null
      contentType?: string | null
      published?: boolean | null
      publishedAtDate?: any | null
      createdAt?: any | null
      updatedAt?: any | null
      title?: string | null
      path?: string | null
      shortDescription?: string | null
      shortDescriptionFormat?: string | null
      description?: string | null
      descriptionFormat?: string | null
      productType?: string | null
      language?: string | null
      primaryLanguage?: string | null
      seasonNumber?: number | null
      episodeNumber?: number | null
      contentPolicyPolicyId?: number | null
      previewMediaId?: string | null
      featureMediaId?: string | null
      contentProvider?: {
        __typename?: 'ContentProvider'
        provider?: ContentProviderProviders | null
        providerKey?: string | null
        contentId?: string | null
      } | null
      yiContentType?: Array<{
        __typename?: 'ContentReference'
        id?: string | null
        sortKey?: number | null
        contentReferenceType?: { __typename?: 'ContentReferenceType'; type?: string | null } | null
        contentTo?: Array<{
          __typename?: 'Content'
          id?: string | null
          titleGroupId?: string | null
          title?: string | null
          contentId?: number | null
          contentType?: string | null
          published?: boolean | null
        } | null> | null
      } | null> | null
      yiSeries?: Array<{
        __typename?: 'ContentReference'
        id?: string | null
        contentReferenceType?: { __typename?: 'ContentReferenceType'; type?: string | null } | null
        contentFrom?: Array<{
          __typename?: 'Content'
          id?: string | null
          contentId?: number | null
          contentType?: string | null
          published?: boolean | null
          title?: string | null
          language?: string | null
          primaryLanguage?: string | null
        } | null> | null
      } | null> | null
      previewMedia?: {
        __typename?: 'Media'
        mediaId?: string | null
        contentId?: string | null
        mediaMaestroTitleCode?: string | null
        policyId?: number | null
        updatedAt?: any | null
        duration?: number | null
        isPublished?: boolean | null
        mediaAssets?: Array<{
          __typename?: 'MediaAsset'
          id?: string | null
          providerKey?: string | null
        } | null> | null
      } | null
      featureMedia?: {
        __typename?: 'Media'
        mediaId?: string | null
        contentId?: string | null
        mediaMaestroTitleCode?: string | null
        policyId?: number | null
        updatedAt?: any | null
        duration?: number | null
        isPublished?: boolean | null
        mediaAssets?: Array<{
          __typename?: 'MediaAsset'
          id?: string | null
          providerKey?: string | null
        } | null> | null
      } | null
      providerMetadata?: {
        __typename?: 'ContentProvider'
        metadata?: any | null
        contentId?: string | null
      } | null
    } | null
  } | null
}

export type ContentList_TranslationsQueryQueryVariables = Exact<{
  contentId?: InputMaybe<Scalars['Int']['input']>
}>

export type ContentList_TranslationsQueryQuery = {
  __typename?: 'Query'
  contentList?: {
    __typename?: 'ContentListResponse'
    content?: Array<{
      __typename?: 'Content'
      id?: string | null
      path?: string | null
      contentId?: number | null
      language?: string | null
      primaryLanguage?: string | null
      title?: string | null
      published?: boolean | null
      contentProvider?: {
        __typename?: 'ContentProvider'
        contentId?: string | null
        providerKey?: string | null
      } | null
    } | null> | null
  } | null
}

export type YiTag_ContentFragmentFragment = {
  __typename?: 'Content'
  id?: string | null
  contentId?: number | null
  title?: string | null
  contentType?: string | null
  published?: boolean | null
  publishedAtDate?: any | null
  description?: string | null
  descriptionFormat?: string | null
  language?: string | null
  primaryLanguage?: string | null
  path?: string | null
  seoTitle?: string | null
  contentPolicyPolicyId?: number | null
  featureMediaId?: string | null
  yiContentType?: Array<{
    __typename?: 'ContentReference'
    id?: string | null
    sortKey?: number | null
    contentReferenceType?: { __typename?: 'ContentReferenceType'; type?: string | null } | null
    contentTo?: Array<{
      __typename?: 'Content'
      id?: string | null
      titleGroupId?: string | null
      title?: string | null
      contentId?: number | null
      contentType?: string | null
      published?: boolean | null
    } | null> | null
  } | null> | null
  yiTagGroup?: Array<{
    __typename?: 'ContentReference'
    id?: string | null
    sortKey?: number | null
    contentReferenceType?: { __typename?: 'ContentReferenceType'; type?: string | null } | null
    contentTo?: Array<{
      __typename?: 'Content'
      id?: string | null
      titleGroupId?: string | null
      title?: string | null
      contentId?: number | null
      contentType?: string | null
      published?: boolean | null
    } | null> | null
  } | null> | null
  featureMedia?: {
    __typename?: 'Media'
    mediaId?: string | null
    contentId?: string | null
    mediaMaestroTitleCode?: string | null
    policyId?: number | null
    updatedAt?: any | null
    duration?: number | null
    isPublished?: boolean | null
    mediaAssets?: Array<{
      __typename?: 'MediaAsset'
      id?: string | null
      providerKey?: string | null
    } | null> | null
  } | null
}

export type Mutation_YiTag_ContentUpdateMutationVariables = Exact<{
  content: ContentInput
  generatePath?: InputMaybe<Scalars['Boolean']['input']>
}>

export type Mutation_YiTag_ContentUpdateMutation = {
  __typename?: 'Mutation'
  contentUpdate?: {
    __typename?: 'ContentUpdateResponse'
    content?: {
      __typename?: 'Content'
      id?: string | null
      contentId?: number | null
      title?: string | null
      contentType?: string | null
      published?: boolean | null
      publishedAtDate?: any | null
      description?: string | null
      descriptionFormat?: string | null
      language?: string | null
      primaryLanguage?: string | null
      path?: string | null
      seoTitle?: string | null
      contentPolicyPolicyId?: number | null
      featureMediaId?: string | null
      yiContentType?: Array<{
        __typename?: 'ContentReference'
        id?: string | null
        sortKey?: number | null
        contentReferenceType?: { __typename?: 'ContentReferenceType'; type?: string | null } | null
        contentTo?: Array<{
          __typename?: 'Content'
          id?: string | null
          titleGroupId?: string | null
          title?: string | null
          contentId?: number | null
          contentType?: string | null
          published?: boolean | null
        } | null> | null
      } | null> | null
      yiTagGroup?: Array<{
        __typename?: 'ContentReference'
        id?: string | null
        sortKey?: number | null
        contentReferenceType?: { __typename?: 'ContentReferenceType'; type?: string | null } | null
        contentTo?: Array<{
          __typename?: 'Content'
          id?: string | null
          titleGroupId?: string | null
          title?: string | null
          contentId?: number | null
          contentType?: string | null
          published?: boolean | null
        } | null> | null
      } | null> | null
      featureMedia?: {
        __typename?: 'Media'
        mediaId?: string | null
        contentId?: string | null
        mediaMaestroTitleCode?: string | null
        policyId?: number | null
        updatedAt?: any | null
        duration?: number | null
        isPublished?: boolean | null
        mediaAssets?: Array<{
          __typename?: 'MediaAsset'
          id?: string | null
          providerKey?: string | null
        } | null> | null
      } | null
    } | null
  } | null
}

export type YiTagGroup_ContentFragmentFragment = {
  __typename?: 'Content'
  id?: string | null
  contentId?: number | null
  title?: string | null
  contentType?: string | null
  published?: boolean | null
  publishedAtDate?: any | null
  path?: string | null
  language?: string | null
  yiContentType?: Array<{
    __typename?: 'ContentReference'
    id?: string | null
    sortKey?: number | null
    contentReferenceType?: { __typename?: 'ContentReferenceType'; type?: string | null } | null
    contentTo?: Array<{
      __typename?: 'Content'
      id?: string | null
      titleGroupId?: string | null
      title?: string | null
      contentId?: number | null
      contentType?: string | null
      published?: boolean | null
    } | null> | null
  } | null> | null
  yiTagsRelatedToGroup?: Array<{
    __typename?: 'ContentReference'
    id?: string | null
    sortKey?: number | null
    contentReferenceType?: { __typename?: 'ContentReferenceType'; type?: string | null } | null
    contentFrom?: Array<{
      __typename?: 'Content'
      id?: string | null
      titleGroupId?: string | null
      title?: string | null
      contentId?: number | null
      contentType?: string | null
      published?: boolean | null
    } | null> | null
  } | null> | null
}

export type Mutation_YiTagGroup_ContentUpdateMutationVariables = Exact<{
  content: ContentInput
  generatePath?: InputMaybe<Scalars['Boolean']['input']>
}>

export type Mutation_YiTagGroup_ContentUpdateMutation = {
  __typename?: 'Mutation'
  contentUpdate?: {
    __typename?: 'ContentUpdateResponse'
    content?: {
      __typename?: 'Content'
      id?: string | null
      contentId?: number | null
      title?: string | null
      contentType?: string | null
      published?: boolean | null
      publishedAtDate?: any | null
      path?: string | null
      language?: string | null
      yiContentType?: Array<{
        __typename?: 'ContentReference'
        id?: string | null
        sortKey?: number | null
        contentReferenceType?: { __typename?: 'ContentReferenceType'; type?: string | null } | null
        contentTo?: Array<{
          __typename?: 'Content'
          id?: string | null
          titleGroupId?: string | null
          title?: string | null
          contentId?: number | null
          contentType?: string | null
          published?: boolean | null
        } | null> | null
      } | null> | null
      yiTagsRelatedToGroup?: Array<{
        __typename?: 'ContentReference'
        id?: string | null
        sortKey?: number | null
        contentReferenceType?: { __typename?: 'ContentReferenceType'; type?: string | null } | null
        contentFrom?: Array<{
          __typename?: 'Content'
          id?: string | null
          titleGroupId?: string | null
          title?: string | null
          contentId?: number | null
          contentType?: string | null
          published?: boolean | null
        } | null> | null
      } | null> | null
    } | null
  } | null
}

export type YiTeacher_ContentFragmentFragment = {
  __typename?: 'Content'
  id?: string | null
  contentId?: number | null
  contentType?: string | null
  published?: boolean | null
  publishedAtDate?: any | null
  shortDescription?: string | null
  shortDescriptionFormat?: string | null
  description?: string | null
  descriptionFormat?: string | null
  language?: string | null
  primaryLanguage?: string | null
  path?: string | null
  seoTitle?: string | null
  seoDescription?: string | null
  title?: string | null
  contentPolicyPolicyId?: number | null
  featureMediaId?: string | null
  yiContentType?: Array<{
    __typename?: 'ContentReference'
    id?: string | null
    sortKey?: number | null
    contentReferenceType?: { __typename?: 'ContentReferenceType'; type?: string | null } | null
    contentTo?: Array<{
      __typename?: 'Content'
      id?: string | null
      titleGroupId?: string | null
      title?: string | null
      contentId?: number | null
      contentType?: string | null
      published?: boolean | null
    } | null> | null
  } | null> | null
  yiTags?: Array<{
    __typename?: 'ContentReference'
    id?: string | null
    sortKey?: number | null
    contentReferenceType?: { __typename?: 'ContentReferenceType'; type?: string | null } | null
    contentTo?: Array<{
      __typename?: 'Content'
      id?: string | null
      titleGroupId?: string | null
      title?: string | null
      contentId?: number | null
      contentType?: string | null
      published?: boolean | null
    } | null> | null
  } | null> | null
  featureMedia?: {
    __typename?: 'Media'
    mediaId?: string | null
    contentId?: string | null
    mediaMaestroTitleCode?: string | null
    policyId?: number | null
    updatedAt?: any | null
    duration?: number | null
    isPublished?: boolean | null
    mediaAssets?: Array<{
      __typename?: 'MediaAsset'
      id?: string | null
      providerKey?: string | null
    } | null> | null
  } | null
  providerMetadata?: {
    __typename?: 'ContentProvider'
    metadata?: any | null
    contentId?: string | null
  } | null
}

export type Mutation_YiTeacher_ContentUpdateMutationVariables = Exact<{
  content: ContentInput
  generatePath?: InputMaybe<Scalars['Boolean']['input']>
}>

export type Mutation_YiTeacher_ContentUpdateMutation = {
  __typename?: 'Mutation'
  contentUpdate?: {
    __typename?: 'ContentUpdateResponse'
    content?: {
      __typename?: 'Content'
      id?: string | null
      contentId?: number | null
      contentType?: string | null
      published?: boolean | null
      publishedAtDate?: any | null
      shortDescription?: string | null
      shortDescriptionFormat?: string | null
      description?: string | null
      descriptionFormat?: string | null
      language?: string | null
      primaryLanguage?: string | null
      path?: string | null
      seoTitle?: string | null
      seoDescription?: string | null
      title?: string | null
      contentPolicyPolicyId?: number | null
      featureMediaId?: string | null
      yiContentType?: Array<{
        __typename?: 'ContentReference'
        id?: string | null
        sortKey?: number | null
        contentReferenceType?: { __typename?: 'ContentReferenceType'; type?: string | null } | null
        contentTo?: Array<{
          __typename?: 'Content'
          id?: string | null
          titleGroupId?: string | null
          title?: string | null
          contentId?: number | null
          contentType?: string | null
          published?: boolean | null
        } | null> | null
      } | null> | null
      yiTags?: Array<{
        __typename?: 'ContentReference'
        id?: string | null
        sortKey?: number | null
        contentReferenceType?: { __typename?: 'ContentReferenceType'; type?: string | null } | null
        contentTo?: Array<{
          __typename?: 'Content'
          id?: string | null
          titleGroupId?: string | null
          title?: string | null
          contentId?: number | null
          contentType?: string | null
          published?: boolean | null
        } | null> | null
      } | null> | null
      featureMedia?: {
        __typename?: 'Media'
        mediaId?: string | null
        contentId?: string | null
        mediaMaestroTitleCode?: string | null
        policyId?: number | null
        updatedAt?: any | null
        duration?: number | null
        isPublished?: boolean | null
        mediaAssets?: Array<{
          __typename?: 'MediaAsset'
          id?: string | null
          providerKey?: string | null
        } | null> | null
      } | null
      providerMetadata?: {
        __typename?: 'ContentProvider'
        metadata?: any | null
        contentId?: string | null
      } | null
    } | null
  } | null
}

export type ContentList_ReferenceTypeOptionsQueryQueryVariables = Exact<{
  offset?: InputMaybe<Scalars['Int']['input']>
  limit?: InputMaybe<Scalars['Int']['input']>
  order?: InputMaybe<
    | Array<
        InputMaybe<
          Array<InputMaybe<Scalars['String']['input']>> | InputMaybe<Scalars['String']['input']>
        >
      >
    | InputMaybe<
        Array<InputMaybe<Scalars['String']['input']>> | InputMaybe<Scalars['String']['input']>
      >
  >
  where?: InputMaybe<ContentWhereInput>
  language?: InputMaybe<
    Array<InputMaybe<Scalars['String']['input']>> | InputMaybe<Scalars['String']['input']>
  >
  contentReferencesFromNot?: InputMaybe<
    | Array<InputMaybe<ContentContentReferencesFromFilterInput>>
    | InputMaybe<ContentContentReferencesFromFilterInput>
  >
}>

export type ContentList_ReferenceTypeOptionsQueryQuery = {
  __typename?: 'Query'
  contentList?: {
    __typename?: 'ContentListResponse'
    content?: Array<{
      __typename?: 'Content'
      id?: string | null
      language?: string | null
      title?: string | null
      contentId?: number | null
      contentType?: string | null
      published?: boolean | null
      contentProvider?: {
        __typename?: 'ContentProvider'
        provider?: ContentProviderProviders | null
        providerKey?: string | null
        contentId?: string | null
      } | null
      yiContentType?: Array<{
        __typename?: 'ContentReference'
        id?: string | null
        sortKey?: number | null
        contentReferenceType?: { __typename?: 'ContentReferenceType'; type?: string | null } | null
        contentTo?: Array<{
          __typename?: 'Content'
          id?: string | null
          titleGroupId?: string | null
          title?: string | null
          contentId?: number | null
          contentType?: string | null
          published?: boolean | null
        } | null> | null
      } | null> | null
    } | null> | null
  } | null
}

export type ContentUpdatedAtByIdQueryVariables = Exact<{
  id: Scalars['ID']['input']
}>

export type ContentUpdatedAtByIdQuery = {
  __typename?: 'Query'
  contentList?: {
    __typename?: 'ContentListResponse'
    content?: Array<{ __typename?: 'Content'; updatedAt?: any | null } | null> | null
  } | null
}

export type ContentImages_ImageContentRelationshipsFragmentFragment = {
  __typename?: 'ImageContentRelationship'
  id?: string | null
  type?: string | null
  image?: {
    __typename?: 'Image'
    id?: string | null
    url?: string | null
    asset?: { __typename?: 'Asset'; providerSourceRenderUrl?: string | null } | null
  } | null
}

export type ContentImages_ContentDetailsFragmentFragment = {
  __typename?: 'Content'
  id?: string | null
  contentId?: number | null
  contentType?: string | null
  language?: string | null
  primaryLanguage?: string | null
  images?: Array<{
    __typename?: 'ImageContentRelationship'
    id?: string | null
    type?: string | null
    image?: {
      __typename?: 'Image'
      id?: string | null
      url?: string | null
      asset?: { __typename?: 'Asset'; providerSourceRenderUrl?: string | null } | null
    } | null
  } | null> | null
}

export type ContentImagesQueryVariables = Exact<{
  offset?: InputMaybe<Scalars['Int']['input']>
  limit?: InputMaybe<Scalars['Int']['input']>
  order?: InputMaybe<
    | Array<
        InputMaybe<
          Array<InputMaybe<Scalars['String']['input']>> | InputMaybe<Scalars['String']['input']>
        >
      >
    | InputMaybe<
        Array<InputMaybe<Scalars['String']['input']>> | InputMaybe<Scalars['String']['input']>
      >
  >
  where?: InputMaybe<ContentWhereInput>
  contentReferencesTo?: InputMaybe<
    | Array<InputMaybe<ContentContentReferencesToFilterInput>>
    | InputMaybe<ContentContentReferencesToFilterInput>
  >
}>

export type ContentImagesQuery = {
  __typename?: 'Query'
  contentList?: {
    __typename?: 'ContentListResponse'
    content?: Array<{
      __typename?: 'Content'
      id?: string | null
      contentId?: number | null
      contentType?: string | null
      language?: string | null
      primaryLanguage?: string | null
      images?: Array<{
        __typename?: 'ImageContentRelationship'
        id?: string | null
        type?: string | null
        image?: {
          __typename?: 'Image'
          id?: string | null
          url?: string | null
          asset?: { __typename?: 'Asset'; providerSourceRenderUrl?: string | null } | null
        } | null
      } | null> | null
    } | null> | null
  } | null
}

export type MediaList_OptionsQueryQueryVariables = Exact<{
  offset?: InputMaybe<Scalars['Int']['input']>
  limit?: InputMaybe<Scalars['Int']['input']>
  where?: InputMaybe<MediaWhereInput>
  order?: InputMaybe<
    | Array<
        InputMaybe<
          Array<InputMaybe<Scalars['String']['input']>> | InputMaybe<Scalars['String']['input']>
        >
      >
    | InputMaybe<
        Array<InputMaybe<Scalars['String']['input']>> | InputMaybe<Scalars['String']['input']>
      >
  >
}>

export type MediaList_OptionsQueryQuery = {
  __typename?: 'Query'
  mediaList?: {
    __typename?: 'MediaListResponse'
    media?: Array<{
      __typename?: 'Media'
      mediaId?: string | null
      contentId?: string | null
      mediaMaestroTitleCode?: string | null
      policyId?: number | null
      updatedAt?: any | null
      duration?: number | null
      isPublished?: boolean | null
      mediaAssets?: Array<{
        __typename?: 'MediaAsset'
        id?: string | null
        providerKey?: string | null
      } | null> | null
    } | null> | null
  } | null
}

export type ContentList_YiReferenceContentFragmentFragment = {
  __typename?: 'Content'
  contentId?: number | null
  id?: string | null
  contentType?: string | null
  title?: string | null
  language?: string | null
  published?: boolean | null
  yiContentType?: Array<{
    __typename?: 'ContentReference'
    id?: string | null
    sortKey?: number | null
    contentReferenceType?: { __typename?: 'ContentReferenceType'; type?: string | null } | null
    contentTo?: Array<{
      __typename?: 'Content'
      id?: string | null
      titleGroupId?: string | null
      title?: string | null
      contentId?: number | null
      contentType?: string | null
      published?: boolean | null
    } | null> | null
  } | null> | null
}

export type ContentList_YiReferencesFromListQueryQueryVariables = Exact<{
  id?: InputMaybe<Scalars['ID']['input']>
  types?: InputMaybe<
    Array<InputMaybe<Scalars['String']['input']>> | InputMaybe<Scalars['String']['input']>
  >
  limit?: InputMaybe<Scalars['Int']['input']>
}>

export type ContentList_YiReferencesFromListQueryQuery = {
  __typename?: 'Query'
  contentList?: {
    __typename?: 'ContentListResponse'
    content?: Array<{
      __typename?: 'Content'
      contentReferencesFrom?: Array<{
        __typename?: 'ContentReference'
        contentReferenceType?: { __typename?: 'ContentReferenceType'; type?: string | null } | null
        contentTo?: Array<{
          __typename?: 'Content'
          contentId?: number | null
          id?: string | null
          contentType?: string | null
          title?: string | null
          language?: string | null
          published?: boolean | null
          yiContentType?: Array<{
            __typename?: 'ContentReference'
            id?: string | null
            sortKey?: number | null
            contentReferenceType?: {
              __typename?: 'ContentReferenceType'
              type?: string | null
            } | null
            contentTo?: Array<{
              __typename?: 'Content'
              id?: string | null
              titleGroupId?: string | null
              title?: string | null
              contentId?: number | null
              contentType?: string | null
              published?: boolean | null
            } | null> | null
          } | null> | null
        } | null> | null
      } | null> | null
    } | null> | null
  } | null
}

export type ContentList_YiReferencesToListQueryQueryVariables = Exact<{
  id?: InputMaybe<Scalars['ID']['input']>
  types?: InputMaybe<
    Array<InputMaybe<Scalars['String']['input']>> | InputMaybe<Scalars['String']['input']>
  >
  limit?: InputMaybe<Scalars['Int']['input']>
}>

export type ContentList_YiReferencesToListQueryQuery = {
  __typename?: 'Query'
  contentList?: {
    __typename?: 'ContentListResponse'
    content?: Array<{
      __typename?: 'Content'
      contentReferencesTo?: Array<{
        __typename?: 'ContentReference'
        contentReferenceType?: { __typename?: 'ContentReferenceType'; type?: string | null } | null
        contentFrom?: Array<{
          __typename?: 'Content'
          contentId?: number | null
          id?: string | null
          contentType?: string | null
          title?: string | null
          language?: string | null
          published?: boolean | null
          yiContentType?: Array<{
            __typename?: 'ContentReference'
            id?: string | null
            sortKey?: number | null
            contentReferenceType?: {
              __typename?: 'ContentReferenceType'
              type?: string | null
            } | null
            contentTo?: Array<{
              __typename?: 'Content'
              id?: string | null
              titleGroupId?: string | null
              title?: string | null
              contentId?: number | null
              contentType?: string | null
              published?: boolean | null
            } | null> | null
          } | null> | null
        } | null> | null
      } | null> | null
    } | null> | null
  } | null
}

export type ContentReferenceTypesListQueryQueryVariables = Exact<{ [key: string]: never }>

export type ContentReferenceTypesListQueryQuery = {
  __typename?: 'Query'
  contentReferenceTypesList?: {
    __typename?: 'ContentReferenceTypesListResponse'
    contentReferenceTypes?: Array<{
      __typename?: 'ContentReferenceType'
      type?: string | null
      id?: string | null
    } | null> | null
  } | null
}

export type ContentList_YiTeacherQueryQueryVariables = Exact<{
  name: Scalars['String']['input']
  offset?: InputMaybe<Scalars['Int']['input']>
  limit?: InputMaybe<Scalars['Int']['input']>
}>

export type ContentList_YiTeacherQueryQuery = {
  __typename?: 'Query'
  contentList?: {
    __typename?: 'ContentListResponse'
    content?: Array<{
      __typename?: 'Content'
      id?: string | null
      title?: string | null
      language?: string | null
      contentType?: string | null
      contentId?: number | null
      published?: boolean | null
      avatar?: Array<{
        __typename?: 'ImageContentRelationship'
        id?: string | null
        type?: string | null
        image?: { __typename?: 'Image'; id?: string | null; url?: string | null } | null
      } | null> | null
    } | null> | null
  } | null
}

export type ContentPageTagListQueryQueryVariables = Exact<{
  limit?: InputMaybe<Scalars['Int']['input']>
}>

export type ContentPageTagListQueryQuery = {
  __typename?: 'Query'
  contentList?: {
    __typename?: 'ContentListResponse'
    content?: Array<{
      __typename?: 'Content'
      id?: string | null
      contentId?: number | null
      contentType?: string | null
      language?: string | null
      titleGroupId?: string | null
      title?: string | null
    } | null> | null
  } | null
}

export type ContentPageTeacherListQueryQueryVariables = Exact<{
  limit?: InputMaybe<Scalars['Int']['input']>
}>

export type ContentPageTeacherListQueryQuery = {
  __typename?: 'Query'
  contentList?: {
    __typename?: 'ContentListResponse'
    content?: Array<{
      __typename?: 'Content'
      id?: string | null
      contentId?: number | null
      contentType?: string | null
      language?: string | null
      titleGroupId?: string | null
      title?: string | null
    } | null> | null
  } | null
}

export type ContentListYiQueryQueryVariables = Exact<{
  language?: InputMaybe<
    Array<InputMaybe<Scalars['String']['input']>> | InputMaybe<Scalars['String']['input']>
  >
  offset?: InputMaybe<Scalars['Int']['input']>
  limit?: InputMaybe<Scalars['Int']['input']>
  order?: InputMaybe<
    | Array<
        InputMaybe<
          Array<InputMaybe<Scalars['String']['input']>> | InputMaybe<Scalars['String']['input']>
        >
      >
    | InputMaybe<
        Array<InputMaybe<Scalars['String']['input']>> | InputMaybe<Scalars['String']['input']>
      >
  >
  where?: InputMaybe<ContentWhereInput>
  references?: InputMaybe<
    | Array<InputMaybe<ContentContentReferencesToFilterInput>>
    | InputMaybe<ContentContentReferencesToFilterInput>
  >
  referencesEvery?: InputMaybe<
    | Array<InputMaybe<ContentContentReferencesToFilterInput>>
    | InputMaybe<ContentContentReferencesToFilterInput>
  >
  referencesNot?: InputMaybe<
    | Array<InputMaybe<ContentContentReferencesToFilterInput>>
    | InputMaybe<ContentContentReferencesToFilterInput>
  >
  contentProviders?: InputMaybe<
    | Array<InputMaybe<ContentContentProviderFilterInput>>
    | InputMaybe<ContentContentProviderFilterInput>
  >
}>

export type ContentListYiQueryQuery = {
  __typename?: 'Query'
  contentList?: {
    __typename?: 'ContentListResponse'
    limit?: number | null
    offset?: number | null
    count?: number | null
    content?: Array<{
      __typename?: 'Content'
      id?: string | null
      contentId?: number | null
      contentType?: string | null
      language?: string | null
      primaryLanguage?: string | null
      title?: string | null
      path?: string | null
      published?: boolean | null
      publishedAtDate?: any | null
      createdAt?: any | null
      updatedAt?: any | null
      contentProvider?: {
        __typename?: 'ContentProvider'
        provider?: ContentProviderProviders | null
        providerKey?: string | null
        contentId?: string | null
      } | null
      yiContentType?: Array<{
        __typename?: 'ContentReference'
        id?: string | null
        sortKey?: number | null
        contentReferenceType?: { __typename?: 'ContentReferenceType'; type?: string | null } | null
        contentTo?: Array<{
          __typename?: 'Content'
          id?: string | null
          titleGroupId?: string | null
          title?: string | null
          contentId?: number | null
          contentType?: string | null
          published?: boolean | null
        } | null> | null
      } | null> | null
      yiYogaTeacher?: Array<{
        __typename?: 'ContentReference'
        id?: string | null
        sortKey?: number | null
        contentReferenceType?: {
          __typename?: 'ContentReferenceType'
          id?: string | null
          type?: string | null
        } | null
        contentTo?: Array<{
          __typename?: 'Content'
          id?: string | null
          title?: string | null
          language?: string | null
          contentType?: string | null
          contentId?: number | null
          published?: boolean | null
          avatar?: Array<{
            __typename?: 'ImageContentRelationship'
            id?: string | null
            type?: string | null
            image?: { __typename?: 'Image'; id?: string | null; url?: string | null } | null
          } | null> | null
        } | null> | null
      } | null> | null
      yiTags?: Array<{
        __typename?: 'ContentReference'
        id?: string | null
        sortKey?: number | null
        contentReferenceType?: { __typename?: 'ContentReferenceType'; type?: string | null } | null
        contentTo?: Array<{
          __typename?: 'Content'
          id?: string | null
          titleGroupId?: string | null
          title?: string | null
          contentId?: number | null
          contentType?: string | null
          published?: boolean | null
        } | null> | null
      } | null> | null
      yiYogaStyle?: Array<{
        __typename?: 'ContentReference'
        id?: string | null
        sortKey?: number | null
        contentReferenceType?: { __typename?: 'ContentReferenceType'; type?: string | null } | null
        contentTo?: Array<{
          __typename?: 'Content'
          id?: string | null
          titleGroupId?: string | null
          title?: string | null
          contentId?: number | null
          contentType?: string | null
          published?: boolean | null
        } | null> | null
      } | null> | null
      yiYogaLevel?: Array<{
        __typename?: 'ContentReference'
        id?: string | null
        sortKey?: number | null
        contentReferenceType?: { __typename?: 'ContentReferenceType'; type?: string | null } | null
        contentTo?: Array<{
          __typename?: 'Content'
          id?: string | null
          titleGroupId?: string | null
          title?: string | null
          contentId?: number | null
          contentType?: string | null
          published?: boolean | null
        } | null> | null
      } | null> | null
      providerMetadata?: {
        __typename?: 'ContentProvider'
        metadata?: any | null
        contentId?: string | null
      } | null
    } | null> | null
  } | null
}

export type YiMediaCreate_MediaByContentIdQueryQueryVariables = Exact<{
  contentId?: InputMaybe<Scalars['ID']['input']>
}>

export type YiMediaCreate_MediaByContentIdQueryQuery = {
  __typename?: 'Query'
  mediaList?: {
    __typename?: 'MediaListResponse'
    count?: number | null
    media?: Array<{ __typename?: 'Media'; mediaId?: string | null } | null> | null
  } | null
}

export type MediaDetailsPageQueryQueryVariables = Exact<{
  mediaId: Scalars['ID']['input']
}>

export type MediaDetailsPageQueryQuery = {
  __typename?: 'Query'
  mediaList?: {
    __typename?: 'MediaListResponse'
    media?: Array<{
      __typename?: 'Media'
      mediaId?: string | null
      policyId?: number | null
      use?: number | null
      contentId?: string | null
      mediaMaestroTitleCode?: string | null
      subtype?: string | null
      filename?: string | null
      isPublished?: boolean | null
      createdAt?: any | null
      updatedAt?: any | null
      duration?: number | null
      aspectRatio?: string | null
      videoSize?: number | null
      framerate?: number | null
      mediaAssets?: Array<{
        __typename?: 'MediaAsset'
        originalFileName?: string | null
        updatedAt?: any | null
        language?: string | null
        id?: string | null
        mediaReferenceType?: string | null
      } | null> | null
    } | null> | null
  } | null
}

export type MediaListYiReferencesQueryVariables = Exact<{
  mediaId?: InputMaybe<Scalars['ID']['input']>
}>

export type MediaListYiReferencesQuery = {
  __typename?: 'Query'
  mediaList?: {
    __typename?: 'MediaListResponse'
    media?: Array<{
      __typename?: 'Media'
      mediaId?: string | null
      contentFeatured?: Array<{
        __typename?: 'Content'
        id?: string | null
        title?: string | null
      } | null> | null
      contentPreview?: Array<{
        __typename?: 'Content'
        id?: string | null
        title?: string | null
      } | null> | null
    } | null> | null
  } | null
}

export type MediaListQueryVariables = Exact<{
  offset?: InputMaybe<Scalars['Int']['input']>
  limit?: InputMaybe<Scalars['Int']['input']>
  order?: InputMaybe<
    | Array<
        InputMaybe<
          Array<InputMaybe<Scalars['String']['input']>> | InputMaybe<Scalars['String']['input']>
        >
      >
    | InputMaybe<
        Array<InputMaybe<Scalars['String']['input']>> | InputMaybe<Scalars['String']['input']>
      >
  >
  where?: InputMaybe<MediaWhereInput>
}>

export type MediaListQuery = {
  __typename?: 'Query'
  mediaList?: {
    __typename?: 'MediaListResponse'
    count?: number | null
    media?: Array<{
      __typename?: 'Media'
      mediaId?: string | null
      policyId?: number | null
      use?: number | null
      contentId?: string | null
      createdAt?: any | null
    } | null> | null
  } | null
}

export type ContentPolicyList_YiQueryQueryVariables = Exact<{ [key: string]: never }>

export type ContentPolicyList_YiQueryQuery = {
  __typename?: 'Query'
  contentPolicyList?: {
    __typename?: 'ContentPolicyListResponse'
    contentPolicies?: Array<{
      __typename?: 'ContentPolicy'
      policyId?: string | null
      name?: string | null
    } | null> | null
  } | null
}

export type Common_ContentFragmentFragment = {
  __typename?: 'Content'
  id?: string | null
  contentId?: number | null
  contentType?: string | null
  published?: boolean | null
  publishedAtDate?: any | null
  createdAt?: any | null
  updatedAt?: any | null
  title?: string | null
  path?: string | null
  shortDescription?: string | null
  description?: string | null
  language?: string | null
  contentPolicyPolicyId?: number | null
  contentProvider?: {
    __typename?: 'ContentProvider'
    provider?: ContentProviderProviders | null
    providerKey?: string | null
    contentId?: string | null
  } | null
}

export type Common_ContentProviderFragmentFragment = {
  __typename?: 'Content'
  contentProvider?: {
    __typename?: 'ContentProvider'
    provider?: ContentProviderProviders | null
    providerKey?: string | null
    contentId?: string | null
  } | null
}

export type Common_MediaFragmentFragment = {
  __typename?: 'Media'
  mediaId?: string | null
  contentId?: string | null
  mediaMaestroTitleCode?: string | null
  policyId?: number | null
  updatedAt?: any | null
  duration?: number | null
  isPublished?: boolean | null
  mediaAssets?: Array<{
    __typename?: 'MediaAsset'
    id?: string | null
    providerKey?: string | null
  } | null> | null
}

export type ContentAssetReferenceDeleteMutationMutationVariables = Exact<{
  contentAssetReference: ContentAssetReferenceDeleteInput
}>

export type ContentAssetReferenceDeleteMutationMutation = {
  __typename?: 'Mutation'
  contentAssetReferenceDelete: {
    __typename?: 'ContentAssetReferenceMutationResponse'
    success: boolean
  }
}

export type ContentDetails_ContentAssetReferenceFragmentFragment = {
  __typename?: 'ContentAssetReference'
  id?: string | null
  asset?: {
    __typename?: 'Asset'
    id?: string | null
    mimeType?: string | null
    fileSize?: number | null
    originalFileName?: string | null
    renderUrl?: string | null
    contentAssetReference?: {
      __typename?: 'ContentAssetReference'
      assetsId?: string | null
    } | null
  } | null
}

export type ContentDetails_Person_ContentFragmentFragment = {
  __typename?: 'Content'
  id?: string | null
  title?: string | null
  language?: string | null
  contentType?: string | null
  contentId?: number | null
  published?: boolean | null
  avatar?: Array<{
    __typename?: 'ImageContentRelationship'
    id?: string | null
    type?: string | null
    image?: { __typename?: 'Image'; id?: string | null; url?: string | null } | null
  } | null> | null
}

export type ContentDetails_Person_ContentReferenceFragmentFragment = {
  __typename?: 'ContentReference'
  id?: string | null
  sortKey?: number | null
  contentReferenceType?: {
    __typename?: 'ContentReferenceType'
    id?: string | null
    type?: string | null
  } | null
  contentTo?: Array<{
    __typename?: 'Content'
    id?: string | null
    title?: string | null
    language?: string | null
    contentType?: string | null
    contentId?: number | null
    published?: boolean | null
    avatar?: Array<{
      __typename?: 'ImageContentRelationship'
      id?: string | null
      type?: string | null
      image?: { __typename?: 'Image'; id?: string | null; url?: string | null } | null
    } | null> | null
  } | null> | null
}

export type ContentDetails_Tag_ContentReferenceFragmentFragment = {
  __typename?: 'ContentReference'
  id?: string | null
  sortKey?: number | null
  contentReferenceType?: { __typename?: 'ContentReferenceType'; type?: string | null } | null
  contentTo?: Array<{
    __typename?: 'Content'
    id?: string | null
    titleGroupId?: string | null
    title?: string | null
    contentId?: number | null
    contentType?: string | null
    published?: boolean | null
  } | null> | null
}

export type ContentFeatureMediaFragmentFragment = {
  __typename?: 'Content'
  contentPolicyPolicyId?: number | null
  featureMediaId?: string | null
  featureMedia?: {
    __typename?: 'Media'
    mediaId?: string | null
    contentId?: string | null
    mediaMaestroTitleCode?: string | null
    policyId?: number | null
    updatedAt?: any | null
    duration?: number | null
    isPublished?: boolean | null
    mediaAssets?: Array<{
      __typename?: 'MediaAsset'
      id?: string | null
      providerKey?: string | null
    } | null> | null
  } | null
}

export type ContentList_AllYiTagsListQueryQueryVariables = Exact<{
  path: Scalars['String']['input']
  offset?: InputMaybe<Scalars['Int']['input']>
  limit?: InputMaybe<Scalars['Int']['input']>
  language?: InputMaybe<Array<Scalars['String']['input']> | Scalars['String']['input']>
}>

export type ContentList_AllYiTagsListQueryQuery = {
  __typename?: 'Query'
  contentList?: {
    __typename?: 'ContentListResponse'
    content?: Array<{
      __typename?: 'Content'
      id?: string | null
      language?: string | null
      title?: string | null
      contentId?: number | null
      contentType?: string | null
      published?: boolean | null
      contentProvider?: {
        __typename?: 'ContentProvider'
        providerKey?: string | null
        contentId?: string | null
      } | null
    } | null> | null
  } | null
}

export type ContentList_YiSpecialTagsByTitlesQueryVariables = Exact<{
  titles?: InputMaybe<Array<Scalars['String']['input']> | Scalars['String']['input']>
  contentPolicyPolicyId: Scalars['Int']['input']
}>

export type ContentList_YiSpecialTagsByTitlesQuery = {
  __typename?: 'Query'
  contentList?: {
    __typename?: 'ContentListResponse'
    content?: Array<{
      __typename?: 'Content'
      id?: string | null
      language?: string | null
      title?: string | null
      contentId?: number | null
      contentType?: string | null
      published?: boolean | null
      contentProvider?: {
        __typename?: 'ContentProvider'
        providerKey?: string | null
        contentId?: string | null
      } | null
    } | null> | null
  } | null
}

export type ContentList_YiTagsListByGroupQueryQueryVariables = Exact<{
  path: Scalars['String']['input']
  offset?: InputMaybe<Scalars['Int']['input']>
  limit?: InputMaybe<Scalars['Int']['input']>
  language?: InputMaybe<Array<Scalars['String']['input']> | Scalars['String']['input']>
  contentReferencesTo?: InputMaybe<
    | Array<InputMaybe<ContentContentReferencesToFilterInput>>
    | InputMaybe<ContentContentReferencesToFilterInput>
  >
}>

export type ContentList_YiTagsListByGroupQueryQuery = {
  __typename?: 'Query'
  contentList?: {
    __typename?: 'ContentListResponse'
    content?: Array<{
      __typename?: 'Content'
      id?: string | null
      contentReferencesTo?: Array<{
        __typename?: 'ContentReference'
        id?: string | null
        contentFrom?: Array<{
          __typename?: 'Content'
          id?: string | null
          language?: string | null
          title?: string | null
          contentId?: number | null
          contentType?: string | null
          published?: boolean | null
          contentProvider?: {
            __typename?: 'ContentProvider'
            providerKey?: string | null
            contentId?: string | null
          } | null
        } | null> | null
      } | null> | null
    } | null> | null
  } | null
}

export type ContentPreviewMediaFragmentFragment = {
  __typename?: 'Content'
  contentPolicyPolicyId?: number | null
  previewMediaId?: string | null
  previewMedia?: {
    __typename?: 'Media'
    mediaId?: string | null
    contentId?: string | null
    mediaMaestroTitleCode?: string | null
    policyId?: number | null
    updatedAt?: any | null
    duration?: number | null
    isPublished?: boolean | null
    mediaAssets?: Array<{
      __typename?: 'MediaAsset'
      id?: string | null
      providerKey?: string | null
    } | null> | null
  } | null
}

export type Content_ProviderCommonFragmentFragment = {
  __typename?: 'ContentProvider'
  contentId?: string | null
}

export type Content_ProviderMetadataFragmentFragment = {
  __typename?: 'Content'
  providerMetadata?: {
    __typename?: 'ContentProvider'
    metadata?: any | null
    contentId?: string | null
  } | null
}

export type ContentReferenceCreateManyMutationVariables = Exact<{
  contentReferences: Array<ContentReferenceCreateInput> | ContentReferenceCreateInput
  deleteOmittedReferences?: InputMaybe<Scalars['Boolean']['input']>
}>

export type ContentReferenceCreateManyMutation = {
  __typename?: 'Mutation'
  contentReferenceCreateMany: {
    __typename?: 'ContentReferenceCreateManyResponse'
    contentReferences?: Array<{
      __typename?: 'ContentReference'
      id?: string | null
      sortKey?: number | null
    } | null> | null
  }
}

export type ContentReferenceDeleteMutationVariables = Exact<{
  contentReference?: InputMaybe<ContentReferenceDeleteInput>
}>

export type ContentReferenceDeleteMutation = {
  __typename?: 'Mutation'
  contentReferenceDelete: {
    __typename?: 'ContentReferenceDeleteResponse'
    contentReference?: {
      __typename?: 'ContentReference'
      id?: string | null
      fromContentContentId?: number | null
      fromContentContentType?: string | null
      toContentContentId?: number | null
      toContentContentType?: string | null
      contentReferenceTypesId?: string | null
    } | null
  }
}

export type UpdateProviderMetadataMutationVariables = Exact<{
  contentProvider: ContentProviderUpdateByContentIdInput
}>

export type UpdateProviderMetadataMutation = {
  __typename?: 'Mutation'
  contentProviderUpdateByContentId?: {
    __typename?: 'ContentProviderMutationResponse'
    contentProvider?: {
      __typename?: 'ContentProvider'
      metadata?: any | null
      contentId?: string | null
    } | null
  } | null
}

export type YiContentListQueryVariables = Exact<{
  offset?: InputMaybe<Scalars['Int']['input']>
  limit?: InputMaybe<Scalars['Int']['input']>
  order?: InputMaybe<
    | Array<
        InputMaybe<
          Array<InputMaybe<Scalars['String']['input']>> | InputMaybe<Scalars['String']['input']>
        >
      >
    | InputMaybe<
        Array<InputMaybe<Scalars['String']['input']>> | InputMaybe<Scalars['String']['input']>
      >
  >
  where?: InputMaybe<ContentWhereInput>
  contentReferencesTo?: InputMaybe<
    | Array<InputMaybe<ContentContentReferencesToFilterInput>>
    | InputMaybe<ContentContentReferencesToFilterInput>
  >
}>

export type YiContentListQuery = {
  __typename?: 'Query'
  contentList?: {
    __typename?: 'ContentListResponse'
    content?: Array<{
      __typename?: 'Content'
      id?: string | null
      contentId?: number | null
      contentType?: string | null
      published?: boolean | null
      publishedAtDate?: any | null
      createdAt?: any | null
      updatedAt?: any | null
      title?: string | null
      path?: string | null
      shortDescription?: string | null
      description?: string | null
      language?: string | null
      contentPolicyPolicyId?: number | null
      descriptionFormat?: string | null
      shortDescriptionFormat?: string | null
      displayType?: string | null
      primaryLanguage?: string | null
      productType?: string | null
      seoDescription?: string | null
      seoTitle?: string | null
      episodeNumber?: number | null
      seasonNumber?: number | null
      director?: string | null
      producer?: string | null
      writer?: string | null
      studio?: string | null
      copyright?: string | null
      instructor?: string | null
      cast?: string | null
      seoKeywords?: string | null
      seoRobotsNoFollow?: boolean | null
      seoRobotsNoIndex?: boolean | null
      excludeFromRecommendations?: boolean | null
      contentSearchNoIndex?: boolean | null
      featureMediaId?: string | null
      titleGroupId?: string | null
      previewMediaId?: string | null
      yiContentType?: Array<{
        __typename?: 'ContentReference'
        id?: string | null
        sortKey?: number | null
        contentReferenceType?: { __typename?: 'ContentReferenceType'; type?: string | null } | null
        contentTo?: Array<{
          __typename?: 'Content'
          id?: string | null
          titleGroupId?: string | null
          title?: string | null
          contentId?: number | null
          contentType?: string | null
          published?: boolean | null
        } | null> | null
      } | null> | null
      yiTags?: Array<{
        __typename?: 'ContentReference'
        id?: string | null
        sortKey?: number | null
        contentReferenceType?: { __typename?: 'ContentReferenceType'; type?: string | null } | null
        contentTo?: Array<{
          __typename?: 'Content'
          id?: string | null
          titleGroupId?: string | null
          title?: string | null
          contentId?: number | null
          contentType?: string | null
          published?: boolean | null
        } | null> | null
      } | null> | null
      yiYogaStyle?: Array<{
        __typename?: 'ContentReference'
        id?: string | null
        sortKey?: number | null
        contentReferenceType?: { __typename?: 'ContentReferenceType'; type?: string | null } | null
        contentTo?: Array<{
          __typename?: 'Content'
          id?: string | null
          titleGroupId?: string | null
          title?: string | null
          contentId?: number | null
          contentType?: string | null
          published?: boolean | null
        } | null> | null
      } | null> | null
      yiYogaLevel?: Array<{
        __typename?: 'ContentReference'
        id?: string | null
        sortKey?: number | null
        contentReferenceType?: { __typename?: 'ContentReferenceType'; type?: string | null } | null
        contentTo?: Array<{
          __typename?: 'Content'
          id?: string | null
          titleGroupId?: string | null
          title?: string | null
          contentId?: number | null
          contentType?: string | null
          published?: boolean | null
        } | null> | null
      } | null> | null
      yiYogaTeacher?: Array<{
        __typename?: 'ContentReference'
        id?: string | null
        sortKey?: number | null
        contentReferenceType?: {
          __typename?: 'ContentReferenceType'
          id?: string | null
          type?: string | null
        } | null
        contentTo?: Array<{
          __typename?: 'Content'
          id?: string | null
          title?: string | null
          language?: string | null
          contentType?: string | null
          contentId?: number | null
          published?: boolean | null
          avatar?: Array<{
            __typename?: 'ImageContentRelationship'
            id?: string | null
            type?: string | null
            image?: { __typename?: 'Image'; id?: string | null; url?: string | null } | null
          } | null> | null
        } | null> | null
      } | null> | null
      yiPracticeType?: Array<{
        __typename?: 'ContentReference'
        id?: string | null
        sortKey?: number | null
        contentReferenceType?: { __typename?: 'ContentReferenceType'; type?: string | null } | null
        contentTo?: Array<{
          __typename?: 'Content'
          id?: string | null
          titleGroupId?: string | null
          title?: string | null
          contentId?: number | null
          contentType?: string | null
          published?: boolean | null
        } | null> | null
      } | null> | null
      adminCategory?: Array<{
        __typename?: 'ContentReference'
        id?: string | null
        sortKey?: number | null
        contentReferenceType?: { __typename?: 'ContentReferenceType'; type?: string | null } | null
        contentTo?: Array<{
          __typename?: 'Content'
          id?: string | null
          titleGroupId?: string | null
          title?: string | null
          contentId?: number | null
          contentType?: string | null
          published?: boolean | null
        } | null> | null
      } | null> | null
      category?: Array<{
        __typename?: 'ContentReference'
        id?: string | null
        sortKey?: number | null
        contentReferenceType?: { __typename?: 'ContentReferenceType'; type?: string | null } | null
        contentTo?: Array<{
          __typename?: 'Content'
          id?: string | null
          titleGroupId?: string | null
          title?: string | null
          contentId?: number | null
          contentType?: string | null
          published?: boolean | null
        } | null> | null
      } | null> | null
      centers?: Array<{
        __typename?: 'ContentReference'
        id?: string | null
        sortKey?: number | null
        contentReferenceType?: { __typename?: 'ContentReferenceType'; type?: string | null } | null
        contentTo?: Array<{
          __typename?: 'Content'
          id?: string | null
          titleGroupId?: string | null
          title?: string | null
          contentId?: number | null
          contentType?: string | null
          published?: boolean | null
        } | null> | null
      } | null> | null
      contentOrigin?: Array<{
        __typename?: 'ContentReference'
        id?: string | null
        sortKey?: number | null
        contentReferenceType?: { __typename?: 'ContentReferenceType'; type?: string | null } | null
        contentTo?: Array<{
          __typename?: 'Content'
          id?: string | null
          titleGroupId?: string | null
          title?: string | null
          contentId?: number | null
          contentType?: string | null
          published?: boolean | null
        } | null> | null
      } | null> | null
      consciousFormat?: Array<{
        __typename?: 'ContentReference'
        id?: string | null
        sortKey?: number | null
        contentReferenceType?: { __typename?: 'ContentReferenceType'; type?: string | null } | null
        contentTo?: Array<{
          __typename?: 'Content'
          id?: string | null
          titleGroupId?: string | null
          title?: string | null
          contentId?: number | null
          contentType?: string | null
          published?: boolean | null
        } | null> | null
      } | null> | null
      consciousTopic?: Array<{
        __typename?: 'ContentReference'
        id?: string | null
        sortKey?: number | null
        contentReferenceType?: { __typename?: 'ContentReferenceType'; type?: string | null } | null
        contentTo?: Array<{
          __typename?: 'Content'
          id?: string | null
          titleGroupId?: string | null
          title?: string | null
          contentId?: number | null
          contentType?: string | null
          published?: boolean | null
        } | null> | null
      } | null> | null
      filmSubject?: Array<{
        __typename?: 'ContentReference'
        id?: string | null
        sortKey?: number | null
        contentReferenceType?: { __typename?: 'ContentReferenceType'; type?: string | null } | null
        contentTo?: Array<{
          __typename?: 'Content'
          id?: string | null
          titleGroupId?: string | null
          title?: string | null
          contentId?: number | null
          contentType?: string | null
          published?: boolean | null
        } | null> | null
      } | null> | null
      filmType?: Array<{
        __typename?: 'ContentReference'
        id?: string | null
        sortKey?: number | null
        contentReferenceType?: { __typename?: 'ContentReferenceType'; type?: string | null } | null
        contentTo?: Array<{
          __typename?: 'Content'
          id?: string | null
          titleGroupId?: string | null
          title?: string | null
          contentId?: number | null
          contentType?: string | null
          published?: boolean | null
        } | null> | null
      } | null> | null
      fitnessDuration?: Array<{
        __typename?: 'ContentReference'
        id?: string | null
        sortKey?: number | null
        contentReferenceType?: { __typename?: 'ContentReferenceType'; type?: string | null } | null
        contentTo?: Array<{
          __typename?: 'Content'
          id?: string | null
          titleGroupId?: string | null
          title?: string | null
          contentId?: number | null
          contentType?: string | null
          published?: boolean | null
        } | null> | null
      } | null> | null
      fitnessLevel?: Array<{
        __typename?: 'ContentReference'
        id?: string | null
        sortKey?: number | null
        contentReferenceType?: { __typename?: 'ContentReferenceType'; type?: string | null } | null
        contentTo?: Array<{
          __typename?: 'Content'
          id?: string | null
          titleGroupId?: string | null
          title?: string | null
          contentId?: number | null
          contentType?: string | null
          published?: boolean | null
        } | null> | null
      } | null> | null
      fitnessInstructor?: Array<{
        __typename?: 'ContentReference'
        id?: string | null
        sortKey?: number | null
        contentReferenceType?: { __typename?: 'ContentReferenceType'; type?: string | null } | null
        contentTo?: Array<{
          __typename?: 'Content'
          id?: string | null
          titleGroupId?: string | null
          title?: string | null
          contentId?: number | null
          contentType?: string | null
          published?: boolean | null
        } | null> | null
      } | null> | null
      fitnessSpecialty?: Array<{
        __typename?: 'ContentReference'
        id?: string | null
        sortKey?: number | null
        contentReferenceType?: { __typename?: 'ContentReferenceType'; type?: string | null } | null
        contentTo?: Array<{
          __typename?: 'Content'
          id?: string | null
          titleGroupId?: string | null
          title?: string | null
          contentId?: number | null
          contentType?: string | null
          published?: boolean | null
        } | null> | null
      } | null> | null
      fitnessStyle?: Array<{
        __typename?: 'ContentReference'
        id?: string | null
        sortKey?: number | null
        contentReferenceType?: { __typename?: 'ContentReferenceType'; type?: string | null } | null
        contentTo?: Array<{
          __typename?: 'Content'
          id?: string | null
          titleGroupId?: string | null
          title?: string | null
          contentId?: number | null
          contentType?: string | null
          published?: boolean | null
        } | null> | null
      } | null> | null
      genres?: Array<{
        __typename?: 'ContentReference'
        id?: string | null
        sortKey?: number | null
        contentReferenceType?: { __typename?: 'ContentReferenceType'; type?: string | null } | null
        contentTo?: Array<{
          __typename?: 'Content'
          id?: string | null
          titleGroupId?: string | null
          title?: string | null
          contentId?: number | null
          contentType?: string | null
          published?: boolean | null
        } | null> | null
      } | null> | null
      interviewGuest?: Array<{
        __typename?: 'ContentReference'
        id?: string | null
        sortKey?: number | null
        contentReferenceType?: { __typename?: 'ContentReferenceType'; type?: string | null } | null
        contentTo?: Array<{
          __typename?: 'Content'
          id?: string | null
          titleGroupId?: string | null
          title?: string | null
          contentId?: number | null
          contentType?: string | null
          published?: boolean | null
        } | null> | null
      } | null> | null
      interviewHost?: Array<{
        __typename?: 'ContentReference'
        id?: string | null
        sortKey?: number | null
        contentReferenceType?: { __typename?: 'ContentReferenceType'; type?: string | null } | null
        contentTo?: Array<{
          __typename?: 'Content'
          id?: string | null
          titleGroupId?: string | null
          title?: string | null
          contentId?: number | null
          contentType?: string | null
          published?: boolean | null
        } | null> | null
      } | null> | null
      marketingCenters?: Array<{
        __typename?: 'ContentReference'
        id?: string | null
        sortKey?: number | null
        contentReferenceType?: { __typename?: 'ContentReferenceType'; type?: string | null } | null
        contentTo?: Array<{
          __typename?: 'Content'
          id?: string | null
          titleGroupId?: string | null
          title?: string | null
          contentId?: number | null
          contentType?: string | null
          published?: boolean | null
        } | null> | null
      } | null> | null
      meditationFocus?: Array<{
        __typename?: 'ContentReference'
        id?: string | null
        sortKey?: number | null
        contentReferenceType?: { __typename?: 'ContentReferenceType'; type?: string | null } | null
        contentTo?: Array<{
          __typename?: 'Content'
          id?: string | null
          titleGroupId?: string | null
          title?: string | null
          contentId?: number | null
          contentType?: string | null
          published?: boolean | null
        } | null> | null
      } | null> | null
      meditationStyle?: Array<{
        __typename?: 'ContentReference'
        id?: string | null
        sortKey?: number | null
        contentReferenceType?: { __typename?: 'ContentReferenceType'; type?: string | null } | null
        contentTo?: Array<{
          __typename?: 'Content'
          id?: string | null
          titleGroupId?: string | null
          title?: string | null
          contentId?: number | null
          contentType?: string | null
          published?: boolean | null
        } | null> | null
      } | null> | null
      meditationTeacher?: Array<{
        __typename?: 'ContentReference'
        id?: string | null
        sortKey?: number | null
        contentReferenceType?: { __typename?: 'ContentReferenceType'; type?: string | null } | null
        contentTo?: Array<{
          __typename?: 'Content'
          id?: string | null
          titleGroupId?: string | null
          title?: string | null
          contentId?: number | null
          contentType?: string | null
          published?: boolean | null
        } | null> | null
      } | null> | null
      meditationDuration?: Array<{
        __typename?: 'ContentReference'
        id?: string | null
        sortKey?: number | null
        contentReferenceType?: { __typename?: 'ContentReferenceType'; type?: string | null } | null
        contentTo?: Array<{
          __typename?: 'Content'
          id?: string | null
          titleGroupId?: string | null
          title?: string | null
          contentId?: number | null
          contentType?: string | null
          published?: boolean | null
        } | null> | null
      } | null> | null
      onboardingChoices?: Array<{
        __typename?: 'ContentReference'
        id?: string | null
        sortKey?: number | null
        contentReferenceType?: { __typename?: 'ContentReferenceType'; type?: string | null } | null
        contentTo?: Array<{
          __typename?: 'Content'
          id?: string | null
          titleGroupId?: string | null
          title?: string | null
          contentId?: number | null
          contentType?: string | null
          published?: boolean | null
        } | null> | null
      } | null> | null
      product?: Array<{
        __typename?: 'ContentReference'
        id?: string | null
        sortKey?: number | null
        contentReferenceType?: { __typename?: 'ContentReferenceType'; type?: string | null } | null
        contentTo?: Array<{
          __typename?: 'Content'
          id?: string | null
          titleGroupId?: string | null
          title?: string | null
          contentId?: number | null
          contentType?: string | null
          published?: boolean | null
        } | null> | null
      } | null> | null
      rainbowCategory?: Array<{
        __typename?: 'ContentReference'
        id?: string | null
        sortKey?: number | null
        contentReferenceType?: { __typename?: 'ContentReferenceType'; type?: string | null } | null
        contentTo?: Array<{
          __typename?: 'Content'
          id?: string | null
          titleGroupId?: string | null
          title?: string | null
          contentId?: number | null
          contentType?: string | null
          published?: boolean | null
        } | null> | null
      } | null> | null
      recipeDiet?: Array<{
        __typename?: 'ContentReference'
        id?: string | null
        sortKey?: number | null
        contentReferenceType?: { __typename?: 'ContentReferenceType'; type?: string | null } | null
        contentTo?: Array<{
          __typename?: 'Content'
          id?: string | null
          titleGroupId?: string | null
          title?: string | null
          contentId?: number | null
          contentType?: string | null
          published?: boolean | null
        } | null> | null
      } | null> | null
      recipeType?: Array<{
        __typename?: 'ContentReference'
        id?: string | null
        sortKey?: number | null
        contentReferenceType?: { __typename?: 'ContentReferenceType'; type?: string | null } | null
        contentTo?: Array<{
          __typename?: 'Content'
          id?: string | null
          titleGroupId?: string | null
          title?: string | null
          contentId?: number | null
          contentType?: string | null
          published?: boolean | null
        } | null> | null
      } | null> | null
      series?: Array<{
        __typename?: 'ContentReference'
        id?: string | null
        sortKey?: number | null
        contentReferenceType?: { __typename?: 'ContentReferenceType'; type?: string | null } | null
        contentTo?: Array<{
          __typename?: 'Content'
          id?: string | null
          titleGroupId?: string | null
          title?: string | null
          contentId?: number | null
          contentType?: string | null
          published?: boolean | null
        } | null> | null
      } | null> | null
      similarVideos?: Array<{
        __typename?: 'ContentReference'
        id?: string | null
        sortKey?: number | null
        contentReferenceType?: { __typename?: 'ContentReferenceType'; type?: string | null } | null
        contentTo?: Array<{
          __typename?: 'Content'
          id?: string | null
          titleGroupId?: string | null
          title?: string | null
          contentId?: number | null
          contentType?: string | null
          published?: boolean | null
        } | null> | null
      } | null> | null
      thirdPartyGenre?: Array<{
        __typename?: 'ContentReference'
        id?: string | null
        sortKey?: number | null
        contentReferenceType?: { __typename?: 'ContentReferenceType'; type?: string | null } | null
        contentTo?: Array<{
          __typename?: 'Content'
          id?: string | null
          titleGroupId?: string | null
          title?: string | null
          contentId?: number | null
          contentType?: string | null
          published?: boolean | null
        } | null> | null
      } | null> | null
      videoCollection?: Array<{
        __typename?: 'ContentReference'
        id?: string | null
        sortKey?: number | null
        contentReferenceType?: { __typename?: 'ContentReferenceType'; type?: string | null } | null
        contentTo?: Array<{
          __typename?: 'Content'
          id?: string | null
          titleGroupId?: string | null
          title?: string | null
          contentId?: number | null
          contentType?: string | null
          published?: boolean | null
        } | null> | null
      } | null> | null
      videoTopic?: Array<{
        __typename?: 'ContentReference'
        id?: string | null
        sortKey?: number | null
        contentReferenceType?: { __typename?: 'ContentReferenceType'; type?: string | null } | null
        contentTo?: Array<{
          __typename?: 'Content'
          id?: string | null
          titleGroupId?: string | null
          title?: string | null
          contentId?: number | null
          contentType?: string | null
          published?: boolean | null
        } | null> | null
      } | null> | null
      yogaDuration?: Array<{
        __typename?: 'ContentReference'
        id?: string | null
        sortKey?: number | null
        contentReferenceType?: { __typename?: 'ContentReferenceType'; type?: string | null } | null
        contentTo?: Array<{
          __typename?: 'Content'
          id?: string | null
          titleGroupId?: string | null
          title?: string | null
          contentId?: number | null
          contentType?: string | null
          published?: boolean | null
        } | null> | null
      } | null> | null
      yogaFocus?: Array<{
        __typename?: 'ContentReference'
        id?: string | null
        sortKey?: number | null
        contentReferenceType?: { __typename?: 'ContentReferenceType'; type?: string | null } | null
        contentTo?: Array<{
          __typename?: 'Content'
          id?: string | null
          titleGroupId?: string | null
          title?: string | null
          contentId?: number | null
          contentType?: string | null
          published?: boolean | null
        } | null> | null
      } | null> | null
      yogaLevel?: Array<{
        __typename?: 'ContentReference'
        id?: string | null
        sortKey?: number | null
        contentReferenceType?: { __typename?: 'ContentReferenceType'; type?: string | null } | null
        contentTo?: Array<{
          __typename?: 'Content'
          id?: string | null
          titleGroupId?: string | null
          title?: string | null
          contentId?: number | null
          contentType?: string | null
          published?: boolean | null
        } | null> | null
      } | null> | null
      yogaStyle?: Array<{
        __typename?: 'ContentReference'
        id?: string | null
        sortKey?: number | null
        contentReferenceType?: { __typename?: 'ContentReferenceType'; type?: string | null } | null
        contentTo?: Array<{
          __typename?: 'Content'
          id?: string | null
          titleGroupId?: string | null
          title?: string | null
          contentId?: number | null
          contentType?: string | null
          published?: boolean | null
        } | null> | null
      } | null> | null
      yogaTeacher?: Array<{
        __typename?: 'ContentReference'
        id?: string | null
        sortKey?: number | null
        contentReferenceType?: { __typename?: 'ContentReferenceType'; type?: string | null } | null
        contentTo?: Array<{
          __typename?: 'Content'
          id?: string | null
          titleGroupId?: string | null
          title?: string | null
          contentId?: number | null
          contentType?: string | null
          published?: boolean | null
        } | null> | null
      } | null> | null
      contentProvider?: {
        __typename?: 'ContentProvider'
        provider?: ContentProviderProviders | null
        providerKey?: string | null
        contentId?: string | null
      } | null
      contentPolicy?: {
        __typename?: 'ContentPolicy'
        policyId?: string | null
        name?: string | null
      } | null
      yiActionType?: Array<{
        __typename?: 'ContentReference'
        id?: string | null
        sortKey?: number | null
        contentReferenceType?: {
          __typename?: 'ContentReferenceType'
          id?: string | null
          type?: string | null
        } | null
        contentTo?: Array<{
          __typename?: 'Content'
          id?: string | null
          title?: string | null
          language?: string | null
          contentType?: string | null
          contentId?: number | null
          published?: boolean | null
          avatar?: Array<{
            __typename?: 'ImageContentRelationship'
            id?: string | null
            type?: string | null
            image?: { __typename?: 'Image'; id?: string | null; url?: string | null } | null
          } | null> | null
        } | null> | null
      } | null> | null
      yiCourseModules?: Array<{
        __typename?: 'ContentReference'
        sortKey?: number | null
        id?: string | null
        contentReferenceType?: { __typename?: 'ContentReferenceType'; type?: string | null } | null
        contentTo?: Array<{
          __typename?: 'Content'
          title?: string | null
          id?: string | null
          contentType?: string | null
          contentId?: number | null
          published?: boolean | null
          yiCourseModuleType?: Array<{
            __typename?: 'ContentReference'
            id?: string | null
            sortKey?: number | null
            contentReferenceType?: {
              __typename?: 'ContentReferenceType'
              type?: string | null
            } | null
            contentTo?: Array<{
              __typename?: 'Content'
              id?: string | null
              titleGroupId?: string | null
              title?: string | null
              contentId?: number | null
              contentType?: string | null
              published?: boolean | null
            } | null> | null
          } | null> | null
          providerMetadata?: {
            __typename?: 'ContentProvider'
            metadata?: any | null
            contentId?: string | null
          } | null
        } | null> | null
      } | null> | null
      yiCourseSalesPages?: Array<{
        __typename?: 'ContentReference'
        id?: string | null
        contentFrom?: Array<{
          __typename?: 'Content'
          id?: string | null
          contentType?: string | null
          contentId?: number | null
          title?: string | null
          published?: boolean | null
        } | null> | null
      } | null> | null
      yiPosePronunciation?: Array<{
        __typename?: 'ContentAssetReference'
        id?: string | null
        contentAssetReferenceTypesId?: string | null
        asset?: {
          __typename?: 'Asset'
          id?: string | null
          renderUrl?: string | null
          originalFileName?: string | null
          uuid?: string | null
        } | null
      } | null> | null
      yiCourses?: Array<{
        __typename?: 'ContentReference'
        id?: string | null
        contentTo?: Array<{
          __typename?: 'Content'
          id?: string | null
          contentType?: string | null
          contentId?: number | null
          title?: string | null
          published?: boolean | null
          contentProvider?: {
            __typename?: 'ContentProvider'
            provider?: ContentProviderProviders | null
            providerKey?: string | null
            contentId?: string | null
          } | null
        } | null> | null
      } | null> | null
      yiGiveAwayCourses?: Array<{
        __typename?: 'ContentReference'
        id?: string | null
        contentTo?: Array<{
          __typename?: 'Content'
          id?: string | null
          contentType?: string | null
          contentId?: number | null
          title?: string | null
          published?: boolean | null
        } | null> | null
      } | null> | null
      yiPromotedContent?: Array<{
        __typename?: 'ContentReference'
        id?: string | null
        contentTo?: Array<{
          __typename?: 'Content'
          id?: string | null
          contentType?: string | null
          contentId?: number | null
          title?: string | null
          published?: boolean | null
          contentProvider?: {
            __typename?: 'ContentProvider'
            provider?: ContentProviderProviders | null
            providerKey?: string | null
            contentId?: string | null
          } | null
          yiContentType?: Array<{
            __typename?: 'ContentReference'
            id?: string | null
            sortKey?: number | null
            contentReferenceType?: {
              __typename?: 'ContentReferenceType'
              type?: string | null
            } | null
            contentTo?: Array<{
              __typename?: 'Content'
              id?: string | null
              titleGroupId?: string | null
              title?: string | null
              contentId?: number | null
              contentType?: string | null
              published?: boolean | null
            } | null> | null
          } | null> | null
        } | null> | null
      } | null> | null
      yiHomepageHeroContent?: Array<{
        __typename?: 'ContentReference'
        id?: string | null
        contentReferenceType?: { __typename?: 'ContentReferenceType'; type?: string | null } | null
        contentTo?: Array<{
          __typename?: 'Content'
          id?: string | null
          contentType?: string | null
          contentId?: number | null
          title?: string | null
          published?: boolean | null
          yiContentType?: Array<{
            __typename?: 'ContentReference'
            id?: string | null
            sortKey?: number | null
            contentReferenceType?: {
              __typename?: 'ContentReferenceType'
              type?: string | null
            } | null
            contentTo?: Array<{
              __typename?: 'Content'
              id?: string | null
              titleGroupId?: string | null
              title?: string | null
              contentId?: number | null
              contentType?: string | null
              published?: boolean | null
            } | null> | null
          } | null> | null
          contentProvider?: {
            __typename?: 'ContentProvider'
            provider?: ContentProviderProviders | null
            providerKey?: string | null
            contentId?: string | null
          } | null
        } | null> | null
      } | null> | null
      yiSeriesEpisodes?: Array<{
        __typename?: 'ContentReference'
        id?: string | null
        sortKey?: number | null
        contentReferenceType?: { __typename?: 'ContentReferenceType'; type?: string | null } | null
        contentTo?: Array<{
          __typename?: 'Content'
          title?: string | null
          id?: string | null
          contentType?: string | null
          contentId?: number | null
          published?: boolean | null
          seasonNumber?: number | null
          episodeNumber?: number | null
          providerMetadata?: {
            __typename?: 'ContentProvider'
            metadata?: any | null
            contentId?: string | null
          } | null
        } | null> | null
      } | null> | null
      yiArticleTopic?: Array<{
        __typename?: 'ContentReference'
        id?: string | null
        sortKey?: number | null
        contentReferenceType?: { __typename?: 'ContentReferenceType'; type?: string | null } | null
        contentTo?: Array<{
          __typename?: 'Content'
          id?: string | null
          titleGroupId?: string | null
          title?: string | null
          contentId?: number | null
          contentType?: string | null
          published?: boolean | null
        } | null> | null
      } | null> | null
      yiCourseModuleType?: Array<{
        __typename?: 'ContentReference'
        id?: string | null
        sortKey?: number | null
        contentReferenceType?: { __typename?: 'ContentReferenceType'; type?: string | null } | null
        contentTo?: Array<{
          __typename?: 'Content'
          id?: string | null
          titleGroupId?: string | null
          title?: string | null
          contentId?: number | null
          contentType?: string | null
          published?: boolean | null
        } | null> | null
      } | null> | null
      yiConsumptionType?: Array<{
        __typename?: 'ContentReference'
        id?: string | null
        sortKey?: number | null
        contentReferenceType?: { __typename?: 'ContentReferenceType'; type?: string | null } | null
        contentTo?: Array<{
          __typename?: 'Content'
          id?: string | null
          titleGroupId?: string | null
          title?: string | null
          contentId?: number | null
          contentType?: string | null
          published?: boolean | null
        } | null> | null
      } | null> | null
      yiYogaStyles?: Array<{
        __typename?: 'ContentReference'
        id?: string | null
        sortKey?: number | null
        contentReferenceType?: { __typename?: 'ContentReferenceType'; type?: string | null } | null
        contentTo?: Array<{
          __typename?: 'Content'
          id?: string | null
          titleGroupId?: string | null
          title?: string | null
          contentId?: number | null
          contentType?: string | null
          published?: boolean | null
        } | null> | null
      } | null> | null
      yiTagGroup?: Array<{
        __typename?: 'ContentReference'
        id?: string | null
        sortKey?: number | null
        contentReferenceType?: { __typename?: 'ContentReferenceType'; type?: string | null } | null
        contentTo?: Array<{
          __typename?: 'Content'
          id?: string | null
          titleGroupId?: string | null
          title?: string | null
          contentId?: number | null
          contentType?: string | null
          published?: boolean | null
        } | null> | null
      } | null> | null
      yiTagsRelatedToGroup?: Array<{
        __typename?: 'ContentReference'
        id?: string | null
        sortKey?: number | null
        contentReferenceType?: { __typename?: 'ContentReferenceType'; type?: string | null } | null
        contentFrom?: Array<{
          __typename?: 'Content'
          id?: string | null
          titleGroupId?: string | null
          title?: string | null
          contentId?: number | null
          contentType?: string | null
          published?: boolean | null
        } | null> | null
      } | null> | null
      featureMedia?: {
        __typename?: 'Media'
        mediaId?: string | null
        contentId?: string | null
        mediaMaestroTitleCode?: string | null
        policyId?: number | null
        updatedAt?: any | null
        duration?: number | null
        isPublished?: boolean | null
        mediaAssets?: Array<{
          __typename?: 'MediaAsset'
          id?: string | null
          providerKey?: string | null
        } | null> | null
      } | null
      providerMetadata?: {
        __typename?: 'ContentProvider'
        metadata?: any | null
        contentId?: string | null
      } | null
      previewMedia?: {
        __typename?: 'Media'
        mediaId?: string | null
        contentId?: string | null
        mediaMaestroTitleCode?: string | null
        policyId?: number | null
        updatedAt?: any | null
        duration?: number | null
        isPublished?: boolean | null
        mediaAssets?: Array<{
          __typename?: 'MediaAsset'
          id?: string | null
          providerKey?: string | null
        } | null> | null
      } | null
      yiCourseModuleDownload?: Array<{
        __typename?: 'ContentAssetReference'
        id?: string | null
        asset?: {
          __typename?: 'Asset'
          id?: string | null
          mimeType?: string | null
          fileSize?: number | null
          originalFileName?: string | null
          renderUrl?: string | null
          contentAssetReference?: {
            __typename?: 'ContentAssetReference'
            assetsId?: string | null
          } | null
        } | null
      } | null> | null
    } | null> | null
  } | null
}

export const NewHistoryFragmentDoc = {
  kind: 'Document',
  definitions: [
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'NewHistory' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'ChatHistory' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          { kind: 'Field', name: { kind: 'Name', value: 'userInfoUuid' } },
          { kind: 'Field', name: { kind: 'Name', value: 'chatSessionsId' } },
          { kind: 'Field', name: { kind: 'Name', value: 'data' } },
          { kind: 'Field', name: { kind: 'Name', value: 'type' } },
        ],
      },
    },
  ],
} as unknown as DocumentNode<NewHistoryFragment, unknown>
export const ContentDetails_Tag_ContentReferenceFragmentFragmentDoc = {
  kind: 'Document',
  definitions: [
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'ContentDetails_Tag_ContentReferenceFragment' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'ContentReference' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          { kind: 'Field', name: { kind: 'Name', value: 'sortKey' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'contentReferenceType' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [{ kind: 'Field', name: { kind: 'Name', value: 'type' } }],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'contentTo' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'language' },
                value: {
                  kind: 'ListValue',
                  values: [
                    { kind: 'StringValue', value: 'en', block: false },
                    { kind: 'StringValue', value: '_primary', block: false },
                  ],
                },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                { kind: 'Field', name: { kind: 'Name', value: 'titleGroupId' } },
                { kind: 'Field', name: { kind: 'Name', value: 'title' } },
                { kind: 'Field', name: { kind: 'Name', value: 'contentId' } },
                { kind: 'Field', name: { kind: 'Name', value: 'contentType' } },
                { kind: 'Field', name: { kind: 'Name', value: 'published' } },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<ContentDetails_Tag_ContentReferenceFragmentFragment, unknown>
export const GaiaVideo_ContentFragmentFragmentDoc = {
  kind: 'Document',
  definitions: [
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'GaiaVideo_ContentFragment' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'Content' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'episodeNumber' } },
          { kind: 'Field', name: { kind: 'Name', value: 'seasonNumber' } },
          { kind: 'Field', name: { kind: 'Name', value: 'director' } },
          { kind: 'Field', name: { kind: 'Name', value: 'producer' } },
          { kind: 'Field', name: { kind: 'Name', value: 'writer' } },
          { kind: 'Field', name: { kind: 'Name', value: 'studio' } },
          { kind: 'Field', name: { kind: 'Name', value: 'copyright' } },
          { kind: 'Field', name: { kind: 'Name', value: 'instructor' } },
          { kind: 'Field', name: { kind: 'Name', value: 'cast' } },
          { kind: 'Field', name: { kind: 'Name', value: 'productType' } },
          { kind: 'Field', name: { kind: 'Name', value: 'displayType' } },
          { kind: 'Field', name: { kind: 'Name', value: 'seoTitle' } },
          { kind: 'Field', name: { kind: 'Name', value: 'seoDescription' } },
          { kind: 'Field', name: { kind: 'Name', value: 'seoKeywords' } },
          { kind: 'Field', name: { kind: 'Name', value: 'seoRobotsNoFollow' } },
          { kind: 'Field', name: { kind: 'Name', value: 'seoRobotsNoIndex' } },
          { kind: 'Field', name: { kind: 'Name', value: 'excludeFromRecommendations' } },
          { kind: 'Field', name: { kind: 'Name', value: 'contentSearchNoIndex' } },
          {
            kind: 'Field',
            alias: { kind: 'Name', value: 'adminCategory' },
            name: { kind: 'Name', value: 'contentReferencesFrom' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'types' },
                value: { kind: 'StringValue', value: 'admin_category', block: false },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'ContentDetails_Tag_ContentReferenceFragment' },
                },
              ],
            },
          },
          {
            kind: 'Field',
            alias: { kind: 'Name', value: 'category' },
            name: { kind: 'Name', value: 'contentReferencesFrom' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'types' },
                value: { kind: 'StringValue', value: 'category', block: false },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'ContentDetails_Tag_ContentReferenceFragment' },
                },
              ],
            },
          },
          {
            kind: 'Field',
            alias: { kind: 'Name', value: 'centers' },
            name: { kind: 'Name', value: 'contentReferencesFrom' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'types' },
                value: { kind: 'StringValue', value: 'centers', block: false },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'ContentDetails_Tag_ContentReferenceFragment' },
                },
              ],
            },
          },
          {
            kind: 'Field',
            alias: { kind: 'Name', value: 'contentOrigin' },
            name: { kind: 'Name', value: 'contentReferencesFrom' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'types' },
                value: { kind: 'StringValue', value: 'content_origin', block: false },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'ContentDetails_Tag_ContentReferenceFragment' },
                },
              ],
            },
          },
          {
            kind: 'Field',
            alias: { kind: 'Name', value: 'consciousFormat' },
            name: { kind: 'Name', value: 'contentReferencesFrom' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'types' },
                value: { kind: 'StringValue', value: 'conscious-format', block: false },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'ContentDetails_Tag_ContentReferenceFragment' },
                },
              ],
            },
          },
          {
            kind: 'Field',
            alias: { kind: 'Name', value: 'consciousTopic' },
            name: { kind: 'Name', value: 'contentReferencesFrom' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'types' },
                value: { kind: 'StringValue', value: 'conscious-topic', block: false },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'ContentDetails_Tag_ContentReferenceFragment' },
                },
              ],
            },
          },
          {
            kind: 'Field',
            alias: { kind: 'Name', value: 'filmSubject' },
            name: { kind: 'Name', value: 'contentReferencesFrom' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'types' },
                value: { kind: 'StringValue', value: 'film-subject', block: false },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'ContentDetails_Tag_ContentReferenceFragment' },
                },
              ],
            },
          },
          {
            kind: 'Field',
            alias: { kind: 'Name', value: 'filmType' },
            name: { kind: 'Name', value: 'contentReferencesFrom' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'types' },
                value: { kind: 'StringValue', value: 'film-type', block: false },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'ContentDetails_Tag_ContentReferenceFragment' },
                },
              ],
            },
          },
          {
            kind: 'Field',
            alias: { kind: 'Name', value: 'fitnessDuration' },
            name: { kind: 'Name', value: 'contentReferencesFrom' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'types' },
                value: { kind: 'StringValue', value: 'fitness-duration', block: false },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'ContentDetails_Tag_ContentReferenceFragment' },
                },
              ],
            },
          },
          {
            kind: 'Field',
            alias: { kind: 'Name', value: 'fitnessLevel' },
            name: { kind: 'Name', value: 'contentReferencesFrom' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'types' },
                value: { kind: 'StringValue', value: 'fitness-level', block: false },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'ContentDetails_Tag_ContentReferenceFragment' },
                },
              ],
            },
          },
          {
            kind: 'Field',
            alias: { kind: 'Name', value: 'fitnessInstructor' },
            name: { kind: 'Name', value: 'contentReferencesFrom' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'types' },
                value: { kind: 'StringValue', value: 'fitness-instructor', block: false },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'ContentDetails_Tag_ContentReferenceFragment' },
                },
              ],
            },
          },
          {
            kind: 'Field',
            alias: { kind: 'Name', value: 'fitnessSpecialty' },
            name: { kind: 'Name', value: 'contentReferencesFrom' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'types' },
                value: { kind: 'StringValue', value: 'fitness-specialty', block: false },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'ContentDetails_Tag_ContentReferenceFragment' },
                },
              ],
            },
          },
          {
            kind: 'Field',
            alias: { kind: 'Name', value: 'fitnessStyle' },
            name: { kind: 'Name', value: 'contentReferencesFrom' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'types' },
                value: { kind: 'StringValue', value: 'fitness-style', block: false },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'ContentDetails_Tag_ContentReferenceFragment' },
                },
              ],
            },
          },
          {
            kind: 'Field',
            alias: { kind: 'Name', value: 'genres' },
            name: { kind: 'Name', value: 'contentReferencesFrom' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'types' },
                value: { kind: 'StringValue', value: 'genres', block: false },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'ContentDetails_Tag_ContentReferenceFragment' },
                },
              ],
            },
          },
          {
            kind: 'Field',
            alias: { kind: 'Name', value: 'interviewGuest' },
            name: { kind: 'Name', value: 'contentReferencesFrom' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'types' },
                value: { kind: 'StringValue', value: 'interview-guest', block: false },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'ContentDetails_Tag_ContentReferenceFragment' },
                },
              ],
            },
          },
          {
            kind: 'Field',
            alias: { kind: 'Name', value: 'interviewHost' },
            name: { kind: 'Name', value: 'contentReferencesFrom' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'types' },
                value: { kind: 'StringValue', value: 'interview-host', block: false },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'ContentDetails_Tag_ContentReferenceFragment' },
                },
              ],
            },
          },
          {
            kind: 'Field',
            alias: { kind: 'Name', value: 'marketingCenters' },
            name: { kind: 'Name', value: 'contentReferencesFrom' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'types' },
                value: { kind: 'StringValue', value: 'marketing-centers', block: false },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'ContentDetails_Tag_ContentReferenceFragment' },
                },
              ],
            },
          },
          {
            kind: 'Field',
            alias: { kind: 'Name', value: 'meditationFocus' },
            name: { kind: 'Name', value: 'contentReferencesFrom' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'types' },
                value: { kind: 'StringValue', value: 'fitness-style', block: false },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'ContentDetails_Tag_ContentReferenceFragment' },
                },
              ],
            },
          },
          {
            kind: 'Field',
            alias: { kind: 'Name', value: 'meditationStyle' },
            name: { kind: 'Name', value: 'contentReferencesFrom' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'types' },
                value: { kind: 'StringValue', value: 'meditation-style', block: false },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'ContentDetails_Tag_ContentReferenceFragment' },
                },
              ],
            },
          },
          {
            kind: 'Field',
            alias: { kind: 'Name', value: 'meditationTeacher' },
            name: { kind: 'Name', value: 'contentReferencesFrom' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'types' },
                value: { kind: 'StringValue', value: 'meditation-teacher', block: false },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'ContentDetails_Tag_ContentReferenceFragment' },
                },
              ],
            },
          },
          {
            kind: 'Field',
            alias: { kind: 'Name', value: 'meditationDuration' },
            name: { kind: 'Name', value: 'contentReferencesFrom' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'types' },
                value: { kind: 'StringValue', value: 'meditation-duration', block: false },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'ContentDetails_Tag_ContentReferenceFragment' },
                },
              ],
            },
          },
          {
            kind: 'Field',
            alias: { kind: 'Name', value: 'onboardingChoices' },
            name: { kind: 'Name', value: 'contentReferencesFrom' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'types' },
                value: { kind: 'StringValue', value: 'onboarding_choices', block: false },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'ContentDetails_Tag_ContentReferenceFragment' },
                },
              ],
            },
          },
          {
            kind: 'Field',
            alias: { kind: 'Name', value: 'product' },
            name: { kind: 'Name', value: 'contentReferencesFrom' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'types' },
                value: { kind: 'StringValue', value: 'product', block: false },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'ContentDetails_Tag_ContentReferenceFragment' },
                },
              ],
            },
          },
          {
            kind: 'Field',
            alias: { kind: 'Name', value: 'rainbowCategory' },
            name: { kind: 'Name', value: 'contentReferencesFrom' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'types' },
                value: { kind: 'StringValue', value: 'rainbow-category', block: false },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'ContentDetails_Tag_ContentReferenceFragment' },
                },
              ],
            },
          },
          {
            kind: 'Field',
            alias: { kind: 'Name', value: 'recipeDiet' },
            name: { kind: 'Name', value: 'contentReferencesFrom' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'types' },
                value: { kind: 'StringValue', value: 'recipe-diet', block: false },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'ContentDetails_Tag_ContentReferenceFragment' },
                },
              ],
            },
          },
          {
            kind: 'Field',
            alias: { kind: 'Name', value: 'recipeType' },
            name: { kind: 'Name', value: 'contentReferencesFrom' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'types' },
                value: { kind: 'StringValue', value: 'recipe-type', block: false },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'ContentDetails_Tag_ContentReferenceFragment' },
                },
              ],
            },
          },
          {
            kind: 'Field',
            alias: { kind: 'Name', value: 'series' },
            name: { kind: 'Name', value: 'contentReferencesFrom' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'types' },
                value: { kind: 'StringValue', value: 'series', block: false },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'ContentDetails_Tag_ContentReferenceFragment' },
                },
              ],
            },
          },
          {
            kind: 'Field',
            alias: { kind: 'Name', value: 'similarVideos' },
            name: { kind: 'Name', value: 'contentReferencesFrom' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'types' },
                value: { kind: 'StringValue', value: 'similar-videos', block: false },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'ContentDetails_Tag_ContentReferenceFragment' },
                },
              ],
            },
          },
          {
            kind: 'Field',
            alias: { kind: 'Name', value: 'thirdPartyGenre' },
            name: { kind: 'Name', value: 'contentReferencesFrom' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'types' },
                value: { kind: 'StringValue', value: 'third-party-genre', block: false },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'ContentDetails_Tag_ContentReferenceFragment' },
                },
              ],
            },
          },
          {
            kind: 'Field',
            alias: { kind: 'Name', value: 'videoCollection' },
            name: { kind: 'Name', value: 'contentReferencesFrom' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'types' },
                value: { kind: 'StringValue', value: 'video-collection', block: false },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'ContentDetails_Tag_ContentReferenceFragment' },
                },
              ],
            },
          },
          {
            kind: 'Field',
            alias: { kind: 'Name', value: 'videoTopic' },
            name: { kind: 'Name', value: 'contentReferencesFrom' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'types' },
                value: { kind: 'StringValue', value: 'video-topic', block: false },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'ContentDetails_Tag_ContentReferenceFragment' },
                },
              ],
            },
          },
          {
            kind: 'Field',
            alias: { kind: 'Name', value: 'yogaDuration' },
            name: { kind: 'Name', value: 'contentReferencesFrom' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'types' },
                value: { kind: 'StringValue', value: 'yoga-duration', block: false },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'ContentDetails_Tag_ContentReferenceFragment' },
                },
              ],
            },
          },
          {
            kind: 'Field',
            alias: { kind: 'Name', value: 'yogaFocus' },
            name: { kind: 'Name', value: 'contentReferencesFrom' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'types' },
                value: { kind: 'StringValue', value: 'yoga-focus', block: false },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'ContentDetails_Tag_ContentReferenceFragment' },
                },
              ],
            },
          },
          {
            kind: 'Field',
            alias: { kind: 'Name', value: 'yogaLevel' },
            name: { kind: 'Name', value: 'contentReferencesFrom' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'types' },
                value: { kind: 'StringValue', value: 'yoga-level', block: false },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'ContentDetails_Tag_ContentReferenceFragment' },
                },
              ],
            },
          },
          {
            kind: 'Field',
            alias: { kind: 'Name', value: 'yogaStyle' },
            name: { kind: 'Name', value: 'contentReferencesFrom' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'types' },
                value: { kind: 'StringValue', value: 'yoga-style', block: false },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'ContentDetails_Tag_ContentReferenceFragment' },
                },
              ],
            },
          },
          {
            kind: 'Field',
            alias: { kind: 'Name', value: 'yogaTeacher' },
            name: { kind: 'Name', value: 'contentReferencesFrom' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'types' },
                value: { kind: 'StringValue', value: 'yoga-teacher', block: false },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'ContentDetails_Tag_ContentReferenceFragment' },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'ContentDetails_Tag_ContentReferenceFragment' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'ContentReference' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          { kind: 'Field', name: { kind: 'Name', value: 'sortKey' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'contentReferenceType' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [{ kind: 'Field', name: { kind: 'Name', value: 'type' } }],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'contentTo' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'language' },
                value: {
                  kind: 'ListValue',
                  values: [
                    { kind: 'StringValue', value: 'en', block: false },
                    { kind: 'StringValue', value: '_primary', block: false },
                  ],
                },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                { kind: 'Field', name: { kind: 'Name', value: 'titleGroupId' } },
                { kind: 'Field', name: { kind: 'Name', value: 'title' } },
                { kind: 'Field', name: { kind: 'Name', value: 'contentId' } },
                { kind: 'Field', name: { kind: 'Name', value: 'contentType' } },
                { kind: 'Field', name: { kind: 'Name', value: 'published' } },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<GaiaVideo_ContentFragmentFragment, unknown>
export const Common_MediaFragmentFragmentDoc = {
  kind: 'Document',
  definitions: [
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'Common_MediaFragment' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'Media' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'mediaId' } },
          { kind: 'Field', name: { kind: 'Name', value: 'contentId' } },
          { kind: 'Field', name: { kind: 'Name', value: 'mediaMaestroTitleCode' } },
          { kind: 'Field', name: { kind: 'Name', value: 'policyId' } },
          { kind: 'Field', name: { kind: 'Name', value: 'updatedAt' } },
          { kind: 'Field', name: { kind: 'Name', value: 'duration' } },
          { kind: 'Field', name: { kind: 'Name', value: 'isPublished' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'mediaAssets' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                { kind: 'Field', name: { kind: 'Name', value: 'providerKey' } },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<Common_MediaFragmentFragment, unknown>
export const ContentFeatureMediaFragmentFragmentDoc = {
  kind: 'Document',
  definitions: [
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'ContentFeatureMediaFragment' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'Content' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'contentPolicyPolicyId' } },
          { kind: 'Field', name: { kind: 'Name', value: 'featureMediaId' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'featureMedia' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'FragmentSpread', name: { kind: 'Name', value: 'Common_MediaFragment' } },
              ],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'Common_MediaFragment' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'Media' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'mediaId' } },
          { kind: 'Field', name: { kind: 'Name', value: 'contentId' } },
          { kind: 'Field', name: { kind: 'Name', value: 'mediaMaestroTitleCode' } },
          { kind: 'Field', name: { kind: 'Name', value: 'policyId' } },
          { kind: 'Field', name: { kind: 'Name', value: 'updatedAt' } },
          { kind: 'Field', name: { kind: 'Name', value: 'duration' } },
          { kind: 'Field', name: { kind: 'Name', value: 'isPublished' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'mediaAssets' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                { kind: 'Field', name: { kind: 'Name', value: 'providerKey' } },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<ContentFeatureMediaFragmentFragment, unknown>
export const ContentDetails_Person_ContentFragmentFragmentDoc = {
  kind: 'Document',
  definitions: [
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'ContentDetails_Person_ContentFragment' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'Content' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          { kind: 'Field', name: { kind: 'Name', value: 'title' } },
          { kind: 'Field', name: { kind: 'Name', value: 'language' } },
          { kind: 'Field', name: { kind: 'Name', value: 'contentType' } },
          { kind: 'Field', name: { kind: 'Name', value: 'contentId' } },
          { kind: 'Field', name: { kind: 'Name', value: 'published' } },
          {
            kind: 'Field',
            alias: { kind: 'Name', value: 'avatar' },
            name: { kind: 'Name', value: 'imageContentRelationships' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                { kind: 'Field', name: { kind: 'Name', value: 'type' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'image' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'url' } },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<ContentDetails_Person_ContentFragmentFragment, unknown>
export const ContentDetails_Person_ContentReferenceFragmentFragmentDoc = {
  kind: 'Document',
  definitions: [
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'ContentDetails_Person_ContentReferenceFragment' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'ContentReference' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          { kind: 'Field', name: { kind: 'Name', value: 'sortKey' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'contentReferenceType' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                { kind: 'Field', name: { kind: 'Name', value: 'type' } },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'contentTo' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'ContentDetails_Person_ContentFragment' },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'ContentDetails_Person_ContentFragment' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'Content' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          { kind: 'Field', name: { kind: 'Name', value: 'title' } },
          { kind: 'Field', name: { kind: 'Name', value: 'language' } },
          { kind: 'Field', name: { kind: 'Name', value: 'contentType' } },
          { kind: 'Field', name: { kind: 'Name', value: 'contentId' } },
          { kind: 'Field', name: { kind: 'Name', value: 'published' } },
          {
            kind: 'Field',
            alias: { kind: 'Name', value: 'avatar' },
            name: { kind: 'Name', value: 'imageContentRelationships' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                { kind: 'Field', name: { kind: 'Name', value: 'type' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'image' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'url' } },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<ContentDetails_Person_ContentReferenceFragmentFragment, unknown>
export const Content_ProviderCommonFragmentFragmentDoc = {
  kind: 'Document',
  definitions: [
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'Content_ProviderCommonFragment' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'ContentProvider' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [{ kind: 'Field', name: { kind: 'Name', value: 'contentId' } }],
      },
    },
  ],
} as unknown as DocumentNode<Content_ProviderCommonFragmentFragment, unknown>
export const Content_ProviderMetadataFragmentFragmentDoc = {
  kind: 'Document',
  definitions: [
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'Content_ProviderMetadataFragment' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'Content' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            alias: { kind: 'Name', value: 'providerMetadata' },
            name: { kind: 'Name', value: 'contentProvider' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'metadata' } },
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'Content_ProviderCommonFragment' },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'Content_ProviderCommonFragment' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'ContentProvider' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [{ kind: 'Field', name: { kind: 'Name', value: 'contentId' } }],
      },
    },
  ],
} as unknown as DocumentNode<Content_ProviderMetadataFragmentFragment, unknown>
export const YiArticle_ContentFragmentFragmentDoc = {
  kind: 'Document',
  definitions: [
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'YIArticle_ContentFragment' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'Content' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'contentPolicyPolicyId' } },
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          { kind: 'Field', name: { kind: 'Name', value: 'contentId' } },
          { kind: 'Field', name: { kind: 'Name', value: 'contentType' } },
          { kind: 'Field', name: { kind: 'Name', value: 'language' } },
          { kind: 'Field', name: { kind: 'Name', value: 'description' } },
          { kind: 'Field', name: { kind: 'Name', value: 'descriptionFormat' } },
          { kind: 'Field', name: { kind: 'Name', value: 'shortDescription' } },
          { kind: 'Field', name: { kind: 'Name', value: 'shortDescriptionFormat' } },
          { kind: 'Field', name: { kind: 'Name', value: 'path' } },
          { kind: 'Field', name: { kind: 'Name', value: 'primaryLanguage' } },
          { kind: 'Field', name: { kind: 'Name', value: 'published' } },
          { kind: 'Field', name: { kind: 'Name', value: 'publishedAtDate' } },
          { kind: 'Field', name: { kind: 'Name', value: 'seoDescription' } },
          { kind: 'Field', name: { kind: 'Name', value: 'seoTitle' } },
          { kind: 'Field', name: { kind: 'Name', value: 'title' } },
          { kind: 'FragmentSpread', name: { kind: 'Name', value: 'ContentFeatureMediaFragment' } },
          {
            kind: 'Field',
            alias: { kind: 'Name', value: 'yiContentType' },
            name: { kind: 'Name', value: 'contentReferencesFrom' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'types' },
                value: { kind: 'StringValue', value: 'yi-content-type', block: false },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'ContentDetails_Tag_ContentReferenceFragment' },
                },
              ],
            },
          },
          {
            kind: 'Field',
            alias: { kind: 'Name', value: 'yiYogaTeacher' },
            name: { kind: 'Name', value: 'contentReferencesFrom' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'types' },
                value: { kind: 'StringValue', value: 'yi-yoga-teacher', block: false },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'ContentDetails_Person_ContentReferenceFragment' },
                },
              ],
            },
          },
          {
            kind: 'Field',
            alias: { kind: 'Name', value: 'yiTags' },
            name: { kind: 'Name', value: 'contentReferencesFrom' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'types' },
                value: { kind: 'StringValue', value: 'yi-tag', block: false },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'ContentDetails_Tag_ContentReferenceFragment' },
                },
              ],
            },
          },
          {
            kind: 'Field',
            alias: { kind: 'Name', value: 'yiArticleTopic' },
            name: { kind: 'Name', value: 'contentReferencesFrom' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'types' },
                value: { kind: 'StringValue', value: 'yi-article-topic', block: false },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'ContentDetails_Tag_ContentReferenceFragment' },
                },
              ],
            },
          },
          {
            kind: 'FragmentSpread',
            name: { kind: 'Name', value: 'Content_ProviderMetadataFragment' },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'Common_MediaFragment' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'Media' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'mediaId' } },
          { kind: 'Field', name: { kind: 'Name', value: 'contentId' } },
          { kind: 'Field', name: { kind: 'Name', value: 'mediaMaestroTitleCode' } },
          { kind: 'Field', name: { kind: 'Name', value: 'policyId' } },
          { kind: 'Field', name: { kind: 'Name', value: 'updatedAt' } },
          { kind: 'Field', name: { kind: 'Name', value: 'duration' } },
          { kind: 'Field', name: { kind: 'Name', value: 'isPublished' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'mediaAssets' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                { kind: 'Field', name: { kind: 'Name', value: 'providerKey' } },
              ],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'ContentDetails_Person_ContentFragment' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'Content' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          { kind: 'Field', name: { kind: 'Name', value: 'title' } },
          { kind: 'Field', name: { kind: 'Name', value: 'language' } },
          { kind: 'Field', name: { kind: 'Name', value: 'contentType' } },
          { kind: 'Field', name: { kind: 'Name', value: 'contentId' } },
          { kind: 'Field', name: { kind: 'Name', value: 'published' } },
          {
            kind: 'Field',
            alias: { kind: 'Name', value: 'avatar' },
            name: { kind: 'Name', value: 'imageContentRelationships' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                { kind: 'Field', name: { kind: 'Name', value: 'type' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'image' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'url' } },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'Content_ProviderCommonFragment' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'ContentProvider' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [{ kind: 'Field', name: { kind: 'Name', value: 'contentId' } }],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'ContentFeatureMediaFragment' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'Content' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'contentPolicyPolicyId' } },
          { kind: 'Field', name: { kind: 'Name', value: 'featureMediaId' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'featureMedia' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'FragmentSpread', name: { kind: 'Name', value: 'Common_MediaFragment' } },
              ],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'ContentDetails_Tag_ContentReferenceFragment' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'ContentReference' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          { kind: 'Field', name: { kind: 'Name', value: 'sortKey' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'contentReferenceType' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [{ kind: 'Field', name: { kind: 'Name', value: 'type' } }],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'contentTo' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'language' },
                value: {
                  kind: 'ListValue',
                  values: [
                    { kind: 'StringValue', value: 'en', block: false },
                    { kind: 'StringValue', value: '_primary', block: false },
                  ],
                },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                { kind: 'Field', name: { kind: 'Name', value: 'titleGroupId' } },
                { kind: 'Field', name: { kind: 'Name', value: 'title' } },
                { kind: 'Field', name: { kind: 'Name', value: 'contentId' } },
                { kind: 'Field', name: { kind: 'Name', value: 'contentType' } },
                { kind: 'Field', name: { kind: 'Name', value: 'published' } },
              ],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'ContentDetails_Person_ContentReferenceFragment' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'ContentReference' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          { kind: 'Field', name: { kind: 'Name', value: 'sortKey' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'contentReferenceType' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                { kind: 'Field', name: { kind: 'Name', value: 'type' } },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'contentTo' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'ContentDetails_Person_ContentFragment' },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'Content_ProviderMetadataFragment' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'Content' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            alias: { kind: 'Name', value: 'providerMetadata' },
            name: { kind: 'Name', value: 'contentProvider' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'metadata' } },
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'Content_ProviderCommonFragment' },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<YiArticle_ContentFragmentFragment, unknown>
export const YiClass_ContentFragmentFragmentDoc = {
  kind: 'Document',
  definitions: [
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'YIClass_ContentFragment' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'Content' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'descriptionFormat' } },
          { kind: 'Field', name: { kind: 'Name', value: 'shortDescriptionFormat' } },
          { kind: 'Field', name: { kind: 'Name', value: 'displayType' } },
          { kind: 'Field', name: { kind: 'Name', value: 'primaryLanguage' } },
          { kind: 'Field', name: { kind: 'Name', value: 'productType' } },
          { kind: 'Field', name: { kind: 'Name', value: 'seoDescription' } },
          { kind: 'Field', name: { kind: 'Name', value: 'seoTitle' } },
          { kind: 'FragmentSpread', name: { kind: 'Name', value: 'ContentFeatureMediaFragment' } },
          {
            kind: 'Field',
            alias: { kind: 'Name', value: 'yiContentType' },
            name: { kind: 'Name', value: 'contentReferencesFrom' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'types' },
                value: { kind: 'StringValue', value: 'yi-content-type', block: false },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'ContentDetails_Tag_ContentReferenceFragment' },
                },
              ],
            },
          },
          {
            kind: 'Field',
            alias: { kind: 'Name', value: 'yiTags' },
            name: { kind: 'Name', value: 'contentReferencesFrom' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'types' },
                value: { kind: 'StringValue', value: 'yi-tag', block: false },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'ContentDetails_Tag_ContentReferenceFragment' },
                },
              ],
            },
          },
          {
            kind: 'Field',
            alias: { kind: 'Name', value: 'yiYogaStyle' },
            name: { kind: 'Name', value: 'contentReferencesFrom' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'types' },
                value: { kind: 'StringValue', value: 'yi-yoga-style', block: false },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'ContentDetails_Tag_ContentReferenceFragment' },
                },
              ],
            },
          },
          {
            kind: 'Field',
            alias: { kind: 'Name', value: 'yiYogaLevel' },
            name: { kind: 'Name', value: 'contentReferencesFrom' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'types' },
                value: { kind: 'StringValue', value: 'yi-yoga-level', block: false },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'ContentDetails_Tag_ContentReferenceFragment' },
                },
              ],
            },
          },
          {
            kind: 'Field',
            alias: { kind: 'Name', value: 'yiYogaTeacher' },
            name: { kind: 'Name', value: 'contentReferencesFrom' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'types' },
                value: { kind: 'StringValue', value: 'yi-yoga-teacher', block: false },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'ContentDetails_Person_ContentReferenceFragment' },
                },
              ],
            },
          },
          {
            kind: 'Field',
            alias: { kind: 'Name', value: 'yiPracticeType' },
            name: { kind: 'Name', value: 'contentReferencesFrom' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'types' },
                value: { kind: 'StringValue', value: 'yi-practice-type', block: false },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'ContentDetails_Tag_ContentReferenceFragment' },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'Common_MediaFragment' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'Media' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'mediaId' } },
          { kind: 'Field', name: { kind: 'Name', value: 'contentId' } },
          { kind: 'Field', name: { kind: 'Name', value: 'mediaMaestroTitleCode' } },
          { kind: 'Field', name: { kind: 'Name', value: 'policyId' } },
          { kind: 'Field', name: { kind: 'Name', value: 'updatedAt' } },
          { kind: 'Field', name: { kind: 'Name', value: 'duration' } },
          { kind: 'Field', name: { kind: 'Name', value: 'isPublished' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'mediaAssets' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                { kind: 'Field', name: { kind: 'Name', value: 'providerKey' } },
              ],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'ContentDetails_Person_ContentFragment' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'Content' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          { kind: 'Field', name: { kind: 'Name', value: 'title' } },
          { kind: 'Field', name: { kind: 'Name', value: 'language' } },
          { kind: 'Field', name: { kind: 'Name', value: 'contentType' } },
          { kind: 'Field', name: { kind: 'Name', value: 'contentId' } },
          { kind: 'Field', name: { kind: 'Name', value: 'published' } },
          {
            kind: 'Field',
            alias: { kind: 'Name', value: 'avatar' },
            name: { kind: 'Name', value: 'imageContentRelationships' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                { kind: 'Field', name: { kind: 'Name', value: 'type' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'image' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'url' } },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'ContentFeatureMediaFragment' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'Content' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'contentPolicyPolicyId' } },
          { kind: 'Field', name: { kind: 'Name', value: 'featureMediaId' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'featureMedia' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'FragmentSpread', name: { kind: 'Name', value: 'Common_MediaFragment' } },
              ],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'ContentDetails_Tag_ContentReferenceFragment' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'ContentReference' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          { kind: 'Field', name: { kind: 'Name', value: 'sortKey' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'contentReferenceType' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [{ kind: 'Field', name: { kind: 'Name', value: 'type' } }],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'contentTo' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'language' },
                value: {
                  kind: 'ListValue',
                  values: [
                    { kind: 'StringValue', value: 'en', block: false },
                    { kind: 'StringValue', value: '_primary', block: false },
                  ],
                },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                { kind: 'Field', name: { kind: 'Name', value: 'titleGroupId' } },
                { kind: 'Field', name: { kind: 'Name', value: 'title' } },
                { kind: 'Field', name: { kind: 'Name', value: 'contentId' } },
                { kind: 'Field', name: { kind: 'Name', value: 'contentType' } },
                { kind: 'Field', name: { kind: 'Name', value: 'published' } },
              ],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'ContentDetails_Person_ContentReferenceFragment' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'ContentReference' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          { kind: 'Field', name: { kind: 'Name', value: 'sortKey' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'contentReferenceType' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                { kind: 'Field', name: { kind: 'Name', value: 'type' } },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'contentTo' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'ContentDetails_Person_ContentFragment' },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<YiClass_ContentFragmentFragment, unknown>
export const YiCourse_ModuleDetailsContentFragmentFragmentDoc = {
  kind: 'Document',
  definitions: [
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'YICourse_ModuleDetailsContentFragment' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'Content' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'title' } },
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          { kind: 'Field', name: { kind: 'Name', value: 'contentType' } },
          { kind: 'Field', name: { kind: 'Name', value: 'contentId' } },
          { kind: 'Field', name: { kind: 'Name', value: 'published' } },
          {
            kind: 'Field',
            alias: { kind: 'Name', value: 'yiCourseModuleType' },
            name: { kind: 'Name', value: 'contentReferencesFrom' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'types' },
                value: { kind: 'StringValue', value: 'yi-course-module-type', block: false },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'ContentDetails_Tag_ContentReferenceFragment' },
                },
              ],
            },
          },
          {
            kind: 'FragmentSpread',
            name: { kind: 'Name', value: 'Content_ProviderMetadataFragment' },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'Content_ProviderCommonFragment' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'ContentProvider' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [{ kind: 'Field', name: { kind: 'Name', value: 'contentId' } }],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'ContentDetails_Tag_ContentReferenceFragment' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'ContentReference' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          { kind: 'Field', name: { kind: 'Name', value: 'sortKey' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'contentReferenceType' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [{ kind: 'Field', name: { kind: 'Name', value: 'type' } }],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'contentTo' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'language' },
                value: {
                  kind: 'ListValue',
                  values: [
                    { kind: 'StringValue', value: 'en', block: false },
                    { kind: 'StringValue', value: '_primary', block: false },
                  ],
                },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                { kind: 'Field', name: { kind: 'Name', value: 'titleGroupId' } },
                { kind: 'Field', name: { kind: 'Name', value: 'title' } },
                { kind: 'Field', name: { kind: 'Name', value: 'contentId' } },
                { kind: 'Field', name: { kind: 'Name', value: 'contentType' } },
                { kind: 'Field', name: { kind: 'Name', value: 'published' } },
              ],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'Content_ProviderMetadataFragment' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'Content' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            alias: { kind: 'Name', value: 'providerMetadata' },
            name: { kind: 'Name', value: 'contentProvider' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'metadata' } },
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'Content_ProviderCommonFragment' },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<YiCourse_ModuleDetailsContentFragmentFragment, unknown>
export const YiCourse_ModulesContentReferenceFragmentFragmentDoc = {
  kind: 'Document',
  definitions: [
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'YICourse_ModulesContentReferenceFragment' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'ContentReference' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'sortKey' } },
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'contentReferenceType' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [{ kind: 'Field', name: { kind: 'Name', value: 'type' } }],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'contentTo' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'YICourse_ModuleDetailsContentFragment' },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'ContentDetails_Tag_ContentReferenceFragment' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'ContentReference' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          { kind: 'Field', name: { kind: 'Name', value: 'sortKey' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'contentReferenceType' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [{ kind: 'Field', name: { kind: 'Name', value: 'type' } }],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'contentTo' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'language' },
                value: {
                  kind: 'ListValue',
                  values: [
                    { kind: 'StringValue', value: 'en', block: false },
                    { kind: 'StringValue', value: '_primary', block: false },
                  ],
                },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                { kind: 'Field', name: { kind: 'Name', value: 'titleGroupId' } },
                { kind: 'Field', name: { kind: 'Name', value: 'title' } },
                { kind: 'Field', name: { kind: 'Name', value: 'contentId' } },
                { kind: 'Field', name: { kind: 'Name', value: 'contentType' } },
                { kind: 'Field', name: { kind: 'Name', value: 'published' } },
              ],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'Content_ProviderCommonFragment' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'ContentProvider' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [{ kind: 'Field', name: { kind: 'Name', value: 'contentId' } }],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'Content_ProviderMetadataFragment' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'Content' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            alias: { kind: 'Name', value: 'providerMetadata' },
            name: { kind: 'Name', value: 'contentProvider' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'metadata' } },
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'Content_ProviderCommonFragment' },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'YICourse_ModuleDetailsContentFragment' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'Content' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'title' } },
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          { kind: 'Field', name: { kind: 'Name', value: 'contentType' } },
          { kind: 'Field', name: { kind: 'Name', value: 'contentId' } },
          { kind: 'Field', name: { kind: 'Name', value: 'published' } },
          {
            kind: 'Field',
            alias: { kind: 'Name', value: 'yiCourseModuleType' },
            name: { kind: 'Name', value: 'contentReferencesFrom' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'types' },
                value: { kind: 'StringValue', value: 'yi-course-module-type', block: false },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'ContentDetails_Tag_ContentReferenceFragment' },
                },
              ],
            },
          },
          {
            kind: 'FragmentSpread',
            name: { kind: 'Name', value: 'Content_ProviderMetadataFragment' },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<YiCourse_ModulesContentReferenceFragmentFragment, unknown>
export const YiCourse_ContentFragmentFragmentDoc = {
  kind: 'Document',
  definitions: [
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'YICourse_ContentFragment' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'Content' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          { kind: 'Field', name: { kind: 'Name', value: 'contentId' } },
          { kind: 'Field', name: { kind: 'Name', value: 'contentType' } },
          { kind: 'Field', name: { kind: 'Name', value: 'published' } },
          { kind: 'Field', name: { kind: 'Name', value: 'publishedAtDate' } },
          { kind: 'Field', name: { kind: 'Name', value: 'createdAt' } },
          { kind: 'Field', name: { kind: 'Name', value: 'updatedAt' } },
          { kind: 'Field', name: { kind: 'Name', value: 'title' } },
          { kind: 'Field', name: { kind: 'Name', value: 'path' } },
          { kind: 'Field', name: { kind: 'Name', value: 'shortDescription' } },
          { kind: 'Field', name: { kind: 'Name', value: 'description' } },
          { kind: 'Field', name: { kind: 'Name', value: 'language' } },
          { kind: 'Field', name: { kind: 'Name', value: 'seoDescription' } },
          { kind: 'Field', name: { kind: 'Name', value: 'seoTitle' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'contentProvider' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'provider' } },
                { kind: 'Field', name: { kind: 'Name', value: 'providerKey' } },
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'Content_ProviderCommonFragment' },
                },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'contentPolicy' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'policyId' } },
                { kind: 'Field', name: { kind: 'Name', value: 'name' } },
              ],
            },
          },
          { kind: 'Field', name: { kind: 'Name', value: 'descriptionFormat' } },
          { kind: 'Field', name: { kind: 'Name', value: 'shortDescriptionFormat' } },
          { kind: 'Field', name: { kind: 'Name', value: 'displayType' } },
          { kind: 'Field', name: { kind: 'Name', value: 'featureMediaId' } },
          { kind: 'Field', name: { kind: 'Name', value: 'primaryLanguage' } },
          { kind: 'Field', name: { kind: 'Name', value: 'productType' } },
          { kind: 'Field', name: { kind: 'Name', value: 'seoDescription' } },
          { kind: 'Field', name: { kind: 'Name', value: 'seoTitle' } },
          {
            kind: 'Field',
            alias: { kind: 'Name', value: 'yiContentType' },
            name: { kind: 'Name', value: 'contentReferencesFrom' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'types' },
                value: { kind: 'StringValue', value: 'yi-content-type', block: false },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'ContentDetails_Tag_ContentReferenceFragment' },
                },
              ],
            },
          },
          {
            kind: 'Field',
            alias: { kind: 'Name', value: 'yiTags' },
            name: { kind: 'Name', value: 'contentReferencesFrom' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'types' },
                value: { kind: 'StringValue', value: 'yi-tag', block: false },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'ContentDetails_Tag_ContentReferenceFragment' },
                },
              ],
            },
          },
          {
            kind: 'Field',
            alias: { kind: 'Name', value: 'yiYogaTeacher' },
            name: { kind: 'Name', value: 'contentReferencesFrom' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'types' },
                value: { kind: 'StringValue', value: 'yi-yoga-teacher', block: false },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'ContentDetails_Person_ContentReferenceFragment' },
                },
              ],
            },
          },
          {
            kind: 'Field',
            alias: { kind: 'Name', value: 'yiActionType' },
            name: { kind: 'Name', value: 'references' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'types' },
                value: { kind: 'StringValue', value: 'yi-action-type', block: false },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'ContentDetails_Person_ContentReferenceFragment' },
                },
              ],
            },
          },
          {
            kind: 'Field',
            alias: { kind: 'Name', value: 'yiCourseModules' },
            name: { kind: 'Name', value: 'contentReferencesFrom' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'types' },
                value: {
                  kind: 'ListValue',
                  values: [
                    { kind: 'StringValue', value: 'yi-course-module', block: false },
                    { kind: 'StringValue', value: 'yi-course-module-group', block: false },
                  ],
                },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'YICourse_ModulesContentReferenceFragment' },
                },
              ],
            },
          },
          {
            kind: 'Field',
            alias: { kind: 'Name', value: 'yiCourseSalesPages' },
            name: { kind: 'Name', value: 'contentReferencesTo' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'types' },
                value: { kind: 'StringValue', value: 'yi-course', block: false },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'contentFrom' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'contentType' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'contentId' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'title' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'published' } },
                    ],
                  },
                },
              ],
            },
          },
          {
            kind: 'FragmentSpread',
            name: { kind: 'Name', value: 'Content_ProviderMetadataFragment' },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'ContentDetails_Person_ContentFragment' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'Content' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          { kind: 'Field', name: { kind: 'Name', value: 'title' } },
          { kind: 'Field', name: { kind: 'Name', value: 'language' } },
          { kind: 'Field', name: { kind: 'Name', value: 'contentType' } },
          { kind: 'Field', name: { kind: 'Name', value: 'contentId' } },
          { kind: 'Field', name: { kind: 'Name', value: 'published' } },
          {
            kind: 'Field',
            alias: { kind: 'Name', value: 'avatar' },
            name: { kind: 'Name', value: 'imageContentRelationships' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                { kind: 'Field', name: { kind: 'Name', value: 'type' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'image' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'url' } },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'ContentDetails_Tag_ContentReferenceFragment' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'ContentReference' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          { kind: 'Field', name: { kind: 'Name', value: 'sortKey' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'contentReferenceType' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [{ kind: 'Field', name: { kind: 'Name', value: 'type' } }],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'contentTo' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'language' },
                value: {
                  kind: 'ListValue',
                  values: [
                    { kind: 'StringValue', value: 'en', block: false },
                    { kind: 'StringValue', value: '_primary', block: false },
                  ],
                },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                { kind: 'Field', name: { kind: 'Name', value: 'titleGroupId' } },
                { kind: 'Field', name: { kind: 'Name', value: 'title' } },
                { kind: 'Field', name: { kind: 'Name', value: 'contentId' } },
                { kind: 'Field', name: { kind: 'Name', value: 'contentType' } },
                { kind: 'Field', name: { kind: 'Name', value: 'published' } },
              ],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'Content_ProviderCommonFragment' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'ContentProvider' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [{ kind: 'Field', name: { kind: 'Name', value: 'contentId' } }],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'Content_ProviderMetadataFragment' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'Content' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            alias: { kind: 'Name', value: 'providerMetadata' },
            name: { kind: 'Name', value: 'contentProvider' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'metadata' } },
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'Content_ProviderCommonFragment' },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'YICourse_ModuleDetailsContentFragment' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'Content' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'title' } },
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          { kind: 'Field', name: { kind: 'Name', value: 'contentType' } },
          { kind: 'Field', name: { kind: 'Name', value: 'contentId' } },
          { kind: 'Field', name: { kind: 'Name', value: 'published' } },
          {
            kind: 'Field',
            alias: { kind: 'Name', value: 'yiCourseModuleType' },
            name: { kind: 'Name', value: 'contentReferencesFrom' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'types' },
                value: { kind: 'StringValue', value: 'yi-course-module-type', block: false },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'ContentDetails_Tag_ContentReferenceFragment' },
                },
              ],
            },
          },
          {
            kind: 'FragmentSpread',
            name: { kind: 'Name', value: 'Content_ProviderMetadataFragment' },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'ContentDetails_Person_ContentReferenceFragment' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'ContentReference' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          { kind: 'Field', name: { kind: 'Name', value: 'sortKey' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'contentReferenceType' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                { kind: 'Field', name: { kind: 'Name', value: 'type' } },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'contentTo' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'ContentDetails_Person_ContentFragment' },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'YICourse_ModulesContentReferenceFragment' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'ContentReference' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'sortKey' } },
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'contentReferenceType' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [{ kind: 'Field', name: { kind: 'Name', value: 'type' } }],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'contentTo' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'YICourse_ModuleDetailsContentFragment' },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<YiCourse_ContentFragmentFragment, unknown>
export const ContentDetails_ContentAssetReferenceFragmentFragmentDoc = {
  kind: 'Document',
  definitions: [
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'ContentDetails_ContentAssetReferenceFragment' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'ContentAssetReference' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'asset' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                { kind: 'Field', name: { kind: 'Name', value: 'mimeType' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'contentAssetReference' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [{ kind: 'Field', name: { kind: 'Name', value: 'assetsId' } }],
                  },
                },
                { kind: 'Field', name: { kind: 'Name', value: 'fileSize' } },
                { kind: 'Field', name: { kind: 'Name', value: 'originalFileName' } },
                { kind: 'Field', name: { kind: 'Name', value: 'renderUrl' } },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<ContentDetails_ContentAssetReferenceFragmentFragment, unknown>
export const YiCourseModuleDownload_ContentFragmentFragmentDoc = {
  kind: 'Document',
  definitions: [
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'YICourseModuleDownload_ContentFragment' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'Content' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            alias: { kind: 'Name', value: 'yiCourseModuleDownload' },
            name: { kind: 'Name', value: 'contentAssetReferences' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'contentAssetReferences' },
                value: {
                  kind: 'ObjectValue',
                  fields: [
                    {
                      kind: 'ObjectField',
                      name: { kind: 'Name', value: 'type' },
                      value: {
                        kind: 'StringValue',
                        value: 'yi-course-module-download',
                        block: false,
                      },
                    },
                  ],
                },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'ContentDetails_ContentAssetReferenceFragment' },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'ContentDetails_ContentAssetReferenceFragment' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'ContentAssetReference' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'asset' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                { kind: 'Field', name: { kind: 'Name', value: 'mimeType' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'contentAssetReference' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [{ kind: 'Field', name: { kind: 'Name', value: 'assetsId' } }],
                  },
                },
                { kind: 'Field', name: { kind: 'Name', value: 'fileSize' } },
                { kind: 'Field', name: { kind: 'Name', value: 'originalFileName' } },
                { kind: 'Field', name: { kind: 'Name', value: 'renderUrl' } },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<YiCourseModuleDownload_ContentFragmentFragment, unknown>
export const YiCourseModule_ContentFragmentFragmentDoc = {
  kind: 'Document',
  definitions: [
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'YICourseModule_ContentFragment' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'Content' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          { kind: 'Field', name: { kind: 'Name', value: 'title' } },
          { kind: 'Field', name: { kind: 'Name', value: 'contentType' } },
          { kind: 'Field', name: { kind: 'Name', value: 'contentId' } },
          { kind: 'Field', name: { kind: 'Name', value: 'description' } },
          { kind: 'Field', name: { kind: 'Name', value: 'descriptionFormat' } },
          { kind: 'Field', name: { kind: 'Name', value: 'published' } },
          { kind: 'Field', name: { kind: 'Name', value: 'publishedAtDate' } },
          { kind: 'Field', name: { kind: 'Name', value: 'primaryLanguage' } },
          { kind: 'Field', name: { kind: 'Name', value: 'language' } },
          { kind: 'Field', name: { kind: 'Name', value: 'shortDescription' } },
          { kind: 'Field', name: { kind: 'Name', value: 'shortDescriptionFormat' } },
          { kind: 'Field', name: { kind: 'Name', value: 'path' } },
          { kind: 'FragmentSpread', name: { kind: 'Name', value: 'ContentFeatureMediaFragment' } },
          {
            kind: 'Field',
            alias: { kind: 'Name', value: 'yiContentType' },
            name: { kind: 'Name', value: 'contentReferencesFrom' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'types' },
                value: { kind: 'StringValue', value: 'yi-content-type', block: false },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'ContentDetails_Tag_ContentReferenceFragment' },
                },
              ],
            },
          },
          {
            kind: 'Field',
            alias: { kind: 'Name', value: 'yiCourseModuleType' },
            name: { kind: 'Name', value: 'contentReferencesFrom' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'types' },
                value: { kind: 'StringValue', value: 'yi-course-module-type', block: false },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'ContentDetails_Tag_ContentReferenceFragment' },
                },
              ],
            },
          },
          {
            kind: 'Field',
            alias: { kind: 'Name', value: 'yiConsumptionType' },
            name: { kind: 'Name', value: 'contentReferencesFrom' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'types' },
                value: { kind: 'StringValue', value: 'yi-consumption-type', block: false },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'ContentDetails_Tag_ContentReferenceFragment' },
                },
              ],
            },
          },
          {
            kind: 'Field',
            alias: { kind: 'Name', value: 'yiYogaStyles' },
            name: { kind: 'Name', value: 'contentReferencesFrom' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'types' },
                value: { kind: 'StringValue', value: 'yi-yoga-style', block: false },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'ContentDetails_Tag_ContentReferenceFragment' },
                },
              ],
            },
          },
          {
            kind: 'FragmentSpread',
            name: { kind: 'Name', value: 'YICourseModuleDownload_ContentFragment' },
          },
          {
            kind: 'FragmentSpread',
            name: { kind: 'Name', value: 'Content_ProviderMetadataFragment' },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'Common_MediaFragment' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'Media' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'mediaId' } },
          { kind: 'Field', name: { kind: 'Name', value: 'contentId' } },
          { kind: 'Field', name: { kind: 'Name', value: 'mediaMaestroTitleCode' } },
          { kind: 'Field', name: { kind: 'Name', value: 'policyId' } },
          { kind: 'Field', name: { kind: 'Name', value: 'updatedAt' } },
          { kind: 'Field', name: { kind: 'Name', value: 'duration' } },
          { kind: 'Field', name: { kind: 'Name', value: 'isPublished' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'mediaAssets' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                { kind: 'Field', name: { kind: 'Name', value: 'providerKey' } },
              ],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'ContentDetails_ContentAssetReferenceFragment' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'ContentAssetReference' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'asset' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                { kind: 'Field', name: { kind: 'Name', value: 'mimeType' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'contentAssetReference' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [{ kind: 'Field', name: { kind: 'Name', value: 'assetsId' } }],
                  },
                },
                { kind: 'Field', name: { kind: 'Name', value: 'fileSize' } },
                { kind: 'Field', name: { kind: 'Name', value: 'originalFileName' } },
                { kind: 'Field', name: { kind: 'Name', value: 'renderUrl' } },
              ],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'Content_ProviderCommonFragment' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'ContentProvider' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [{ kind: 'Field', name: { kind: 'Name', value: 'contentId' } }],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'ContentFeatureMediaFragment' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'Content' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'contentPolicyPolicyId' } },
          { kind: 'Field', name: { kind: 'Name', value: 'featureMediaId' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'featureMedia' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'FragmentSpread', name: { kind: 'Name', value: 'Common_MediaFragment' } },
              ],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'ContentDetails_Tag_ContentReferenceFragment' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'ContentReference' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          { kind: 'Field', name: { kind: 'Name', value: 'sortKey' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'contentReferenceType' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [{ kind: 'Field', name: { kind: 'Name', value: 'type' } }],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'contentTo' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'language' },
                value: {
                  kind: 'ListValue',
                  values: [
                    { kind: 'StringValue', value: 'en', block: false },
                    { kind: 'StringValue', value: '_primary', block: false },
                  ],
                },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                { kind: 'Field', name: { kind: 'Name', value: 'titleGroupId' } },
                { kind: 'Field', name: { kind: 'Name', value: 'title' } },
                { kind: 'Field', name: { kind: 'Name', value: 'contentId' } },
                { kind: 'Field', name: { kind: 'Name', value: 'contentType' } },
                { kind: 'Field', name: { kind: 'Name', value: 'published' } },
              ],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'YICourseModuleDownload_ContentFragment' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'Content' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            alias: { kind: 'Name', value: 'yiCourseModuleDownload' },
            name: { kind: 'Name', value: 'contentAssetReferences' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'contentAssetReferences' },
                value: {
                  kind: 'ObjectValue',
                  fields: [
                    {
                      kind: 'ObjectField',
                      name: { kind: 'Name', value: 'type' },
                      value: {
                        kind: 'StringValue',
                        value: 'yi-course-module-download',
                        block: false,
                      },
                    },
                  ],
                },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'ContentDetails_ContentAssetReferenceFragment' },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'Content_ProviderMetadataFragment' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'Content' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            alias: { kind: 'Name', value: 'providerMetadata' },
            name: { kind: 'Name', value: 'contentProvider' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'metadata' } },
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'Content_ProviderCommonFragment' },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<YiCourseModule_ContentFragmentFragment, unknown>
export const Common_ContentProviderFragmentFragmentDoc = {
  kind: 'Document',
  definitions: [
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'Common_ContentProviderFragment' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'Content' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'contentProvider' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'provider' } },
                { kind: 'Field', name: { kind: 'Name', value: 'providerKey' } },
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'Content_ProviderCommonFragment' },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'Content_ProviderCommonFragment' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'ContentProvider' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [{ kind: 'Field', name: { kind: 'Name', value: 'contentId' } }],
      },
    },
  ],
} as unknown as DocumentNode<Common_ContentProviderFragmentFragment, unknown>
export const YiCourseSales_ContentFragmentFragmentDoc = {
  kind: 'Document',
  definitions: [
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'YICourseSales_ContentFragment' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'Content' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'contentPolicyPolicyId' } },
          { kind: 'Field', name: { kind: 'Name', value: 'description' } },
          { kind: 'Field', name: { kind: 'Name', value: 'descriptionFormat' } },
          { kind: 'Field', name: { kind: 'Name', value: 'path' } },
          { kind: 'Field', name: { kind: 'Name', value: 'primaryLanguage' } },
          { kind: 'Field', name: { kind: 'Name', value: 'published' } },
          { kind: 'Field', name: { kind: 'Name', value: 'publishedAtDate' } },
          { kind: 'FragmentSpread', name: { kind: 'Name', value: 'ContentFeatureMediaFragment' } },
          {
            kind: 'Field',
            alias: { kind: 'Name', value: 'yiContentType' },
            name: { kind: 'Name', value: 'contentReferencesFrom' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'types' },
                value: { kind: 'StringValue', value: 'yi-content-type', block: false },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'ContentDetails_Tag_ContentReferenceFragment' },
                },
              ],
            },
          },
          {
            kind: 'Field',
            alias: { kind: 'Name', value: 'yiCourses' },
            name: { kind: 'Name', value: 'contentReferencesFrom' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'types' },
                value: { kind: 'StringValue', value: 'yi-course', block: false },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'contentTo' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'contentType' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'contentId' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'title' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'published' } },
                      {
                        kind: 'FragmentSpread',
                        name: { kind: 'Name', value: 'Common_ContentProviderFragment' },
                      },
                    ],
                  },
                },
              ],
            },
          },
          {
            kind: 'FragmentSpread',
            name: { kind: 'Name', value: 'Content_ProviderMetadataFragment' },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'Common_MediaFragment' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'Media' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'mediaId' } },
          { kind: 'Field', name: { kind: 'Name', value: 'contentId' } },
          { kind: 'Field', name: { kind: 'Name', value: 'mediaMaestroTitleCode' } },
          { kind: 'Field', name: { kind: 'Name', value: 'policyId' } },
          { kind: 'Field', name: { kind: 'Name', value: 'updatedAt' } },
          { kind: 'Field', name: { kind: 'Name', value: 'duration' } },
          { kind: 'Field', name: { kind: 'Name', value: 'isPublished' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'mediaAssets' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                { kind: 'Field', name: { kind: 'Name', value: 'providerKey' } },
              ],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'Content_ProviderCommonFragment' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'ContentProvider' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [{ kind: 'Field', name: { kind: 'Name', value: 'contentId' } }],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'ContentFeatureMediaFragment' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'Content' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'contentPolicyPolicyId' } },
          { kind: 'Field', name: { kind: 'Name', value: 'featureMediaId' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'featureMedia' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'FragmentSpread', name: { kind: 'Name', value: 'Common_MediaFragment' } },
              ],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'ContentDetails_Tag_ContentReferenceFragment' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'ContentReference' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          { kind: 'Field', name: { kind: 'Name', value: 'sortKey' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'contentReferenceType' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [{ kind: 'Field', name: { kind: 'Name', value: 'type' } }],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'contentTo' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'language' },
                value: {
                  kind: 'ListValue',
                  values: [
                    { kind: 'StringValue', value: 'en', block: false },
                    { kind: 'StringValue', value: '_primary', block: false },
                  ],
                },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                { kind: 'Field', name: { kind: 'Name', value: 'titleGroupId' } },
                { kind: 'Field', name: { kind: 'Name', value: 'title' } },
                { kind: 'Field', name: { kind: 'Name', value: 'contentId' } },
                { kind: 'Field', name: { kind: 'Name', value: 'contentType' } },
                { kind: 'Field', name: { kind: 'Name', value: 'published' } },
              ],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'Common_ContentProviderFragment' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'Content' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'contentProvider' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'provider' } },
                { kind: 'Field', name: { kind: 'Name', value: 'providerKey' } },
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'Content_ProviderCommonFragment' },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'Content_ProviderMetadataFragment' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'Content' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            alias: { kind: 'Name', value: 'providerMetadata' },
            name: { kind: 'Name', value: 'contentProvider' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'metadata' } },
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'Content_ProviderCommonFragment' },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<YiCourseSales_ContentFragmentFragment, unknown>
export const YiCourseSection_ContentFragmentFragmentDoc = {
  kind: 'Document',
  definitions: [
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'YICourseSection_ContentFragment' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'Content' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          { kind: 'Field', name: { kind: 'Name', value: 'title' } },
          { kind: 'Field', name: { kind: 'Name', value: 'contentType' } },
          { kind: 'Field', name: { kind: 'Name', value: 'contentId' } },
          { kind: 'Field', name: { kind: 'Name', value: 'published' } },
          {
            kind: 'Field',
            alias: { kind: 'Name', value: 'yiContentType' },
            name: { kind: 'Name', value: 'contentReferencesFrom' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'types' },
                value: { kind: 'StringValue', value: 'yi-content-type', block: false },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'ContentDetails_Tag_ContentReferenceFragment' },
                },
              ],
            },
          },
          {
            kind: 'FragmentSpread',
            name: { kind: 'Name', value: 'Content_ProviderMetadataFragment' },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'Content_ProviderCommonFragment' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'ContentProvider' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [{ kind: 'Field', name: { kind: 'Name', value: 'contentId' } }],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'ContentDetails_Tag_ContentReferenceFragment' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'ContentReference' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          { kind: 'Field', name: { kind: 'Name', value: 'sortKey' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'contentReferenceType' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [{ kind: 'Field', name: { kind: 'Name', value: 'type' } }],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'contentTo' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'language' },
                value: {
                  kind: 'ListValue',
                  values: [
                    { kind: 'StringValue', value: 'en', block: false },
                    { kind: 'StringValue', value: '_primary', block: false },
                  ],
                },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                { kind: 'Field', name: { kind: 'Name', value: 'titleGroupId' } },
                { kind: 'Field', name: { kind: 'Name', value: 'title' } },
                { kind: 'Field', name: { kind: 'Name', value: 'contentId' } },
                { kind: 'Field', name: { kind: 'Name', value: 'contentType' } },
                { kind: 'Field', name: { kind: 'Name', value: 'published' } },
              ],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'Content_ProviderMetadataFragment' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'Content' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            alias: { kind: 'Name', value: 'providerMetadata' },
            name: { kind: 'Name', value: 'contentProvider' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'metadata' } },
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'Content_ProviderCommonFragment' },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<YiCourseSection_ContentFragmentFragment, unknown>
export const YiHomepageHero_ContentFragmentFragmentDoc = {
  kind: 'Document',
  definitions: [
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'YIHomepageHero_ContentFragment' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'Content' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          { kind: 'Field', name: { kind: 'Name', value: 'contentId' } },
          { kind: 'Field', name: { kind: 'Name', value: 'contentType' } },
          { kind: 'Field', name: { kind: 'Name', value: 'language' } },
          { kind: 'Field', name: { kind: 'Name', value: 'primaryLanguage' } },
          { kind: 'Field', name: { kind: 'Name', value: 'published' } },
          { kind: 'Field', name: { kind: 'Name', value: 'publishedAtDate' } },
          { kind: 'Field', name: { kind: 'Name', value: 'title' } },
          {
            kind: 'Field',
            alias: { kind: 'Name', value: 'yiContentType' },
            name: { kind: 'Name', value: 'contentReferencesFrom' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'types' },
                value: { kind: 'StringValue', value: 'yi-content-type', block: false },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'ContentDetails_Tag_ContentReferenceFragment' },
                },
              ],
            },
          },
          {
            kind: 'Field',
            alias: { kind: 'Name', value: 'yiHomepageHeroContent' },
            name: { kind: 'Name', value: 'contentReferencesFrom' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'types' },
                value: { kind: 'StringValue', value: 'yi-homepage-hero-content', block: false },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'contentReferenceType' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [{ kind: 'Field', name: { kind: 'Name', value: 'type' } }],
                  },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'contentTo' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'contentType' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'contentId' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'title' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'published' } },
                      {
                        kind: 'Field',
                        alias: { kind: 'Name', value: 'yiContentType' },
                        name: { kind: 'Name', value: 'contentReferencesFrom' },
                        arguments: [
                          {
                            kind: 'Argument',
                            name: { kind: 'Name', value: 'types' },
                            value: { kind: 'StringValue', value: 'yi-content-type', block: false },
                          },
                        ],
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            {
                              kind: 'FragmentSpread',
                              name: {
                                kind: 'Name',
                                value: 'ContentDetails_Tag_ContentReferenceFragment',
                              },
                            },
                          ],
                        },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'contentProvider' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            { kind: 'Field', name: { kind: 'Name', value: 'provider' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'providerKey' } },
                            {
                              kind: 'FragmentSpread',
                              name: { kind: 'Name', value: 'Content_ProviderCommonFragment' },
                            },
                          ],
                        },
                      },
                    ],
                  },
                },
              ],
            },
          },
          {
            kind: 'FragmentSpread',
            name: { kind: 'Name', value: 'Content_ProviderMetadataFragment' },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'Content_ProviderCommonFragment' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'ContentProvider' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [{ kind: 'Field', name: { kind: 'Name', value: 'contentId' } }],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'ContentDetails_Tag_ContentReferenceFragment' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'ContentReference' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          { kind: 'Field', name: { kind: 'Name', value: 'sortKey' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'contentReferenceType' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [{ kind: 'Field', name: { kind: 'Name', value: 'type' } }],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'contentTo' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'language' },
                value: {
                  kind: 'ListValue',
                  values: [
                    { kind: 'StringValue', value: 'en', block: false },
                    { kind: 'StringValue', value: '_primary', block: false },
                  ],
                },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                { kind: 'Field', name: { kind: 'Name', value: 'titleGroupId' } },
                { kind: 'Field', name: { kind: 'Name', value: 'title' } },
                { kind: 'Field', name: { kind: 'Name', value: 'contentId' } },
                { kind: 'Field', name: { kind: 'Name', value: 'contentType' } },
                { kind: 'Field', name: { kind: 'Name', value: 'published' } },
              ],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'Content_ProviderMetadataFragment' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'Content' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            alias: { kind: 'Name', value: 'providerMetadata' },
            name: { kind: 'Name', value: 'contentProvider' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'metadata' } },
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'Content_ProviderCommonFragment' },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<YiHomepageHero_ContentFragmentFragment, unknown>
export const YiMeditation_ContentFragmentFragmentDoc = {
  kind: 'Document',
  definitions: [
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'YIMeditation_ContentFragment' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'Content' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'descriptionFormat' } },
          { kind: 'Field', name: { kind: 'Name', value: 'shortDescriptionFormat' } },
          { kind: 'Field', name: { kind: 'Name', value: 'displayType' } },
          { kind: 'Field', name: { kind: 'Name', value: 'primaryLanguage' } },
          { kind: 'Field', name: { kind: 'Name', value: 'productType' } },
          { kind: 'Field', name: { kind: 'Name', value: 'seoDescription' } },
          { kind: 'Field', name: { kind: 'Name', value: 'seoTitle' } },
          { kind: 'FragmentSpread', name: { kind: 'Name', value: 'ContentFeatureMediaFragment' } },
          {
            kind: 'Field',
            alias: { kind: 'Name', value: 'yiContentType' },
            name: { kind: 'Name', value: 'contentReferencesFrom' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'types' },
                value: { kind: 'StringValue', value: 'yi-content-type', block: false },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'ContentDetails_Tag_ContentReferenceFragment' },
                },
              ],
            },
          },
          {
            kind: 'Field',
            alias: { kind: 'Name', value: 'yiTags' },
            name: { kind: 'Name', value: 'contentReferencesFrom' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'types' },
                value: { kind: 'StringValue', value: 'yi-tag', block: false },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'ContentDetails_Tag_ContentReferenceFragment' },
                },
              ],
            },
          },
          {
            kind: 'Field',
            alias: { kind: 'Name', value: 'yiYogaStyle' },
            name: { kind: 'Name', value: 'contentReferencesFrom' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'types' },
                value: { kind: 'StringValue', value: 'yi-yoga-style', block: false },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'ContentDetails_Tag_ContentReferenceFragment' },
                },
              ],
            },
          },
          {
            kind: 'Field',
            alias: { kind: 'Name', value: 'yiYogaTeacher' },
            name: { kind: 'Name', value: 'contentReferencesFrom' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'types' },
                value: { kind: 'StringValue', value: 'yi-yoga-teacher', block: false },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'ContentDetails_Person_ContentReferenceFragment' },
                },
              ],
            },
          },
          {
            kind: 'Field',
            alias: { kind: 'Name', value: 'yiPracticeType' },
            name: { kind: 'Name', value: 'contentReferencesFrom' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'types' },
                value: { kind: 'StringValue', value: 'yi-practice-type', block: false },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'ContentDetails_Person_ContentReferenceFragment' },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'Common_MediaFragment' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'Media' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'mediaId' } },
          { kind: 'Field', name: { kind: 'Name', value: 'contentId' } },
          { kind: 'Field', name: { kind: 'Name', value: 'mediaMaestroTitleCode' } },
          { kind: 'Field', name: { kind: 'Name', value: 'policyId' } },
          { kind: 'Field', name: { kind: 'Name', value: 'updatedAt' } },
          { kind: 'Field', name: { kind: 'Name', value: 'duration' } },
          { kind: 'Field', name: { kind: 'Name', value: 'isPublished' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'mediaAssets' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                { kind: 'Field', name: { kind: 'Name', value: 'providerKey' } },
              ],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'ContentDetails_Person_ContentFragment' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'Content' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          { kind: 'Field', name: { kind: 'Name', value: 'title' } },
          { kind: 'Field', name: { kind: 'Name', value: 'language' } },
          { kind: 'Field', name: { kind: 'Name', value: 'contentType' } },
          { kind: 'Field', name: { kind: 'Name', value: 'contentId' } },
          { kind: 'Field', name: { kind: 'Name', value: 'published' } },
          {
            kind: 'Field',
            alias: { kind: 'Name', value: 'avatar' },
            name: { kind: 'Name', value: 'imageContentRelationships' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                { kind: 'Field', name: { kind: 'Name', value: 'type' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'image' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'url' } },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'ContentFeatureMediaFragment' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'Content' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'contentPolicyPolicyId' } },
          { kind: 'Field', name: { kind: 'Name', value: 'featureMediaId' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'featureMedia' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'FragmentSpread', name: { kind: 'Name', value: 'Common_MediaFragment' } },
              ],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'ContentDetails_Tag_ContentReferenceFragment' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'ContentReference' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          { kind: 'Field', name: { kind: 'Name', value: 'sortKey' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'contentReferenceType' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [{ kind: 'Field', name: { kind: 'Name', value: 'type' } }],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'contentTo' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'language' },
                value: {
                  kind: 'ListValue',
                  values: [
                    { kind: 'StringValue', value: 'en', block: false },
                    { kind: 'StringValue', value: '_primary', block: false },
                  ],
                },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                { kind: 'Field', name: { kind: 'Name', value: 'titleGroupId' } },
                { kind: 'Field', name: { kind: 'Name', value: 'title' } },
                { kind: 'Field', name: { kind: 'Name', value: 'contentId' } },
                { kind: 'Field', name: { kind: 'Name', value: 'contentType' } },
                { kind: 'Field', name: { kind: 'Name', value: 'published' } },
              ],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'ContentDetails_Person_ContentReferenceFragment' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'ContentReference' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          { kind: 'Field', name: { kind: 'Name', value: 'sortKey' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'contentReferenceType' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                { kind: 'Field', name: { kind: 'Name', value: 'type' } },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'contentTo' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'ContentDetails_Person_ContentFragment' },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<YiMeditation_ContentFragmentFragment, unknown>
export const YiMemberPromo_ContentFragmentFragmentDoc = {
  kind: 'Document',
  definitions: [
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'YIMemberPromo_ContentFragment' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'Content' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'contentPolicyPolicyId' } },
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          { kind: 'Field', name: { kind: 'Name', value: 'contentId' } },
          { kind: 'Field', name: { kind: 'Name', value: 'contentType' } },
          { kind: 'Field', name: { kind: 'Name', value: 'language' } },
          { kind: 'Field', name: { kind: 'Name', value: 'description' } },
          { kind: 'Field', name: { kind: 'Name', value: 'descriptionFormat' } },
          { kind: 'Field', name: { kind: 'Name', value: 'path' } },
          { kind: 'Field', name: { kind: 'Name', value: 'primaryLanguage' } },
          { kind: 'Field', name: { kind: 'Name', value: 'published' } },
          { kind: 'Field', name: { kind: 'Name', value: 'publishedAtDate' } },
          { kind: 'Field', name: { kind: 'Name', value: 'title' } },
          { kind: 'FragmentSpread', name: { kind: 'Name', value: 'ContentFeatureMediaFragment' } },
          {
            kind: 'Field',
            alias: { kind: 'Name', value: 'yiContentType' },
            name: { kind: 'Name', value: 'contentReferencesFrom' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'types' },
                value: { kind: 'StringValue', value: 'yi-content-type', block: false },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'ContentDetails_Tag_ContentReferenceFragment' },
                },
              ],
            },
          },
          {
            kind: 'Field',
            alias: { kind: 'Name', value: 'yiGiveAwayCourses' },
            name: { kind: 'Name', value: 'contentReferencesFrom' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'types' },
                value: { kind: 'StringValue', value: 'yi-course', block: false },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'contentTo' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'contentType' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'contentId' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'title' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'published' } },
                    ],
                  },
                },
              ],
            },
          },
          {
            kind: 'Field',
            alias: { kind: 'Name', value: 'yiPromotedContent' },
            name: { kind: 'Name', value: 'contentReferencesFrom' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'types' },
                value: { kind: 'StringValue', value: 'yi-promoted-content', block: false },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'contentTo' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'contentType' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'contentId' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'title' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'published' } },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'contentProvider' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            { kind: 'Field', name: { kind: 'Name', value: 'provider' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'providerKey' } },
                            {
                              kind: 'FragmentSpread',
                              name: { kind: 'Name', value: 'Content_ProviderCommonFragment' },
                            },
                          ],
                        },
                      },
                      {
                        kind: 'Field',
                        alias: { kind: 'Name', value: 'yiContentType' },
                        name: { kind: 'Name', value: 'contentReferencesFrom' },
                        arguments: [
                          {
                            kind: 'Argument',
                            name: { kind: 'Name', value: 'types' },
                            value: { kind: 'StringValue', value: 'yi-content-type', block: false },
                          },
                        ],
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            {
                              kind: 'FragmentSpread',
                              name: {
                                kind: 'Name',
                                value: 'ContentDetails_Tag_ContentReferenceFragment',
                              },
                            },
                          ],
                        },
                      },
                    ],
                  },
                },
              ],
            },
          },
          {
            kind: 'FragmentSpread',
            name: { kind: 'Name', value: 'Content_ProviderMetadataFragment' },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'Common_MediaFragment' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'Media' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'mediaId' } },
          { kind: 'Field', name: { kind: 'Name', value: 'contentId' } },
          { kind: 'Field', name: { kind: 'Name', value: 'mediaMaestroTitleCode' } },
          { kind: 'Field', name: { kind: 'Name', value: 'policyId' } },
          { kind: 'Field', name: { kind: 'Name', value: 'updatedAt' } },
          { kind: 'Field', name: { kind: 'Name', value: 'duration' } },
          { kind: 'Field', name: { kind: 'Name', value: 'isPublished' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'mediaAssets' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                { kind: 'Field', name: { kind: 'Name', value: 'providerKey' } },
              ],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'Content_ProviderCommonFragment' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'ContentProvider' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [{ kind: 'Field', name: { kind: 'Name', value: 'contentId' } }],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'ContentFeatureMediaFragment' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'Content' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'contentPolicyPolicyId' } },
          { kind: 'Field', name: { kind: 'Name', value: 'featureMediaId' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'featureMedia' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'FragmentSpread', name: { kind: 'Name', value: 'Common_MediaFragment' } },
              ],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'ContentDetails_Tag_ContentReferenceFragment' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'ContentReference' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          { kind: 'Field', name: { kind: 'Name', value: 'sortKey' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'contentReferenceType' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [{ kind: 'Field', name: { kind: 'Name', value: 'type' } }],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'contentTo' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'language' },
                value: {
                  kind: 'ListValue',
                  values: [
                    { kind: 'StringValue', value: 'en', block: false },
                    { kind: 'StringValue', value: '_primary', block: false },
                  ],
                },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                { kind: 'Field', name: { kind: 'Name', value: 'titleGroupId' } },
                { kind: 'Field', name: { kind: 'Name', value: 'title' } },
                { kind: 'Field', name: { kind: 'Name', value: 'contentId' } },
                { kind: 'Field', name: { kind: 'Name', value: 'contentType' } },
                { kind: 'Field', name: { kind: 'Name', value: 'published' } },
              ],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'Content_ProviderMetadataFragment' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'Content' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            alias: { kind: 'Name', value: 'providerMetadata' },
            name: { kind: 'Name', value: 'contentProvider' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'metadata' } },
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'Content_ProviderCommonFragment' },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<YiMemberPromo_ContentFragmentFragment, unknown>
export const YiPose_ContentFragmentFragmentDoc = {
  kind: 'Document',
  definitions: [
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'YIPose_ContentFragment' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'Content' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'contentPolicyPolicyId' } },
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          { kind: 'Field', name: { kind: 'Name', value: 'contentId' } },
          { kind: 'Field', name: { kind: 'Name', value: 'contentType' } },
          { kind: 'Field', name: { kind: 'Name', value: 'language' } },
          { kind: 'Field', name: { kind: 'Name', value: 'description' } },
          { kind: 'Field', name: { kind: 'Name', value: 'descriptionFormat' } },
          { kind: 'Field', name: { kind: 'Name', value: 'shortDescription' } },
          { kind: 'Field', name: { kind: 'Name', value: 'shortDescriptionFormat' } },
          { kind: 'Field', name: { kind: 'Name', value: 'path' } },
          { kind: 'Field', name: { kind: 'Name', value: 'primaryLanguage' } },
          { kind: 'Field', name: { kind: 'Name', value: 'published' } },
          { kind: 'Field', name: { kind: 'Name', value: 'publishedAtDate' } },
          { kind: 'Field', name: { kind: 'Name', value: 'seoDescription' } },
          { kind: 'Field', name: { kind: 'Name', value: 'seoTitle' } },
          { kind: 'Field', name: { kind: 'Name', value: 'title' } },
          { kind: 'Field', name: { kind: 'Name', value: 'titleGroupId' } },
          {
            kind: 'Field',
            alias: { kind: 'Name', value: 'yiContentType' },
            name: { kind: 'Name', value: 'contentReferencesFrom' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'types' },
                value: { kind: 'StringValue', value: 'yi-content-type', block: false },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'ContentDetails_Tag_ContentReferenceFragment' },
                },
              ],
            },
          },
          {
            kind: 'Field',
            alias: { kind: 'Name', value: 'yiTags' },
            name: { kind: 'Name', value: 'contentReferencesFrom' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'types' },
                value: { kind: 'StringValue', value: 'yi-tag', block: false },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'ContentDetails_Tag_ContentReferenceFragment' },
                },
              ],
            },
          },
          {
            kind: 'Field',
            alias: { kind: 'Name', value: 'yiPosePronunciation' },
            name: { kind: 'Name', value: 'contentAssetReferences' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'contentAssetReferences' },
                value: {
                  kind: 'ListValue',
                  values: [
                    {
                      kind: 'ObjectValue',
                      fields: [
                        {
                          kind: 'ObjectField',
                          name: { kind: 'Name', value: 'type' },
                          value: {
                            kind: 'StringValue',
                            value: 'yi-pose-pronunciation',
                            block: false,
                          },
                        },
                      ],
                    },
                  ],
                },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                { kind: 'Field', name: { kind: 'Name', value: 'contentAssetReferenceTypesId' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'asset' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'renderUrl' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'originalFileName' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'uuid' } },
                    ],
                  },
                },
              ],
            },
          },
          {
            kind: 'FragmentSpread',
            name: { kind: 'Name', value: 'Content_ProviderMetadataFragment' },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'Content_ProviderCommonFragment' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'ContentProvider' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [{ kind: 'Field', name: { kind: 'Name', value: 'contentId' } }],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'ContentDetails_Tag_ContentReferenceFragment' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'ContentReference' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          { kind: 'Field', name: { kind: 'Name', value: 'sortKey' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'contentReferenceType' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [{ kind: 'Field', name: { kind: 'Name', value: 'type' } }],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'contentTo' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'language' },
                value: {
                  kind: 'ListValue',
                  values: [
                    { kind: 'StringValue', value: 'en', block: false },
                    { kind: 'StringValue', value: '_primary', block: false },
                  ],
                },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                { kind: 'Field', name: { kind: 'Name', value: 'titleGroupId' } },
                { kind: 'Field', name: { kind: 'Name', value: 'title' } },
                { kind: 'Field', name: { kind: 'Name', value: 'contentId' } },
                { kind: 'Field', name: { kind: 'Name', value: 'contentType' } },
                { kind: 'Field', name: { kind: 'Name', value: 'published' } },
              ],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'Content_ProviderMetadataFragment' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'Content' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            alias: { kind: 'Name', value: 'providerMetadata' },
            name: { kind: 'Name', value: 'contentProvider' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'metadata' } },
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'Content_ProviderCommonFragment' },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<YiPose_ContentFragmentFragment, unknown>
export const ContentPreviewMediaFragmentFragmentDoc = {
  kind: 'Document',
  definitions: [
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'ContentPreviewMediaFragment' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'Content' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'contentPolicyPolicyId' } },
          { kind: 'Field', name: { kind: 'Name', value: 'previewMediaId' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'previewMedia' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'FragmentSpread', name: { kind: 'Name', value: 'Common_MediaFragment' } },
              ],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'Common_MediaFragment' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'Media' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'mediaId' } },
          { kind: 'Field', name: { kind: 'Name', value: 'contentId' } },
          { kind: 'Field', name: { kind: 'Name', value: 'mediaMaestroTitleCode' } },
          { kind: 'Field', name: { kind: 'Name', value: 'policyId' } },
          { kind: 'Field', name: { kind: 'Name', value: 'updatedAt' } },
          { kind: 'Field', name: { kind: 'Name', value: 'duration' } },
          { kind: 'Field', name: { kind: 'Name', value: 'isPublished' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'mediaAssets' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                { kind: 'Field', name: { kind: 'Name', value: 'providerKey' } },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<ContentPreviewMediaFragmentFragment, unknown>
export const YiSeries_EpisodeDetailsContentFragmentFragmentDoc = {
  kind: 'Document',
  definitions: [
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'YISeries_EpisodeDetailsContentFragment' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'Content' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'title' } },
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          { kind: 'Field', name: { kind: 'Name', value: 'contentType' } },
          { kind: 'Field', name: { kind: 'Name', value: 'contentId' } },
          { kind: 'Field', name: { kind: 'Name', value: 'published' } },
          { kind: 'Field', name: { kind: 'Name', value: 'seasonNumber' } },
          { kind: 'Field', name: { kind: 'Name', value: 'episodeNumber' } },
          {
            kind: 'FragmentSpread',
            name: { kind: 'Name', value: 'Content_ProviderMetadataFragment' },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'Content_ProviderCommonFragment' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'ContentProvider' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [{ kind: 'Field', name: { kind: 'Name', value: 'contentId' } }],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'Content_ProviderMetadataFragment' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'Content' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            alias: { kind: 'Name', value: 'providerMetadata' },
            name: { kind: 'Name', value: 'contentProvider' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'metadata' } },
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'Content_ProviderCommonFragment' },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<YiSeries_EpisodeDetailsContentFragmentFragment, unknown>
export const YiSeries_EpisodeContentFragmentFragmentDoc = {
  kind: 'Document',
  definitions: [
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'YISeries_EpisodeContentFragment' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'ContentReference' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          { kind: 'Field', name: { kind: 'Name', value: 'sortKey' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'contentReferenceType' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [{ kind: 'Field', name: { kind: 'Name', value: 'type' } }],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'contentTo' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'YISeries_EpisodeDetailsContentFragment' },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'Content_ProviderCommonFragment' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'ContentProvider' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [{ kind: 'Field', name: { kind: 'Name', value: 'contentId' } }],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'Content_ProviderMetadataFragment' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'Content' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            alias: { kind: 'Name', value: 'providerMetadata' },
            name: { kind: 'Name', value: 'contentProvider' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'metadata' } },
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'Content_ProviderCommonFragment' },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'YISeries_EpisodeDetailsContentFragment' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'Content' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'title' } },
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          { kind: 'Field', name: { kind: 'Name', value: 'contentType' } },
          { kind: 'Field', name: { kind: 'Name', value: 'contentId' } },
          { kind: 'Field', name: { kind: 'Name', value: 'published' } },
          { kind: 'Field', name: { kind: 'Name', value: 'seasonNumber' } },
          { kind: 'Field', name: { kind: 'Name', value: 'episodeNumber' } },
          {
            kind: 'FragmentSpread',
            name: { kind: 'Name', value: 'Content_ProviderMetadataFragment' },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<YiSeries_EpisodeContentFragmentFragment, unknown>
export const YiSeries_ContentFragmentFragmentDoc = {
  kind: 'Document',
  definitions: [
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'YISeries_ContentFragment' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'Content' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          { kind: 'Field', name: { kind: 'Name', value: 'contentId' } },
          { kind: 'Field', name: { kind: 'Name', value: 'contentType' } },
          { kind: 'Field', name: { kind: 'Name', value: 'published' } },
          { kind: 'Field', name: { kind: 'Name', value: 'publishedAtDate' } },
          { kind: 'Field', name: { kind: 'Name', value: 'createdAt' } },
          { kind: 'Field', name: { kind: 'Name', value: 'updatedAt' } },
          { kind: 'Field', name: { kind: 'Name', value: 'title' } },
          { kind: 'Field', name: { kind: 'Name', value: 'path' } },
          { kind: 'Field', name: { kind: 'Name', value: 'shortDescription' } },
          { kind: 'Field', name: { kind: 'Name', value: 'shortDescriptionFormat' } },
          { kind: 'Field', name: { kind: 'Name', value: 'description' } },
          { kind: 'Field', name: { kind: 'Name', value: 'descriptionFormat' } },
          { kind: 'Field', name: { kind: 'Name', value: 'productType' } },
          { kind: 'Field', name: { kind: 'Name', value: 'language' } },
          { kind: 'Field', name: { kind: 'Name', value: 'primaryLanguage' } },
          { kind: 'FragmentSpread', name: { kind: 'Name', value: 'ContentPreviewMediaFragment' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'contentProvider' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'provider' } },
                { kind: 'Field', name: { kind: 'Name', value: 'providerKey' } },
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'Content_ProviderCommonFragment' },
                },
              ],
            },
          },
          {
            kind: 'Field',
            alias: { kind: 'Name', value: 'yiContentType' },
            name: { kind: 'Name', value: 'contentReferencesFrom' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'types' },
                value: { kind: 'StringValue', value: 'yi-content-type', block: false },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'ContentDetails_Tag_ContentReferenceFragment' },
                },
              ],
            },
          },
          {
            kind: 'Field',
            alias: { kind: 'Name', value: 'yiSeriesEpisodes' },
            name: { kind: 'Name', value: 'contentReferencesFrom' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'types' },
                value: {
                  kind: 'ListValue',
                  values: [{ kind: 'StringValue', value: 'yi-series-episode', block: false }],
                },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'YISeries_EpisodeContentFragment' },
                },
              ],
            },
          },
          {
            kind: 'FragmentSpread',
            name: { kind: 'Name', value: 'Content_ProviderMetadataFragment' },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'Common_MediaFragment' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'Media' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'mediaId' } },
          { kind: 'Field', name: { kind: 'Name', value: 'contentId' } },
          { kind: 'Field', name: { kind: 'Name', value: 'mediaMaestroTitleCode' } },
          { kind: 'Field', name: { kind: 'Name', value: 'policyId' } },
          { kind: 'Field', name: { kind: 'Name', value: 'updatedAt' } },
          { kind: 'Field', name: { kind: 'Name', value: 'duration' } },
          { kind: 'Field', name: { kind: 'Name', value: 'isPublished' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'mediaAssets' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                { kind: 'Field', name: { kind: 'Name', value: 'providerKey' } },
              ],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'Content_ProviderCommonFragment' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'ContentProvider' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [{ kind: 'Field', name: { kind: 'Name', value: 'contentId' } }],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'Content_ProviderMetadataFragment' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'Content' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            alias: { kind: 'Name', value: 'providerMetadata' },
            name: { kind: 'Name', value: 'contentProvider' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'metadata' } },
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'Content_ProviderCommonFragment' },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'YISeries_EpisodeDetailsContentFragment' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'Content' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'title' } },
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          { kind: 'Field', name: { kind: 'Name', value: 'contentType' } },
          { kind: 'Field', name: { kind: 'Name', value: 'contentId' } },
          { kind: 'Field', name: { kind: 'Name', value: 'published' } },
          { kind: 'Field', name: { kind: 'Name', value: 'seasonNumber' } },
          { kind: 'Field', name: { kind: 'Name', value: 'episodeNumber' } },
          {
            kind: 'FragmentSpread',
            name: { kind: 'Name', value: 'Content_ProviderMetadataFragment' },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'ContentPreviewMediaFragment' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'Content' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'contentPolicyPolicyId' } },
          { kind: 'Field', name: { kind: 'Name', value: 'previewMediaId' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'previewMedia' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'FragmentSpread', name: { kind: 'Name', value: 'Common_MediaFragment' } },
              ],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'ContentDetails_Tag_ContentReferenceFragment' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'ContentReference' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          { kind: 'Field', name: { kind: 'Name', value: 'sortKey' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'contentReferenceType' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [{ kind: 'Field', name: { kind: 'Name', value: 'type' } }],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'contentTo' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'language' },
                value: {
                  kind: 'ListValue',
                  values: [
                    { kind: 'StringValue', value: 'en', block: false },
                    { kind: 'StringValue', value: '_primary', block: false },
                  ],
                },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                { kind: 'Field', name: { kind: 'Name', value: 'titleGroupId' } },
                { kind: 'Field', name: { kind: 'Name', value: 'title' } },
                { kind: 'Field', name: { kind: 'Name', value: 'contentId' } },
                { kind: 'Field', name: { kind: 'Name', value: 'contentType' } },
                { kind: 'Field', name: { kind: 'Name', value: 'published' } },
              ],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'YISeries_EpisodeContentFragment' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'ContentReference' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          { kind: 'Field', name: { kind: 'Name', value: 'sortKey' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'contentReferenceType' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [{ kind: 'Field', name: { kind: 'Name', value: 'type' } }],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'contentTo' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'YISeries_EpisodeDetailsContentFragment' },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<YiSeries_ContentFragmentFragment, unknown>
export const YiSeriesEpisode_ContentFragmentFragmentDoc = {
  kind: 'Document',
  definitions: [
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'YISeriesEpisode_ContentFragment' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'Content' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          { kind: 'Field', name: { kind: 'Name', value: 'contentId' } },
          { kind: 'Field', name: { kind: 'Name', value: 'contentType' } },
          { kind: 'Field', name: { kind: 'Name', value: 'published' } },
          { kind: 'Field', name: { kind: 'Name', value: 'publishedAtDate' } },
          { kind: 'Field', name: { kind: 'Name', value: 'createdAt' } },
          { kind: 'Field', name: { kind: 'Name', value: 'updatedAt' } },
          { kind: 'Field', name: { kind: 'Name', value: 'title' } },
          { kind: 'Field', name: { kind: 'Name', value: 'path' } },
          { kind: 'Field', name: { kind: 'Name', value: 'shortDescription' } },
          { kind: 'Field', name: { kind: 'Name', value: 'shortDescriptionFormat' } },
          { kind: 'Field', name: { kind: 'Name', value: 'description' } },
          { kind: 'Field', name: { kind: 'Name', value: 'descriptionFormat' } },
          { kind: 'Field', name: { kind: 'Name', value: 'productType' } },
          { kind: 'Field', name: { kind: 'Name', value: 'language' } },
          { kind: 'Field', name: { kind: 'Name', value: 'primaryLanguage' } },
          { kind: 'Field', name: { kind: 'Name', value: 'seasonNumber' } },
          { kind: 'Field', name: { kind: 'Name', value: 'episodeNumber' } },
          { kind: 'Field', name: { kind: 'Name', value: 'productType' } },
          { kind: 'FragmentSpread', name: { kind: 'Name', value: 'ContentPreviewMediaFragment' } },
          { kind: 'FragmentSpread', name: { kind: 'Name', value: 'ContentFeatureMediaFragment' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'contentProvider' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'provider' } },
                { kind: 'Field', name: { kind: 'Name', value: 'providerKey' } },
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'Content_ProviderCommonFragment' },
                },
              ],
            },
          },
          {
            kind: 'Field',
            alias: { kind: 'Name', value: 'yiContentType' },
            name: { kind: 'Name', value: 'contentReferencesFrom' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'types' },
                value: { kind: 'StringValue', value: 'yi-content-type', block: false },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'ContentDetails_Tag_ContentReferenceFragment' },
                },
              ],
            },
          },
          {
            kind: 'Field',
            alias: { kind: 'Name', value: 'yiSeries' },
            name: { kind: 'Name', value: 'contentReferencesTo' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'types' },
                value: {
                  kind: 'ListValue',
                  values: [{ kind: 'StringValue', value: 'yi-series-episode', block: false }],
                },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'contentReferenceType' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [{ kind: 'Field', name: { kind: 'Name', value: 'type' } }],
                  },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'contentFrom' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'contentId' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'contentType' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'published' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'title' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'language' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'primaryLanguage' } },
                    ],
                  },
                },
              ],
            },
          },
          {
            kind: 'FragmentSpread',
            name: { kind: 'Name', value: 'Content_ProviderMetadataFragment' },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'Common_MediaFragment' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'Media' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'mediaId' } },
          { kind: 'Field', name: { kind: 'Name', value: 'contentId' } },
          { kind: 'Field', name: { kind: 'Name', value: 'mediaMaestroTitleCode' } },
          { kind: 'Field', name: { kind: 'Name', value: 'policyId' } },
          { kind: 'Field', name: { kind: 'Name', value: 'updatedAt' } },
          { kind: 'Field', name: { kind: 'Name', value: 'duration' } },
          { kind: 'Field', name: { kind: 'Name', value: 'isPublished' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'mediaAssets' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                { kind: 'Field', name: { kind: 'Name', value: 'providerKey' } },
              ],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'Content_ProviderCommonFragment' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'ContentProvider' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [{ kind: 'Field', name: { kind: 'Name', value: 'contentId' } }],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'ContentPreviewMediaFragment' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'Content' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'contentPolicyPolicyId' } },
          { kind: 'Field', name: { kind: 'Name', value: 'previewMediaId' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'previewMedia' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'FragmentSpread', name: { kind: 'Name', value: 'Common_MediaFragment' } },
              ],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'ContentFeatureMediaFragment' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'Content' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'contentPolicyPolicyId' } },
          { kind: 'Field', name: { kind: 'Name', value: 'featureMediaId' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'featureMedia' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'FragmentSpread', name: { kind: 'Name', value: 'Common_MediaFragment' } },
              ],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'ContentDetails_Tag_ContentReferenceFragment' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'ContentReference' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          { kind: 'Field', name: { kind: 'Name', value: 'sortKey' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'contentReferenceType' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [{ kind: 'Field', name: { kind: 'Name', value: 'type' } }],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'contentTo' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'language' },
                value: {
                  kind: 'ListValue',
                  values: [
                    { kind: 'StringValue', value: 'en', block: false },
                    { kind: 'StringValue', value: '_primary', block: false },
                  ],
                },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                { kind: 'Field', name: { kind: 'Name', value: 'titleGroupId' } },
                { kind: 'Field', name: { kind: 'Name', value: 'title' } },
                { kind: 'Field', name: { kind: 'Name', value: 'contentId' } },
                { kind: 'Field', name: { kind: 'Name', value: 'contentType' } },
                { kind: 'Field', name: { kind: 'Name', value: 'published' } },
              ],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'Content_ProviderMetadataFragment' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'Content' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            alias: { kind: 'Name', value: 'providerMetadata' },
            name: { kind: 'Name', value: 'contentProvider' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'metadata' } },
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'Content_ProviderCommonFragment' },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<YiSeriesEpisode_ContentFragmentFragment, unknown>
export const YiTag_ContentFragmentFragmentDoc = {
  kind: 'Document',
  definitions: [
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'YITag_ContentFragment' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'Content' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          { kind: 'Field', name: { kind: 'Name', value: 'contentId' } },
          { kind: 'Field', name: { kind: 'Name', value: 'title' } },
          { kind: 'Field', name: { kind: 'Name', value: 'contentType' } },
          { kind: 'Field', name: { kind: 'Name', value: 'published' } },
          { kind: 'Field', name: { kind: 'Name', value: 'publishedAtDate' } },
          { kind: 'Field', name: { kind: 'Name', value: 'description' } },
          { kind: 'Field', name: { kind: 'Name', value: 'descriptionFormat' } },
          { kind: 'Field', name: { kind: 'Name', value: 'language' } },
          { kind: 'Field', name: { kind: 'Name', value: 'primaryLanguage' } },
          { kind: 'Field', name: { kind: 'Name', value: 'path' } },
          { kind: 'Field', name: { kind: 'Name', value: 'seoTitle' } },
          { kind: 'FragmentSpread', name: { kind: 'Name', value: 'ContentFeatureMediaFragment' } },
          {
            kind: 'Field',
            alias: { kind: 'Name', value: 'yiContentType' },
            name: { kind: 'Name', value: 'contentReferencesFrom' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'types' },
                value: { kind: 'StringValue', value: 'yi-content-type', block: false },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'ContentDetails_Tag_ContentReferenceFragment' },
                },
              ],
            },
          },
          {
            kind: 'Field',
            alias: { kind: 'Name', value: 'yiTagGroup' },
            name: { kind: 'Name', value: 'contentReferencesFrom' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'types' },
                value: { kind: 'StringValue', value: 'yi-tag-group', block: false },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                { kind: 'Field', name: { kind: 'Name', value: 'sortKey' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'contentReferenceType' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [{ kind: 'Field', name: { kind: 'Name', value: 'type' } }],
                  },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'contentTo' },
                  arguments: [
                    {
                      kind: 'Argument',
                      name: { kind: 'Name', value: 'language' },
                      value: {
                        kind: 'ListValue',
                        values: [
                          { kind: 'StringValue', value: 'en', block: false },
                          { kind: 'StringValue', value: '_primary', block: false },
                        ],
                      },
                    },
                  ],
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'titleGroupId' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'title' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'contentId' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'contentType' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'published' } },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'Common_MediaFragment' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'Media' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'mediaId' } },
          { kind: 'Field', name: { kind: 'Name', value: 'contentId' } },
          { kind: 'Field', name: { kind: 'Name', value: 'mediaMaestroTitleCode' } },
          { kind: 'Field', name: { kind: 'Name', value: 'policyId' } },
          { kind: 'Field', name: { kind: 'Name', value: 'updatedAt' } },
          { kind: 'Field', name: { kind: 'Name', value: 'duration' } },
          { kind: 'Field', name: { kind: 'Name', value: 'isPublished' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'mediaAssets' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                { kind: 'Field', name: { kind: 'Name', value: 'providerKey' } },
              ],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'ContentFeatureMediaFragment' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'Content' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'contentPolicyPolicyId' } },
          { kind: 'Field', name: { kind: 'Name', value: 'featureMediaId' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'featureMedia' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'FragmentSpread', name: { kind: 'Name', value: 'Common_MediaFragment' } },
              ],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'ContentDetails_Tag_ContentReferenceFragment' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'ContentReference' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          { kind: 'Field', name: { kind: 'Name', value: 'sortKey' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'contentReferenceType' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [{ kind: 'Field', name: { kind: 'Name', value: 'type' } }],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'contentTo' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'language' },
                value: {
                  kind: 'ListValue',
                  values: [
                    { kind: 'StringValue', value: 'en', block: false },
                    { kind: 'StringValue', value: '_primary', block: false },
                  ],
                },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                { kind: 'Field', name: { kind: 'Name', value: 'titleGroupId' } },
                { kind: 'Field', name: { kind: 'Name', value: 'title' } },
                { kind: 'Field', name: { kind: 'Name', value: 'contentId' } },
                { kind: 'Field', name: { kind: 'Name', value: 'contentType' } },
                { kind: 'Field', name: { kind: 'Name', value: 'published' } },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<YiTag_ContentFragmentFragment, unknown>
export const YiTagGroup_ContentFragmentFragmentDoc = {
  kind: 'Document',
  definitions: [
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'YITagGroup_ContentFragment' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'Content' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          { kind: 'Field', name: { kind: 'Name', value: 'contentId' } },
          { kind: 'Field', name: { kind: 'Name', value: 'title' } },
          { kind: 'Field', name: { kind: 'Name', value: 'contentType' } },
          { kind: 'Field', name: { kind: 'Name', value: 'published' } },
          { kind: 'Field', name: { kind: 'Name', value: 'publishedAtDate' } },
          { kind: 'Field', name: { kind: 'Name', value: 'path' } },
          { kind: 'Field', name: { kind: 'Name', value: 'language' } },
          {
            kind: 'Field',
            alias: { kind: 'Name', value: 'yiContentType' },
            name: { kind: 'Name', value: 'contentReferencesFrom' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'types' },
                value: { kind: 'StringValue', value: 'yi-content-type', block: false },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'ContentDetails_Tag_ContentReferenceFragment' },
                },
              ],
            },
          },
          {
            kind: 'Field',
            alias: { kind: 'Name', value: 'yiTagsRelatedToGroup' },
            name: { kind: 'Name', value: 'contentReferencesTo' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'types' },
                value: { kind: 'StringValue', value: 'yi-tag-group', block: false },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                { kind: 'Field', name: { kind: 'Name', value: 'sortKey' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'contentReferenceType' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [{ kind: 'Field', name: { kind: 'Name', value: 'type' } }],
                  },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'contentFrom' },
                  arguments: [
                    {
                      kind: 'Argument',
                      name: { kind: 'Name', value: 'language' },
                      value: {
                        kind: 'ListValue',
                        values: [
                          { kind: 'StringValue', value: 'en', block: false },
                          { kind: 'StringValue', value: '_primary', block: false },
                        ],
                      },
                    },
                  ],
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'titleGroupId' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'title' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'contentId' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'contentType' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'published' } },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'ContentDetails_Tag_ContentReferenceFragment' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'ContentReference' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          { kind: 'Field', name: { kind: 'Name', value: 'sortKey' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'contentReferenceType' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [{ kind: 'Field', name: { kind: 'Name', value: 'type' } }],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'contentTo' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'language' },
                value: {
                  kind: 'ListValue',
                  values: [
                    { kind: 'StringValue', value: 'en', block: false },
                    { kind: 'StringValue', value: '_primary', block: false },
                  ],
                },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                { kind: 'Field', name: { kind: 'Name', value: 'titleGroupId' } },
                { kind: 'Field', name: { kind: 'Name', value: 'title' } },
                { kind: 'Field', name: { kind: 'Name', value: 'contentId' } },
                { kind: 'Field', name: { kind: 'Name', value: 'contentType' } },
                { kind: 'Field', name: { kind: 'Name', value: 'published' } },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<YiTagGroup_ContentFragmentFragment, unknown>
export const YiTeacher_ContentFragmentFragmentDoc = {
  kind: 'Document',
  definitions: [
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'YITeacher_ContentFragment' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'Content' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          { kind: 'Field', name: { kind: 'Name', value: 'contentId' } },
          { kind: 'Field', name: { kind: 'Name', value: 'contentType' } },
          { kind: 'Field', name: { kind: 'Name', value: 'published' } },
          { kind: 'Field', name: { kind: 'Name', value: 'publishedAtDate' } },
          { kind: 'Field', name: { kind: 'Name', value: 'shortDescription' } },
          { kind: 'Field', name: { kind: 'Name', value: 'shortDescriptionFormat' } },
          { kind: 'Field', name: { kind: 'Name', value: 'description' } },
          { kind: 'Field', name: { kind: 'Name', value: 'descriptionFormat' } },
          { kind: 'Field', name: { kind: 'Name', value: 'language' } },
          { kind: 'Field', name: { kind: 'Name', value: 'primaryLanguage' } },
          { kind: 'Field', name: { kind: 'Name', value: 'path' } },
          { kind: 'Field', name: { kind: 'Name', value: 'seoTitle' } },
          { kind: 'Field', name: { kind: 'Name', value: 'seoDescription' } },
          { kind: 'Field', name: { kind: 'Name', value: 'title' } },
          { kind: 'FragmentSpread', name: { kind: 'Name', value: 'ContentFeatureMediaFragment' } },
          {
            kind: 'Field',
            alias: { kind: 'Name', value: 'yiContentType' },
            name: { kind: 'Name', value: 'contentReferencesFrom' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'types' },
                value: { kind: 'StringValue', value: 'yi-content-type', block: false },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'ContentDetails_Tag_ContentReferenceFragment' },
                },
              ],
            },
          },
          {
            kind: 'Field',
            alias: { kind: 'Name', value: 'yiTags' },
            name: { kind: 'Name', value: 'contentReferencesFrom' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'types' },
                value: { kind: 'StringValue', value: 'yi-tag', block: false },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'ContentDetails_Tag_ContentReferenceFragment' },
                },
              ],
            },
          },
          {
            kind: 'FragmentSpread',
            name: { kind: 'Name', value: 'Content_ProviderMetadataFragment' },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'Common_MediaFragment' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'Media' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'mediaId' } },
          { kind: 'Field', name: { kind: 'Name', value: 'contentId' } },
          { kind: 'Field', name: { kind: 'Name', value: 'mediaMaestroTitleCode' } },
          { kind: 'Field', name: { kind: 'Name', value: 'policyId' } },
          { kind: 'Field', name: { kind: 'Name', value: 'updatedAt' } },
          { kind: 'Field', name: { kind: 'Name', value: 'duration' } },
          { kind: 'Field', name: { kind: 'Name', value: 'isPublished' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'mediaAssets' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                { kind: 'Field', name: { kind: 'Name', value: 'providerKey' } },
              ],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'Content_ProviderCommonFragment' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'ContentProvider' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [{ kind: 'Field', name: { kind: 'Name', value: 'contentId' } }],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'ContentFeatureMediaFragment' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'Content' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'contentPolicyPolicyId' } },
          { kind: 'Field', name: { kind: 'Name', value: 'featureMediaId' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'featureMedia' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'FragmentSpread', name: { kind: 'Name', value: 'Common_MediaFragment' } },
              ],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'ContentDetails_Tag_ContentReferenceFragment' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'ContentReference' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          { kind: 'Field', name: { kind: 'Name', value: 'sortKey' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'contentReferenceType' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [{ kind: 'Field', name: { kind: 'Name', value: 'type' } }],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'contentTo' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'language' },
                value: {
                  kind: 'ListValue',
                  values: [
                    { kind: 'StringValue', value: 'en', block: false },
                    { kind: 'StringValue', value: '_primary', block: false },
                  ],
                },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                { kind: 'Field', name: { kind: 'Name', value: 'titleGroupId' } },
                { kind: 'Field', name: { kind: 'Name', value: 'title' } },
                { kind: 'Field', name: { kind: 'Name', value: 'contentId' } },
                { kind: 'Field', name: { kind: 'Name', value: 'contentType' } },
                { kind: 'Field', name: { kind: 'Name', value: 'published' } },
              ],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'Content_ProviderMetadataFragment' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'Content' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            alias: { kind: 'Name', value: 'providerMetadata' },
            name: { kind: 'Name', value: 'contentProvider' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'metadata' } },
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'Content_ProviderCommonFragment' },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<YiTeacher_ContentFragmentFragment, unknown>
export const ContentImages_ImageContentRelationshipsFragmentFragmentDoc = {
  kind: 'Document',
  definitions: [
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'ContentImages_ImageContentRelationshipsFragment' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'ImageContentRelationship' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          { kind: 'Field', name: { kind: 'Name', value: 'type' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'image' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                { kind: 'Field', name: { kind: 'Name', value: 'url' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'asset' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'providerSourceRenderUrl' } },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<ContentImages_ImageContentRelationshipsFragmentFragment, unknown>
export const ContentImages_ContentDetailsFragmentFragmentDoc = {
  kind: 'Document',
  definitions: [
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'ContentImages_ContentDetailsFragment' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'Content' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          { kind: 'Field', name: { kind: 'Name', value: 'contentId' } },
          { kind: 'Field', name: { kind: 'Name', value: 'contentType' } },
          { kind: 'Field', name: { kind: 'Name', value: 'language' } },
          { kind: 'Field', name: { kind: 'Name', value: 'primaryLanguage' } },
          {
            kind: 'Field',
            alias: { kind: 'Name', value: 'images' },
            name: { kind: 'Name', value: 'imageContentRelationships' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'ContentImages_ImageContentRelationshipsFragment' },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'ContentImages_ImageContentRelationshipsFragment' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'ImageContentRelationship' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          { kind: 'Field', name: { kind: 'Name', value: 'type' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'image' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                { kind: 'Field', name: { kind: 'Name', value: 'url' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'asset' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'providerSourceRenderUrl' } },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<ContentImages_ContentDetailsFragmentFragment, unknown>
export const ContentList_YiReferenceContentFragmentFragmentDoc = {
  kind: 'Document',
  definitions: [
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'ContentList_YIReferenceContentFragment' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'Content' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'contentId' } },
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          { kind: 'Field', name: { kind: 'Name', value: 'contentType' } },
          { kind: 'Field', name: { kind: 'Name', value: 'title' } },
          { kind: 'Field', name: { kind: 'Name', value: 'language' } },
          { kind: 'Field', name: { kind: 'Name', value: 'published' } },
          {
            kind: 'Field',
            alias: { kind: 'Name', value: 'yiContentType' },
            name: { kind: 'Name', value: 'contentReferencesFrom' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'types' },
                value: { kind: 'StringValue', value: 'yi-content-type', block: false },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'ContentDetails_Tag_ContentReferenceFragment' },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'ContentDetails_Tag_ContentReferenceFragment' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'ContentReference' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          { kind: 'Field', name: { kind: 'Name', value: 'sortKey' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'contentReferenceType' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [{ kind: 'Field', name: { kind: 'Name', value: 'type' } }],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'contentTo' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'language' },
                value: {
                  kind: 'ListValue',
                  values: [
                    { kind: 'StringValue', value: 'en', block: false },
                    { kind: 'StringValue', value: '_primary', block: false },
                  ],
                },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                { kind: 'Field', name: { kind: 'Name', value: 'titleGroupId' } },
                { kind: 'Field', name: { kind: 'Name', value: 'title' } },
                { kind: 'Field', name: { kind: 'Name', value: 'contentId' } },
                { kind: 'Field', name: { kind: 'Name', value: 'contentType' } },
                { kind: 'Field', name: { kind: 'Name', value: 'published' } },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<ContentList_YiReferenceContentFragmentFragment, unknown>
export const Common_ContentFragmentFragmentDoc = {
  kind: 'Document',
  definitions: [
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'Common_ContentFragment' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'Content' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          { kind: 'Field', name: { kind: 'Name', value: 'contentId' } },
          { kind: 'Field', name: { kind: 'Name', value: 'contentType' } },
          { kind: 'Field', name: { kind: 'Name', value: 'published' } },
          { kind: 'Field', name: { kind: 'Name', value: 'publishedAtDate' } },
          { kind: 'Field', name: { kind: 'Name', value: 'createdAt' } },
          { kind: 'Field', name: { kind: 'Name', value: 'updatedAt' } },
          { kind: 'Field', name: { kind: 'Name', value: 'title' } },
          { kind: 'Field', name: { kind: 'Name', value: 'path' } },
          { kind: 'Field', name: { kind: 'Name', value: 'shortDescription' } },
          { kind: 'Field', name: { kind: 'Name', value: 'description' } },
          { kind: 'Field', name: { kind: 'Name', value: 'language' } },
          { kind: 'Field', name: { kind: 'Name', value: 'contentPolicyPolicyId' } },
          {
            kind: 'FragmentSpread',
            name: { kind: 'Name', value: 'Common_ContentProviderFragment' },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'Content_ProviderCommonFragment' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'ContentProvider' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [{ kind: 'Field', name: { kind: 'Name', value: 'contentId' } }],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'Common_ContentProviderFragment' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'Content' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'contentProvider' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'provider' } },
                { kind: 'Field', name: { kind: 'Name', value: 'providerKey' } },
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'Content_ProviderCommonFragment' },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<Common_ContentFragmentFragment, unknown>
export const ChatHistoryCreateDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'mutation',
      name: { kind: 'Name', value: 'ChatHistoryCreate' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'userInfoId' } },
          type: { kind: 'NamedType', name: { kind: 'Name', value: 'ID' } },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'chatSessionId' } },
          type: {
            kind: 'NonNullType',
            type: { kind: 'NamedType', name: { kind: 'Name', value: 'ID' } },
          },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'chatData' } },
          type: {
            kind: 'NonNullType',
            type: { kind: 'NamedType', name: { kind: 'Name', value: 'JSON' } },
          },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'chatType' } },
          type: { kind: 'NamedType', name: { kind: 'Name', value: 'String' } },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'chatHistoryCreate' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'chatHistory' },
                value: {
                  kind: 'ObjectValue',
                  fields: [
                    {
                      kind: 'ObjectField',
                      name: { kind: 'Name', value: 'userInfoUuid' },
                      value: { kind: 'Variable', name: { kind: 'Name', value: 'userInfoId' } },
                    },
                    {
                      kind: 'ObjectField',
                      name: { kind: 'Name', value: 'chatSessionsId' },
                      value: { kind: 'Variable', name: { kind: 'Name', value: 'chatSessionId' } },
                    },
                    {
                      kind: 'ObjectField',
                      name: { kind: 'Name', value: 'data' },
                      value: { kind: 'Variable', name: { kind: 'Name', value: 'chatData' } },
                    },
                    {
                      kind: 'ObjectField',
                      name: { kind: 'Name', value: 'type' },
                      value: { kind: 'Variable', name: { kind: 'Name', value: 'chatType' } },
                    },
                  ],
                },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'chatHistory' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'userInfoUuid' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'chatSessionsId' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'type' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'data' } },
                    ],
                  },
                },
                { kind: 'Field', name: { kind: 'Name', value: 'success' } },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<ChatHistoryCreateMutation, ChatHistoryCreateMutationVariables>
export const ChatHistoryDeleteDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'mutation',
      name: { kind: 'Name', value: 'ChatHistoryDelete' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'chatHistoryId' } },
          type: {
            kind: 'NonNullType',
            type: { kind: 'NamedType', name: { kind: 'Name', value: 'ID' } },
          },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'chatHistoryDelete' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'chatHistory' },
                value: {
                  kind: 'ObjectValue',
                  fields: [
                    {
                      kind: 'ObjectField',
                      name: { kind: 'Name', value: 'id' },
                      value: { kind: 'Variable', name: { kind: 'Name', value: 'chatHistoryId' } },
                    },
                  ],
                },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [{ kind: 'Field', name: { kind: 'Name', value: 'success' } }],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<ChatHistoryDeleteMutation, ChatHistoryDeleteMutationVariables>
export const ChatHistoryListDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'ChatHistoryList' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'userInfoId' } },
          type: {
            kind: 'NonNullType',
            type: { kind: 'NamedType', name: { kind: 'Name', value: 'ID' } },
          },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'chatSessionId' } },
          type: {
            kind: 'NonNullType',
            type: { kind: 'NamedType', name: { kind: 'Name', value: 'ID' } },
          },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'chatHistoryList' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'limit' },
                value: { kind: 'IntValue', value: '10' },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'where' },
                value: {
                  kind: 'ObjectValue',
                  fields: [
                    {
                      kind: 'ObjectField',
                      name: { kind: 'Name', value: 'userInfoUuid' },
                      value: {
                        kind: 'ObjectValue',
                        fields: [
                          {
                            kind: 'ObjectField',
                            name: { kind: 'Name', value: 'eq' },
                            value: {
                              kind: 'Variable',
                              name: { kind: 'Name', value: 'userInfoId' },
                            },
                          },
                        ],
                      },
                    },
                    {
                      kind: 'ObjectField',
                      name: { kind: 'Name', value: 'chatSessionsId' },
                      value: {
                        kind: 'ObjectValue',
                        fields: [
                          {
                            kind: 'ObjectField',
                            name: { kind: 'Name', value: 'eq' },
                            value: {
                              kind: 'Variable',
                              name: { kind: 'Name', value: 'chatSessionId' },
                            },
                          },
                        ],
                      },
                    },
                  ],
                },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'chatHistories' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'userInfoUuid' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'chatSessionsId' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'type' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'data' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'responseData' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'createdAt' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'updatedAt' } },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<ChatHistoryListQuery, ChatHistoryListQueryVariables>
export const ChatSessionCreateDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'mutation',
      name: { kind: 'Name', value: 'ChatSessionCreate' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'userInfoId' } },
          type: { kind: 'NamedType', name: { kind: 'Name', value: 'ID' } },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'title' } },
          type: { kind: 'NamedType', name: { kind: 'Name', value: 'String' } },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'description' } },
          type: { kind: 'NamedType', name: { kind: 'Name', value: 'String' } },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'chatSessionCreate' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'chatSession' },
                value: {
                  kind: 'ObjectValue',
                  fields: [
                    {
                      kind: 'ObjectField',
                      name: { kind: 'Name', value: 'userInfoUuid' },
                      value: { kind: 'Variable', name: { kind: 'Name', value: 'userInfoId' } },
                    },
                    {
                      kind: 'ObjectField',
                      name: { kind: 'Name', value: 'title' },
                      value: { kind: 'Variable', name: { kind: 'Name', value: 'title' } },
                    },
                    {
                      kind: 'ObjectField',
                      name: { kind: 'Name', value: 'description' },
                      value: { kind: 'Variable', name: { kind: 'Name', value: 'description' } },
                    },
                  ],
                },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'success' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'chatSession' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'title' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'description' } },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<ChatSessionCreateMutation, ChatSessionCreateMutationVariables>
export const ChatSessionDeleteDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'mutation',
      name: { kind: 'Name', value: 'ChatSessionDelete' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'chatSessionId' } },
          type: {
            kind: 'NonNullType',
            type: { kind: 'NamedType', name: { kind: 'Name', value: 'ID' } },
          },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'chatSessionDelete' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'chatSession' },
                value: {
                  kind: 'ObjectValue',
                  fields: [
                    {
                      kind: 'ObjectField',
                      name: { kind: 'Name', value: 'id' },
                      value: { kind: 'Variable', name: { kind: 'Name', value: 'chatSessionId' } },
                    },
                  ],
                },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [{ kind: 'Field', name: { kind: 'Name', value: 'success' } }],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<ChatSessionDeleteMutation, ChatSessionDeleteMutationVariables>
export const ChatSessionListDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'ChatSessionList' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'userInfoId' } },
          type: {
            kind: 'NonNullType',
            type: { kind: 'NamedType', name: { kind: 'Name', value: 'ID' } },
          },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'chatSessionList' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'where' },
                value: {
                  kind: 'ObjectValue',
                  fields: [
                    {
                      kind: 'ObjectField',
                      name: { kind: 'Name', value: 'userInfoUuid' },
                      value: {
                        kind: 'ObjectValue',
                        fields: [
                          {
                            kind: 'ObjectField',
                            name: { kind: 'Name', value: 'eq' },
                            value: {
                              kind: 'Variable',
                              name: { kind: 'Name', value: 'userInfoId' },
                            },
                          },
                        ],
                      },
                    },
                  ],
                },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'chatSessions' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'userInfoUuid' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'title' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'description' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'createdAt' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'updatedAt' } },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<ChatSessionListQuery, ChatSessionListQueryVariables>
export const DocumentContentListDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'DocumentContentList' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'contentId' } },
          type: { kind: 'NamedType', name: { kind: 'Name', value: 'Int' } },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'contentList' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'where' },
                value: {
                  kind: 'ObjectValue',
                  fields: [
                    {
                      kind: 'ObjectField',
                      name: { kind: 'Name', value: 'contentId' },
                      value: {
                        kind: 'ObjectValue',
                        fields: [
                          {
                            kind: 'ObjectField',
                            name: { kind: 'Name', value: 'eq' },
                            value: { kind: 'Variable', name: { kind: 'Name', value: 'contentId' } },
                          },
                        ],
                      },
                    },
                  ],
                },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'language' },
                value: {
                  kind: 'ListValue',
                  values: [{ kind: 'StringValue', value: 'en', block: false }],
                },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'count' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'content' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'contentId' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'contentType' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'language' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'path' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'title' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'writer' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'description' } },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<DocumentContentListQuery, DocumentContentListQueryVariables>
export const DocumentEmbeddingsListDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'DocumentEmbeddingsList' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'documentId' } },
          type: { kind: 'NamedType', name: { kind: 'Name', value: 'ID' } },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'documentNumber' } },
          type: { kind: 'NamedType', name: { kind: 'Name', value: 'ID' } },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'documentEmbeddingsList' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'where' },
                value: {
                  kind: 'ObjectValue',
                  fields: [
                    {
                      kind: 'ObjectField',
                      name: { kind: 'Name', value: 'documentsId' },
                      value: {
                        kind: 'ObjectValue',
                        fields: [
                          {
                            kind: 'ObjectField',
                            name: { kind: 'Name', value: 'eq' },
                            value: {
                              kind: 'Variable',
                              name: { kind: 'Name', value: 'documentId' },
                            },
                          },
                        ],
                      },
                    },
                    {
                      kind: 'ObjectField',
                      name: { kind: 'Name', value: 'documentNumber' },
                      value: {
                        kind: 'ObjectValue',
                        fields: [
                          {
                            kind: 'ObjectField',
                            name: { kind: 'Name', value: 'eq' },
                            value: {
                              kind: 'Variable',
                              name: { kind: 'Name', value: 'documentNumber' },
                            },
                          },
                        ],
                      },
                    },
                  ],
                },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'count' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'documentEmbeddings' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'language' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'documentsId' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'documentNumber' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'documentText' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'embedding' } },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'document' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'content' },
                              selectionSet: {
                                kind: 'SelectionSet',
                                selections: [
                                  { kind: 'Field', name: { kind: 'Name', value: 'title' } },
                                  { kind: 'Field', name: { kind: 'Name', value: 'writer' } },
                                  { kind: 'Field', name: { kind: 'Name', value: 'path' } },
                                ],
                              },
                            },
                          ],
                        },
                      },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<DocumentEmbeddingsListQuery, DocumentEmbeddingsListQueryVariables>
export const GetContentImagesDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'GetContentImages' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'contentId' } },
          type: {
            kind: 'NonNullType',
            type: { kind: 'NamedType', name: { kind: 'Name', value: 'Int' } },
          },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'contentType' } },
          type: {
            kind: 'NonNullType',
            type: { kind: 'NamedType', name: { kind: 'Name', value: 'String' } },
          },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'language' } },
          type: {
            kind: 'NonNullType',
            type: {
              kind: 'ListType',
              type: {
                kind: 'NonNullType',
                type: { kind: 'NamedType', name: { kind: 'Name', value: 'String' } },
              },
            },
          },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'contentList' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'where' },
                value: {
                  kind: 'ObjectValue',
                  fields: [
                    {
                      kind: 'ObjectField',
                      name: { kind: 'Name', value: 'contentId' },
                      value: {
                        kind: 'ObjectValue',
                        fields: [
                          {
                            kind: 'ObjectField',
                            name: { kind: 'Name', value: 'eq' },
                            value: { kind: 'Variable', name: { kind: 'Name', value: 'contentId' } },
                          },
                        ],
                      },
                    },
                    {
                      kind: 'ObjectField',
                      name: { kind: 'Name', value: 'contentType' },
                      value: {
                        kind: 'ObjectValue',
                        fields: [
                          {
                            kind: 'ObjectField',
                            name: { kind: 'Name', value: 'eq' },
                            value: {
                              kind: 'Variable',
                              name: { kind: 'Name', value: 'contentType' },
                            },
                          },
                        ],
                      },
                    },
                  ],
                },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'language' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'language' } },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'limit' },
                value: { kind: 'IntValue', value: '1' },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'content' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'contentId' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'contentType' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'language' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'primaryLanguage' } },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'imageContentRelationships' },
                        arguments: [
                          {
                            kind: 'Argument',
                            name: { kind: 'Name', value: 'language' },
                            value: { kind: 'Variable', name: { kind: 'Name', value: 'language' } },
                          },
                        ],
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'type' } },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'image' },
                              selectionSet: {
                                kind: 'SelectionSet',
                                selections: [
                                  { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                                  { kind: 'Field', name: { kind: 'Name', value: 'url' } },
                                  {
                                    kind: 'Field',
                                    name: { kind: 'Name', value: 'originalFileName' },
                                  },
                                ],
                              },
                            },
                          ],
                        },
                      },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<GetContentImagesQuery, GetContentImagesQueryVariables>
export const GetMediaByIdDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'GetMediaById' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'mediaId' } },
          type: {
            kind: 'NonNullType',
            type: { kind: 'NamedType', name: { kind: 'Name', value: 'ID' } },
          },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'mediaList' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'where' },
                value: {
                  kind: 'ObjectValue',
                  fields: [
                    {
                      kind: 'ObjectField',
                      name: { kind: 'Name', value: 'mediaId' },
                      value: {
                        kind: 'ObjectValue',
                        fields: [
                          {
                            kind: 'ObjectField',
                            name: { kind: 'Name', value: 'eq' },
                            value: { kind: 'Variable', name: { kind: 'Name', value: 'mediaId' } },
                          },
                        ],
                      },
                    },
                  ],
                },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'media' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'mediaId' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'contentId' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'policyId' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'mediaMaestroTitleCode' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'updatedAt' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'duration' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'isPublished' } },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'mediaAssets' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'providerKey' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'originalFileName' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'updatedAt' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'language' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'mediaReferenceType' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'duration' } },
                          ],
                        },
                      },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<GetMediaByIdQuery, GetMediaByIdQueryVariables>
export const GetMediaSuggestionsDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'GetMediaSuggestions' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'contentId' } },
          type: {
            kind: 'NonNullType',
            type: { kind: 'NamedType', name: { kind: 'Name', value: 'String' } },
          },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'limit' } },
          type: {
            kind: 'NonNullType',
            type: { kind: 'NamedType', name: { kind: 'Name', value: 'Int' } },
          },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'mediaList' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'where' },
                value: {
                  kind: 'ObjectValue',
                  fields: [
                    {
                      kind: 'ObjectField',
                      name: { kind: 'Name', value: 'contentId' },
                      value: {
                        kind: 'ObjectValue',
                        fields: [
                          {
                            kind: 'ObjectField',
                            name: { kind: 'Name', value: 'ilike' },
                            value: { kind: 'Variable', name: { kind: 'Name', value: 'contentId' } },
                          },
                        ],
                      },
                    },
                  ],
                },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'limit' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'limit' } },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'order' },
                value: {
                  kind: 'ListValue',
                  values: [
                    {
                      kind: 'ListValue',
                      values: [
                        { kind: 'StringValue', value: 'createdAt', block: false },
                        { kind: 'StringValue', value: 'DESC', block: false },
                      ],
                    },
                  ],
                },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'media' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'mediaId' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'contentId' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'createdAt' } },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<GetMediaSuggestionsQuery, GetMediaSuggestionsQueryVariables>
export const SearchContentDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'SearchContent' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'contentType' } },
          type: {
            kind: 'NonNullType',
            type: { kind: 'NamedType', name: { kind: 'Name', value: 'String' } },
          },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'bundle' } },
          type: { kind: 'NamedType', name: { kind: 'Name', value: 'String' } },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'title' } },
          type: { kind: 'NamedType', name: { kind: 'Name', value: 'String' } },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'filterType' } },
          type: { kind: 'NamedType', name: { kind: 'Name', value: 'String' } },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'limit' } },
          type: { kind: 'NamedType', name: { kind: 'Name', value: 'Int' } },
          defaultValue: { kind: 'IntValue', value: '50' },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'language' } },
          type: {
            kind: 'ListType',
            type: { kind: 'NamedType', name: { kind: 'Name', value: 'String' } },
          },
          defaultValue: {
            kind: 'ListValue',
            values: [
              { kind: 'StringValue', value: 'en', block: false },
              { kind: 'StringValue', value: '_primary', block: false },
            ],
          },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'contentList' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'where' },
                value: {
                  kind: 'ObjectValue',
                  fields: [
                    {
                      kind: 'ObjectField',
                      name: { kind: 'Name', value: 'contentType' },
                      value: {
                        kind: 'ObjectValue',
                        fields: [
                          {
                            kind: 'ObjectField',
                            name: { kind: 'Name', value: 'eq' },
                            value: {
                              kind: 'Variable',
                              name: { kind: 'Name', value: 'contentType' },
                            },
                          },
                        ],
                      },
                    },
                    {
                      kind: 'ObjectField',
                      name: { kind: 'Name', value: 'bundle' },
                      value: {
                        kind: 'ObjectValue',
                        fields: [
                          {
                            kind: 'ObjectField',
                            name: { kind: 'Name', value: 'eq' },
                            value: { kind: 'Variable', name: { kind: 'Name', value: 'bundle' } },
                          },
                        ],
                      },
                    },
                    {
                      kind: 'ObjectField',
                      name: { kind: 'Name', value: 'title' },
                      value: {
                        kind: 'ObjectValue',
                        fields: [
                          {
                            kind: 'ObjectField',
                            name: { kind: 'Name', value: 'ilike' },
                            value: { kind: 'Variable', name: { kind: 'Name', value: 'title' } },
                          },
                        ],
                      },
                    },
                    {
                      kind: 'ObjectField',
                      name: { kind: 'Name', value: 'filterType' },
                      value: {
                        kind: 'ObjectValue',
                        fields: [
                          {
                            kind: 'ObjectField',
                            name: { kind: 'Name', value: 'eq' },
                            value: {
                              kind: 'Variable',
                              name: { kind: 'Name', value: 'filterType' },
                            },
                          },
                        ],
                      },
                    },
                  ],
                },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'language' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'language' } },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'limit' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'limit' } },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'order' },
                value: {
                  kind: 'ListValue',
                  values: [
                    {
                      kind: 'ListValue',
                      values: [
                        { kind: 'StringValue', value: 'title', block: false },
                        { kind: 'StringValue', value: 'ASC', block: false },
                      ],
                    },
                  ],
                },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'content' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'contentId' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'contentType' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'title' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'published' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'titleGroupId' } },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<SearchContentQuery, SearchContentQueryVariables>
export const SearchVideoContentDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'SearchVideoContent' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'title' } },
          type: { kind: 'NamedType', name: { kind: 'Name', value: 'String' } },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'limit' } },
          type: { kind: 'NamedType', name: { kind: 'Name', value: 'Int' } },
          defaultValue: { kind: 'IntValue', value: '50' },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'language' } },
          type: {
            kind: 'ListType',
            type: { kind: 'NamedType', name: { kind: 'Name', value: 'String' } },
          },
          defaultValue: {
            kind: 'ListValue',
            values: [
              { kind: 'StringValue', value: 'en', block: false },
              { kind: 'StringValue', value: '_primary', block: false },
            ],
          },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'contentList' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'where' },
                value: {
                  kind: 'ObjectValue',
                  fields: [
                    {
                      kind: 'ObjectField',
                      name: { kind: 'Name', value: 'contentType' },
                      value: {
                        kind: 'ObjectValue',
                        fields: [
                          {
                            kind: 'ObjectField',
                            name: { kind: 'Name', value: 'eq' },
                            value: { kind: 'StringValue', value: 'video', block: false },
                          },
                        ],
                      },
                    },
                    {
                      kind: 'ObjectField',
                      name: { kind: 'Name', value: 'title' },
                      value: {
                        kind: 'ObjectValue',
                        fields: [
                          {
                            kind: 'ObjectField',
                            name: { kind: 'Name', value: 'ilike' },
                            value: { kind: 'Variable', name: { kind: 'Name', value: 'title' } },
                          },
                        ],
                      },
                    },
                  ],
                },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'language' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'language' } },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'limit' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'limit' } },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'order' },
                value: {
                  kind: 'ListValue',
                  values: [
                    {
                      kind: 'ListValue',
                      values: [
                        { kind: 'StringValue', value: 'title', block: false },
                        { kind: 'StringValue', value: 'ASC', block: false },
                      ],
                    },
                  ],
                },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'content' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'contentId' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'contentType' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'title' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'published' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'titleGroupId' } },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'imageContentRelationships' },
                        arguments: [
                          {
                            kind: 'Argument',
                            name: { kind: 'Name', value: 'language' },
                            value: { kind: 'Variable', name: { kind: 'Name', value: 'language' } },
                          },
                          {
                            kind: 'Argument',
                            name: { kind: 'Name', value: 'types' },
                            value: {
                              kind: 'ListValue',
                              values: [
                                { kind: 'StringValue', value: 'd6-keyart-no-text', block: false },
                              ],
                            },
                          },
                        ],
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'type' } },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'image' },
                              selectionSet: {
                                kind: 'SelectionSet',
                                selections: [
                                  { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                                  { kind: 'Field', name: { kind: 'Name', value: 'url' } },
                                ],
                              },
                            },
                          ],
                        },
                      },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<SearchVideoContentQuery, SearchVideoContentQueryVariables>
export const CreateContentReferenceDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'mutation',
      name: { kind: 'Name', value: 'CreateContentReference' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'contentReference' } },
          type: {
            kind: 'NonNullType',
            type: {
              kind: 'NamedType',
              name: { kind: 'Name', value: 'ContentReferenceCreateInput' },
            },
          },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'contentReferenceCreate' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'contentReference' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'contentReference' } },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'contentReference' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'fromContentContentId' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'fromContentContentType' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'toContentContentId' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'toContentContentType' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'contentReferenceTypesId' } },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  CreateContentReferenceMutation,
  CreateContentReferenceMutationVariables
>
export const CreateContentReferencesDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'mutation',
      name: { kind: 'Name', value: 'CreateContentReferences' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'contentReferences' } },
          type: {
            kind: 'NonNullType',
            type: {
              kind: 'ListType',
              type: {
                kind: 'NonNullType',
                type: {
                  kind: 'NamedType',
                  name: { kind: 'Name', value: 'ContentReferenceCreateInput' },
                },
              },
            },
          },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'deleteOmittedReferences' } },
          type: { kind: 'NamedType', name: { kind: 'Name', value: 'Boolean' } },
          defaultValue: { kind: 'BooleanValue', value: false },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'contentReferenceCreateMany' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'contentReferences' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'contentReferences' } },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'deleteOmittedReferences' },
                value: {
                  kind: 'Variable',
                  name: { kind: 'Name', value: 'deleteOmittedReferences' },
                },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'contentReferences' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'fromContentContentId' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'fromContentContentType' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'toContentContentId' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'toContentContentType' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'contentReferenceTypesId' } },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  CreateContentReferencesMutation,
  CreateContentReferencesMutationVariables
>
export const DeleteContentReferenceDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'mutation',
      name: { kind: 'Name', value: 'DeleteContentReference' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'contentReference' } },
          type: {
            kind: 'NonNullType',
            type: {
              kind: 'NamedType',
              name: { kind: 'Name', value: 'ContentReferenceDeleteInput' },
            },
          },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'contentReferenceDelete' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'contentReference' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'contentReference' } },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'contentReference' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'fromContentContentId' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'fromContentContentType' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'toContentContentId' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'toContentContentType' } },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  DeleteContentReferenceMutation,
  DeleteContentReferenceMutationVariables
>
export const ContentListDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'ContentList' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'offset' } },
          type: { kind: 'NamedType', name: { kind: 'Name', value: 'Int' } },
          defaultValue: { kind: 'IntValue', value: '0' },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'limit' } },
          type: { kind: 'NamedType', name: { kind: 'Name', value: 'Int' } },
          defaultValue: { kind: 'IntValue', value: '25' },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'order' } },
          type: {
            kind: 'ListType',
            type: {
              kind: 'ListType',
              type: { kind: 'NamedType', name: { kind: 'Name', value: 'String' } },
            },
          },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'where' } },
          type: { kind: 'NamedType', name: { kind: 'Name', value: 'ContentWhereInput' } },
          defaultValue: { kind: 'ObjectValue', fields: [] },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'language' } },
          type: {
            kind: 'ListType',
            type: { kind: 'NamedType', name: { kind: 'Name', value: 'String' } },
          },
          defaultValue: {
            kind: 'ListValue',
            values: [
              { kind: 'StringValue', value: 'en', block: false },
              { kind: 'StringValue', value: '_primary', block: false },
            ],
          },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'contentList' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'offset' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'offset' } },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'limit' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'limit' } },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'order' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'order' } },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'where' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'where' } },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'language' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'language' } },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'count' } },
                { kind: 'Field', name: { kind: 'Name', value: 'limit' } },
                { kind: 'Field', name: { kind: 'Name', value: 'offset' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'content' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'titleGroupId' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'contentId' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'contentType' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'language' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'title' } },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<ContentListQuery, ContentListQueryVariables>
export const GetCourseContentDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'GetCourseContent' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'id' } },
          type: {
            kind: 'NonNullType',
            type: { kind: 'NamedType', name: { kind: 'Name', value: 'ID' } },
          },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'contentList' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'where' },
                value: {
                  kind: 'ObjectValue',
                  fields: [
                    {
                      kind: 'ObjectField',
                      name: { kind: 'Name', value: 'id' },
                      value: {
                        kind: 'ObjectValue',
                        fields: [
                          {
                            kind: 'ObjectField',
                            name: { kind: 'Name', value: 'eq' },
                            value: { kind: 'Variable', name: { kind: 'Name', value: 'id' } },
                          },
                        ],
                      },
                    },
                    {
                      kind: 'ObjectField',
                      name: { kind: 'Name', value: 'contentType' },
                      value: {
                        kind: 'ObjectValue',
                        fields: [
                          {
                            kind: 'ObjectField',
                            name: { kind: 'Name', value: 'eq' },
                            value: { kind: 'StringValue', value: 'course', block: false },
                          },
                        ],
                      },
                    },
                  ],
                },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'content' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'contentId' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'contentType' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'title' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'description' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'descriptionFormat' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'shortDescription' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'shortDescriptionFormat' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'thirdPartyDescription' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'path' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'language' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'primaryLanguage' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'published' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'publishedAtDate' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'productionStatus' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'contentSearchNoIndex' } },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'excludeFromRecommendations' },
                      },
                      { kind: 'Field', name: { kind: 'Name', value: 'createdAt' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'updatedAt' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'productType' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'displayType' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'seasonNumber' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'episodeNumber' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'director' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'producer' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'writer' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'studio' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'copyright' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'instructor' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'cast' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'previewMediaId' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'featureMediaId' } },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'contentReferencesTo' },
                        arguments: [
                          {
                            kind: 'Argument',
                            name: { kind: 'Name', value: 'types' },
                            value: {
                              kind: 'ListValue',
                              values: [
                                { kind: 'StringValue', value: 'course-module', block: false },
                              ],
                            },
                          },
                        ],
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            { kind: 'Field', name: { kind: 'Name', value: 'sortKey' } },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'contentFrom' },
                              selectionSet: {
                                kind: 'SelectionSet',
                                selections: [
                                  { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                                  { kind: 'Field', name: { kind: 'Name', value: 'contentId' } },
                                  { kind: 'Field', name: { kind: 'Name', value: 'contentType' } },
                                  { kind: 'Field', name: { kind: 'Name', value: 'title' } },
                                  { kind: 'Field', name: { kind: 'Name', value: 'published' } },
                                  {
                                    kind: 'Field',
                                    name: { kind: 'Name', value: 'contentReferencesTo' },
                                    arguments: [
                                      {
                                        kind: 'Argument',
                                        name: { kind: 'Name', value: 'types' },
                                        value: {
                                          kind: 'ListValue',
                                          values: [
                                            {
                                              kind: 'StringValue',
                                              value: 'course-module-practice',
                                              block: false,
                                            },
                                            {
                                              kind: 'StringValue',
                                              value: 'course-module-other',
                                              block: false,
                                            },
                                          ],
                                        },
                                      },
                                    ],
                                    selectionSet: {
                                      kind: 'SelectionSet',
                                      selections: [
                                        {
                                          kind: 'Field',
                                          name: { kind: 'Name', value: 'contentReferenceType' },
                                          selectionSet: {
                                            kind: 'SelectionSet',
                                            selections: [
                                              {
                                                kind: 'Field',
                                                name: { kind: 'Name', value: 'type' },
                                              },
                                            ],
                                          },
                                        },
                                        { kind: 'Field', name: { kind: 'Name', value: 'sortKey' } },
                                      ],
                                    },
                                  },
                                ],
                              },
                            },
                          ],
                        },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'contentReferencesFrom' },
                        arguments: [
                          {
                            kind: 'Argument',
                            name: { kind: 'Name', value: 'types' },
                            value: {
                              kind: 'ListValue',
                              values: [
                                { kind: 'StringValue', value: 'admin_category', block: false },
                                { kind: 'StringValue', value: 'category', block: false },
                                { kind: 'StringValue', value: 'rainbow-category', block: false },
                                { kind: 'StringValue', value: 'centers', block: false },
                                { kind: 'StringValue', value: 'marketing-centers', block: false },
                                { kind: 'StringValue', value: 'content_origin', block: false },
                                { kind: 'StringValue', value: 'interview-guest', block: false },
                                { kind: 'StringValue', value: 'interview-host', block: false },
                                { kind: 'StringValue', value: 'similar-videos', block: false },
                                { kind: 'StringValue', value: 'third-party-genre', block: false },
                              ],
                            },
                          },
                        ],
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'contentReferenceType' },
                              selectionSet: {
                                kind: 'SelectionSet',
                                selections: [
                                  { kind: 'Field', name: { kind: 'Name', value: 'type' } },
                                ],
                              },
                            },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'contentTo' },
                              arguments: [
                                {
                                  kind: 'Argument',
                                  name: { kind: 'Name', value: 'language' },
                                  value: {
                                    kind: 'ListValue',
                                    values: [
                                      { kind: 'StringValue', value: 'en', block: false },
                                      { kind: 'StringValue', value: '_primary', block: false },
                                    ],
                                  },
                                },
                              ],
                              selectionSet: {
                                kind: 'SelectionSet',
                                selections: [
                                  { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                                  { kind: 'Field', name: { kind: 'Name', value: 'contentId' } },
                                  { kind: 'Field', name: { kind: 'Name', value: 'contentType' } },
                                  { kind: 'Field', name: { kind: 'Name', value: 'title' } },
                                  { kind: 'Field', name: { kind: 'Name', value: 'published' } },
                                  { kind: 'Field', name: { kind: 'Name', value: 'titleGroupId' } },
                                ],
                              },
                            },
                          ],
                        },
                      },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<GetCourseContentQuery, GetCourseContentQueryVariables>
export const GetCourseModuleContentDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'GetCourseModuleContent' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'id' } },
          type: {
            kind: 'NonNullType',
            type: { kind: 'NamedType', name: { kind: 'Name', value: 'ID' } },
          },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'contentList' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'where' },
                value: {
                  kind: 'ObjectValue',
                  fields: [
                    {
                      kind: 'ObjectField',
                      name: { kind: 'Name', value: 'id' },
                      value: {
                        kind: 'ObjectValue',
                        fields: [
                          {
                            kind: 'ObjectField',
                            name: { kind: 'Name', value: 'eq' },
                            value: { kind: 'Variable', name: { kind: 'Name', value: 'id' } },
                          },
                        ],
                      },
                    },
                  ],
                },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'content' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'contentId' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'contentType' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'title' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'description' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'descriptionFormat' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'shortDescription' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'shortDescriptionFormat' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'thirdPartyDescription' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'path' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'language' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'primaryLanguage' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'published' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'publishedAtDate' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'productionStatus' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'contentSearchNoIndex' } },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'excludeFromRecommendations' },
                      },
                      { kind: 'Field', name: { kind: 'Name', value: 'createdAt' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'updatedAt' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'productType' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'displayType' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'seasonNumber' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'episodeNumber' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'director' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'producer' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'writer' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'studio' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'copyright' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'instructor' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'cast' } },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<GetCourseModuleContentQuery, GetCourseModuleContentQueryVariables>
export const GetCourseModuleContentReferencesDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'GetCourseModuleContentReferences' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'id' } },
          type: {
            kind: 'NonNullType',
            type: { kind: 'NamedType', name: { kind: 'Name', value: 'ID' } },
          },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'language' } },
          type: {
            kind: 'NonNullType',
            type: {
              kind: 'ListType',
              type: { kind: 'NamedType', name: { kind: 'Name', value: 'String' } },
            },
          },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'contentList' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'where' },
                value: {
                  kind: 'ObjectValue',
                  fields: [
                    {
                      kind: 'ObjectField',
                      name: { kind: 'Name', value: 'id' },
                      value: {
                        kind: 'ObjectValue',
                        fields: [
                          {
                            kind: 'ObjectField',
                            name: { kind: 'Name', value: 'eq' },
                            value: { kind: 'Variable', name: { kind: 'Name', value: 'id' } },
                          },
                        ],
                      },
                    },
                  ],
                },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'content' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'contentReferencesTo' },
                        arguments: [
                          {
                            kind: 'Argument',
                            name: { kind: 'Name', value: 'types' },
                            value: {
                              kind: 'ListValue',
                              values: [
                                {
                                  kind: 'StringValue',
                                  value: 'course-module-practice',
                                  block: false,
                                },
                                { kind: 'StringValue', value: 'course-module-other', block: false },
                              ],
                            },
                          },
                        ],
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'contentReferenceType' },
                              selectionSet: {
                                kind: 'SelectionSet',
                                selections: [
                                  { kind: 'Field', name: { kind: 'Name', value: 'type' } },
                                ],
                              },
                            },
                            { kind: 'Field', name: { kind: 'Name', value: 'sortKey' } },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'contentFrom' },
                              arguments: [
                                {
                                  kind: 'Argument',
                                  name: { kind: 'Name', value: 'language' },
                                  value: {
                                    kind: 'Variable',
                                    name: { kind: 'Name', value: 'language' },
                                  },
                                },
                              ],
                              selectionSet: {
                                kind: 'SelectionSet',
                                selections: [
                                  { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                                  { kind: 'Field', name: { kind: 'Name', value: 'contentId' } },
                                  { kind: 'Field', name: { kind: 'Name', value: 'contentType' } },
                                  { kind: 'Field', name: { kind: 'Name', value: 'title' } },
                                  { kind: 'Field', name: { kind: 'Name', value: 'published' } },
                                  {
                                    kind: 'Field',
                                    name: { kind: 'Name', value: 'imageContentRelationships' },
                                    arguments: [
                                      {
                                        kind: 'Argument',
                                        name: { kind: 'Name', value: 'language' },
                                        value: {
                                          kind: 'Variable',
                                          name: { kind: 'Name', value: 'language' },
                                        },
                                      },
                                      {
                                        kind: 'Argument',
                                        name: { kind: 'Name', value: 'types' },
                                        value: {
                                          kind: 'ListValue',
                                          values: [
                                            {
                                              kind: 'StringValue',
                                              value: 'd6-keyart-with-text',
                                              block: false,
                                            },
                                            {
                                              kind: 'StringValue',
                                              value: 'd6-keyart-no-text',
                                              block: false,
                                            },
                                          ],
                                        },
                                      },
                                    ],
                                    selectionSet: {
                                      kind: 'SelectionSet',
                                      selections: [
                                        { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                                        { kind: 'Field', name: { kind: 'Name', value: 'type' } },
                                        {
                                          kind: 'Field',
                                          name: { kind: 'Name', value: 'image' },
                                          selectionSet: {
                                            kind: 'SelectionSet',
                                            selections: [
                                              {
                                                kind: 'Field',
                                                name: { kind: 'Name', value: 'id' },
                                              },
                                              {
                                                kind: 'Field',
                                                name: { kind: 'Name', value: 'url' },
                                              },
                                            ],
                                          },
                                        },
                                      ],
                                    },
                                  },
                                ],
                              },
                            },
                          ],
                        },
                      },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  GetCourseModuleContentReferencesQuery,
  GetCourseModuleContentReferencesQueryVariables
>
export const GetParentCourseIdDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'GetParentCourseId' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'id' } },
          type: {
            kind: 'NonNullType',
            type: { kind: 'NamedType', name: { kind: 'Name', value: 'ID' } },
          },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'contentList' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'where' },
                value: {
                  kind: 'ObjectValue',
                  fields: [
                    {
                      kind: 'ObjectField',
                      name: { kind: 'Name', value: 'id' },
                      value: {
                        kind: 'ObjectValue',
                        fields: [
                          {
                            kind: 'ObjectField',
                            name: { kind: 'Name', value: 'eq' },
                            value: { kind: 'Variable', name: { kind: 'Name', value: 'id' } },
                          },
                        ],
                      },
                    },
                  ],
                },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'content' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'contentReferencesFrom' },
                        arguments: [
                          {
                            kind: 'Argument',
                            name: { kind: 'Name', value: 'types' },
                            value: {
                              kind: 'ListValue',
                              values: [
                                { kind: 'StringValue', value: 'course-module', block: false },
                              ],
                            },
                          },
                        ],
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'contentTo' },
                              selectionSet: {
                                kind: 'SelectionSet',
                                selections: [
                                  { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                                  { kind: 'Field', name: { kind: 'Name', value: 'contentId' } },
                                  { kind: 'Field', name: { kind: 'Name', value: 'contentType' } },
                                  { kind: 'Field', name: { kind: 'Name', value: 'title' } },
                                ],
                              },
                            },
                          ],
                        },
                      },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<GetParentCourseIdQuery, GetParentCourseIdQueryVariables>
export const GetSeriesWithLatestEpisodeAdminCategoryDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'GetSeriesWithLatestEpisodeAdminCategory' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'seriesContentId' } },
          type: {
            kind: 'NonNullType',
            type: { kind: 'NamedType', name: { kind: 'Name', value: 'Int' } },
          },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'contentList' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'where' },
                value: {
                  kind: 'ObjectValue',
                  fields: [
                    {
                      kind: 'ObjectField',
                      name: { kind: 'Name', value: 'contentId' },
                      value: {
                        kind: 'ObjectValue',
                        fields: [
                          {
                            kind: 'ObjectField',
                            name: { kind: 'Name', value: 'eq' },
                            value: {
                              kind: 'Variable',
                              name: { kind: 'Name', value: 'seriesContentId' },
                            },
                          },
                        ],
                      },
                    },
                    {
                      kind: 'ObjectField',
                      name: { kind: 'Name', value: 'contentType' },
                      value: {
                        kind: 'ObjectValue',
                        fields: [
                          {
                            kind: 'ObjectField',
                            name: { kind: 'Name', value: 'eq' },
                            value: { kind: 'StringValue', value: 'series', block: false },
                          },
                        ],
                      },
                    },
                  ],
                },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'content' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'contentId' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'contentType' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'title' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'language' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'episodeNumber' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'seasonNumber' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'producer' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'writer' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'episodesCount' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'seasonsCount' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'director' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'instructor' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'studio' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'copyright' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'cast' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'productType' } },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'contentReferencesFrom' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'fromContentContentId' },
                            },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'fromContentContentType' },
                            },
                            { kind: 'Field', name: { kind: 'Name', value: 'toContentContentId' } },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'toContentContentType' },
                            },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'contentTo' },
                              selectionSet: {
                                kind: 'SelectionSet',
                                selections: [
                                  { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                                  { kind: 'Field', name: { kind: 'Name', value: 'contentId' } },
                                  { kind: 'Field', name: { kind: 'Name', value: 'contentType' } },
                                  { kind: 'Field', name: { kind: 'Name', value: 'subType' } },
                                  { kind: 'Field', name: { kind: 'Name', value: 'bundle' } },
                                  { kind: 'Field', name: { kind: 'Name', value: 'title' } },
                                ],
                              },
                            },
                          ],
                        },
                      },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  GetSeriesWithLatestEpisodeAdminCategoryQuery,
  GetSeriesWithLatestEpisodeAdminCategoryQueryVariables
>
export const GetProductReferencesDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'GetProductReferences' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'productContentId' } },
          type: {
            kind: 'NonNullType',
            type: { kind: 'NamedType', name: { kind: 'Name', value: 'Int' } },
          },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'contentList' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'where' },
                value: {
                  kind: 'ObjectValue',
                  fields: [
                    {
                      kind: 'ObjectField',
                      name: { kind: 'Name', value: 'contentId' },
                      value: {
                        kind: 'ObjectValue',
                        fields: [
                          {
                            kind: 'ObjectField',
                            name: { kind: 'Name', value: 'eq' },
                            value: {
                              kind: 'Variable',
                              name: { kind: 'Name', value: 'productContentId' },
                            },
                          },
                        ],
                      },
                    },
                    {
                      kind: 'ObjectField',
                      name: { kind: 'Name', value: 'contentType' },
                      value: {
                        kind: 'ObjectValue',
                        fields: [
                          {
                            kind: 'ObjectField',
                            name: { kind: 'Name', value: 'eq' },
                            value: { kind: 'StringValue', value: 'product', block: false },
                          },
                        ],
                      },
                    },
                  ],
                },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'content' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'contentId' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'contentType' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'title' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'language' } },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'contentReferencesFrom' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'fromContentContentId' },
                            },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'fromContentContentType' },
                            },
                            { kind: 'Field', name: { kind: 'Name', value: 'toContentContentId' } },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'toContentContentType' },
                            },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'contentFrom' },
                              selectionSet: {
                                kind: 'SelectionSet',
                                selections: [
                                  { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                                  { kind: 'Field', name: { kind: 'Name', value: 'contentId' } },
                                  { kind: 'Field', name: { kind: 'Name', value: 'contentType' } },
                                  { kind: 'Field', name: { kind: 'Name', value: 'title' } },
                                  { kind: 'Field', name: { kind: 'Name', value: 'language' } },
                                  { kind: 'Field', name: { kind: 'Name', value: 'published' } },
                                  { kind: 'Field', name: { kind: 'Name', value: 'path' } },
                                ],
                              },
                            },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'contentTo' },
                              selectionSet: {
                                kind: 'SelectionSet',
                                selections: [
                                  { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                                  { kind: 'Field', name: { kind: 'Name', value: 'contentId' } },
                                  { kind: 'Field', name: { kind: 'Name', value: 'contentType' } },
                                  { kind: 'Field', name: { kind: 'Name', value: 'title' } },
                                  { kind: 'Field', name: { kind: 'Name', value: 'language' } },
                                  { kind: 'Field', name: { kind: 'Name', value: 'published' } },
                                  { kind: 'Field', name: { kind: 'Name', value: 'path' } },
                                ],
                              },
                            },
                          ],
                        },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'contentReferencesTo' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'fromContentContentId' },
                            },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'fromContentContentType' },
                            },
                            { kind: 'Field', name: { kind: 'Name', value: 'toContentContentId' } },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'toContentContentType' },
                            },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'contentFrom' },
                              selectionSet: {
                                kind: 'SelectionSet',
                                selections: [
                                  { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                                  { kind: 'Field', name: { kind: 'Name', value: 'contentId' } },
                                  { kind: 'Field', name: { kind: 'Name', value: 'contentType' } },
                                  { kind: 'Field', name: { kind: 'Name', value: 'title' } },
                                  { kind: 'Field', name: { kind: 'Name', value: 'language' } },
                                  { kind: 'Field', name: { kind: 'Name', value: 'published' } },
                                  { kind: 'Field', name: { kind: 'Name', value: 'path' } },
                                ],
                              },
                            },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'contentTo' },
                              selectionSet: {
                                kind: 'SelectionSet',
                                selections: [
                                  { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                                  { kind: 'Field', name: { kind: 'Name', value: 'contentId' } },
                                  { kind: 'Field', name: { kind: 'Name', value: 'contentType' } },
                                  { kind: 'Field', name: { kind: 'Name', value: 'title' } },
                                  { kind: 'Field', name: { kind: 'Name', value: 'language' } },
                                  { kind: 'Field', name: { kind: 'Name', value: 'published' } },
                                  { kind: 'Field', name: { kind: 'Name', value: 'path' } },
                                ],
                              },
                            },
                          ],
                        },
                      },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<GetProductReferencesQuery, GetProductReferencesQueryVariables>
export const UpdateCourseContentDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'mutation',
      name: { kind: 'Name', value: 'UpdateCourseContent' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'content' } },
          type: {
            kind: 'NonNullType',
            type: { kind: 'NamedType', name: { kind: 'Name', value: 'ContentInput' } },
          },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'generatePath' } },
          type: { kind: 'NamedType', name: { kind: 'Name', value: 'Boolean' } },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'contentUpdate' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'content' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'content' } },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'generatePath' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'generatePath' } },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'content' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'contentId' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'contentType' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'title' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'description' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'descriptionFormat' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'shortDescription' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'shortDescriptionFormat' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'thirdPartyDescription' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'path' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'language' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'published' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'publishedAtDate' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'productionStatus' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'contentSearchNoIndex' } },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'excludeFromRecommendations' },
                      },
                      { kind: 'Field', name: { kind: 'Name', value: 'createdAt' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'updatedAt' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'productType' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'displayType' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'seasonNumber' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'episodeNumber' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'director' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'producer' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'writer' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'studio' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'copyright' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'instructor' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'cast' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'previewMediaId' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'featureMediaId' } },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<UpdateCourseContentMutation, UpdateCourseContentMutationVariables>
export const GetContentReferenceTypesDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'GetContentReferenceTypes' },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'contentReferenceTypesList' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'contentReferenceTypes' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'type' } },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<GetContentReferenceTypesQuery, GetContentReferenceTypesQueryVariables>
export const UpdateContentReferencesSortOrderDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'mutation',
      name: { kind: 'Name', value: 'UpdateContentReferencesSortOrder' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'contentReferences' } },
          type: {
            kind: 'NonNullType',
            type: {
              kind: 'ListType',
              type: {
                kind: 'NonNullType',
                type: {
                  kind: 'NamedType',
                  name: { kind: 'Name', value: 'ContentReferenceCreateInput' },
                },
              },
            },
          },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'deleteOmittedReferences' } },
          type: { kind: 'NamedType', name: { kind: 'Name', value: 'Boolean' } },
          defaultValue: { kind: 'BooleanValue', value: false },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'contentReferenceCreateMany' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'contentReferences' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'contentReferences' } },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'deleteOmittedReferences' },
                value: {
                  kind: 'Variable',
                  name: { kind: 'Name', value: 'deleteOmittedReferences' },
                },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'contentReferences' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'sortKey' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'fromContentContentId' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'fromContentContentType' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'toContentContentId' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'toContentContentType' } },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  UpdateContentReferencesSortOrderMutation,
  UpdateContentReferencesSortOrderMutationVariables
>
export const GetContentTranslationsDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'GetContentTranslations' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'contentId' } },
          type: {
            kind: 'NonNullType',
            type: { kind: 'NamedType', name: { kind: 'Name', value: 'Int' } },
          },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'contentType' } },
          type: {
            kind: 'NonNullType',
            type: { kind: 'NamedType', name: { kind: 'Name', value: 'String' } },
          },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'contentList' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'where' },
                value: {
                  kind: 'ObjectValue',
                  fields: [
                    {
                      kind: 'ObjectField',
                      name: { kind: 'Name', value: 'contentId' },
                      value: {
                        kind: 'ObjectValue',
                        fields: [
                          {
                            kind: 'ObjectField',
                            name: { kind: 'Name', value: 'eq' },
                            value: { kind: 'Variable', name: { kind: 'Name', value: 'contentId' } },
                          },
                        ],
                      },
                    },
                    {
                      kind: 'ObjectField',
                      name: { kind: 'Name', value: 'contentType' },
                      value: {
                        kind: 'ObjectValue',
                        fields: [
                          {
                            kind: 'ObjectField',
                            name: { kind: 'Name', value: 'eq' },
                            value: {
                              kind: 'Variable',
                              name: { kind: 'Name', value: 'contentType' },
                            },
                          },
                        ],
                      },
                    },
                  ],
                },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'content' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'contentId' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'contentType' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'language' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'primaryLanguage' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'title' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'published' } },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<GetContentTranslationsQuery, GetContentTranslationsQueryVariables>
export const YiContentTypeTagQueryDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'YIContentTypeTagQuery' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'title' } },
          type: {
            kind: 'NonNullType',
            type: { kind: 'NamedType', name: { kind: 'Name', value: 'String' } },
          },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'contentPolicyPolicyId' } },
          type: {
            kind: 'NonNullType',
            type: { kind: 'NamedType', name: { kind: 'Name', value: 'Int' } },
          },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'contentList' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'where' },
                value: {
                  kind: 'ObjectValue',
                  fields: [
                    {
                      kind: 'ObjectField',
                      name: { kind: 'Name', value: 'contentType' },
                      value: {
                        kind: 'ObjectValue',
                        fields: [
                          {
                            kind: 'ObjectField',
                            name: { kind: 'Name', value: 'eq' },
                            value: { kind: 'StringValue', value: 'tag', block: false },
                          },
                        ],
                      },
                    },
                    {
                      kind: 'ObjectField',
                      name: { kind: 'Name', value: 'title' },
                      value: {
                        kind: 'ObjectValue',
                        fields: [
                          {
                            kind: 'ObjectField',
                            name: { kind: 'Name', value: 'eq' },
                            value: { kind: 'Variable', name: { kind: 'Name', value: 'title' } },
                          },
                        ],
                      },
                    },
                    {
                      kind: 'ObjectField',
                      name: { kind: 'Name', value: 'contentPolicyPolicyId' },
                      value: {
                        kind: 'ObjectValue',
                        fields: [
                          {
                            kind: 'ObjectField',
                            name: { kind: 'Name', value: 'eq' },
                            value: {
                              kind: 'Variable',
                              name: { kind: 'Name', value: 'contentPolicyPolicyId' },
                            },
                          },
                        ],
                      },
                    },
                  ],
                },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'content' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'contentId' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'contentType' } },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<YiContentTypeTagQueryQuery, YiContentTypeTagQueryQueryVariables>
export const Mutation_GaiaVideo_ContentUpdateDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'mutation',
      name: { kind: 'Name', value: 'Mutation_GaiaVideo_ContentUpdate' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'content' } },
          type: {
            kind: 'NonNullType',
            type: { kind: 'NamedType', name: { kind: 'Name', value: 'ContentInput' } },
          },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'generatePath' } },
          type: { kind: 'NamedType', name: { kind: 'Name', value: 'Boolean' } },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'contentUpdate' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'content' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'content' } },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'generatePath' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'generatePath' } },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'content' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {
                        kind: 'FragmentSpread',
                        name: { kind: 'Name', value: 'Common_ContentFragment' },
                      },
                      {
                        kind: 'FragmentSpread',
                        name: { kind: 'Name', value: 'GaiaVideo_ContentFragment' },
                      },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'Content_ProviderCommonFragment' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'ContentProvider' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [{ kind: 'Field', name: { kind: 'Name', value: 'contentId' } }],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'Common_ContentProviderFragment' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'Content' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'contentProvider' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'provider' } },
                { kind: 'Field', name: { kind: 'Name', value: 'providerKey' } },
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'Content_ProviderCommonFragment' },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'ContentDetails_Tag_ContentReferenceFragment' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'ContentReference' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          { kind: 'Field', name: { kind: 'Name', value: 'sortKey' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'contentReferenceType' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [{ kind: 'Field', name: { kind: 'Name', value: 'type' } }],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'contentTo' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'language' },
                value: {
                  kind: 'ListValue',
                  values: [
                    { kind: 'StringValue', value: 'en', block: false },
                    { kind: 'StringValue', value: '_primary', block: false },
                  ],
                },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                { kind: 'Field', name: { kind: 'Name', value: 'titleGroupId' } },
                { kind: 'Field', name: { kind: 'Name', value: 'title' } },
                { kind: 'Field', name: { kind: 'Name', value: 'contentId' } },
                { kind: 'Field', name: { kind: 'Name', value: 'contentType' } },
                { kind: 'Field', name: { kind: 'Name', value: 'published' } },
              ],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'Common_ContentFragment' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'Content' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          { kind: 'Field', name: { kind: 'Name', value: 'contentId' } },
          { kind: 'Field', name: { kind: 'Name', value: 'contentType' } },
          { kind: 'Field', name: { kind: 'Name', value: 'published' } },
          { kind: 'Field', name: { kind: 'Name', value: 'publishedAtDate' } },
          { kind: 'Field', name: { kind: 'Name', value: 'createdAt' } },
          { kind: 'Field', name: { kind: 'Name', value: 'updatedAt' } },
          { kind: 'Field', name: { kind: 'Name', value: 'title' } },
          { kind: 'Field', name: { kind: 'Name', value: 'path' } },
          { kind: 'Field', name: { kind: 'Name', value: 'shortDescription' } },
          { kind: 'Field', name: { kind: 'Name', value: 'description' } },
          { kind: 'Field', name: { kind: 'Name', value: 'language' } },
          { kind: 'Field', name: { kind: 'Name', value: 'contentPolicyPolicyId' } },
          {
            kind: 'FragmentSpread',
            name: { kind: 'Name', value: 'Common_ContentProviderFragment' },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'GaiaVideo_ContentFragment' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'Content' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'episodeNumber' } },
          { kind: 'Field', name: { kind: 'Name', value: 'seasonNumber' } },
          { kind: 'Field', name: { kind: 'Name', value: 'director' } },
          { kind: 'Field', name: { kind: 'Name', value: 'producer' } },
          { kind: 'Field', name: { kind: 'Name', value: 'writer' } },
          { kind: 'Field', name: { kind: 'Name', value: 'studio' } },
          { kind: 'Field', name: { kind: 'Name', value: 'copyright' } },
          { kind: 'Field', name: { kind: 'Name', value: 'instructor' } },
          { kind: 'Field', name: { kind: 'Name', value: 'cast' } },
          { kind: 'Field', name: { kind: 'Name', value: 'productType' } },
          { kind: 'Field', name: { kind: 'Name', value: 'displayType' } },
          { kind: 'Field', name: { kind: 'Name', value: 'seoTitle' } },
          { kind: 'Field', name: { kind: 'Name', value: 'seoDescription' } },
          { kind: 'Field', name: { kind: 'Name', value: 'seoKeywords' } },
          { kind: 'Field', name: { kind: 'Name', value: 'seoRobotsNoFollow' } },
          { kind: 'Field', name: { kind: 'Name', value: 'seoRobotsNoIndex' } },
          { kind: 'Field', name: { kind: 'Name', value: 'excludeFromRecommendations' } },
          { kind: 'Field', name: { kind: 'Name', value: 'contentSearchNoIndex' } },
          {
            kind: 'Field',
            alias: { kind: 'Name', value: 'adminCategory' },
            name: { kind: 'Name', value: 'contentReferencesFrom' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'types' },
                value: { kind: 'StringValue', value: 'admin_category', block: false },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'ContentDetails_Tag_ContentReferenceFragment' },
                },
              ],
            },
          },
          {
            kind: 'Field',
            alias: { kind: 'Name', value: 'category' },
            name: { kind: 'Name', value: 'contentReferencesFrom' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'types' },
                value: { kind: 'StringValue', value: 'category', block: false },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'ContentDetails_Tag_ContentReferenceFragment' },
                },
              ],
            },
          },
          {
            kind: 'Field',
            alias: { kind: 'Name', value: 'centers' },
            name: { kind: 'Name', value: 'contentReferencesFrom' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'types' },
                value: { kind: 'StringValue', value: 'centers', block: false },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'ContentDetails_Tag_ContentReferenceFragment' },
                },
              ],
            },
          },
          {
            kind: 'Field',
            alias: { kind: 'Name', value: 'contentOrigin' },
            name: { kind: 'Name', value: 'contentReferencesFrom' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'types' },
                value: { kind: 'StringValue', value: 'content_origin', block: false },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'ContentDetails_Tag_ContentReferenceFragment' },
                },
              ],
            },
          },
          {
            kind: 'Field',
            alias: { kind: 'Name', value: 'consciousFormat' },
            name: { kind: 'Name', value: 'contentReferencesFrom' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'types' },
                value: { kind: 'StringValue', value: 'conscious-format', block: false },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'ContentDetails_Tag_ContentReferenceFragment' },
                },
              ],
            },
          },
          {
            kind: 'Field',
            alias: { kind: 'Name', value: 'consciousTopic' },
            name: { kind: 'Name', value: 'contentReferencesFrom' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'types' },
                value: { kind: 'StringValue', value: 'conscious-topic', block: false },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'ContentDetails_Tag_ContentReferenceFragment' },
                },
              ],
            },
          },
          {
            kind: 'Field',
            alias: { kind: 'Name', value: 'filmSubject' },
            name: { kind: 'Name', value: 'contentReferencesFrom' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'types' },
                value: { kind: 'StringValue', value: 'film-subject', block: false },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'ContentDetails_Tag_ContentReferenceFragment' },
                },
              ],
            },
          },
          {
            kind: 'Field',
            alias: { kind: 'Name', value: 'filmType' },
            name: { kind: 'Name', value: 'contentReferencesFrom' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'types' },
                value: { kind: 'StringValue', value: 'film-type', block: false },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'ContentDetails_Tag_ContentReferenceFragment' },
                },
              ],
            },
          },
          {
            kind: 'Field',
            alias: { kind: 'Name', value: 'fitnessDuration' },
            name: { kind: 'Name', value: 'contentReferencesFrom' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'types' },
                value: { kind: 'StringValue', value: 'fitness-duration', block: false },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'ContentDetails_Tag_ContentReferenceFragment' },
                },
              ],
            },
          },
          {
            kind: 'Field',
            alias: { kind: 'Name', value: 'fitnessLevel' },
            name: { kind: 'Name', value: 'contentReferencesFrom' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'types' },
                value: { kind: 'StringValue', value: 'fitness-level', block: false },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'ContentDetails_Tag_ContentReferenceFragment' },
                },
              ],
            },
          },
          {
            kind: 'Field',
            alias: { kind: 'Name', value: 'fitnessInstructor' },
            name: { kind: 'Name', value: 'contentReferencesFrom' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'types' },
                value: { kind: 'StringValue', value: 'fitness-instructor', block: false },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'ContentDetails_Tag_ContentReferenceFragment' },
                },
              ],
            },
          },
          {
            kind: 'Field',
            alias: { kind: 'Name', value: 'fitnessSpecialty' },
            name: { kind: 'Name', value: 'contentReferencesFrom' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'types' },
                value: { kind: 'StringValue', value: 'fitness-specialty', block: false },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'ContentDetails_Tag_ContentReferenceFragment' },
                },
              ],
            },
          },
          {
            kind: 'Field',
            alias: { kind: 'Name', value: 'fitnessStyle' },
            name: { kind: 'Name', value: 'contentReferencesFrom' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'types' },
                value: { kind: 'StringValue', value: 'fitness-style', block: false },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'ContentDetails_Tag_ContentReferenceFragment' },
                },
              ],
            },
          },
          {
            kind: 'Field',
            alias: { kind: 'Name', value: 'genres' },
            name: { kind: 'Name', value: 'contentReferencesFrom' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'types' },
                value: { kind: 'StringValue', value: 'genres', block: false },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'ContentDetails_Tag_ContentReferenceFragment' },
                },
              ],
            },
          },
          {
            kind: 'Field',
            alias: { kind: 'Name', value: 'interviewGuest' },
            name: { kind: 'Name', value: 'contentReferencesFrom' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'types' },
                value: { kind: 'StringValue', value: 'interview-guest', block: false },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'ContentDetails_Tag_ContentReferenceFragment' },
                },
              ],
            },
          },
          {
            kind: 'Field',
            alias: { kind: 'Name', value: 'interviewHost' },
            name: { kind: 'Name', value: 'contentReferencesFrom' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'types' },
                value: { kind: 'StringValue', value: 'interview-host', block: false },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'ContentDetails_Tag_ContentReferenceFragment' },
                },
              ],
            },
          },
          {
            kind: 'Field',
            alias: { kind: 'Name', value: 'marketingCenters' },
            name: { kind: 'Name', value: 'contentReferencesFrom' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'types' },
                value: { kind: 'StringValue', value: 'marketing-centers', block: false },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'ContentDetails_Tag_ContentReferenceFragment' },
                },
              ],
            },
          },
          {
            kind: 'Field',
            alias: { kind: 'Name', value: 'meditationFocus' },
            name: { kind: 'Name', value: 'contentReferencesFrom' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'types' },
                value: { kind: 'StringValue', value: 'fitness-style', block: false },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'ContentDetails_Tag_ContentReferenceFragment' },
                },
              ],
            },
          },
          {
            kind: 'Field',
            alias: { kind: 'Name', value: 'meditationStyle' },
            name: { kind: 'Name', value: 'contentReferencesFrom' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'types' },
                value: { kind: 'StringValue', value: 'meditation-style', block: false },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'ContentDetails_Tag_ContentReferenceFragment' },
                },
              ],
            },
          },
          {
            kind: 'Field',
            alias: { kind: 'Name', value: 'meditationTeacher' },
            name: { kind: 'Name', value: 'contentReferencesFrom' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'types' },
                value: { kind: 'StringValue', value: 'meditation-teacher', block: false },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'ContentDetails_Tag_ContentReferenceFragment' },
                },
              ],
            },
          },
          {
            kind: 'Field',
            alias: { kind: 'Name', value: 'meditationDuration' },
            name: { kind: 'Name', value: 'contentReferencesFrom' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'types' },
                value: { kind: 'StringValue', value: 'meditation-duration', block: false },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'ContentDetails_Tag_ContentReferenceFragment' },
                },
              ],
            },
          },
          {
            kind: 'Field',
            alias: { kind: 'Name', value: 'onboardingChoices' },
            name: { kind: 'Name', value: 'contentReferencesFrom' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'types' },
                value: { kind: 'StringValue', value: 'onboarding_choices', block: false },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'ContentDetails_Tag_ContentReferenceFragment' },
                },
              ],
            },
          },
          {
            kind: 'Field',
            alias: { kind: 'Name', value: 'product' },
            name: { kind: 'Name', value: 'contentReferencesFrom' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'types' },
                value: { kind: 'StringValue', value: 'product', block: false },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'ContentDetails_Tag_ContentReferenceFragment' },
                },
              ],
            },
          },
          {
            kind: 'Field',
            alias: { kind: 'Name', value: 'rainbowCategory' },
            name: { kind: 'Name', value: 'contentReferencesFrom' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'types' },
                value: { kind: 'StringValue', value: 'rainbow-category', block: false },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'ContentDetails_Tag_ContentReferenceFragment' },
                },
              ],
            },
          },
          {
            kind: 'Field',
            alias: { kind: 'Name', value: 'recipeDiet' },
            name: { kind: 'Name', value: 'contentReferencesFrom' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'types' },
                value: { kind: 'StringValue', value: 'recipe-diet', block: false },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'ContentDetails_Tag_ContentReferenceFragment' },
                },
              ],
            },
          },
          {
            kind: 'Field',
            alias: { kind: 'Name', value: 'recipeType' },
            name: { kind: 'Name', value: 'contentReferencesFrom' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'types' },
                value: { kind: 'StringValue', value: 'recipe-type', block: false },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'ContentDetails_Tag_ContentReferenceFragment' },
                },
              ],
            },
          },
          {
            kind: 'Field',
            alias: { kind: 'Name', value: 'series' },
            name: { kind: 'Name', value: 'contentReferencesFrom' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'types' },
                value: { kind: 'StringValue', value: 'series', block: false },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'ContentDetails_Tag_ContentReferenceFragment' },
                },
              ],
            },
          },
          {
            kind: 'Field',
            alias: { kind: 'Name', value: 'similarVideos' },
            name: { kind: 'Name', value: 'contentReferencesFrom' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'types' },
                value: { kind: 'StringValue', value: 'similar-videos', block: false },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'ContentDetails_Tag_ContentReferenceFragment' },
                },
              ],
            },
          },
          {
            kind: 'Field',
            alias: { kind: 'Name', value: 'thirdPartyGenre' },
            name: { kind: 'Name', value: 'contentReferencesFrom' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'types' },
                value: { kind: 'StringValue', value: 'third-party-genre', block: false },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'ContentDetails_Tag_ContentReferenceFragment' },
                },
              ],
            },
          },
          {
            kind: 'Field',
            alias: { kind: 'Name', value: 'videoCollection' },
            name: { kind: 'Name', value: 'contentReferencesFrom' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'types' },
                value: { kind: 'StringValue', value: 'video-collection', block: false },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'ContentDetails_Tag_ContentReferenceFragment' },
                },
              ],
            },
          },
          {
            kind: 'Field',
            alias: { kind: 'Name', value: 'videoTopic' },
            name: { kind: 'Name', value: 'contentReferencesFrom' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'types' },
                value: { kind: 'StringValue', value: 'video-topic', block: false },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'ContentDetails_Tag_ContentReferenceFragment' },
                },
              ],
            },
          },
          {
            kind: 'Field',
            alias: { kind: 'Name', value: 'yogaDuration' },
            name: { kind: 'Name', value: 'contentReferencesFrom' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'types' },
                value: { kind: 'StringValue', value: 'yoga-duration', block: false },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'ContentDetails_Tag_ContentReferenceFragment' },
                },
              ],
            },
          },
          {
            kind: 'Field',
            alias: { kind: 'Name', value: 'yogaFocus' },
            name: { kind: 'Name', value: 'contentReferencesFrom' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'types' },
                value: { kind: 'StringValue', value: 'yoga-focus', block: false },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'ContentDetails_Tag_ContentReferenceFragment' },
                },
              ],
            },
          },
          {
            kind: 'Field',
            alias: { kind: 'Name', value: 'yogaLevel' },
            name: { kind: 'Name', value: 'contentReferencesFrom' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'types' },
                value: { kind: 'StringValue', value: 'yoga-level', block: false },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'ContentDetails_Tag_ContentReferenceFragment' },
                },
              ],
            },
          },
          {
            kind: 'Field',
            alias: { kind: 'Name', value: 'yogaStyle' },
            name: { kind: 'Name', value: 'contentReferencesFrom' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'types' },
                value: { kind: 'StringValue', value: 'yoga-style', block: false },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'ContentDetails_Tag_ContentReferenceFragment' },
                },
              ],
            },
          },
          {
            kind: 'Field',
            alias: { kind: 'Name', value: 'yogaTeacher' },
            name: { kind: 'Name', value: 'contentReferencesFrom' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'types' },
                value: { kind: 'StringValue', value: 'yoga-teacher', block: false },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'ContentDetails_Tag_ContentReferenceFragment' },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  Mutation_GaiaVideo_ContentUpdateMutation,
  Mutation_GaiaVideo_ContentUpdateMutationVariables
>
export const Mutation_YiArticle_ContentUpdateDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'mutation',
      name: { kind: 'Name', value: 'Mutation_YIArticle_ContentUpdate' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'content' } },
          type: {
            kind: 'NonNullType',
            type: { kind: 'NamedType', name: { kind: 'Name', value: 'ContentInput' } },
          },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'generatePath' } },
          type: { kind: 'NamedType', name: { kind: 'Name', value: 'Boolean' } },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'contentUpdate' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'content' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'content' } },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'generatePath' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'generatePath' } },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'content' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {
                        kind: 'FragmentSpread',
                        name: { kind: 'Name', value: 'YIArticle_ContentFragment' },
                      },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'Common_MediaFragment' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'Media' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'mediaId' } },
          { kind: 'Field', name: { kind: 'Name', value: 'contentId' } },
          { kind: 'Field', name: { kind: 'Name', value: 'mediaMaestroTitleCode' } },
          { kind: 'Field', name: { kind: 'Name', value: 'policyId' } },
          { kind: 'Field', name: { kind: 'Name', value: 'updatedAt' } },
          { kind: 'Field', name: { kind: 'Name', value: 'duration' } },
          { kind: 'Field', name: { kind: 'Name', value: 'isPublished' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'mediaAssets' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                { kind: 'Field', name: { kind: 'Name', value: 'providerKey' } },
              ],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'ContentFeatureMediaFragment' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'Content' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'contentPolicyPolicyId' } },
          { kind: 'Field', name: { kind: 'Name', value: 'featureMediaId' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'featureMedia' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'FragmentSpread', name: { kind: 'Name', value: 'Common_MediaFragment' } },
              ],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'ContentDetails_Tag_ContentReferenceFragment' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'ContentReference' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          { kind: 'Field', name: { kind: 'Name', value: 'sortKey' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'contentReferenceType' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [{ kind: 'Field', name: { kind: 'Name', value: 'type' } }],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'contentTo' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'language' },
                value: {
                  kind: 'ListValue',
                  values: [
                    { kind: 'StringValue', value: 'en', block: false },
                    { kind: 'StringValue', value: '_primary', block: false },
                  ],
                },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                { kind: 'Field', name: { kind: 'Name', value: 'titleGroupId' } },
                { kind: 'Field', name: { kind: 'Name', value: 'title' } },
                { kind: 'Field', name: { kind: 'Name', value: 'contentId' } },
                { kind: 'Field', name: { kind: 'Name', value: 'contentType' } },
                { kind: 'Field', name: { kind: 'Name', value: 'published' } },
              ],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'ContentDetails_Person_ContentFragment' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'Content' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          { kind: 'Field', name: { kind: 'Name', value: 'title' } },
          { kind: 'Field', name: { kind: 'Name', value: 'language' } },
          { kind: 'Field', name: { kind: 'Name', value: 'contentType' } },
          { kind: 'Field', name: { kind: 'Name', value: 'contentId' } },
          { kind: 'Field', name: { kind: 'Name', value: 'published' } },
          {
            kind: 'Field',
            alias: { kind: 'Name', value: 'avatar' },
            name: { kind: 'Name', value: 'imageContentRelationships' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                { kind: 'Field', name: { kind: 'Name', value: 'type' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'image' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'url' } },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'ContentDetails_Person_ContentReferenceFragment' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'ContentReference' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          { kind: 'Field', name: { kind: 'Name', value: 'sortKey' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'contentReferenceType' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                { kind: 'Field', name: { kind: 'Name', value: 'type' } },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'contentTo' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'ContentDetails_Person_ContentFragment' },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'Content_ProviderCommonFragment' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'ContentProvider' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [{ kind: 'Field', name: { kind: 'Name', value: 'contentId' } }],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'Content_ProviderMetadataFragment' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'Content' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            alias: { kind: 'Name', value: 'providerMetadata' },
            name: { kind: 'Name', value: 'contentProvider' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'metadata' } },
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'Content_ProviderCommonFragment' },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'YIArticle_ContentFragment' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'Content' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'contentPolicyPolicyId' } },
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          { kind: 'Field', name: { kind: 'Name', value: 'contentId' } },
          { kind: 'Field', name: { kind: 'Name', value: 'contentType' } },
          { kind: 'Field', name: { kind: 'Name', value: 'language' } },
          { kind: 'Field', name: { kind: 'Name', value: 'description' } },
          { kind: 'Field', name: { kind: 'Name', value: 'descriptionFormat' } },
          { kind: 'Field', name: { kind: 'Name', value: 'shortDescription' } },
          { kind: 'Field', name: { kind: 'Name', value: 'shortDescriptionFormat' } },
          { kind: 'Field', name: { kind: 'Name', value: 'path' } },
          { kind: 'Field', name: { kind: 'Name', value: 'primaryLanguage' } },
          { kind: 'Field', name: { kind: 'Name', value: 'published' } },
          { kind: 'Field', name: { kind: 'Name', value: 'publishedAtDate' } },
          { kind: 'Field', name: { kind: 'Name', value: 'seoDescription' } },
          { kind: 'Field', name: { kind: 'Name', value: 'seoTitle' } },
          { kind: 'Field', name: { kind: 'Name', value: 'title' } },
          { kind: 'FragmentSpread', name: { kind: 'Name', value: 'ContentFeatureMediaFragment' } },
          {
            kind: 'Field',
            alias: { kind: 'Name', value: 'yiContentType' },
            name: { kind: 'Name', value: 'contentReferencesFrom' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'types' },
                value: { kind: 'StringValue', value: 'yi-content-type', block: false },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'ContentDetails_Tag_ContentReferenceFragment' },
                },
              ],
            },
          },
          {
            kind: 'Field',
            alias: { kind: 'Name', value: 'yiYogaTeacher' },
            name: { kind: 'Name', value: 'contentReferencesFrom' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'types' },
                value: { kind: 'StringValue', value: 'yi-yoga-teacher', block: false },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'ContentDetails_Person_ContentReferenceFragment' },
                },
              ],
            },
          },
          {
            kind: 'Field',
            alias: { kind: 'Name', value: 'yiTags' },
            name: { kind: 'Name', value: 'contentReferencesFrom' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'types' },
                value: { kind: 'StringValue', value: 'yi-tag', block: false },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'ContentDetails_Tag_ContentReferenceFragment' },
                },
              ],
            },
          },
          {
            kind: 'Field',
            alias: { kind: 'Name', value: 'yiArticleTopic' },
            name: { kind: 'Name', value: 'contentReferencesFrom' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'types' },
                value: { kind: 'StringValue', value: 'yi-article-topic', block: false },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'ContentDetails_Tag_ContentReferenceFragment' },
                },
              ],
            },
          },
          {
            kind: 'FragmentSpread',
            name: { kind: 'Name', value: 'Content_ProviderMetadataFragment' },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  Mutation_YiArticle_ContentUpdateMutation,
  Mutation_YiArticle_ContentUpdateMutationVariables
>
export const Mutation_YicLass_ContentUpdateDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'mutation',
      name: { kind: 'Name', value: 'Mutation_YICLass_ContentUpdate' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'content' } },
          type: {
            kind: 'NonNullType',
            type: { kind: 'NamedType', name: { kind: 'Name', value: 'ContentInput' } },
          },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'generatePath' } },
          type: { kind: 'NamedType', name: { kind: 'Name', value: 'Boolean' } },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'contentUpdate' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'content' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'content' } },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'generatePath' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'generatePath' } },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'content' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {
                        kind: 'FragmentSpread',
                        name: { kind: 'Name', value: 'Common_ContentFragment' },
                      },
                      {
                        kind: 'FragmentSpread',
                        name: { kind: 'Name', value: 'YIClass_ContentFragment' },
                      },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'Content_ProviderCommonFragment' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'ContentProvider' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [{ kind: 'Field', name: { kind: 'Name', value: 'contentId' } }],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'Common_ContentProviderFragment' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'Content' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'contentProvider' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'provider' } },
                { kind: 'Field', name: { kind: 'Name', value: 'providerKey' } },
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'Content_ProviderCommonFragment' },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'Common_MediaFragment' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'Media' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'mediaId' } },
          { kind: 'Field', name: { kind: 'Name', value: 'contentId' } },
          { kind: 'Field', name: { kind: 'Name', value: 'mediaMaestroTitleCode' } },
          { kind: 'Field', name: { kind: 'Name', value: 'policyId' } },
          { kind: 'Field', name: { kind: 'Name', value: 'updatedAt' } },
          { kind: 'Field', name: { kind: 'Name', value: 'duration' } },
          { kind: 'Field', name: { kind: 'Name', value: 'isPublished' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'mediaAssets' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                { kind: 'Field', name: { kind: 'Name', value: 'providerKey' } },
              ],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'ContentFeatureMediaFragment' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'Content' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'contentPolicyPolicyId' } },
          { kind: 'Field', name: { kind: 'Name', value: 'featureMediaId' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'featureMedia' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'FragmentSpread', name: { kind: 'Name', value: 'Common_MediaFragment' } },
              ],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'ContentDetails_Tag_ContentReferenceFragment' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'ContentReference' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          { kind: 'Field', name: { kind: 'Name', value: 'sortKey' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'contentReferenceType' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [{ kind: 'Field', name: { kind: 'Name', value: 'type' } }],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'contentTo' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'language' },
                value: {
                  kind: 'ListValue',
                  values: [
                    { kind: 'StringValue', value: 'en', block: false },
                    { kind: 'StringValue', value: '_primary', block: false },
                  ],
                },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                { kind: 'Field', name: { kind: 'Name', value: 'titleGroupId' } },
                { kind: 'Field', name: { kind: 'Name', value: 'title' } },
                { kind: 'Field', name: { kind: 'Name', value: 'contentId' } },
                { kind: 'Field', name: { kind: 'Name', value: 'contentType' } },
                { kind: 'Field', name: { kind: 'Name', value: 'published' } },
              ],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'ContentDetails_Person_ContentFragment' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'Content' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          { kind: 'Field', name: { kind: 'Name', value: 'title' } },
          { kind: 'Field', name: { kind: 'Name', value: 'language' } },
          { kind: 'Field', name: { kind: 'Name', value: 'contentType' } },
          { kind: 'Field', name: { kind: 'Name', value: 'contentId' } },
          { kind: 'Field', name: { kind: 'Name', value: 'published' } },
          {
            kind: 'Field',
            alias: { kind: 'Name', value: 'avatar' },
            name: { kind: 'Name', value: 'imageContentRelationships' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                { kind: 'Field', name: { kind: 'Name', value: 'type' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'image' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'url' } },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'ContentDetails_Person_ContentReferenceFragment' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'ContentReference' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          { kind: 'Field', name: { kind: 'Name', value: 'sortKey' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'contentReferenceType' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                { kind: 'Field', name: { kind: 'Name', value: 'type' } },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'contentTo' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'ContentDetails_Person_ContentFragment' },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'Common_ContentFragment' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'Content' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          { kind: 'Field', name: { kind: 'Name', value: 'contentId' } },
          { kind: 'Field', name: { kind: 'Name', value: 'contentType' } },
          { kind: 'Field', name: { kind: 'Name', value: 'published' } },
          { kind: 'Field', name: { kind: 'Name', value: 'publishedAtDate' } },
          { kind: 'Field', name: { kind: 'Name', value: 'createdAt' } },
          { kind: 'Field', name: { kind: 'Name', value: 'updatedAt' } },
          { kind: 'Field', name: { kind: 'Name', value: 'title' } },
          { kind: 'Field', name: { kind: 'Name', value: 'path' } },
          { kind: 'Field', name: { kind: 'Name', value: 'shortDescription' } },
          { kind: 'Field', name: { kind: 'Name', value: 'description' } },
          { kind: 'Field', name: { kind: 'Name', value: 'language' } },
          { kind: 'Field', name: { kind: 'Name', value: 'contentPolicyPolicyId' } },
          {
            kind: 'FragmentSpread',
            name: { kind: 'Name', value: 'Common_ContentProviderFragment' },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'YIClass_ContentFragment' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'Content' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'descriptionFormat' } },
          { kind: 'Field', name: { kind: 'Name', value: 'shortDescriptionFormat' } },
          { kind: 'Field', name: { kind: 'Name', value: 'displayType' } },
          { kind: 'Field', name: { kind: 'Name', value: 'primaryLanguage' } },
          { kind: 'Field', name: { kind: 'Name', value: 'productType' } },
          { kind: 'Field', name: { kind: 'Name', value: 'seoDescription' } },
          { kind: 'Field', name: { kind: 'Name', value: 'seoTitle' } },
          { kind: 'FragmentSpread', name: { kind: 'Name', value: 'ContentFeatureMediaFragment' } },
          {
            kind: 'Field',
            alias: { kind: 'Name', value: 'yiContentType' },
            name: { kind: 'Name', value: 'contentReferencesFrom' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'types' },
                value: { kind: 'StringValue', value: 'yi-content-type', block: false },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'ContentDetails_Tag_ContentReferenceFragment' },
                },
              ],
            },
          },
          {
            kind: 'Field',
            alias: { kind: 'Name', value: 'yiTags' },
            name: { kind: 'Name', value: 'contentReferencesFrom' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'types' },
                value: { kind: 'StringValue', value: 'yi-tag', block: false },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'ContentDetails_Tag_ContentReferenceFragment' },
                },
              ],
            },
          },
          {
            kind: 'Field',
            alias: { kind: 'Name', value: 'yiYogaStyle' },
            name: { kind: 'Name', value: 'contentReferencesFrom' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'types' },
                value: { kind: 'StringValue', value: 'yi-yoga-style', block: false },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'ContentDetails_Tag_ContentReferenceFragment' },
                },
              ],
            },
          },
          {
            kind: 'Field',
            alias: { kind: 'Name', value: 'yiYogaLevel' },
            name: { kind: 'Name', value: 'contentReferencesFrom' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'types' },
                value: { kind: 'StringValue', value: 'yi-yoga-level', block: false },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'ContentDetails_Tag_ContentReferenceFragment' },
                },
              ],
            },
          },
          {
            kind: 'Field',
            alias: { kind: 'Name', value: 'yiYogaTeacher' },
            name: { kind: 'Name', value: 'contentReferencesFrom' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'types' },
                value: { kind: 'StringValue', value: 'yi-yoga-teacher', block: false },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'ContentDetails_Person_ContentReferenceFragment' },
                },
              ],
            },
          },
          {
            kind: 'Field',
            alias: { kind: 'Name', value: 'yiPracticeType' },
            name: { kind: 'Name', value: 'contentReferencesFrom' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'types' },
                value: { kind: 'StringValue', value: 'yi-practice-type', block: false },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'ContentDetails_Tag_ContentReferenceFragment' },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  Mutation_YicLass_ContentUpdateMutation,
  Mutation_YicLass_ContentUpdateMutationVariables
>
export const YiCourseModuleSearchContentSelectQueryDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'YICourseModuleSearchContentSelectQuery' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'offset' } },
          type: { kind: 'NamedType', name: { kind: 'Name', value: 'Int' } },
          defaultValue: { kind: 'IntValue', value: '0' },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'limit' } },
          type: { kind: 'NamedType', name: { kind: 'Name', value: 'Int' } },
          defaultValue: { kind: 'IntValue', value: '25' },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'where' } },
          type: { kind: 'NamedType', name: { kind: 'Name', value: 'ContentWhereInput' } },
          defaultValue: { kind: 'ObjectValue', fields: [] },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'referencesNot' } },
          type: {
            kind: 'ListType',
            type: {
              kind: 'NamedType',
              name: { kind: 'Name', value: 'ContentContentReferencesToFilterInput' },
            },
          },
          defaultValue: { kind: 'ListValue', values: [] },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'contentList' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'offset' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'offset' } },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'limit' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'limit' } },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'where' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'where' } },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'order' },
                value: {
                  kind: 'ListValue',
                  values: [
                    {
                      kind: 'ListValue',
                      values: [
                        { kind: 'StringValue', value: 'updatedAt', block: false },
                        { kind: 'StringValue', value: 'DESC', block: false },
                      ],
                    },
                  ],
                },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'referencesNot' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'referencesNot' } },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'content' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'updatedAt' } },
                      {
                        kind: 'FragmentSpread',
                        name: { kind: 'Name', value: 'YICourse_ModuleDetailsContentFragment' },
                      },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'ContentDetails_Tag_ContentReferenceFragment' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'ContentReference' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          { kind: 'Field', name: { kind: 'Name', value: 'sortKey' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'contentReferenceType' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [{ kind: 'Field', name: { kind: 'Name', value: 'type' } }],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'contentTo' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'language' },
                value: {
                  kind: 'ListValue',
                  values: [
                    { kind: 'StringValue', value: 'en', block: false },
                    { kind: 'StringValue', value: '_primary', block: false },
                  ],
                },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                { kind: 'Field', name: { kind: 'Name', value: 'titleGroupId' } },
                { kind: 'Field', name: { kind: 'Name', value: 'title' } },
                { kind: 'Field', name: { kind: 'Name', value: 'contentId' } },
                { kind: 'Field', name: { kind: 'Name', value: 'contentType' } },
                { kind: 'Field', name: { kind: 'Name', value: 'published' } },
              ],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'Content_ProviderCommonFragment' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'ContentProvider' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [{ kind: 'Field', name: { kind: 'Name', value: 'contentId' } }],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'Content_ProviderMetadataFragment' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'Content' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            alias: { kind: 'Name', value: 'providerMetadata' },
            name: { kind: 'Name', value: 'contentProvider' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'metadata' } },
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'Content_ProviderCommonFragment' },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'YICourse_ModuleDetailsContentFragment' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'Content' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'title' } },
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          { kind: 'Field', name: { kind: 'Name', value: 'contentType' } },
          { kind: 'Field', name: { kind: 'Name', value: 'contentId' } },
          { kind: 'Field', name: { kind: 'Name', value: 'published' } },
          {
            kind: 'Field',
            alias: { kind: 'Name', value: 'yiCourseModuleType' },
            name: { kind: 'Name', value: 'contentReferencesFrom' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'types' },
                value: { kind: 'StringValue', value: 'yi-course-module-type', block: false },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'ContentDetails_Tag_ContentReferenceFragment' },
                },
              ],
            },
          },
          {
            kind: 'FragmentSpread',
            name: { kind: 'Name', value: 'Content_ProviderMetadataFragment' },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  YiCourseModuleSearchContentSelectQueryQuery,
  YiCourseModuleSearchContentSelectQueryQueryVariables
>
export const Mutation_YiCourse_ContentUpdateDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'mutation',
      name: { kind: 'Name', value: 'Mutation_YICourse_ContentUpdate' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'content' } },
          type: {
            kind: 'NonNullType',
            type: { kind: 'NamedType', name: { kind: 'Name', value: 'ContentInput' } },
          },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'generatePath' } },
          type: { kind: 'NamedType', name: { kind: 'Name', value: 'Boolean' } },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'contentUpdate' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'content' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'content' } },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'generatePath' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'generatePath' } },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'content' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {
                        kind: 'FragmentSpread',
                        name: { kind: 'Name', value: 'Common_ContentFragment' },
                      },
                      {
                        kind: 'FragmentSpread',
                        name: { kind: 'Name', value: 'YICourse_ContentFragment' },
                      },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'Content_ProviderCommonFragment' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'ContentProvider' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [{ kind: 'Field', name: { kind: 'Name', value: 'contentId' } }],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'Common_ContentProviderFragment' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'Content' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'contentProvider' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'provider' } },
                { kind: 'Field', name: { kind: 'Name', value: 'providerKey' } },
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'Content_ProviderCommonFragment' },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'ContentDetails_Tag_ContentReferenceFragment' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'ContentReference' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          { kind: 'Field', name: { kind: 'Name', value: 'sortKey' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'contentReferenceType' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [{ kind: 'Field', name: { kind: 'Name', value: 'type' } }],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'contentTo' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'language' },
                value: {
                  kind: 'ListValue',
                  values: [
                    { kind: 'StringValue', value: 'en', block: false },
                    { kind: 'StringValue', value: '_primary', block: false },
                  ],
                },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                { kind: 'Field', name: { kind: 'Name', value: 'titleGroupId' } },
                { kind: 'Field', name: { kind: 'Name', value: 'title' } },
                { kind: 'Field', name: { kind: 'Name', value: 'contentId' } },
                { kind: 'Field', name: { kind: 'Name', value: 'contentType' } },
                { kind: 'Field', name: { kind: 'Name', value: 'published' } },
              ],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'ContentDetails_Person_ContentFragment' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'Content' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          { kind: 'Field', name: { kind: 'Name', value: 'title' } },
          { kind: 'Field', name: { kind: 'Name', value: 'language' } },
          { kind: 'Field', name: { kind: 'Name', value: 'contentType' } },
          { kind: 'Field', name: { kind: 'Name', value: 'contentId' } },
          { kind: 'Field', name: { kind: 'Name', value: 'published' } },
          {
            kind: 'Field',
            alias: { kind: 'Name', value: 'avatar' },
            name: { kind: 'Name', value: 'imageContentRelationships' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                { kind: 'Field', name: { kind: 'Name', value: 'type' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'image' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'url' } },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'ContentDetails_Person_ContentReferenceFragment' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'ContentReference' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          { kind: 'Field', name: { kind: 'Name', value: 'sortKey' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'contentReferenceType' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                { kind: 'Field', name: { kind: 'Name', value: 'type' } },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'contentTo' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'ContentDetails_Person_ContentFragment' },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'Content_ProviderMetadataFragment' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'Content' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            alias: { kind: 'Name', value: 'providerMetadata' },
            name: { kind: 'Name', value: 'contentProvider' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'metadata' } },
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'Content_ProviderCommonFragment' },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'YICourse_ModuleDetailsContentFragment' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'Content' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'title' } },
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          { kind: 'Field', name: { kind: 'Name', value: 'contentType' } },
          { kind: 'Field', name: { kind: 'Name', value: 'contentId' } },
          { kind: 'Field', name: { kind: 'Name', value: 'published' } },
          {
            kind: 'Field',
            alias: { kind: 'Name', value: 'yiCourseModuleType' },
            name: { kind: 'Name', value: 'contentReferencesFrom' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'types' },
                value: { kind: 'StringValue', value: 'yi-course-module-type', block: false },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'ContentDetails_Tag_ContentReferenceFragment' },
                },
              ],
            },
          },
          {
            kind: 'FragmentSpread',
            name: { kind: 'Name', value: 'Content_ProviderMetadataFragment' },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'YICourse_ModulesContentReferenceFragment' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'ContentReference' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'sortKey' } },
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'contentReferenceType' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [{ kind: 'Field', name: { kind: 'Name', value: 'type' } }],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'contentTo' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'YICourse_ModuleDetailsContentFragment' },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'Common_ContentFragment' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'Content' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          { kind: 'Field', name: { kind: 'Name', value: 'contentId' } },
          { kind: 'Field', name: { kind: 'Name', value: 'contentType' } },
          { kind: 'Field', name: { kind: 'Name', value: 'published' } },
          { kind: 'Field', name: { kind: 'Name', value: 'publishedAtDate' } },
          { kind: 'Field', name: { kind: 'Name', value: 'createdAt' } },
          { kind: 'Field', name: { kind: 'Name', value: 'updatedAt' } },
          { kind: 'Field', name: { kind: 'Name', value: 'title' } },
          { kind: 'Field', name: { kind: 'Name', value: 'path' } },
          { kind: 'Field', name: { kind: 'Name', value: 'shortDescription' } },
          { kind: 'Field', name: { kind: 'Name', value: 'description' } },
          { kind: 'Field', name: { kind: 'Name', value: 'language' } },
          { kind: 'Field', name: { kind: 'Name', value: 'contentPolicyPolicyId' } },
          {
            kind: 'FragmentSpread',
            name: { kind: 'Name', value: 'Common_ContentProviderFragment' },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'YICourse_ContentFragment' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'Content' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          { kind: 'Field', name: { kind: 'Name', value: 'contentId' } },
          { kind: 'Field', name: { kind: 'Name', value: 'contentType' } },
          { kind: 'Field', name: { kind: 'Name', value: 'published' } },
          { kind: 'Field', name: { kind: 'Name', value: 'publishedAtDate' } },
          { kind: 'Field', name: { kind: 'Name', value: 'createdAt' } },
          { kind: 'Field', name: { kind: 'Name', value: 'updatedAt' } },
          { kind: 'Field', name: { kind: 'Name', value: 'title' } },
          { kind: 'Field', name: { kind: 'Name', value: 'path' } },
          { kind: 'Field', name: { kind: 'Name', value: 'shortDescription' } },
          { kind: 'Field', name: { kind: 'Name', value: 'description' } },
          { kind: 'Field', name: { kind: 'Name', value: 'language' } },
          { kind: 'Field', name: { kind: 'Name', value: 'seoDescription' } },
          { kind: 'Field', name: { kind: 'Name', value: 'seoTitle' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'contentProvider' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'provider' } },
                { kind: 'Field', name: { kind: 'Name', value: 'providerKey' } },
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'Content_ProviderCommonFragment' },
                },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'contentPolicy' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'policyId' } },
                { kind: 'Field', name: { kind: 'Name', value: 'name' } },
              ],
            },
          },
          { kind: 'Field', name: { kind: 'Name', value: 'descriptionFormat' } },
          { kind: 'Field', name: { kind: 'Name', value: 'shortDescriptionFormat' } },
          { kind: 'Field', name: { kind: 'Name', value: 'displayType' } },
          { kind: 'Field', name: { kind: 'Name', value: 'featureMediaId' } },
          { kind: 'Field', name: { kind: 'Name', value: 'primaryLanguage' } },
          { kind: 'Field', name: { kind: 'Name', value: 'productType' } },
          { kind: 'Field', name: { kind: 'Name', value: 'seoDescription' } },
          { kind: 'Field', name: { kind: 'Name', value: 'seoTitle' } },
          {
            kind: 'Field',
            alias: { kind: 'Name', value: 'yiContentType' },
            name: { kind: 'Name', value: 'contentReferencesFrom' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'types' },
                value: { kind: 'StringValue', value: 'yi-content-type', block: false },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'ContentDetails_Tag_ContentReferenceFragment' },
                },
              ],
            },
          },
          {
            kind: 'Field',
            alias: { kind: 'Name', value: 'yiTags' },
            name: { kind: 'Name', value: 'contentReferencesFrom' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'types' },
                value: { kind: 'StringValue', value: 'yi-tag', block: false },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'ContentDetails_Tag_ContentReferenceFragment' },
                },
              ],
            },
          },
          {
            kind: 'Field',
            alias: { kind: 'Name', value: 'yiYogaTeacher' },
            name: { kind: 'Name', value: 'contentReferencesFrom' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'types' },
                value: { kind: 'StringValue', value: 'yi-yoga-teacher', block: false },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'ContentDetails_Person_ContentReferenceFragment' },
                },
              ],
            },
          },
          {
            kind: 'Field',
            alias: { kind: 'Name', value: 'yiActionType' },
            name: { kind: 'Name', value: 'references' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'types' },
                value: { kind: 'StringValue', value: 'yi-action-type', block: false },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'ContentDetails_Person_ContentReferenceFragment' },
                },
              ],
            },
          },
          {
            kind: 'Field',
            alias: { kind: 'Name', value: 'yiCourseModules' },
            name: { kind: 'Name', value: 'contentReferencesFrom' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'types' },
                value: {
                  kind: 'ListValue',
                  values: [
                    { kind: 'StringValue', value: 'yi-course-module', block: false },
                    { kind: 'StringValue', value: 'yi-course-module-group', block: false },
                  ],
                },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'YICourse_ModulesContentReferenceFragment' },
                },
              ],
            },
          },
          {
            kind: 'Field',
            alias: { kind: 'Name', value: 'yiCourseSalesPages' },
            name: { kind: 'Name', value: 'contentReferencesTo' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'types' },
                value: { kind: 'StringValue', value: 'yi-course', block: false },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'contentFrom' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'contentType' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'contentId' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'title' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'published' } },
                    ],
                  },
                },
              ],
            },
          },
          {
            kind: 'FragmentSpread',
            name: { kind: 'Name', value: 'Content_ProviderMetadataFragment' },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  Mutation_YiCourse_ContentUpdateMutation,
  Mutation_YiCourse_ContentUpdateMutationVariables
>
export const Mutation_YiCourseModule_ContentUpdateDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'mutation',
      name: { kind: 'Name', value: 'Mutation_YICourseModule_ContentUpdate' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'content' } },
          type: {
            kind: 'NonNullType',
            type: { kind: 'NamedType', name: { kind: 'Name', value: 'ContentInput' } },
          },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'contentUpdate' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'content' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'content' } },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'content' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {
                        kind: 'FragmentSpread',
                        name: { kind: 'Name', value: 'YICourseModule_ContentFragment' },
                      },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'Common_MediaFragment' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'Media' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'mediaId' } },
          { kind: 'Field', name: { kind: 'Name', value: 'contentId' } },
          { kind: 'Field', name: { kind: 'Name', value: 'mediaMaestroTitleCode' } },
          { kind: 'Field', name: { kind: 'Name', value: 'policyId' } },
          { kind: 'Field', name: { kind: 'Name', value: 'updatedAt' } },
          { kind: 'Field', name: { kind: 'Name', value: 'duration' } },
          { kind: 'Field', name: { kind: 'Name', value: 'isPublished' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'mediaAssets' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                { kind: 'Field', name: { kind: 'Name', value: 'providerKey' } },
              ],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'ContentFeatureMediaFragment' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'Content' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'contentPolicyPolicyId' } },
          { kind: 'Field', name: { kind: 'Name', value: 'featureMediaId' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'featureMedia' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'FragmentSpread', name: { kind: 'Name', value: 'Common_MediaFragment' } },
              ],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'ContentDetails_Tag_ContentReferenceFragment' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'ContentReference' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          { kind: 'Field', name: { kind: 'Name', value: 'sortKey' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'contentReferenceType' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [{ kind: 'Field', name: { kind: 'Name', value: 'type' } }],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'contentTo' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'language' },
                value: {
                  kind: 'ListValue',
                  values: [
                    { kind: 'StringValue', value: 'en', block: false },
                    { kind: 'StringValue', value: '_primary', block: false },
                  ],
                },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                { kind: 'Field', name: { kind: 'Name', value: 'titleGroupId' } },
                { kind: 'Field', name: { kind: 'Name', value: 'title' } },
                { kind: 'Field', name: { kind: 'Name', value: 'contentId' } },
                { kind: 'Field', name: { kind: 'Name', value: 'contentType' } },
                { kind: 'Field', name: { kind: 'Name', value: 'published' } },
              ],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'ContentDetails_ContentAssetReferenceFragment' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'ContentAssetReference' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'asset' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                { kind: 'Field', name: { kind: 'Name', value: 'mimeType' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'contentAssetReference' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [{ kind: 'Field', name: { kind: 'Name', value: 'assetsId' } }],
                  },
                },
                { kind: 'Field', name: { kind: 'Name', value: 'fileSize' } },
                { kind: 'Field', name: { kind: 'Name', value: 'originalFileName' } },
                { kind: 'Field', name: { kind: 'Name', value: 'renderUrl' } },
              ],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'YICourseModuleDownload_ContentFragment' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'Content' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            alias: { kind: 'Name', value: 'yiCourseModuleDownload' },
            name: { kind: 'Name', value: 'contentAssetReferences' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'contentAssetReferences' },
                value: {
                  kind: 'ObjectValue',
                  fields: [
                    {
                      kind: 'ObjectField',
                      name: { kind: 'Name', value: 'type' },
                      value: {
                        kind: 'StringValue',
                        value: 'yi-course-module-download',
                        block: false,
                      },
                    },
                  ],
                },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'ContentDetails_ContentAssetReferenceFragment' },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'Content_ProviderCommonFragment' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'ContentProvider' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [{ kind: 'Field', name: { kind: 'Name', value: 'contentId' } }],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'Content_ProviderMetadataFragment' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'Content' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            alias: { kind: 'Name', value: 'providerMetadata' },
            name: { kind: 'Name', value: 'contentProvider' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'metadata' } },
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'Content_ProviderCommonFragment' },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'YICourseModule_ContentFragment' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'Content' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          { kind: 'Field', name: { kind: 'Name', value: 'title' } },
          { kind: 'Field', name: { kind: 'Name', value: 'contentType' } },
          { kind: 'Field', name: { kind: 'Name', value: 'contentId' } },
          { kind: 'Field', name: { kind: 'Name', value: 'description' } },
          { kind: 'Field', name: { kind: 'Name', value: 'descriptionFormat' } },
          { kind: 'Field', name: { kind: 'Name', value: 'published' } },
          { kind: 'Field', name: { kind: 'Name', value: 'publishedAtDate' } },
          { kind: 'Field', name: { kind: 'Name', value: 'primaryLanguage' } },
          { kind: 'Field', name: { kind: 'Name', value: 'language' } },
          { kind: 'Field', name: { kind: 'Name', value: 'shortDescription' } },
          { kind: 'Field', name: { kind: 'Name', value: 'shortDescriptionFormat' } },
          { kind: 'Field', name: { kind: 'Name', value: 'path' } },
          { kind: 'FragmentSpread', name: { kind: 'Name', value: 'ContentFeatureMediaFragment' } },
          {
            kind: 'Field',
            alias: { kind: 'Name', value: 'yiContentType' },
            name: { kind: 'Name', value: 'contentReferencesFrom' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'types' },
                value: { kind: 'StringValue', value: 'yi-content-type', block: false },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'ContentDetails_Tag_ContentReferenceFragment' },
                },
              ],
            },
          },
          {
            kind: 'Field',
            alias: { kind: 'Name', value: 'yiCourseModuleType' },
            name: { kind: 'Name', value: 'contentReferencesFrom' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'types' },
                value: { kind: 'StringValue', value: 'yi-course-module-type', block: false },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'ContentDetails_Tag_ContentReferenceFragment' },
                },
              ],
            },
          },
          {
            kind: 'Field',
            alias: { kind: 'Name', value: 'yiConsumptionType' },
            name: { kind: 'Name', value: 'contentReferencesFrom' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'types' },
                value: { kind: 'StringValue', value: 'yi-consumption-type', block: false },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'ContentDetails_Tag_ContentReferenceFragment' },
                },
              ],
            },
          },
          {
            kind: 'Field',
            alias: { kind: 'Name', value: 'yiYogaStyles' },
            name: { kind: 'Name', value: 'contentReferencesFrom' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'types' },
                value: { kind: 'StringValue', value: 'yi-yoga-style', block: false },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'ContentDetails_Tag_ContentReferenceFragment' },
                },
              ],
            },
          },
          {
            kind: 'FragmentSpread',
            name: { kind: 'Name', value: 'YICourseModuleDownload_ContentFragment' },
          },
          {
            kind: 'FragmentSpread',
            name: { kind: 'Name', value: 'Content_ProviderMetadataFragment' },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  Mutation_YiCourseModule_ContentUpdateMutation,
  Mutation_YiCourseModule_ContentUpdateMutationVariables
>
export const YiCourseModuleDownloadDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'YICourseModuleDownload' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'id' } },
          type: {
            kind: 'NonNullType',
            type: { kind: 'NamedType', name: { kind: 'Name', value: 'ID' } },
          },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'contentList' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'where' },
                value: {
                  kind: 'ObjectValue',
                  fields: [
                    {
                      kind: 'ObjectField',
                      name: { kind: 'Name', value: 'id' },
                      value: {
                        kind: 'ObjectValue',
                        fields: [
                          {
                            kind: 'ObjectField',
                            name: { kind: 'Name', value: 'eq' },
                            value: { kind: 'Variable', name: { kind: 'Name', value: 'id' } },
                          },
                        ],
                      },
                    },
                  ],
                },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'content' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                      {
                        kind: 'FragmentSpread',
                        name: { kind: 'Name', value: 'YICourseModuleDownload_ContentFragment' },
                      },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'ContentDetails_ContentAssetReferenceFragment' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'ContentAssetReference' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'asset' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                { kind: 'Field', name: { kind: 'Name', value: 'mimeType' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'contentAssetReference' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [{ kind: 'Field', name: { kind: 'Name', value: 'assetsId' } }],
                  },
                },
                { kind: 'Field', name: { kind: 'Name', value: 'fileSize' } },
                { kind: 'Field', name: { kind: 'Name', value: 'originalFileName' } },
                { kind: 'Field', name: { kind: 'Name', value: 'renderUrl' } },
              ],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'YICourseModuleDownload_ContentFragment' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'Content' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            alias: { kind: 'Name', value: 'yiCourseModuleDownload' },
            name: { kind: 'Name', value: 'contentAssetReferences' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'contentAssetReferences' },
                value: {
                  kind: 'ObjectValue',
                  fields: [
                    {
                      kind: 'ObjectField',
                      name: { kind: 'Name', value: 'type' },
                      value: {
                        kind: 'StringValue',
                        value: 'yi-course-module-download',
                        block: false,
                      },
                    },
                  ],
                },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'ContentDetails_ContentAssetReferenceFragment' },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<YiCourseModuleDownloadQuery, YiCourseModuleDownloadQueryVariables>
export const Mutation_YiCourseSales_ContentUpdateDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'mutation',
      name: { kind: 'Name', value: 'Mutation_YICourseSales_ContentUpdate' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'content' } },
          type: {
            kind: 'NonNullType',
            type: { kind: 'NamedType', name: { kind: 'Name', value: 'ContentInput' } },
          },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'generatePath' } },
          type: { kind: 'NamedType', name: { kind: 'Name', value: 'Boolean' } },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'contentUpdate' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'content' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'content' } },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'generatePath' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'generatePath' } },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'content' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {
                        kind: 'FragmentSpread',
                        name: { kind: 'Name', value: 'YICourseSales_ContentFragment' },
                      },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'Common_MediaFragment' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'Media' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'mediaId' } },
          { kind: 'Field', name: { kind: 'Name', value: 'contentId' } },
          { kind: 'Field', name: { kind: 'Name', value: 'mediaMaestroTitleCode' } },
          { kind: 'Field', name: { kind: 'Name', value: 'policyId' } },
          { kind: 'Field', name: { kind: 'Name', value: 'updatedAt' } },
          { kind: 'Field', name: { kind: 'Name', value: 'duration' } },
          { kind: 'Field', name: { kind: 'Name', value: 'isPublished' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'mediaAssets' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                { kind: 'Field', name: { kind: 'Name', value: 'providerKey' } },
              ],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'ContentFeatureMediaFragment' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'Content' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'contentPolicyPolicyId' } },
          { kind: 'Field', name: { kind: 'Name', value: 'featureMediaId' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'featureMedia' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'FragmentSpread', name: { kind: 'Name', value: 'Common_MediaFragment' } },
              ],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'ContentDetails_Tag_ContentReferenceFragment' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'ContentReference' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          { kind: 'Field', name: { kind: 'Name', value: 'sortKey' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'contentReferenceType' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [{ kind: 'Field', name: { kind: 'Name', value: 'type' } }],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'contentTo' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'language' },
                value: {
                  kind: 'ListValue',
                  values: [
                    { kind: 'StringValue', value: 'en', block: false },
                    { kind: 'StringValue', value: '_primary', block: false },
                  ],
                },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                { kind: 'Field', name: { kind: 'Name', value: 'titleGroupId' } },
                { kind: 'Field', name: { kind: 'Name', value: 'title' } },
                { kind: 'Field', name: { kind: 'Name', value: 'contentId' } },
                { kind: 'Field', name: { kind: 'Name', value: 'contentType' } },
                { kind: 'Field', name: { kind: 'Name', value: 'published' } },
              ],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'Content_ProviderCommonFragment' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'ContentProvider' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [{ kind: 'Field', name: { kind: 'Name', value: 'contentId' } }],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'Common_ContentProviderFragment' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'Content' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'contentProvider' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'provider' } },
                { kind: 'Field', name: { kind: 'Name', value: 'providerKey' } },
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'Content_ProviderCommonFragment' },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'Content_ProviderMetadataFragment' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'Content' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            alias: { kind: 'Name', value: 'providerMetadata' },
            name: { kind: 'Name', value: 'contentProvider' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'metadata' } },
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'Content_ProviderCommonFragment' },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'YICourseSales_ContentFragment' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'Content' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'contentPolicyPolicyId' } },
          { kind: 'Field', name: { kind: 'Name', value: 'description' } },
          { kind: 'Field', name: { kind: 'Name', value: 'descriptionFormat' } },
          { kind: 'Field', name: { kind: 'Name', value: 'path' } },
          { kind: 'Field', name: { kind: 'Name', value: 'primaryLanguage' } },
          { kind: 'Field', name: { kind: 'Name', value: 'published' } },
          { kind: 'Field', name: { kind: 'Name', value: 'publishedAtDate' } },
          { kind: 'FragmentSpread', name: { kind: 'Name', value: 'ContentFeatureMediaFragment' } },
          {
            kind: 'Field',
            alias: { kind: 'Name', value: 'yiContentType' },
            name: { kind: 'Name', value: 'contentReferencesFrom' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'types' },
                value: { kind: 'StringValue', value: 'yi-content-type', block: false },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'ContentDetails_Tag_ContentReferenceFragment' },
                },
              ],
            },
          },
          {
            kind: 'Field',
            alias: { kind: 'Name', value: 'yiCourses' },
            name: { kind: 'Name', value: 'contentReferencesFrom' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'types' },
                value: { kind: 'StringValue', value: 'yi-course', block: false },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'contentTo' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'contentType' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'contentId' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'title' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'published' } },
                      {
                        kind: 'FragmentSpread',
                        name: { kind: 'Name', value: 'Common_ContentProviderFragment' },
                      },
                    ],
                  },
                },
              ],
            },
          },
          {
            kind: 'FragmentSpread',
            name: { kind: 'Name', value: 'Content_ProviderMetadataFragment' },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  Mutation_YiCourseSales_ContentUpdateMutation,
  Mutation_YiCourseSales_ContentUpdateMutationVariables
>
export const Mutation_YiCourseSection_ContentUpdateDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'mutation',
      name: { kind: 'Name', value: 'Mutation_YICourseSection_ContentUpdate' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'content' } },
          type: {
            kind: 'NonNullType',
            type: { kind: 'NamedType', name: { kind: 'Name', value: 'ContentInput' } },
          },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'contentUpdate' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'content' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'content' } },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'content' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {
                        kind: 'FragmentSpread',
                        name: { kind: 'Name', value: 'YICourseSection_ContentFragment' },
                      },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'ContentDetails_Tag_ContentReferenceFragment' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'ContentReference' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          { kind: 'Field', name: { kind: 'Name', value: 'sortKey' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'contentReferenceType' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [{ kind: 'Field', name: { kind: 'Name', value: 'type' } }],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'contentTo' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'language' },
                value: {
                  kind: 'ListValue',
                  values: [
                    { kind: 'StringValue', value: 'en', block: false },
                    { kind: 'StringValue', value: '_primary', block: false },
                  ],
                },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                { kind: 'Field', name: { kind: 'Name', value: 'titleGroupId' } },
                { kind: 'Field', name: { kind: 'Name', value: 'title' } },
                { kind: 'Field', name: { kind: 'Name', value: 'contentId' } },
                { kind: 'Field', name: { kind: 'Name', value: 'contentType' } },
                { kind: 'Field', name: { kind: 'Name', value: 'published' } },
              ],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'Content_ProviderCommonFragment' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'ContentProvider' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [{ kind: 'Field', name: { kind: 'Name', value: 'contentId' } }],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'Content_ProviderMetadataFragment' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'Content' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            alias: { kind: 'Name', value: 'providerMetadata' },
            name: { kind: 'Name', value: 'contentProvider' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'metadata' } },
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'Content_ProviderCommonFragment' },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'YICourseSection_ContentFragment' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'Content' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          { kind: 'Field', name: { kind: 'Name', value: 'title' } },
          { kind: 'Field', name: { kind: 'Name', value: 'contentType' } },
          { kind: 'Field', name: { kind: 'Name', value: 'contentId' } },
          { kind: 'Field', name: { kind: 'Name', value: 'published' } },
          {
            kind: 'Field',
            alias: { kind: 'Name', value: 'yiContentType' },
            name: { kind: 'Name', value: 'contentReferencesFrom' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'types' },
                value: { kind: 'StringValue', value: 'yi-content-type', block: false },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'ContentDetails_Tag_ContentReferenceFragment' },
                },
              ],
            },
          },
          {
            kind: 'FragmentSpread',
            name: { kind: 'Name', value: 'Content_ProviderMetadataFragment' },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  Mutation_YiCourseSection_ContentUpdateMutation,
  Mutation_YiCourseSection_ContentUpdateMutationVariables
>
export const Mutation_YiHomepageHero_ContentUpdateDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'mutation',
      name: { kind: 'Name', value: 'Mutation_YIHomepageHero_ContentUpdate' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'content' } },
          type: {
            kind: 'NonNullType',
            type: { kind: 'NamedType', name: { kind: 'Name', value: 'ContentInput' } },
          },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'generatePath' } },
          type: { kind: 'NamedType', name: { kind: 'Name', value: 'Boolean' } },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'contentUpdate' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'content' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'content' } },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'generatePath' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'generatePath' } },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'content' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {
                        kind: 'FragmentSpread',
                        name: { kind: 'Name', value: 'YIHomepageHero_ContentFragment' },
                      },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'ContentDetails_Tag_ContentReferenceFragment' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'ContentReference' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          { kind: 'Field', name: { kind: 'Name', value: 'sortKey' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'contentReferenceType' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [{ kind: 'Field', name: { kind: 'Name', value: 'type' } }],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'contentTo' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'language' },
                value: {
                  kind: 'ListValue',
                  values: [
                    { kind: 'StringValue', value: 'en', block: false },
                    { kind: 'StringValue', value: '_primary', block: false },
                  ],
                },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                { kind: 'Field', name: { kind: 'Name', value: 'titleGroupId' } },
                { kind: 'Field', name: { kind: 'Name', value: 'title' } },
                { kind: 'Field', name: { kind: 'Name', value: 'contentId' } },
                { kind: 'Field', name: { kind: 'Name', value: 'contentType' } },
                { kind: 'Field', name: { kind: 'Name', value: 'published' } },
              ],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'Content_ProviderCommonFragment' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'ContentProvider' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [{ kind: 'Field', name: { kind: 'Name', value: 'contentId' } }],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'Content_ProviderMetadataFragment' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'Content' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            alias: { kind: 'Name', value: 'providerMetadata' },
            name: { kind: 'Name', value: 'contentProvider' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'metadata' } },
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'Content_ProviderCommonFragment' },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'YIHomepageHero_ContentFragment' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'Content' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          { kind: 'Field', name: { kind: 'Name', value: 'contentId' } },
          { kind: 'Field', name: { kind: 'Name', value: 'contentType' } },
          { kind: 'Field', name: { kind: 'Name', value: 'language' } },
          { kind: 'Field', name: { kind: 'Name', value: 'primaryLanguage' } },
          { kind: 'Field', name: { kind: 'Name', value: 'published' } },
          { kind: 'Field', name: { kind: 'Name', value: 'publishedAtDate' } },
          { kind: 'Field', name: { kind: 'Name', value: 'title' } },
          {
            kind: 'Field',
            alias: { kind: 'Name', value: 'yiContentType' },
            name: { kind: 'Name', value: 'contentReferencesFrom' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'types' },
                value: { kind: 'StringValue', value: 'yi-content-type', block: false },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'ContentDetails_Tag_ContentReferenceFragment' },
                },
              ],
            },
          },
          {
            kind: 'Field',
            alias: { kind: 'Name', value: 'yiHomepageHeroContent' },
            name: { kind: 'Name', value: 'contentReferencesFrom' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'types' },
                value: { kind: 'StringValue', value: 'yi-homepage-hero-content', block: false },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'contentReferenceType' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [{ kind: 'Field', name: { kind: 'Name', value: 'type' } }],
                  },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'contentTo' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'contentType' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'contentId' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'title' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'published' } },
                      {
                        kind: 'Field',
                        alias: { kind: 'Name', value: 'yiContentType' },
                        name: { kind: 'Name', value: 'contentReferencesFrom' },
                        arguments: [
                          {
                            kind: 'Argument',
                            name: { kind: 'Name', value: 'types' },
                            value: { kind: 'StringValue', value: 'yi-content-type', block: false },
                          },
                        ],
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            {
                              kind: 'FragmentSpread',
                              name: {
                                kind: 'Name',
                                value: 'ContentDetails_Tag_ContentReferenceFragment',
                              },
                            },
                          ],
                        },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'contentProvider' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            { kind: 'Field', name: { kind: 'Name', value: 'provider' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'providerKey' } },
                            {
                              kind: 'FragmentSpread',
                              name: { kind: 'Name', value: 'Content_ProviderCommonFragment' },
                            },
                          ],
                        },
                      },
                    ],
                  },
                },
              ],
            },
          },
          {
            kind: 'FragmentSpread',
            name: { kind: 'Name', value: 'Content_ProviderMetadataFragment' },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  Mutation_YiHomepageHero_ContentUpdateMutation,
  Mutation_YiHomepageHero_ContentUpdateMutationVariables
>
export const Mutation_YiMeditation_ContentUpdateDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'mutation',
      name: { kind: 'Name', value: 'Mutation_YIMeditation_ContentUpdate' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'content' } },
          type: {
            kind: 'NonNullType',
            type: { kind: 'NamedType', name: { kind: 'Name', value: 'ContentInput' } },
          },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'generatePath' } },
          type: { kind: 'NamedType', name: { kind: 'Name', value: 'Boolean' } },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'contentUpdate' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'content' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'content' } },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'generatePath' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'generatePath' } },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'content' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {
                        kind: 'FragmentSpread',
                        name: { kind: 'Name', value: 'Common_ContentFragment' },
                      },
                      {
                        kind: 'FragmentSpread',
                        name: { kind: 'Name', value: 'YIMeditation_ContentFragment' },
                      },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'Content_ProviderCommonFragment' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'ContentProvider' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [{ kind: 'Field', name: { kind: 'Name', value: 'contentId' } }],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'Common_ContentProviderFragment' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'Content' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'contentProvider' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'provider' } },
                { kind: 'Field', name: { kind: 'Name', value: 'providerKey' } },
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'Content_ProviderCommonFragment' },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'Common_MediaFragment' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'Media' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'mediaId' } },
          { kind: 'Field', name: { kind: 'Name', value: 'contentId' } },
          { kind: 'Field', name: { kind: 'Name', value: 'mediaMaestroTitleCode' } },
          { kind: 'Field', name: { kind: 'Name', value: 'policyId' } },
          { kind: 'Field', name: { kind: 'Name', value: 'updatedAt' } },
          { kind: 'Field', name: { kind: 'Name', value: 'duration' } },
          { kind: 'Field', name: { kind: 'Name', value: 'isPublished' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'mediaAssets' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                { kind: 'Field', name: { kind: 'Name', value: 'providerKey' } },
              ],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'ContentFeatureMediaFragment' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'Content' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'contentPolicyPolicyId' } },
          { kind: 'Field', name: { kind: 'Name', value: 'featureMediaId' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'featureMedia' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'FragmentSpread', name: { kind: 'Name', value: 'Common_MediaFragment' } },
              ],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'ContentDetails_Tag_ContentReferenceFragment' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'ContentReference' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          { kind: 'Field', name: { kind: 'Name', value: 'sortKey' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'contentReferenceType' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [{ kind: 'Field', name: { kind: 'Name', value: 'type' } }],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'contentTo' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'language' },
                value: {
                  kind: 'ListValue',
                  values: [
                    { kind: 'StringValue', value: 'en', block: false },
                    { kind: 'StringValue', value: '_primary', block: false },
                  ],
                },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                { kind: 'Field', name: { kind: 'Name', value: 'titleGroupId' } },
                { kind: 'Field', name: { kind: 'Name', value: 'title' } },
                { kind: 'Field', name: { kind: 'Name', value: 'contentId' } },
                { kind: 'Field', name: { kind: 'Name', value: 'contentType' } },
                { kind: 'Field', name: { kind: 'Name', value: 'published' } },
              ],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'ContentDetails_Person_ContentFragment' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'Content' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          { kind: 'Field', name: { kind: 'Name', value: 'title' } },
          { kind: 'Field', name: { kind: 'Name', value: 'language' } },
          { kind: 'Field', name: { kind: 'Name', value: 'contentType' } },
          { kind: 'Field', name: { kind: 'Name', value: 'contentId' } },
          { kind: 'Field', name: { kind: 'Name', value: 'published' } },
          {
            kind: 'Field',
            alias: { kind: 'Name', value: 'avatar' },
            name: { kind: 'Name', value: 'imageContentRelationships' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                { kind: 'Field', name: { kind: 'Name', value: 'type' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'image' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'url' } },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'ContentDetails_Person_ContentReferenceFragment' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'ContentReference' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          { kind: 'Field', name: { kind: 'Name', value: 'sortKey' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'contentReferenceType' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                { kind: 'Field', name: { kind: 'Name', value: 'type' } },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'contentTo' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'ContentDetails_Person_ContentFragment' },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'Common_ContentFragment' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'Content' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          { kind: 'Field', name: { kind: 'Name', value: 'contentId' } },
          { kind: 'Field', name: { kind: 'Name', value: 'contentType' } },
          { kind: 'Field', name: { kind: 'Name', value: 'published' } },
          { kind: 'Field', name: { kind: 'Name', value: 'publishedAtDate' } },
          { kind: 'Field', name: { kind: 'Name', value: 'createdAt' } },
          { kind: 'Field', name: { kind: 'Name', value: 'updatedAt' } },
          { kind: 'Field', name: { kind: 'Name', value: 'title' } },
          { kind: 'Field', name: { kind: 'Name', value: 'path' } },
          { kind: 'Field', name: { kind: 'Name', value: 'shortDescription' } },
          { kind: 'Field', name: { kind: 'Name', value: 'description' } },
          { kind: 'Field', name: { kind: 'Name', value: 'language' } },
          { kind: 'Field', name: { kind: 'Name', value: 'contentPolicyPolicyId' } },
          {
            kind: 'FragmentSpread',
            name: { kind: 'Name', value: 'Common_ContentProviderFragment' },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'YIMeditation_ContentFragment' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'Content' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'descriptionFormat' } },
          { kind: 'Field', name: { kind: 'Name', value: 'shortDescriptionFormat' } },
          { kind: 'Field', name: { kind: 'Name', value: 'displayType' } },
          { kind: 'Field', name: { kind: 'Name', value: 'primaryLanguage' } },
          { kind: 'Field', name: { kind: 'Name', value: 'productType' } },
          { kind: 'Field', name: { kind: 'Name', value: 'seoDescription' } },
          { kind: 'Field', name: { kind: 'Name', value: 'seoTitle' } },
          { kind: 'FragmentSpread', name: { kind: 'Name', value: 'ContentFeatureMediaFragment' } },
          {
            kind: 'Field',
            alias: { kind: 'Name', value: 'yiContentType' },
            name: { kind: 'Name', value: 'contentReferencesFrom' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'types' },
                value: { kind: 'StringValue', value: 'yi-content-type', block: false },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'ContentDetails_Tag_ContentReferenceFragment' },
                },
              ],
            },
          },
          {
            kind: 'Field',
            alias: { kind: 'Name', value: 'yiTags' },
            name: { kind: 'Name', value: 'contentReferencesFrom' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'types' },
                value: { kind: 'StringValue', value: 'yi-tag', block: false },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'ContentDetails_Tag_ContentReferenceFragment' },
                },
              ],
            },
          },
          {
            kind: 'Field',
            alias: { kind: 'Name', value: 'yiYogaStyle' },
            name: { kind: 'Name', value: 'contentReferencesFrom' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'types' },
                value: { kind: 'StringValue', value: 'yi-yoga-style', block: false },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'ContentDetails_Tag_ContentReferenceFragment' },
                },
              ],
            },
          },
          {
            kind: 'Field',
            alias: { kind: 'Name', value: 'yiYogaTeacher' },
            name: { kind: 'Name', value: 'contentReferencesFrom' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'types' },
                value: { kind: 'StringValue', value: 'yi-yoga-teacher', block: false },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'ContentDetails_Person_ContentReferenceFragment' },
                },
              ],
            },
          },
          {
            kind: 'Field',
            alias: { kind: 'Name', value: 'yiPracticeType' },
            name: { kind: 'Name', value: 'contentReferencesFrom' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'types' },
                value: { kind: 'StringValue', value: 'yi-practice-type', block: false },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'ContentDetails_Person_ContentReferenceFragment' },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  Mutation_YiMeditation_ContentUpdateMutation,
  Mutation_YiMeditation_ContentUpdateMutationVariables
>
export const Mutation_YiMemberPromo_ContentUpdateDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'mutation',
      name: { kind: 'Name', value: 'Mutation_YIMemberPromo_ContentUpdate' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'content' } },
          type: {
            kind: 'NonNullType',
            type: { kind: 'NamedType', name: { kind: 'Name', value: 'ContentInput' } },
          },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'generatePath' } },
          type: { kind: 'NamedType', name: { kind: 'Name', value: 'Boolean' } },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'contentUpdate' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'content' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'content' } },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'generatePath' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'generatePath' } },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'content' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {
                        kind: 'FragmentSpread',
                        name: { kind: 'Name', value: 'YIMemberPromo_ContentFragment' },
                      },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'Common_MediaFragment' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'Media' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'mediaId' } },
          { kind: 'Field', name: { kind: 'Name', value: 'contentId' } },
          { kind: 'Field', name: { kind: 'Name', value: 'mediaMaestroTitleCode' } },
          { kind: 'Field', name: { kind: 'Name', value: 'policyId' } },
          { kind: 'Field', name: { kind: 'Name', value: 'updatedAt' } },
          { kind: 'Field', name: { kind: 'Name', value: 'duration' } },
          { kind: 'Field', name: { kind: 'Name', value: 'isPublished' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'mediaAssets' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                { kind: 'Field', name: { kind: 'Name', value: 'providerKey' } },
              ],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'ContentFeatureMediaFragment' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'Content' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'contentPolicyPolicyId' } },
          { kind: 'Field', name: { kind: 'Name', value: 'featureMediaId' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'featureMedia' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'FragmentSpread', name: { kind: 'Name', value: 'Common_MediaFragment' } },
              ],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'ContentDetails_Tag_ContentReferenceFragment' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'ContentReference' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          { kind: 'Field', name: { kind: 'Name', value: 'sortKey' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'contentReferenceType' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [{ kind: 'Field', name: { kind: 'Name', value: 'type' } }],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'contentTo' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'language' },
                value: {
                  kind: 'ListValue',
                  values: [
                    { kind: 'StringValue', value: 'en', block: false },
                    { kind: 'StringValue', value: '_primary', block: false },
                  ],
                },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                { kind: 'Field', name: { kind: 'Name', value: 'titleGroupId' } },
                { kind: 'Field', name: { kind: 'Name', value: 'title' } },
                { kind: 'Field', name: { kind: 'Name', value: 'contentId' } },
                { kind: 'Field', name: { kind: 'Name', value: 'contentType' } },
                { kind: 'Field', name: { kind: 'Name', value: 'published' } },
              ],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'Content_ProviderCommonFragment' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'ContentProvider' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [{ kind: 'Field', name: { kind: 'Name', value: 'contentId' } }],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'Content_ProviderMetadataFragment' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'Content' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            alias: { kind: 'Name', value: 'providerMetadata' },
            name: { kind: 'Name', value: 'contentProvider' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'metadata' } },
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'Content_ProviderCommonFragment' },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'YIMemberPromo_ContentFragment' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'Content' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'contentPolicyPolicyId' } },
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          { kind: 'Field', name: { kind: 'Name', value: 'contentId' } },
          { kind: 'Field', name: { kind: 'Name', value: 'contentType' } },
          { kind: 'Field', name: { kind: 'Name', value: 'language' } },
          { kind: 'Field', name: { kind: 'Name', value: 'description' } },
          { kind: 'Field', name: { kind: 'Name', value: 'descriptionFormat' } },
          { kind: 'Field', name: { kind: 'Name', value: 'path' } },
          { kind: 'Field', name: { kind: 'Name', value: 'primaryLanguage' } },
          { kind: 'Field', name: { kind: 'Name', value: 'published' } },
          { kind: 'Field', name: { kind: 'Name', value: 'publishedAtDate' } },
          { kind: 'Field', name: { kind: 'Name', value: 'title' } },
          { kind: 'FragmentSpread', name: { kind: 'Name', value: 'ContentFeatureMediaFragment' } },
          {
            kind: 'Field',
            alias: { kind: 'Name', value: 'yiContentType' },
            name: { kind: 'Name', value: 'contentReferencesFrom' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'types' },
                value: { kind: 'StringValue', value: 'yi-content-type', block: false },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'ContentDetails_Tag_ContentReferenceFragment' },
                },
              ],
            },
          },
          {
            kind: 'Field',
            alias: { kind: 'Name', value: 'yiGiveAwayCourses' },
            name: { kind: 'Name', value: 'contentReferencesFrom' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'types' },
                value: { kind: 'StringValue', value: 'yi-course', block: false },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'contentTo' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'contentType' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'contentId' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'title' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'published' } },
                    ],
                  },
                },
              ],
            },
          },
          {
            kind: 'Field',
            alias: { kind: 'Name', value: 'yiPromotedContent' },
            name: { kind: 'Name', value: 'contentReferencesFrom' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'types' },
                value: { kind: 'StringValue', value: 'yi-promoted-content', block: false },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'contentTo' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'contentType' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'contentId' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'title' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'published' } },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'contentProvider' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            { kind: 'Field', name: { kind: 'Name', value: 'provider' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'providerKey' } },
                            {
                              kind: 'FragmentSpread',
                              name: { kind: 'Name', value: 'Content_ProviderCommonFragment' },
                            },
                          ],
                        },
                      },
                      {
                        kind: 'Field',
                        alias: { kind: 'Name', value: 'yiContentType' },
                        name: { kind: 'Name', value: 'contentReferencesFrom' },
                        arguments: [
                          {
                            kind: 'Argument',
                            name: { kind: 'Name', value: 'types' },
                            value: { kind: 'StringValue', value: 'yi-content-type', block: false },
                          },
                        ],
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            {
                              kind: 'FragmentSpread',
                              name: {
                                kind: 'Name',
                                value: 'ContentDetails_Tag_ContentReferenceFragment',
                              },
                            },
                          ],
                        },
                      },
                    ],
                  },
                },
              ],
            },
          },
          {
            kind: 'FragmentSpread',
            name: { kind: 'Name', value: 'Content_ProviderMetadataFragment' },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  Mutation_YiMemberPromo_ContentUpdateMutation,
  Mutation_YiMemberPromo_ContentUpdateMutationVariables
>
export const Mutation_YiPose_ContentUpdateDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'mutation',
      name: { kind: 'Name', value: 'Mutation_YIPose_ContentUpdate' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'content' } },
          type: {
            kind: 'NonNullType',
            type: { kind: 'NamedType', name: { kind: 'Name', value: 'ContentInput' } },
          },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'generatePath' } },
          type: { kind: 'NamedType', name: { kind: 'Name', value: 'Boolean' } },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'contentUpdate' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'content' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'content' } },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'generatePath' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'generatePath' } },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'content' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {
                        kind: 'FragmentSpread',
                        name: { kind: 'Name', value: 'Common_ContentFragment' },
                      },
                      {
                        kind: 'FragmentSpread',
                        name: { kind: 'Name', value: 'YIPose_ContentFragment' },
                      },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'Content_ProviderCommonFragment' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'ContentProvider' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [{ kind: 'Field', name: { kind: 'Name', value: 'contentId' } }],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'Common_ContentProviderFragment' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'Content' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'contentProvider' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'provider' } },
                { kind: 'Field', name: { kind: 'Name', value: 'providerKey' } },
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'Content_ProviderCommonFragment' },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'ContentDetails_Tag_ContentReferenceFragment' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'ContentReference' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          { kind: 'Field', name: { kind: 'Name', value: 'sortKey' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'contentReferenceType' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [{ kind: 'Field', name: { kind: 'Name', value: 'type' } }],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'contentTo' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'language' },
                value: {
                  kind: 'ListValue',
                  values: [
                    { kind: 'StringValue', value: 'en', block: false },
                    { kind: 'StringValue', value: '_primary', block: false },
                  ],
                },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                { kind: 'Field', name: { kind: 'Name', value: 'titleGroupId' } },
                { kind: 'Field', name: { kind: 'Name', value: 'title' } },
                { kind: 'Field', name: { kind: 'Name', value: 'contentId' } },
                { kind: 'Field', name: { kind: 'Name', value: 'contentType' } },
                { kind: 'Field', name: { kind: 'Name', value: 'published' } },
              ],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'Content_ProviderMetadataFragment' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'Content' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            alias: { kind: 'Name', value: 'providerMetadata' },
            name: { kind: 'Name', value: 'contentProvider' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'metadata' } },
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'Content_ProviderCommonFragment' },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'Common_ContentFragment' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'Content' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          { kind: 'Field', name: { kind: 'Name', value: 'contentId' } },
          { kind: 'Field', name: { kind: 'Name', value: 'contentType' } },
          { kind: 'Field', name: { kind: 'Name', value: 'published' } },
          { kind: 'Field', name: { kind: 'Name', value: 'publishedAtDate' } },
          { kind: 'Field', name: { kind: 'Name', value: 'createdAt' } },
          { kind: 'Field', name: { kind: 'Name', value: 'updatedAt' } },
          { kind: 'Field', name: { kind: 'Name', value: 'title' } },
          { kind: 'Field', name: { kind: 'Name', value: 'path' } },
          { kind: 'Field', name: { kind: 'Name', value: 'shortDescription' } },
          { kind: 'Field', name: { kind: 'Name', value: 'description' } },
          { kind: 'Field', name: { kind: 'Name', value: 'language' } },
          { kind: 'Field', name: { kind: 'Name', value: 'contentPolicyPolicyId' } },
          {
            kind: 'FragmentSpread',
            name: { kind: 'Name', value: 'Common_ContentProviderFragment' },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'YIPose_ContentFragment' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'Content' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'contentPolicyPolicyId' } },
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          { kind: 'Field', name: { kind: 'Name', value: 'contentId' } },
          { kind: 'Field', name: { kind: 'Name', value: 'contentType' } },
          { kind: 'Field', name: { kind: 'Name', value: 'language' } },
          { kind: 'Field', name: { kind: 'Name', value: 'description' } },
          { kind: 'Field', name: { kind: 'Name', value: 'descriptionFormat' } },
          { kind: 'Field', name: { kind: 'Name', value: 'shortDescription' } },
          { kind: 'Field', name: { kind: 'Name', value: 'shortDescriptionFormat' } },
          { kind: 'Field', name: { kind: 'Name', value: 'path' } },
          { kind: 'Field', name: { kind: 'Name', value: 'primaryLanguage' } },
          { kind: 'Field', name: { kind: 'Name', value: 'published' } },
          { kind: 'Field', name: { kind: 'Name', value: 'publishedAtDate' } },
          { kind: 'Field', name: { kind: 'Name', value: 'seoDescription' } },
          { kind: 'Field', name: { kind: 'Name', value: 'seoTitle' } },
          { kind: 'Field', name: { kind: 'Name', value: 'title' } },
          { kind: 'Field', name: { kind: 'Name', value: 'titleGroupId' } },
          {
            kind: 'Field',
            alias: { kind: 'Name', value: 'yiContentType' },
            name: { kind: 'Name', value: 'contentReferencesFrom' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'types' },
                value: { kind: 'StringValue', value: 'yi-content-type', block: false },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'ContentDetails_Tag_ContentReferenceFragment' },
                },
              ],
            },
          },
          {
            kind: 'Field',
            alias: { kind: 'Name', value: 'yiTags' },
            name: { kind: 'Name', value: 'contentReferencesFrom' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'types' },
                value: { kind: 'StringValue', value: 'yi-tag', block: false },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'ContentDetails_Tag_ContentReferenceFragment' },
                },
              ],
            },
          },
          {
            kind: 'Field',
            alias: { kind: 'Name', value: 'yiPosePronunciation' },
            name: { kind: 'Name', value: 'contentAssetReferences' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'contentAssetReferences' },
                value: {
                  kind: 'ListValue',
                  values: [
                    {
                      kind: 'ObjectValue',
                      fields: [
                        {
                          kind: 'ObjectField',
                          name: { kind: 'Name', value: 'type' },
                          value: {
                            kind: 'StringValue',
                            value: 'yi-pose-pronunciation',
                            block: false,
                          },
                        },
                      ],
                    },
                  ],
                },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                { kind: 'Field', name: { kind: 'Name', value: 'contentAssetReferenceTypesId' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'asset' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'renderUrl' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'originalFileName' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'uuid' } },
                    ],
                  },
                },
              ],
            },
          },
          {
            kind: 'FragmentSpread',
            name: { kind: 'Name', value: 'Content_ProviderMetadataFragment' },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  Mutation_YiPose_ContentUpdateMutation,
  Mutation_YiPose_ContentUpdateMutationVariables
>
export const SeriesEpisodeSearchContentSelectQueryDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'SeriesEpisodeSearchContentSelectQuery' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'offset' } },
          type: { kind: 'NamedType', name: { kind: 'Name', value: 'Int' } },
          defaultValue: { kind: 'IntValue', value: '0' },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'limit' } },
          type: { kind: 'NamedType', name: { kind: 'Name', value: 'Int' } },
          defaultValue: { kind: 'IntValue', value: '25' },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'where' } },
          type: { kind: 'NamedType', name: { kind: 'Name', value: 'ContentWhereInput' } },
          defaultValue: { kind: 'ObjectValue', fields: [] },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'referencesNot' } },
          type: {
            kind: 'ListType',
            type: {
              kind: 'NamedType',
              name: { kind: 'Name', value: 'ContentContentReferencesToFilterInput' },
            },
          },
          defaultValue: { kind: 'ListValue', values: [] },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'contentList' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'offset' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'offset' } },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'limit' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'limit' } },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'where' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'where' } },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'order' },
                value: {
                  kind: 'ListValue',
                  values: [
                    {
                      kind: 'ListValue',
                      values: [
                        { kind: 'StringValue', value: 'updatedAt', block: false },
                        { kind: 'StringValue', value: 'DESC', block: false },
                      ],
                    },
                  ],
                },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'referencesNot' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'referencesNot' } },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'content' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {
                        kind: 'FragmentSpread',
                        name: { kind: 'Name', value: 'YISeries_EpisodeDetailsContentFragment' },
                      },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'Content_ProviderCommonFragment' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'ContentProvider' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [{ kind: 'Field', name: { kind: 'Name', value: 'contentId' } }],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'Content_ProviderMetadataFragment' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'Content' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            alias: { kind: 'Name', value: 'providerMetadata' },
            name: { kind: 'Name', value: 'contentProvider' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'metadata' } },
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'Content_ProviderCommonFragment' },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'YISeries_EpisodeDetailsContentFragment' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'Content' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'title' } },
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          { kind: 'Field', name: { kind: 'Name', value: 'contentType' } },
          { kind: 'Field', name: { kind: 'Name', value: 'contentId' } },
          { kind: 'Field', name: { kind: 'Name', value: 'published' } },
          { kind: 'Field', name: { kind: 'Name', value: 'seasonNumber' } },
          { kind: 'Field', name: { kind: 'Name', value: 'episodeNumber' } },
          {
            kind: 'FragmentSpread',
            name: { kind: 'Name', value: 'Content_ProviderMetadataFragment' },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  SeriesEpisodeSearchContentSelectQueryQuery,
  SeriesEpisodeSearchContentSelectQueryQueryVariables
>
export const Mutation_YiSeries_ContentUpdateDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'mutation',
      name: { kind: 'Name', value: 'Mutation_YISeries_ContentUpdate' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'content' } },
          type: {
            kind: 'NonNullType',
            type: { kind: 'NamedType', name: { kind: 'Name', value: 'ContentInput' } },
          },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'generatePath' } },
          type: { kind: 'NamedType', name: { kind: 'Name', value: 'Boolean' } },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'contentUpdate' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'content' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'content' } },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'generatePath' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'generatePath' } },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'content' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {
                        kind: 'FragmentSpread',
                        name: { kind: 'Name', value: 'Common_ContentFragment' },
                      },
                      {
                        kind: 'FragmentSpread',
                        name: { kind: 'Name', value: 'YISeries_ContentFragment' },
                      },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'Content_ProviderCommonFragment' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'ContentProvider' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [{ kind: 'Field', name: { kind: 'Name', value: 'contentId' } }],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'Common_ContentProviderFragment' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'Content' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'contentProvider' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'provider' } },
                { kind: 'Field', name: { kind: 'Name', value: 'providerKey' } },
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'Content_ProviderCommonFragment' },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'Common_MediaFragment' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'Media' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'mediaId' } },
          { kind: 'Field', name: { kind: 'Name', value: 'contentId' } },
          { kind: 'Field', name: { kind: 'Name', value: 'mediaMaestroTitleCode' } },
          { kind: 'Field', name: { kind: 'Name', value: 'policyId' } },
          { kind: 'Field', name: { kind: 'Name', value: 'updatedAt' } },
          { kind: 'Field', name: { kind: 'Name', value: 'duration' } },
          { kind: 'Field', name: { kind: 'Name', value: 'isPublished' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'mediaAssets' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                { kind: 'Field', name: { kind: 'Name', value: 'providerKey' } },
              ],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'ContentPreviewMediaFragment' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'Content' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'contentPolicyPolicyId' } },
          { kind: 'Field', name: { kind: 'Name', value: 'previewMediaId' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'previewMedia' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'FragmentSpread', name: { kind: 'Name', value: 'Common_MediaFragment' } },
              ],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'ContentDetails_Tag_ContentReferenceFragment' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'ContentReference' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          { kind: 'Field', name: { kind: 'Name', value: 'sortKey' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'contentReferenceType' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [{ kind: 'Field', name: { kind: 'Name', value: 'type' } }],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'contentTo' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'language' },
                value: {
                  kind: 'ListValue',
                  values: [
                    { kind: 'StringValue', value: 'en', block: false },
                    { kind: 'StringValue', value: '_primary', block: false },
                  ],
                },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                { kind: 'Field', name: { kind: 'Name', value: 'titleGroupId' } },
                { kind: 'Field', name: { kind: 'Name', value: 'title' } },
                { kind: 'Field', name: { kind: 'Name', value: 'contentId' } },
                { kind: 'Field', name: { kind: 'Name', value: 'contentType' } },
                { kind: 'Field', name: { kind: 'Name', value: 'published' } },
              ],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'Content_ProviderMetadataFragment' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'Content' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            alias: { kind: 'Name', value: 'providerMetadata' },
            name: { kind: 'Name', value: 'contentProvider' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'metadata' } },
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'Content_ProviderCommonFragment' },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'YISeries_EpisodeDetailsContentFragment' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'Content' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'title' } },
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          { kind: 'Field', name: { kind: 'Name', value: 'contentType' } },
          { kind: 'Field', name: { kind: 'Name', value: 'contentId' } },
          { kind: 'Field', name: { kind: 'Name', value: 'published' } },
          { kind: 'Field', name: { kind: 'Name', value: 'seasonNumber' } },
          { kind: 'Field', name: { kind: 'Name', value: 'episodeNumber' } },
          {
            kind: 'FragmentSpread',
            name: { kind: 'Name', value: 'Content_ProviderMetadataFragment' },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'YISeries_EpisodeContentFragment' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'ContentReference' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          { kind: 'Field', name: { kind: 'Name', value: 'sortKey' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'contentReferenceType' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [{ kind: 'Field', name: { kind: 'Name', value: 'type' } }],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'contentTo' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'YISeries_EpisodeDetailsContentFragment' },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'Common_ContentFragment' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'Content' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          { kind: 'Field', name: { kind: 'Name', value: 'contentId' } },
          { kind: 'Field', name: { kind: 'Name', value: 'contentType' } },
          { kind: 'Field', name: { kind: 'Name', value: 'published' } },
          { kind: 'Field', name: { kind: 'Name', value: 'publishedAtDate' } },
          { kind: 'Field', name: { kind: 'Name', value: 'createdAt' } },
          { kind: 'Field', name: { kind: 'Name', value: 'updatedAt' } },
          { kind: 'Field', name: { kind: 'Name', value: 'title' } },
          { kind: 'Field', name: { kind: 'Name', value: 'path' } },
          { kind: 'Field', name: { kind: 'Name', value: 'shortDescription' } },
          { kind: 'Field', name: { kind: 'Name', value: 'description' } },
          { kind: 'Field', name: { kind: 'Name', value: 'language' } },
          { kind: 'Field', name: { kind: 'Name', value: 'contentPolicyPolicyId' } },
          {
            kind: 'FragmentSpread',
            name: { kind: 'Name', value: 'Common_ContentProviderFragment' },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'YISeries_ContentFragment' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'Content' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          { kind: 'Field', name: { kind: 'Name', value: 'contentId' } },
          { kind: 'Field', name: { kind: 'Name', value: 'contentType' } },
          { kind: 'Field', name: { kind: 'Name', value: 'published' } },
          { kind: 'Field', name: { kind: 'Name', value: 'publishedAtDate' } },
          { kind: 'Field', name: { kind: 'Name', value: 'createdAt' } },
          { kind: 'Field', name: { kind: 'Name', value: 'updatedAt' } },
          { kind: 'Field', name: { kind: 'Name', value: 'title' } },
          { kind: 'Field', name: { kind: 'Name', value: 'path' } },
          { kind: 'Field', name: { kind: 'Name', value: 'shortDescription' } },
          { kind: 'Field', name: { kind: 'Name', value: 'shortDescriptionFormat' } },
          { kind: 'Field', name: { kind: 'Name', value: 'description' } },
          { kind: 'Field', name: { kind: 'Name', value: 'descriptionFormat' } },
          { kind: 'Field', name: { kind: 'Name', value: 'productType' } },
          { kind: 'Field', name: { kind: 'Name', value: 'language' } },
          { kind: 'Field', name: { kind: 'Name', value: 'primaryLanguage' } },
          { kind: 'FragmentSpread', name: { kind: 'Name', value: 'ContentPreviewMediaFragment' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'contentProvider' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'provider' } },
                { kind: 'Field', name: { kind: 'Name', value: 'providerKey' } },
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'Content_ProviderCommonFragment' },
                },
              ],
            },
          },
          {
            kind: 'Field',
            alias: { kind: 'Name', value: 'yiContentType' },
            name: { kind: 'Name', value: 'contentReferencesFrom' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'types' },
                value: { kind: 'StringValue', value: 'yi-content-type', block: false },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'ContentDetails_Tag_ContentReferenceFragment' },
                },
              ],
            },
          },
          {
            kind: 'Field',
            alias: { kind: 'Name', value: 'yiSeriesEpisodes' },
            name: { kind: 'Name', value: 'contentReferencesFrom' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'types' },
                value: {
                  kind: 'ListValue',
                  values: [{ kind: 'StringValue', value: 'yi-series-episode', block: false }],
                },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'YISeries_EpisodeContentFragment' },
                },
              ],
            },
          },
          {
            kind: 'FragmentSpread',
            name: { kind: 'Name', value: 'Content_ProviderMetadataFragment' },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  Mutation_YiSeries_ContentUpdateMutation,
  Mutation_YiSeries_ContentUpdateMutationVariables
>
export const Mutation_YiSeriesEpisode_ContentUpdateDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'mutation',
      name: { kind: 'Name', value: 'Mutation_YISeriesEpisode_ContentUpdate' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'content' } },
          type: {
            kind: 'NonNullType',
            type: { kind: 'NamedType', name: { kind: 'Name', value: 'ContentInput' } },
          },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'generatePath' } },
          type: { kind: 'NamedType', name: { kind: 'Name', value: 'Boolean' } },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'contentUpdate' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'content' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'content' } },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'generatePath' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'generatePath' } },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'content' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {
                        kind: 'FragmentSpread',
                        name: { kind: 'Name', value: 'YISeriesEpisode_ContentFragment' },
                      },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'Common_MediaFragment' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'Media' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'mediaId' } },
          { kind: 'Field', name: { kind: 'Name', value: 'contentId' } },
          { kind: 'Field', name: { kind: 'Name', value: 'mediaMaestroTitleCode' } },
          { kind: 'Field', name: { kind: 'Name', value: 'policyId' } },
          { kind: 'Field', name: { kind: 'Name', value: 'updatedAt' } },
          { kind: 'Field', name: { kind: 'Name', value: 'duration' } },
          { kind: 'Field', name: { kind: 'Name', value: 'isPublished' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'mediaAssets' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                { kind: 'Field', name: { kind: 'Name', value: 'providerKey' } },
              ],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'ContentPreviewMediaFragment' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'Content' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'contentPolicyPolicyId' } },
          { kind: 'Field', name: { kind: 'Name', value: 'previewMediaId' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'previewMedia' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'FragmentSpread', name: { kind: 'Name', value: 'Common_MediaFragment' } },
              ],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'ContentFeatureMediaFragment' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'Content' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'contentPolicyPolicyId' } },
          { kind: 'Field', name: { kind: 'Name', value: 'featureMediaId' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'featureMedia' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'FragmentSpread', name: { kind: 'Name', value: 'Common_MediaFragment' } },
              ],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'Content_ProviderCommonFragment' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'ContentProvider' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [{ kind: 'Field', name: { kind: 'Name', value: 'contentId' } }],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'ContentDetails_Tag_ContentReferenceFragment' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'ContentReference' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          { kind: 'Field', name: { kind: 'Name', value: 'sortKey' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'contentReferenceType' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [{ kind: 'Field', name: { kind: 'Name', value: 'type' } }],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'contentTo' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'language' },
                value: {
                  kind: 'ListValue',
                  values: [
                    { kind: 'StringValue', value: 'en', block: false },
                    { kind: 'StringValue', value: '_primary', block: false },
                  ],
                },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                { kind: 'Field', name: { kind: 'Name', value: 'titleGroupId' } },
                { kind: 'Field', name: { kind: 'Name', value: 'title' } },
                { kind: 'Field', name: { kind: 'Name', value: 'contentId' } },
                { kind: 'Field', name: { kind: 'Name', value: 'contentType' } },
                { kind: 'Field', name: { kind: 'Name', value: 'published' } },
              ],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'Content_ProviderMetadataFragment' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'Content' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            alias: { kind: 'Name', value: 'providerMetadata' },
            name: { kind: 'Name', value: 'contentProvider' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'metadata' } },
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'Content_ProviderCommonFragment' },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'YISeriesEpisode_ContentFragment' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'Content' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          { kind: 'Field', name: { kind: 'Name', value: 'contentId' } },
          { kind: 'Field', name: { kind: 'Name', value: 'contentType' } },
          { kind: 'Field', name: { kind: 'Name', value: 'published' } },
          { kind: 'Field', name: { kind: 'Name', value: 'publishedAtDate' } },
          { kind: 'Field', name: { kind: 'Name', value: 'createdAt' } },
          { kind: 'Field', name: { kind: 'Name', value: 'updatedAt' } },
          { kind: 'Field', name: { kind: 'Name', value: 'title' } },
          { kind: 'Field', name: { kind: 'Name', value: 'path' } },
          { kind: 'Field', name: { kind: 'Name', value: 'shortDescription' } },
          { kind: 'Field', name: { kind: 'Name', value: 'shortDescriptionFormat' } },
          { kind: 'Field', name: { kind: 'Name', value: 'description' } },
          { kind: 'Field', name: { kind: 'Name', value: 'descriptionFormat' } },
          { kind: 'Field', name: { kind: 'Name', value: 'productType' } },
          { kind: 'Field', name: { kind: 'Name', value: 'language' } },
          { kind: 'Field', name: { kind: 'Name', value: 'primaryLanguage' } },
          { kind: 'Field', name: { kind: 'Name', value: 'seasonNumber' } },
          { kind: 'Field', name: { kind: 'Name', value: 'episodeNumber' } },
          { kind: 'Field', name: { kind: 'Name', value: 'productType' } },
          { kind: 'FragmentSpread', name: { kind: 'Name', value: 'ContentPreviewMediaFragment' } },
          { kind: 'FragmentSpread', name: { kind: 'Name', value: 'ContentFeatureMediaFragment' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'contentProvider' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'provider' } },
                { kind: 'Field', name: { kind: 'Name', value: 'providerKey' } },
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'Content_ProviderCommonFragment' },
                },
              ],
            },
          },
          {
            kind: 'Field',
            alias: { kind: 'Name', value: 'yiContentType' },
            name: { kind: 'Name', value: 'contentReferencesFrom' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'types' },
                value: { kind: 'StringValue', value: 'yi-content-type', block: false },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'ContentDetails_Tag_ContentReferenceFragment' },
                },
              ],
            },
          },
          {
            kind: 'Field',
            alias: { kind: 'Name', value: 'yiSeries' },
            name: { kind: 'Name', value: 'contentReferencesTo' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'types' },
                value: {
                  kind: 'ListValue',
                  values: [{ kind: 'StringValue', value: 'yi-series-episode', block: false }],
                },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'contentReferenceType' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [{ kind: 'Field', name: { kind: 'Name', value: 'type' } }],
                  },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'contentFrom' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'contentId' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'contentType' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'published' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'title' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'language' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'primaryLanguage' } },
                    ],
                  },
                },
              ],
            },
          },
          {
            kind: 'FragmentSpread',
            name: { kind: 'Name', value: 'Content_ProviderMetadataFragment' },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  Mutation_YiSeriesEpisode_ContentUpdateMutation,
  Mutation_YiSeriesEpisode_ContentUpdateMutationVariables
>
export const ContentList_TranslationsQueryDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'ContentList_TranslationsQuery' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'contentId' } },
          type: { kind: 'NamedType', name: { kind: 'Name', value: 'Int' } },
          defaultValue: { kind: 'IntValue', value: '0' },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'contentList' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'where' },
                value: {
                  kind: 'ObjectValue',
                  fields: [
                    {
                      kind: 'ObjectField',
                      name: { kind: 'Name', value: 'contentId' },
                      value: {
                        kind: 'ObjectValue',
                        fields: [
                          {
                            kind: 'ObjectField',
                            name: { kind: 'Name', value: 'eq' },
                            value: { kind: 'Variable', name: { kind: 'Name', value: 'contentId' } },
                          },
                        ],
                      },
                    },
                  ],
                },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'content' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'path' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'contentId' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'language' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'primaryLanguage' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'title' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'published' } },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'contentProvider' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            { kind: 'Field', name: { kind: 'Name', value: 'contentId' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'providerKey' } },
                          ],
                        },
                      },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  ContentList_TranslationsQueryQuery,
  ContentList_TranslationsQueryQueryVariables
>
export const Mutation_YiTag_ContentUpdateDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'mutation',
      name: { kind: 'Name', value: 'Mutation_YITag_ContentUpdate' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'content' } },
          type: {
            kind: 'NonNullType',
            type: { kind: 'NamedType', name: { kind: 'Name', value: 'ContentInput' } },
          },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'generatePath' } },
          type: { kind: 'NamedType', name: { kind: 'Name', value: 'Boolean' } },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'contentUpdate' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'content' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'content' } },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'generatePath' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'generatePath' } },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'content' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {
                        kind: 'FragmentSpread',
                        name: { kind: 'Name', value: 'YITag_ContentFragment' },
                      },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'Common_MediaFragment' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'Media' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'mediaId' } },
          { kind: 'Field', name: { kind: 'Name', value: 'contentId' } },
          { kind: 'Field', name: { kind: 'Name', value: 'mediaMaestroTitleCode' } },
          { kind: 'Field', name: { kind: 'Name', value: 'policyId' } },
          { kind: 'Field', name: { kind: 'Name', value: 'updatedAt' } },
          { kind: 'Field', name: { kind: 'Name', value: 'duration' } },
          { kind: 'Field', name: { kind: 'Name', value: 'isPublished' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'mediaAssets' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                { kind: 'Field', name: { kind: 'Name', value: 'providerKey' } },
              ],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'ContentFeatureMediaFragment' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'Content' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'contentPolicyPolicyId' } },
          { kind: 'Field', name: { kind: 'Name', value: 'featureMediaId' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'featureMedia' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'FragmentSpread', name: { kind: 'Name', value: 'Common_MediaFragment' } },
              ],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'ContentDetails_Tag_ContentReferenceFragment' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'ContentReference' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          { kind: 'Field', name: { kind: 'Name', value: 'sortKey' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'contentReferenceType' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [{ kind: 'Field', name: { kind: 'Name', value: 'type' } }],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'contentTo' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'language' },
                value: {
                  kind: 'ListValue',
                  values: [
                    { kind: 'StringValue', value: 'en', block: false },
                    { kind: 'StringValue', value: '_primary', block: false },
                  ],
                },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                { kind: 'Field', name: { kind: 'Name', value: 'titleGroupId' } },
                { kind: 'Field', name: { kind: 'Name', value: 'title' } },
                { kind: 'Field', name: { kind: 'Name', value: 'contentId' } },
                { kind: 'Field', name: { kind: 'Name', value: 'contentType' } },
                { kind: 'Field', name: { kind: 'Name', value: 'published' } },
              ],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'YITag_ContentFragment' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'Content' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          { kind: 'Field', name: { kind: 'Name', value: 'contentId' } },
          { kind: 'Field', name: { kind: 'Name', value: 'title' } },
          { kind: 'Field', name: { kind: 'Name', value: 'contentType' } },
          { kind: 'Field', name: { kind: 'Name', value: 'published' } },
          { kind: 'Field', name: { kind: 'Name', value: 'publishedAtDate' } },
          { kind: 'Field', name: { kind: 'Name', value: 'description' } },
          { kind: 'Field', name: { kind: 'Name', value: 'descriptionFormat' } },
          { kind: 'Field', name: { kind: 'Name', value: 'language' } },
          { kind: 'Field', name: { kind: 'Name', value: 'primaryLanguage' } },
          { kind: 'Field', name: { kind: 'Name', value: 'path' } },
          { kind: 'Field', name: { kind: 'Name', value: 'seoTitle' } },
          { kind: 'FragmentSpread', name: { kind: 'Name', value: 'ContentFeatureMediaFragment' } },
          {
            kind: 'Field',
            alias: { kind: 'Name', value: 'yiContentType' },
            name: { kind: 'Name', value: 'contentReferencesFrom' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'types' },
                value: { kind: 'StringValue', value: 'yi-content-type', block: false },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'ContentDetails_Tag_ContentReferenceFragment' },
                },
              ],
            },
          },
          {
            kind: 'Field',
            alias: { kind: 'Name', value: 'yiTagGroup' },
            name: { kind: 'Name', value: 'contentReferencesFrom' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'types' },
                value: { kind: 'StringValue', value: 'yi-tag-group', block: false },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                { kind: 'Field', name: { kind: 'Name', value: 'sortKey' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'contentReferenceType' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [{ kind: 'Field', name: { kind: 'Name', value: 'type' } }],
                  },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'contentTo' },
                  arguments: [
                    {
                      kind: 'Argument',
                      name: { kind: 'Name', value: 'language' },
                      value: {
                        kind: 'ListValue',
                        values: [
                          { kind: 'StringValue', value: 'en', block: false },
                          { kind: 'StringValue', value: '_primary', block: false },
                        ],
                      },
                    },
                  ],
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'titleGroupId' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'title' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'contentId' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'contentType' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'published' } },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  Mutation_YiTag_ContentUpdateMutation,
  Mutation_YiTag_ContentUpdateMutationVariables
>
export const Mutation_YiTagGroup_ContentUpdateDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'mutation',
      name: { kind: 'Name', value: 'Mutation_YITagGroup_ContentUpdate' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'content' } },
          type: {
            kind: 'NonNullType',
            type: { kind: 'NamedType', name: { kind: 'Name', value: 'ContentInput' } },
          },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'generatePath' } },
          type: { kind: 'NamedType', name: { kind: 'Name', value: 'Boolean' } },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'contentUpdate' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'content' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'content' } },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'generatePath' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'generatePath' } },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'content' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {
                        kind: 'FragmentSpread',
                        name: { kind: 'Name', value: 'YITagGroup_ContentFragment' },
                      },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'ContentDetails_Tag_ContentReferenceFragment' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'ContentReference' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          { kind: 'Field', name: { kind: 'Name', value: 'sortKey' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'contentReferenceType' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [{ kind: 'Field', name: { kind: 'Name', value: 'type' } }],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'contentTo' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'language' },
                value: {
                  kind: 'ListValue',
                  values: [
                    { kind: 'StringValue', value: 'en', block: false },
                    { kind: 'StringValue', value: '_primary', block: false },
                  ],
                },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                { kind: 'Field', name: { kind: 'Name', value: 'titleGroupId' } },
                { kind: 'Field', name: { kind: 'Name', value: 'title' } },
                { kind: 'Field', name: { kind: 'Name', value: 'contentId' } },
                { kind: 'Field', name: { kind: 'Name', value: 'contentType' } },
                { kind: 'Field', name: { kind: 'Name', value: 'published' } },
              ],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'YITagGroup_ContentFragment' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'Content' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          { kind: 'Field', name: { kind: 'Name', value: 'contentId' } },
          { kind: 'Field', name: { kind: 'Name', value: 'title' } },
          { kind: 'Field', name: { kind: 'Name', value: 'contentType' } },
          { kind: 'Field', name: { kind: 'Name', value: 'published' } },
          { kind: 'Field', name: { kind: 'Name', value: 'publishedAtDate' } },
          { kind: 'Field', name: { kind: 'Name', value: 'path' } },
          { kind: 'Field', name: { kind: 'Name', value: 'language' } },
          {
            kind: 'Field',
            alias: { kind: 'Name', value: 'yiContentType' },
            name: { kind: 'Name', value: 'contentReferencesFrom' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'types' },
                value: { kind: 'StringValue', value: 'yi-content-type', block: false },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'ContentDetails_Tag_ContentReferenceFragment' },
                },
              ],
            },
          },
          {
            kind: 'Field',
            alias: { kind: 'Name', value: 'yiTagsRelatedToGroup' },
            name: { kind: 'Name', value: 'contentReferencesTo' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'types' },
                value: { kind: 'StringValue', value: 'yi-tag-group', block: false },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                { kind: 'Field', name: { kind: 'Name', value: 'sortKey' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'contentReferenceType' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [{ kind: 'Field', name: { kind: 'Name', value: 'type' } }],
                  },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'contentFrom' },
                  arguments: [
                    {
                      kind: 'Argument',
                      name: { kind: 'Name', value: 'language' },
                      value: {
                        kind: 'ListValue',
                        values: [
                          { kind: 'StringValue', value: 'en', block: false },
                          { kind: 'StringValue', value: '_primary', block: false },
                        ],
                      },
                    },
                  ],
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'titleGroupId' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'title' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'contentId' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'contentType' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'published' } },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  Mutation_YiTagGroup_ContentUpdateMutation,
  Mutation_YiTagGroup_ContentUpdateMutationVariables
>
export const Mutation_YiTeacher_ContentUpdateDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'mutation',
      name: { kind: 'Name', value: 'Mutation_YITeacher_ContentUpdate' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'content' } },
          type: {
            kind: 'NonNullType',
            type: { kind: 'NamedType', name: { kind: 'Name', value: 'ContentInput' } },
          },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'generatePath' } },
          type: { kind: 'NamedType', name: { kind: 'Name', value: 'Boolean' } },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'contentUpdate' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'content' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'content' } },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'generatePath' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'generatePath' } },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'content' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {
                        kind: 'FragmentSpread',
                        name: { kind: 'Name', value: 'YITeacher_ContentFragment' },
                      },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'Common_MediaFragment' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'Media' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'mediaId' } },
          { kind: 'Field', name: { kind: 'Name', value: 'contentId' } },
          { kind: 'Field', name: { kind: 'Name', value: 'mediaMaestroTitleCode' } },
          { kind: 'Field', name: { kind: 'Name', value: 'policyId' } },
          { kind: 'Field', name: { kind: 'Name', value: 'updatedAt' } },
          { kind: 'Field', name: { kind: 'Name', value: 'duration' } },
          { kind: 'Field', name: { kind: 'Name', value: 'isPublished' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'mediaAssets' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                { kind: 'Field', name: { kind: 'Name', value: 'providerKey' } },
              ],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'ContentFeatureMediaFragment' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'Content' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'contentPolicyPolicyId' } },
          { kind: 'Field', name: { kind: 'Name', value: 'featureMediaId' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'featureMedia' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'FragmentSpread', name: { kind: 'Name', value: 'Common_MediaFragment' } },
              ],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'ContentDetails_Tag_ContentReferenceFragment' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'ContentReference' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          { kind: 'Field', name: { kind: 'Name', value: 'sortKey' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'contentReferenceType' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [{ kind: 'Field', name: { kind: 'Name', value: 'type' } }],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'contentTo' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'language' },
                value: {
                  kind: 'ListValue',
                  values: [
                    { kind: 'StringValue', value: 'en', block: false },
                    { kind: 'StringValue', value: '_primary', block: false },
                  ],
                },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                { kind: 'Field', name: { kind: 'Name', value: 'titleGroupId' } },
                { kind: 'Field', name: { kind: 'Name', value: 'title' } },
                { kind: 'Field', name: { kind: 'Name', value: 'contentId' } },
                { kind: 'Field', name: { kind: 'Name', value: 'contentType' } },
                { kind: 'Field', name: { kind: 'Name', value: 'published' } },
              ],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'Content_ProviderCommonFragment' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'ContentProvider' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [{ kind: 'Field', name: { kind: 'Name', value: 'contentId' } }],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'Content_ProviderMetadataFragment' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'Content' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            alias: { kind: 'Name', value: 'providerMetadata' },
            name: { kind: 'Name', value: 'contentProvider' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'metadata' } },
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'Content_ProviderCommonFragment' },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'YITeacher_ContentFragment' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'Content' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          { kind: 'Field', name: { kind: 'Name', value: 'contentId' } },
          { kind: 'Field', name: { kind: 'Name', value: 'contentType' } },
          { kind: 'Field', name: { kind: 'Name', value: 'published' } },
          { kind: 'Field', name: { kind: 'Name', value: 'publishedAtDate' } },
          { kind: 'Field', name: { kind: 'Name', value: 'shortDescription' } },
          { kind: 'Field', name: { kind: 'Name', value: 'shortDescriptionFormat' } },
          { kind: 'Field', name: { kind: 'Name', value: 'description' } },
          { kind: 'Field', name: { kind: 'Name', value: 'descriptionFormat' } },
          { kind: 'Field', name: { kind: 'Name', value: 'language' } },
          { kind: 'Field', name: { kind: 'Name', value: 'primaryLanguage' } },
          { kind: 'Field', name: { kind: 'Name', value: 'path' } },
          { kind: 'Field', name: { kind: 'Name', value: 'seoTitle' } },
          { kind: 'Field', name: { kind: 'Name', value: 'seoDescription' } },
          { kind: 'Field', name: { kind: 'Name', value: 'title' } },
          { kind: 'FragmentSpread', name: { kind: 'Name', value: 'ContentFeatureMediaFragment' } },
          {
            kind: 'Field',
            alias: { kind: 'Name', value: 'yiContentType' },
            name: { kind: 'Name', value: 'contentReferencesFrom' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'types' },
                value: { kind: 'StringValue', value: 'yi-content-type', block: false },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'ContentDetails_Tag_ContentReferenceFragment' },
                },
              ],
            },
          },
          {
            kind: 'Field',
            alias: { kind: 'Name', value: 'yiTags' },
            name: { kind: 'Name', value: 'contentReferencesFrom' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'types' },
                value: { kind: 'StringValue', value: 'yi-tag', block: false },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'ContentDetails_Tag_ContentReferenceFragment' },
                },
              ],
            },
          },
          {
            kind: 'FragmentSpread',
            name: { kind: 'Name', value: 'Content_ProviderMetadataFragment' },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  Mutation_YiTeacher_ContentUpdateMutation,
  Mutation_YiTeacher_ContentUpdateMutationVariables
>
export const ContentList_ReferenceTypeOptionsQueryDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'ContentList_ReferenceTypeOptionsQuery' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'offset' } },
          type: { kind: 'NamedType', name: { kind: 'Name', value: 'Int' } },
          defaultValue: { kind: 'IntValue', value: '0' },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'limit' } },
          type: { kind: 'NamedType', name: { kind: 'Name', value: 'Int' } },
          defaultValue: { kind: 'IntValue', value: '500' },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'order' } },
          type: {
            kind: 'ListType',
            type: {
              kind: 'ListType',
              type: { kind: 'NamedType', name: { kind: 'Name', value: 'String' } },
            },
          },
          defaultValue: {
            kind: 'ListValue',
            values: [
              {
                kind: 'ListValue',
                values: [
                  { kind: 'StringValue', value: 'title', block: false },
                  { kind: 'StringValue', value: 'asc', block: false },
                ],
              },
            ],
          },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'where' } },
          type: { kind: 'NamedType', name: { kind: 'Name', value: 'ContentWhereInput' } },
          defaultValue: { kind: 'ObjectValue', fields: [] },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'language' } },
          type: {
            kind: 'ListType',
            type: { kind: 'NamedType', name: { kind: 'Name', value: 'String' } },
          },
          defaultValue: {
            kind: 'ListValue',
            values: [
              { kind: 'StringValue', value: 'en', block: false },
              { kind: 'StringValue', value: '_primary', block: false },
            ],
          },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'contentReferencesFromNot' } },
          type: {
            kind: 'ListType',
            type: {
              kind: 'NamedType',
              name: { kind: 'Name', value: 'ContentContentReferencesFromFilterInput' },
            },
          },
          defaultValue: { kind: 'ListValue', values: [] },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'contentList' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'offset' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'offset' } },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'limit' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'limit' } },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'order' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'order' } },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'where' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'where' } },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'language' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'language' } },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'contentReferencesFromNot' },
                value: {
                  kind: 'Variable',
                  name: { kind: 'Name', value: 'contentReferencesFromNot' },
                },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'content' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'language' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'title' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'contentId' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'contentType' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'published' } },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'contentProvider' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            { kind: 'Field', name: { kind: 'Name', value: 'provider' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'providerKey' } },
                            {
                              kind: 'FragmentSpread',
                              name: { kind: 'Name', value: 'Content_ProviderCommonFragment' },
                            },
                          ],
                        },
                      },
                      {
                        kind: 'Field',
                        alias: { kind: 'Name', value: 'yiContentType' },
                        name: { kind: 'Name', value: 'contentReferencesFrom' },
                        arguments: [
                          {
                            kind: 'Argument',
                            name: { kind: 'Name', value: 'types' },
                            value: { kind: 'StringValue', value: 'yi-content-type', block: false },
                          },
                        ],
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            {
                              kind: 'FragmentSpread',
                              name: {
                                kind: 'Name',
                                value: 'ContentDetails_Tag_ContentReferenceFragment',
                              },
                            },
                          ],
                        },
                      },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'Content_ProviderCommonFragment' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'ContentProvider' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [{ kind: 'Field', name: { kind: 'Name', value: 'contentId' } }],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'ContentDetails_Tag_ContentReferenceFragment' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'ContentReference' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          { kind: 'Field', name: { kind: 'Name', value: 'sortKey' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'contentReferenceType' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [{ kind: 'Field', name: { kind: 'Name', value: 'type' } }],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'contentTo' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'language' },
                value: {
                  kind: 'ListValue',
                  values: [
                    { kind: 'StringValue', value: 'en', block: false },
                    { kind: 'StringValue', value: '_primary', block: false },
                  ],
                },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                { kind: 'Field', name: { kind: 'Name', value: 'titleGroupId' } },
                { kind: 'Field', name: { kind: 'Name', value: 'title' } },
                { kind: 'Field', name: { kind: 'Name', value: 'contentId' } },
                { kind: 'Field', name: { kind: 'Name', value: 'contentType' } },
                { kind: 'Field', name: { kind: 'Name', value: 'published' } },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  ContentList_ReferenceTypeOptionsQueryQuery,
  ContentList_ReferenceTypeOptionsQueryQueryVariables
>
export const ContentUpdatedAtByIdDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'ContentUpdatedAtById' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'id' } },
          type: {
            kind: 'NonNullType',
            type: { kind: 'NamedType', name: { kind: 'Name', value: 'ID' } },
          },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'contentList' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'where' },
                value: {
                  kind: 'ObjectValue',
                  fields: [
                    {
                      kind: 'ObjectField',
                      name: { kind: 'Name', value: 'id' },
                      value: {
                        kind: 'ObjectValue',
                        fields: [
                          {
                            kind: 'ObjectField',
                            name: { kind: 'Name', value: 'eq' },
                            value: { kind: 'Variable', name: { kind: 'Name', value: 'id' } },
                          },
                        ],
                      },
                    },
                  ],
                },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'content' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [{ kind: 'Field', name: { kind: 'Name', value: 'updatedAt' } }],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<ContentUpdatedAtByIdQuery, ContentUpdatedAtByIdQueryVariables>
export const ContentImagesDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'ContentImages' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'offset' } },
          type: { kind: 'NamedType', name: { kind: 'Name', value: 'Int' } },
          defaultValue: { kind: 'IntValue', value: '0' },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'limit' } },
          type: { kind: 'NamedType', name: { kind: 'Name', value: 'Int' } },
          defaultValue: { kind: 'IntValue', value: '25' },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'order' } },
          type: {
            kind: 'ListType',
            type: {
              kind: 'ListType',
              type: { kind: 'NamedType', name: { kind: 'Name', value: 'String' } },
            },
          },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'where' } },
          type: { kind: 'NamedType', name: { kind: 'Name', value: 'ContentWhereInput' } },
          defaultValue: { kind: 'ObjectValue', fields: [] },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'contentReferencesTo' } },
          type: {
            kind: 'ListType',
            type: {
              kind: 'NamedType',
              name: { kind: 'Name', value: 'ContentContentReferencesToFilterInput' },
            },
          },
          defaultValue: { kind: 'ListValue', values: [] },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'contentList' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'offset' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'offset' } },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'limit' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'limit' } },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'order' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'order' } },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'where' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'where' } },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'contentReferencesTo' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'contentReferencesTo' } },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'content' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {
                        kind: 'FragmentSpread',
                        name: { kind: 'Name', value: 'ContentImages_ContentDetailsFragment' },
                      },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'ContentImages_ImageContentRelationshipsFragment' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'ImageContentRelationship' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          { kind: 'Field', name: { kind: 'Name', value: 'type' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'image' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                { kind: 'Field', name: { kind: 'Name', value: 'url' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'asset' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'providerSourceRenderUrl' } },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'ContentImages_ContentDetailsFragment' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'Content' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          { kind: 'Field', name: { kind: 'Name', value: 'contentId' } },
          { kind: 'Field', name: { kind: 'Name', value: 'contentType' } },
          { kind: 'Field', name: { kind: 'Name', value: 'language' } },
          { kind: 'Field', name: { kind: 'Name', value: 'primaryLanguage' } },
          {
            kind: 'Field',
            alias: { kind: 'Name', value: 'images' },
            name: { kind: 'Name', value: 'imageContentRelationships' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'ContentImages_ImageContentRelationshipsFragment' },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<ContentImagesQuery, ContentImagesQueryVariables>
export const MediaList_OptionsQueryDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'MediaList_OptionsQuery' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'offset' } },
          type: { kind: 'NamedType', name: { kind: 'Name', value: 'Int' } },
          defaultValue: { kind: 'IntValue', value: '0' },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'limit' } },
          type: { kind: 'NamedType', name: { kind: 'Name', value: 'Int' } },
          defaultValue: { kind: 'IntValue', value: '500' },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'where' } },
          type: { kind: 'NamedType', name: { kind: 'Name', value: 'MediaWhereInput' } },
          defaultValue: { kind: 'ObjectValue', fields: [] },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'order' } },
          type: {
            kind: 'ListType',
            type: {
              kind: 'ListType',
              type: { kind: 'NamedType', name: { kind: 'Name', value: 'String' } },
            },
          },
          defaultValue: {
            kind: 'ListValue',
            values: [
              {
                kind: 'ListValue',
                values: [
                  { kind: 'StringValue', value: 'updatedAt', block: false },
                  { kind: 'StringValue', value: 'desc', block: false },
                ],
              },
            ],
          },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'mediaList' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'offset' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'offset' } },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'limit' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'limit' } },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'where' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'where' } },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'order' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'order' } },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'media' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {
                        kind: 'FragmentSpread',
                        name: { kind: 'Name', value: 'Common_MediaFragment' },
                      },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'Common_MediaFragment' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'Media' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'mediaId' } },
          { kind: 'Field', name: { kind: 'Name', value: 'contentId' } },
          { kind: 'Field', name: { kind: 'Name', value: 'mediaMaestroTitleCode' } },
          { kind: 'Field', name: { kind: 'Name', value: 'policyId' } },
          { kind: 'Field', name: { kind: 'Name', value: 'updatedAt' } },
          { kind: 'Field', name: { kind: 'Name', value: 'duration' } },
          { kind: 'Field', name: { kind: 'Name', value: 'isPublished' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'mediaAssets' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                { kind: 'Field', name: { kind: 'Name', value: 'providerKey' } },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<MediaList_OptionsQueryQuery, MediaList_OptionsQueryQueryVariables>
export const ContentList_YiReferencesFromListQueryDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'ContentList_YIReferencesFromListQuery' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'id' } },
          type: { kind: 'NamedType', name: { kind: 'Name', value: 'ID' } },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'types' } },
          type: {
            kind: 'ListType',
            type: { kind: 'NamedType', name: { kind: 'Name', value: 'String' } },
          },
          defaultValue: { kind: 'ListValue', values: [] },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'limit' } },
          type: { kind: 'NamedType', name: { kind: 'Name', value: 'Int' } },
          defaultValue: { kind: 'IntValue', value: '100' },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'contentList' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'where' },
                value: {
                  kind: 'ObjectValue',
                  fields: [
                    {
                      kind: 'ObjectField',
                      name: { kind: 'Name', value: 'id' },
                      value: {
                        kind: 'ObjectValue',
                        fields: [
                          {
                            kind: 'ObjectField',
                            name: { kind: 'Name', value: 'eq' },
                            value: { kind: 'Variable', name: { kind: 'Name', value: 'id' } },
                          },
                        ],
                      },
                    },
                  ],
                },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'content' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'contentReferencesFrom' },
                        arguments: [
                          {
                            kind: 'Argument',
                            name: { kind: 'Name', value: 'types' },
                            value: { kind: 'Variable', name: { kind: 'Name', value: 'types' } },
                          },
                          {
                            kind: 'Argument',
                            name: { kind: 'Name', value: 'limit' },
                            value: { kind: 'Variable', name: { kind: 'Name', value: 'limit' } },
                          },
                        ],
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'contentReferenceType' },
                              selectionSet: {
                                kind: 'SelectionSet',
                                selections: [
                                  { kind: 'Field', name: { kind: 'Name', value: 'type' } },
                                ],
                              },
                            },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'contentTo' },
                              selectionSet: {
                                kind: 'SelectionSet',
                                selections: [
                                  {
                                    kind: 'FragmentSpread',
                                    name: {
                                      kind: 'Name',
                                      value: 'ContentList_YIReferenceContentFragment',
                                    },
                                  },
                                ],
                              },
                            },
                          ],
                        },
                      },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'ContentDetails_Tag_ContentReferenceFragment' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'ContentReference' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          { kind: 'Field', name: { kind: 'Name', value: 'sortKey' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'contentReferenceType' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [{ kind: 'Field', name: { kind: 'Name', value: 'type' } }],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'contentTo' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'language' },
                value: {
                  kind: 'ListValue',
                  values: [
                    { kind: 'StringValue', value: 'en', block: false },
                    { kind: 'StringValue', value: '_primary', block: false },
                  ],
                },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                { kind: 'Field', name: { kind: 'Name', value: 'titleGroupId' } },
                { kind: 'Field', name: { kind: 'Name', value: 'title' } },
                { kind: 'Field', name: { kind: 'Name', value: 'contentId' } },
                { kind: 'Field', name: { kind: 'Name', value: 'contentType' } },
                { kind: 'Field', name: { kind: 'Name', value: 'published' } },
              ],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'ContentList_YIReferenceContentFragment' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'Content' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'contentId' } },
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          { kind: 'Field', name: { kind: 'Name', value: 'contentType' } },
          { kind: 'Field', name: { kind: 'Name', value: 'title' } },
          { kind: 'Field', name: { kind: 'Name', value: 'language' } },
          { kind: 'Field', name: { kind: 'Name', value: 'published' } },
          {
            kind: 'Field',
            alias: { kind: 'Name', value: 'yiContentType' },
            name: { kind: 'Name', value: 'contentReferencesFrom' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'types' },
                value: { kind: 'StringValue', value: 'yi-content-type', block: false },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'ContentDetails_Tag_ContentReferenceFragment' },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  ContentList_YiReferencesFromListQueryQuery,
  ContentList_YiReferencesFromListQueryQueryVariables
>
export const ContentList_YiReferencesToListQueryDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'ContentList_YIReferencesToListQuery' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'id' } },
          type: { kind: 'NamedType', name: { kind: 'Name', value: 'ID' } },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'types' } },
          type: {
            kind: 'ListType',
            type: { kind: 'NamedType', name: { kind: 'Name', value: 'String' } },
          },
          defaultValue: { kind: 'ListValue', values: [] },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'limit' } },
          type: { kind: 'NamedType', name: { kind: 'Name', value: 'Int' } },
          defaultValue: { kind: 'IntValue', value: '100' },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'contentList' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'where' },
                value: {
                  kind: 'ObjectValue',
                  fields: [
                    {
                      kind: 'ObjectField',
                      name: { kind: 'Name', value: 'id' },
                      value: {
                        kind: 'ObjectValue',
                        fields: [
                          {
                            kind: 'ObjectField',
                            name: { kind: 'Name', value: 'eq' },
                            value: { kind: 'Variable', name: { kind: 'Name', value: 'id' } },
                          },
                        ],
                      },
                    },
                  ],
                },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'content' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'contentReferencesTo' },
                        arguments: [
                          {
                            kind: 'Argument',
                            name: { kind: 'Name', value: 'types' },
                            value: { kind: 'Variable', name: { kind: 'Name', value: 'types' } },
                          },
                          {
                            kind: 'Argument',
                            name: { kind: 'Name', value: 'limit' },
                            value: { kind: 'Variable', name: { kind: 'Name', value: 'limit' } },
                          },
                        ],
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'contentReferenceType' },
                              selectionSet: {
                                kind: 'SelectionSet',
                                selections: [
                                  { kind: 'Field', name: { kind: 'Name', value: 'type' } },
                                ],
                              },
                            },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'contentFrom' },
                              selectionSet: {
                                kind: 'SelectionSet',
                                selections: [
                                  {
                                    kind: 'FragmentSpread',
                                    name: {
                                      kind: 'Name',
                                      value: 'ContentList_YIReferenceContentFragment',
                                    },
                                  },
                                ],
                              },
                            },
                          ],
                        },
                      },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'ContentDetails_Tag_ContentReferenceFragment' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'ContentReference' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          { kind: 'Field', name: { kind: 'Name', value: 'sortKey' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'contentReferenceType' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [{ kind: 'Field', name: { kind: 'Name', value: 'type' } }],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'contentTo' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'language' },
                value: {
                  kind: 'ListValue',
                  values: [
                    { kind: 'StringValue', value: 'en', block: false },
                    { kind: 'StringValue', value: '_primary', block: false },
                  ],
                },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                { kind: 'Field', name: { kind: 'Name', value: 'titleGroupId' } },
                { kind: 'Field', name: { kind: 'Name', value: 'title' } },
                { kind: 'Field', name: { kind: 'Name', value: 'contentId' } },
                { kind: 'Field', name: { kind: 'Name', value: 'contentType' } },
                { kind: 'Field', name: { kind: 'Name', value: 'published' } },
              ],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'ContentList_YIReferenceContentFragment' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'Content' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'contentId' } },
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          { kind: 'Field', name: { kind: 'Name', value: 'contentType' } },
          { kind: 'Field', name: { kind: 'Name', value: 'title' } },
          { kind: 'Field', name: { kind: 'Name', value: 'language' } },
          { kind: 'Field', name: { kind: 'Name', value: 'published' } },
          {
            kind: 'Field',
            alias: { kind: 'Name', value: 'yiContentType' },
            name: { kind: 'Name', value: 'contentReferencesFrom' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'types' },
                value: { kind: 'StringValue', value: 'yi-content-type', block: false },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'ContentDetails_Tag_ContentReferenceFragment' },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  ContentList_YiReferencesToListQueryQuery,
  ContentList_YiReferencesToListQueryQueryVariables
>
export const ContentReferenceTypesListQueryDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'ContentReferenceTypesListQuery' },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'contentReferenceTypesList' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'contentReferenceTypes' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'type' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  ContentReferenceTypesListQueryQuery,
  ContentReferenceTypesListQueryQueryVariables
>
export const ContentList_YiTeacherQueryDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'ContentList_YITeacherQuery' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'name' } },
          type: {
            kind: 'NonNullType',
            type: { kind: 'NamedType', name: { kind: 'Name', value: 'String' } },
          },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'offset' } },
          type: { kind: 'NamedType', name: { kind: 'Name', value: 'Int' } },
          defaultValue: { kind: 'IntValue', value: '0' },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'limit' } },
          type: { kind: 'NamedType', name: { kind: 'Name', value: 'Int' } },
          defaultValue: { kind: 'IntValue', value: '25' },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'contentList' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'offset' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'offset' } },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'limit' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'limit' } },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'where' },
                value: {
                  kind: 'ObjectValue',
                  fields: [
                    {
                      kind: 'ObjectField',
                      name: { kind: 'Name', value: 'contentType' },
                      value: {
                        kind: 'ObjectValue',
                        fields: [
                          {
                            kind: 'ObjectField',
                            name: { kind: 'Name', value: 'eq' },
                            value: { kind: 'StringValue', value: 'person', block: false },
                          },
                        ],
                      },
                    },
                    {
                      kind: 'ObjectField',
                      name: { kind: 'Name', value: 'path' },
                      value: {
                        kind: 'ObjectValue',
                        fields: [
                          {
                            kind: 'ObjectField',
                            name: { kind: 'Name', value: 'ilike' },
                            value: {
                              kind: 'StringValue',
                              value: 'yoga-international/%',
                              block: false,
                            },
                          },
                        ],
                      },
                    },
                    {
                      kind: 'ObjectField',
                      name: { kind: 'Name', value: 'title' },
                      value: {
                        kind: 'ObjectValue',
                        fields: [
                          {
                            kind: 'ObjectField',
                            name: { kind: 'Name', value: 'ilike' },
                            value: { kind: 'Variable', name: { kind: 'Name', value: 'name' } },
                          },
                        ],
                      },
                    },
                  ],
                },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'content' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {
                        kind: 'FragmentSpread',
                        name: { kind: 'Name', value: 'ContentDetails_Person_ContentFragment' },
                      },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'ContentDetails_Person_ContentFragment' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'Content' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          { kind: 'Field', name: { kind: 'Name', value: 'title' } },
          { kind: 'Field', name: { kind: 'Name', value: 'language' } },
          { kind: 'Field', name: { kind: 'Name', value: 'contentType' } },
          { kind: 'Field', name: { kind: 'Name', value: 'contentId' } },
          { kind: 'Field', name: { kind: 'Name', value: 'published' } },
          {
            kind: 'Field',
            alias: { kind: 'Name', value: 'avatar' },
            name: { kind: 'Name', value: 'imageContentRelationships' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                { kind: 'Field', name: { kind: 'Name', value: 'type' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'image' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'url' } },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  ContentList_YiTeacherQueryQuery,
  ContentList_YiTeacherQueryQueryVariables
>
export const ContentPageTagListQueryDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'ContentPageTagListQuery' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'limit' } },
          type: { kind: 'NamedType', name: { kind: 'Name', value: 'Int' } },
          defaultValue: { kind: 'IntValue', value: '1000' },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'contentList' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'where' },
                value: {
                  kind: 'ObjectValue',
                  fields: [
                    {
                      kind: 'ObjectField',
                      name: { kind: 'Name', value: 'contentType' },
                      value: {
                        kind: 'ObjectValue',
                        fields: [
                          {
                            kind: 'ObjectField',
                            name: { kind: 'Name', value: 'eq' },
                            value: { kind: 'StringValue', value: 'tag', block: false },
                          },
                        ],
                      },
                    },
                    {
                      kind: 'ObjectField',
                      name: { kind: 'Name', value: 'path' },
                      value: {
                        kind: 'ObjectValue',
                        fields: [
                          {
                            kind: 'ObjectField',
                            name: { kind: 'Name', value: 'ilike' },
                            value: {
                              kind: 'StringValue',
                              value: 'yoga-international/%/teacher/%',
                              block: false,
                            },
                          },
                        ],
                      },
                    },
                  ],
                },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'limit' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'limit' } },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'content' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'contentId' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'contentType' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'language' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'titleGroupId' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'title' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'titleGroupId' } },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<ContentPageTagListQueryQuery, ContentPageTagListQueryQueryVariables>
export const ContentPageTeacherListQueryDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'ContentPageTeacherListQuery' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'limit' } },
          type: { kind: 'NamedType', name: { kind: 'Name', value: 'Int' } },
          defaultValue: { kind: 'IntValue', value: '1000' },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'contentList' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'where' },
                value: {
                  kind: 'ObjectValue',
                  fields: [
                    {
                      kind: 'ObjectField',
                      name: { kind: 'Name', value: 'contentType' },
                      value: {
                        kind: 'ObjectValue',
                        fields: [
                          {
                            kind: 'ObjectField',
                            name: { kind: 'Name', value: 'eq' },
                            value: { kind: 'StringValue', value: 'person', block: false },
                          },
                        ],
                      },
                    },
                    {
                      kind: 'ObjectField',
                      name: { kind: 'Name', value: 'path' },
                      value: {
                        kind: 'ObjectValue',
                        fields: [
                          {
                            kind: 'ObjectField',
                            name: { kind: 'Name', value: 'ilike' },
                            value: {
                              kind: 'StringValue',
                              value: 'yoga-international/%/teacher/%',
                              block: false,
                            },
                          },
                        ],
                      },
                    },
                  ],
                },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'limit' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'limit' } },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'content' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'contentId' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'contentType' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'language' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'titleGroupId' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'title' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'titleGroupId' } },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  ContentPageTeacherListQueryQuery,
  ContentPageTeacherListQueryQueryVariables
>
export const ContentListYiQueryDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'ContentListYIQuery' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'language' } },
          type: {
            kind: 'ListType',
            type: { kind: 'NamedType', name: { kind: 'Name', value: 'String' } },
          },
          defaultValue: {
            kind: 'ListValue',
            values: [{ kind: 'StringValue', value: 'en', block: false }],
          },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'offset' } },
          type: { kind: 'NamedType', name: { kind: 'Name', value: 'Int' } },
          defaultValue: { kind: 'IntValue', value: '0' },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'limit' } },
          type: { kind: 'NamedType', name: { kind: 'Name', value: 'Int' } },
          defaultValue: { kind: 'IntValue', value: '25' },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'order' } },
          type: {
            kind: 'ListType',
            type: {
              kind: 'ListType',
              type: { kind: 'NamedType', name: { kind: 'Name', value: 'String' } },
            },
          },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'where' } },
          type: { kind: 'NamedType', name: { kind: 'Name', value: 'ContentWhereInput' } },
          defaultValue: { kind: 'ObjectValue', fields: [] },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'references' } },
          type: {
            kind: 'ListType',
            type: {
              kind: 'NamedType',
              name: { kind: 'Name', value: 'ContentContentReferencesToFilterInput' },
            },
          },
          defaultValue: { kind: 'ListValue', values: [] },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'referencesEvery' } },
          type: {
            kind: 'ListType',
            type: {
              kind: 'NamedType',
              name: { kind: 'Name', value: 'ContentContentReferencesToFilterInput' },
            },
          },
          defaultValue: { kind: 'ListValue', values: [] },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'referencesNot' } },
          type: {
            kind: 'ListType',
            type: {
              kind: 'NamedType',
              name: { kind: 'Name', value: 'ContentContentReferencesToFilterInput' },
            },
          },
          defaultValue: { kind: 'ListValue', values: [] },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'contentProviders' } },
          type: {
            kind: 'ListType',
            type: {
              kind: 'NamedType',
              name: { kind: 'Name', value: 'ContentContentProviderFilterInput' },
            },
          },
          defaultValue: { kind: 'ListValue', values: [] },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'contentList' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'offset' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'offset' } },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'limit' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'limit' } },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'order' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'order' } },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'where' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'where' } },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'references' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'references' } },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'referencesEvery' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'referencesEvery' } },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'referencesNot' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'referencesNot' } },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'contentProviders' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'contentProviders' } },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'language' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'language' } },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'limit' } },
                { kind: 'Field', name: { kind: 'Name', value: 'offset' } },
                { kind: 'Field', name: { kind: 'Name', value: 'count' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'content' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'contentId' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'contentType' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'language' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'primaryLanguage' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'title' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'path' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'published' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'publishedAtDate' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'createdAt' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'updatedAt' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'path' } },
                      {
                        kind: 'FragmentSpread',
                        name: { kind: 'Name', value: 'Content_ProviderMetadataFragment' },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'contentProvider' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            { kind: 'Field', name: { kind: 'Name', value: 'provider' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'providerKey' } },
                            {
                              kind: 'FragmentSpread',
                              name: { kind: 'Name', value: 'Content_ProviderCommonFragment' },
                            },
                          ],
                        },
                      },
                      {
                        kind: 'Field',
                        alias: { kind: 'Name', value: 'yiContentType' },
                        name: { kind: 'Name', value: 'contentReferencesFrom' },
                        arguments: [
                          {
                            kind: 'Argument',
                            name: { kind: 'Name', value: 'types' },
                            value: { kind: 'StringValue', value: 'yi-content-type', block: false },
                          },
                        ],
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            {
                              kind: 'FragmentSpread',
                              name: {
                                kind: 'Name',
                                value: 'ContentDetails_Tag_ContentReferenceFragment',
                              },
                            },
                          ],
                        },
                      },
                      {
                        kind: 'Field',
                        alias: { kind: 'Name', value: 'yiYogaTeacher' },
                        name: { kind: 'Name', value: 'contentReferencesFrom' },
                        arguments: [
                          {
                            kind: 'Argument',
                            name: { kind: 'Name', value: 'types' },
                            value: { kind: 'StringValue', value: 'yi-yoga-teacher', block: false },
                          },
                        ],
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            {
                              kind: 'FragmentSpread',
                              name: {
                                kind: 'Name',
                                value: 'ContentDetails_Person_ContentReferenceFragment',
                              },
                            },
                          ],
                        },
                      },
                      {
                        kind: 'Field',
                        alias: { kind: 'Name', value: 'yiTags' },
                        name: { kind: 'Name', value: 'contentReferencesFrom' },
                        arguments: [
                          {
                            kind: 'Argument',
                            name: { kind: 'Name', value: 'types' },
                            value: { kind: 'StringValue', value: 'yi-tag', block: false },
                          },
                        ],
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            {
                              kind: 'FragmentSpread',
                              name: {
                                kind: 'Name',
                                value: 'ContentDetails_Tag_ContentReferenceFragment',
                              },
                            },
                          ],
                        },
                      },
                      {
                        kind: 'Field',
                        alias: { kind: 'Name', value: 'yiYogaStyle' },
                        name: { kind: 'Name', value: 'contentReferencesFrom' },
                        arguments: [
                          {
                            kind: 'Argument',
                            name: { kind: 'Name', value: 'types' },
                            value: { kind: 'StringValue', value: 'yi-yoga-style', block: false },
                          },
                        ],
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            {
                              kind: 'FragmentSpread',
                              name: {
                                kind: 'Name',
                                value: 'ContentDetails_Tag_ContentReferenceFragment',
                              },
                            },
                          ],
                        },
                      },
                      {
                        kind: 'Field',
                        alias: { kind: 'Name', value: 'yiYogaLevel' },
                        name: { kind: 'Name', value: 'contentReferencesFrom' },
                        arguments: [
                          {
                            kind: 'Argument',
                            name: { kind: 'Name', value: 'types' },
                            value: { kind: 'StringValue', value: 'yi-yoga-level', block: false },
                          },
                        ],
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            {
                              kind: 'FragmentSpread',
                              name: {
                                kind: 'Name',
                                value: 'ContentDetails_Tag_ContentReferenceFragment',
                              },
                            },
                          ],
                        },
                      },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'Content_ProviderCommonFragment' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'ContentProvider' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [{ kind: 'Field', name: { kind: 'Name', value: 'contentId' } }],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'ContentDetails_Person_ContentFragment' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'Content' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          { kind: 'Field', name: { kind: 'Name', value: 'title' } },
          { kind: 'Field', name: { kind: 'Name', value: 'language' } },
          { kind: 'Field', name: { kind: 'Name', value: 'contentType' } },
          { kind: 'Field', name: { kind: 'Name', value: 'contentId' } },
          { kind: 'Field', name: { kind: 'Name', value: 'published' } },
          {
            kind: 'Field',
            alias: { kind: 'Name', value: 'avatar' },
            name: { kind: 'Name', value: 'imageContentRelationships' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                { kind: 'Field', name: { kind: 'Name', value: 'type' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'image' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'url' } },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'Content_ProviderMetadataFragment' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'Content' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            alias: { kind: 'Name', value: 'providerMetadata' },
            name: { kind: 'Name', value: 'contentProvider' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'metadata' } },
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'Content_ProviderCommonFragment' },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'ContentDetails_Tag_ContentReferenceFragment' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'ContentReference' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          { kind: 'Field', name: { kind: 'Name', value: 'sortKey' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'contentReferenceType' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [{ kind: 'Field', name: { kind: 'Name', value: 'type' } }],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'contentTo' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'language' },
                value: {
                  kind: 'ListValue',
                  values: [
                    { kind: 'StringValue', value: 'en', block: false },
                    { kind: 'StringValue', value: '_primary', block: false },
                  ],
                },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                { kind: 'Field', name: { kind: 'Name', value: 'titleGroupId' } },
                { kind: 'Field', name: { kind: 'Name', value: 'title' } },
                { kind: 'Field', name: { kind: 'Name', value: 'contentId' } },
                { kind: 'Field', name: { kind: 'Name', value: 'contentType' } },
                { kind: 'Field', name: { kind: 'Name', value: 'published' } },
              ],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'ContentDetails_Person_ContentReferenceFragment' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'ContentReference' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          { kind: 'Field', name: { kind: 'Name', value: 'sortKey' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'contentReferenceType' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                { kind: 'Field', name: { kind: 'Name', value: 'type' } },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'contentTo' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'ContentDetails_Person_ContentFragment' },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<ContentListYiQueryQuery, ContentListYiQueryQueryVariables>
export const YiMediaCreate_MediaByContentIdQueryDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'YIMediaCreate_MediaByContentIdQuery' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'contentId' } },
          type: { kind: 'NamedType', name: { kind: 'Name', value: 'ID' } },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'mediaList' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'where' },
                value: {
                  kind: 'ObjectValue',
                  fields: [
                    {
                      kind: 'ObjectField',
                      name: { kind: 'Name', value: 'contentId' },
                      value: {
                        kind: 'ObjectValue',
                        fields: [
                          {
                            kind: 'ObjectField',
                            name: { kind: 'Name', value: 'eq' },
                            value: { kind: 'Variable', name: { kind: 'Name', value: 'contentId' } },
                          },
                        ],
                      },
                    },
                  ],
                },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'count' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'media' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [{ kind: 'Field', name: { kind: 'Name', value: 'mediaId' } }],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  YiMediaCreate_MediaByContentIdQueryQuery,
  YiMediaCreate_MediaByContentIdQueryQueryVariables
>
export const MediaDetailsPageQueryDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'MediaDetailsPageQuery' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'mediaId' } },
          type: {
            kind: 'NonNullType',
            type: { kind: 'NamedType', name: { kind: 'Name', value: 'ID' } },
          },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'mediaList' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'where' },
                value: {
                  kind: 'ObjectValue',
                  fields: [
                    {
                      kind: 'ObjectField',
                      name: { kind: 'Name', value: 'mediaId' },
                      value: {
                        kind: 'ObjectValue',
                        fields: [
                          {
                            kind: 'ObjectField',
                            name: { kind: 'Name', value: 'eq' },
                            value: { kind: 'Variable', name: { kind: 'Name', value: 'mediaId' } },
                          },
                        ],
                      },
                    },
                  ],
                },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'media' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'mediaId' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'policyId' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'use' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'contentId' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'mediaMaestroTitleCode' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'subtype' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'filename' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'isPublished' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'createdAt' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'updatedAt' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'duration' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'aspectRatio' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'videoSize' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'framerate' } },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'mediaAssets' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            { kind: 'Field', name: { kind: 'Name', value: 'originalFileName' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'updatedAt' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'language' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'mediaReferenceType' } },
                          ],
                        },
                      },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<MediaDetailsPageQueryQuery, MediaDetailsPageQueryQueryVariables>
export const MediaListYiReferencesDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'MediaListYIReferences' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'mediaId' } },
          type: { kind: 'NamedType', name: { kind: 'Name', value: 'ID' } },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'mediaList' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'where' },
                value: {
                  kind: 'ObjectValue',
                  fields: [
                    {
                      kind: 'ObjectField',
                      name: { kind: 'Name', value: 'mediaId' },
                      value: {
                        kind: 'ObjectValue',
                        fields: [
                          {
                            kind: 'ObjectField',
                            name: { kind: 'Name', value: 'eq' },
                            value: { kind: 'Variable', name: { kind: 'Name', value: 'mediaId' } },
                          },
                        ],
                      },
                    },
                  ],
                },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'media' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'mediaId' } },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'contentFeatured' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'title' } },
                          ],
                        },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'contentPreview' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'title' } },
                          ],
                        },
                      },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<MediaListYiReferencesQuery, MediaListYiReferencesQueryVariables>
export const MediaListDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'MediaList' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'offset' } },
          type: { kind: 'NamedType', name: { kind: 'Name', value: 'Int' } },
          defaultValue: { kind: 'IntValue', value: '0' },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'limit' } },
          type: { kind: 'NamedType', name: { kind: 'Name', value: 'Int' } },
          defaultValue: { kind: 'IntValue', value: '25' },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'order' } },
          type: {
            kind: 'ListType',
            type: {
              kind: 'ListType',
              type: { kind: 'NamedType', name: { kind: 'Name', value: 'String' } },
            },
          },
          defaultValue: {
            kind: 'ListValue',
            values: [
              {
                kind: 'ListValue',
                values: [
                  { kind: 'StringValue', value: 'createdAt', block: false },
                  { kind: 'StringValue', value: 'desc', block: false },
                ],
              },
            ],
          },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'where' } },
          type: { kind: 'NamedType', name: { kind: 'Name', value: 'MediaWhereInput' } },
          defaultValue: { kind: 'ObjectValue', fields: [] },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'mediaList' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'limit' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'limit' } },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'offset' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'offset' } },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'order' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'order' } },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'where' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'where' } },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'count' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'media' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'mediaId' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'policyId' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'use' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'contentId' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'createdAt' } },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<MediaListQuery, MediaListQueryVariables>
export const ContentPolicyList_YiQueryDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'ContentPolicyList_YIQuery' },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'contentPolicyList' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'limit' },
                value: { kind: 'IntValue', value: '1000' },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'contentPolicies' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'policyId' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'name' } },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  ContentPolicyList_YiQueryQuery,
  ContentPolicyList_YiQueryQueryVariables
>
export const ContentAssetReferenceDeleteMutationDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'mutation',
      name: { kind: 'Name', value: 'ContentAssetReferenceDeleteMutation' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'contentAssetReference' } },
          type: {
            kind: 'NonNullType',
            type: {
              kind: 'NamedType',
              name: { kind: 'Name', value: 'ContentAssetReferenceDeleteInput' },
            },
          },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'contentAssetReferenceDelete' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'contentAssetReference' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'contentAssetReference' } },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [{ kind: 'Field', name: { kind: 'Name', value: 'success' } }],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  ContentAssetReferenceDeleteMutationMutation,
  ContentAssetReferenceDeleteMutationMutationVariables
>
export const ContentList_AllYiTagsListQueryDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'ContentList_AllYITagsListQuery' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'path' } },
          type: {
            kind: 'NonNullType',
            type: { kind: 'NamedType', name: { kind: 'Name', value: 'String' } },
          },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'offset' } },
          type: { kind: 'NamedType', name: { kind: 'Name', value: 'Int' } },
          defaultValue: { kind: 'IntValue', value: '0' },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'limit' } },
          type: { kind: 'NamedType', name: { kind: 'Name', value: 'Int' } },
          defaultValue: { kind: 'IntValue', value: '25' },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'language' } },
          type: {
            kind: 'ListType',
            type: {
              kind: 'NonNullType',
              type: { kind: 'NamedType', name: { kind: 'Name', value: 'String' } },
            },
          },
          defaultValue: {
            kind: 'ListValue',
            values: [{ kind: 'StringValue', value: 'en', block: false }],
          },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'contentList' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'offset' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'offset' } },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'limit' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'limit' } },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'where' },
                value: {
                  kind: 'ObjectValue',
                  fields: [
                    {
                      kind: 'ObjectField',
                      name: { kind: 'Name', value: 'contentType' },
                      value: {
                        kind: 'ObjectValue',
                        fields: [
                          {
                            kind: 'ObjectField',
                            name: { kind: 'Name', value: 'eq' },
                            value: { kind: 'StringValue', value: 'tag', block: false },
                          },
                        ],
                      },
                    },
                    {
                      kind: 'ObjectField',
                      name: { kind: 'Name', value: 'path' },
                      value: {
                        kind: 'ObjectValue',
                        fields: [
                          {
                            kind: 'ObjectField',
                            name: { kind: 'Name', value: 'ilike' },
                            value: { kind: 'Variable', name: { kind: 'Name', value: 'path' } },
                          },
                        ],
                      },
                    },
                    {
                      kind: 'ObjectField',
                      name: { kind: 'Name', value: 'language' },
                      value: {
                        kind: 'ObjectValue',
                        fields: [
                          {
                            kind: 'ObjectField',
                            name: { kind: 'Name', value: 'in' },
                            value: { kind: 'Variable', name: { kind: 'Name', value: 'language' } },
                          },
                        ],
                      },
                    },
                  ],
                },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'contentReferencesTo' },
                value: {
                  kind: 'ListValue',
                  values: [
                    {
                      kind: 'ObjectValue',
                      fields: [
                        {
                          kind: 'ObjectField',
                          name: { kind: 'Name', value: 'type' },
                          value: { kind: 'StringValue', value: 'yi-content-type', block: false },
                        },
                        {
                          kind: 'ObjectField',
                          name: { kind: 'Name', value: 'contentType' },
                          value: { kind: 'StringValue', value: 'tag', block: false },
                        },
                      ],
                    },
                  ],
                },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'content' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'language' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'title' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'contentId' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'contentType' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'published' } },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'contentProvider' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            {
                              kind: 'FragmentSpread',
                              name: { kind: 'Name', value: 'Content_ProviderCommonFragment' },
                            },
                            { kind: 'Field', name: { kind: 'Name', value: 'providerKey' } },
                          ],
                        },
                      },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'Content_ProviderCommonFragment' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'ContentProvider' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [{ kind: 'Field', name: { kind: 'Name', value: 'contentId' } }],
      },
    },
  ],
} as unknown as DocumentNode<
  ContentList_AllYiTagsListQueryQuery,
  ContentList_AllYiTagsListQueryQueryVariables
>
export const ContentList_YiSpecialTagsByTitlesDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'ContentList_YISpecialTagsByTitles' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'titles' } },
          type: {
            kind: 'ListType',
            type: {
              kind: 'NonNullType',
              type: { kind: 'NamedType', name: { kind: 'Name', value: 'String' } },
            },
          },
          defaultValue: { kind: 'ListValue', values: [] },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'contentPolicyPolicyId' } },
          type: {
            kind: 'NonNullType',
            type: { kind: 'NamedType', name: { kind: 'Name', value: 'Int' } },
          },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'contentList' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'where' },
                value: {
                  kind: 'ObjectValue',
                  fields: [
                    {
                      kind: 'ObjectField',
                      name: { kind: 'Name', value: 'contentType' },
                      value: {
                        kind: 'ObjectValue',
                        fields: [
                          {
                            kind: 'ObjectField',
                            name: { kind: 'Name', value: 'eq' },
                            value: { kind: 'StringValue', value: 'tag', block: false },
                          },
                        ],
                      },
                    },
                    {
                      kind: 'ObjectField',
                      name: { kind: 'Name', value: 'title' },
                      value: {
                        kind: 'ObjectValue',
                        fields: [
                          {
                            kind: 'ObjectField',
                            name: { kind: 'Name', value: 'in' },
                            value: { kind: 'Variable', name: { kind: 'Name', value: 'titles' } },
                          },
                        ],
                      },
                    },
                    {
                      kind: 'ObjectField',
                      name: { kind: 'Name', value: 'contentPolicyPolicyId' },
                      value: {
                        kind: 'ObjectValue',
                        fields: [
                          {
                            kind: 'ObjectField',
                            name: { kind: 'Name', value: 'eq' },
                            value: {
                              kind: 'Variable',
                              name: { kind: 'Name', value: 'contentPolicyPolicyId' },
                            },
                          },
                        ],
                      },
                    },
                  ],
                },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'referencesNot' },
                value: {
                  kind: 'ListValue',
                  values: [
                    {
                      kind: 'ObjectValue',
                      fields: [
                        {
                          kind: 'ObjectField',
                          name: { kind: 'Name', value: 'type' },
                          value: { kind: 'StringValue', value: 'yi-content-type', block: false },
                        },
                        {
                          kind: 'ObjectField',
                          name: { kind: 'Name', value: 'contentType' },
                          value: { kind: 'StringValue', value: 'tag', block: false },
                        },
                      ],
                    },
                  ],
                },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'content' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'language' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'title' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'contentId' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'contentType' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'published' } },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'contentProvider' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            {
                              kind: 'FragmentSpread',
                              name: { kind: 'Name', value: 'Content_ProviderCommonFragment' },
                            },
                            { kind: 'Field', name: { kind: 'Name', value: 'providerKey' } },
                          ],
                        },
                      },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'Content_ProviderCommonFragment' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'ContentProvider' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [{ kind: 'Field', name: { kind: 'Name', value: 'contentId' } }],
      },
    },
  ],
} as unknown as DocumentNode<
  ContentList_YiSpecialTagsByTitlesQuery,
  ContentList_YiSpecialTagsByTitlesQueryVariables
>
export const ContentList_YiTagsListByGroupQueryDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'ContentList_YITagsListByGroupQuery' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'path' } },
          type: {
            kind: 'NonNullType',
            type: { kind: 'NamedType', name: { kind: 'Name', value: 'String' } },
          },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'offset' } },
          type: { kind: 'NamedType', name: { kind: 'Name', value: 'Int' } },
          defaultValue: { kind: 'IntValue', value: '0' },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'limit' } },
          type: { kind: 'NamedType', name: { kind: 'Name', value: 'Int' } },
          defaultValue: { kind: 'IntValue', value: '25' },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'language' } },
          type: {
            kind: 'ListType',
            type: {
              kind: 'NonNullType',
              type: { kind: 'NamedType', name: { kind: 'Name', value: 'String' } },
            },
          },
          defaultValue: {
            kind: 'ListValue',
            values: [{ kind: 'StringValue', value: 'en', block: false }],
          },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'contentReferencesTo' } },
          type: {
            kind: 'ListType',
            type: {
              kind: 'NamedType',
              name: { kind: 'Name', value: 'ContentContentReferencesToFilterInput' },
            },
          },
          defaultValue: { kind: 'ListValue', values: [] },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'contentList' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'offset' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'offset' } },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'limit' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'limit' } },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'where' },
                value: {
                  kind: 'ObjectValue',
                  fields: [
                    {
                      kind: 'ObjectField',
                      name: { kind: 'Name', value: 'contentType' },
                      value: {
                        kind: 'ObjectValue',
                        fields: [
                          {
                            kind: 'ObjectField',
                            name: { kind: 'Name', value: 'eq' },
                            value: { kind: 'StringValue', value: 'tag', block: false },
                          },
                        ],
                      },
                    },
                    {
                      kind: 'ObjectField',
                      name: { kind: 'Name', value: 'path' },
                      value: {
                        kind: 'ObjectValue',
                        fields: [
                          {
                            kind: 'ObjectField',
                            name: { kind: 'Name', value: 'eq' },
                            value: { kind: 'Variable', name: { kind: 'Name', value: 'path' } },
                          },
                        ],
                      },
                    },
                    {
                      kind: 'ObjectField',
                      name: { kind: 'Name', value: 'language' },
                      value: {
                        kind: 'ObjectValue',
                        fields: [
                          {
                            kind: 'ObjectField',
                            name: { kind: 'Name', value: 'in' },
                            value: { kind: 'Variable', name: { kind: 'Name', value: 'language' } },
                          },
                        ],
                      },
                    },
                  ],
                },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'contentReferencesTo' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'contentReferencesTo' } },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'content' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'contentReferencesTo' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'contentFrom' },
                              arguments: [
                                {
                                  kind: 'Argument',
                                  name: { kind: 'Name', value: 'language' },
                                  value: {
                                    kind: 'Variable',
                                    name: { kind: 'Name', value: 'language' },
                                  },
                                },
                              ],
                              selectionSet: {
                                kind: 'SelectionSet',
                                selections: [
                                  { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                                  { kind: 'Field', name: { kind: 'Name', value: 'language' } },
                                  { kind: 'Field', name: { kind: 'Name', value: 'title' } },
                                  { kind: 'Field', name: { kind: 'Name', value: 'contentId' } },
                                  { kind: 'Field', name: { kind: 'Name', value: 'contentType' } },
                                  { kind: 'Field', name: { kind: 'Name', value: 'published' } },
                                  {
                                    kind: 'Field',
                                    name: { kind: 'Name', value: 'contentProvider' },
                                    selectionSet: {
                                      kind: 'SelectionSet',
                                      selections: [
                                        {
                                          kind: 'FragmentSpread',
                                          name: {
                                            kind: 'Name',
                                            value: 'Content_ProviderCommonFragment',
                                          },
                                        },
                                        {
                                          kind: 'Field',
                                          name: { kind: 'Name', value: 'providerKey' },
                                        },
                                      ],
                                    },
                                  },
                                ],
                              },
                            },
                          ],
                        },
                      },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'Content_ProviderCommonFragment' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'ContentProvider' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [{ kind: 'Field', name: { kind: 'Name', value: 'contentId' } }],
      },
    },
  ],
} as unknown as DocumentNode<
  ContentList_YiTagsListByGroupQueryQuery,
  ContentList_YiTagsListByGroupQueryQueryVariables
>
export const ContentReferenceCreateManyDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'mutation',
      name: { kind: 'Name', value: 'ContentReferenceCreateMany' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'contentReferences' } },
          type: {
            kind: 'NonNullType',
            type: {
              kind: 'ListType',
              type: {
                kind: 'NonNullType',
                type: {
                  kind: 'NamedType',
                  name: { kind: 'Name', value: 'ContentReferenceCreateInput' },
                },
              },
            },
          },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'deleteOmittedReferences' } },
          type: { kind: 'NamedType', name: { kind: 'Name', value: 'Boolean' } },
          defaultValue: { kind: 'BooleanValue', value: false },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'contentReferenceCreateMany' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'contentReferences' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'contentReferences' } },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'deleteOmittedReferences' },
                value: {
                  kind: 'Variable',
                  name: { kind: 'Name', value: 'deleteOmittedReferences' },
                },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'contentReferences' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'sortKey' } },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  ContentReferenceCreateManyMutation,
  ContentReferenceCreateManyMutationVariables
>
export const ContentReferenceDeleteDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'mutation',
      name: { kind: 'Name', value: 'ContentReferenceDelete' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'contentReference' } },
          type: { kind: 'NamedType', name: { kind: 'Name', value: 'ContentReferenceDeleteInput' } },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'contentReferenceDelete' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'contentReference' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'contentReference' } },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'contentReference' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'fromContentContentId' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'fromContentContentType' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'toContentContentId' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'toContentContentType' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'contentReferenceTypesId' } },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  ContentReferenceDeleteMutation,
  ContentReferenceDeleteMutationVariables
>
export const UpdateProviderMetadataDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'mutation',
      name: { kind: 'Name', value: 'UpdateProviderMetadata' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'contentProvider' } },
          type: {
            kind: 'NonNullType',
            type: {
              kind: 'NamedType',
              name: { kind: 'Name', value: 'ContentProviderUpdateByContentIdInput' },
            },
          },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'contentProviderUpdateByContentId' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'contentProvider' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'contentProvider' } },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'contentProvider' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {
                        kind: 'FragmentSpread',
                        name: { kind: 'Name', value: 'Content_ProviderCommonFragment' },
                      },
                      { kind: 'Field', name: { kind: 'Name', value: 'metadata' } },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'Content_ProviderCommonFragment' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'ContentProvider' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [{ kind: 'Field', name: { kind: 'Name', value: 'contentId' } }],
      },
    },
  ],
} as unknown as DocumentNode<
  UpdateProviderMetadataMutation,
  UpdateProviderMetadataMutationVariables
>
export const YiContentListDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'YIContentList' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'offset' } },
          type: { kind: 'NamedType', name: { kind: 'Name', value: 'Int' } },
          defaultValue: { kind: 'IntValue', value: '0' },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'limit' } },
          type: { kind: 'NamedType', name: { kind: 'Name', value: 'Int' } },
          defaultValue: { kind: 'IntValue', value: '25' },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'order' } },
          type: {
            kind: 'ListType',
            type: {
              kind: 'ListType',
              type: { kind: 'NamedType', name: { kind: 'Name', value: 'String' } },
            },
          },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'where' } },
          type: { kind: 'NamedType', name: { kind: 'Name', value: 'ContentWhereInput' } },
          defaultValue: { kind: 'ObjectValue', fields: [] },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'contentReferencesTo' } },
          type: {
            kind: 'ListType',
            type: {
              kind: 'NamedType',
              name: { kind: 'Name', value: 'ContentContentReferencesToFilterInput' },
            },
          },
          defaultValue: { kind: 'ListValue', values: [] },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'contentList' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'offset' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'offset' } },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'limit' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'limit' } },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'order' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'order' } },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'where' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'where' } },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'contentReferencesTo' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'contentReferencesTo' } },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'content' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {
                        kind: 'FragmentSpread',
                        name: { kind: 'Name', value: 'Common_ContentFragment' },
                      },
                      {
                        kind: 'FragmentSpread',
                        name: { kind: 'Name', value: 'YIClass_ContentFragment' },
                      },
                      {
                        kind: 'FragmentSpread',
                        name: { kind: 'Name', value: 'GaiaVideo_ContentFragment' },
                      },
                      {
                        kind: 'FragmentSpread',
                        name: { kind: 'Name', value: 'YICourse_ContentFragment' },
                      },
                      {
                        kind: 'FragmentSpread',
                        name: { kind: 'Name', value: 'YICourseSection_ContentFragment' },
                      },
                      {
                        kind: 'FragmentSpread',
                        name: { kind: 'Name', value: 'YIPose_ContentFragment' },
                      },
                      {
                        kind: 'FragmentSpread',
                        name: { kind: 'Name', value: 'YICourseSales_ContentFragment' },
                      },
                      {
                        kind: 'FragmentSpread',
                        name: { kind: 'Name', value: 'YIMemberPromo_ContentFragment' },
                      },
                      {
                        kind: 'FragmentSpread',
                        name: { kind: 'Name', value: 'YIHomepageHero_ContentFragment' },
                      },
                      {
                        kind: 'FragmentSpread',
                        name: { kind: 'Name', value: 'YISeries_ContentFragment' },
                      },
                      {
                        kind: 'FragmentSpread',
                        name: { kind: 'Name', value: 'YIArticle_ContentFragment' },
                      },
                      {
                        kind: 'FragmentSpread',
                        name: { kind: 'Name', value: 'YICourseModule_ContentFragment' },
                      },
                      {
                        kind: 'FragmentSpread',
                        name: { kind: 'Name', value: 'YITeacher_ContentFragment' },
                      },
                      {
                        kind: 'FragmentSpread',
                        name: { kind: 'Name', value: 'YITag_ContentFragment' },
                      },
                      {
                        kind: 'FragmentSpread',
                        name: { kind: 'Name', value: 'YITagGroup_ContentFragment' },
                      },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'Content_ProviderCommonFragment' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'ContentProvider' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [{ kind: 'Field', name: { kind: 'Name', value: 'contentId' } }],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'Common_ContentProviderFragment' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'Content' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'contentProvider' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'provider' } },
                { kind: 'Field', name: { kind: 'Name', value: 'providerKey' } },
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'Content_ProviderCommonFragment' },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'Common_MediaFragment' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'Media' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'mediaId' } },
          { kind: 'Field', name: { kind: 'Name', value: 'contentId' } },
          { kind: 'Field', name: { kind: 'Name', value: 'mediaMaestroTitleCode' } },
          { kind: 'Field', name: { kind: 'Name', value: 'policyId' } },
          { kind: 'Field', name: { kind: 'Name', value: 'updatedAt' } },
          { kind: 'Field', name: { kind: 'Name', value: 'duration' } },
          { kind: 'Field', name: { kind: 'Name', value: 'isPublished' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'mediaAssets' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                { kind: 'Field', name: { kind: 'Name', value: 'providerKey' } },
              ],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'ContentFeatureMediaFragment' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'Content' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'contentPolicyPolicyId' } },
          { kind: 'Field', name: { kind: 'Name', value: 'featureMediaId' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'featureMedia' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'FragmentSpread', name: { kind: 'Name', value: 'Common_MediaFragment' } },
              ],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'ContentDetails_Tag_ContentReferenceFragment' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'ContentReference' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          { kind: 'Field', name: { kind: 'Name', value: 'sortKey' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'contentReferenceType' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [{ kind: 'Field', name: { kind: 'Name', value: 'type' } }],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'contentTo' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'language' },
                value: {
                  kind: 'ListValue',
                  values: [
                    { kind: 'StringValue', value: 'en', block: false },
                    { kind: 'StringValue', value: '_primary', block: false },
                  ],
                },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                { kind: 'Field', name: { kind: 'Name', value: 'titleGroupId' } },
                { kind: 'Field', name: { kind: 'Name', value: 'title' } },
                { kind: 'Field', name: { kind: 'Name', value: 'contentId' } },
                { kind: 'Field', name: { kind: 'Name', value: 'contentType' } },
                { kind: 'Field', name: { kind: 'Name', value: 'published' } },
              ],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'ContentDetails_Person_ContentFragment' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'Content' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          { kind: 'Field', name: { kind: 'Name', value: 'title' } },
          { kind: 'Field', name: { kind: 'Name', value: 'language' } },
          { kind: 'Field', name: { kind: 'Name', value: 'contentType' } },
          { kind: 'Field', name: { kind: 'Name', value: 'contentId' } },
          { kind: 'Field', name: { kind: 'Name', value: 'published' } },
          {
            kind: 'Field',
            alias: { kind: 'Name', value: 'avatar' },
            name: { kind: 'Name', value: 'imageContentRelationships' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                { kind: 'Field', name: { kind: 'Name', value: 'type' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'image' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'url' } },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'ContentDetails_Person_ContentReferenceFragment' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'ContentReference' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          { kind: 'Field', name: { kind: 'Name', value: 'sortKey' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'contentReferenceType' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                { kind: 'Field', name: { kind: 'Name', value: 'type' } },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'contentTo' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'ContentDetails_Person_ContentFragment' },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'Content_ProviderMetadataFragment' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'Content' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            alias: { kind: 'Name', value: 'providerMetadata' },
            name: { kind: 'Name', value: 'contentProvider' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'metadata' } },
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'Content_ProviderCommonFragment' },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'YICourse_ModuleDetailsContentFragment' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'Content' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'title' } },
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          { kind: 'Field', name: { kind: 'Name', value: 'contentType' } },
          { kind: 'Field', name: { kind: 'Name', value: 'contentId' } },
          { kind: 'Field', name: { kind: 'Name', value: 'published' } },
          {
            kind: 'Field',
            alias: { kind: 'Name', value: 'yiCourseModuleType' },
            name: { kind: 'Name', value: 'contentReferencesFrom' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'types' },
                value: { kind: 'StringValue', value: 'yi-course-module-type', block: false },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'ContentDetails_Tag_ContentReferenceFragment' },
                },
              ],
            },
          },
          {
            kind: 'FragmentSpread',
            name: { kind: 'Name', value: 'Content_ProviderMetadataFragment' },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'YICourse_ModulesContentReferenceFragment' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'ContentReference' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'sortKey' } },
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'contentReferenceType' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [{ kind: 'Field', name: { kind: 'Name', value: 'type' } }],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'contentTo' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'YICourse_ModuleDetailsContentFragment' },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'ContentPreviewMediaFragment' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'Content' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'contentPolicyPolicyId' } },
          { kind: 'Field', name: { kind: 'Name', value: 'previewMediaId' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'previewMedia' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'FragmentSpread', name: { kind: 'Name', value: 'Common_MediaFragment' } },
              ],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'YISeries_EpisodeDetailsContentFragment' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'Content' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'title' } },
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          { kind: 'Field', name: { kind: 'Name', value: 'contentType' } },
          { kind: 'Field', name: { kind: 'Name', value: 'contentId' } },
          { kind: 'Field', name: { kind: 'Name', value: 'published' } },
          { kind: 'Field', name: { kind: 'Name', value: 'seasonNumber' } },
          { kind: 'Field', name: { kind: 'Name', value: 'episodeNumber' } },
          {
            kind: 'FragmentSpread',
            name: { kind: 'Name', value: 'Content_ProviderMetadataFragment' },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'YISeries_EpisodeContentFragment' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'ContentReference' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          { kind: 'Field', name: { kind: 'Name', value: 'sortKey' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'contentReferenceType' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [{ kind: 'Field', name: { kind: 'Name', value: 'type' } }],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'contentTo' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'YISeries_EpisodeDetailsContentFragment' },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'ContentDetails_ContentAssetReferenceFragment' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'ContentAssetReference' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'asset' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                { kind: 'Field', name: { kind: 'Name', value: 'mimeType' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'contentAssetReference' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [{ kind: 'Field', name: { kind: 'Name', value: 'assetsId' } }],
                  },
                },
                { kind: 'Field', name: { kind: 'Name', value: 'fileSize' } },
                { kind: 'Field', name: { kind: 'Name', value: 'originalFileName' } },
                { kind: 'Field', name: { kind: 'Name', value: 'renderUrl' } },
              ],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'YICourseModuleDownload_ContentFragment' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'Content' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            alias: { kind: 'Name', value: 'yiCourseModuleDownload' },
            name: { kind: 'Name', value: 'contentAssetReferences' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'contentAssetReferences' },
                value: {
                  kind: 'ObjectValue',
                  fields: [
                    {
                      kind: 'ObjectField',
                      name: { kind: 'Name', value: 'type' },
                      value: {
                        kind: 'StringValue',
                        value: 'yi-course-module-download',
                        block: false,
                      },
                    },
                  ],
                },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'ContentDetails_ContentAssetReferenceFragment' },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'Common_ContentFragment' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'Content' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          { kind: 'Field', name: { kind: 'Name', value: 'contentId' } },
          { kind: 'Field', name: { kind: 'Name', value: 'contentType' } },
          { kind: 'Field', name: { kind: 'Name', value: 'published' } },
          { kind: 'Field', name: { kind: 'Name', value: 'publishedAtDate' } },
          { kind: 'Field', name: { kind: 'Name', value: 'createdAt' } },
          { kind: 'Field', name: { kind: 'Name', value: 'updatedAt' } },
          { kind: 'Field', name: { kind: 'Name', value: 'title' } },
          { kind: 'Field', name: { kind: 'Name', value: 'path' } },
          { kind: 'Field', name: { kind: 'Name', value: 'shortDescription' } },
          { kind: 'Field', name: { kind: 'Name', value: 'description' } },
          { kind: 'Field', name: { kind: 'Name', value: 'language' } },
          { kind: 'Field', name: { kind: 'Name', value: 'contentPolicyPolicyId' } },
          {
            kind: 'FragmentSpread',
            name: { kind: 'Name', value: 'Common_ContentProviderFragment' },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'YIClass_ContentFragment' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'Content' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'descriptionFormat' } },
          { kind: 'Field', name: { kind: 'Name', value: 'shortDescriptionFormat' } },
          { kind: 'Field', name: { kind: 'Name', value: 'displayType' } },
          { kind: 'Field', name: { kind: 'Name', value: 'primaryLanguage' } },
          { kind: 'Field', name: { kind: 'Name', value: 'productType' } },
          { kind: 'Field', name: { kind: 'Name', value: 'seoDescription' } },
          { kind: 'Field', name: { kind: 'Name', value: 'seoTitle' } },
          { kind: 'FragmentSpread', name: { kind: 'Name', value: 'ContentFeatureMediaFragment' } },
          {
            kind: 'Field',
            alias: { kind: 'Name', value: 'yiContentType' },
            name: { kind: 'Name', value: 'contentReferencesFrom' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'types' },
                value: { kind: 'StringValue', value: 'yi-content-type', block: false },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'ContentDetails_Tag_ContentReferenceFragment' },
                },
              ],
            },
          },
          {
            kind: 'Field',
            alias: { kind: 'Name', value: 'yiTags' },
            name: { kind: 'Name', value: 'contentReferencesFrom' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'types' },
                value: { kind: 'StringValue', value: 'yi-tag', block: false },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'ContentDetails_Tag_ContentReferenceFragment' },
                },
              ],
            },
          },
          {
            kind: 'Field',
            alias: { kind: 'Name', value: 'yiYogaStyle' },
            name: { kind: 'Name', value: 'contentReferencesFrom' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'types' },
                value: { kind: 'StringValue', value: 'yi-yoga-style', block: false },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'ContentDetails_Tag_ContentReferenceFragment' },
                },
              ],
            },
          },
          {
            kind: 'Field',
            alias: { kind: 'Name', value: 'yiYogaLevel' },
            name: { kind: 'Name', value: 'contentReferencesFrom' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'types' },
                value: { kind: 'StringValue', value: 'yi-yoga-level', block: false },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'ContentDetails_Tag_ContentReferenceFragment' },
                },
              ],
            },
          },
          {
            kind: 'Field',
            alias: { kind: 'Name', value: 'yiYogaTeacher' },
            name: { kind: 'Name', value: 'contentReferencesFrom' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'types' },
                value: { kind: 'StringValue', value: 'yi-yoga-teacher', block: false },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'ContentDetails_Person_ContentReferenceFragment' },
                },
              ],
            },
          },
          {
            kind: 'Field',
            alias: { kind: 'Name', value: 'yiPracticeType' },
            name: { kind: 'Name', value: 'contentReferencesFrom' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'types' },
                value: { kind: 'StringValue', value: 'yi-practice-type', block: false },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'ContentDetails_Tag_ContentReferenceFragment' },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'GaiaVideo_ContentFragment' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'Content' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'episodeNumber' } },
          { kind: 'Field', name: { kind: 'Name', value: 'seasonNumber' } },
          { kind: 'Field', name: { kind: 'Name', value: 'director' } },
          { kind: 'Field', name: { kind: 'Name', value: 'producer' } },
          { kind: 'Field', name: { kind: 'Name', value: 'writer' } },
          { kind: 'Field', name: { kind: 'Name', value: 'studio' } },
          { kind: 'Field', name: { kind: 'Name', value: 'copyright' } },
          { kind: 'Field', name: { kind: 'Name', value: 'instructor' } },
          { kind: 'Field', name: { kind: 'Name', value: 'cast' } },
          { kind: 'Field', name: { kind: 'Name', value: 'productType' } },
          { kind: 'Field', name: { kind: 'Name', value: 'displayType' } },
          { kind: 'Field', name: { kind: 'Name', value: 'seoTitle' } },
          { kind: 'Field', name: { kind: 'Name', value: 'seoDescription' } },
          { kind: 'Field', name: { kind: 'Name', value: 'seoKeywords' } },
          { kind: 'Field', name: { kind: 'Name', value: 'seoRobotsNoFollow' } },
          { kind: 'Field', name: { kind: 'Name', value: 'seoRobotsNoIndex' } },
          { kind: 'Field', name: { kind: 'Name', value: 'excludeFromRecommendations' } },
          { kind: 'Field', name: { kind: 'Name', value: 'contentSearchNoIndex' } },
          {
            kind: 'Field',
            alias: { kind: 'Name', value: 'adminCategory' },
            name: { kind: 'Name', value: 'contentReferencesFrom' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'types' },
                value: { kind: 'StringValue', value: 'admin_category', block: false },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'ContentDetails_Tag_ContentReferenceFragment' },
                },
              ],
            },
          },
          {
            kind: 'Field',
            alias: { kind: 'Name', value: 'category' },
            name: { kind: 'Name', value: 'contentReferencesFrom' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'types' },
                value: { kind: 'StringValue', value: 'category', block: false },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'ContentDetails_Tag_ContentReferenceFragment' },
                },
              ],
            },
          },
          {
            kind: 'Field',
            alias: { kind: 'Name', value: 'centers' },
            name: { kind: 'Name', value: 'contentReferencesFrom' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'types' },
                value: { kind: 'StringValue', value: 'centers', block: false },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'ContentDetails_Tag_ContentReferenceFragment' },
                },
              ],
            },
          },
          {
            kind: 'Field',
            alias: { kind: 'Name', value: 'contentOrigin' },
            name: { kind: 'Name', value: 'contentReferencesFrom' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'types' },
                value: { kind: 'StringValue', value: 'content_origin', block: false },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'ContentDetails_Tag_ContentReferenceFragment' },
                },
              ],
            },
          },
          {
            kind: 'Field',
            alias: { kind: 'Name', value: 'consciousFormat' },
            name: { kind: 'Name', value: 'contentReferencesFrom' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'types' },
                value: { kind: 'StringValue', value: 'conscious-format', block: false },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'ContentDetails_Tag_ContentReferenceFragment' },
                },
              ],
            },
          },
          {
            kind: 'Field',
            alias: { kind: 'Name', value: 'consciousTopic' },
            name: { kind: 'Name', value: 'contentReferencesFrom' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'types' },
                value: { kind: 'StringValue', value: 'conscious-topic', block: false },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'ContentDetails_Tag_ContentReferenceFragment' },
                },
              ],
            },
          },
          {
            kind: 'Field',
            alias: { kind: 'Name', value: 'filmSubject' },
            name: { kind: 'Name', value: 'contentReferencesFrom' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'types' },
                value: { kind: 'StringValue', value: 'film-subject', block: false },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'ContentDetails_Tag_ContentReferenceFragment' },
                },
              ],
            },
          },
          {
            kind: 'Field',
            alias: { kind: 'Name', value: 'filmType' },
            name: { kind: 'Name', value: 'contentReferencesFrom' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'types' },
                value: { kind: 'StringValue', value: 'film-type', block: false },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'ContentDetails_Tag_ContentReferenceFragment' },
                },
              ],
            },
          },
          {
            kind: 'Field',
            alias: { kind: 'Name', value: 'fitnessDuration' },
            name: { kind: 'Name', value: 'contentReferencesFrom' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'types' },
                value: { kind: 'StringValue', value: 'fitness-duration', block: false },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'ContentDetails_Tag_ContentReferenceFragment' },
                },
              ],
            },
          },
          {
            kind: 'Field',
            alias: { kind: 'Name', value: 'fitnessLevel' },
            name: { kind: 'Name', value: 'contentReferencesFrom' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'types' },
                value: { kind: 'StringValue', value: 'fitness-level', block: false },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'ContentDetails_Tag_ContentReferenceFragment' },
                },
              ],
            },
          },
          {
            kind: 'Field',
            alias: { kind: 'Name', value: 'fitnessInstructor' },
            name: { kind: 'Name', value: 'contentReferencesFrom' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'types' },
                value: { kind: 'StringValue', value: 'fitness-instructor', block: false },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'ContentDetails_Tag_ContentReferenceFragment' },
                },
              ],
            },
          },
          {
            kind: 'Field',
            alias: { kind: 'Name', value: 'fitnessSpecialty' },
            name: { kind: 'Name', value: 'contentReferencesFrom' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'types' },
                value: { kind: 'StringValue', value: 'fitness-specialty', block: false },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'ContentDetails_Tag_ContentReferenceFragment' },
                },
              ],
            },
          },
          {
            kind: 'Field',
            alias: { kind: 'Name', value: 'fitnessStyle' },
            name: { kind: 'Name', value: 'contentReferencesFrom' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'types' },
                value: { kind: 'StringValue', value: 'fitness-style', block: false },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'ContentDetails_Tag_ContentReferenceFragment' },
                },
              ],
            },
          },
          {
            kind: 'Field',
            alias: { kind: 'Name', value: 'genres' },
            name: { kind: 'Name', value: 'contentReferencesFrom' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'types' },
                value: { kind: 'StringValue', value: 'genres', block: false },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'ContentDetails_Tag_ContentReferenceFragment' },
                },
              ],
            },
          },
          {
            kind: 'Field',
            alias: { kind: 'Name', value: 'interviewGuest' },
            name: { kind: 'Name', value: 'contentReferencesFrom' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'types' },
                value: { kind: 'StringValue', value: 'interview-guest', block: false },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'ContentDetails_Tag_ContentReferenceFragment' },
                },
              ],
            },
          },
          {
            kind: 'Field',
            alias: { kind: 'Name', value: 'interviewHost' },
            name: { kind: 'Name', value: 'contentReferencesFrom' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'types' },
                value: { kind: 'StringValue', value: 'interview-host', block: false },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'ContentDetails_Tag_ContentReferenceFragment' },
                },
              ],
            },
          },
          {
            kind: 'Field',
            alias: { kind: 'Name', value: 'marketingCenters' },
            name: { kind: 'Name', value: 'contentReferencesFrom' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'types' },
                value: { kind: 'StringValue', value: 'marketing-centers', block: false },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'ContentDetails_Tag_ContentReferenceFragment' },
                },
              ],
            },
          },
          {
            kind: 'Field',
            alias: { kind: 'Name', value: 'meditationFocus' },
            name: { kind: 'Name', value: 'contentReferencesFrom' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'types' },
                value: { kind: 'StringValue', value: 'fitness-style', block: false },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'ContentDetails_Tag_ContentReferenceFragment' },
                },
              ],
            },
          },
          {
            kind: 'Field',
            alias: { kind: 'Name', value: 'meditationStyle' },
            name: { kind: 'Name', value: 'contentReferencesFrom' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'types' },
                value: { kind: 'StringValue', value: 'meditation-style', block: false },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'ContentDetails_Tag_ContentReferenceFragment' },
                },
              ],
            },
          },
          {
            kind: 'Field',
            alias: { kind: 'Name', value: 'meditationTeacher' },
            name: { kind: 'Name', value: 'contentReferencesFrom' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'types' },
                value: { kind: 'StringValue', value: 'meditation-teacher', block: false },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'ContentDetails_Tag_ContentReferenceFragment' },
                },
              ],
            },
          },
          {
            kind: 'Field',
            alias: { kind: 'Name', value: 'meditationDuration' },
            name: { kind: 'Name', value: 'contentReferencesFrom' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'types' },
                value: { kind: 'StringValue', value: 'meditation-duration', block: false },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'ContentDetails_Tag_ContentReferenceFragment' },
                },
              ],
            },
          },
          {
            kind: 'Field',
            alias: { kind: 'Name', value: 'onboardingChoices' },
            name: { kind: 'Name', value: 'contentReferencesFrom' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'types' },
                value: { kind: 'StringValue', value: 'onboarding_choices', block: false },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'ContentDetails_Tag_ContentReferenceFragment' },
                },
              ],
            },
          },
          {
            kind: 'Field',
            alias: { kind: 'Name', value: 'product' },
            name: { kind: 'Name', value: 'contentReferencesFrom' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'types' },
                value: { kind: 'StringValue', value: 'product', block: false },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'ContentDetails_Tag_ContentReferenceFragment' },
                },
              ],
            },
          },
          {
            kind: 'Field',
            alias: { kind: 'Name', value: 'rainbowCategory' },
            name: { kind: 'Name', value: 'contentReferencesFrom' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'types' },
                value: { kind: 'StringValue', value: 'rainbow-category', block: false },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'ContentDetails_Tag_ContentReferenceFragment' },
                },
              ],
            },
          },
          {
            kind: 'Field',
            alias: { kind: 'Name', value: 'recipeDiet' },
            name: { kind: 'Name', value: 'contentReferencesFrom' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'types' },
                value: { kind: 'StringValue', value: 'recipe-diet', block: false },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'ContentDetails_Tag_ContentReferenceFragment' },
                },
              ],
            },
          },
          {
            kind: 'Field',
            alias: { kind: 'Name', value: 'recipeType' },
            name: { kind: 'Name', value: 'contentReferencesFrom' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'types' },
                value: { kind: 'StringValue', value: 'recipe-type', block: false },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'ContentDetails_Tag_ContentReferenceFragment' },
                },
              ],
            },
          },
          {
            kind: 'Field',
            alias: { kind: 'Name', value: 'series' },
            name: { kind: 'Name', value: 'contentReferencesFrom' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'types' },
                value: { kind: 'StringValue', value: 'series', block: false },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'ContentDetails_Tag_ContentReferenceFragment' },
                },
              ],
            },
          },
          {
            kind: 'Field',
            alias: { kind: 'Name', value: 'similarVideos' },
            name: { kind: 'Name', value: 'contentReferencesFrom' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'types' },
                value: { kind: 'StringValue', value: 'similar-videos', block: false },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'ContentDetails_Tag_ContentReferenceFragment' },
                },
              ],
            },
          },
          {
            kind: 'Field',
            alias: { kind: 'Name', value: 'thirdPartyGenre' },
            name: { kind: 'Name', value: 'contentReferencesFrom' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'types' },
                value: { kind: 'StringValue', value: 'third-party-genre', block: false },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'ContentDetails_Tag_ContentReferenceFragment' },
                },
              ],
            },
          },
          {
            kind: 'Field',
            alias: { kind: 'Name', value: 'videoCollection' },
            name: { kind: 'Name', value: 'contentReferencesFrom' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'types' },
                value: { kind: 'StringValue', value: 'video-collection', block: false },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'ContentDetails_Tag_ContentReferenceFragment' },
                },
              ],
            },
          },
          {
            kind: 'Field',
            alias: { kind: 'Name', value: 'videoTopic' },
            name: { kind: 'Name', value: 'contentReferencesFrom' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'types' },
                value: { kind: 'StringValue', value: 'video-topic', block: false },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'ContentDetails_Tag_ContentReferenceFragment' },
                },
              ],
            },
          },
          {
            kind: 'Field',
            alias: { kind: 'Name', value: 'yogaDuration' },
            name: { kind: 'Name', value: 'contentReferencesFrom' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'types' },
                value: { kind: 'StringValue', value: 'yoga-duration', block: false },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'ContentDetails_Tag_ContentReferenceFragment' },
                },
              ],
            },
          },
          {
            kind: 'Field',
            alias: { kind: 'Name', value: 'yogaFocus' },
            name: { kind: 'Name', value: 'contentReferencesFrom' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'types' },
                value: { kind: 'StringValue', value: 'yoga-focus', block: false },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'ContentDetails_Tag_ContentReferenceFragment' },
                },
              ],
            },
          },
          {
            kind: 'Field',
            alias: { kind: 'Name', value: 'yogaLevel' },
            name: { kind: 'Name', value: 'contentReferencesFrom' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'types' },
                value: { kind: 'StringValue', value: 'yoga-level', block: false },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'ContentDetails_Tag_ContentReferenceFragment' },
                },
              ],
            },
          },
          {
            kind: 'Field',
            alias: { kind: 'Name', value: 'yogaStyle' },
            name: { kind: 'Name', value: 'contentReferencesFrom' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'types' },
                value: { kind: 'StringValue', value: 'yoga-style', block: false },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'ContentDetails_Tag_ContentReferenceFragment' },
                },
              ],
            },
          },
          {
            kind: 'Field',
            alias: { kind: 'Name', value: 'yogaTeacher' },
            name: { kind: 'Name', value: 'contentReferencesFrom' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'types' },
                value: { kind: 'StringValue', value: 'yoga-teacher', block: false },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'ContentDetails_Tag_ContentReferenceFragment' },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'YICourse_ContentFragment' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'Content' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          { kind: 'Field', name: { kind: 'Name', value: 'contentId' } },
          { kind: 'Field', name: { kind: 'Name', value: 'contentType' } },
          { kind: 'Field', name: { kind: 'Name', value: 'published' } },
          { kind: 'Field', name: { kind: 'Name', value: 'publishedAtDate' } },
          { kind: 'Field', name: { kind: 'Name', value: 'createdAt' } },
          { kind: 'Field', name: { kind: 'Name', value: 'updatedAt' } },
          { kind: 'Field', name: { kind: 'Name', value: 'title' } },
          { kind: 'Field', name: { kind: 'Name', value: 'path' } },
          { kind: 'Field', name: { kind: 'Name', value: 'shortDescription' } },
          { kind: 'Field', name: { kind: 'Name', value: 'description' } },
          { kind: 'Field', name: { kind: 'Name', value: 'language' } },
          { kind: 'Field', name: { kind: 'Name', value: 'seoDescription' } },
          { kind: 'Field', name: { kind: 'Name', value: 'seoTitle' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'contentProvider' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'provider' } },
                { kind: 'Field', name: { kind: 'Name', value: 'providerKey' } },
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'Content_ProviderCommonFragment' },
                },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'contentPolicy' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'policyId' } },
                { kind: 'Field', name: { kind: 'Name', value: 'name' } },
              ],
            },
          },
          { kind: 'Field', name: { kind: 'Name', value: 'descriptionFormat' } },
          { kind: 'Field', name: { kind: 'Name', value: 'shortDescriptionFormat' } },
          { kind: 'Field', name: { kind: 'Name', value: 'displayType' } },
          { kind: 'Field', name: { kind: 'Name', value: 'featureMediaId' } },
          { kind: 'Field', name: { kind: 'Name', value: 'primaryLanguage' } },
          { kind: 'Field', name: { kind: 'Name', value: 'productType' } },
          { kind: 'Field', name: { kind: 'Name', value: 'seoDescription' } },
          { kind: 'Field', name: { kind: 'Name', value: 'seoTitle' } },
          {
            kind: 'Field',
            alias: { kind: 'Name', value: 'yiContentType' },
            name: { kind: 'Name', value: 'contentReferencesFrom' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'types' },
                value: { kind: 'StringValue', value: 'yi-content-type', block: false },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'ContentDetails_Tag_ContentReferenceFragment' },
                },
              ],
            },
          },
          {
            kind: 'Field',
            alias: { kind: 'Name', value: 'yiTags' },
            name: { kind: 'Name', value: 'contentReferencesFrom' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'types' },
                value: { kind: 'StringValue', value: 'yi-tag', block: false },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'ContentDetails_Tag_ContentReferenceFragment' },
                },
              ],
            },
          },
          {
            kind: 'Field',
            alias: { kind: 'Name', value: 'yiYogaTeacher' },
            name: { kind: 'Name', value: 'contentReferencesFrom' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'types' },
                value: { kind: 'StringValue', value: 'yi-yoga-teacher', block: false },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'ContentDetails_Person_ContentReferenceFragment' },
                },
              ],
            },
          },
          {
            kind: 'Field',
            alias: { kind: 'Name', value: 'yiActionType' },
            name: { kind: 'Name', value: 'references' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'types' },
                value: { kind: 'StringValue', value: 'yi-action-type', block: false },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'ContentDetails_Person_ContentReferenceFragment' },
                },
              ],
            },
          },
          {
            kind: 'Field',
            alias: { kind: 'Name', value: 'yiCourseModules' },
            name: { kind: 'Name', value: 'contentReferencesFrom' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'types' },
                value: {
                  kind: 'ListValue',
                  values: [
                    { kind: 'StringValue', value: 'yi-course-module', block: false },
                    { kind: 'StringValue', value: 'yi-course-module-group', block: false },
                  ],
                },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'YICourse_ModulesContentReferenceFragment' },
                },
              ],
            },
          },
          {
            kind: 'Field',
            alias: { kind: 'Name', value: 'yiCourseSalesPages' },
            name: { kind: 'Name', value: 'contentReferencesTo' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'types' },
                value: { kind: 'StringValue', value: 'yi-course', block: false },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'contentFrom' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'contentType' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'contentId' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'title' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'published' } },
                    ],
                  },
                },
              ],
            },
          },
          {
            kind: 'FragmentSpread',
            name: { kind: 'Name', value: 'Content_ProviderMetadataFragment' },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'YICourseSection_ContentFragment' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'Content' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          { kind: 'Field', name: { kind: 'Name', value: 'title' } },
          { kind: 'Field', name: { kind: 'Name', value: 'contentType' } },
          { kind: 'Field', name: { kind: 'Name', value: 'contentId' } },
          { kind: 'Field', name: { kind: 'Name', value: 'published' } },
          {
            kind: 'Field',
            alias: { kind: 'Name', value: 'yiContentType' },
            name: { kind: 'Name', value: 'contentReferencesFrom' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'types' },
                value: { kind: 'StringValue', value: 'yi-content-type', block: false },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'ContentDetails_Tag_ContentReferenceFragment' },
                },
              ],
            },
          },
          {
            kind: 'FragmentSpread',
            name: { kind: 'Name', value: 'Content_ProviderMetadataFragment' },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'YIPose_ContentFragment' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'Content' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'contentPolicyPolicyId' } },
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          { kind: 'Field', name: { kind: 'Name', value: 'contentId' } },
          { kind: 'Field', name: { kind: 'Name', value: 'contentType' } },
          { kind: 'Field', name: { kind: 'Name', value: 'language' } },
          { kind: 'Field', name: { kind: 'Name', value: 'description' } },
          { kind: 'Field', name: { kind: 'Name', value: 'descriptionFormat' } },
          { kind: 'Field', name: { kind: 'Name', value: 'shortDescription' } },
          { kind: 'Field', name: { kind: 'Name', value: 'shortDescriptionFormat' } },
          { kind: 'Field', name: { kind: 'Name', value: 'path' } },
          { kind: 'Field', name: { kind: 'Name', value: 'primaryLanguage' } },
          { kind: 'Field', name: { kind: 'Name', value: 'published' } },
          { kind: 'Field', name: { kind: 'Name', value: 'publishedAtDate' } },
          { kind: 'Field', name: { kind: 'Name', value: 'seoDescription' } },
          { kind: 'Field', name: { kind: 'Name', value: 'seoTitle' } },
          { kind: 'Field', name: { kind: 'Name', value: 'title' } },
          { kind: 'Field', name: { kind: 'Name', value: 'titleGroupId' } },
          {
            kind: 'Field',
            alias: { kind: 'Name', value: 'yiContentType' },
            name: { kind: 'Name', value: 'contentReferencesFrom' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'types' },
                value: { kind: 'StringValue', value: 'yi-content-type', block: false },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'ContentDetails_Tag_ContentReferenceFragment' },
                },
              ],
            },
          },
          {
            kind: 'Field',
            alias: { kind: 'Name', value: 'yiTags' },
            name: { kind: 'Name', value: 'contentReferencesFrom' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'types' },
                value: { kind: 'StringValue', value: 'yi-tag', block: false },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'ContentDetails_Tag_ContentReferenceFragment' },
                },
              ],
            },
          },
          {
            kind: 'Field',
            alias: { kind: 'Name', value: 'yiPosePronunciation' },
            name: { kind: 'Name', value: 'contentAssetReferences' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'contentAssetReferences' },
                value: {
                  kind: 'ListValue',
                  values: [
                    {
                      kind: 'ObjectValue',
                      fields: [
                        {
                          kind: 'ObjectField',
                          name: { kind: 'Name', value: 'type' },
                          value: {
                            kind: 'StringValue',
                            value: 'yi-pose-pronunciation',
                            block: false,
                          },
                        },
                      ],
                    },
                  ],
                },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                { kind: 'Field', name: { kind: 'Name', value: 'contentAssetReferenceTypesId' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'asset' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'renderUrl' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'originalFileName' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'uuid' } },
                    ],
                  },
                },
              ],
            },
          },
          {
            kind: 'FragmentSpread',
            name: { kind: 'Name', value: 'Content_ProviderMetadataFragment' },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'YICourseSales_ContentFragment' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'Content' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'contentPolicyPolicyId' } },
          { kind: 'Field', name: { kind: 'Name', value: 'description' } },
          { kind: 'Field', name: { kind: 'Name', value: 'descriptionFormat' } },
          { kind: 'Field', name: { kind: 'Name', value: 'path' } },
          { kind: 'Field', name: { kind: 'Name', value: 'primaryLanguage' } },
          { kind: 'Field', name: { kind: 'Name', value: 'published' } },
          { kind: 'Field', name: { kind: 'Name', value: 'publishedAtDate' } },
          { kind: 'FragmentSpread', name: { kind: 'Name', value: 'ContentFeatureMediaFragment' } },
          {
            kind: 'Field',
            alias: { kind: 'Name', value: 'yiContentType' },
            name: { kind: 'Name', value: 'contentReferencesFrom' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'types' },
                value: { kind: 'StringValue', value: 'yi-content-type', block: false },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'ContentDetails_Tag_ContentReferenceFragment' },
                },
              ],
            },
          },
          {
            kind: 'Field',
            alias: { kind: 'Name', value: 'yiCourses' },
            name: { kind: 'Name', value: 'contentReferencesFrom' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'types' },
                value: { kind: 'StringValue', value: 'yi-course', block: false },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'contentTo' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'contentType' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'contentId' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'title' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'published' } },
                      {
                        kind: 'FragmentSpread',
                        name: { kind: 'Name', value: 'Common_ContentProviderFragment' },
                      },
                    ],
                  },
                },
              ],
            },
          },
          {
            kind: 'FragmentSpread',
            name: { kind: 'Name', value: 'Content_ProviderMetadataFragment' },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'YIMemberPromo_ContentFragment' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'Content' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'contentPolicyPolicyId' } },
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          { kind: 'Field', name: { kind: 'Name', value: 'contentId' } },
          { kind: 'Field', name: { kind: 'Name', value: 'contentType' } },
          { kind: 'Field', name: { kind: 'Name', value: 'language' } },
          { kind: 'Field', name: { kind: 'Name', value: 'description' } },
          { kind: 'Field', name: { kind: 'Name', value: 'descriptionFormat' } },
          { kind: 'Field', name: { kind: 'Name', value: 'path' } },
          { kind: 'Field', name: { kind: 'Name', value: 'primaryLanguage' } },
          { kind: 'Field', name: { kind: 'Name', value: 'published' } },
          { kind: 'Field', name: { kind: 'Name', value: 'publishedAtDate' } },
          { kind: 'Field', name: { kind: 'Name', value: 'title' } },
          { kind: 'FragmentSpread', name: { kind: 'Name', value: 'ContentFeatureMediaFragment' } },
          {
            kind: 'Field',
            alias: { kind: 'Name', value: 'yiContentType' },
            name: { kind: 'Name', value: 'contentReferencesFrom' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'types' },
                value: { kind: 'StringValue', value: 'yi-content-type', block: false },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'ContentDetails_Tag_ContentReferenceFragment' },
                },
              ],
            },
          },
          {
            kind: 'Field',
            alias: { kind: 'Name', value: 'yiGiveAwayCourses' },
            name: { kind: 'Name', value: 'contentReferencesFrom' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'types' },
                value: { kind: 'StringValue', value: 'yi-course', block: false },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'contentTo' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'contentType' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'contentId' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'title' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'published' } },
                    ],
                  },
                },
              ],
            },
          },
          {
            kind: 'Field',
            alias: { kind: 'Name', value: 'yiPromotedContent' },
            name: { kind: 'Name', value: 'contentReferencesFrom' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'types' },
                value: { kind: 'StringValue', value: 'yi-promoted-content', block: false },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'contentTo' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'contentType' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'contentId' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'title' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'published' } },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'contentProvider' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            { kind: 'Field', name: { kind: 'Name', value: 'provider' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'providerKey' } },
                            {
                              kind: 'FragmentSpread',
                              name: { kind: 'Name', value: 'Content_ProviderCommonFragment' },
                            },
                          ],
                        },
                      },
                      {
                        kind: 'Field',
                        alias: { kind: 'Name', value: 'yiContentType' },
                        name: { kind: 'Name', value: 'contentReferencesFrom' },
                        arguments: [
                          {
                            kind: 'Argument',
                            name: { kind: 'Name', value: 'types' },
                            value: { kind: 'StringValue', value: 'yi-content-type', block: false },
                          },
                        ],
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            {
                              kind: 'FragmentSpread',
                              name: {
                                kind: 'Name',
                                value: 'ContentDetails_Tag_ContentReferenceFragment',
                              },
                            },
                          ],
                        },
                      },
                    ],
                  },
                },
              ],
            },
          },
          {
            kind: 'FragmentSpread',
            name: { kind: 'Name', value: 'Content_ProviderMetadataFragment' },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'YIHomepageHero_ContentFragment' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'Content' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          { kind: 'Field', name: { kind: 'Name', value: 'contentId' } },
          { kind: 'Field', name: { kind: 'Name', value: 'contentType' } },
          { kind: 'Field', name: { kind: 'Name', value: 'language' } },
          { kind: 'Field', name: { kind: 'Name', value: 'primaryLanguage' } },
          { kind: 'Field', name: { kind: 'Name', value: 'published' } },
          { kind: 'Field', name: { kind: 'Name', value: 'publishedAtDate' } },
          { kind: 'Field', name: { kind: 'Name', value: 'title' } },
          {
            kind: 'Field',
            alias: { kind: 'Name', value: 'yiContentType' },
            name: { kind: 'Name', value: 'contentReferencesFrom' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'types' },
                value: { kind: 'StringValue', value: 'yi-content-type', block: false },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'ContentDetails_Tag_ContentReferenceFragment' },
                },
              ],
            },
          },
          {
            kind: 'Field',
            alias: { kind: 'Name', value: 'yiHomepageHeroContent' },
            name: { kind: 'Name', value: 'contentReferencesFrom' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'types' },
                value: { kind: 'StringValue', value: 'yi-homepage-hero-content', block: false },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'contentReferenceType' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [{ kind: 'Field', name: { kind: 'Name', value: 'type' } }],
                  },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'contentTo' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'contentType' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'contentId' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'title' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'published' } },
                      {
                        kind: 'Field',
                        alias: { kind: 'Name', value: 'yiContentType' },
                        name: { kind: 'Name', value: 'contentReferencesFrom' },
                        arguments: [
                          {
                            kind: 'Argument',
                            name: { kind: 'Name', value: 'types' },
                            value: { kind: 'StringValue', value: 'yi-content-type', block: false },
                          },
                        ],
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            {
                              kind: 'FragmentSpread',
                              name: {
                                kind: 'Name',
                                value: 'ContentDetails_Tag_ContentReferenceFragment',
                              },
                            },
                          ],
                        },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'contentProvider' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            { kind: 'Field', name: { kind: 'Name', value: 'provider' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'providerKey' } },
                            {
                              kind: 'FragmentSpread',
                              name: { kind: 'Name', value: 'Content_ProviderCommonFragment' },
                            },
                          ],
                        },
                      },
                    ],
                  },
                },
              ],
            },
          },
          {
            kind: 'FragmentSpread',
            name: { kind: 'Name', value: 'Content_ProviderMetadataFragment' },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'YISeries_ContentFragment' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'Content' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          { kind: 'Field', name: { kind: 'Name', value: 'contentId' } },
          { kind: 'Field', name: { kind: 'Name', value: 'contentType' } },
          { kind: 'Field', name: { kind: 'Name', value: 'published' } },
          { kind: 'Field', name: { kind: 'Name', value: 'publishedAtDate' } },
          { kind: 'Field', name: { kind: 'Name', value: 'createdAt' } },
          { kind: 'Field', name: { kind: 'Name', value: 'updatedAt' } },
          { kind: 'Field', name: { kind: 'Name', value: 'title' } },
          { kind: 'Field', name: { kind: 'Name', value: 'path' } },
          { kind: 'Field', name: { kind: 'Name', value: 'shortDescription' } },
          { kind: 'Field', name: { kind: 'Name', value: 'shortDescriptionFormat' } },
          { kind: 'Field', name: { kind: 'Name', value: 'description' } },
          { kind: 'Field', name: { kind: 'Name', value: 'descriptionFormat' } },
          { kind: 'Field', name: { kind: 'Name', value: 'productType' } },
          { kind: 'Field', name: { kind: 'Name', value: 'language' } },
          { kind: 'Field', name: { kind: 'Name', value: 'primaryLanguage' } },
          { kind: 'FragmentSpread', name: { kind: 'Name', value: 'ContentPreviewMediaFragment' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'contentProvider' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'provider' } },
                { kind: 'Field', name: { kind: 'Name', value: 'providerKey' } },
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'Content_ProviderCommonFragment' },
                },
              ],
            },
          },
          {
            kind: 'Field',
            alias: { kind: 'Name', value: 'yiContentType' },
            name: { kind: 'Name', value: 'contentReferencesFrom' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'types' },
                value: { kind: 'StringValue', value: 'yi-content-type', block: false },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'ContentDetails_Tag_ContentReferenceFragment' },
                },
              ],
            },
          },
          {
            kind: 'Field',
            alias: { kind: 'Name', value: 'yiSeriesEpisodes' },
            name: { kind: 'Name', value: 'contentReferencesFrom' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'types' },
                value: {
                  kind: 'ListValue',
                  values: [{ kind: 'StringValue', value: 'yi-series-episode', block: false }],
                },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'YISeries_EpisodeContentFragment' },
                },
              ],
            },
          },
          {
            kind: 'FragmentSpread',
            name: { kind: 'Name', value: 'Content_ProviderMetadataFragment' },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'YIArticle_ContentFragment' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'Content' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'contentPolicyPolicyId' } },
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          { kind: 'Field', name: { kind: 'Name', value: 'contentId' } },
          { kind: 'Field', name: { kind: 'Name', value: 'contentType' } },
          { kind: 'Field', name: { kind: 'Name', value: 'language' } },
          { kind: 'Field', name: { kind: 'Name', value: 'description' } },
          { kind: 'Field', name: { kind: 'Name', value: 'descriptionFormat' } },
          { kind: 'Field', name: { kind: 'Name', value: 'shortDescription' } },
          { kind: 'Field', name: { kind: 'Name', value: 'shortDescriptionFormat' } },
          { kind: 'Field', name: { kind: 'Name', value: 'path' } },
          { kind: 'Field', name: { kind: 'Name', value: 'primaryLanguage' } },
          { kind: 'Field', name: { kind: 'Name', value: 'published' } },
          { kind: 'Field', name: { kind: 'Name', value: 'publishedAtDate' } },
          { kind: 'Field', name: { kind: 'Name', value: 'seoDescription' } },
          { kind: 'Field', name: { kind: 'Name', value: 'seoTitle' } },
          { kind: 'Field', name: { kind: 'Name', value: 'title' } },
          { kind: 'FragmentSpread', name: { kind: 'Name', value: 'ContentFeatureMediaFragment' } },
          {
            kind: 'Field',
            alias: { kind: 'Name', value: 'yiContentType' },
            name: { kind: 'Name', value: 'contentReferencesFrom' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'types' },
                value: { kind: 'StringValue', value: 'yi-content-type', block: false },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'ContentDetails_Tag_ContentReferenceFragment' },
                },
              ],
            },
          },
          {
            kind: 'Field',
            alias: { kind: 'Name', value: 'yiYogaTeacher' },
            name: { kind: 'Name', value: 'contentReferencesFrom' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'types' },
                value: { kind: 'StringValue', value: 'yi-yoga-teacher', block: false },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'ContentDetails_Person_ContentReferenceFragment' },
                },
              ],
            },
          },
          {
            kind: 'Field',
            alias: { kind: 'Name', value: 'yiTags' },
            name: { kind: 'Name', value: 'contentReferencesFrom' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'types' },
                value: { kind: 'StringValue', value: 'yi-tag', block: false },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'ContentDetails_Tag_ContentReferenceFragment' },
                },
              ],
            },
          },
          {
            kind: 'Field',
            alias: { kind: 'Name', value: 'yiArticleTopic' },
            name: { kind: 'Name', value: 'contentReferencesFrom' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'types' },
                value: { kind: 'StringValue', value: 'yi-article-topic', block: false },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'ContentDetails_Tag_ContentReferenceFragment' },
                },
              ],
            },
          },
          {
            kind: 'FragmentSpread',
            name: { kind: 'Name', value: 'Content_ProviderMetadataFragment' },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'YICourseModule_ContentFragment' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'Content' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          { kind: 'Field', name: { kind: 'Name', value: 'title' } },
          { kind: 'Field', name: { kind: 'Name', value: 'contentType' } },
          { kind: 'Field', name: { kind: 'Name', value: 'contentId' } },
          { kind: 'Field', name: { kind: 'Name', value: 'description' } },
          { kind: 'Field', name: { kind: 'Name', value: 'descriptionFormat' } },
          { kind: 'Field', name: { kind: 'Name', value: 'published' } },
          { kind: 'Field', name: { kind: 'Name', value: 'publishedAtDate' } },
          { kind: 'Field', name: { kind: 'Name', value: 'primaryLanguage' } },
          { kind: 'Field', name: { kind: 'Name', value: 'language' } },
          { kind: 'Field', name: { kind: 'Name', value: 'shortDescription' } },
          { kind: 'Field', name: { kind: 'Name', value: 'shortDescriptionFormat' } },
          { kind: 'Field', name: { kind: 'Name', value: 'path' } },
          { kind: 'FragmentSpread', name: { kind: 'Name', value: 'ContentFeatureMediaFragment' } },
          {
            kind: 'Field',
            alias: { kind: 'Name', value: 'yiContentType' },
            name: { kind: 'Name', value: 'contentReferencesFrom' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'types' },
                value: { kind: 'StringValue', value: 'yi-content-type', block: false },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'ContentDetails_Tag_ContentReferenceFragment' },
                },
              ],
            },
          },
          {
            kind: 'Field',
            alias: { kind: 'Name', value: 'yiCourseModuleType' },
            name: { kind: 'Name', value: 'contentReferencesFrom' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'types' },
                value: { kind: 'StringValue', value: 'yi-course-module-type', block: false },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'ContentDetails_Tag_ContentReferenceFragment' },
                },
              ],
            },
          },
          {
            kind: 'Field',
            alias: { kind: 'Name', value: 'yiConsumptionType' },
            name: { kind: 'Name', value: 'contentReferencesFrom' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'types' },
                value: { kind: 'StringValue', value: 'yi-consumption-type', block: false },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'ContentDetails_Tag_ContentReferenceFragment' },
                },
              ],
            },
          },
          {
            kind: 'Field',
            alias: { kind: 'Name', value: 'yiYogaStyles' },
            name: { kind: 'Name', value: 'contentReferencesFrom' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'types' },
                value: { kind: 'StringValue', value: 'yi-yoga-style', block: false },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'ContentDetails_Tag_ContentReferenceFragment' },
                },
              ],
            },
          },
          {
            kind: 'FragmentSpread',
            name: { kind: 'Name', value: 'YICourseModuleDownload_ContentFragment' },
          },
          {
            kind: 'FragmentSpread',
            name: { kind: 'Name', value: 'Content_ProviderMetadataFragment' },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'YITeacher_ContentFragment' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'Content' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          { kind: 'Field', name: { kind: 'Name', value: 'contentId' } },
          { kind: 'Field', name: { kind: 'Name', value: 'contentType' } },
          { kind: 'Field', name: { kind: 'Name', value: 'published' } },
          { kind: 'Field', name: { kind: 'Name', value: 'publishedAtDate' } },
          { kind: 'Field', name: { kind: 'Name', value: 'shortDescription' } },
          { kind: 'Field', name: { kind: 'Name', value: 'shortDescriptionFormat' } },
          { kind: 'Field', name: { kind: 'Name', value: 'description' } },
          { kind: 'Field', name: { kind: 'Name', value: 'descriptionFormat' } },
          { kind: 'Field', name: { kind: 'Name', value: 'language' } },
          { kind: 'Field', name: { kind: 'Name', value: 'primaryLanguage' } },
          { kind: 'Field', name: { kind: 'Name', value: 'path' } },
          { kind: 'Field', name: { kind: 'Name', value: 'seoTitle' } },
          { kind: 'Field', name: { kind: 'Name', value: 'seoDescription' } },
          { kind: 'Field', name: { kind: 'Name', value: 'title' } },
          { kind: 'FragmentSpread', name: { kind: 'Name', value: 'ContentFeatureMediaFragment' } },
          {
            kind: 'Field',
            alias: { kind: 'Name', value: 'yiContentType' },
            name: { kind: 'Name', value: 'contentReferencesFrom' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'types' },
                value: { kind: 'StringValue', value: 'yi-content-type', block: false },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'ContentDetails_Tag_ContentReferenceFragment' },
                },
              ],
            },
          },
          {
            kind: 'Field',
            alias: { kind: 'Name', value: 'yiTags' },
            name: { kind: 'Name', value: 'contentReferencesFrom' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'types' },
                value: { kind: 'StringValue', value: 'yi-tag', block: false },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'ContentDetails_Tag_ContentReferenceFragment' },
                },
              ],
            },
          },
          {
            kind: 'FragmentSpread',
            name: { kind: 'Name', value: 'Content_ProviderMetadataFragment' },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'YITag_ContentFragment' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'Content' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          { kind: 'Field', name: { kind: 'Name', value: 'contentId' } },
          { kind: 'Field', name: { kind: 'Name', value: 'title' } },
          { kind: 'Field', name: { kind: 'Name', value: 'contentType' } },
          { kind: 'Field', name: { kind: 'Name', value: 'published' } },
          { kind: 'Field', name: { kind: 'Name', value: 'publishedAtDate' } },
          { kind: 'Field', name: { kind: 'Name', value: 'description' } },
          { kind: 'Field', name: { kind: 'Name', value: 'descriptionFormat' } },
          { kind: 'Field', name: { kind: 'Name', value: 'language' } },
          { kind: 'Field', name: { kind: 'Name', value: 'primaryLanguage' } },
          { kind: 'Field', name: { kind: 'Name', value: 'path' } },
          { kind: 'Field', name: { kind: 'Name', value: 'seoTitle' } },
          { kind: 'FragmentSpread', name: { kind: 'Name', value: 'ContentFeatureMediaFragment' } },
          {
            kind: 'Field',
            alias: { kind: 'Name', value: 'yiContentType' },
            name: { kind: 'Name', value: 'contentReferencesFrom' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'types' },
                value: { kind: 'StringValue', value: 'yi-content-type', block: false },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'ContentDetails_Tag_ContentReferenceFragment' },
                },
              ],
            },
          },
          {
            kind: 'Field',
            alias: { kind: 'Name', value: 'yiTagGroup' },
            name: { kind: 'Name', value: 'contentReferencesFrom' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'types' },
                value: { kind: 'StringValue', value: 'yi-tag-group', block: false },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                { kind: 'Field', name: { kind: 'Name', value: 'sortKey' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'contentReferenceType' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [{ kind: 'Field', name: { kind: 'Name', value: 'type' } }],
                  },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'contentTo' },
                  arguments: [
                    {
                      kind: 'Argument',
                      name: { kind: 'Name', value: 'language' },
                      value: {
                        kind: 'ListValue',
                        values: [
                          { kind: 'StringValue', value: 'en', block: false },
                          { kind: 'StringValue', value: '_primary', block: false },
                        ],
                      },
                    },
                  ],
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'titleGroupId' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'title' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'contentId' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'contentType' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'published' } },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'YITagGroup_ContentFragment' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'Content' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          { kind: 'Field', name: { kind: 'Name', value: 'contentId' } },
          { kind: 'Field', name: { kind: 'Name', value: 'title' } },
          { kind: 'Field', name: { kind: 'Name', value: 'contentType' } },
          { kind: 'Field', name: { kind: 'Name', value: 'published' } },
          { kind: 'Field', name: { kind: 'Name', value: 'publishedAtDate' } },
          { kind: 'Field', name: { kind: 'Name', value: 'path' } },
          { kind: 'Field', name: { kind: 'Name', value: 'language' } },
          {
            kind: 'Field',
            alias: { kind: 'Name', value: 'yiContentType' },
            name: { kind: 'Name', value: 'contentReferencesFrom' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'types' },
                value: { kind: 'StringValue', value: 'yi-content-type', block: false },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'ContentDetails_Tag_ContentReferenceFragment' },
                },
              ],
            },
          },
          {
            kind: 'Field',
            alias: { kind: 'Name', value: 'yiTagsRelatedToGroup' },
            name: { kind: 'Name', value: 'contentReferencesTo' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'types' },
                value: { kind: 'StringValue', value: 'yi-tag-group', block: false },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                { kind: 'Field', name: { kind: 'Name', value: 'sortKey' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'contentReferenceType' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [{ kind: 'Field', name: { kind: 'Name', value: 'type' } }],
                  },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'contentFrom' },
                  arguments: [
                    {
                      kind: 'Argument',
                      name: { kind: 'Name', value: 'language' },
                      value: {
                        kind: 'ListValue',
                        values: [
                          { kind: 'StringValue', value: 'en', block: false },
                          { kind: 'StringValue', value: '_primary', block: false },
                        ],
                      },
                    },
                  ],
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'titleGroupId' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'title' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'contentId' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'contentType' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'published' } },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<YiContentListQuery, YiContentListQueryVariables>
